/*! For license information please see vendors.js.LICENSE.txt */
(self.webpackChunkworkflow = self.webpackChunkworkflow || []).push([
  [216],
  {
    4010: function (e, t, n) {
      "use strict";
      function r() {
        return JSON.parse(
          JSON.stringify({
            credentials: "same-origin",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json;",
            },
          })
        );
      }
      function i(e, t) {
        return fetch(e, t).then(function (e) {
          if (!e.ok) throw e;
          return e.json();
        });
      }
      function o() {
        return i("/cart.js", r());
      }
      function s(e, t, n) {
        var o = r();
        return (
          (o.method = "POST"),
          (o.body = JSON.stringify({ id: e, quantity: t, properties: n })),
          i("/cart/add.js", o)
        );
      }
      function a(e, t) {
        var n = r();
        return (
          (t = t || {}),
          (n.method = "POST"),
          (n.body = JSON.stringify({
            line: e,
            quantity: t.quantity,
            properties: t.properties,
          })),
          i("/cart/change.js", n)
        );
      }
      n.d(t, {
        Nu: function () {
          return o;
        },
        S0: function () {
          return s;
        },
        Q$: function () {
          return a;
        },
      });
    },
    5931: function (e, t, n) {
      "use strict";
      if (
        (n.d(t, {
          y0: function () {
            return o;
          },
          jX: function () {
            return a;
          },
          $G: function () {
            return u;
          },
          cl: function () {
            return l;
          },
        }),
        /^(348|576)$/.test(n.j))
      )
        var r = n(4010);
      if (/^(348|576)$/.test(n.j)) var i = n(781);
      function o() {
        return r.Nu();
      }
      function s(e) {
        return (
          i.Jy(e),
          r.Nu().then(function (t) {
            var n = -1;
            return (
              t.items.forEach(function (t, r) {
                n = t.key === e ? r + 1 : n;
              }),
              -1 === n
                ? Promise.reject(
                    new Error(
                      "Theme Cart: Unable to match line item with provided key"
                    )
                  )
                : n
            );
          })
        );
      }
      function a(e, t) {
        return (t = t || {}), i.id(e), r.S0(e, t.quantity, t.properties);
      }
      function u(e, t) {
        return (
          i.Jy(e),
          i.YM(t),
          s(e).then(function (e) {
            return r.Q$(e, t);
          })
        );
      }
      function l(e) {
        return (
          i.Jy(e),
          s(e).then(function (e) {
            return r.Q$(e, { quantity: 0 });
          })
        );
      }
    },
    781: function (e, t, n) {
      "use strict";
      function r(e) {
        if ("string" != typeof e || 2 !== e.split(":").length)
          throw new TypeError(
            "Theme Cart: Provided key value is not a string with the format xxx:xxx"
          );
      }
      function i(e) {
        if ("number" != typeof e || isNaN(e))
          throw new TypeError("Theme Cart: Variant ID must be a number");
      }
      function o(e) {
        if ("object" != typeof e)
          throw new TypeError("Theme Cart: Options must be an object");
        if (void 0 === e.quantity && void 0 === e.properties)
          throw new Error(
            "Theme Cart: You muse define a value for quantity or properties"
          );
        void 0 !== e.quantity &&
          (function (e) {
            if ("number" != typeof e || isNaN(e))
              throw new TypeError(
                "Theme Cart: An object which specifies a quantity or properties value is required"
              );
          })(e.quantity),
          void 0 !== e.properties &&
            (function (e) {
              if ("object" != typeof e)
                throw new TypeError("Theme Cart: Properties must be an object");
            })(e.properties);
      }
      n.d(t, {
        Jy: function () {
          return r;
        },
        id: function () {
          return i;
        },
        YM: function () {
          return o;
        },
      });
    },
    4306: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return ht;
        },
      });
      var r,
        i,
        o,
        s,
        a = Object.create,
        u = Object.defineProperty,
        l = Object.getPrototypeOf,
        c = Object.prototype.hasOwnProperty,
        p = Object.getOwnPropertyNames,
        f = Object.getOwnPropertyDescriptor,
        d = (e, t) => () => (
          t || e((t = { exports: {} }).exports, t), t.exports
        ),
        h = d((e) => {
          function t(e, t) {
            const n = Object.create(null),
              r = e.split(",");
            for (let e = 0; e < r.length; e++) n[r[e]] = !0;
            return t ? (e) => !!n[e.toLowerCase()] : (e) => !!n[e];
          }
          Object.defineProperty(e, "__esModule", { value: !0 });
          var r = {
              1: "TEXT",
              2: "CLASS",
              4: "STYLE",
              8: "PROPS",
              16: "FULL_PROPS",
              32: "HYDRATE_EVENTS",
              64: "STABLE_FRAGMENT",
              128: "KEYED_FRAGMENT",
              256: "UNKEYED_FRAGMENT",
              512: "NEED_PATCH",
              1024: "DYNAMIC_SLOTS",
              2048: "DEV_ROOT_FRAGMENT",
              [-1]: "HOISTED",
              [-2]: "BAIL",
            },
            i = t(
              "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt"
            ),
            o =
              "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly",
            s = t(o),
            a = t(
              o +
                ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected"
            ),
            u = /[>/="'\u0009\u000a\u000c\u0020]/,
            l = {},
            c = t(
              "animation-iteration-count,border-image-outset,border-image-slice,border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,stroke-miterlimit,stroke-opacity,stroke-width"
            ),
            p = t(
              "accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap"
            ),
            f = /;(?![^(]*\))/g,
            d = /:(.+)/;
          function h(e) {
            const t = {};
            return (
              e.split(f).forEach((e) => {
                if (e) {
                  const n = e.split(d);
                  n.length > 1 && (t[n[0].trim()] = n[1].trim());
                }
              }),
              t
            );
          }
          var m = t(
              "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot"
            ),
            g = t(
              "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view"
            ),
            y = t(
              "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr"
            ),
            v = /["'&<>]/,
            D = /^-?>|<!--|-->|--!>|<!-$/g;
          function b(e, t) {
            if (e === t) return !0;
            let n = O(e),
              r = O(t);
            if (n || r) return !(!n || !r) && e.getTime() === t.getTime();
            if (((n = T(e)), (r = T(t)), n || r))
              return (
                !(!n || !r) &&
                (function (e, t) {
                  if (e.length !== t.length) return !1;
                  let n = !0;
                  for (let r = 0; n && r < e.length; r++) n = b(e[r], t[r]);
                  return n;
                })(e, t)
              );
            if (((n = N(e)), (r = N(t)), n || r)) {
              if (!n || !r) return !1;
              if (Object.keys(e).length !== Object.keys(t).length) return !1;
              for (const n in e) {
                const r = e.hasOwnProperty(n),
                  i = t.hasOwnProperty(n);
                if ((r && !i) || (!r && i) || !b(e[n], t[n])) return !1;
              }
            }
            return String(e) === String(t);
          }
          var E,
            C = (e, t) =>
              F(t)
                ? {
                    [`Map(${t.size})`]: [...t.entries()].reduce(
                      (e, [t, n]) => ((e[`${t} =>`] = n), e),
                      {}
                    ),
                  }
                : k(t)
                ? { [`Set(${t.size})`]: [...t.values()] }
                : !N(t) || T(t) || j(t)
                ? t
                : String(t),
            x = Object.freeze({}),
            w = Object.freeze([]),
            A = /^on[^a-z]/,
            S = Object.assign,
            _ = Object.prototype.hasOwnProperty,
            T = Array.isArray,
            F = (e) => "[object Map]" === I(e),
            k = (e) => "[object Set]" === I(e),
            O = (e) => e instanceof Date,
            B = (e) => "function" == typeof e,
            P = (e) => "string" == typeof e,
            N = (e) => null !== e && "object" == typeof e,
            M = Object.prototype.toString,
            I = (e) => M.call(e),
            j = (e) => "[object Object]" === I(e),
            L = t(
              ",key,ref,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
            ),
            $ = (e) => {
              const t = Object.create(null);
              return (n) => t[n] || (t[n] = e(n));
            },
            R = /-(\w)/g,
            z = $((e) => e.replace(R, (e, t) => (t ? t.toUpperCase() : ""))),
            V = /\B([A-Z])/g,
            q = $((e) => e.replace(V, "-$1").toLowerCase()),
            W = $((e) => e.charAt(0).toUpperCase() + e.slice(1)),
            U = $((e) => (e ? `on${W(e)}` : ""));
          (e.EMPTY_ARR = w),
            (e.EMPTY_OBJ = x),
            (e.NO = () => !1),
            (e.NOOP = () => {}),
            (e.PatchFlagNames = r),
            (e.babelParserDefaultPlugins = [
              "bigInt",
              "optionalChaining",
              "nullishCoalescingOperator",
            ]),
            (e.camelize = z),
            (e.capitalize = W),
            (e.def = (e, t, n) => {
              Object.defineProperty(e, t, {
                configurable: !0,
                enumerable: !1,
                value: n,
              });
            }),
            (e.escapeHtml = function (e) {
              const t = "" + e,
                n = v.exec(t);
              if (!n) return t;
              let r,
                i,
                o = "",
                s = 0;
              for (i = n.index; i < t.length; i++) {
                switch (t.charCodeAt(i)) {
                  case 34:
                    r = "&quot;";
                    break;
                  case 38:
                    r = "&amp;";
                    break;
                  case 39:
                    r = "&#39;";
                    break;
                  case 60:
                    r = "&lt;";
                    break;
                  case 62:
                    r = "&gt;";
                    break;
                  default:
                    continue;
                }
                s !== i && (o += t.substring(s, i)), (s = i + 1), (o += r);
              }
              return s !== i ? o + t.substring(s, i) : o;
            }),
            (e.escapeHtmlComment = function (e) {
              return e.replace(D, "");
            }),
            (e.extend = S),
            (e.generateCodeFrame = function (e, t = 0, n = e.length) {
              const r = e.split(/\r?\n/);
              let i = 0;
              const o = [];
              for (let e = 0; e < r.length; e++)
                if (((i += r[e].length + 1), i >= t)) {
                  for (let s = e - 2; s <= e + 2 || n > i; s++) {
                    if (s < 0 || s >= r.length) continue;
                    const a = s + 1;
                    o.push(
                      `${a}${" ".repeat(Math.max(3 - String(a).length, 0))}|  ${
                        r[s]
                      }`
                    );
                    const u = r[s].length;
                    if (s === e) {
                      const e = t - (i - u) + 1,
                        r = Math.max(1, n > i ? u - e : n - t);
                      o.push("   |  " + " ".repeat(e) + "^".repeat(r));
                    } else if (s > e) {
                      if (n > i) {
                        const e = Math.max(Math.min(n - i, u), 1);
                        o.push("   |  " + "^".repeat(e));
                      }
                      i += u + 1;
                    }
                  }
                  break;
                }
              return o.join("\n");
            }),
            (e.getGlobalThis = () =>
              E ||
              (E =
                "undefined" != typeof globalThis
                  ? globalThis
                  : "undefined" != typeof self
                  ? self
                  : "undefined" != typeof window
                  ? window
                  : void 0 !== n.g
                  ? n.g
                  : {})),
            (e.hasChanged = (e, t) => e !== t && (e == e || t == t)),
            (e.hasOwn = (e, t) => _.call(e, t)),
            (e.hyphenate = q),
            (e.invokeArrayFns = (e, t) => {
              for (let n = 0; n < e.length; n++) e[n](t);
            }),
            (e.isArray = T),
            (e.isBooleanAttr = a),
            (e.isDate = O),
            (e.isFunction = B),
            (e.isGloballyWhitelisted = i),
            (e.isHTMLTag = m),
            (e.isIntegerKey = (e) =>
              P(e) &&
              "NaN" !== e &&
              "-" !== e[0] &&
              "" + parseInt(e, 10) === e),
            (e.isKnownAttr = p),
            (e.isMap = F),
            (e.isModelListener = (e) => e.startsWith("onUpdate:")),
            (e.isNoUnitNumericStyleProp = c),
            (e.isObject = N),
            (e.isOn = (e) => A.test(e)),
            (e.isPlainObject = j),
            (e.isPromise = (e) => N(e) && B(e.then) && B(e.catch)),
            (e.isReservedProp = L),
            (e.isSSRSafeAttrName = function (e) {
              if (l.hasOwnProperty(e)) return l[e];
              const t = u.test(e);
              return (
                t && console.error(`unsafe attribute name: ${e}`), (l[e] = !t)
              );
            }),
            (e.isSVGTag = g),
            (e.isSet = k),
            (e.isSpecialBooleanAttr = s),
            (e.isString = P),
            (e.isSymbol = (e) => "symbol" == typeof e),
            (e.isVoidTag = y),
            (e.looseEqual = b),
            (e.looseIndexOf = function (e, t) {
              return e.findIndex((e) => b(e, t));
            }),
            (e.makeMap = t),
            (e.normalizeClass = function e(t) {
              let n = "";
              if (P(t)) n = t;
              else if (T(t))
                for (let r = 0; r < t.length; r++) {
                  const i = e(t[r]);
                  i && (n += i + " ");
                }
              else if (N(t)) for (const e in t) t[e] && (n += e + " ");
              return n.trim();
            }),
            (e.normalizeStyle = function e(t) {
              if (T(t)) {
                const n = {};
                for (let r = 0; r < t.length; r++) {
                  const i = t[r],
                    o = e(P(i) ? h(i) : i);
                  if (o) for (const e in o) n[e] = o[e];
                }
                return n;
              }
              if (N(t)) return t;
            }),
            (e.objectToString = M),
            (e.parseStringStyle = h),
            (e.propsToAttrMap = {
              acceptCharset: "accept-charset",
              className: "class",
              htmlFor: "for",
              httpEquiv: "http-equiv",
            }),
            (e.remove = (e, t) => {
              const n = e.indexOf(t);
              n > -1 && e.splice(n, 1);
            }),
            (e.slotFlagsText = { 1: "STABLE", 2: "DYNAMIC", 3: "FORWARDED" }),
            (e.stringifyStyle = function (e) {
              let t = "";
              if (!e) return t;
              for (const n in e) {
                const r = e[n],
                  i = n.startsWith("--") ? n : q(n);
                (P(r) || ("number" == typeof r && c(i))) && (t += `${i}:${r};`);
              }
              return t;
            }),
            (e.toDisplayString = (e) =>
              null == e ? "" : N(e) ? JSON.stringify(e, C, 2) : String(e)),
            (e.toHandlerKey = U),
            (e.toNumber = (e) => {
              const t = parseFloat(e);
              return isNaN(t) ? e : t;
            }),
            (e.toRawType = (e) => I(e).slice(8, -1)),
            (e.toTypeString = I);
        }),
        m = d((e, t) => {
          t.exports = h();
        }),
        g = d((e) => {
          Object.defineProperty(e, "__esModule", { value: !0 });
          var t,
            n = m(),
            r = new WeakMap(),
            i = [],
            o = Symbol("iterate"),
            s = Symbol("Map key iterate");
          function a(e, r = n.EMPTY_OBJ) {
            (function (e) {
              return e && !0 === e._isEffect;
            })(e) && (e = e.raw);
            const o = (function (e, n) {
              const r = function () {
                if (!r.active) return e();
                if (!i.includes(r)) {
                  l(r);
                  try {
                    return d(), i.push(r), (t = r), e();
                  } finally {
                    i.pop(), h(), (t = i[i.length - 1]);
                  }
                }
              };
              return (
                (r.id = u++),
                (r.allowRecurse = !!n.allowRecurse),
                (r._isEffect = !0),
                (r.active = !0),
                (r.raw = e),
                (r.deps = []),
                (r.options = n),
                r
              );
            })(e, r);
            return r.lazy || o(), o;
          }
          var u = 0;
          function l(e) {
            const { deps: t } = e;
            if (t.length) {
              for (let n = 0; n < t.length; n++) t[n].delete(e);
              t.length = 0;
            }
          }
          var c = !0,
            p = [];
          function f() {
            p.push(c), (c = !1);
          }
          function d() {
            p.push(c), (c = !0);
          }
          function h() {
            const e = p.pop();
            c = void 0 === e || e;
          }
          function g(e, n, i) {
            if (!c || void 0 === t) return;
            let o = r.get(e);
            o || r.set(e, (o = new Map()));
            let s = o.get(i);
            s || o.set(i, (s = new Set())),
              s.has(t) ||
                (s.add(t),
                t.deps.push(s),
                t.options.onTrack &&
                  t.options.onTrack({ effect: t, target: e, type: n, key: i }));
          }
          function y(e, i, a, u, l, c) {
            const p = r.get(e);
            if (!p) return;
            const f = new Set(),
              d = (e) => {
                e &&
                  e.forEach((e) => {
                    (e !== t || e.allowRecurse) && f.add(e);
                  });
              };
            if ("clear" === i) p.forEach(d);
            else if ("length" === a && n.isArray(e))
              p.forEach((e, t) => {
                ("length" === t || t >= u) && d(e);
              });
            else
              switch ((void 0 !== a && d(p.get(a)), i)) {
                case "add":
                  n.isArray(e)
                    ? n.isIntegerKey(a) && d(p.get("length"))
                    : (d(p.get(o)), n.isMap(e) && d(p.get(s)));
                  break;
                case "delete":
                  n.isArray(e) || (d(p.get(o)), n.isMap(e) && d(p.get(s)));
                  break;
                case "set":
                  n.isMap(e) && d(p.get(o));
              }
            f.forEach((t) => {
              t.options.onTrigger &&
                t.options.onTrigger({
                  effect: t,
                  target: e,
                  key: a,
                  type: i,
                  newValue: u,
                  oldValue: l,
                  oldTarget: c,
                }),
                t.options.scheduler ? t.options.scheduler(t) : t();
            });
          }
          var v = n.makeMap("__proto__,__v_isRef,__isVue"),
            D = new Set(
              Object.getOwnPropertyNames(Symbol)
                .map((e) => Symbol[e])
                .filter(n.isSymbol)
            ),
            b = A(),
            E = A(!1, !0),
            C = A(!0),
            x = A(!0, !0),
            w = {};
          function A(e = !1, t = !1) {
            return function (r, i, o) {
              if ("__v_isReactive" === i) return !e;
              if ("__v_isReadonly" === i) return e;
              if (
                "__v_raw" === i &&
                o === (e ? (t ? se : oe) : t ? ie : re).get(r)
              )
                return r;
              const s = n.isArray(r);
              if (!e && s && n.hasOwn(w, i)) return Reflect.get(w, i, o);
              const a = Reflect.get(r, i, o);
              return (n.isSymbol(i) ? D.has(i) : v(i))
                ? a
                : (e || g(r, "get", i),
                  t
                    ? a
                    : me(a)
                    ? s && n.isIntegerKey(i)
                      ? a
                      : a.value
                    : n.isObject(a)
                    ? e
                      ? ue(a)
                      : ae(a)
                    : a);
            };
          }
          ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
            const t = Array.prototype[e];
            w[e] = function (...e) {
              const n = de(this);
              for (let e = 0, t = this.length; e < t; e++) g(n, "get", e + "");
              const r = t.apply(n, e);
              return -1 === r || !1 === r ? t.apply(n, e.map(de)) : r;
            };
          }),
            ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
              const t = Array.prototype[e];
              w[e] = function (...e) {
                f();
                const n = t.apply(this, e);
                return h(), n;
              };
            });
          var S = T(),
            _ = T(!0);
          function T(e = !1) {
            return function (t, r, i, o) {
              let s = t[r];
              if (
                !e &&
                ((i = de(i)), (s = de(s)), !n.isArray(t) && me(s) && !me(i))
              )
                return (s.value = i), !0;
              const a =
                  n.isArray(t) && n.isIntegerKey(r)
                    ? Number(r) < t.length
                    : n.hasOwn(t, r),
                u = Reflect.set(t, r, i, o);
              return (
                t === de(o) &&
                  (a
                    ? n.hasChanged(i, s) && y(t, "set", r, i, s)
                    : y(t, "add", r, i)),
                u
              );
            };
          }
          var F = {
              get: b,
              set: S,
              deleteProperty: function (e, t) {
                const r = n.hasOwn(e, t),
                  i = e[t],
                  o = Reflect.deleteProperty(e, t);
                return o && r && y(e, "delete", t, void 0, i), o;
              },
              has: function (e, t) {
                const r = Reflect.has(e, t);
                return (n.isSymbol(t) && D.has(t)) || g(e, "has", t), r;
              },
              ownKeys: function (e) {
                return (
                  g(e, "iterate", n.isArray(e) ? "length" : o),
                  Reflect.ownKeys(e)
                );
              },
            },
            k = {
              get: C,
              set: (e, t) => (
                console.warn(
                  `Set operation on key "${String(
                    t
                  )}" failed: target is readonly.`,
                  e
                ),
                !0
              ),
              deleteProperty: (e, t) => (
                console.warn(
                  `Delete operation on key "${String(
                    t
                  )}" failed: target is readonly.`,
                  e
                ),
                !0
              ),
            },
            O = n.extend({}, F, { get: E, set: _ }),
            B = n.extend({}, k, { get: x }),
            P = (e) => (n.isObject(e) ? ae(e) : e),
            N = (e) => (n.isObject(e) ? ue(e) : e),
            M = (e) => e,
            I = (e) => Reflect.getPrototypeOf(e);
          function j(e, t, n = !1, r = !1) {
            const i = de((e = e.__v_raw)),
              o = de(t);
            t !== o && !n && g(i, "get", t), !n && g(i, "get", o);
            const { has: s } = I(i),
              a = r ? M : n ? N : P;
            return s.call(i, t)
              ? a(e.get(t))
              : s.call(i, o)
              ? a(e.get(o))
              : void (e !== i && e.get(t));
          }
          function L(e, t = !1) {
            const n = this.__v_raw,
              r = de(n),
              i = de(e);
            return (
              e !== i && !t && g(r, "has", e),
              !t && g(r, "has", i),
              e === i ? n.has(e) : n.has(e) || n.has(i)
            );
          }
          function $(e, t = !1) {
            return (
              (e = e.__v_raw),
              !t && g(de(e), "iterate", o),
              Reflect.get(e, "size", e)
            );
          }
          function R(e) {
            e = de(e);
            const t = de(this);
            return I(t).has.call(t, e) || (t.add(e), y(t, "add", e, e)), this;
          }
          function z(e, t) {
            t = de(t);
            const r = de(this),
              { has: i, get: o } = I(r);
            let s = i.call(r, e);
            s ? ne(r, i, e) : ((e = de(e)), (s = i.call(r, e)));
            const a = o.call(r, e);
            return (
              r.set(e, t),
              s
                ? n.hasChanged(t, a) && y(r, "set", e, t, a)
                : y(r, "add", e, t),
              this
            );
          }
          function V(e) {
            const t = de(this),
              { has: n, get: r } = I(t);
            let i = n.call(t, e);
            i ? ne(t, n, e) : ((e = de(e)), (i = n.call(t, e)));
            const o = r ? r.call(t, e) : void 0,
              s = t.delete(e);
            return i && y(t, "delete", e, void 0, o), s;
          }
          function q() {
            const e = de(this),
              t = 0 !== e.size,
              r = n.isMap(e) ? new Map(e) : new Set(e),
              i = e.clear();
            return t && y(e, "clear", void 0, void 0, r), i;
          }
          function W(e, t) {
            return function (n, r) {
              const i = this,
                s = i.__v_raw,
                a = de(s),
                u = t ? M : e ? N : P;
              return (
                !e && g(a, "iterate", o),
                s.forEach((e, t) => n.call(r, u(e), u(t), i))
              );
            };
          }
          function U(e, t, r) {
            return function (...i) {
              const a = this.__v_raw,
                u = de(a),
                l = n.isMap(u),
                c = "entries" === e || (e === Symbol.iterator && l),
                p = "keys" === e && l,
                f = a[e](...i),
                d = r ? M : t ? N : P;
              return (
                !t && g(u, "iterate", p ? s : o),
                {
                  next() {
                    const { value: e, done: t } = f.next();
                    return t
                      ? { value: e, done: t }
                      : { value: c ? [d(e[0]), d(e[1])] : d(e), done: t };
                  },
                  [Symbol.iterator]() {
                    return this;
                  },
                }
              );
            };
          }
          function H(e) {
            return function (...t) {
              {
                const r = t[0] ? `on key "${t[0]}" ` : "";
                console.warn(
                  `${n.capitalize(
                    e
                  )} operation ${r}failed: target is readonly.`,
                  de(this)
                );
              }
              return "delete" !== e && this;
            };
          }
          var G = {
              get(e) {
                return j(this, e);
              },
              get size() {
                return $(this);
              },
              has: L,
              add: R,
              set: z,
              delete: V,
              clear: q,
              forEach: W(!1, !1),
            },
            Y = {
              get(e) {
                return j(this, e, !1, !0);
              },
              get size() {
                return $(this);
              },
              has: L,
              add: R,
              set: z,
              delete: V,
              clear: q,
              forEach: W(!1, !0),
            },
            X = {
              get(e) {
                return j(this, e, !0);
              },
              get size() {
                return $(this, !0);
              },
              has(e) {
                return L.call(this, e, !0);
              },
              add: H("add"),
              set: H("set"),
              delete: H("delete"),
              clear: H("clear"),
              forEach: W(!0, !1),
            },
            J = {
              get(e) {
                return j(this, e, !0, !0);
              },
              get size() {
                return $(this, !0);
              },
              has(e) {
                return L.call(this, e, !0);
              },
              add: H("add"),
              set: H("set"),
              delete: H("delete"),
              clear: H("clear"),
              forEach: W(!0, !0),
            };
          function Z(e, t) {
            const r = t ? (e ? J : Y) : e ? X : G;
            return (t, i, o) =>
              "__v_isReactive" === i
                ? !e
                : "__v_isReadonly" === i
                ? e
                : "__v_raw" === i
                ? t
                : Reflect.get(n.hasOwn(r, i) && i in t ? r : t, i, o);
          }
          ["keys", "values", "entries", Symbol.iterator].forEach((e) => {
            (G[e] = U(e, !1, !1)),
              (X[e] = U(e, !0, !1)),
              (Y[e] = U(e, !1, !0)),
              (J[e] = U(e, !0, !0));
          });
          var K = { get: Z(!1, !1) },
            Q = { get: Z(!1, !0) },
            ee = { get: Z(!0, !1) },
            te = { get: Z(!0, !0) };
          function ne(e, t, r) {
            const i = de(r);
            if (i !== r && t.call(e, i)) {
              const t = n.toRawType(e);
              console.warn(
                `Reactive ${t} contains both the raw and reactive versions of the same object${
                  "Map" === t ? " as keys" : ""
                }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
              );
            }
          }
          var re = new WeakMap(),
            ie = new WeakMap(),
            oe = new WeakMap(),
            se = new WeakMap();
          function ae(e) {
            return e && e.__v_isReadonly ? e : le(e, !1, F, K, re);
          }
          function ue(e) {
            return le(e, !0, k, ee, oe);
          }
          function le(e, t, r, i, o) {
            if (!n.isObject(e))
              return (
                console.warn(`value cannot be made reactive: ${String(e)}`), e
              );
            if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
            const s = o.get(e);
            if (s) return s;
            const a =
              (u = e).__v_skip || !Object.isExtensible(u)
                ? 0
                : (function (e) {
                    switch (e) {
                      case "Object":
                      case "Array":
                        return 1;
                      case "Map":
                      case "Set":
                      case "WeakMap":
                      case "WeakSet":
                        return 2;
                      default:
                        return 0;
                    }
                  })(n.toRawType(u));
            var u;
            if (0 === a) return e;
            const l = new Proxy(e, 2 === a ? i : r);
            return o.set(e, l), l;
          }
          function ce(e) {
            return pe(e) ? ce(e.__v_raw) : !(!e || !e.__v_isReactive);
          }
          function pe(e) {
            return !(!e || !e.__v_isReadonly);
          }
          function fe(e) {
            return ce(e) || pe(e);
          }
          function de(e) {
            return (e && de(e.__v_raw)) || e;
          }
          var he = (e) => (n.isObject(e) ? ae(e) : e);
          function me(e) {
            return Boolean(e && !0 === e.__v_isRef);
          }
          function ge(e, t = !1) {
            return me(e)
              ? e
              : new (class {
                  constructor(e, t = !1) {
                    (this._rawValue = e),
                      (this._shallow = t),
                      (this.__v_isRef = !0),
                      (this._value = t ? e : he(e));
                  }
                  get value() {
                    return g(de(this), "get", "value"), this._value;
                  }
                  set value(e) {
                    n.hasChanged(de(e), this._rawValue) &&
                      ((this._rawValue = e),
                      (this._value = this._shallow ? e : he(e)),
                      y(de(this), "set", "value", e));
                  }
                })(e, t);
          }
          function ye(e) {
            return me(e) ? e.value : e;
          }
          var ve = {
            get: (e, t, n) => ye(Reflect.get(e, t, n)),
            set: (e, t, n, r) => {
              const i = e[t];
              return me(i) && !me(n)
                ? ((i.value = n), !0)
                : Reflect.set(e, t, n, r);
            },
          };
          function De(e, t) {
            return me(e[t])
              ? e[t]
              : new (class {
                  constructor(e, t) {
                    (this._object = e), (this._key = t), (this.__v_isRef = !0);
                  }
                  get value() {
                    return this._object[this._key];
                  }
                  set value(e) {
                    this._object[this._key] = e;
                  }
                })(e, t);
          }
          (e.ITERATE_KEY = o),
            (e.computed = function (e) {
              let t, r;
              return (
                n.isFunction(e)
                  ? ((t = e),
                    (r = () => {
                      console.warn(
                        "Write operation failed: computed value is readonly"
                      );
                    }))
                  : ((t = e.get), (r = e.set)),
                new (class {
                  constructor(e, t, n) {
                    (this._setter = t),
                      (this._dirty = !0),
                      (this.__v_isRef = !0),
                      (this.effect = a(e, {
                        lazy: !0,
                        scheduler: () => {
                          this._dirty ||
                            ((this._dirty = !0), y(de(this), "set", "value"));
                        },
                      })),
                      (this.__v_isReadonly = n);
                  }
                  get value() {
                    const e = de(this);
                    return (
                      e._dirty && ((e._value = this.effect()), (e._dirty = !1)),
                      g(e, "get", "value"),
                      e._value
                    );
                  }
                  set value(e) {
                    this._setter(e);
                  }
                })(t, r, n.isFunction(e) || !e.set)
              );
            }),
            (e.customRef = function (e) {
              return new (class {
                constructor(e) {
                  this.__v_isRef = !0;
                  const { get: t, set: n } = e(
                    () => g(this, "get", "value"),
                    () => y(this, "set", "value")
                  );
                  (this._get = t), (this._set = n);
                }
                get value() {
                  return this._get();
                }
                set value(e) {
                  this._set(e);
                }
              })(e);
            }),
            (e.effect = a),
            (e.enableTracking = d),
            (e.isProxy = fe),
            (e.isReactive = ce),
            (e.isReadonly = pe),
            (e.isRef = me),
            (e.markRaw = function (e) {
              return n.def(e, "__v_skip", !0), e;
            }),
            (e.pauseTracking = f),
            (e.proxyRefs = function (e) {
              return ce(e) ? e : new Proxy(e, ve);
            }),
            (e.reactive = ae),
            (e.readonly = ue),
            (e.ref = function (e) {
              return ge(e);
            }),
            (e.resetTracking = h),
            (e.shallowReactive = function (e) {
              return le(e, !1, O, Q, ie);
            }),
            (e.shallowReadonly = function (e) {
              return le(e, !0, B, te, se);
            }),
            (e.shallowRef = function (e) {
              return ge(e, !0);
            }),
            (e.stop = function (e) {
              e.active &&
                (l(e), e.options.onStop && e.options.onStop(), (e.active = !1));
            }),
            (e.toRaw = de),
            (e.toRef = De),
            (e.toRefs = function (e) {
              fe(e) ||
                console.warn(
                  "toRefs() expects a reactive object but received a plain one."
                );
              const t = n.isArray(e) ? new Array(e.length) : {};
              for (const n in e) t[n] = De(e, n);
              return t;
            }),
            (e.track = g),
            (e.trigger = y),
            (e.triggerRef = function (e) {
              y(de(e), "set", "value", e.value);
            }),
            (e.unref = ye);
        }),
        y = d((e, t) => {
          t.exports = g();
        }),
        v = !1,
        D = !1,
        b = [];
      function E() {
        (v = !1), (D = !0);
        for (let e = 0; e < b.length; e++) b[e]();
        (b.length = 0), (D = !1);
      }
      var C = !0;
      function x(e) {
        i = e;
      }
      var w = [],
        A = [],
        S = [];
      function _(e, t) {
        e._x_attributeCleanups &&
          Object.entries(e._x_attributeCleanups).forEach(([n, r]) => {
            (void 0 === t || t.includes(n)) &&
              (r.forEach((e) => e()), delete e._x_attributeCleanups[n]);
          });
      }
      var T = new MutationObserver(I),
        F = !1;
      function k() {
        T.observe(document, {
          subtree: !0,
          childList: !0,
          attributes: !0,
          attributeOldValue: !0,
        }),
          (F = !0);
      }
      var O = [],
        B = !1;
      function P(e) {
        if (!F) return e();
        (O = O.concat(T.takeRecords())).length &&
          !B &&
          ((B = !0),
          queueMicrotask(() => {
            I(O), (O.length = 0), (B = !1);
          })),
          T.disconnect(),
          (F = !1);
        let t = e();
        return k(), t;
      }
      var N = !1,
        M = [];
      function I(e) {
        if (N) return void (M = M.concat(e));
        let t = [],
          n = [],
          r = new Map(),
          i = new Map();
        for (let o = 0; o < e.length; o++)
          if (
            !e[o].target._x_ignoreMutationObserver &&
            ("childList" === e[o].type &&
              (e[o].addedNodes.forEach((e) => 1 === e.nodeType && t.push(e)),
              e[o].removedNodes.forEach((e) => 1 === e.nodeType && n.push(e))),
            "attributes" === e[o].type)
          ) {
            let t = e[o].target,
              n = e[o].attributeName,
              s = e[o].oldValue,
              a = () => {
                r.has(t) || r.set(t, []),
                  r.get(t).push({ name: n, value: t.getAttribute(n) });
              },
              u = () => {
                i.has(t) || i.set(t, []), i.get(t).push(n);
              };
            t.hasAttribute(n) && null === s
              ? a()
              : t.hasAttribute(n)
              ? (u(), a())
              : u();
          }
        i.forEach((e, t) => {
          _(t, e);
        }),
          r.forEach((e, t) => {
            w.forEach((n) => n(t, e));
          });
        for (let e of n) t.includes(e) || A.forEach((t) => t(e));
        t.forEach((e) => {
          (e._x_ignoreSelf = !0), (e._x_ignore = !0);
        });
        for (let e of t)
          n.includes(e) ||
            (e.isConnected &&
              (delete e._x_ignoreSelf,
              delete e._x_ignore,
              S.forEach((t) => t(e)),
              (e._x_ignore = !0),
              (e._x_ignoreSelf = !0)));
        t.forEach((e) => {
          delete e._x_ignoreSelf, delete e._x_ignore;
        }),
          (t = null),
          (n = null),
          (r = null),
          (i = null);
      }
      function j(e) {
        return z(R(e));
      }
      function L(e, t, n) {
        return (
          (e._x_dataStack = [t, ...R(n || e)]),
          () => {
            e._x_dataStack = e._x_dataStack.filter((e) => e !== t);
          }
        );
      }
      function $(e, t) {
        let n = e._x_dataStack[0];
        Object.entries(t).forEach(([e, t]) => {
          n[e] = t;
        });
      }
      function R(e) {
        return e._x_dataStack
          ? e._x_dataStack
          : "function" == typeof ShadowRoot && e instanceof ShadowRoot
          ? R(e.host)
          : e.parentNode
          ? R(e.parentNode)
          : [];
      }
      function z(e) {
        let t = new Proxy(
          {},
          {
            ownKeys: () =>
              Array.from(new Set(e.flatMap((e) => Object.keys(e)))),
            has: (t, n) => e.some((e) => e.hasOwnProperty(n)),
            get: (n, r) =>
              (e.find((e) => {
                if (e.hasOwnProperty(r)) {
                  let n = Object.getOwnPropertyDescriptor(e, r);
                  if (
                    (n.get && n.get._x_alreadyBound) ||
                    (n.set && n.set._x_alreadyBound)
                  )
                    return !0;
                  if ((n.get || n.set) && n.enumerable) {
                    let i = n.get,
                      o = n.set,
                      s = n;
                    (i = i && i.bind(t)),
                      (o = o && o.bind(t)),
                      i && (i._x_alreadyBound = !0),
                      o && (o._x_alreadyBound = !0),
                      Object.defineProperty(e, r, { ...s, get: i, set: o });
                  }
                  return !0;
                }
                return !1;
              }) || {})[r],
            set: (t, n, r) => {
              let i = e.find((e) => e.hasOwnProperty(n));
              return i ? (i[n] = r) : (e[e.length - 1][n] = r), !0;
            },
          }
        );
        return t;
      }
      function V(e) {
        let t = (n, r = "") => {
          Object.entries(Object.getOwnPropertyDescriptors(n)).forEach(
            ([i, { value: o, enumerable: s }]) => {
              if (!1 === s || void 0 === o) return;
              let a = "" === r ? i : `${r}.${i}`;
              var u;
              "object" == typeof o && null !== o && o._x_interceptor
                ? (n[i] = o.initialize(e, a, i))
                : "object" != typeof (u = o) ||
                  Array.isArray(u) ||
                  null === u ||
                  o === n ||
                  o instanceof Element ||
                  t(o, a);
            }
          );
        };
        return t(e);
      }
      function q(e, t = () => {}) {
        let n = {
          initialValue: void 0,
          _x_interceptor: !0,
          initialize(t, n, r) {
            return e(
              this.initialValue,
              () =>
                (function (e, t) {
                  return t.split(".").reduce((e, t) => e[t], e);
                })(t, n),
              (e) => W(t, n, e),
              n,
              r
            );
          },
        };
        return (
          t(n),
          (e) => {
            if ("object" == typeof e && null !== e && e._x_interceptor) {
              let t = n.initialize.bind(n);
              n.initialize = (r, i, o) => {
                let s = e.initialize(r, i, o);
                return (n.initialValue = s), t(r, i, o);
              };
            } else n.initialValue = e;
            return n;
          }
        );
      }
      function W(e, t, n) {
        if (("string" == typeof t && (t = t.split(".")), 1 !== t.length)) {
          if (0 === t.length) throw error;
          return e[t[0]] || (e[t[0]] = {}), W(e[t[0]], t.slice(1), n);
        }
        e[t[0]] = n;
      }
      var U = {};
      function H(e, t) {
        U[e] = t;
      }
      function G(e, t) {
        return (
          Object.entries(U).forEach(([n, r]) => {
            Object.defineProperty(e, `$${n}`, {
              get: () => r(t, { Alpine: nt, interceptor: q }),
              enumerable: !1,
            });
          }),
          e
        );
      }
      function Y(e, t, n, ...r) {
        try {
          return n(...r);
        } catch (n) {
          X(n, e, t);
        }
      }
      function X(e, t, n) {
        Object.assign(e, { el: t, expression: n }),
          console.warn(
            `Alpine Expression Error: ${e.message}\n\n${
              n ? 'Expression: "' + n + '"\n\n' : ""
            }`,
            t
          ),
          setTimeout(() => {
            throw e;
          }, 0);
      }
      function J(e, t, n = {}) {
        let r;
        return Z(e, t)((e) => (r = e), n), r;
      }
      function Z(...e) {
        return K(...e);
      }
      var K = Q;
      function Q(e, t) {
        let n = {};
        G(n, e);
        let r = [n, ...R(e)];
        if ("function" == typeof t)
          return (function (e, t) {
            return (n = () => {}, { scope: r = {}, params: i = [] } = {}) => {
              te(n, t.apply(z([r, ...e]), i));
            };
          })(r, t);
        let i = (function (e, t, n) {
          let r = (function (e, t) {
            if (ee[e]) return ee[e];
            let n = Object.getPrototypeOf(async function () {}).constructor,
              r =
                /^[\n\s]*if.*\(.*\)/.test(e) || /^(let|const)\s/.test(e)
                  ? `(() => { ${e} })()`
                  : e,
              i = (() => {
                try {
                  return new n(
                    ["__self", "scope"],
                    `with (scope) { __self.result = ${r} }; __self.finished = true; return __self.result;`
                  );
                } catch (n) {
                  return X(n, t, e), Promise.resolve();
                }
              })();
            return (ee[e] = i), i;
          })(t, n);
          return (i = () => {}, { scope: o = {}, params: s = [] } = {}) => {
            (r.result = void 0), (r.finished = !1);
            let a = z([o, ...e]);
            if ("function" == typeof r) {
              let e = r(r, a).catch((e) => X(e, n, t));
              r.finished
                ? (te(i, r.result, a, s, n), (r.result = void 0))
                : e
                    .then((e) => {
                      te(i, e, a, s, n);
                    })
                    .catch((e) => X(e, n, t))
                    .finally(() => (r.result = void 0));
            }
          };
        })(r, t, e);
        return Y.bind(null, e, t, i);
      }
      var ee = {};
      function te(e, t, n, r, i) {
        if ("function" == typeof t) {
          let o = t.apply(n, r);
          o instanceof Promise
            ? o.then((t) => te(e, t, n, r)).catch((e) => X(e, i, t))
            : e(o);
        } else e(t);
      }
      var ne = "x-";
      function re(e = "") {
        return ne + e;
      }
      var ie = {};
      function oe(e, t) {
        ie[e] = t;
      }
      function se(e, t, n) {
        let r = {},
          s = Array.from(t)
            .map(pe((e, t) => (r[e] = t)))
            .filter(he)
            .map(
              (function (e, t) {
                return ({ name: n, value: r }) => {
                  let i = n.match(me()),
                    o = n.match(/:([a-zA-Z0-9\-:]+)/),
                    s = n.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
                    a = t || e[n] || n;
                  return {
                    type: i ? i[1] : null,
                    value: o ? o[1] : null,
                    modifiers: s.map((e) => e.replace(".", "")),
                    expression: r,
                    original: a,
                  };
                };
              })(r, n)
            )
            .sort(ve);
        return s.map((t) =>
          (function (e, t) {
            let n = ie[t.type] || (() => {}),
              r = [],
              [s, a] = (function (e) {
                let t = () => {};
                return [
                  (n) => {
                    let r = i(n);
                    e._x_effects ||
                      ((e._x_effects = new Set()),
                      (e._x_runEffects = () => {
                        e._x_effects.forEach((e) => e());
                      })),
                      e._x_effects.add(r),
                      (t = () => {
                        void 0 !== r && (e._x_effects.delete(r), o(r));
                      });
                  },
                  () => {
                    t();
                  },
                ];
              })(e);
            r.push(a);
            let u = {
                Alpine: nt,
                effect: s,
                cleanup: (e) => r.push(e),
                evaluateLater: Z.bind(Z, e),
                evaluate: J.bind(J, e),
              },
              l = () => r.forEach((e) => e());
            !(function (e, t, n) {
              e._x_attributeCleanups || (e._x_attributeCleanups = {}),
                e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []),
                e._x_attributeCleanups[t].push(n);
            })(e, t.original, l);
            let c = () => {
              e._x_ignore ||
                e._x_ignoreSelf ||
                (n.inline && n.inline(e, t, u),
                (n = n.bind(n, e, t, u)),
                ae ? ue.get(le).push(n) : n());
            };
            return (c.runCleanups = l), c;
          })(e, t)
        );
      }
      var ae = !1,
        ue = new Map(),
        le = Symbol(),
        ce =
          (e, t) =>
          ({ name: n, value: r }) => (
            n.startsWith(e) && (n = n.replace(e, t)), { name: n, value: r }
          );
      function pe(e = () => {}) {
        return ({ name: t, value: n }) => {
          let { name: r, value: i } = fe.reduce((e, t) => t(e), {
            name: t,
            value: n,
          });
          return r !== t && e(r, t), { name: r, value: i };
        };
      }
      var fe = [];
      function de(e) {
        fe.push(e);
      }
      function he({ name: e }) {
        return me().test(e);
      }
      var me = () => new RegExp(`^${ne}([^:^.]+)\\b`),
        ge = "DEFAULT",
        ye = [
          "ignore",
          "ref",
          "data",
          "id",
          "bind",
          "init",
          "for",
          "model",
          "transition",
          "show",
          "if",
          ge,
          "teleport",
          "element",
        ];
      function ve(e, t) {
        let n = -1 === ye.indexOf(e.type) ? ge : e.type,
          r = -1 === ye.indexOf(t.type) ? ge : t.type;
        return ye.indexOf(n) - ye.indexOf(r);
      }
      function De(e, t, n = {}) {
        e.dispatchEvent(
          new CustomEvent(t, {
            detail: n,
            bubbles: !0,
            composed: !0,
            cancelable: !0,
          })
        );
      }
      var be = [],
        Ee = !1;
      function Ce(e) {
        be.push(e),
          queueMicrotask(() => {
            Ee ||
              setTimeout(() => {
                xe();
              });
          });
      }
      function xe() {
        for (Ee = !1; be.length; ) be.shift()();
      }
      function we(e, t) {
        if ("function" == typeof ShadowRoot && e instanceof ShadowRoot)
          return void Array.from(e.children).forEach((e) => we(e, t));
        let n = !1;
        if ((t(e, () => (n = !0)), n)) return;
        let r = e.firstElementChild;
        for (; r; ) we(r, t), (r = r.nextElementSibling);
      }
      function Ae(e, ...t) {
        console.warn(`Alpine Warning: ${e}`, ...t);
      }
      var Se = [],
        _e = [];
      function Te() {
        return Se.map((e) => e());
      }
      function Fe() {
        return Se.concat(_e).map((e) => e());
      }
      function ke(e) {
        Se.push(e);
      }
      function Oe(e) {
        _e.push(e);
      }
      function Be(e, t = !1) {
        return Pe(e, (e) => {
          if ((t ? Fe() : Te()).some((t) => e.matches(t))) return !0;
        });
      }
      function Pe(e, t) {
        if (e) {
          if (t(e)) return e;
          if ((e._x_teleportBack && (e = e._x_teleportBack), e.parentElement))
            return Pe(e.parentElement, t);
        }
      }
      function Ne(e, t = we) {
        !(function (n) {
          ae = !0;
          let r = Symbol();
          (le = r), ue.set(r, []);
          let i = () => {
            for (; ue.get(r).length; ) ue.get(r).shift()();
            ue.delete(r);
          };
          t(e, (e, t) => {
            se(e, e.attributes).forEach((e) => e()), e._x_ignore && t();
          }),
            (ae = !1),
            i();
        })();
      }
      function Me(e, t) {
        return Array.isArray(t)
          ? Ie(e, t.join(" "))
          : "object" == typeof t && null !== t
          ? (function (e, t) {
              let n = (e) => e.split(" ").filter(Boolean),
                r = Object.entries(t)
                  .flatMap(([e, t]) => !!t && n(e))
                  .filter(Boolean),
                i = Object.entries(t)
                  .flatMap(([e, t]) => !t && n(e))
                  .filter(Boolean),
                o = [],
                s = [];
              return (
                i.forEach((t) => {
                  e.classList.contains(t) && (e.classList.remove(t), s.push(t));
                }),
                r.forEach((t) => {
                  e.classList.contains(t) || (e.classList.add(t), o.push(t));
                }),
                () => {
                  s.forEach((t) => e.classList.add(t)),
                    o.forEach((t) => e.classList.remove(t));
                }
              );
            })(e, t)
          : "function" == typeof t
          ? Me(e, t())
          : Ie(e, t);
      }
      function Ie(e, t) {
        return (
          (t = !0 === t ? (t = "") : t || ""),
          (n = t
            .split(" ")
            .filter((t) => !e.classList.contains(t))
            .filter(Boolean)),
          e.classList.add(...n),
          () => {
            e.classList.remove(...n);
          }
        );
        var n;
      }
      function je(e, t) {
        return "object" == typeof t && null !== t
          ? (function (e, t) {
              let n = {};
              return (
                Object.entries(t).forEach(([t, r]) => {
                  (n[t] = e.style[t]),
                    e.style.setProperty(
                      t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(),
                      r
                    );
                }),
                setTimeout(() => {
                  0 === e.style.length && e.removeAttribute("style");
                }),
                () => {
                  je(e, n);
                }
              );
            })(e, t)
          : (function (e, t) {
              let n = e.getAttribute("style", t);
              return (
                e.setAttribute("style", t),
                () => {
                  e.setAttribute("style", n || "");
                }
              );
            })(e, t);
      }
      function Le(e, t = () => {}) {
        let n = !1;
        return function () {
          n ? t.apply(this, arguments) : ((n = !0), e.apply(this, arguments));
        };
      }
      function $e(e, t, n = {}) {
        e._x_transition ||
          (e._x_transition = {
            enter: { during: n, start: n, end: n },
            leave: { during: n, start: n, end: n },
            in(n = () => {}, r = () => {}) {
              ze(
                e,
                t,
                {
                  during: this.enter.during,
                  start: this.enter.start,
                  end: this.enter.end,
                },
                n,
                r
              );
            },
            out(n = () => {}, r = () => {}) {
              ze(
                e,
                t,
                {
                  during: this.leave.during,
                  start: this.leave.start,
                  end: this.leave.end,
                },
                n,
                r
              );
            },
          });
      }
      function Re(e) {
        let t = e.parentNode;
        if (t) return t._x_hidePromise ? t : Re(t);
      }
      function ze(
        e,
        t,
        { during: n, start: r, end: i } = {},
        o = () => {},
        s = () => {}
      ) {
        if (
          (e._x_transitioning && e._x_transitioning.cancel(),
          0 === Object.keys(n).length &&
            0 === Object.keys(r).length &&
            0 === Object.keys(i).length)
        )
          return o(), void s();
        let a, u, l;
        !(function (e, t) {
          let n,
            r,
            i,
            o = Le(() => {
              P(() => {
                (n = !0),
                  r || t.before(),
                  i || (t.end(), xe()),
                  t.after(),
                  e.isConnected && t.cleanup(),
                  delete e._x_transitioning;
              });
            });
          (e._x_transitioning = {
            beforeCancels: [],
            beforeCancel(e) {
              this.beforeCancels.push(e);
            },
            cancel: Le(function () {
              for (; this.beforeCancels.length; ) this.beforeCancels.shift()();
              o();
            }),
            finish: o,
          }),
            P(() => {
              t.start(), t.during();
            }),
            (Ee = !0),
            requestAnimationFrame(() => {
              if (n) return;
              let o =
                  1e3 *
                  Number(
                    getComputedStyle(e)
                      .transitionDuration.replace(/,.*/, "")
                      .replace("s", "")
                  ),
                s =
                  1e3 *
                  Number(
                    getComputedStyle(e)
                      .transitionDelay.replace(/,.*/, "")
                      .replace("s", "")
                  );
              0 === o &&
                (o =
                  1e3 *
                  Number(
                    getComputedStyle(e).animationDuration.replace("s", "")
                  )),
                P(() => {
                  t.before();
                }),
                (r = !0),
                requestAnimationFrame(() => {
                  n ||
                    (P(() => {
                      t.end();
                    }),
                    xe(),
                    setTimeout(e._x_transitioning.finish, o + s),
                    (i = !0));
                });
            });
        })(e, {
          start() {
            a = t(e, r);
          },
          during() {
            u = t(e, n);
          },
          before: o,
          end() {
            a(), (l = t(e, i));
          },
          after: s,
          cleanup() {
            u(), l();
          },
        });
      }
      function Ve(e, t, n) {
        if (-1 === e.indexOf(t)) return n;
        const r = e[e.indexOf(t) + 1];
        if (!r) return n;
        if ("scale" === t && isNaN(r)) return n;
        if ("duration" === t) {
          let e = r.match(/([0-9]+)ms/);
          if (e) return e[1];
        }
        return "origin" === t &&
          ["top", "right", "left", "center", "bottom"].includes(
            e[e.indexOf(t) + 2]
          )
          ? [r, e[e.indexOf(t) + 2]].join(" ")
          : r;
      }
      oe(
        "transition",
        (e, { value: t, modifiers: n, expression: r }, { evaluate: i }) => {
          "function" == typeof r && (r = i(r)),
            r
              ? (function (e, t, n) {
                  $e(e, Me, ""),
                    {
                      enter: (t) => {
                        e._x_transition.enter.during = t;
                      },
                      "enter-start": (t) => {
                        e._x_transition.enter.start = t;
                      },
                      "enter-end": (t) => {
                        e._x_transition.enter.end = t;
                      },
                      leave: (t) => {
                        e._x_transition.leave.during = t;
                      },
                      "leave-start": (t) => {
                        e._x_transition.leave.start = t;
                      },
                      "leave-end": (t) => {
                        e._x_transition.leave.end = t;
                      },
                    }[n](t);
                })(e, r, t)
              : (function (e, t, n) {
                  $e(e, je);
                  let r = !t.includes("in") && !t.includes("out") && !n,
                    i = r || t.includes("in") || ["enter"].includes(n),
                    o = r || t.includes("out") || ["leave"].includes(n);
                  t.includes("in") &&
                    !r &&
                    (t = t.filter((e, n) => n < t.indexOf("out"))),
                    t.includes("out") &&
                      !r &&
                      (t = t.filter((e, n) => n > t.indexOf("out")));
                  let s = !t.includes("opacity") && !t.includes("scale"),
                    a = s || t.includes("opacity") ? 0 : 1,
                    u = s || t.includes("scale") ? Ve(t, "scale", 95) / 100 : 1,
                    l = Ve(t, "delay", 0),
                    c = Ve(t, "origin", "center"),
                    p = "opacity, transform",
                    f = Ve(t, "duration", 150) / 1e3,
                    d = Ve(t, "duration", 75) / 1e3,
                    h = "cubic-bezier(0.4, 0.0, 0.2, 1)";
                  i &&
                    ((e._x_transition.enter.during = {
                      transformOrigin: c,
                      transitionDelay: l,
                      transitionProperty: p,
                      transitionDuration: `${f}s`,
                      transitionTimingFunction: h,
                    }),
                    (e._x_transition.enter.start = {
                      opacity: a,
                      transform: `scale(${u})`,
                    }),
                    (e._x_transition.enter.end = {
                      opacity: 1,
                      transform: "scale(1)",
                    })),
                    o &&
                      ((e._x_transition.leave.during = {
                        transformOrigin: c,
                        transitionDelay: l,
                        transitionProperty: p,
                        transitionDuration: `${d}s`,
                        transitionTimingFunction: h,
                      }),
                      (e._x_transition.leave.start = {
                        opacity: 1,
                        transform: "scale(1)",
                      }),
                      (e._x_transition.leave.end = {
                        opacity: a,
                        transform: `scale(${u})`,
                      }));
                })(e, n, t);
        }
      ),
        (window.Element.prototype._x_toggleAndCascadeWithTransitions =
          function (e, t, n, r) {
            let i = () => {
              "visible" === document.visibilityState
                ? requestAnimationFrame(n)
                : setTimeout(n);
            };
            t
              ? e._x_transition &&
                (e._x_transition.enter || e._x_transition.leave)
                ? e._x_transition.enter &&
                  (Object.entries(e._x_transition.enter.during).length ||
                    Object.entries(e._x_transition.enter.start).length ||
                    Object.entries(e._x_transition.enter.end).length)
                  ? e._x_transition.in(n)
                  : i()
                : e._x_transition
                ? e._x_transition.in(n)
                : i()
              : ((e._x_hidePromise = e._x_transition
                  ? new Promise((t, n) => {
                      e._x_transition.out(
                        () => {},
                        () => t(r)
                      ),
                        e._x_transitioning.beforeCancel(() =>
                          n({ isFromCancelledTransition: !0 })
                        );
                    })
                  : Promise.resolve(r)),
                queueMicrotask(() => {
                  let t = Re(e);
                  t
                    ? (t._x_hideChildren || (t._x_hideChildren = []),
                      t._x_hideChildren.push(e))
                    : queueMicrotask(() => {
                        let t = (e) => {
                          let n = Promise.all([
                            e._x_hidePromise,
                            ...(e._x_hideChildren || []).map(t),
                          ]).then(([e]) => e());
                          return (
                            delete e._x_hidePromise, delete e._x_hideChildren, n
                          );
                        };
                        t(e).catch((e) => {
                          if (!e.isFromCancelledTransition) throw e;
                        });
                      });
                }));
          });
      var qe = !1;
      function We(e, t = () => {}) {
        return (...n) => (qe ? t(...n) : e(...n));
      }
      function Ue(e, t, n, i = []) {
        switch (
          (e._x_bindings || (e._x_bindings = r({})),
          (e._x_bindings[t] = n),
          (t = i.includes("camel")
            ? t.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase())
            : t))
        ) {
          case "value":
            !(function (e, t) {
              if ("radio" === e.type)
                void 0 === e.attributes.value && (e.value = t),
                  window.fromModel && (e.checked = He(e.value, t));
              else if ("checkbox" === e.type)
                Number.isInteger(t)
                  ? (e.value = t)
                  : Number.isInteger(t) ||
                    Array.isArray(t) ||
                    "boolean" == typeof t ||
                    [null, void 0].includes(t)
                  ? Array.isArray(t)
                    ? (e.checked = t.some((t) => He(t, e.value)))
                    : (e.checked = !!t)
                  : (e.value = String(t));
              else if ("SELECT" === e.tagName)
                !(function (e, t) {
                  const n = [].concat(t).map((e) => e + "");
                  Array.from(e.options).forEach((e) => {
                    e.selected = n.includes(e.value);
                  });
                })(e, t);
              else {
                if (e.value === t) return;
                e.value = t;
              }
            })(e, n);
            break;
          case "style":
            !(function (e, t) {
              e._x_undoAddedStyles && e._x_undoAddedStyles(),
                (e._x_undoAddedStyles = je(e, t));
            })(e, n);
            break;
          case "class":
            !(function (e, t) {
              e._x_undoAddedClasses && e._x_undoAddedClasses(),
                (e._x_undoAddedClasses = Me(e, t));
            })(e, n);
            break;
          default:
            !(function (e, t, n) {
              [null, void 0, !1].includes(n) &&
              (function (e) {
                return ![
                  "aria-pressed",
                  "aria-checked",
                  "aria-expanded",
                  "aria-selected",
                ].includes(e);
              })(t)
                ? e.removeAttribute(t)
                : (Ge(t) && (n = t),
                  (function (e, t, n) {
                    e.getAttribute(t) != n && e.setAttribute(t, n);
                  })(e, t, n));
            })(e, t, n);
        }
      }
      function He(e, t) {
        return e == t;
      }
      function Ge(e) {
        return [
          "disabled",
          "checked",
          "required",
          "readonly",
          "hidden",
          "open",
          "selected",
          "autofocus",
          "itemscope",
          "multiple",
          "novalidate",
          "allowfullscreen",
          "allowpaymentrequest",
          "formnovalidate",
          "autoplay",
          "controls",
          "loop",
          "muted",
          "playsinline",
          "default",
          "ismap",
          "reversed",
          "async",
          "defer",
          "nomodule",
        ].includes(e);
      }
      function Ye(e, t) {
        var n;
        return function () {
          var r = this,
            i = arguments,
            o = function () {
              (n = null), e.apply(r, i);
            };
          clearTimeout(n), (n = setTimeout(o, t));
        };
      }
      function Xe(e, t) {
        let n;
        return function () {
          let r = this,
            i = arguments;
          n || (e.apply(r, i), (n = !0), setTimeout(() => (n = !1), t));
        };
      }
      var Je,
        Ze,
        Ke = {},
        Qe = !1,
        et = {},
        tt = {},
        nt = {
          get reactive() {
            return r;
          },
          get release() {
            return o;
          },
          get effect() {
            return i;
          },
          get raw() {
            return s;
          },
          version: "3.8.1",
          flushAndStopDeferringMutations: function () {
            (N = !1), I(M), (M = []);
          },
          disableEffectScheduling: function (e) {
            (C = !1), e(), (C = !0);
          },
          setReactivityEngine: function (e) {
            (r = e.reactive),
              (o = e.release),
              (i = (t) =>
                e.effect(t, {
                  scheduler: (e) => {
                    C
                      ? (function (e) {
                          var t;
                          (t = e),
                            b.includes(t) || b.push(t),
                            D || v || ((v = !0), queueMicrotask(E));
                        })(e)
                      : e();
                  },
                })),
              (s = e.raw);
          },
          closestDataStack: R,
          skipDuringClone: We,
          addRootSelector: ke,
          addInitSelector: Oe,
          addScopeToNode: L,
          deferMutations: function () {
            N = !0;
          },
          mapAttributes: de,
          evaluateLater: Z,
          setEvaluator: function (e) {
            K = e;
          },
          mergeProxies: z,
          findClosest: Pe,
          closestRoot: Be,
          interceptor: q,
          transition: ze,
          setStyles: je,
          mutateDom: P,
          directive: oe,
          throttle: Xe,
          debounce: Ye,
          evaluate: J,
          initTree: Ne,
          nextTick: Ce,
          prefixed: re,
          prefix: function (e) {
            ne = e;
          },
          plugin: function (e) {
            e(nt);
          },
          magic: H,
          store: function (e, t) {
            if ((Qe || ((Ke = r(Ke)), (Qe = !0)), void 0 === t)) return Ke[e];
            (Ke[e] = t),
              "object" == typeof t &&
                null !== t &&
                t.hasOwnProperty("init") &&
                "function" == typeof t.init &&
                Ke[e].init(),
              V(Ke[e]);
          },
          start: function () {
            var e;
            document.body ||
              Ae(
                "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
              ),
              De(document, "alpine:init"),
              De(document, "alpine:initializing"),
              k(),
              (e = (e) => Ne(e, we)),
              S.push(e),
              A.push((e) => {
                we(e, (e) => _(e));
              }),
              w.push((e, t) => {
                se(e, t).forEach((e) => e());
              }),
              Array.from(document.querySelectorAll(Fe()))
                .filter((e) => !Be(e.parentElement, !0))
                .forEach((e) => {
                  Ne(e);
                }),
              De(document, "alpine:initialized");
          },
          clone: function (e, t) {
            t._x_dataStack || (t._x_dataStack = e._x_dataStack),
              (qe = !0),
              (function (e) {
                let n = i;
                x((e, t) => {
                  let r = n(e);
                  return o(r), () => {};
                }),
                  (function (e) {
                    let t = !1;
                    Ne(e, (e, n) => {
                      we(e, (e, r) => {
                        if (
                          t &&
                          (function (e) {
                            return Te().some((t) => e.matches(t));
                          })(e)
                        )
                          return r();
                        (t = !0), n(e, r);
                      });
                    });
                  })(t),
                  x(n);
              })(),
              (qe = !1);
          },
          bound: function (e, t, n) {
            if (e._x_bindings && void 0 !== e._x_bindings[t])
              return e._x_bindings[t];
            let r = e.getAttribute(t);
            return null === r
              ? "function" == typeof n
                ? n()
                : n
              : Ge(t)
              ? !![t, "true"].includes(r)
              : "" === r || r;
          },
          $data: j,
          data: function (e, t) {
            tt[e] = t;
          },
          bind: function (e, t) {
            et[e] = "function" != typeof t ? () => t : t;
          },
        },
        rt =
          ((Je = y()),
          ((e, t, n) => {
            if ((t && "object" == typeof t) || "function" == typeof t)
              for (let r of p(t))
                c.call(e, r) ||
                  "default" === r ||
                  u(e, r, {
                    get: () => t[r],
                    enumerable: !(n = f(t, r)) || n.enumerable,
                  });
            return e;
          })(
            ((Ze = u(
              null != Je ? a(l(Je)) : {},
              "default",
              Je && Je.__esModule && "default" in Je
                ? { get: () => Je.default, enumerable: !0 }
                : { value: Je, enumerable: !0 }
            )),
            u(Ze, "__esModule", { value: !0 })),
            Je
          ));
      H("nextTick", () => Ce),
        H("dispatch", (e) => De.bind(De, e)),
        H("watch", (e) => (t, n) => {
          let r,
            o = Z(e, t),
            s = !0;
          i(() =>
            o((e) => {
              JSON.stringify(e),
                s
                  ? (r = e)
                  : queueMicrotask(() => {
                      n(e, r), (r = e);
                    }),
                (s = !1);
            })
          );
        }),
        H("store", function () {
          return Ke;
        }),
        H("data", (e) => j(e)),
        H("root", (e) => Be(e)),
        H(
          "refs",
          (e) => (
            e._x_refs_proxy ||
              (e._x_refs_proxy = z(
                (function (e) {
                  let t = [],
                    n = e;
                  for (; n; )
                    n._x_refs && t.push(n._x_refs), (n = n.parentNode);
                  return t;
                })(e)
              )),
            e._x_refs_proxy
          )
        );
      var it = {};
      function ot(e) {
        return it[e] || (it[e] = 0), ++it[e];
      }
      H("id", (e) => (t, n = null) => {
        let r = (function (e, t) {
            return Pe(e, (e) => {
              if (e._x_ids && e._x_ids[t]) return !0;
            });
          })(e, t),
          i = r ? r._x_ids[t] : ot(t);
        return n ? `${t}-${i}-${n}` : `${t}-${i}`;
      }),
        H("el", (e) => e),
        oe("teleport", (e, { expression: t }, { cleanup: n }) => {
          "template" !== e.tagName.toLowerCase() &&
            Ae("x-teleport can only be used on a <template> tag", e);
          let r = document.querySelector(t);
          r || Ae(`Cannot find x-teleport element for selector: "${t}"`);
          let i = e.content.cloneNode(!0).firstElementChild;
          (e._x_teleport = i),
            (i._x_teleportBack = e),
            e._x_forwardEvents &&
              e._x_forwardEvents.forEach((t) => {
                i.addEventListener(t, (t) => {
                  t.stopPropagation(),
                    e.dispatchEvent(new t.constructor(t.type, t));
                });
              }),
            L(i, {}, e),
            P(() => {
              r.appendChild(i), Ne(i), (i._x_ignore = !0);
            }),
            n(() => i.remove());
        });
      var st = () => {};
      function at(e, t, n, r) {
        let i = e,
          o = (e) => r(e),
          s = {},
          a = (e, t) => (n) => t(e, n);
        if (
          (n.includes("dot") && (t = t.replace(/-/g, ".")),
          n.includes("camel") &&
            (t = t.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase())),
          n.includes("passive") && (s.passive = !0),
          n.includes("capture") && (s.capture = !0),
          n.includes("window") && (i = window),
          n.includes("document") && (i = document),
          n.includes("prevent") &&
            (o = a(o, (e, t) => {
              t.preventDefault(), e(t);
            })),
          n.includes("stop") &&
            (o = a(o, (e, t) => {
              t.stopPropagation(), e(t);
            })),
          n.includes("self") &&
            (o = a(o, (t, n) => {
              n.target === e && t(n);
            })),
          (n.includes("away") || n.includes("outside")) &&
            ((i = document),
            (o = a(o, (t, n) => {
              e.contains(n.target) ||
                (e.offsetWidth < 1 && e.offsetHeight < 1) ||
                (!1 !== e._x_isShown && t(n));
            }))),
          (o = a(o, (e, r) => {
            ((function (e) {
              return ["keydown", "keyup"].includes(e);
            })(t) &&
              (function (e, t) {
                let n = t.filter(
                  (e) =>
                    !["window", "document", "prevent", "stop", "once"].includes(
                      e
                    )
                );
                if (n.includes("debounce")) {
                  let e = n.indexOf("debounce");
                  n.splice(
                    e,
                    ut((n[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
                  );
                }
                if (0 === n.length) return !1;
                if (1 === n.length && lt(e.key).includes(n[0])) return !1;
                const r = [
                  "ctrl",
                  "shift",
                  "alt",
                  "meta",
                  "cmd",
                  "super",
                ].filter((e) => n.includes(e));
                return (
                  (n = n.filter((e) => !r.includes(e))),
                  !(
                    r.length > 0 &&
                    r.filter(
                      (t) => (
                        ("cmd" !== t && "super" !== t) || (t = "meta"),
                        e[`${t}Key`]
                      )
                    ).length === r.length &&
                    lt(e.key).includes(n[0])
                  )
                );
              })(r, n)) ||
              e(r);
          })),
          n.includes("debounce"))
        ) {
          let e = n[n.indexOf("debounce") + 1] || "invalid-wait",
            t = ut(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
          o = Ye(o, t);
        }
        if (n.includes("throttle")) {
          let e = n[n.indexOf("throttle") + 1] || "invalid-wait",
            t = ut(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
          o = Xe(o, t);
        }
        return (
          n.includes("once") &&
            (o = a(o, (e, n) => {
              e(n), i.removeEventListener(t, o, s);
            })),
          i.addEventListener(t, o, s),
          () => {
            i.removeEventListener(t, o, s);
          }
        );
      }
      function ut(e) {
        return !Array.isArray(e) && !isNaN(e);
      }
      function lt(e) {
        if (!e) return [];
        e = e
          .replace(/([a-z])([A-Z])/g, "$1-$2")
          .replace(/[_\s]/, "-")
          .toLowerCase();
        let t = {
          ctrl: "control",
          slash: "/",
          space: "-",
          spacebar: "-",
          cmd: "meta",
          esc: "escape",
          up: "arrow-up",
          down: "arrow-down",
          left: "arrow-left",
          right: "arrow-right",
          period: ".",
          equal: "=",
        };
        return (
          (t[e] = e),
          Object.keys(t)
            .map((n) => {
              if (t[n] === e) return n;
            })
            .filter((e) => e)
        );
      }
      function ct(e) {
        let t = e ? parseFloat(e) : null;
        return (n = t), Array.isArray(n) || isNaN(n) ? e : t;
        var n;
      }
      function pt(e, t, n, r) {
        let i = {};
        return (
          /^\[.*\]$/.test(e.item) && Array.isArray(t)
            ? e.item
                .replace("[", "")
                .replace("]", "")
                .split(",")
                .map((e) => e.trim())
                .forEach((e, n) => {
                  i[e] = t[n];
                })
            : /^\{.*\}$/.test(e.item) &&
              !Array.isArray(t) &&
              "object" == typeof t
            ? e.item
                .replace("{", "")
                .replace("}", "")
                .split(",")
                .map((e) => e.trim())
                .forEach((e) => {
                  i[e] = t[e];
                })
            : (i[e.item] = t),
          e.index && (i[e.index] = n),
          e.collection && (i[e.collection] = r),
          i
        );
      }
      function ft() {}
      (st.inline = (e, { modifiers: t }, { cleanup: n }) => {
        t.includes("self") ? (e._x_ignoreSelf = !0) : (e._x_ignore = !0),
          n(() => {
            t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore;
          });
      }),
        oe("ignore", st),
        oe("effect", (e, { expression: t }, { effect: n }) => n(Z(e, t))),
        oe(
          "model",
          (e, { modifiers: t, expression: n }, { effect: r, cleanup: i }) => {
            let o = Z(e, n),
              s = Z(e, `${n} = rightSideOfExpression($event, ${n})`);
            var a =
              "select" === e.tagName.toLowerCase() ||
              ["checkbox", "radio"].includes(e.type) ||
              t.includes("lazy")
                ? "change"
                : "input";
            let u = (function (e, t, n) {
                return (
                  "radio" === e.type &&
                    P(() => {
                      e.hasAttribute("name") || e.setAttribute("name", n);
                    }),
                  (n, r) =>
                    P(() => {
                      if (n instanceof CustomEvent && void 0 !== n.detail)
                        return n.detail || n.target.value;
                      if ("checkbox" === e.type) {
                        if (Array.isArray(r)) {
                          let e = t.includes("number")
                            ? ct(n.target.value)
                            : n.target.value;
                          return n.target.checked
                            ? r.concat([e])
                            : r.filter((t) => !(t == e));
                        }
                        return n.target.checked;
                      }
                      if ("select" === e.tagName.toLowerCase() && e.multiple)
                        return t.includes("number")
                          ? Array.from(n.target.selectedOptions).map((e) =>
                              ct(e.value || e.text)
                            )
                          : Array.from(n.target.selectedOptions).map(
                              (e) => e.value || e.text
                            );
                      {
                        let e = n.target.value;
                        return t.includes("number")
                          ? ct(e)
                          : t.includes("trim")
                          ? e.trim()
                          : e;
                      }
                    })
                );
              })(e, t, n),
              l = at(e, a, t, (e) => {
                s(() => {}, { scope: { $event: e, rightSideOfExpression: u } });
              });
            i(() => l());
            let c = Z(e, `${n} = __placeholder`);
            (e._x_model = {
              get() {
                let e;
                return o((t) => (e = t)), e;
              },
              set(e) {
                c(() => {}, { scope: { __placeholder: e } });
              },
            }),
              (e._x_forceModelUpdate = () => {
                o((t) => {
                  void 0 === t && n.match(/\./) && (t = ""),
                    (window.fromModel = !0),
                    P(() => Ue(e, "value", t)),
                    delete window.fromModel;
                });
              }),
              r(() => {
                (t.includes("unintrusive") &&
                  document.activeElement.isSameNode(e)) ||
                  e._x_forceModelUpdate();
              });
          }
        ),
        oe("cloak", (e) =>
          queueMicrotask(() => P(() => e.removeAttribute(re("cloak"))))
        ),
        Oe(() => `[${re("init")}]`),
        oe(
          "init",
          We((e, { expression: t }) =>
            "string" == typeof t ? !!t.trim() && J(e, t, {}) : J(e, t, {})
          )
        ),
        oe("text", (e, { expression: t }, { effect: n, evaluateLater: r }) => {
          let i = r(t);
          n(() => {
            i((t) => {
              P(() => {
                e.textContent = t;
              });
            });
          });
        }),
        oe("html", (e, { expression: t }, { effect: n, evaluateLater: r }) => {
          let i = r(t);
          n(() => {
            i((t) => {
              e.innerHTML = t;
            });
          });
        }),
        de(ce(":", re("bind:"))),
        oe(
          "bind",
          (
            e,
            { value: t, modifiers: n, expression: r, original: i },
            { effect: o }
          ) => {
            if (!t)
              return (function (e, t, n, r) {
                let i = {};
                var o;
                (o = i),
                  Object.entries(et).forEach(([e, t]) => {
                    Object.defineProperty(o, e, {
                      get:
                        () =>
                        (...e) =>
                          t(...e),
                    });
                  });
                let s = Z(e, t),
                  a = [];
                for (; a.length; ) a.pop()();
                s(
                  (t) => {
                    let r = Object.entries(t).map(([e, t]) => ({
                        name: e,
                        value: t,
                      })),
                      i = (function (e) {
                        return Array.from(e)
                          .map(pe())
                          .filter((e) => !he(e));
                      })(r);
                    (r = r.map((e) =>
                      i.find((t) => t.name === e.name)
                        ? { name: `x-bind:${e.name}`, value: `"${e.value}"` }
                        : e
                    )),
                      se(e, r, n).map((e) => {
                        a.push(e.runCleanups), e();
                      });
                  },
                  { scope: i }
                );
              })(e, r, i);
            if ("key" === t)
              return (function (e, t) {
                e._x_keyExpression = t;
              })(e, r);
            let s = Z(e, r);
            o(() =>
              s((i) => {
                void 0 === i && r.match(/\./) && (i = ""),
                  P(() => Ue(e, t, i, n));
              })
            );
          }
        ),
        ke(() => `[${re("data")}]`),
        oe(
          "data",
          We((e, { expression: t }, { cleanup: n }) => {
            t = "" === t ? "{}" : t;
            let i = {};
            G(i, e);
            let o = {};
            var s, a;
            (s = o),
              (a = i),
              Object.entries(tt).forEach(([e, t]) => {
                Object.defineProperty(s, e, {
                  get:
                    () =>
                    (...e) =>
                      t.bind(a)(...e),
                  enumerable: !1,
                });
              });
            let u = J(e, t, { scope: o });
            void 0 === u && (u = {}), G(u, e);
            let l = r(u);
            V(l);
            let c = L(e, l);
            l.init && J(e, l.init),
              n(() => {
                c(), l.destroy && J(e, l.destroy);
              });
          })
        ),
        oe("show", (e, { modifiers: t, expression: n }, { effect: r }) => {
          let i,
            o = Z(e, n),
            s = () =>
              P(() => {
                (e.style.display = "none"), (e._x_isShown = !1);
              }),
            a = () =>
              P(() => {
                1 === e.style.length && "none" === e.style.display
                  ? e.removeAttribute("style")
                  : e.style.removeProperty("display"),
                  (e._x_isShown = !0);
              }),
            u = () => setTimeout(a),
            l = Le(
              (e) => (e ? a() : s()),
              (t) => {
                "function" == typeof e._x_toggleAndCascadeWithTransitions
                  ? e._x_toggleAndCascadeWithTransitions(e, t, a, s)
                  : t
                  ? u()
                  : s();
              }
            ),
            c = !0;
          r(() =>
            o((e) => {
              (c || e !== i) &&
                (t.includes("immediate") && (e ? u() : s()),
                l(e),
                (i = e),
                (c = !1));
            })
          );
        }),
        oe("for", (e, { expression: t }, { effect: n, cleanup: i }) => {
          let o = (function (e) {
              let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
                n = e.match(/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/);
              if (!n) return;
              let r = {};
              r.items = n[2].trim();
              let i = n[1].replace(/^\s*\(|\)\s*$/g, "").trim(),
                o = i.match(t);
              return (
                o
                  ? ((r.item = i.replace(t, "").trim()),
                    (r.index = o[1].trim()),
                    o[2] && (r.collection = o[2].trim()))
                  : (r.item = i),
                r
              );
            })(t),
            s = Z(e, o.items),
            a = Z(e, e._x_keyExpression || "index");
          (e._x_prevKeys = []),
            (e._x_lookup = {}),
            n(() =>
              (function (e, t, n, i) {
                let o = e;
                n((n) => {
                  var s;
                  (s = n),
                    !Array.isArray(s) &&
                      !isNaN(s) &&
                      n >= 0 &&
                      (n = Array.from(Array(n).keys(), (e) => e + 1)),
                    void 0 === n && (n = []);
                  let a = e._x_lookup,
                    u = e._x_prevKeys,
                    l = [],
                    c = [];
                  if ("object" != typeof (p = n) || Array.isArray(p))
                    for (let e = 0; e < n.length; e++) {
                      let r = pt(t, n[e], e, n);
                      i((e) => c.push(e), { scope: { index: e, ...r } }),
                        l.push(r);
                    }
                  else
                    n = Object.entries(n).map(([e, r]) => {
                      let o = pt(t, r, e, n);
                      i((e) => c.push(e), { scope: { index: e, ...o } }),
                        l.push(o);
                    });
                  var p;
                  let f = [],
                    d = [],
                    h = [],
                    m = [];
                  for (let e = 0; e < u.length; e++) {
                    let t = u[e];
                    -1 === c.indexOf(t) && h.push(t);
                  }
                  u = u.filter((e) => !h.includes(e));
                  let g = "template";
                  for (let e = 0; e < c.length; e++) {
                    let t = c[e],
                      n = u.indexOf(t);
                    if (-1 === n) u.splice(e, 0, t), f.push([g, e]);
                    else if (n !== e) {
                      let t = u.splice(e, 1)[0],
                        r = u.splice(n - 1, 1)[0];
                      u.splice(e, 0, r), u.splice(n, 0, t), d.push([t, r]);
                    } else m.push(t);
                    g = t;
                  }
                  for (let e = 0; e < h.length; e++) {
                    let t = h[e];
                    a[t].remove(), (a[t] = null), delete a[t];
                  }
                  for (let e = 0; e < d.length; e++) {
                    let [t, n] = d[e],
                      r = a[t],
                      i = a[n],
                      o = document.createElement("div");
                    P(() => {
                      i.after(o),
                        r.after(i),
                        i._x_currentIfEl && i.after(i._x_currentIfEl),
                        o.before(r),
                        r._x_currentIfEl && r.after(r._x_currentIfEl),
                        o.remove();
                    }),
                      $(i, l[c.indexOf(n)]);
                  }
                  for (let e = 0; e < f.length; e++) {
                    let [t, n] = f[e],
                      i = "template" === t ? o : a[t];
                    i._x_currentIfEl && (i = i._x_currentIfEl);
                    let s = l[n],
                      u = c[n],
                      p = document.importNode(o.content, !0).firstElementChild;
                    L(p, r(s), o),
                      P(() => {
                        i.after(p), Ne(p);
                      }),
                      "object" == typeof u &&
                        Ae(
                          "x-for key cannot be an object, it must be a string or an integer",
                          o
                        ),
                      (a[u] = p);
                  }
                  for (let e = 0; e < m.length; e++)
                    $(a[m[e]], l[c.indexOf(m[e])]);
                  o._x_prevKeys = c;
                });
              })(e, o, s, a)
            ),
            i(() => {
              Object.values(e._x_lookup).forEach((e) => e.remove()),
                delete e._x_prevKeys,
                delete e._x_lookup;
            });
        }),
        (ft.inline = (e, { expression: t }, { cleanup: n }) => {
          let r = Be(e);
          r._x_refs || (r._x_refs = {}),
            (r._x_refs[t] = e),
            n(() => delete r._x_refs[t]);
        }),
        oe("ref", ft),
        oe("if", (e, { expression: t }, { effect: n, cleanup: r }) => {
          let i = Z(e, t);
          n(() =>
            i((t) => {
              t
                ? (() => {
                    if (e._x_currentIfEl) return e._x_currentIfEl;
                    let t = e.content.cloneNode(!0).firstElementChild;
                    L(t, {}, e),
                      P(() => {
                        e.after(t), Ne(t);
                      }),
                      (e._x_currentIfEl = t),
                      (e._x_undoIf = () => {
                        t.remove(), delete e._x_currentIfEl;
                      });
                  })()
                : e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
            })
          ),
            r(() => e._x_undoIf && e._x_undoIf());
        }),
        oe("id", (e, { expression: t }, { evaluate: n }) => {
          n(t).forEach((t) =>
            (function (e, t) {
              e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = ot(t));
            })(e, t)
          );
        }),
        de(ce("@", re("on:"))),
        oe(
          "on",
          We((e, { value: t, modifiers: n, expression: r }, { cleanup: i }) => {
            let o = r ? Z(e, r) : () => {};
            "template" === e.tagName.toLowerCase() &&
              (e._x_forwardEvents || (e._x_forwardEvents = []),
              e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
            let s = at(e, t, n, (e) => {
              o(() => {}, { scope: { $event: e }, params: [e] });
            });
            i(() => s());
          })
        ),
        nt.setEvaluator(Q),
        nt.setReactivityEngine({
          reactive: rt.reactive,
          effect: rt.effect,
          release: rt.stop,
          raw: rt.toRaw,
        });
      var dt = 348 == n.j ? nt : null,
        ht = 348 == n.j ? dt : null;
    },
    2711: function (e) {
      e.exports = (function (e) {
        function t(r) {
          if (n[r]) return n[r].exports;
          var i = (n[r] = { exports: {}, id: r, loaded: !1 });
          return (
            e[r].call(i.exports, i, i.exports, t), (i.loaded = !0), i.exports
          );
        }
        var n = {};
        return (t.m = e), (t.c = n), (t.p = "dist/"), t(0);
      })([
        function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          var i =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              },
            o = (r(n(1)), n(6)),
            s = r(o),
            a = r(n(7)),
            u = r(n(8)),
            l = r(n(9)),
            c = r(n(10)),
            p = r(n(11)),
            f = r(n(14)),
            d = [],
            h = !1,
            m = {
              offset: 120,
              delay: 0,
              easing: "ease",
              duration: 400,
              disable: !1,
              once: !1,
              startEvent: "DOMContentLoaded",
              throttleDelay: 99,
              debounceDelay: 50,
              disableMutationObserver: !1,
            },
            g = function () {
              if (
                (arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0] &&
                  (h = !0),
                h)
              )
                return (d = (0, p.default)(d, m)), (0, c.default)(d, m.once), d;
            },
            y = function () {
              (d = (0, f.default)()), g();
            };
          e.exports = {
            init: function (e) {
              (m = i(m, e)), (d = (0, f.default)());
              var t = document.all && !window.atob;
              return (function (e) {
                return (
                  !0 === e ||
                  ("mobile" === e && l.default.mobile()) ||
                  ("phone" === e && l.default.phone()) ||
                  ("tablet" === e && l.default.tablet()) ||
                  ("function" == typeof e && !0 === e())
                );
              })(m.disable) || t
                ? void d.forEach(function (e, t) {
                    e.node.removeAttribute("data-aos"),
                      e.node.removeAttribute("data-aos-easing"),
                      e.node.removeAttribute("data-aos-duration"),
                      e.node.removeAttribute("data-aos-delay");
                  })
                : (m.disableMutationObserver ||
                    u.default.isSupported() ||
                    (console.info(
                      '\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '
                    ),
                    (m.disableMutationObserver = !0)),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-easing", m.easing),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-duration", m.duration),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-delay", m.delay),
                  "DOMContentLoaded" === m.startEvent &&
                  ["complete", "interactive"].indexOf(document.readyState) > -1
                    ? g(!0)
                    : "load" === m.startEvent
                    ? window.addEventListener(m.startEvent, function () {
                        g(!0);
                      })
                    : document.addEventListener(m.startEvent, function () {
                        g(!0);
                      }),
                  window.addEventListener(
                    "resize",
                    (0, a.default)(g, m.debounceDelay, !0)
                  ),
                  window.addEventListener(
                    "orientationchange",
                    (0, a.default)(g, m.debounceDelay, !0)
                  ),
                  window.addEventListener(
                    "scroll",
                    (0, s.default)(function () {
                      (0, c.default)(d, m.once);
                    }, m.throttleDelay)
                  ),
                  m.disableMutationObserver || u.default.ready("[data-aos]", y),
                  d);
            },
            refresh: g,
            refreshHard: y,
          };
        },
        function (e, t) {},
        ,
        ,
        ,
        ,
        function (e, t) {
          (function (t) {
            "use strict";
            function n(e, t, n) {
              function i(t) {
                var n = f,
                  r = d;
                return (f = d = void 0), (v = t), (m = e.apply(r, n));
              }
              function s(e) {
                return (v = e), (g = setTimeout(l, t)), C ? i(e) : m;
              }
              function u(e) {
                var n = e - y;
                return void 0 === y || n >= t || n < 0 || (x && e - v >= h);
              }
              function l() {
                var e = E();
                return u(e)
                  ? c(e)
                  : void (g = setTimeout(
                      l,
                      (function (e) {
                        var n = t - (e - y);
                        return x ? b(n, h - (e - v)) : n;
                      })(e)
                    ));
              }
              function c(e) {
                return (g = void 0), w && f ? i(e) : ((f = d = void 0), m);
              }
              function p() {
                var e = E(),
                  n = u(e);
                if (((f = arguments), (d = this), (y = e), n)) {
                  if (void 0 === g) return s(y);
                  if (x) return (g = setTimeout(l, t)), i(y);
                }
                return void 0 === g && (g = setTimeout(l, t)), m;
              }
              var f,
                d,
                h,
                m,
                g,
                y,
                v = 0,
                C = !1,
                x = !1,
                w = !0;
              if ("function" != typeof e) throw new TypeError(a);
              return (
                (t = o(t) || 0),
                r(n) &&
                  ((C = !!n.leading),
                  (h = (x = "maxWait" in n) ? D(o(n.maxWait) || 0, t) : h),
                  (w = "trailing" in n ? !!n.trailing : w)),
                (p.cancel = function () {
                  void 0 !== g && clearTimeout(g),
                    (v = 0),
                    (f = y = d = g = void 0);
                }),
                (p.flush = function () {
                  return void 0 === g ? m : c(E());
                }),
                p
              );
            }
            function r(e) {
              var t = void 0 === e ? "undefined" : s(e);
              return !!e && ("object" == t || "function" == t);
            }
            function i(e) {
              return (
                "symbol" == (void 0 === e ? "undefined" : s(e)) ||
                ((function (e) {
                  return !!e && "object" == (void 0 === e ? "undefined" : s(e));
                })(e) &&
                  v.call(e) == l)
              );
            }
            function o(e) {
              if ("number" == typeof e) return e;
              if (i(e)) return u;
              if (r(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = r(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(c, "");
              var n = f.test(e);
              return n || d.test(e)
                ? h(e.slice(2), n ? 2 : 8)
                : p.test(e)
                ? u
                : +e;
            }
            var s =
                "function" == typeof Symbol &&
                "symbol" == typeof Symbol.iterator
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        "function" == typeof Symbol &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? "symbol"
                        : typeof e;
                    },
              a = "Expected a function",
              u = NaN,
              l = "[object Symbol]",
              c = /^\s+|\s+$/g,
              p = /^[-+]0x[0-9a-f]+$/i,
              f = /^0b[01]+$/i,
              d = /^0o[0-7]+$/i,
              h = parseInt,
              m =
                "object" == (void 0 === t ? "undefined" : s(t)) &&
                t &&
                t.Object === Object &&
                t,
              g =
                "object" ==
                  ("undefined" == typeof self ? "undefined" : s(self)) &&
                self &&
                self.Object === Object &&
                self,
              y = m || g || Function("return this")(),
              v = Object.prototype.toString,
              D = Math.max,
              b = Math.min,
              E = function () {
                return y.Date.now();
              };
            e.exports = function (e, t, i) {
              var o = !0,
                s = !0;
              if ("function" != typeof e) throw new TypeError(a);
              return (
                r(i) &&
                  ((o = "leading" in i ? !!i.leading : o),
                  (s = "trailing" in i ? !!i.trailing : s)),
                n(e, t, { leading: o, maxWait: t, trailing: s })
              );
            };
          }).call(
            t,
            (function () {
              return this;
            })()
          );
        },
        function (e, t) {
          (function (t) {
            "use strict";
            function n(e) {
              var t = void 0 === e ? "undefined" : o(e);
              return !!e && ("object" == t || "function" == t);
            }
            function r(e) {
              return (
                "symbol" == (void 0 === e ? "undefined" : o(e)) ||
                ((function (e) {
                  return !!e && "object" == (void 0 === e ? "undefined" : o(e));
                })(e) &&
                  y.call(e) == u)
              );
            }
            function i(e) {
              if ("number" == typeof e) return e;
              if (r(e)) return a;
              if (n(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = n(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(l, "");
              var i = p.test(e);
              return i || f.test(e)
                ? d(e.slice(2), i ? 2 : 8)
                : c.test(e)
                ? a
                : +e;
            }
            var o =
                "function" == typeof Symbol &&
                "symbol" == typeof Symbol.iterator
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        "function" == typeof Symbol &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? "symbol"
                        : typeof e;
                    },
              s = "Expected a function",
              a = NaN,
              u = "[object Symbol]",
              l = /^\s+|\s+$/g,
              c = /^[-+]0x[0-9a-f]+$/i,
              p = /^0b[01]+$/i,
              f = /^0o[0-7]+$/i,
              d = parseInt,
              h =
                "object" == (void 0 === t ? "undefined" : o(t)) &&
                t &&
                t.Object === Object &&
                t,
              m =
                "object" ==
                  ("undefined" == typeof self ? "undefined" : o(self)) &&
                self &&
                self.Object === Object &&
                self,
              g = h || m || Function("return this")(),
              y = Object.prototype.toString,
              v = Math.max,
              D = Math.min,
              b = function () {
                return g.Date.now();
              };
            e.exports = function (e, t, r) {
              function o(t) {
                var n = f,
                  r = d;
                return (f = d = void 0), (E = t), (m = e.apply(r, n));
              }
              function a(e) {
                return (E = e), (g = setTimeout(l, t)), C ? o(e) : m;
              }
              function u(e) {
                var n = e - y;
                return void 0 === y || n >= t || n < 0 || (x && e - E >= h);
              }
              function l() {
                var e = b();
                return u(e)
                  ? c(e)
                  : void (g = setTimeout(
                      l,
                      (function (e) {
                        var n = t - (e - y);
                        return x ? D(n, h - (e - E)) : n;
                      })(e)
                    ));
              }
              function c(e) {
                return (g = void 0), w && f ? o(e) : ((f = d = void 0), m);
              }
              function p() {
                var e = b(),
                  n = u(e);
                if (((f = arguments), (d = this), (y = e), n)) {
                  if (void 0 === g) return a(y);
                  if (x) return (g = setTimeout(l, t)), o(y);
                }
                return void 0 === g && (g = setTimeout(l, t)), m;
              }
              var f,
                d,
                h,
                m,
                g,
                y,
                E = 0,
                C = !1,
                x = !1,
                w = !0;
              if ("function" != typeof e) throw new TypeError(s);
              return (
                (t = i(t) || 0),
                n(r) &&
                  ((C = !!r.leading),
                  (h = (x = "maxWait" in r) ? v(i(r.maxWait) || 0, t) : h),
                  (w = "trailing" in r ? !!r.trailing : w)),
                (p.cancel = function () {
                  void 0 !== g && clearTimeout(g),
                    (E = 0),
                    (f = y = d = g = void 0);
                }),
                (p.flush = function () {
                  return void 0 === g ? m : c(b());
                }),
                p
              );
            };
          }).call(
            t,
            (function () {
              return this;
            })()
          );
        },
        function (e, t) {
          "use strict";
          function n(e) {
            var t = void 0,
              r = void 0;
            for (t = 0; t < e.length; t += 1) {
              if ((r = e[t]).dataset && r.dataset.aos) return !0;
              if (r.children && n(r.children)) return !0;
            }
            return !1;
          }
          function r() {
            return (
              window.MutationObserver ||
              window.WebKitMutationObserver ||
              window.MozMutationObserver
            );
          }
          function i(e) {
            e &&
              e.forEach(function (e) {
                var t = Array.prototype.slice.call(e.addedNodes),
                  r = Array.prototype.slice.call(e.removedNodes);
                if (n(t.concat(r))) return o();
              });
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = function () {};
          t.default = {
            isSupported: function () {
              return !!r();
            },
            ready: function (e, t) {
              var n = window.document,
                s = new (r())(i);
              (o = t),
                s.observe(n.documentElement, {
                  childList: !0,
                  subtree: !0,
                  removedNodes: !0,
                });
            },
          };
        },
        function (e, t) {
          "use strict";
          function n() {
            return (
              navigator.userAgent || navigator.vendor || window.opera || ""
            );
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var r = (function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  (r.enumerable = r.enumerable || !1),
                    (r.configurable = !0),
                    "value" in r && (r.writable = !0),
                    Object.defineProperty(e, r.key, r);
                }
              }
              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            })(),
            i =
              /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            o =
              /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            s =
              /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
            a =
              /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            u = (function () {
              function e() {
                !(function (e, t) {
                  if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function");
                })(this, e);
              }
              return (
                r(e, [
                  {
                    key: "phone",
                    value: function () {
                      var e = n();
                      return !(!i.test(e) && !o.test(e.substr(0, 4)));
                    },
                  },
                  {
                    key: "mobile",
                    value: function () {
                      var e = n();
                      return !(!s.test(e) && !a.test(e.substr(0, 4)));
                    },
                  },
                  {
                    key: "tablet",
                    value: function () {
                      return this.mobile() && !this.phone();
                    },
                  },
                ]),
                e
              );
            })();
          t.default = new u();
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          t.default = function (e, t) {
            var n = window.pageYOffset,
              r = window.innerHeight;
            e.forEach(function (e, i) {
              !(function (e, t, n) {
                var r = e.node.getAttribute("data-aos-once");
                t > e.position
                  ? e.node.classList.add("aos-animate")
                  : void 0 !== r &&
                    ("false" === r || (!n && "true" !== r)) &&
                    e.node.classList.remove("aos-animate");
              })(e, r + n, t);
            });
          };
        },
        function (e, t, n) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var r = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(n(12));
          t.default = function (e, t) {
            return (
              e.forEach(function (e, n) {
                e.node.classList.add("aos-init"),
                  (e.position = (0, r.default)(e.node, t.offset));
              }),
              e
            );
          };
        },
        function (e, t, n) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var r = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(n(13));
          t.default = function (e, t) {
            var n = 0,
              i = 0,
              o = window.innerHeight,
              s = {
                offset: e.getAttribute("data-aos-offset"),
                anchor: e.getAttribute("data-aos-anchor"),
                anchorPlacement: e.getAttribute("data-aos-anchor-placement"),
              };
            switch (
              (s.offset && !isNaN(s.offset) && (i = parseInt(s.offset)),
              s.anchor &&
                document.querySelectorAll(s.anchor) &&
                (e = document.querySelectorAll(s.anchor)[0]),
              (n = (0, r.default)(e).top),
              s.anchorPlacement)
            ) {
              case "top-bottom":
                break;
              case "center-bottom":
                n += e.offsetHeight / 2;
                break;
              case "bottom-bottom":
                n += e.offsetHeight;
                break;
              case "top-center":
                n += o / 2;
                break;
              case "bottom-center":
                n += o / 2 + e.offsetHeight;
                break;
              case "center-center":
                n += o / 2 + e.offsetHeight / 2;
                break;
              case "top-top":
                n += o;
                break;
              case "bottom-top":
                n += e.offsetHeight + o;
                break;
              case "center-top":
                n += e.offsetHeight / 2 + o;
            }
            return s.anchorPlacement || s.offset || isNaN(t) || (i = t), n + i;
          };
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          t.default = function (e) {
            for (
              var t = 0, n = 0;
              e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);

            )
              (t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0)),
                (n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0)),
                (e = e.offsetParent);
            return { top: n, left: t };
          };
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          t.default = function (e) {
            return (
              (e = e || document.querySelectorAll("[data-aos]")),
              Array.prototype.map.call(e, function (e) {
                return { node: e };
              })
            );
          };
        },
      ]);
    },
    6358: function (e, t, n) {
      "use strict";
      function r(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return e;
      }
      function i(e, t) {
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.__proto__ = t);
      }
      n.d(t, {
        p8: function () {
          return $r;
        },
      });
      var o,
        s,
        a,
        u,
        l,
        c,
        p,
        f,
        d,
        h,
        m,
        g,
        y,
        v,
        D,
        b,
        E,
        C,
        x,
        w,
        A,
        S,
        _,
        T,
        F,
        k,
        O,
        B,
        P = {
          autoSleep: 120,
          force3D: "auto",
          nullTargetWarn: 1,
          units: { lineHeight: "" },
        },
        N = { duration: 0.5, overwrite: !1, delay: 0 },
        M = 1e8,
        I = 1e-8,
        j = 2 * Math.PI,
        L = j / 4,
        $ = 0,
        R = Math.sqrt,
        z = Math.cos,
        V = Math.sin,
        q = function (e) {
          return "string" == typeof e;
        },
        W = function (e) {
          return "function" == typeof e;
        },
        U = function (e) {
          return "number" == typeof e;
        },
        H = function (e) {
          return void 0 === e;
        },
        G = function (e) {
          return "object" == typeof e;
        },
        Y = function (e) {
          return !1 !== e;
        },
        X = function () {
          return "undefined" != typeof window;
        },
        J = function (e) {
          return W(e) || q(e);
        },
        Z =
          ("function" == typeof ArrayBuffer && ArrayBuffer.isView) ||
          function () {},
        K = Array.isArray,
        Q = /(?:-?\.?\d|\.)+/gi,
        ee = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
        te = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
        ne = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
        re = /[+-]=-?[.\d]+/,
        ie = /[^,'"\[\]\s]+/gi,
        oe = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
        se = {},
        ae = {},
        ue = function (e) {
          return (ae = Ne(e, se)) && wn;
        },
        le = function (e, t) {
          return console.warn(
            "Invalid property",
            e,
            "set to",
            t,
            "Missing plugin? gsap.registerPlugin()"
          );
        },
        ce = function (e, t) {
          return !t && console.warn(e);
        },
        pe = function (e, t) {
          return (e && (se[e] = t) && ae && (ae[e] = t)) || se;
        },
        fe = function () {
          return 0;
        },
        de = {},
        he = [],
        me = {},
        ge = {},
        ye = {},
        ve = 30,
        De = [],
        be = "",
        Ee = function (e) {
          var t,
            n,
            r = e[0];
          if ((G(r) || W(r) || (e = [e]), !(t = (r._gsap || {}).harness))) {
            for (n = De.length; n-- && !De[n].targetTest(r); );
            t = De[n];
          }
          for (n = e.length; n--; )
            (e[n] && (e[n]._gsap || (e[n]._gsap = new Ht(e[n], t)))) ||
              e.splice(n, 1);
          return e;
        },
        Ce = function (e) {
          return e._gsap || Ee(pt(e))[0]._gsap;
        },
        xe = function (e, t, n) {
          return (n = e[t]) && W(n)
            ? e[t]()
            : (H(n) && e.getAttribute && e.getAttribute(t)) || n;
        },
        we = function (e, t) {
          return (e = e.split(",")).forEach(t) || e;
        },
        Ae = function (e) {
          return Math.round(1e5 * e) / 1e5 || 0;
        },
        Se = function (e) {
          return Math.round(1e7 * e) / 1e7 || 0;
        },
        _e = function (e, t) {
          var n = t.charAt(0),
            r = parseFloat(t.substr(2));
          return (
            (e = parseFloat(e)),
            "+" === n ? e + r : "-" === n ? e - r : "*" === n ? e * r : e / r
          );
        },
        Te = function (e, t) {
          for (var n = t.length, r = 0; e.indexOf(t[r]) < 0 && ++r < n; );
          return r < n;
        },
        Fe = function () {
          var e,
            t,
            n = he.length,
            r = he.slice(0);
          for (me = {}, he.length = 0, e = 0; e < n; e++)
            (t = r[e]) &&
              t._lazy &&
              (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
        },
        ke = function (e, t, n, r) {
          he.length && Fe(), e.render(t, n, r), he.length && Fe();
        },
        Oe = function (e) {
          var t = parseFloat(e);
          return (t || 0 === t) && (e + "").match(ie).length < 2
            ? t
            : q(e)
            ? e.trim()
            : e;
        },
        Be = function (e) {
          return e;
        },
        Pe = function (e, t) {
          for (var n in t) n in e || (e[n] = t[n]);
          return e;
        },
        Ne = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        Me = function e(t, n) {
          for (var r in n)
            "__proto__" !== r &&
              "constructor" !== r &&
              "prototype" !== r &&
              (t[r] = G(n[r]) ? e(t[r] || (t[r] = {}), n[r]) : n[r]);
          return t;
        },
        Ie = function (e, t) {
          var n,
            r = {};
          for (n in e) n in t || (r[n] = e[n]);
          return r;
        },
        je = function (e) {
          var t,
            n = e.parent || s,
            r = e.keyframes
              ? ((t = K(e.keyframes)),
                function (e, n) {
                  for (var r in n)
                    r in e ||
                      ("duration" === r && t) ||
                      "ease" === r ||
                      (e[r] = n[r]);
                })
              : Pe;
          if (Y(e.inherit))
            for (; n; ) r(e, n.vars.defaults), (n = n.parent || n._dp);
          return e;
        },
        Le = function (e, t, n, r, i) {
          void 0 === n && (n = "_first"), void 0 === r && (r = "_last");
          var o,
            s = e[r];
          if (i) for (o = t[i]; s && s[i] > o; ) s = s._prev;
          return (
            s
              ? ((t._next = s._next), (s._next = t))
              : ((t._next = e[n]), (e[n] = t)),
            t._next ? (t._next._prev = t) : (e[r] = t),
            (t._prev = s),
            (t.parent = t._dp = e),
            t
          );
        },
        $e = function (e, t, n, r) {
          void 0 === n && (n = "_first"), void 0 === r && (r = "_last");
          var i = t._prev,
            o = t._next;
          i ? (i._next = o) : e[n] === t && (e[n] = o),
            o ? (o._prev = i) : e[r] === t && (e[r] = i),
            (t._next = t._prev = t.parent = null);
        },
        Re = function (e, t) {
          e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove(e),
            (e._act = 0);
        },
        ze = function (e, t) {
          if (e && (!t || t._end > e._dur || t._start < 0))
            for (var n = e; n; ) (n._dirty = 1), (n = n.parent);
          return e;
        },
        Ve = function (e) {
          for (var t = e.parent; t && t.parent; )
            (t._dirty = 1), t.totalDuration(), (t = t.parent);
          return e;
        },
        qe = function e(t) {
          return !t || (t._ts && e(t.parent));
        },
        We = function (e) {
          return e._repeat
            ? Ue(e._tTime, (e = e.duration() + e._rDelay)) * e
            : 0;
        },
        Ue = function (e, t) {
          var n = Math.floor((e /= t));
          return e && n === e ? n - 1 : n;
        },
        He = function (e, t) {
          return (
            (e - t._start) * t._ts +
            (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur)
          );
        },
        Ge = function (e) {
          return (e._end = Se(
            e._start + (e._tDur / Math.abs(e._ts || e._rts || I) || 0)
          ));
        },
        Ye = function (e, t) {
          var n = e._dp;
          return (
            n &&
              n.smoothChildTiming &&
              e._ts &&
              ((e._start = Se(
                n._time -
                  (e._ts > 0
                    ? t / e._ts
                    : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)
              )),
              Ge(e),
              n._dirty || ze(n, e)),
            e
          );
        },
        Xe = function (e, t) {
          var n;
          if (
            ((t._time || (t._initted && !t._dur)) &&
              ((n = He(e.rawTime(), t)),
              (!t._dur || at(0, t.totalDuration(), n) - t._tTime > I) &&
                t.render(n, !0)),
            ze(e, t)._dp && e._initted && e._time >= e._dur && e._ts)
          ) {
            if (e._dur < e.duration())
              for (n = e; n._dp; )
                n.rawTime() >= 0 && n.totalTime(n._tTime), (n = n._dp);
            e._zTime = -1e-8;
          }
        },
        Je = function (e, t, n, r) {
          return (
            t.parent && Re(t),
            (t._start = Se(
              (U(n) ? n : n || e !== s ? it(e, n, t) : e._time) + t._delay
            )),
            (t._end = Se(
              t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)
            )),
            Le(e, t, "_first", "_last", e._sort ? "_start" : 0),
            et(t) || (e._recent = t),
            r || Xe(e, t),
            e
          );
        },
        Ze = function (e, t) {
          return (
            (se.ScrollTrigger || le("scrollTrigger", t)) &&
            se.ScrollTrigger.create(t, e)
          );
        },
        Ke = function (e, t, n, r) {
          return (
            en(e, t),
            e._initted
              ? !n &&
                e._pt &&
                ((e._dur && !1 !== e.vars.lazy) || (!e._dur && e.vars.lazy)) &&
                p !== Pt.frame
                ? (he.push(e), (e._lazy = [t, r]), 1)
                : void 0
              : 1
          );
        },
        Qe = function e(t) {
          var n = t.parent;
          return (
            n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e(n))
          );
        },
        et = function (e) {
          var t = e.data;
          return "isFromStart" === t || "isStart" === t;
        },
        tt = function (e, t, n, r) {
          var i = e._repeat,
            o = Se(t) || 0,
            s = e._tTime / e._tDur;
          return (
            s && !r && (e._time *= o / e._dur),
            (e._dur = o),
            (e._tDur = i
              ? i < 0
                ? 1e10
                : Se(o * (i + 1) + e._rDelay * i)
              : o),
            s > 0 && !r ? Ye(e, (e._tTime = e._tDur * s)) : e.parent && Ge(e),
            n || ze(e.parent, e),
            e
          );
        },
        nt = function (e) {
          return e instanceof Yt ? ze(e) : tt(e, e._dur);
        },
        rt = { _start: 0, endTime: fe, totalDuration: fe },
        it = function e(t, n, r) {
          var i,
            o,
            s,
            a = t.labels,
            u = t._recent || rt,
            l = t.duration() >= M ? u.endTime(!1) : t._dur;
          return q(n) && (isNaN(n) || n in a)
            ? ((o = n.charAt(0)),
              (s = "%" === n.substr(-1)),
              (i = n.indexOf("=")),
              "<" === o || ">" === o
                ? (i >= 0 && (n = n.replace(/=/, "")),
                  ("<" === o ? u._start : u.endTime(u._repeat >= 0)) +
                    (parseFloat(n.substr(1)) || 0) *
                      (s ? (i < 0 ? u : r).totalDuration() / 100 : 1))
                : i < 0
                ? (n in a || (a[n] = l), a[n])
                : ((o = parseFloat(n.charAt(i - 1) + n.substr(i + 1))),
                  s && r && (o = (o / 100) * (K(r) ? r[0] : r).totalDuration()),
                  i > 1 ? e(t, n.substr(0, i - 1), r) + o : l + o))
            : null == n
            ? l
            : +n;
        },
        ot = function (e, t, n) {
          var r,
            i,
            o = U(t[1]),
            s = (o ? 2 : 1) + (e < 2 ? 0 : 1),
            a = t[s];
          if ((o && (a.duration = t[1]), (a.parent = n), e)) {
            for (r = a, i = n; i && !("immediateRender" in r); )
              (r = i.vars.defaults || {}), (i = Y(i.vars.inherit) && i.parent);
            (a.immediateRender = Y(r.immediateRender)),
              e < 2 ? (a.runBackwards = 1) : (a.startAt = t[s - 1]);
          }
          return new sn(t[0], a, t[s + 1]);
        },
        st = function (e, t) {
          return e || 0 === e ? t(e) : t;
        },
        at = function (e, t, n) {
          return n < e ? e : n > t ? t : n;
        },
        ut = function (e, t) {
          return q(e) && (t = oe.exec(e)) ? t[1] : "";
        },
        lt = [].slice,
        ct = function (e, t) {
          return (
            e &&
            G(e) &&
            "length" in e &&
            ((!t && !e.length) || (e.length - 1 in e && G(e[0]))) &&
            !e.nodeType &&
            e !== a
          );
        },
        pt = function (e, t, n) {
          return !q(e) || n || (!u && Nt())
            ? K(e)
              ? (function (e, t, n) {
                  return (
                    void 0 === n && (n = []),
                    e.forEach(function (e) {
                      var r;
                      return (q(e) && !t) || ct(e, 1)
                        ? (r = n).push.apply(r, pt(e))
                        : n.push(e);
                    }) || n
                  );
                })(e, n)
              : ct(e)
              ? lt.call(e, 0)
              : e
              ? [e]
              : []
            : lt.call((t || l).querySelectorAll(e), 0);
        },
        ft = function (e) {
          return e.sort(function () {
            return 0.5 - Math.random();
          });
        },
        dt = function (e) {
          if (W(e)) return e;
          var t = G(e) ? e : { each: e },
            n = zt(t.ease),
            r = t.from || 0,
            i = parseFloat(t.base) || 0,
            o = {},
            s = r > 0 && r < 1,
            a = isNaN(r) || s,
            u = t.axis,
            l = r,
            c = r;
          return (
            q(r)
              ? (l = c = { center: 0.5, edges: 0.5, end: 1 }[r] || 0)
              : !s && a && ((l = r[0]), (c = r[1])),
            function (e, s, p) {
              var f,
                d,
                h,
                m,
                g,
                y,
                v,
                D,
                b,
                E = (p || t).length,
                C = o[E];
              if (!C) {
                if (!(b = "auto" === t.grid ? 0 : (t.grid || [1, M])[1])) {
                  for (
                    v = -M;
                    v < (v = p[b++].getBoundingClientRect().left) && b < E;

                  );
                  b--;
                }
                for (
                  C = o[E] = [],
                    f = a ? Math.min(b, E) * l - 0.5 : r % b,
                    d = b === M ? 0 : a ? (E * c) / b - 0.5 : (r / b) | 0,
                    v = 0,
                    D = M,
                    y = 0;
                  y < E;
                  y++
                )
                  (h = (y % b) - f),
                    (m = d - ((y / b) | 0)),
                    (C[y] = g =
                      u ? Math.abs("y" === u ? m : h) : R(h * h + m * m)),
                    g > v && (v = g),
                    g < D && (D = g);
                "random" === r && ft(C),
                  (C.max = v - D),
                  (C.min = D),
                  (C.v = E =
                    (parseFloat(t.amount) ||
                      parseFloat(t.each) *
                        (b > E
                          ? E - 1
                          : u
                          ? "y" === u
                            ? E / b
                            : b
                          : Math.max(b, E / b)) ||
                      0) * ("edges" === r ? -1 : 1)),
                  (C.b = E < 0 ? i - E : i),
                  (C.u = ut(t.amount || t.each) || 0),
                  (n = n && E < 0 ? $t(n) : n);
              }
              return (
                (E = (C[e] - C.min) / C.max || 0),
                Se(C.b + (n ? n(E) : E) * C.v) + C.u
              );
            }
          );
        },
        ht = function (e) {
          var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
          return function (n) {
            var r = Math.round(parseFloat(n) / e) * e * t;
            return (r - (r % 1)) / t + (U(n) ? 0 : ut(n));
          };
        },
        mt = function (e, t) {
          var n,
            r,
            i = K(e);
          return (
            !i &&
              G(e) &&
              ((n = i = e.radius || M),
              e.values
                ? ((e = pt(e.values)), (r = !U(e[0])) && (n *= n))
                : (e = ht(e.increment))),
            st(
              t,
              i
                ? W(e)
                  ? function (t) {
                      return (r = e(t)), Math.abs(r - t) <= n ? r : t;
                    }
                  : function (t) {
                      for (
                        var i,
                          o,
                          s = parseFloat(r ? t.x : t),
                          a = parseFloat(r ? t.y : 0),
                          u = M,
                          l = 0,
                          c = e.length;
                        c--;

                      )
                        (i = r
                          ? (i = e[c].x - s) * i + (o = e[c].y - a) * o
                          : Math.abs(e[c] - s)) < u && ((u = i), (l = c));
                      return (
                        (l = !n || u <= n ? e[l] : t),
                        r || l === t || U(t) ? l : l + ut(t)
                      );
                    }
                : ht(e)
            )
          );
        },
        gt = function (e, t, n, r) {
          return st(K(e) ? !t : !0 === n ? !!(n = 0) : !r, function () {
            return K(e)
              ? e[~~(Math.random() * e.length)]
              : (n = n || 1e-5) &&
                  (r = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) &&
                  Math.floor(
                    Math.round(
                      (e - n / 2 + Math.random() * (t - e + 0.99 * n)) / n
                    ) *
                      n *
                      r
                  ) / r;
          });
        },
        yt = function (e, t, n) {
          return st(n, function (n) {
            return e[~~t(n)];
          });
        },
        vt = function (e) {
          for (var t, n, r, i, o = 0, s = ""; ~(t = e.indexOf("random(", o)); )
            (r = e.indexOf(")", t)),
              (i = "[" === e.charAt(t + 7)),
              (n = e.substr(t + 7, r - t - 7).match(i ? ie : Q)),
              (s +=
                e.substr(o, t - o) +
                gt(i ? n : +n[0], i ? 0 : +n[1], +n[2] || 1e-5)),
              (o = r + 1);
          return s + e.substr(o, e.length - o);
        },
        Dt = function (e, t, n, r, i) {
          var o = t - e,
            s = r - n;
          return st(i, function (t) {
            return n + (((t - e) / o) * s || 0);
          });
        },
        bt = function (e, t, n) {
          var r,
            i,
            o,
            s = e.labels,
            a = M;
          for (r in s)
            (i = s[r] - t) < 0 == !!n &&
              i &&
              a > (i = Math.abs(i)) &&
              ((o = r), (a = i));
          return o;
        },
        Et = function (e, t, n) {
          var r,
            i,
            o = e.vars,
            s = o[t];
          if (s)
            return (
              (r = o[t + "Params"]),
              (i = o.callbackScope || e),
              n && he.length && Fe(),
              r ? s.apply(i, r) : s.call(i)
            );
        },
        Ct = function (e) {
          return (
            Re(e),
            e.scrollTrigger && e.scrollTrigger.kill(!1),
            e.progress() < 1 && Et(e, "onInterrupt"),
            e
          );
        },
        xt = function (e) {
          var t = (e = (!e.name && e.default) || e).name,
            n = W(e),
            r =
              t && !n && e.init
                ? function () {
                    this._props = [];
                  }
                : e,
            i = {
              init: fe,
              render: mn,
              add: Kt,
              kill: yn,
              modifier: gn,
              rawVars: 0,
            },
            o = {
              targetTest: 0,
              get: 0,
              getSetter: pn,
              aliases: {},
              register: 0,
            };
          if ((Nt(), e !== r)) {
            if (ge[t]) return;
            Pe(r, Pe(Ie(e, i), o)),
              Ne(r.prototype, Ne(i, Ie(e, o))),
              (ge[(r.prop = t)] = r),
              e.targetTest && (De.push(r), (de[t] = 1)),
              (t =
                ("css" === t
                  ? "CSS"
                  : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin");
          }
          pe(t, r), e.register && e.register(wn, r, bn);
        },
        wt = 255,
        At = {
          aqua: [0, wt, wt],
          lime: [0, wt, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, wt],
          navy: [0, 0, 128],
          white: [wt, wt, wt],
          olive: [128, 128, 0],
          yellow: [wt, wt, 0],
          orange: [wt, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [wt, 0, 0],
          pink: [wt, 192, 203],
          cyan: [0, wt, wt],
          transparent: [wt, wt, wt, 0],
        },
        St = function (e, t, n) {
          return (
            ((6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1
              ? t + (n - t) * e * 6
              : e < 0.5
              ? n
              : 3 * e < 2
              ? t + (n - t) * (2 / 3 - e) * 6
              : t) *
              wt +
              0.5) |
            0
          );
        },
        _t = function (e, t, n) {
          var r,
            i,
            o,
            s,
            a,
            u,
            l,
            c,
            p,
            f,
            d = e ? (U(e) ? [e >> 16, (e >> 8) & wt, e & wt] : 0) : At.black;
          if (!d) {
            if (
              ("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), At[e])
            )
              d = At[e];
            else if ("#" === e.charAt(0)) {
              if (
                (e.length < 6 &&
                  ((r = e.charAt(1)),
                  (i = e.charAt(2)),
                  (o = e.charAt(3)),
                  (e =
                    "#" +
                    r +
                    r +
                    i +
                    i +
                    o +
                    o +
                    (5 === e.length ? e.charAt(4) + e.charAt(4) : ""))),
                9 === e.length)
              )
                return [
                  (d = parseInt(e.substr(1, 6), 16)) >> 16,
                  (d >> 8) & wt,
                  d & wt,
                  parseInt(e.substr(7), 16) / 255,
                ];
              d = [
                (e = parseInt(e.substr(1), 16)) >> 16,
                (e >> 8) & wt,
                e & wt,
              ];
            } else if ("hsl" === e.substr(0, 3))
              if (((d = f = e.match(Q)), t)) {
                if (~e.indexOf("="))
                  return (d = e.match(ee)), n && d.length < 4 && (d[3] = 1), d;
              } else
                (s = (+d[0] % 360) / 360),
                  (a = +d[1] / 100),
                  (r =
                    2 * (u = +d[2] / 100) -
                    (i = u <= 0.5 ? u * (a + 1) : u + a - u * a)),
                  d.length > 3 && (d[3] *= 1),
                  (d[0] = St(s + 1 / 3, r, i)),
                  (d[1] = St(s, r, i)),
                  (d[2] = St(s - 1 / 3, r, i));
            else d = e.match(Q) || At.transparent;
            d = d.map(Number);
          }
          return (
            t &&
              !f &&
              ((r = d[0] / wt),
              (i = d[1] / wt),
              (o = d[2] / wt),
              (u = ((l = Math.max(r, i, o)) + (c = Math.min(r, i, o))) / 2),
              l === c
                ? (s = a = 0)
                : ((p = l - c),
                  (a = u > 0.5 ? p / (2 - l - c) : p / (l + c)),
                  (s =
                    l === r
                      ? (i - o) / p + (i < o ? 6 : 0)
                      : l === i
                      ? (o - r) / p + 2
                      : (r - i) / p + 4),
                  (s *= 60)),
              (d[0] = ~~(s + 0.5)),
              (d[1] = ~~(100 * a + 0.5)),
              (d[2] = ~~(100 * u + 0.5))),
            n && d.length < 4 && (d[3] = 1),
            d
          );
        },
        Tt = function (e) {
          var t = [],
            n = [],
            r = -1;
          return (
            e.split(kt).forEach(function (e) {
              var i = e.match(te) || [];
              t.push.apply(t, i), n.push((r += i.length + 1));
            }),
            (t.c = n),
            t
          );
        },
        Ft = function (e, t, n) {
          var r,
            i,
            o,
            s,
            a = "",
            u = (e + a).match(kt),
            l = t ? "hsla(" : "rgba(",
            c = 0;
          if (!u) return e;
          if (
            ((u = u.map(function (e) {
              return (
                (e = _t(e, t, 1)) &&
                l +
                  (t
                    ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3]
                    : e.join(",")) +
                  ")"
              );
            })),
            n && ((o = Tt(e)), (r = n.c).join(a) !== o.c.join(a)))
          )
            for (s = (i = e.replace(kt, "1").split(te)).length - 1; c < s; c++)
              a +=
                i[c] +
                (~r.indexOf(c)
                  ? u.shift() || l + "0,0,0,0)"
                  : (o.length ? o : u.length ? u : n).shift());
          if (!i)
            for (s = (i = e.split(kt)).length - 1; c < s; c++) a += i[c] + u[c];
          return a + i[s];
        },
        kt = (function () {
          var e,
            t =
              "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
          for (e in At) t += "|" + e + "\\b";
          return new RegExp(t + ")", "gi");
        })(),
        Ot = /hsl[a]?\(/,
        Bt = function (e) {
          var t,
            n = e.join(" ");
          if (((kt.lastIndex = 0), kt.test(n)))
            return (
              (t = Ot.test(n)),
              (e[1] = Ft(e[1], t)),
              (e[0] = Ft(e[0], t, Tt(e[1]))),
              !0
            );
        },
        Pt =
          ((b = Date.now),
          (E = 500),
          (C = 33),
          (x = b()),
          (w = x),
          (S = A = 1e3 / 240),
          (T = function e(t) {
            var n,
              r,
              i,
              o,
              s = b() - w,
              a = !0 === t;
            if (
              (s > E && (x += s - C),
              ((n = (i = (w += s) - x) - S) > 0 || a) &&
                ((o = ++y.frame),
                (v = i - 1e3 * y.time),
                (y.time = i /= 1e3),
                (S += n + (n >= A ? 4 : A - n)),
                (r = 1)),
              a || (h = m(e)),
              r)
            )
              for (D = 0; D < _.length; D++) _[D](i, v, o, t);
          }),
          (y = {
            time: 0,
            frame: 0,
            tick: function () {
              T(!0);
            },
            deltaRatio: function (e) {
              return v / (1e3 / (e || 60));
            },
            wake: function () {
              c &&
                (!u &&
                  X() &&
                  ((a = u = window),
                  (l = a.document || {}),
                  (se.gsap = wn),
                  (a.gsapVersions || (a.gsapVersions = [])).push(wn.version),
                  ue(ae || a.GreenSockGlobals || (!a.gsap && a) || {}),
                  (g = a.requestAnimationFrame)),
                h && y.sleep(),
                (m =
                  g ||
                  function (e) {
                    return setTimeout(e, (S - 1e3 * y.time + 1) | 0);
                  }),
                (d = 1),
                T(2));
            },
            sleep: function () {
              (g ? a.cancelAnimationFrame : clearTimeout)(h), (d = 0), (m = fe);
            },
            lagSmoothing: function (e, t) {
              (E = e || 1e8), (C = Math.min(t, E, 0));
            },
            fps: function (e) {
              (A = 1e3 / (e || 240)), (S = 1e3 * y.time + A);
            },
            add: function (e, t, n) {
              var r = t
                ? function (t, n, i, o) {
                    e(t, n, i, o), y.remove(r);
                  }
                : e;
              return y.remove(e), _[n ? "unshift" : "push"](r), Nt(), r;
            },
            remove: function (e, t) {
              ~(t = _.indexOf(e)) && _.splice(t, 1) && D >= t && D--;
            },
            _listeners: (_ = []),
          })),
        Nt = function () {
          return !d && Pt.wake();
        },
        Mt = {},
        It = /^[\d.\-M][\d.\-,\s]/,
        jt = /["']/g,
        Lt = function (e) {
          for (
            var t,
              n,
              r,
              i = {},
              o = e.substr(1, e.length - 3).split(":"),
              s = o[0],
              a = 1,
              u = o.length;
            a < u;
            a++
          )
            (n = o[a]),
              (t = a !== u - 1 ? n.lastIndexOf(",") : n.length),
              (r = n.substr(0, t)),
              (i[s] = isNaN(r) ? r.replace(jt, "").trim() : +r),
              (s = n.substr(t + 1).trim());
          return i;
        },
        $t = function (e) {
          return function (t) {
            return 1 - e(1 - t);
          };
        },
        Rt = function e(t, n) {
          for (var r, i = t._first; i; )
            i instanceof Yt
              ? e(i, n)
              : !i.vars.yoyoEase ||
                (i._yoyo && i._repeat) ||
                i._yoyo === n ||
                (i.timeline
                  ? e(i.timeline, n)
                  : ((r = i._ease),
                    (i._ease = i._yEase),
                    (i._yEase = r),
                    (i._yoyo = n))),
              (i = i._next);
        },
        zt = function (e, t) {
          return (
            (e &&
              (W(e)
                ? e
                : Mt[e] ||
                  (function (e) {
                    var t,
                      n,
                      r,
                      i,
                      o = (e + "").split("("),
                      s = Mt[o[0]];
                    return s && o.length > 1 && s.config
                      ? s.config.apply(
                          null,
                          ~e.indexOf("{")
                            ? [Lt(o[1])]
                            : ((t = e),
                              (n = t.indexOf("(") + 1),
                              (r = t.indexOf(")")),
                              (i = t.indexOf("(", n)),
                              t.substring(
                                n,
                                ~i && i < r ? t.indexOf(")", r + 1) : r
                              ))
                                .split(",")
                                .map(Oe)
                        )
                      : Mt._CE && It.test(e)
                      ? Mt._CE("", e)
                      : s;
                  })(e))) ||
            t
          );
        },
        Vt = function (e, t, n, r) {
          void 0 === n &&
            (n = function (e) {
              return 1 - t(1 - e);
            }),
            void 0 === r &&
              (r = function (e) {
                return e < 0.5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2;
              });
          var i,
            o = { easeIn: t, easeOut: n, easeInOut: r };
          return (
            we(e, function (e) {
              for (var t in ((Mt[e] = se[e] = o),
              (Mt[(i = e.toLowerCase())] = n),
              o))
                Mt[
                  i +
                    ("easeIn" === t
                      ? ".in"
                      : "easeOut" === t
                      ? ".out"
                      : ".inOut")
                ] = Mt[e + "." + t] = o[t];
            }),
            o
          );
        },
        qt = function (e) {
          return function (t) {
            return t < 0.5
              ? (1 - e(1 - 2 * t)) / 2
              : 0.5 + e(2 * (t - 0.5)) / 2;
          };
        },
        Wt = function e(t, n, r) {
          var i = n >= 1 ? n : 1,
            o = (r || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1),
            s = (o / j) * (Math.asin(1 / i) || 0),
            a = function (e) {
              return 1 === e
                ? 1
                : i * Math.pow(2, -10 * e) * V((e - s) * o) + 1;
            },
            u =
              "out" === t
                ? a
                : "in" === t
                ? function (e) {
                    return 1 - a(1 - e);
                  }
                : qt(a);
          return (
            (o = j / o),
            (u.config = function (n, r) {
              return e(t, n, r);
            }),
            u
          );
        },
        Ut = function e(t, n) {
          void 0 === n && (n = 1.70158);
          var r = function (e) {
              return e ? --e * e * ((n + 1) * e + n) + 1 : 0;
            },
            i =
              "out" === t
                ? r
                : "in" === t
                ? function (e) {
                    return 1 - r(1 - e);
                  }
                : qt(r);
          return (
            (i.config = function (n) {
              return e(t, n);
            }),
            i
          );
        };
      we("Linear,Quad,Cubic,Quart,Quint,Strong", function (e, t) {
        var n = t < 5 ? t + 1 : t;
        Vt(
          e + ",Power" + (n - 1),
          t
            ? function (e) {
                return Math.pow(e, n);
              }
            : function (e) {
                return e;
              },
          function (e) {
            return 1 - Math.pow(1 - e, n);
          },
          function (e) {
            return e < 0.5
              ? Math.pow(2 * e, n) / 2
              : 1 - Math.pow(2 * (1 - e), n) / 2;
          }
        );
      }),
        (Mt.Linear.easeNone = Mt.none = Mt.Linear.easeIn),
        Vt("Elastic", Wt("in"), Wt("out"), Wt()),
        (F = 7.5625),
        (O = 1 / (k = 2.75)),
        Vt(
          "Bounce",
          function (e) {
            return 1 - B(1 - e);
          },
          (B = function (e) {
            return e < O
              ? F * e * e
              : e < 0.7272727272727273
              ? F * Math.pow(e - 1.5 / k, 2) + 0.75
              : e < 0.9090909090909092
              ? F * (e -= 2.25 / k) * e + 0.9375
              : F * Math.pow(e - 2.625 / k, 2) + 0.984375;
          })
        ),
        Vt("Expo", function (e) {
          return e ? Math.pow(2, 10 * (e - 1)) : 0;
        }),
        Vt("Circ", function (e) {
          return -(R(1 - e * e) - 1);
        }),
        Vt("Sine", function (e) {
          return 1 === e ? 1 : 1 - z(e * L);
        }),
        Vt("Back", Ut("in"), Ut("out"), Ut()),
        (Mt.SteppedEase =
          Mt.steps =
          se.SteppedEase =
            {
              config: function (e, t) {
                void 0 === e && (e = 1);
                var n = 1 / e,
                  r = e + (t ? 0 : 1),
                  i = t ? 1 : 0;
                return function (e) {
                  return (((r * at(0, 0.99999999, e)) | 0) + i) * n;
                };
              },
            }),
        (N.ease = Mt["quad.out"]),
        we(
          "onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",
          function (e) {
            return (be += e + "," + e + "Params,");
          }
        );
      var Ht = function (e, t) {
          (this.id = $++),
            (e._gsap = this),
            (this.target = e),
            (this.harness = t),
            (this.get = t ? t.get : xe),
            (this.set = t ? t.getSetter : pn);
        },
        Gt = (function () {
          function e(e) {
            (this.vars = e),
              (this._delay = +e.delay || 0),
              (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) &&
                ((this._rDelay = e.repeatDelay || 0),
                (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
              (this._ts = 1),
              tt(this, +e.duration, 1, 1),
              (this.data = e.data),
              d || Pt.wake();
          }
          var t = e.prototype;
          return (
            (t.delay = function (e) {
              return e || 0 === e
                ? (this.parent &&
                    this.parent.smoothChildTiming &&
                    this.startTime(this._start + e - this._delay),
                  (this._delay = e),
                  this)
                : this._delay;
            }),
            (t.duration = function (e) {
              return arguments.length
                ? this.totalDuration(
                    this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e
                  )
                : this.totalDuration() && this._dur;
            }),
            (t.totalDuration = function (e) {
              return arguments.length
                ? ((this._dirty = 0),
                  tt(
                    this,
                    this._repeat < 0
                      ? e
                      : (e - this._repeat * this._rDelay) / (this._repeat + 1)
                  ))
                : this._tDur;
            }),
            (t.totalTime = function (e, t) {
              if ((Nt(), !arguments.length)) return this._tTime;
              var n = this._dp;
              if (n && n.smoothChildTiming && this._ts) {
                for (
                  Ye(this, e), !n._dp || n.parent || Xe(n, this);
                  n && n.parent;

                )
                  n.parent._time !==
                    n._start +
                      (n._ts >= 0
                        ? n._tTime / n._ts
                        : (n.totalDuration() - n._tTime) / -n._ts) &&
                    n.totalTime(n._tTime, !0),
                    (n = n.parent);
                !this.parent &&
                  this._dp.autoRemoveChildren &&
                  ((this._ts > 0 && e < this._tDur) ||
                    (this._ts < 0 && e > 0) ||
                    (!this._tDur && !e)) &&
                  Je(this._dp, this, this._start - this._delay);
              }
              return (
                (this._tTime !== e ||
                  (!this._dur && !t) ||
                  (this._initted && Math.abs(this._zTime) === I) ||
                  (!e && !this._initted && (this.add || this._ptLookup))) &&
                  (this._ts || (this._pTime = e), ke(this, e, t)),
                this
              );
            }),
            (t.time = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    Math.min(this.totalDuration(), e + We(this)) %
                      (this._dur + this._rDelay) || (e ? this._dur : 0),
                    t
                  )
                : this._time;
            }),
            (t.totalProgress = function (e, t) {
              return arguments.length
                ? this.totalTime(this.totalDuration() * e, t)
                : this.totalDuration()
                ? Math.min(1, this._tTime / this._tDur)
                : this.ratio;
            }),
            (t.progress = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    this.duration() *
                      (!this._yoyo || 1 & this.iteration() ? e : 1 - e) +
                      We(this),
                    t
                  )
                : this.duration()
                ? Math.min(1, this._time / this._dur)
                : this.ratio;
            }),
            (t.iteration = function (e, t) {
              var n = this.duration() + this._rDelay;
              return arguments.length
                ? this.totalTime(this._time + (e - 1) * n, t)
                : this._repeat
                ? Ue(this._tTime, n) + 1
                : 1;
            }),
            (t.timeScale = function (e) {
              if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
              if (this._rts === e) return this;
              var t =
                this.parent && this._ts
                  ? He(this.parent._time, this)
                  : this._tTime;
              return (
                (this._rts = +e || 0),
                (this._ts = this._ps || -1e-8 === e ? 0 : this._rts),
                this.totalTime(at(-this._delay, this._tDur, t), !0),
                Ge(this),
                Ve(this)
              );
            }),
            (t.paused = function (e) {
              return arguments.length
                ? (this._ps !== e &&
                    ((this._ps = e),
                    e
                      ? ((this._pTime =
                          this._tTime ||
                          Math.max(-this._delay, this.rawTime())),
                        (this._ts = this._act = 0))
                      : (Nt(),
                        (this._ts = this._rts),
                        this.totalTime(
                          this.parent && !this.parent.smoothChildTiming
                            ? this.rawTime()
                            : this._tTime || this._pTime,
                          1 === this.progress() &&
                            Math.abs(this._zTime) !== I &&
                            (this._tTime -= I)
                        ))),
                  this)
                : this._ps;
            }),
            (t.startTime = function (e) {
              if (arguments.length) {
                this._start = e;
                var t = this.parent || this._dp;
                return (
                  t &&
                    (t._sort || !this.parent) &&
                    Je(t, this, e - this._delay),
                  this
                );
              }
              return this._start;
            }),
            (t.endTime = function (e) {
              return (
                this._start +
                (Y(e) ? this.totalDuration() : this.duration()) /
                  Math.abs(this._ts || 1)
              );
            }),
            (t.rawTime = function (e) {
              var t = this.parent || this._dp;
              return t
                ? e &&
                  (!this._ts ||
                    (this._repeat && this._time && this.totalProgress() < 1))
                  ? this._tTime % (this._dur + this._rDelay)
                  : this._ts
                  ? He(t.rawTime(e), this)
                  : this._tTime
                : this._tTime;
            }),
            (t.globalTime = function (e) {
              for (var t = this, n = arguments.length ? e : t.rawTime(); t; )
                (n = t._start + n / (t._ts || 1)), (t = t._dp);
              return n;
            }),
            (t.repeat = function (e) {
              return arguments.length
                ? ((this._repeat = e === 1 / 0 ? -2 : e), nt(this))
                : -2 === this._repeat
                ? 1 / 0
                : this._repeat;
            }),
            (t.repeatDelay = function (e) {
              if (arguments.length) {
                var t = this._time;
                return (this._rDelay = e), nt(this), t ? this.time(t) : this;
              }
              return this._rDelay;
            }),
            (t.yoyo = function (e) {
              return arguments.length ? ((this._yoyo = e), this) : this._yoyo;
            }),
            (t.seek = function (e, t) {
              return this.totalTime(it(this, e), Y(t));
            }),
            (t.restart = function (e, t) {
              return this.play().totalTime(e ? -this._delay : 0, Y(t));
            }),
            (t.play = function (e, t) {
              return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
            }),
            (t.reverse = function (e, t) {
              return (
                null != e && this.seek(e || this.totalDuration(), t),
                this.reversed(!0).paused(!1)
              );
            }),
            (t.pause = function (e, t) {
              return null != e && this.seek(e, t), this.paused(!0);
            }),
            (t.resume = function () {
              return this.paused(!1);
            }),
            (t.reversed = function (e) {
              return arguments.length
                ? (!!e !== this.reversed() &&
                    this.timeScale(-this._rts || (e ? -1e-8 : 0)),
                  this)
                : this._rts < 0;
            }),
            (t.invalidate = function () {
              return (
                (this._initted = this._act = 0), (this._zTime = -1e-8), this
              );
            }),
            (t.isActive = function () {
              var e,
                t = this.parent || this._dp,
                n = this._start;
              return !(
                t &&
                !(
                  this._ts &&
                  this._initted &&
                  t.isActive() &&
                  (e = t.rawTime(!0)) >= n &&
                  e < this.endTime(!0) - I
                )
              );
            }),
            (t.eventCallback = function (e, t, n) {
              var r = this.vars;
              return arguments.length > 1
                ? (t
                    ? ((r[e] = t),
                      n && (r[e + "Params"] = n),
                      "onUpdate" === e && (this._onUpdate = t))
                    : delete r[e],
                  this)
                : r[e];
            }),
            (t.then = function (e) {
              var t = this;
              return new Promise(function (n) {
                var r = W(e) ? e : Be,
                  i = function () {
                    var e = t.then;
                    (t.then = null),
                      W(r) && (r = r(t)) && (r.then || r === t) && (t.then = e),
                      n(r),
                      (t.then = e);
                  };
                (t._initted && 1 === t.totalProgress() && t._ts >= 0) ||
                (!t._tTime && t._ts < 0)
                  ? i()
                  : (t._prom = i);
              });
            }),
            (t.kill = function () {
              Ct(this);
            }),
            e
          );
        })();
      Pe(Gt.prototype, {
        _time: 0,
        _start: 0,
        _end: 0,
        _tTime: 0,
        _tDur: 0,
        _dirty: 0,
        _repeat: 0,
        _yoyo: !1,
        parent: null,
        _initted: !1,
        _rDelay: 0,
        _ts: 1,
        _dp: 0,
        ratio: 0,
        _zTime: -1e-8,
        _prom: 0,
        _ps: !1,
        _rts: 1,
      });
      var Yt = (function (e) {
        function t(t, n) {
          var i;
          return (
            void 0 === t && (t = {}),
            ((i = e.call(this, t) || this).labels = {}),
            (i.smoothChildTiming = !!t.smoothChildTiming),
            (i.autoRemoveChildren = !!t.autoRemoveChildren),
            (i._sort = Y(t.sortChildren)),
            s && Je(t.parent || s, r(i), n),
            t.reversed && i.reverse(),
            t.paused && i.paused(!0),
            t.scrollTrigger && Ze(r(i), t.scrollTrigger),
            i
          );
        }
        i(t, e);
        var n = t.prototype;
        return (
          (n.to = function (e, t, n) {
            return ot(0, arguments, this), this;
          }),
          (n.from = function (e, t, n) {
            return ot(1, arguments, this), this;
          }),
          (n.fromTo = function (e, t, n, r) {
            return ot(2, arguments, this), this;
          }),
          (n.set = function (e, t, n) {
            return (
              (t.duration = 0),
              (t.parent = this),
              je(t).repeatDelay || (t.repeat = 0),
              (t.immediateRender = !!t.immediateRender),
              new sn(e, t, it(this, n), 1),
              this
            );
          }),
          (n.call = function (e, t, n) {
            return Je(this, sn.delayedCall(0, e, t), n);
          }),
          (n.staggerTo = function (e, t, n, r, i, o, s) {
            return (
              (n.duration = t),
              (n.stagger = n.stagger || r),
              (n.onComplete = o),
              (n.onCompleteParams = s),
              (n.parent = this),
              new sn(e, n, it(this, i)),
              this
            );
          }),
          (n.staggerFrom = function (e, t, n, r, i, o, s) {
            return (
              (n.runBackwards = 1),
              (je(n).immediateRender = Y(n.immediateRender)),
              this.staggerTo(e, t, n, r, i, o, s)
            );
          }),
          (n.staggerFromTo = function (e, t, n, r, i, o, s, a) {
            return (
              (r.startAt = n),
              (je(r).immediateRender = Y(r.immediateRender)),
              this.staggerTo(e, t, r, i, o, s, a)
            );
          }),
          (n.render = function (e, t, n) {
            var r,
              i,
              o,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              h,
              m,
              g = this._time,
              y = this._dirty ? this.totalDuration() : this._tDur,
              v = this._dur,
              D = e <= 0 ? 0 : Se(e),
              b = this._zTime < 0 != e < 0 && (this._initted || !v);
            if (
              (this !== s && D > y && e >= 0 && (D = y),
              D !== this._tTime || n || b)
            ) {
              if (
                (g !== this._time &&
                  v &&
                  ((D += this._time - g), (e += this._time - g)),
                (r = D),
                (f = this._start),
                (l = !(p = this._ts)),
                b && (v || (g = this._zTime), (e || !t) && (this._zTime = e)),
                this._repeat)
              ) {
                if (
                  ((h = this._yoyo),
                  (u = v + this._rDelay),
                  this._repeat < -1 && e < 0)
                )
                  return this.totalTime(100 * u + e, t, n);
                if (
                  ((r = Se(D % u)),
                  D === y
                    ? ((a = this._repeat), (r = v))
                    : ((a = ~~(D / u)) && a === D / u && ((r = v), a--),
                      r > v && (r = v)),
                  (d = Ue(this._tTime, u)),
                  !g && this._tTime && d !== a && (d = a),
                  h && 1 & a && ((r = v - r), (m = 1)),
                  a !== d && !this._lock)
                ) {
                  var E = h && 1 & d,
                    C = E === (h && 1 & a);
                  if (
                    (a < d && (E = !E),
                    (g = E ? 0 : v),
                    (this._lock = 1),
                    (this.render(g || (m ? 0 : Se(a * u)), t, !v)._lock = 0),
                    (this._tTime = D),
                    !t && this.parent && Et(this, "onRepeat"),
                    this.vars.repeatRefresh &&
                      !m &&
                      (this.invalidate()._lock = 1),
                    (g && g !== this._time) ||
                      l !== !this._ts ||
                      (this.vars.onRepeat && !this.parent && !this._act))
                  )
                    return this;
                  if (
                    ((v = this._dur),
                    (y = this._tDur),
                    C &&
                      ((this._lock = 2),
                      (g = E ? v : -1e-4),
                      this.render(g, !0),
                      this.vars.repeatRefresh && !m && this.invalidate()),
                    (this._lock = 0),
                    !this._ts && !l)
                  )
                    return this;
                  Rt(this, m);
                }
              }
              if (
                (this._hasPause &&
                  !this._forcing &&
                  this._lock < 2 &&
                  ((c = (function (e, t, n) {
                    var r;
                    if (n > t)
                      for (r = e._first; r && r._start <= n; ) {
                        if ("isPause" === r.data && r._start > t) return r;
                        r = r._next;
                      }
                    else
                      for (r = e._last; r && r._start >= n; ) {
                        if ("isPause" === r.data && r._start < t) return r;
                        r = r._prev;
                      }
                  })(this, Se(g), Se(r))),
                  c && (D -= r - (r = c._start))),
                (this._tTime = D),
                (this._time = r),
                (this._act = !p),
                this._initted ||
                  ((this._onUpdate = this.vars.onUpdate),
                  (this._initted = 1),
                  (this._zTime = e),
                  (g = 0)),
                !g && r && !t && (Et(this, "onStart"), this._tTime !== D))
              )
                return this;
              if (r >= g && e >= 0)
                for (i = this._first; i; ) {
                  if (
                    ((o = i._next),
                    (i._act || r >= i._start) && i._ts && c !== i)
                  ) {
                    if (i.parent !== this) return this.render(e, t, n);
                    if (
                      (i.render(
                        i._ts > 0
                          ? (r - i._start) * i._ts
                          : (i._dirty ? i.totalDuration() : i._tDur) +
                              (r - i._start) * i._ts,
                        t,
                        n
                      ),
                      r !== this._time || (!this._ts && !l))
                    ) {
                      (c = 0), o && (D += this._zTime = -1e-8);
                      break;
                    }
                  }
                  i = o;
                }
              else {
                i = this._last;
                for (var x = e < 0 ? e : r; i; ) {
                  if (
                    ((o = i._prev), (i._act || x <= i._end) && i._ts && c !== i)
                  ) {
                    if (i.parent !== this) return this.render(e, t, n);
                    if (
                      (i.render(
                        i._ts > 0
                          ? (x - i._start) * i._ts
                          : (i._dirty ? i.totalDuration() : i._tDur) +
                              (x - i._start) * i._ts,
                        t,
                        n
                      ),
                      r !== this._time || (!this._ts && !l))
                    ) {
                      (c = 0), o && (D += this._zTime = x ? -1e-8 : I);
                      break;
                    }
                  }
                  i = o;
                }
              }
              if (
                c &&
                !t &&
                (this.pause(),
                (c.render(r >= g ? 0 : -1e-8)._zTime = r >= g ? 1 : -1),
                this._ts)
              )
                return (this._start = f), Ge(this), this.render(e, t, n);
              this._onUpdate && !t && Et(this, "onUpdate", !0),
                ((D === y && this._tTime >= this.totalDuration()) ||
                  (!D && g)) &&
                  ((f !== this._start && Math.abs(p) === Math.abs(this._ts)) ||
                    this._lock ||
                    ((e || !v) &&
                      ((D === y && this._ts > 0) || (!D && this._ts < 0)) &&
                      Re(this, 1),
                    t ||
                      (e < 0 && !g) ||
                      (!D && !g && y) ||
                      (Et(
                        this,
                        D === y && e >= 0 ? "onComplete" : "onReverseComplete",
                        !0
                      ),
                      this._prom &&
                        !(D < y && this.timeScale() > 0) &&
                        this._prom())));
            }
            return this;
          }),
          (n.add = function (e, t) {
            var n = this;
            if ((U(t) || (t = it(this, t, e)), !(e instanceof Gt))) {
              if (K(e))
                return (
                  e.forEach(function (e) {
                    return n.add(e, t);
                  }),
                  this
                );
              if (q(e)) return this.addLabel(e, t);
              if (!W(e)) return this;
              e = sn.delayedCall(0, e);
            }
            return this !== e ? Je(this, e, t) : this;
          }),
          (n.getChildren = function (e, t, n, r) {
            void 0 === e && (e = !0),
              void 0 === t && (t = !0),
              void 0 === n && (n = !0),
              void 0 === r && (r = -M);
            for (var i = [], o = this._first; o; )
              o._start >= r &&
                (o instanceof sn
                  ? t && i.push(o)
                  : (n && i.push(o),
                    e && i.push.apply(i, o.getChildren(!0, t, n)))),
                (o = o._next);
            return i;
          }),
          (n.getById = function (e) {
            for (var t = this.getChildren(1, 1, 1), n = t.length; n--; )
              if (t[n].vars.id === e) return t[n];
          }),
          (n.remove = function (e) {
            return q(e)
              ? this.removeLabel(e)
              : W(e)
              ? this.killTweensOf(e)
              : ($e(this, e),
                e === this._recent && (this._recent = this._last),
                ze(this));
          }),
          (n.totalTime = function (t, n) {
            return arguments.length
              ? ((this._forcing = 1),
                !this._dp &&
                  this._ts &&
                  (this._start = Se(
                    Pt.time -
                      (this._ts > 0
                        ? t / this._ts
                        : (this.totalDuration() - t) / -this._ts)
                  )),
                e.prototype.totalTime.call(this, t, n),
                (this._forcing = 0),
                this)
              : this._tTime;
          }),
          (n.addLabel = function (e, t) {
            return (this.labels[e] = it(this, t)), this;
          }),
          (n.removeLabel = function (e) {
            return delete this.labels[e], this;
          }),
          (n.addPause = function (e, t, n) {
            var r = sn.delayedCall(0, t || fe, n);
            return (
              (r.data = "isPause"),
              (this._hasPause = 1),
              Je(this, r, it(this, e))
            );
          }),
          (n.removePause = function (e) {
            var t = this._first;
            for (e = it(this, e); t; )
              t._start === e && "isPause" === t.data && Re(t), (t = t._next);
          }),
          (n.killTweensOf = function (e, t, n) {
            for (var r = this.getTweensOf(e, n), i = r.length; i--; )
              Xt !== r[i] && r[i].kill(e, t);
            return this;
          }),
          (n.getTweensOf = function (e, t) {
            for (var n, r = [], i = pt(e), o = this._first, s = U(t); o; )
              o instanceof sn
                ? Te(o._targets, i) &&
                  (s
                    ? (!Xt || (o._initted && o._ts)) &&
                      o.globalTime(0) <= t &&
                      o.globalTime(o.totalDuration()) > t
                    : !t || o.isActive()) &&
                  r.push(o)
                : (n = o.getTweensOf(i, t)).length && r.push.apply(r, n),
                (o = o._next);
            return r;
          }),
          (n.tweenTo = function (e, t) {
            t = t || {};
            var n,
              r = this,
              i = it(r, e),
              o = t,
              s = o.startAt,
              a = o.onStart,
              u = o.onStartParams,
              l = o.immediateRender,
              c = sn.to(
                r,
                Pe(
                  {
                    ease: t.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: i,
                    overwrite: "auto",
                    duration:
                      t.duration ||
                      Math.abs(
                        (i - (s && "time" in s ? s.time : r._time)) /
                          r.timeScale()
                      ) ||
                      I,
                    onStart: function () {
                      if ((r.pause(), !n)) {
                        var e =
                          t.duration ||
                          Math.abs(
                            (i - (s && "time" in s ? s.time : r._time)) /
                              r.timeScale()
                          );
                        c._dur !== e && tt(c, e, 0, 1).render(c._time, !0, !0),
                          (n = 1);
                      }
                      a && a.apply(c, u || []);
                    },
                  },
                  t
                )
              );
            return l ? c.render(0) : c;
          }),
          (n.tweenFromTo = function (e, t, n) {
            return this.tweenTo(t, Pe({ startAt: { time: it(this, e) } }, n));
          }),
          (n.recent = function () {
            return this._recent;
          }),
          (n.nextLabel = function (e) {
            return void 0 === e && (e = this._time), bt(this, it(this, e));
          }),
          (n.previousLabel = function (e) {
            return void 0 === e && (e = this._time), bt(this, it(this, e), 1);
          }),
          (n.currentLabel = function (e) {
            return arguments.length
              ? this.seek(e, !0)
              : this.previousLabel(this._time + I);
          }),
          (n.shiftChildren = function (e, t, n) {
            void 0 === n && (n = 0);
            for (var r, i = this._first, o = this.labels; i; )
              i._start >= n && ((i._start += e), (i._end += e)), (i = i._next);
            if (t) for (r in o) o[r] >= n && (o[r] += e);
            return ze(this);
          }),
          (n.invalidate = function () {
            var t = this._first;
            for (this._lock = 0; t; ) t.invalidate(), (t = t._next);
            return e.prototype.invalidate.call(this);
          }),
          (n.clear = function (e) {
            void 0 === e && (e = !0);
            for (var t, n = this._first; n; )
              (t = n._next), this.remove(n), (n = t);
            return (
              this._dp && (this._time = this._tTime = this._pTime = 0),
              e && (this.labels = {}),
              ze(this)
            );
          }),
          (n.totalDuration = function (e) {
            var t,
              n,
              r,
              i = 0,
              o = this,
              a = o._last,
              u = M;
            if (arguments.length)
              return o.timeScale(
                (o._repeat < 0 ? o.duration() : o.totalDuration()) /
                  (o.reversed() ? -e : e)
              );
            if (o._dirty) {
              for (r = o.parent; a; )
                (t = a._prev),
                  a._dirty && a.totalDuration(),
                  (n = a._start) > u && o._sort && a._ts && !o._lock
                    ? ((o._lock = 1), (Je(o, a, n - a._delay, 1)._lock = 0))
                    : (u = n),
                  n < 0 &&
                    a._ts &&
                    ((i -= n),
                    ((!r && !o._dp) || (r && r.smoothChildTiming)) &&
                      ((o._start += n / o._ts),
                      (o._time -= n),
                      (o._tTime -= n)),
                    o.shiftChildren(-n, !1, -Infinity),
                    (u = 0)),
                  a._end > i && a._ts && (i = a._end),
                  (a = t);
              tt(o, o === s && o._time > i ? o._time : i, 1, 1), (o._dirty = 0);
            }
            return o._tDur;
          }),
          (t.updateRoot = function (e) {
            if ((s._ts && (ke(s, He(e, s)), (p = Pt.frame)), Pt.frame >= ve)) {
              ve += P.autoSleep || 120;
              var t = s._first;
              if ((!t || !t._ts) && P.autoSleep && Pt._listeners.length < 2) {
                for (; t && !t._ts; ) t = t._next;
                t || Pt.sleep();
              }
            }
          }),
          t
        );
      })(Gt);
      Pe(Yt.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
      var Xt,
        Jt,
        Zt = function (e, t, n, r, i, o, s) {
          var a,
            u,
            l,
            c,
            p,
            f,
            d,
            h,
            m = new bn(this._pt, e, t, 0, 1, hn, null, i),
            g = 0,
            y = 0;
          for (
            m.b = n,
              m.e = r,
              n += "",
              (d = ~(r += "").indexOf("random(")) && (r = vt(r)),
              o && (o((h = [n, r]), e, t), (n = h[0]), (r = h[1])),
              u = n.match(ne) || [];
            (a = ne.exec(r));

          )
            (c = a[0]),
              (p = r.substring(g, a.index)),
              l ? (l = (l + 1) % 5) : "rgba(" === p.substr(-5) && (l = 1),
              c !== u[y++] &&
                ((f = parseFloat(u[y - 1]) || 0),
                (m._pt = {
                  _next: m._pt,
                  p: p || 1 === y ? p : ",",
                  s: f,
                  c: "=" === c.charAt(1) ? _e(f, c) - f : parseFloat(c) - f,
                  m: l && l < 4 ? Math.round : 0,
                }),
                (g = ne.lastIndex));
          return (
            (m.c = g < r.length ? r.substring(g, r.length) : ""),
            (m.fp = s),
            (re.test(r) || d) && (m.e = 0),
            (this._pt = m),
            m
          );
        },
        Kt = function (e, t, n, r, i, o, s, a, u) {
          W(r) && (r = r(i || 0, e, o));
          var l,
            c = e[t],
            p =
              "get" !== n
                ? n
                : W(c)
                ? u
                  ? e[
                      t.indexOf("set") || !W(e["get" + t.substr(3)])
                        ? t
                        : "get" + t.substr(3)
                    ](u)
                  : e[t]()
                : c,
            f = W(c) ? (u ? ln : un) : an;
          if (
            (q(r) &&
              (~r.indexOf("random(") && (r = vt(r)),
              "=" === r.charAt(1) &&
                ((l = _e(p, r) + (ut(p) || 0)) || 0 === l) &&
                (r = l)),
            p !== r || Jt)
          )
            return isNaN(p * r) || "" === r
              ? (!c && !(t in e) && le(t, r),
                Zt.call(this, e, t, p, r, f, a || P.stringFilter, u))
              : ((l = new bn(
                  this._pt,
                  e,
                  t,
                  +p || 0,
                  r - (p || 0),
                  "boolean" == typeof c ? dn : fn,
                  0,
                  f
                )),
                u && (l.fp = u),
                s && l.modifier(s, this, e),
                (this._pt = l));
        },
        Qt = function (e, t, n, r, i, o) {
          var s, a, u, l;
          if (
            ge[e] &&
            !1 !==
              (s = new ge[e]()).init(
                i,
                s.rawVars
                  ? t[e]
                  : (function (e, t, n, r, i) {
                      if (
                        (W(e) && (e = nn(e, i, t, n, r)),
                        !G(e) || (e.style && e.nodeType) || K(e) || Z(e))
                      )
                        return q(e) ? nn(e, i, t, n, r) : e;
                      var o,
                        s = {};
                      for (o in e) s[o] = nn(e[o], i, t, n, r);
                      return s;
                    })(t[e], r, i, o, n),
                n,
                r,
                o
              ) &&
            ((n._pt = a =
              new bn(n._pt, i, e, 0, 1, s.render, s, 0, s.priority)),
            n !== f)
          )
            for (
              u = n._ptLookup[n._targets.indexOf(i)], l = s._props.length;
              l--;

            )
              u[s._props[l]] = a;
          return s;
        },
        en = function e(t, n) {
          var r,
            i,
            a,
            u,
            l,
            c,
            p,
            f,
            d,
            h,
            m,
            g,
            y,
            v = t.vars,
            D = v.ease,
            b = v.startAt,
            E = v.immediateRender,
            C = v.lazy,
            x = v.onUpdate,
            w = v.onUpdateParams,
            A = v.callbackScope,
            S = v.runBackwards,
            _ = v.yoyoEase,
            T = v.keyframes,
            F = v.autoRevert,
            k = t._dur,
            O = t._startAt,
            B = t._targets,
            P = t.parent,
            j = P && "nested" === P.data ? P.parent._targets : B,
            L = "auto" === t._overwrite && !o,
            $ = t.timeline;
          if (
            ($ && (!T || !D) && (D = "none"),
            (t._ease = zt(D, N.ease)),
            (t._yEase = _ ? $t(zt(!0 === _ ? D : _, N.ease)) : 0),
            _ &&
              t._yoyo &&
              !t._repeat &&
              ((_ = t._yEase), (t._yEase = t._ease), (t._ease = _)),
            (t._from = !$ && !!v.runBackwards),
            !$ || (T && !v.stagger))
          ) {
            if (
              ((g = (f = B[0] ? Ce(B[0]).harness : 0) && v[f.prop]),
              (r = Ie(v, de)),
              O && (Re(O.render(-1, !0)), (O._lazy = 0)),
              b)
            )
              if (
                (Re(
                  (t._startAt = sn.set(
                    B,
                    Pe(
                      {
                        data: "isStart",
                        overwrite: !1,
                        parent: P,
                        immediateRender: !0,
                        lazy: Y(C),
                        startAt: null,
                        delay: 0,
                        onUpdate: x,
                        onUpdateParams: w,
                        callbackScope: A,
                        stagger: 0,
                      },
                      b
                    )
                  ))
                ),
                n < 0 && !E && !F && t._startAt.render(-1, !0),
                E)
              ) {
                if ((n > 0 && !F && (t._startAt = 0), k && n <= 0))
                  return void (n && (t._zTime = n));
              } else !1 === F && (t._startAt = 0);
            else if (S && k)
              if (O) !F && (t._startAt = 0);
              else if (
                (n && (E = !1),
                (a = Pe(
                  {
                    overwrite: !1,
                    data: "isFromStart",
                    lazy: E && Y(C),
                    immediateRender: E,
                    stagger: 0,
                    parent: P,
                  },
                  r
                )),
                g && (a[f.prop] = g),
                Re((t._startAt = sn.set(B, a))),
                n < 0 && t._startAt.render(-1, !0),
                (t._zTime = n),
                E)
              ) {
                if (!n) return;
              } else e(t._startAt, I);
            for (
              t._pt = t._ptCache = 0, C = (k && Y(C)) || (C && !k), i = 0;
              i < B.length;
              i++
            ) {
              if (
                ((p = (l = B[i])._gsap || Ee(B)[i]._gsap),
                (t._ptLookup[i] = h = {}),
                me[p.id] && he.length && Fe(),
                (m = j === B ? i : j.indexOf(l)),
                f &&
                  !1 !== (d = new f()).init(l, g || r, t, m, j) &&
                  ((t._pt = u =
                    new bn(t._pt, l, d.name, 0, 1, d.render, d, 0, d.priority)),
                  d._props.forEach(function (e) {
                    h[e] = u;
                  }),
                  d.priority && (c = 1)),
                !f || g)
              )
                for (a in r)
                  ge[a] && (d = Qt(a, r, t, m, l, j))
                    ? d.priority && (c = 1)
                    : (h[a] = u =
                        Kt.call(t, l, a, "get", r[a], m, j, 0, v.stringFilter));
              t._op && t._op[i] && t.kill(l, t._op[i]),
                L &&
                  t._pt &&
                  ((Xt = t),
                  s.killTweensOf(l, h, t.globalTime(n)),
                  (y = !t.parent),
                  (Xt = 0)),
                t._pt && C && (me[p.id] = 1);
            }
            c && Dn(t), t._onInit && t._onInit(t);
          }
          (t._onUpdate = x),
            (t._initted = (!t._op || t._pt) && !y),
            T && n <= 0 && $.render(M, !0, !0);
        },
        tn = function (e, t, n, r) {
          var i,
            o,
            s = t.ease || r || "power1.inOut";
          if (K(t))
            (o = n[e] || (n[e] = [])),
              t.forEach(function (e, n) {
                return o.push({ t: (n / (t.length - 1)) * 100, v: e, e: s });
              });
          else
            for (i in t)
              (o = n[i] || (n[i] = [])),
                "ease" === i || o.push({ t: parseFloat(e), v: t[i], e: s });
        },
        nn = function (e, t, n, r, i) {
          return W(e)
            ? e.call(t, n, r, i)
            : q(e) && ~e.indexOf("random(")
            ? vt(e)
            : e;
        },
        rn = be + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
        on = {};
      we(rn + ",id,stagger,delay,duration,paused,scrollTrigger", function (e) {
        return (on[e] = 1);
      });
      var sn = (function (e) {
        function t(t, n, i, a) {
          var u;
          "number" == typeof n && ((i.duration = n), (n = i), (i = null));
          var l,
            c,
            p,
            f,
            d,
            h,
            m,
            g,
            y = (u = e.call(this, a ? n : je(n)) || this).vars,
            v = y.duration,
            D = y.delay,
            b = y.immediateRender,
            E = y.stagger,
            C = y.overwrite,
            x = y.keyframes,
            w = y.defaults,
            A = y.scrollTrigger,
            S = y.yoyoEase,
            _ = n.parent || s,
            T = (K(t) || Z(t) ? U(t[0]) : "length" in n) ? [t] : pt(t);
          if (
            ((u._targets = T.length
              ? Ee(T)
              : ce(
                  "GSAP target " + t + " not found. https://greensock.com",
                  !P.nullTargetWarn
                ) || []),
            (u._ptLookup = []),
            (u._overwrite = C),
            x || E || J(v) || J(D))
          ) {
            if (
              ((n = u.vars),
              (l = u.timeline =
                new Yt({ data: "nested", defaults: w || {} })).kill(),
              (l.parent = l._dp = r(u)),
              (l._start = 0),
              E || J(v) || J(D))
            ) {
              if (((f = T.length), (m = E && dt(E)), G(E)))
                for (d in E) ~rn.indexOf(d) && (g || (g = {}), (g[d] = E[d]));
              for (c = 0; c < f; c++)
                ((p = Ie(n, on)).stagger = 0),
                  S && (p.yoyoEase = S),
                  g && Ne(p, g),
                  (h = T[c]),
                  (p.duration = +nn(v, r(u), c, h, T)),
                  (p.delay = (+nn(D, r(u), c, h, T) || 0) - u._delay),
                  !E &&
                    1 === f &&
                    p.delay &&
                    ((u._delay = D = p.delay), (u._start += D), (p.delay = 0)),
                  l.to(h, p, m ? m(c, h, T) : 0),
                  (l._ease = Mt.none);
              l.duration() ? (v = D = 0) : (u.timeline = 0);
            } else if (x) {
              je(Pe(l.vars.defaults, { ease: "none" })),
                (l._ease = zt(x.ease || n.ease || "none"));
              var F,
                k,
                O,
                B = 0;
              if (K(x))
                x.forEach(function (e) {
                  return l.to(T, e, ">");
                });
              else {
                for (d in ((p = {}), x))
                  "ease" === d ||
                    "easeEach" === d ||
                    tn(d, x[d], p, x.easeEach);
                for (d in p)
                  for (
                    F = p[d].sort(function (e, t) {
                      return e.t - t.t;
                    }),
                      B = 0,
                      c = 0;
                    c < F.length;
                    c++
                  )
                    ((O = {
                      ease: (k = F[c]).e,
                      duration: ((k.t - (c ? F[c - 1].t : 0)) / 100) * v,
                    })[d] = k.v),
                      l.to(T, O, B),
                      (B += O.duration);
                l.duration() < v && l.to({}, { duration: v - l.duration() });
              }
            }
            v || u.duration((v = l.duration()));
          } else u.timeline = 0;
          return (
            !0 !== C || o || ((Xt = r(u)), s.killTweensOf(T), (Xt = 0)),
            Je(_, r(u), i),
            n.reversed && u.reverse(),
            n.paused && u.paused(!0),
            (b ||
              (!v &&
                !x &&
                u._start === Se(_._time) &&
                Y(b) &&
                qe(r(u)) &&
                "nested" !== _.data)) &&
              ((u._tTime = -1e-8), u.render(Math.max(0, -D))),
            A && Ze(r(u), A),
            u
          );
        }
        i(t, e);
        var n = t.prototype;
        return (
          (n.render = function (e, t, n) {
            var r,
              i,
              o,
              s,
              a,
              u,
              l,
              c,
              p,
              f = this._time,
              d = this._tDur,
              h = this._dur,
              m = e > d - I && e >= 0 ? d : e < I ? 0 : e;
            if (h) {
              if (
                m !== this._tTime ||
                !e ||
                n ||
                (!this._initted && this._tTime) ||
                (this._startAt && this._zTime < 0 != e < 0)
              ) {
                if (((r = m), (c = this.timeline), this._repeat)) {
                  if (((s = h + this._rDelay), this._repeat < -1 && e < 0))
                    return this.totalTime(100 * s + e, t, n);
                  if (
                    ((r = Se(m % s)),
                    m === d
                      ? ((o = this._repeat), (r = h))
                      : ((o = ~~(m / s)) && o === m / s && ((r = h), o--),
                        r > h && (r = h)),
                    (u = this._yoyo && 1 & o) &&
                      ((p = this._yEase), (r = h - r)),
                    (a = Ue(this._tTime, s)),
                    r === f && !n && this._initted)
                  )
                    return (this._tTime = m), this;
                  o !== a &&
                    (c && this._yEase && Rt(c, u),
                    !this.vars.repeatRefresh ||
                      u ||
                      this._lock ||
                      ((this._lock = n = 1),
                      (this.render(Se(s * o), !0).invalidate()._lock = 0)));
                }
                if (!this._initted) {
                  if (Ke(this, e < 0 ? e : r, n, t))
                    return (this._tTime = 0), this;
                  if (f !== this._time) return this;
                  if (h !== this._dur) return this.render(e, t, n);
                }
                if (
                  ((this._tTime = m),
                  (this._time = r),
                  !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                  (this.ratio = l = (p || this._ease)(r / h)),
                  this._from && (this.ratio = l = 1 - l),
                  r && !f && !t && (Et(this, "onStart"), this._tTime !== m))
                )
                  return this;
                for (i = this._pt; i; ) i.r(l, i.d), (i = i._next);
                (c &&
                  c.render(
                    e < 0
                      ? e
                      : !r && u
                      ? -1e-8
                      : c._dur * c._ease(r / this._dur),
                    t,
                    n
                  )) ||
                  (this._startAt && (this._zTime = e)),
                  this._onUpdate &&
                    !t &&
                    (e < 0 && this._startAt && this._startAt.render(e, !0, n),
                    Et(this, "onUpdate")),
                  this._repeat &&
                    o !== a &&
                    this.vars.onRepeat &&
                    !t &&
                    this.parent &&
                    Et(this, "onRepeat"),
                  (m !== this._tDur && m) ||
                    this._tTime !== m ||
                    (e < 0 &&
                      this._startAt &&
                      !this._onUpdate &&
                      this._startAt.render(e, !0, !0),
                    (e || !h) &&
                      ((m === this._tDur && this._ts > 0) ||
                        (!m && this._ts < 0)) &&
                      Re(this, 1),
                    t ||
                      (e < 0 && !f) ||
                      (!m && !f) ||
                      (Et(
                        this,
                        m === d ? "onComplete" : "onReverseComplete",
                        !0
                      ),
                      this._prom &&
                        !(m < d && this.timeScale() > 0) &&
                        this._prom()));
              }
            } else
              !(function (e, t, n, r) {
                var i,
                  o,
                  s,
                  a = e.ratio,
                  u =
                    t < 0 ||
                    (!t &&
                      ((!e._start && Qe(e) && (e._initted || !et(e))) ||
                        ((e._ts < 0 || e._dp._ts < 0) && !et(e))))
                      ? 0
                      : 1,
                  l = e._rDelay,
                  c = 0;
                if (
                  (l &&
                    e._repeat &&
                    ((c = at(0, e._tDur, t)),
                    (o = Ue(c, l)),
                    e._yoyo && 1 & o && (u = 1 - u),
                    o !== Ue(e._tTime, l) &&
                      ((a = 1 - u),
                      e.vars.repeatRefresh && e._initted && e.invalidate())),
                  u !== a || r || e._zTime === I || (!t && e._zTime))
                ) {
                  if (!e._initted && Ke(e, t, r, n)) return;
                  for (
                    s = e._zTime,
                      e._zTime = t || (n ? I : 0),
                      n || (n = t && !s),
                      e.ratio = u,
                      e._from && (u = 1 - u),
                      e._time = 0,
                      e._tTime = c,
                      i = e._pt;
                    i;

                  )
                    i.r(u, i.d), (i = i._next);
                  e._startAt && t < 0 && e._startAt.render(t, !0, !0),
                    e._onUpdate && !n && Et(e, "onUpdate"),
                    c && e._repeat && !n && e.parent && Et(e, "onRepeat"),
                    (t >= e._tDur || t < 0) &&
                      e.ratio === u &&
                      (u && Re(e, 1),
                      n ||
                        (Et(e, u ? "onComplete" : "onReverseComplete", !0),
                        e._prom && e._prom()));
                } else e._zTime || (e._zTime = t);
              })(this, e, t, n);
            return this;
          }),
          (n.targets = function () {
            return this._targets;
          }),
          (n.invalidate = function () {
            return (
              (this._pt =
                this._op =
                this._startAt =
                this._onUpdate =
                this._lazy =
                this.ratio =
                  0),
              (this._ptLookup = []),
              this.timeline && this.timeline.invalidate(),
              e.prototype.invalidate.call(this)
            );
          }),
          (n.resetTo = function (e, t, n, r) {
            d || Pt.wake(), this._ts || this.play();
            var i = Math.min(
              this._dur,
              (this._dp._time - this._start) * this._ts
            );
            return (
              this._initted || en(this, i),
              (function (e, t, n, r, i, o, s) {
                var a,
                  u,
                  l,
                  c = ((e._pt && e._ptCache) || (e._ptCache = {}))[t];
                if (!c)
                  for (
                    c = e._ptCache[t] = [],
                      u = e._ptLookup,
                      l = e._targets.length;
                    l--;

                  ) {
                    if ((a = u[l][t]) && a.d && a.d._pt)
                      for (a = a.d._pt; a && a.p !== t; ) a = a._next;
                    if (!a)
                      return (
                        (Jt = 1), (e.vars[t] = "+=0"), en(e, s), (Jt = 0), 1
                      );
                    c.push(a);
                  }
                for (l = c.length; l--; )
                  ((a = c[l]).s =
                    (!r && 0 !== r) || i ? a.s + (r || 0) + o * a.c : r),
                    (a.c = n - a.s),
                    a.e && (a.e = Ae(n) + ut(a.e)),
                    a.b && (a.b = a.s + ut(a.b));
              })(this, e, t, n, r, this._ease(i / this._dur), i)
                ? this.resetTo(e, t, n, r)
                : (Ye(this, 0),
                  this.parent ||
                    Le(
                      this._dp,
                      this,
                      "_first",
                      "_last",
                      this._dp._sort ? "_start" : 0
                    ),
                  this.render(0))
            );
          }),
          (n.kill = function (e, t) {
            if ((void 0 === t && (t = "all"), !(e || (t && "all" !== t))))
              return (this._lazy = this._pt = 0), this.parent ? Ct(this) : this;
            if (this.timeline) {
              var n = this.timeline.totalDuration();
              return (
                this.timeline.killTweensOf(e, t, Xt && !0 !== Xt.vars.overwrite)
                  ._first || Ct(this),
                this.parent &&
                  n !== this.timeline.totalDuration() &&
                  tt(this, (this._dur * this.timeline._tDur) / n, 0, 1),
                this
              );
            }
            var r,
              i,
              o,
              s,
              a,
              u,
              l,
              c = this._targets,
              p = e ? pt(e) : c,
              f = this._ptLookup,
              d = this._pt;
            if (
              (!t || "all" === t) &&
              (function (e, t) {
                for (
                  var n = e.length, r = n === t.length;
                  r && n-- && e[n] === t[n];

                );
                return n < 0;
              })(c, p)
            )
              return "all" === t && (this._pt = 0), Ct(this);
            for (
              r = this._op = this._op || [],
                "all" !== t &&
                  (q(t) &&
                    ((a = {}),
                    we(t, function (e) {
                      return (a[e] = 1);
                    }),
                    (t = a)),
                  (t = (function (e, t) {
                    var n,
                      r,
                      i,
                      o,
                      s = e[0] ? Ce(e[0]).harness : 0,
                      a = s && s.aliases;
                    if (!a) return t;
                    for (r in ((n = Ne({}, t)), a))
                      if ((r in n))
                        for (i = (o = a[r].split(",")).length; i--; )
                          n[o[i]] = n[r];
                    return n;
                  })(c, t))),
                l = c.length;
              l--;

            )
              if (~p.indexOf(c[l]))
                for (a in ((i = f[l]),
                "all" === t
                  ? ((r[l] = t), (s = i), (o = {}))
                  : ((o = r[l] = r[l] || {}), (s = t)),
                s))
                  (u = i && i[a]) &&
                    (("kill" in u.d && !0 !== u.d.kill(a)) ||
                      $e(this, u, "_pt"),
                    delete i[a]),
                    "all" !== o && (o[a] = 1);
            return this._initted && !this._pt && d && Ct(this), this;
          }),
          (t.to = function (e, n) {
            return new t(e, n, arguments[2]);
          }),
          (t.from = function (e, t) {
            return ot(1, arguments);
          }),
          (t.delayedCall = function (e, n, r, i) {
            return new t(n, 0, {
              immediateRender: !1,
              lazy: !1,
              overwrite: !1,
              delay: e,
              onComplete: n,
              onReverseComplete: n,
              onCompleteParams: r,
              onReverseCompleteParams: r,
              callbackScope: i,
            });
          }),
          (t.fromTo = function (e, t, n) {
            return ot(2, arguments);
          }),
          (t.set = function (e, n) {
            return (
              (n.duration = 0), n.repeatDelay || (n.repeat = 0), new t(e, n)
            );
          }),
          (t.killTweensOf = function (e, t, n) {
            return s.killTweensOf(e, t, n);
          }),
          t
        );
      })(Gt);
      Pe(sn.prototype, {
        _targets: [],
        _lazy: 0,
        _startAt: 0,
        _op: 0,
        _onInit: 0,
      }),
        we("staggerTo,staggerFrom,staggerFromTo", function (e) {
          sn[e] = function () {
            var t = new Yt(),
              n = lt.call(arguments, 0);
            return (
              n.splice("staggerFromTo" === e ? 5 : 4, 0, 0), t[e].apply(t, n)
            );
          };
        });
      var an = function (e, t, n) {
          return (e[t] = n);
        },
        un = function (e, t, n) {
          return e[t](n);
        },
        ln = function (e, t, n, r) {
          return e[t](r.fp, n);
        },
        cn = function (e, t, n) {
          return e.setAttribute(t, n);
        },
        pn = function (e, t) {
          return W(e[t]) ? un : H(e[t]) && e.setAttribute ? cn : an;
        },
        fn = function (e, t) {
          return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t);
        },
        dn = function (e, t) {
          return t.set(t.t, t.p, !!(t.s + t.c * e), t);
        },
        hn = function (e, t) {
          var n = t._pt,
            r = "";
          if (!e && t.b) r = t.b;
          else if (1 === e && t.e) r = t.e;
          else {
            for (; n; )
              (r =
                n.p +
                (n.m
                  ? n.m(n.s + n.c * e)
                  : Math.round(1e4 * (n.s + n.c * e)) / 1e4) +
                r),
                (n = n._next);
            r += t.c;
          }
          t.set(t.t, t.p, r, t);
        },
        mn = function (e, t) {
          for (var n = t._pt; n; ) n.r(e, n.d), (n = n._next);
        },
        gn = function (e, t, n, r) {
          for (var i, o = this._pt; o; )
            (i = o._next), o.p === r && o.modifier(e, t, n), (o = i);
        },
        yn = function (e) {
          for (var t, n, r = this._pt; r; )
            (n = r._next),
              (r.p === e && !r.op) || r.op === e
                ? $e(this, r, "_pt")
                : r.dep || (t = 1),
              (r = n);
          return !t;
        },
        vn = function (e, t, n, r) {
          r.mSet(e, t, r.m.call(r.tween, n, r.mt), r);
        },
        Dn = function (e) {
          for (var t, n, r, i, o = e._pt; o; ) {
            for (t = o._next, n = r; n && n.pr > o.pr; ) n = n._next;
            (o._prev = n ? n._prev : i) ? (o._prev._next = o) : (r = o),
              (o._next = n) ? (n._prev = o) : (i = o),
              (o = t);
          }
          e._pt = r;
        },
        bn = (function () {
          function e(e, t, n, r, i, o, s, a, u) {
            (this.t = t),
              (this.s = r),
              (this.c = i),
              (this.p = n),
              (this.r = o || fn),
              (this.d = s || this),
              (this.set = a || an),
              (this.pr = u || 0),
              (this._next = e),
              e && (e._prev = this);
          }
          return (
            (e.prototype.modifier = function (e, t, n) {
              (this.mSet = this.mSet || this.set),
                (this.set = vn),
                (this.m = e),
                (this.mt = n),
                (this.tween = t);
            }),
            e
          );
        })();
      we(
        be +
          "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
        function (e) {
          return (de[e] = 1);
        }
      ),
        (se.TweenMax = se.TweenLite = sn),
        (se.TimelineLite = se.TimelineMax = Yt),
        (s = new Yt({
          sortChildren: !1,
          defaults: N,
          autoRemoveChildren: !0,
          id: "root",
          smoothChildTiming: !0,
        })),
        (P.stringFilter = Bt);
      var En = {
        registerPlugin: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          t.forEach(function (e) {
            return xt(e);
          });
        },
        timeline: function (e) {
          return new Yt(e);
        },
        getTweensOf: function (e, t) {
          return s.getTweensOf(e, t);
        },
        getProperty: function (e, t, n, r) {
          q(e) && (e = pt(e)[0]);
          var i = Ce(e || {}).get,
            o = n ? Be : Oe;
          return (
            "native" === n && (n = ""),
            e
              ? t
                ? o(((ge[t] && ge[t].get) || i)(e, t, n, r))
                : function (t, n, r) {
                    return o(((ge[t] && ge[t].get) || i)(e, t, n, r));
                  }
              : e
          );
        },
        quickSetter: function (e, t, n) {
          if ((e = pt(e)).length > 1) {
            var r = e.map(function (e) {
                return wn.quickSetter(e, t, n);
              }),
              i = r.length;
            return function (e) {
              for (var t = i; t--; ) r[t](e);
            };
          }
          e = e[0] || {};
          var o = ge[t],
            s = Ce(e),
            a = (s.harness && (s.harness.aliases || {})[t]) || t,
            u = o
              ? function (t) {
                  var r = new o();
                  (f._pt = 0),
                    r.init(e, n ? t + n : t, f, 0, [e]),
                    r.render(1, r),
                    f._pt && mn(1, f);
                }
              : s.set(e, a);
          return o
            ? u
            : function (t) {
                return u(e, a, n ? t + n : t, s, 1);
              };
        },
        quickTo: function (e, t, n) {
          var r,
            i = wn.to(
              e,
              Ne((((r = {})[t] = "+=0.1"), (r.paused = !0), r), n || {})
            ),
            o = function (e, n, r) {
              return i.resetTo(t, e, n, r);
            };
          return (o.tween = i), o;
        },
        isTweening: function (e) {
          return s.getTweensOf(e, !0).length > 0;
        },
        defaults: function (e) {
          return e && e.ease && (e.ease = zt(e.ease, N.ease)), Me(N, e || {});
        },
        config: function (e) {
          return Me(P, e || {});
        },
        registerEffect: function (e) {
          var t = e.name,
            n = e.effect,
            r = e.plugins,
            i = e.defaults,
            o = e.extendTimeline;
          (r || "").split(",").forEach(function (e) {
            return (
              e &&
              !ge[e] &&
              !se[e] &&
              ce(t + " effect requires " + e + " plugin.")
            );
          }),
            (ye[t] = function (e, t, r) {
              return n(pt(e), Pe(t || {}, i), r);
            }),
            o &&
              (Yt.prototype[t] = function (e, n, r) {
                return this.add(ye[t](e, G(n) ? n : (r = n) && {}, this), r);
              });
        },
        registerEase: function (e, t) {
          Mt[e] = zt(t);
        },
        parseEase: function (e, t) {
          return arguments.length ? zt(e, t) : Mt;
        },
        getById: function (e) {
          return s.getById(e);
        },
        exportRoot: function (e, t) {
          void 0 === e && (e = {});
          var n,
            r,
            i = new Yt(e);
          for (
            i.smoothChildTiming = Y(e.smoothChildTiming),
              s.remove(i),
              i._dp = 0,
              i._time = i._tTime = s._time,
              n = s._first;
            n;

          )
            (r = n._next),
              (!t &&
                !n._dur &&
                n instanceof sn &&
                n.vars.onComplete === n._targets[0]) ||
                Je(i, n, n._start - n._delay),
              (n = r);
          return Je(s, i, 0), i;
        },
        utils: {
          wrap: function e(t, n, r) {
            var i = n - t;
            return K(t)
              ? yt(t, e(0, t.length), n)
              : st(r, function (e) {
                  return ((i + ((e - t) % i)) % i) + t;
                });
          },
          wrapYoyo: function e(t, n, r) {
            var i = n - t,
              o = 2 * i;
            return K(t)
              ? yt(t, e(0, t.length - 1), n)
              : st(r, function (e) {
                  return (
                    t + ((e = (o + ((e - t) % o)) % o || 0) > i ? o - e : e)
                  );
                });
          },
          distribute: dt,
          random: gt,
          snap: mt,
          normalize: function (e, t, n) {
            return Dt(e, t, 0, 1, n);
          },
          getUnit: ut,
          clamp: function (e, t, n) {
            return st(n, function (n) {
              return at(e, t, n);
            });
          },
          splitColor: _t,
          toArray: pt,
          selector: function (e) {
            return (
              (e = pt(e)[0] || ce("Invalid scope") || {}),
              function (t) {
                var n = e.current || e.nativeElement || e;
                return pt(
                  t,
                  n.querySelectorAll
                    ? n
                    : n === e
                    ? ce("Invalid scope") || l.createElement("div")
                    : e
                );
              }
            );
          },
          mapRange: Dt,
          pipe: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
              t[n] = arguments[n];
            return function (e) {
              return t.reduce(function (e, t) {
                return t(e);
              }, e);
            };
          },
          unitize: function (e, t) {
            return function (n) {
              return e(parseFloat(n)) + (t || ut(n));
            };
          },
          interpolate: function e(t, n, r, i) {
            var o = isNaN(t + n)
              ? 0
              : function (e) {
                  return (1 - e) * t + e * n;
                };
            if (!o) {
              var s,
                a,
                u,
                l,
                c,
                p = q(t),
                f = {};
              if ((!0 === r && (i = 1) && (r = null), p))
                (t = { p: t }), (n = { p: n });
              else if (K(t) && !K(n)) {
                for (u = [], l = t.length, c = l - 2, a = 1; a < l; a++)
                  u.push(e(t[a - 1], t[a]));
                l--,
                  (o = function (e) {
                    e *= l;
                    var t = Math.min(c, ~~e);
                    return u[t](e - t);
                  }),
                  (r = n);
              } else i || (t = Ne(K(t) ? [] : {}, t));
              if (!u) {
                for (s in n) Kt.call(f, t, s, "get", n[s]);
                o = function (e) {
                  return mn(e, f) || (p ? t.p : t);
                };
              }
            }
            return st(r, o);
          },
          shuffle: ft,
        },
        install: ue,
        effects: ye,
        ticker: Pt,
        updateRoot: Yt.updateRoot,
        plugins: ge,
        globalTimeline: s,
        core: {
          PropTween: bn,
          globals: pe,
          Tween: sn,
          Timeline: Yt,
          Animation: Gt,
          getCache: Ce,
          _removeLinkedListItem: $e,
          suppressOverwrites: function (e) {
            return (o = e);
          },
        },
      };
      we("to,from,fromTo,delayedCall,set,killTweensOf", function (e) {
        return (En[e] = sn[e]);
      }),
        Pt.add(Yt.updateRoot),
        (f = En.to({}, { duration: 0 }));
      var Cn = function (e, t) {
          for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t; )
            n = n._next;
          return n;
        },
        xn = function (e, t) {
          return {
            name: e,
            rawVars: 1,
            init: function (e, n, r) {
              r._onInit = function (e) {
                var r, i;
                if (
                  (q(n) &&
                    ((r = {}),
                    we(n, function (e) {
                      return (r[e] = 1);
                    }),
                    (n = r)),
                  t)
                ) {
                  for (i in ((r = {}), n)) r[i] = t(n[i]);
                  n = r;
                }
                !(function (e, t) {
                  var n,
                    r,
                    i,
                    o = e._targets;
                  for (n in t)
                    for (r = o.length; r--; )
                      (i = e._ptLookup[r][n]) &&
                        (i = i.d) &&
                        (i._pt && (i = Cn(i, n)),
                        i && i.modifier && i.modifier(t[n], e, o[r], n));
                })(e, n);
              };
            },
          };
        },
        wn =
          En.registerPlugin(
            {
              name: "attr",
              init: function (e, t, n, r, i) {
                var o, s;
                for (o in t)
                  (s = this.add(
                    e,
                    "setAttribute",
                    (e.getAttribute(o) || 0) + "",
                    t[o],
                    r,
                    i,
                    0,
                    0,
                    o
                  )) && (s.op = o),
                    this._props.push(o);
              },
            },
            {
              name: "endArray",
              init: function (e, t) {
                for (var n = t.length; n--; ) this.add(e, n, e[n] || 0, t[n]);
              },
            },
            xn("roundProps", ht),
            xn("modifiers"),
            xn("snap", mt)
          ) || En;
      (sn.version = Yt.version = wn.version = "3.10.2"),
        (c = 1),
        X() && Nt(),
        Mt.Power0,
        Mt.Power1,
        Mt.Power2,
        Mt.Power3,
        Mt.Power4,
        Mt.Linear,
        Mt.Quad,
        Mt.Cubic,
        Mt.Quart,
        Mt.Quint,
        Mt.Strong,
        Mt.Elastic,
        Mt.Back,
        Mt.SteppedEase,
        Mt.Bounce,
        Mt.Sine,
        Mt.Expo,
        Mt.Circ;
      var An,
        Sn,
        _n,
        Tn,
        Fn,
        kn,
        On,
        Bn = {},
        Pn = 180 / Math.PI,
        Nn = Math.PI / 180,
        Mn = Math.atan2,
        In = /([A-Z])/g,
        jn = /(left|right|width|margin|padding|x)/i,
        Ln = /[\s,\(]\S/,
        $n = {
          autoAlpha: "opacity,visibility",
          scale: "scaleX,scaleY",
          alpha: "opacity",
        },
        Rn = function (e, t) {
          return t.set(
            t.t,
            t.p,
            Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t
          );
        },
        zn = function (e, t) {
          return t.set(
            t.t,
            t.p,
            1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t
          );
        },
        Vn = function (e, t) {
          return t.set(
            t.t,
            t.p,
            e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b,
            t
          );
        },
        qn = function (e, t) {
          var n = t.s + t.c * e;
          t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + t.u, t);
        },
        Wn = function (e, t) {
          return t.set(t.t, t.p, e ? t.e : t.b, t);
        },
        Un = function (e, t) {
          return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t);
        },
        Hn = function (e, t, n) {
          return (e.style[t] = n);
        },
        Gn = function (e, t, n) {
          return e.style.setProperty(t, n);
        },
        Yn = function (e, t, n) {
          return (e._gsap[t] = n);
        },
        Xn = function (e, t, n) {
          return (e._gsap.scaleX = e._gsap.scaleY = n);
        },
        Jn = function (e, t, n, r, i) {
          var o = e._gsap;
          (o.scaleX = o.scaleY = n), o.renderTransform(i, o);
        },
        Zn = function (e, t, n, r, i) {
          var o = e._gsap;
          (o[t] = n), o.renderTransform(i, o);
        },
        Kn = "transform",
        Qn = Kn + "Origin",
        er = function (e, t) {
          var n = Sn.createElementNS
            ? Sn.createElementNS(
                (t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"),
                e
              )
            : Sn.createElement(e);
          return n.style ? n : Sn.createElement(e);
        },
        tr = function e(t, n, r) {
          var i = getComputedStyle(t);
          return (
            i[n] ||
            i.getPropertyValue(n.replace(In, "-$1").toLowerCase()) ||
            i.getPropertyValue(n) ||
            (!r && e(t, rr(n) || n, 1)) ||
            ""
          );
        },
        nr = "O,Moz,ms,Ms,Webkit".split(","),
        rr = function (e, t, n) {
          var r = (t || Fn).style,
            i = 5;
          if (e in r && !n) return e;
          for (
            e = e.charAt(0).toUpperCase() + e.substr(1);
            i-- && !(nr[i] + e in r);

          );
          return i < 0 ? null : (3 === i ? "ms" : i >= 0 ? nr[i] : "") + e;
        },
        ir = function () {
          "undefined" != typeof window &&
            window.document &&
            ((An = window),
            (Sn = An.document),
            (_n = Sn.documentElement),
            (Fn = er("div") || { style: {} }),
            er("div"),
            (Kn = rr(Kn)),
            (Qn = Kn + "Origin"),
            (Fn.style.cssText =
              "border-width:0;line-height:0;position:absolute;padding:0"),
            (On = !!rr("perspective")),
            (Tn = 1));
        },
        or = function e(t) {
          var n,
            r = er(
              "svg",
              (this.ownerSVGElement &&
                this.ownerSVGElement.getAttribute("xmlns")) ||
                "http://www.w3.org/2000/svg"
            ),
            i = this.parentNode,
            o = this.nextSibling,
            s = this.style.cssText;
          if (
            (_n.appendChild(r),
            r.appendChild(this),
            (this.style.display = "block"),
            t)
          )
            try {
              (n = this.getBBox()),
                (this._gsapBBox = this.getBBox),
                (this.getBBox = e);
            } catch (e) {}
          else this._gsapBBox && (n = this._gsapBBox());
          return (
            i && (o ? i.insertBefore(this, o) : i.appendChild(this)),
            _n.removeChild(r),
            (this.style.cssText = s),
            n
          );
        },
        sr = function (e, t) {
          for (var n = t.length; n--; )
            if (e.hasAttribute(t[n])) return e.getAttribute(t[n]);
        },
        ar = function (e) {
          var t;
          try {
            t = e.getBBox();
          } catch (n) {
            t = or.call(e, !0);
          }
          return (
            (t && (t.width || t.height)) ||
              e.getBBox === or ||
              (t = or.call(e, !0)),
            !t || t.width || t.x || t.y
              ? t
              : {
                  x: +sr(e, ["x", "cx", "x1"]) || 0,
                  y: +sr(e, ["y", "cy", "y1"]) || 0,
                  width: 0,
                  height: 0,
                }
          );
        },
        ur = function (e) {
          return !(!e.getCTM || (e.parentNode && !e.ownerSVGElement) || !ar(e));
        },
        lr = function (e, t) {
          if (t) {
            var n = e.style;
            t in Bn && t !== Qn && (t = Kn),
              n.removeProperty
                ? (("ms" !== t.substr(0, 2) && "webkit" !== t.substr(0, 6)) ||
                    (t = "-" + t),
                  n.removeProperty(t.replace(In, "-$1").toLowerCase()))
                : n.removeAttribute(t);
          }
        },
        cr = function (e, t, n, r, i, o) {
          var s = new bn(e._pt, t, n, 0, 1, o ? Un : Wn);
          return (e._pt = s), (s.b = r), (s.e = i), e._props.push(n), s;
        },
        pr = { deg: 1, rad: 1, turn: 1 },
        fr = function e(t, n, r, i) {
          var o,
            s,
            a,
            u,
            l = parseFloat(r) || 0,
            c = (r + "").trim().substr((l + "").length) || "px",
            p = Fn.style,
            f = jn.test(n),
            d = "svg" === t.tagName.toLowerCase(),
            h = (d ? "client" : "offset") + (f ? "Width" : "Height"),
            m = 100,
            g = "px" === i,
            y = "%" === i;
          return i === c || !l || pr[i] || pr[c]
            ? l
            : ("px" !== c && !g && (l = e(t, n, r, "px")),
              (u = t.getCTM && ur(t)),
              (!y && "%" !== c) || (!Bn[n] && !~n.indexOf("adius"))
                ? ((p[f ? "width" : "height"] = m + (g ? c : i)),
                  (s =
                    ~n.indexOf("adius") || ("em" === i && t.appendChild && !d)
                      ? t
                      : t.parentNode),
                  u && (s = (t.ownerSVGElement || {}).parentNode),
                  (s && s !== Sn && s.appendChild) || (s = Sn.body),
                  (a = s._gsap) && y && a.width && f && a.time === Pt.time
                    ? Ae((l / a.width) * m)
                    : ((y || "%" === c) && (p.position = tr(t, "position")),
                      s === t && (p.position = "static"),
                      s.appendChild(Fn),
                      (o = Fn[h]),
                      s.removeChild(Fn),
                      (p.position = "absolute"),
                      f &&
                        y &&
                        (((a = Ce(s)).time = Pt.time), (a.width = s[h])),
                      Ae(g ? (o * l) / m : o && l ? (m / o) * l : 0)))
                : ((o = u ? t.getBBox()[f ? "width" : "height"] : t[h]),
                  Ae(y ? (l / o) * m : (l / 100) * o)));
        },
        dr = function (e, t, n, r) {
          var i;
          return (
            Tn || ir(),
            t in $n &&
              "transform" !== t &&
              ~(t = $n[t]).indexOf(",") &&
              (t = t.split(",")[0]),
            Bn[t] && "transform" !== t
              ? ((i = wr(e, r)),
                (i =
                  "transformOrigin" !== t
                    ? i[t]
                    : i.svg
                    ? i.origin
                    : Ar(tr(e, Qn)) + " " + i.zOrigin + "px"))
              : (!(i = e.style[t]) ||
                  "auto" === i ||
                  r ||
                  ~(i + "").indexOf("calc(")) &&
                (i =
                  (yr[t] && yr[t](e, t, n)) ||
                  tr(e, t) ||
                  xe(e, t) ||
                  ("opacity" === t ? 1 : 0)),
            n && !~(i + "").trim().indexOf(" ") ? fr(e, t, i, n) + n : i
          );
        },
        hr = function (e, t, n, r) {
          if (!n || "none" === n) {
            var i = rr(t, e, 1),
              o = i && tr(e, i, 1);
            o && o !== n
              ? ((t = i), (n = o))
              : "borderColor" === t && (n = tr(e, "borderTopColor"));
          }
          var s,
            a,
            u,
            l,
            c,
            p,
            f,
            d,
            h,
            m,
            g,
            y = new bn(this._pt, e.style, t, 0, 1, hn),
            v = 0,
            D = 0;
          if (
            ((y.b = n),
            (y.e = r),
            (n += ""),
            "auto" == (r += "") &&
              ((e.style[t] = r), (r = tr(e, t) || r), (e.style[t] = n)),
            Bt((s = [n, r])),
            (r = s[1]),
            (u = (n = s[0]).match(te) || []),
            (r.match(te) || []).length)
          ) {
            for (; (a = te.exec(r)); )
              (f = a[0]),
                (h = r.substring(v, a.index)),
                c
                  ? (c = (c + 1) % 5)
                  : ("rgba(" !== h.substr(-5) && "hsla(" !== h.substr(-5)) ||
                    (c = 1),
                f !== (p = u[D++] || "") &&
                  ((l = parseFloat(p) || 0),
                  (g = p.substr((l + "").length)),
                  "=" === f.charAt(1) && (f = _e(l, f) + g),
                  (d = parseFloat(f)),
                  (m = f.substr((d + "").length)),
                  (v = te.lastIndex - m.length),
                  m ||
                    ((m = m || P.units[t] || g),
                    v === r.length && ((r += m), (y.e += m))),
                  g !== m && (l = fr(e, t, p, m) || 0),
                  (y._pt = {
                    _next: y._pt,
                    p: h || 1 === D ? h : ",",
                    s: l,
                    c: d - l,
                    m: (c && c < 4) || "zIndex" === t ? Math.round : 0,
                  }));
            y.c = v < r.length ? r.substring(v, r.length) : "";
          } else y.r = "display" === t && "none" === r ? Un : Wn;
          return re.test(r) && (y.e = 0), (this._pt = y), y;
        },
        mr = {
          top: "0%",
          bottom: "100%",
          left: "0%",
          right: "100%",
          center: "50%",
        },
        gr = function (e, t) {
          if (t.tween && t.tween._time === t.tween._dur) {
            var n,
              r,
              i,
              o = t.t,
              s = o.style,
              a = t.u,
              u = o._gsap;
            if ("all" === a || !0 === a) (s.cssText = ""), (r = 1);
            else
              for (i = (a = a.split(",")).length; --i > -1; )
                (n = a[i]),
                  Bn[n] && ((r = 1), (n = "transformOrigin" === n ? Qn : Kn)),
                  lr(o, n);
            r &&
              (lr(o, Kn),
              u &&
                (u.svg && o.removeAttribute("transform"),
                wr(o, 1),
                (u.uncache = 1)));
          }
        },
        yr = {
          clearProps: function (e, t, n, r, i) {
            if ("isFromStart" !== i.data) {
              var o = (e._pt = new bn(e._pt, t, n, 0, 0, gr));
              return (
                (o.u = r), (o.pr = -10), (o.tween = i), e._props.push(n), 1
              );
            }
          },
        },
        vr = [1, 0, 0, 1, 0, 0],
        Dr = {},
        br = function (e) {
          return "matrix(1, 0, 0, 1, 0, 0)" === e || "none" === e || !e;
        },
        Er = function (e) {
          var t = tr(e, Kn);
          return br(t) ? vr : t.substr(7).match(ee).map(Ae);
        },
        Cr = function (e, t) {
          var n,
            r,
            i,
            o,
            s = e._gsap || Ce(e),
            a = e.style,
            u = Er(e);
          return s.svg && e.getAttribute("transform")
            ? "1,0,0,1,0,0" ===
              (u = [
                (i = e.transform.baseVal.consolidate().matrix).a,
                i.b,
                i.c,
                i.d,
                i.e,
                i.f,
              ]).join(",")
              ? vr
              : u
            : (u !== vr ||
                e.offsetParent ||
                e === _n ||
                s.svg ||
                ((i = a.display),
                (a.display = "block"),
                ((n = e.parentNode) && e.offsetParent) ||
                  ((o = 1), (r = e.nextSibling), _n.appendChild(e)),
                (u = Er(e)),
                i ? (a.display = i) : lr(e, "display"),
                o &&
                  (r
                    ? n.insertBefore(e, r)
                    : n
                    ? n.appendChild(e)
                    : _n.removeChild(e))),
              t && u.length > 6 ? [u[0], u[1], u[4], u[5], u[12], u[13]] : u);
        },
        xr = function (e, t, n, r, i, o) {
          var s,
            a,
            u,
            l = e._gsap,
            c = i || Cr(e, !0),
            p = l.xOrigin || 0,
            f = l.yOrigin || 0,
            d = l.xOffset || 0,
            h = l.yOffset || 0,
            m = c[0],
            g = c[1],
            y = c[2],
            v = c[3],
            D = c[4],
            b = c[5],
            E = t.split(" "),
            C = parseFloat(E[0]) || 0,
            x = parseFloat(E[1]) || 0;
          n
            ? c !== vr &&
              (a = m * v - g * y) &&
              ((u = C * (-g / a) + x * (m / a) - (m * b - g * D) / a),
              (C = C * (v / a) + x * (-y / a) + (y * b - v * D) / a),
              (x = u))
            : ((C =
                (s = ar(e)).x + (~E[0].indexOf("%") ? (C / 100) * s.width : C)),
              (x =
                s.y +
                (~(E[1] || E[0]).indexOf("%") ? (x / 100) * s.height : x))),
            r || (!1 !== r && l.smooth)
              ? ((D = C - p),
                (b = x - f),
                (l.xOffset = d + (D * m + b * y) - D),
                (l.yOffset = h + (D * g + b * v) - b))
              : (l.xOffset = l.yOffset = 0),
            (l.xOrigin = C),
            (l.yOrigin = x),
            (l.smooth = !!r),
            (l.origin = t),
            (l.originIsAbsolute = !!n),
            (e.style[Qn] = "0px 0px"),
            o &&
              (cr(o, l, "xOrigin", p, C),
              cr(o, l, "yOrigin", f, x),
              cr(o, l, "xOffset", d, l.xOffset),
              cr(o, l, "yOffset", h, l.yOffset)),
            e.setAttribute("data-svg-origin", C + " " + x);
        },
        wr = function (e, t) {
          var n = e._gsap || new Ht(e);
          if ("x" in n && !t && !n.uncache) return n;
          var r,
            i,
            o,
            s,
            a,
            u,
            l,
            c,
            p,
            f,
            d,
            h,
            m,
            g,
            y,
            v,
            D,
            b,
            E,
            C,
            x,
            w,
            A,
            S,
            _,
            T,
            F,
            k,
            O,
            B,
            N,
            M,
            I = e.style,
            j = n.scaleX < 0,
            L = "px",
            $ = "deg",
            R = tr(e, Qn) || "0";
          return (
            (r = i = o = u = l = c = p = f = d = 0),
            (s = a = 1),
            (n.svg = !(!e.getCTM || !ur(e))),
            (g = Cr(e, n.svg)),
            n.svg &&
              ((S =
                (!n.uncache || "0px 0px" === R) &&
                !t &&
                e.getAttribute("data-svg-origin")),
              xr(e, S || R, !!S || n.originIsAbsolute, !1 !== n.smooth, g)),
            (h = n.xOrigin || 0),
            (m = n.yOrigin || 0),
            g !== vr &&
              ((b = g[0]),
              (E = g[1]),
              (C = g[2]),
              (x = g[3]),
              (r = w = g[4]),
              (i = A = g[5]),
              6 === g.length
                ? ((s = Math.sqrt(b * b + E * E)),
                  (a = Math.sqrt(x * x + C * C)),
                  (u = b || E ? Mn(E, b) * Pn : 0),
                  (p = C || x ? Mn(C, x) * Pn + u : 0) &&
                    (a *= Math.abs(Math.cos(p * Nn))),
                  n.svg &&
                    ((r -= h - (h * b + m * C)), (i -= m - (h * E + m * x))))
                : ((M = g[6]),
                  (B = g[7]),
                  (F = g[8]),
                  (k = g[9]),
                  (O = g[10]),
                  (N = g[11]),
                  (r = g[12]),
                  (i = g[13]),
                  (o = g[14]),
                  (l = (y = Mn(M, O)) * Pn),
                  y &&
                    ((S = w * (v = Math.cos(-y)) + F * (D = Math.sin(-y))),
                    (_ = A * v + k * D),
                    (T = M * v + O * D),
                    (F = w * -D + F * v),
                    (k = A * -D + k * v),
                    (O = M * -D + O * v),
                    (N = B * -D + N * v),
                    (w = S),
                    (A = _),
                    (M = T)),
                  (c = (y = Mn(-C, O)) * Pn),
                  y &&
                    ((v = Math.cos(-y)),
                    (N = x * (D = Math.sin(-y)) + N * v),
                    (b = S = b * v - F * D),
                    (E = _ = E * v - k * D),
                    (C = T = C * v - O * D)),
                  (u = (y = Mn(E, b)) * Pn),
                  y &&
                    ((S = b * (v = Math.cos(y)) + E * (D = Math.sin(y))),
                    (_ = w * v + A * D),
                    (E = E * v - b * D),
                    (A = A * v - w * D),
                    (b = S),
                    (w = _)),
                  l &&
                    Math.abs(l) + Math.abs(u) > 359.9 &&
                    ((l = u = 0), (c = 180 - c)),
                  (s = Ae(Math.sqrt(b * b + E * E + C * C))),
                  (a = Ae(Math.sqrt(A * A + M * M))),
                  (y = Mn(w, A)),
                  (p = Math.abs(y) > 2e-4 ? y * Pn : 0),
                  (d = N ? 1 / (N < 0 ? -N : N) : 0)),
              n.svg &&
                ((S = e.getAttribute("transform")),
                (n.forceCSS =
                  e.setAttribute("transform", "") || !br(tr(e, Kn))),
                S && e.setAttribute("transform", S))),
            Math.abs(p) > 90 &&
              Math.abs(p) < 270 &&
              (j
                ? ((s *= -1),
                  (p += u <= 0 ? 180 : -180),
                  (u += u <= 0 ? 180 : -180))
                : ((a *= -1), (p += p <= 0 ? 180 : -180))),
            (t = t || n.uncache),
            (n.x =
              r -
              ((n.xPercent =
                r &&
                ((!t && n.xPercent) ||
                  (Math.round(e.offsetWidth / 2) === Math.round(-r) ? -50 : 0)))
                ? (e.offsetWidth * n.xPercent) / 100
                : 0) +
              L),
            (n.y =
              i -
              ((n.yPercent =
                i &&
                ((!t && n.yPercent) ||
                  (Math.round(e.offsetHeight / 2) === Math.round(-i)
                    ? -50
                    : 0)))
                ? (e.offsetHeight * n.yPercent) / 100
                : 0) +
              L),
            (n.z = o + L),
            (n.scaleX = Ae(s)),
            (n.scaleY = Ae(a)),
            (n.rotation = Ae(u) + $),
            (n.rotationX = Ae(l) + $),
            (n.rotationY = Ae(c) + $),
            (n.skewX = p + $),
            (n.skewY = f + $),
            (n.transformPerspective = d + L),
            (n.zOrigin = parseFloat(R.split(" ")[2]) || 0) && (I[Qn] = Ar(R)),
            (n.xOffset = n.yOffset = 0),
            (n.force3D = P.force3D),
            (n.renderTransform = n.svg ? Br : On ? Or : _r),
            (n.uncache = 0),
            n
          );
        },
        Ar = function (e) {
          return (e = e.split(" "))[0] + " " + e[1];
        },
        Sr = function (e, t, n) {
          var r = ut(t);
          return Ae(parseFloat(t) + parseFloat(fr(e, "x", n + "px", r))) + r;
        },
        _r = function (e, t) {
          (t.z = "0px"),
            (t.rotationY = t.rotationX = "0deg"),
            (t.force3D = 0),
            Or(e, t);
        },
        Tr = "0deg",
        Fr = "0px",
        kr = ") ",
        Or = function (e, t) {
          var n = t || this,
            r = n.xPercent,
            i = n.yPercent,
            o = n.x,
            s = n.y,
            a = n.z,
            u = n.rotation,
            l = n.rotationY,
            c = n.rotationX,
            p = n.skewX,
            f = n.skewY,
            d = n.scaleX,
            h = n.scaleY,
            m = n.transformPerspective,
            g = n.force3D,
            y = n.target,
            v = n.zOrigin,
            D = "",
            b = ("auto" === g && e && 1 !== e) || !0 === g;
          if (v && (c !== Tr || l !== Tr)) {
            var E,
              C = parseFloat(l) * Nn,
              x = Math.sin(C),
              w = Math.cos(C);
            (C = parseFloat(c) * Nn),
              (E = Math.cos(C)),
              (o = Sr(y, o, x * E * -v)),
              (s = Sr(y, s, -Math.sin(C) * -v)),
              (a = Sr(y, a, w * E * -v + v));
          }
          m !== Fr && (D += "perspective(" + m + kr),
            (r || i) && (D += "translate(" + r + "%, " + i + "%) "),
            (b || o !== Fr || s !== Fr || a !== Fr) &&
              (D +=
                a !== Fr || b
                  ? "translate3d(" + o + ", " + s + ", " + a + ") "
                  : "translate(" + o + ", " + s + kr),
            u !== Tr && (D += "rotate(" + u + kr),
            l !== Tr && (D += "rotateY(" + l + kr),
            c !== Tr && (D += "rotateX(" + c + kr),
            (p === Tr && f === Tr) || (D += "skew(" + p + ", " + f + kr),
            (1 === d && 1 === h) || (D += "scale(" + d + ", " + h + kr),
            (y.style[Kn] = D || "translate(0, 0)");
        },
        Br = function (e, t) {
          var n,
            r,
            i,
            o,
            s,
            a = t || this,
            u = a.xPercent,
            l = a.yPercent,
            c = a.x,
            p = a.y,
            f = a.rotation,
            d = a.skewX,
            h = a.skewY,
            m = a.scaleX,
            g = a.scaleY,
            y = a.target,
            v = a.xOrigin,
            D = a.yOrigin,
            b = a.xOffset,
            E = a.yOffset,
            C = a.forceCSS,
            x = parseFloat(c),
            w = parseFloat(p);
          (f = parseFloat(f)),
            (d = parseFloat(d)),
            (h = parseFloat(h)) && ((d += h = parseFloat(h)), (f += h)),
            f || d
              ? ((f *= Nn),
                (d *= Nn),
                (n = Math.cos(f) * m),
                (r = Math.sin(f) * m),
                (i = Math.sin(f - d) * -g),
                (o = Math.cos(f - d) * g),
                d &&
                  ((h *= Nn),
                  (s = Math.tan(d - h)),
                  (i *= s = Math.sqrt(1 + s * s)),
                  (o *= s),
                  h &&
                    ((s = Math.tan(h)),
                    (n *= s = Math.sqrt(1 + s * s)),
                    (r *= s))),
                (n = Ae(n)),
                (r = Ae(r)),
                (i = Ae(i)),
                (o = Ae(o)))
              : ((n = m), (o = g), (r = i = 0)),
            ((x && !~(c + "").indexOf("px")) ||
              (w && !~(p + "").indexOf("px"))) &&
              ((x = fr(y, "x", c, "px")), (w = fr(y, "y", p, "px"))),
            (v || D || b || E) &&
              ((x = Ae(x + v - (v * n + D * i) + b)),
              (w = Ae(w + D - (v * r + D * o) + E))),
            (u || l) &&
              ((s = y.getBBox()),
              (x = Ae(x + (u / 100) * s.width)),
              (w = Ae(w + (l / 100) * s.height))),
            (s =
              "matrix(" +
              n +
              "," +
              r +
              "," +
              i +
              "," +
              o +
              "," +
              x +
              "," +
              w +
              ")"),
            y.setAttribute("transform", s),
            C && (y.style[Kn] = s);
        },
        Pr = function (e, t, n, r, i) {
          var o,
            s,
            a = 360,
            u = q(i),
            l = parseFloat(i) * (u && ~i.indexOf("rad") ? Pn : 1) - r,
            c = r + l + "deg";
          return (
            u &&
              ("short" === (o = i.split("_")[1]) &&
                (l %= a) != l % 180 &&
                (l += l < 0 ? a : -360),
              "cw" === o && l < 0
                ? (l = ((l + 36e9) % a) - ~~(l / a) * a)
                : "ccw" === o &&
                  l > 0 &&
                  (l = ((l - 36e9) % a) - ~~(l / a) * a)),
            (e._pt = s = new bn(e._pt, t, n, r, l, zn)),
            (s.e = c),
            (s.u = "deg"),
            e._props.push(n),
            s
          );
        },
        Nr = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        Mr = function (e, t, n) {
          var r,
            i,
            o,
            s,
            a,
            u,
            l,
            c = Nr({}, n._gsap),
            p = n.style;
          for (i in (c.svg
            ? ((o = n.getAttribute("transform")),
              n.setAttribute("transform", ""),
              (p[Kn] = t),
              (r = wr(n, 1)),
              lr(n, Kn),
              n.setAttribute("transform", o))
            : ((o = getComputedStyle(n)[Kn]),
              (p[Kn] = t),
              (r = wr(n, 1)),
              (p[Kn] = o)),
          Bn))
            (o = c[i]) !== (s = r[i]) &&
              "perspective,force3D,transformOrigin,svgOrigin".indexOf(i) < 0 &&
              ((a = ut(o) !== (l = ut(s)) ? fr(n, i, o, l) : parseFloat(o)),
              (u = parseFloat(s)),
              (e._pt = new bn(e._pt, r, i, a, u - a, Rn)),
              (e._pt.u = l || 0),
              e._props.push(i));
          Nr(r, c);
        };
      we("padding,margin,Width,Radius", function (e, t) {
        var n = "Top",
          r = "Right",
          i = "Bottom",
          o = "Left",
          s = (t < 3 ? [n, r, i, o] : [n + o, n + r, i + r, i + o]).map(
            function (n) {
              return t < 2 ? e + n : "border" + n + e;
            }
          );
        yr[t > 1 ? "border" + e : e] = function (e, t, n, r, i) {
          var o, a;
          if (arguments.length < 4)
            return (
              (o = s.map(function (t) {
                return dr(e, t, n);
              })),
              5 === (a = o.join(" ")).split(o[0]).length ? o[0] : a
            );
          (o = (r + "").split(" ")),
            (a = {}),
            s.forEach(function (e, t) {
              return (a[e] = o[t] = o[t] || o[((t - 1) / 2) | 0]);
            }),
            e.init(t, a, i);
        };
      });
      var Ir,
        jr,
        Lr = {
          name: "css",
          register: ir,
          targetTest: function (e) {
            return e.style && e.nodeType;
          },
          init: function (e, t, n, r, i) {
            var o,
              s,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              h,
              m,
              g,
              y,
              v,
              D,
              b,
              E,
              C,
              x,
              w = this._props,
              A = e.style,
              S = n.vars.startAt;
            for (p in (Tn || ir(), t))
              if (
                "autoRound" !== p &&
                ((s = t[p]), !ge[p] || !Qt(p, t, n, r, e, i))
              )
                if (
                  ((l = typeof s),
                  (c = yr[p]),
                  "function" === l && (l = typeof (s = s.call(n, r, e, i))),
                  "string" === l && ~s.indexOf("random(") && (s = vt(s)),
                  c)
                )
                  c(this, e, p, s, n) && (D = 1);
                else if ("--" === p.substr(0, 2))
                  (o = (getComputedStyle(e).getPropertyValue(p) + "").trim()),
                    (s += ""),
                    (kt.lastIndex = 0),
                    kt.test(o) || ((f = ut(o)), (d = ut(s))),
                    d ? f !== d && (o = fr(e, p, o, d) + d) : f && (s += f),
                    this.add(A, "setProperty", o, s, r, i, 0, 0, p),
                    w.push(p);
                else if ("undefined" !== l) {
                  if (
                    (S && p in S
                      ? ((o =
                          "function" == typeof S[p]
                            ? S[p].call(n, r, e, i)
                            : S[p]),
                        q(o) && ~o.indexOf("random(") && (o = vt(o)),
                        ut(o + "") || (o += P.units[p] || ut(dr(e, p)) || ""),
                        "=" === (o + "").charAt(1) && (o = dr(e, p)))
                      : (o = dr(e, p)),
                    (u = parseFloat(o)),
                    (h =
                      "string" === l &&
                      "=" === s.charAt(1) &&
                      s.substr(0, 2)) && (s = s.substr(2)),
                    (a = parseFloat(s)),
                    p in $n &&
                      ("autoAlpha" === p &&
                        (1 === u &&
                          "hidden" === dr(e, "visibility") &&
                          a &&
                          (u = 0),
                        cr(
                          this,
                          A,
                          "visibility",
                          u ? "inherit" : "hidden",
                          a ? "inherit" : "hidden",
                          !a
                        )),
                      "scale" !== p &&
                        "transform" !== p &&
                        ~(p = $n[p]).indexOf(",") &&
                        (p = p.split(",")[0])),
                    (m = p in Bn))
                  )
                    if (
                      (g ||
                        (((y = e._gsap).renderTransform && !t.parseTransform) ||
                          wr(e, t.parseTransform),
                        (v = !1 !== t.smoothOrigin && y.smooth),
                        ((g = this._pt =
                          new bn(
                            this._pt,
                            A,
                            Kn,
                            0,
                            1,
                            y.renderTransform,
                            y,
                            0,
                            -1
                          )).dep = 1)),
                      "scale" === p)
                    )
                      (this._pt = new bn(
                        this._pt,
                        y,
                        "scaleY",
                        y.scaleY,
                        (h ? _e(y.scaleY, h + a) : a) - y.scaleY || 0
                      )),
                        w.push("scaleY", p),
                        (p += "X");
                    else {
                      if ("transformOrigin" === p) {
                        (E = void 0),
                          (C = void 0),
                          (x = void 0),
                          (C = (E = (b = s).split(" "))[0]),
                          (x = E[1] || "50%"),
                          ("top" !== C &&
                            "bottom" !== C &&
                            "left" !== x &&
                            "right" !== x) ||
                            ((b = C), (C = x), (x = b)),
                          (E[0] = mr[C] || C),
                          (E[1] = mr[x] || x),
                          (s = E.join(" ")),
                          y.svg
                            ? xr(e, s, 0, v, 0, this)
                            : ((d = parseFloat(s.split(" ")[2]) || 0) !==
                                y.zOrigin &&
                                cr(this, y, "zOrigin", y.zOrigin, d),
                              cr(this, A, p, Ar(o), Ar(s)));
                        continue;
                      }
                      if ("svgOrigin" === p) {
                        xr(e, s, 1, v, 0, this);
                        continue;
                      }
                      if (p in Dr) {
                        Pr(this, y, p, u, h ? _e(u, h + s) : s);
                        continue;
                      }
                      if ("smoothOrigin" === p) {
                        cr(this, y, "smooth", y.smooth, s);
                        continue;
                      }
                      if ("force3D" === p) {
                        y[p] = s;
                        continue;
                      }
                      if ("transform" === p) {
                        Mr(this, s, e);
                        continue;
                      }
                    }
                  else p in A || (p = rr(p) || p);
                  if (
                    m ||
                    ((a || 0 === a) && (u || 0 === u) && !Ln.test(s) && p in A)
                  )
                    a || (a = 0),
                      (f = (o + "").substr((u + "").length)) !==
                        (d = ut(s) || (p in P.units ? P.units[p] : f)) &&
                        (u = fr(e, p, o, d)),
                      (this._pt = new bn(
                        this._pt,
                        m ? y : A,
                        p,
                        u,
                        (h ? _e(u, h + a) : a) - u,
                        m ||
                        ("px" !== d && "zIndex" !== p) ||
                        !1 === t.autoRound
                          ? Rn
                          : qn
                      )),
                      (this._pt.u = d || 0),
                      f !== d &&
                        "%" !== d &&
                        ((this._pt.b = o), (this._pt.r = Vn));
                  else if (p in A) hr.call(this, e, p, o, h ? h + s : s);
                  else {
                    if (!(p in e)) {
                      le(p, s);
                      continue;
                    }
                    this.add(e, p, o || e[p], h ? h + s : s, r, i);
                  }
                  w.push(p);
                }
            D && Dn(this);
          },
          get: dr,
          aliases: $n,
          getSetter: function (e, t, n) {
            var r = $n[t];
            return (
              r && r.indexOf(",") < 0 && (t = r),
              t in Bn && t !== Qn && (e._gsap.x || dr(e, "x"))
                ? n && kn === n
                  ? "scale" === t
                    ? Xn
                    : Yn
                  : (kn = n || {}) && ("scale" === t ? Jn : Zn)
                : e.style && !H(e.style[t])
                ? Hn
                : ~t.indexOf("-")
                ? Gn
                : pn(e, t)
            );
          },
          core: { _removeProperty: lr, _getMatrix: Cr },
        };
      (wn.utils.checkPrefix = rr),
        (jr = we(
          "x,y,z,scale,scaleX,scaleY,xPercent,yPercent" +
            "," +
            (Ir = "rotation,rotationX,rotationY,skewX,skewY") +
            ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
          function (e) {
            Bn[e] = 1;
          }
        )),
        we(Ir, function (e) {
          (P.units[e] = "deg"), (Dr[e] = 1);
        }),
        ($n[jr[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + Ir),
        we(
          "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",
          function (e) {
            var t = e.split(":");
            $n[t[1]] = jr[t[0]];
          }
        ),
        we(
          "x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",
          function (e) {
            P.units[e] = "px";
          }
        ),
        wn.registerPlugin(Lr);
      var $r = wn.registerPlugin(Lr) || wn;
      $r.core.Tween;
    },
    2817: function (e, t) {
      "use strict";
      var n, r, i;
      !(function (o, s) {
        if ("object" == typeof e.exports) {
          if (!o.document)
            throw new Error("HC-Sticky requires a browser to run.");
          e.exports = s(o);
        } else
          (r = []),
            (n = s(o)),
            void 0 === (i = "function" == typeof n ? n.apply(t, r) : n) ||
              (e.exports = i);
      })("undefined" != typeof window ? window : this, function (e) {
        var t,
          n,
          r = e.document,
          i = {
            top: 0,
            bottom: 0,
            bottomEnd: 0,
            innerTop: 0,
            innerSticker: null,
            stickyClass: "sticky",
            stickTo: null,
            followScroll: !0,
            responsive: null,
            mobileFirst: !1,
            onStart: null,
            onStop: null,
            onBeforeResize: null,
            onResize: null,
            resizeDebounce: 100,
            disable: !1,
          },
          o = function (e, t, n) {
            console.warn(
              "%cHC Sticky:%c " +
                n +
                "%c '" +
                e +
                "'%c is now deprecated and will be removed. Use%c '" +
                t +
                "'%c instead.",
              "color: #fa253b",
              "color: default",
              "color: #5595c6",
              "color: default",
              "color: #5595c6",
              "color: default"
            );
          },
          s = function (t, n) {
            var a = this;
            if (
              ((n = n || {}),
              !(t = "string" == typeof t ? r.querySelector(t) : t))
            )
              return !1;
            n.queries && o("queries", "responsive", "option"),
              n.queryFlow && o("queryFlow", "mobileFirst", "option");
            var u = {},
              l = s.Helpers,
              c = t.parentNode;
            function p(e) {
              (l.isEmptyObject((e = e || {})) && !l.isEmptyObject(u)) ||
                (u = Object.assign({}, i, u, e));
            }
            function f() {
              return u.disable;
            }
            function d() {
              var t,
                r = u.responsive || u.queries;
              if (r) {
                var o = e.innerWidth;
                if (((t = n), (u = Object.assign({}, i, t || {})).mobileFirst))
                  for (var s in r) s <= o && !l.isEmptyObject(r[s]) && p(r[s]);
                else {
                  var a,
                    c = [];
                  for (a in r) {
                    var f = {};
                    (f[a] = r[a]), c.push(f);
                  }
                  for (var d = c.length - 1; 0 <= d; d--) {
                    var h = c[d],
                      m = Object.keys(h)[0];
                    o <= m && !l.isEmptyObject(h[m]) && p(h[m]);
                  }
                }
              }
            }
            function h() {
              (N = j()), (x = I()), (B = w + x - _ - k), (P = S < N);
              var n,
                i = e.pageYOffset || r.documentElement.scrollTop,
                o = l.offset(t).top,
                s = o - i;
              ($ = i < V ? "up" : "down"),
                (L = i - V),
                O < (V = i)
                  ? B + _ + (P ? T : 0) - (u.followScroll && P ? 0 : _) <=
                    i +
                      N -
                      F -
                      (S - (O - F) < N - F &&
                      u.followScroll &&
                      0 < (n = N - S - F)
                        ? n
                        : 0)
                    ? R.release({
                        position: "absolute",
                        bottom: A + c.offsetHeight - B - _,
                      })
                    : P && u.followScroll
                    ? "down" == $
                      ? s + N + T <= S + 0.9
                        ? R.stick({ bottom: T })
                        : "fixed" === R.position &&
                          R.release({
                            position: "absolute",
                            top: o - _ - O - L + F,
                          })
                      : Math.ceil(s + F) < 0 && "fixed" === R.position
                      ? R.release({
                          position: "absolute",
                          top: o - _ - O + F - L,
                        })
                      : i + _ - F <= o && R.stick({ top: _ - F })
                    : R.stick({ top: _ - F })
                  : R.release({ stop: !0 });
            }
            function m() {
              q &&
                (e.removeEventListener("scroll", h, l.supportsPassive),
                (q = !1));
            }
            function g() {
              null !== t.offsetParent && "none" !== l.getStyle(t, "display")
                ? ((function () {
                    var n, i, o, s;
                    (R.css =
                      ((n = t),
                      (i = l.getCascadedStyle(n)),
                      (o = l.getStyle(n)),
                      (s = {
                        height: n.offsetHeight + "px",
                        left: i.left,
                        right: i.right,
                        top: i.top,
                        bottom: i.bottom,
                        position: o.position,
                        display: o.display,
                        verticalAlign: o.verticalAlign,
                        boxSizing: o.boxSizing,
                        marginLeft: i.marginLeft,
                        marginRight: i.marginRight,
                        marginTop: i.marginTop,
                        marginBottom: i.marginBottom,
                        paddingLeft: i.paddingLeft,
                        paddingRight: i.paddingRight,
                      }),
                      i.float && (s.float = i.float || "none"),
                      i.cssFloat && (s.cssFloat = i.cssFloat || "none"),
                      o.MozBoxSizing && (s.MozBoxSizing = o.MozBoxSizing),
                      (s.width =
                        "auto" !== i.width
                          ? i.width
                          : "border-box" === s.boxSizing ||
                            "border-box" === s.MozBoxSizing
                          ? n.offsetWidth + "px"
                          : o.width),
                      s)),
                      z.init(),
                      (b = !(
                        !u.stickTo ||
                        !(
                          "document" === u.stickTo ||
                          (u.stickTo.nodeType && 9 === u.stickTo.nodeType) ||
                          ("object" == typeof u.stickTo &&
                            u.stickTo instanceof
                              ("undefined" != typeof HTMLDocument
                                ? HTMLDocument
                                : Document))
                        )
                      )),
                      (E = u.stickTo ? (b ? r : l.getElement(u.stickTo)) : c),
                      (N = (j = function () {
                        var e =
                            t.offsetHeight +
                            (parseInt(R.css.marginTop) || 0) +
                            (parseInt(R.css.marginBottom) || 0),
                          n = (N || 0) - e;
                        return -1 <= n && n <= 1 ? N : e;
                      })()),
                      (x = (I = function () {
                        return b
                          ? Math.max(
                              r.documentElement.clientHeight,
                              r.body.scrollHeight,
                              r.documentElement.scrollHeight,
                              r.body.offsetHeight,
                              r.documentElement.offsetHeight
                            )
                          : E.offsetHeight;
                      })()),
                      (w = b ? 0 : l.offset(E).top),
                      (A = u.stickTo ? (b ? 0 : l.offset(c).top) : w),
                      (S = e.innerHeight),
                      (M = t.offsetTop - (parseInt(R.css.marginTop) || 0)),
                      (C = l.getElement(u.innerSticker)),
                      (_ =
                        isNaN(u.top) && -1 < u.top.indexOf("%")
                          ? (parseFloat(u.top) / 100) * S
                          : u.top),
                      (T =
                        isNaN(u.bottom) && -1 < u.bottom.indexOf("%")
                          ? (parseFloat(u.bottom) / 100) * S
                          : u.bottom),
                      (F = C ? C.offsetTop : u.innerTop || 0),
                      (k =
                        isNaN(u.bottomEnd) && -1 < u.bottomEnd.indexOf("%")
                          ? (parseFloat(u.bottomEnd) / 100) * S
                          : u.bottomEnd),
                      (O = w - _ + F + M);
                  })(),
                  x < N
                    ? m()
                    : (h(),
                      q ||
                        (e.addEventListener("scroll", h, l.supportsPassive),
                        (q = !0))))
                : m();
            }
            function y() {
              (t.style.position = ""),
                (t.style.left = ""),
                (t.style.top = ""),
                (t.style.bottom = ""),
                (t.style.width = ""),
                t.classList
                  ? t.classList.remove(u.stickyClass)
                  : (t.className = t.className.replace(
                      new RegExp(
                        "(^|\\b)" +
                          u.stickyClass.split(" ").join("|") +
                          "(\\b|$)",
                        "gi"
                      ),
                      " "
                    )),
                (R.css = {}),
                !(R.position = null) === z.isAttached && z.detach();
            }
            function v() {
              y(), d(), (f() ? m : g)();
            }
            function D() {
              W &&
                (e.removeEventListener("resize", H, l.supportsPassive),
                (W = !1)),
                m();
            }
            "static" === l.getStyle(c, "position") &&
              (c.style.position = "relative");
            var b,
              E,
              C,
              x,
              w,
              A,
              S,
              _,
              T,
              F,
              k,
              O,
              B,
              P,
              N,
              M,
              I,
              j,
              L,
              $,
              R = {
                css: {},
                position: null,
                stick: function (e) {
                  (e = e || {}),
                    l.hasClass(t, u.stickyClass) ||
                      (!1 === z.isAttached && z.attach(),
                      (R.position = "fixed"),
                      (t.style.position = "fixed"),
                      (t.style.left = z.offsetLeft + "px"),
                      (t.style.width = z.width),
                      void 0 === e.bottom
                        ? (t.style.bottom = "auto")
                        : (t.style.bottom = e.bottom + "px"),
                      void 0 === e.top
                        ? (t.style.top = "auto")
                        : (t.style.top = e.top + "px"),
                      t.classList
                        ? t.classList.add(u.stickyClass)
                        : (t.className += " " + u.stickyClass),
                      u.onStart && u.onStart.call(t, Object.assign({}, u)));
                },
                release: function (e) {
                  var n;
                  ((e = e || {}).stop = e.stop || !1),
                    (!0 !== e.stop &&
                      "fixed" !== R.position &&
                      null !== R.position &&
                      ((void 0 === e.top && void 0 === e.bottom) ||
                        (void 0 !== e.top &&
                          (parseInt(l.getStyle(t, "top")) || 0) === e.top) ||
                        (void 0 !== e.bottom &&
                          (parseInt(l.getStyle(t, "bottom")) || 0) ===
                            e.bottom))) ||
                      (!0 === e.stop
                        ? !0 === z.isAttached && z.detach()
                        : !1 === z.isAttached && z.attach(),
                      (n = e.position || R.css.position),
                      (R.position = n),
                      (t.style.position = n),
                      (t.style.left =
                        !0 === e.stop ? R.css.left : z.positionLeft + "px"),
                      (t.style.width = ("absolute" !== n ? R.css : z).width),
                      void 0 === e.bottom
                        ? (t.style.bottom = !0 === e.stop ? "" : "auto")
                        : (t.style.bottom = e.bottom + "px"),
                      void 0 === e.top
                        ? (t.style.top = !0 === e.stop ? "" : "auto")
                        : (t.style.top = e.top + "px"),
                      t.classList
                        ? t.classList.remove(u.stickyClass)
                        : (t.className = t.className.replace(
                            new RegExp(
                              "(^|\\b)" +
                                u.stickyClass.split(" ").join("|") +
                                "(\\b|$)",
                              "gi"
                            ),
                            " "
                          )),
                      u.onStop && u.onStop.call(t, Object.assign({}, u)));
                },
              },
              /*z = {
                el: r.createElement("div"),
                offsetLeft: null,
                positionLeft: null,
                width: null,
                isAttached: !1,
                init: function () {
                  for (var e in ((z.el.className = "sticky-spacer"), R.css))
                    z.el.style[e] = R.css[e];
                  z.el.style["z-index"] = "-1";
                  var n = l.getStyle(t);
                  (z.offsetLeft =
                    l.offset(t).left - (parseInt(n.marginLeft) || 0)),
                    (z.positionLeft = l.position(t).left),
                    (z.width = l.getStyle(t, "width"));
                },
                attach: function () {
                  c.insertBefore(z.el, t), (z.isAttached = !0);
                },
                detach: function () {
                  (z.el = c.removeChild(z.el)), (z.isAttached = !1);
                },
              },*/
              V = e.pageYOffset || r.documentElement.scrollTop,
              q = !1,
              W = !1,
              U = function () {
                u.onBeforeResize &&
                  u.onBeforeResize.call(t, Object.assign({}, u)),
                  v(),
                  u.onResize && u.onResize.call(t, Object.assign({}, u));
              },
              H = u.resizeDebounce ? l.debounce(U, u.resizeDebounce) : U;
            (U = function () {
              W ||
                (e.addEventListener("resize", H, l.supportsPassive), (W = !0)),
                d(),
                (f() ? m : g)();
            }),
              (this.options = function (e) {
                return e ? u[e] : Object.assign({}, u);
              }),
              (this.refresh = v),
              (this.update = function (e) {
                p(e), (n = Object.assign({}, n, e || {})), v();
              }),
              (this.attach = U),
              (this.detach = D),
              (this.destroy = function () {
                D(), y();
              }),
              (this.triggerMethod = function (e, t) {
                "function" == typeof a[e] && a[e](t);
              }),
              (this.reinit = function () {
                o("reinit", "refresh", "method"), v();
              }),
              p(n),
              U(),
              e.addEventListener("load", v);
          };
        return (
          void 0 !== e.jQuery &&
            ((t = e.jQuery),
            (n = "hcSticky"),
            t.fn.extend({
              hcSticky: function (e, r) {
                return this.length
                  ? "options" === e
                    ? t.data(this.get(0), n).options()
                    : this.each(function () {
                        var i = t.data(this, n);
                        i
                          ? i.triggerMethod(e, r)
                          : ((i = new s(this, e)), t.data(this, n, i));
                      })
                  : this;
              },
            })),
          (e.hcSticky = e.hcSticky || s),
          s
        );
      }),
        (function (e) {
          var t = e.hcSticky,
            n = e.document;
          "function" != typeof Object.assign &&
            Object.defineProperty(Object, "assign", {
              value: function (e, t) {
                if (null == e)
                  throw new TypeError(
                    "Cannot convert undefined or null to object"
                  );
                for (var n = Object(e), r = 1; r < arguments.length; r++) {
                  var i = arguments[r];
                  if (null != i)
                    for (var o in i)
                      Object.prototype.hasOwnProperty.call(i, o) &&
                        (n[o] = i[o]);
                }
                return n;
              },
              writable: !0,
              configurable: !0,
            }),
            Array.prototype.forEach ||
              (Array.prototype.forEach = function (e) {
                var t, n;
                if (null == this)
                  throw new TypeError("this is null or not defined");
                var r,
                  i = Object(this),
                  o = i.length >>> 0;
                if ("function" != typeof e)
                  throw new TypeError(e + " is not a function");
                for (1 < arguments.length && (t = arguments[1]), n = 0; n < o; )
                  n in i && ((r = i[n]), e.call(t, r, n, i)), n++;
              });
          var r = !1;
          try {
            var i = Object.defineProperty({}, "passive", {
              get: function () {
                r = { passive: !1 };
              },
            });
            e.addEventListener("testPassive", null, i),
              e.removeEventListener("testPassive", null, i);
          } catch (t) {}
          function o(t, r) {
            return e.getComputedStyle
              ? r
                ? n.defaultView.getComputedStyle(t, null).getPropertyValue(r)
                : n.defaultView.getComputedStyle(t, null)
              : t.currentStyle
              ? r
                ? t.currentStyle[
                    r.replace(/-\w/g, function (e) {
                      return e.toUpperCase().replace("-", "");
                    })
                  ]
                : t.currentStyle
              : void 0;
          }
          function s(t) {
            var r = t.getBoundingClientRect(),
              i = e.pageYOffset || n.documentElement.scrollTop;
            return (
              (t = e.pageXOffset || n.documentElement.scrollLeft),
              { top: r.top + i, left: r.left + t }
            );
          }
          t.Helpers = {
            supportsPassive: r,
            isEmptyObject: function (e) {
              for (var t in e) return !1;
              return !0;
            },
            debounce: function (e, t, n) {
              var r;
              return function () {
                var i = this,
                  o = arguments,
                  s = n && !r;
                clearTimeout(r),
                  (r = setTimeout(function () {
                    (r = null), n || e.apply(i, o);
                  }, t)),
                  s && e.apply(i, o);
              };
            },
            hasClass: function (e, t) {
              return e.classList
                ? e.classList.contains(t)
                : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className);
            },
            offset: s,
            position: function (e) {
              var t = s((r = e.offsetParent)),
                n = s(e),
                r = o(r);
              return (
                (e = o(e)),
                (t.top += parseInt(r.borderTopWidth) || 0),
                (t.left += parseInt(r.borderLeftWidth) || 0),
                {
                  top: n.top - t.top - (parseInt(e.marginTop) || 0),
                  left: n.left - t.left - (parseInt(e.marginLeft) || 0),
                }
              );
            },
            getElement: function (t) {
              var r = null;
              return (
                "string" == typeof t
                  ? (r = n.querySelector(t))
                  : e.jQuery && t instanceof e.jQuery && t.length
                  ? (r = t[0])
                  : t instanceof Element && (r = t),
                r
              );
            },
            getStyle: o,
            getCascadedStyle: function (t) {
              var r,
                i = t.cloneNode(!0);
              (i.style.display = "none"),
                Array.prototype.slice
                  .call(i.querySelectorAll('input[type="radio"]'))
                  .forEach(function (e) {
                    e.removeAttribute("name");
                  }),
                t.parentNode.insertBefore(i, t.nextSibling),
                i.currentStyle
                  ? (r = i.currentStyle)
                  : e.getComputedStyle &&
                    (r = n.defaultView.getComputedStyle(i, null));
              var o,
                s,
                a,
                u = {};
              for (o in r)
                !isNaN(o) ||
                  ("string" != typeof r[o] && "number" != typeof r[o]) ||
                  (u[o] = r[o]);
              if (Object.keys(u).length < 3)
                for (var l in ((u = {}), r))
                  isNaN(l) ||
                    (u[
                      r[l].replace(/-\w/g, function (e) {
                        return e.toUpperCase().replace("-", "");
                      })
                    ] = r.getPropertyValue(r[l]));
              return (
                u.margin || "auto" !== u.marginLeft
                  ? u.margin ||
                    u.marginLeft !== u.marginRight ||
                    u.marginLeft !== u.marginTop ||
                    u.marginLeft !== u.marginBottom ||
                    (u.margin = u.marginLeft)
                  : (u.margin = "auto"),
                u.margin ||
                  "0px" !== u.marginLeft ||
                  "0px" !== u.marginRight ||
                  ((a =
                    (s = t.offsetLeft - t.parentNode.offsetLeft) -
                    (parseInt(u.left) || 0) -
                    (parseInt(u.right) || 0)),
                  (0 !=
                    (a =
                      t.parentNode.offsetWidth -
                      t.offsetWidth -
                      s -
                      (parseInt(u.right) || 0) +
                      (parseInt(u.left) || 0) -
                      a) &&
                    1 != a) ||
                    (u.margin = "auto")),
                i.parentNode.removeChild(i),
                (i = null),
                u
              );
            },
          };
        })(window);
    },
    1711: function (e, t, n) {
      "use strict";
      function r(e, t, n) {
        void 0 === n && (n = {});
        var r = Object.assign({}, n, { g: e, email: t }),
          i = Object.keys(r).reduce(function (e, t) {
            return e.append(t, r[t]), e;
          }, new URLSearchParams());
        return fetch(
          "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          {
            method: "POST",
            headers: {
              "Access-Control-Allow-Headers": "*",
              "Content-Type":
                "application/x-www-form-urlencoded; charset=utf-8",
            },
            body: i,
          }
        ).then(function (e) {
          return e.json();
        });
      }
      n.d(t, {
        L: function () {
          return r;
        },
      });
    },
    6486: function (e, t, n) {
      var r;
      (e = n.nmd(e)),
        function () {
          var i,
            o = "Expected a function",
            s = "__lodash_hash_undefined__",
            a = "__lodash_placeholder__",
            u = 32,
            l = 128,
            c = 1 / 0,
            p = 9007199254740991,
            f = NaN,
            d = 4294967295,
            h = [
              ["ary", l],
              ["bind", 1],
              ["bindKey", 2],
              ["curry", 8],
              ["curryRight", 16],
              ["flip", 512],
              ["partial", u],
              ["partialRight", 64],
              ["rearg", 256],
            ],
            m = "[object Arguments]",
            g = "[object Array]",
            y = "[object Boolean]",
            v = "[object Date]",
            D = "[object Error]",
            b = "[object Function]",
            E = "[object GeneratorFunction]",
            C = "[object Map]",
            x = "[object Number]",
            w = "[object Object]",
            A = "[object Promise]",
            S = "[object RegExp]",
            _ = "[object Set]",
            T = "[object String]",
            F = "[object Symbol]",
            k = "[object WeakMap]",
            O = "[object ArrayBuffer]",
            B = "[object DataView]",
            P = "[object Float32Array]",
            N = "[object Float64Array]",
            M = "[object Int8Array]",
            I = "[object Int16Array]",
            j = "[object Int32Array]",
            L = "[object Uint8Array]",
            $ = "[object Uint8ClampedArray]",
            R = "[object Uint16Array]",
            z = "[object Uint32Array]",
            V = /\b__p \+= '';/g,
            q = /\b(__p \+=) '' \+/g,
            W = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            U = /&(?:amp|lt|gt|quot|#39);/g,
            H = /[&<>"']/g,
            G = RegExp(U.source),
            Y = RegExp(H.source),
            X = /<%-([\s\S]+?)%>/g,
            J = /<%([\s\S]+?)%>/g,
            Z = /<%=([\s\S]+?)%>/g,
            K = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Q = /^\w*$/,
            ee =
              /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            te = /[\\^$.*+?()[\]{}|]/g,
            ne = RegExp(te.source),
            re = /^\s+/,
            ie = /\s/,
            oe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            se = /\{\n\/\* \[wrapped with (.+)\] \*/,
            ae = /,? & /,
            ue = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            le = /[()=,{}\[\]\/\s]/,
            ce = /\\(\\)?/g,
            pe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            fe = /\w*$/,
            de = /^[-+]0x[0-9a-f]+$/i,
            he = /^0b[01]+$/i,
            me = /^\[object .+?Constructor\]$/,
            ge = /^0o[0-7]+$/i,
            ye = /^(?:0|[1-9]\d*)$/,
            ve = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            De = /($^)/,
            be = /['\n\r\u2028\u2029\\]/g,
            Ee = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            Ce = "a-z\\xdf-\\xf6\\xf8-\\xff",
            xe = "A-Z\\xc0-\\xd6\\xd8-\\xde",
            we =
              "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            Ae = "[" + we + "]",
            Se = "[" + Ee + "]",
            _e = "\\d+",
            Te = "[" + Ce + "]",
            Fe =
              "[^\\ud800-\\udfff" + we + _e + "\\u2700-\\u27bf" + Ce + xe + "]",
            ke = "\\ud83c[\\udffb-\\udfff]",
            Oe = "[^\\ud800-\\udfff]",
            Be = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            Pe = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            Ne = "[" + xe + "]",
            Me = "(?:" + Te + "|" + Fe + ")",
            Ie = "(?:" + Ne + "|" + Fe + ")",
            je = "(?:['’](?:d|ll|m|re|s|t|ve))?",
            Le = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
            $e = "(?:" + Se + "|" + ke + ")?",
            Re = "[\\ufe0e\\ufe0f]?",
            ze =
              Re +
              $e +
              "(?:\\u200d(?:" +
              [Oe, Be, Pe].join("|") +
              ")" +
              Re +
              $e +
              ")*",
            Ve = "(?:" + ["[\\u2700-\\u27bf]", Be, Pe].join("|") + ")" + ze,
            qe =
              "(?:" +
              [Oe + Se + "?", Se, Be, Pe, "[\\ud800-\\udfff]"].join("|") +
              ")",
            We = RegExp("['’]", "g"),
            Ue = RegExp(Se, "g"),
            He = RegExp(ke + "(?=" + ke + ")|" + qe + ze, "g"),
            Ge = RegExp(
              [
                Ne +
                  "?" +
                  Te +
                  "+" +
                  je +
                  "(?=" +
                  [Ae, Ne, "$"].join("|") +
                  ")",
                Ie + "+" + Le + "(?=" + [Ae, Ne + Me, "$"].join("|") + ")",
                Ne + "?" + Me + "+" + je,
                Ne + "+" + Le,
                "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
                "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
                _e,
                Ve,
              ].join("|"),
              "g"
            ),
            Ye = RegExp("[\\u200d\\ud800-\\udfff" + Ee + "\\ufe0e\\ufe0f]"),
            Xe =
              /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            Je = [
              "Array",
              "Buffer",
              "DataView",
              "Date",
              "Error",
              "Float32Array",
              "Float64Array",
              "Function",
              "Int8Array",
              "Int16Array",
              "Int32Array",
              "Map",
              "Math",
              "Object",
              "Promise",
              "RegExp",
              "Set",
              "String",
              "Symbol",
              "TypeError",
              "Uint8Array",
              "Uint8ClampedArray",
              "Uint16Array",
              "Uint32Array",
              "WeakMap",
              "_",
              "clearTimeout",
              "isFinite",
              "parseInt",
              "setTimeout",
            ],
            Ze = -1,
            Ke = {};
          (Ke[P] =
            Ke[N] =
            Ke[M] =
            Ke[I] =
            Ke[j] =
            Ke[L] =
            Ke[$] =
            Ke[R] =
            Ke[z] =
              !0),
            (Ke[m] =
              Ke[g] =
              Ke[O] =
              Ke[y] =
              Ke[B] =
              Ke[v] =
              Ke[D] =
              Ke[b] =
              Ke[C] =
              Ke[x] =
              Ke[w] =
              Ke[S] =
              Ke[_] =
              Ke[T] =
              Ke[k] =
                !1);
          var Qe = {};
          (Qe[m] =
            Qe[g] =
            Qe[O] =
            Qe[B] =
            Qe[y] =
            Qe[v] =
            Qe[P] =
            Qe[N] =
            Qe[M] =
            Qe[I] =
            Qe[j] =
            Qe[C] =
            Qe[x] =
            Qe[w] =
            Qe[S] =
            Qe[_] =
            Qe[T] =
            Qe[F] =
            Qe[L] =
            Qe[$] =
            Qe[R] =
            Qe[z] =
              !0),
            (Qe[D] = Qe[b] = Qe[k] = !1);
          var et = {
              "\\": "\\",
              "'": "'",
              "\n": "n",
              "\r": "r",
              "\u2028": "u2028",
              "\u2029": "u2029",
            },
            tt = parseFloat,
            nt = parseInt,
            rt = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
            it =
              "object" == typeof self && self && self.Object === Object && self,
            ot = rt || it || Function("return this")(),
            st = t && !t.nodeType && t,
            at = st && e && !e.nodeType && e,
            ut = at && at.exports === st,
            lt = ut && rt.process,
            ct = (function () {
              try {
                return (
                  (at && at.require && at.require("util").types) ||
                  (lt && lt.binding && lt.binding("util"))
                );
              } catch (e) {}
            })(),
            pt = ct && ct.isArrayBuffer,
            ft = ct && ct.isDate,
            dt = ct && ct.isMap,
            ht = ct && ct.isRegExp,
            mt = ct && ct.isSet,
            gt = ct && ct.isTypedArray;
          function yt(e, t, n) {
            switch (n.length) {
              case 0:
                return e.call(t);
              case 1:
                return e.call(t, n[0]);
              case 2:
                return e.call(t, n[0], n[1]);
              case 3:
                return e.call(t, n[0], n[1], n[2]);
            }
            return e.apply(t, n);
          }
          function vt(e, t, n, r) {
            for (var i = -1, o = null == e ? 0 : e.length; ++i < o; ) {
              var s = e[i];
              t(r, s, n(s), e);
            }
            return r;
          }
          function Dt(e, t) {
            for (
              var n = -1, r = null == e ? 0 : e.length;
              ++n < r && !1 !== t(e[n], n, e);

            );
            return e;
          }
          function bt(e, t) {
            for (
              var n = null == e ? 0 : e.length;
              n-- && !1 !== t(e[n], n, e);

            );
            return e;
          }
          function Et(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r; )
              if (!t(e[n], n, e)) return !1;
            return !0;
          }
          function Ct(e, t) {
            for (
              var n = -1, r = null == e ? 0 : e.length, i = 0, o = [];
              ++n < r;

            ) {
              var s = e[n];
              t(s, n, e) && (o[i++] = s);
            }
            return o;
          }
          function xt(e, t) {
            return !(null == e || !e.length) && Pt(e, t, 0) > -1;
          }
          function wt(e, t, n) {
            for (var r = -1, i = null == e ? 0 : e.length; ++r < i; )
              if (n(t, e[r])) return !0;
            return !1;
          }
          function At(e, t) {
            for (
              var n = -1, r = null == e ? 0 : e.length, i = Array(r);
              ++n < r;

            )
              i[n] = t(e[n], n, e);
            return i;
          }
          function St(e, t) {
            for (var n = -1, r = t.length, i = e.length; ++n < r; )
              e[i + n] = t[n];
            return e;
          }
          function _t(e, t, n, r) {
            var i = -1,
              o = null == e ? 0 : e.length;
            for (r && o && (n = e[++i]); ++i < o; ) n = t(n, e[i], i, e);
            return n;
          }
          function Tt(e, t, n, r) {
            var i = null == e ? 0 : e.length;
            for (r && i && (n = e[--i]); i--; ) n = t(n, e[i], i, e);
            return n;
          }
          function Ft(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r; )
              if (t(e[n], n, e)) return !0;
            return !1;
          }
          var kt = jt("length");
          function Ot(e, t, n) {
            var r;
            return (
              n(e, function (e, n, i) {
                if (t(e, n, i)) return (r = n), !1;
              }),
              r
            );
          }
          function Bt(e, t, n, r) {
            for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
              if (t(e[o], o, e)) return o;
            return -1;
          }
          function Pt(e, t, n) {
            return t == t
              ? (function (e, t, n) {
                  for (var r = n - 1, i = e.length; ++r < i; )
                    if (e[r] === t) return r;
                  return -1;
                })(e, t, n)
              : Bt(e, Mt, n);
          }
          function Nt(e, t, n, r) {
            for (var i = n - 1, o = e.length; ++i < o; )
              if (r(e[i], t)) return i;
            return -1;
          }
          function Mt(e) {
            return e != e;
          }
          function It(e, t) {
            var n = null == e ? 0 : e.length;
            return n ? Rt(e, t) / n : f;
          }
          function jt(e) {
            return function (t) {
              return null == t ? i : t[e];
            };
          }
          function Lt(e) {
            return function (t) {
              return null == e ? i : e[t];
            };
          }
          function $t(e, t, n, r, i) {
            return (
              i(e, function (e, i, o) {
                n = r ? ((r = !1), e) : t(n, e, i, o);
              }),
              n
            );
          }
          function Rt(e, t) {
            for (var n, r = -1, o = e.length; ++r < o; ) {
              var s = t(e[r]);
              s !== i && (n = n === i ? s : n + s);
            }
            return n;
          }
          function zt(e, t) {
            for (var n = -1, r = Array(e); ++n < e; ) r[n] = t(n);
            return r;
          }
          function Vt(e) {
            return e ? e.slice(0, an(e) + 1).replace(re, "") : e;
          }
          function qt(e) {
            return function (t) {
              return e(t);
            };
          }
          function Wt(e, t) {
            return At(t, function (t) {
              return e[t];
            });
          }
          function Ut(e, t) {
            return e.has(t);
          }
          function Ht(e, t) {
            for (var n = -1, r = e.length; ++n < r && Pt(t, e[n], 0) > -1; );
            return n;
          }
          function Gt(e, t) {
            for (var n = e.length; n-- && Pt(t, e[n], 0) > -1; );
            return n;
          }
          function Yt(e, t) {
            for (var n = e.length, r = 0; n--; ) e[n] === t && ++r;
            return r;
          }
          var Xt = Lt({
              À: "A",
              Á: "A",
              Â: "A",
              Ã: "A",
              Ä: "A",
              Å: "A",
              à: "a",
              á: "a",
              â: "a",
              ã: "a",
              ä: "a",
              å: "a",
              Ç: "C",
              ç: "c",
              Ð: "D",
              ð: "d",
              È: "E",
              É: "E",
              Ê: "E",
              Ë: "E",
              è: "e",
              é: "e",
              ê: "e",
              ë: "e",
              Ì: "I",
              Í: "I",
              Î: "I",
              Ï: "I",
              ì: "i",
              í: "i",
              î: "i",
              ï: "i",
              Ñ: "N",
              ñ: "n",
              Ò: "O",
              Ó: "O",
              Ô: "O",
              Õ: "O",
              Ö: "O",
              Ø: "O",
              ò: "o",
              ó: "o",
              ô: "o",
              õ: "o",
              ö: "o",
              ø: "o",
              Ù: "U",
              Ú: "U",
              Û: "U",
              Ü: "U",
              ù: "u",
              ú: "u",
              û: "u",
              ü: "u",
              Ý: "Y",
              ý: "y",
              ÿ: "y",
              Æ: "Ae",
              æ: "ae",
              Þ: "Th",
              þ: "th",
              ß: "ss",
              Ā: "A",
              Ă: "A",
              Ą: "A",
              ā: "a",
              ă: "a",
              ą: "a",
              Ć: "C",
              Ĉ: "C",
              Ċ: "C",
              Č: "C",
              ć: "c",
              ĉ: "c",
              ċ: "c",
              č: "c",
              Ď: "D",
              Đ: "D",
              ď: "d",
              đ: "d",
              Ē: "E",
              Ĕ: "E",
              Ė: "E",
              Ę: "E",
              Ě: "E",
              ē: "e",
              ĕ: "e",
              ė: "e",
              ę: "e",
              ě: "e",
              Ĝ: "G",
              Ğ: "G",
              Ġ: "G",
              Ģ: "G",
              ĝ: "g",
              ğ: "g",
              ġ: "g",
              ģ: "g",
              Ĥ: "H",
              Ħ: "H",
              ĥ: "h",
              ħ: "h",
              Ĩ: "I",
              Ī: "I",
              Ĭ: "I",
              Į: "I",
              İ: "I",
              ĩ: "i",
              ī: "i",
              ĭ: "i",
              į: "i",
              ı: "i",
              Ĵ: "J",
              ĵ: "j",
              Ķ: "K",
              ķ: "k",
              ĸ: "k",
              Ĺ: "L",
              Ļ: "L",
              Ľ: "L",
              Ŀ: "L",
              Ł: "L",
              ĺ: "l",
              ļ: "l",
              ľ: "l",
              ŀ: "l",
              ł: "l",
              Ń: "N",
              Ņ: "N",
              Ň: "N",
              Ŋ: "N",
              ń: "n",
              ņ: "n",
              ň: "n",
              ŋ: "n",
              Ō: "O",
              Ŏ: "O",
              Ő: "O",
              ō: "o",
              ŏ: "o",
              ő: "o",
              Ŕ: "R",
              Ŗ: "R",
              Ř: "R",
              ŕ: "r",
              ŗ: "r",
              ř: "r",
              Ś: "S",
              Ŝ: "S",
              Ş: "S",
              Š: "S",
              ś: "s",
              ŝ: "s",
              ş: "s",
              š: "s",
              Ţ: "T",
              Ť: "T",
              Ŧ: "T",
              ţ: "t",
              ť: "t",
              ŧ: "t",
              Ũ: "U",
              Ū: "U",
              Ŭ: "U",
              Ů: "U",
              Ű: "U",
              Ų: "U",
              ũ: "u",
              ū: "u",
              ŭ: "u",
              ů: "u",
              ű: "u",
              ų: "u",
              Ŵ: "W",
              ŵ: "w",
              Ŷ: "Y",
              ŷ: "y",
              Ÿ: "Y",
              Ź: "Z",
              Ż: "Z",
              Ž: "Z",
              ź: "z",
              ż: "z",
              ž: "z",
              Ĳ: "IJ",
              ĳ: "ij",
              Œ: "Oe",
              œ: "oe",
              ŉ: "'n",
              ſ: "s",
            }),
            Jt = Lt({
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
            });
          function Zt(e) {
            return "\\" + et[e];
          }
          function Kt(e) {
            return Ye.test(e);
          }
          function Qt(e) {
            var t = -1,
              n = Array(e.size);
            return (
              e.forEach(function (e, r) {
                n[++t] = [r, e];
              }),
              n
            );
          }
          function en(e, t) {
            return function (n) {
              return e(t(n));
            };
          }
          function tn(e, t) {
            for (var n = -1, r = e.length, i = 0, o = []; ++n < r; ) {
              var s = e[n];
              (s !== t && s !== a) || ((e[n] = a), (o[i++] = n));
            }
            return o;
          }
          function nn(e) {
            var t = -1,
              n = Array(e.size);
            return (
              e.forEach(function (e) {
                n[++t] = e;
              }),
              n
            );
          }
          function rn(e) {
            var t = -1,
              n = Array(e.size);
            return (
              e.forEach(function (e) {
                n[++t] = [e, e];
              }),
              n
            );
          }
          function on(e) {
            return Kt(e)
              ? (function (e) {
                  for (var t = (He.lastIndex = 0); He.test(e); ) ++t;
                  return t;
                })(e)
              : kt(e);
          }
          function sn(e) {
            return Kt(e)
              ? (function (e) {
                  return e.match(He) || [];
                })(e)
              : (function (e) {
                  return e.split("");
                })(e);
          }
          function an(e) {
            for (var t = e.length; t-- && ie.test(e.charAt(t)); );
            return t;
          }
          var un = Lt({
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&quot;": '"',
              "&#39;": "'",
            }),
            ln = (function e(t) {
              var n,
                r = (t =
                  null == t ? ot : ln.defaults(ot.Object(), t, ln.pick(ot, Je)))
                  .Array,
                ie = t.Date,
                Ee = t.Error,
                Ce = t.Function,
                xe = t.Math,
                we = t.Object,
                Ae = t.RegExp,
                Se = t.String,
                _e = t.TypeError,
                Te = r.prototype,
                Fe = Ce.prototype,
                ke = we.prototype,
                Oe = t["__core-js_shared__"],
                Be = Fe.toString,
                Pe = ke.hasOwnProperty,
                Ne = 0,
                Me = (n = /[^.]+$/.exec(
                  (Oe && Oe.keys && Oe.keys.IE_PROTO) || ""
                ))
                  ? "Symbol(src)_1." + n
                  : "",
                Ie = ke.toString,
                je = Be.call(we),
                Le = ot._,
                $e = Ae(
                  "^" +
                    Be.call(Pe)
                      .replace(te, "\\$&")
                      .replace(
                        /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                        "$1.*?"
                      ) +
                    "$"
                ),
                Re = ut ? t.Buffer : i,
                ze = t.Symbol,
                Ve = t.Uint8Array,
                qe = Re ? Re.allocUnsafe : i,
                He = en(we.getPrototypeOf, we),
                Ye = we.create,
                et = ke.propertyIsEnumerable,
                rt = Te.splice,
                it = ze ? ze.isConcatSpreadable : i,
                st = ze ? ze.iterator : i,
                at = ze ? ze.toStringTag : i,
                lt = (function () {
                  try {
                    var e = lo(we, "defineProperty");
                    return e({}, "", {}), e;
                  } catch (e) {}
                })(),
                ct = t.clearTimeout !== ot.clearTimeout && t.clearTimeout,
                kt = ie && ie.now !== ot.Date.now && ie.now,
                Lt = t.setTimeout !== ot.setTimeout && t.setTimeout,
                cn = xe.ceil,
                pn = xe.floor,
                fn = we.getOwnPropertySymbols,
                dn = Re ? Re.isBuffer : i,
                hn = t.isFinite,
                mn = Te.join,
                gn = en(we.keys, we),
                yn = xe.max,
                vn = xe.min,
                Dn = ie.now,
                bn = t.parseInt,
                En = xe.random,
                Cn = Te.reverse,
                xn = lo(t, "DataView"),
                wn = lo(t, "Map"),
                An = lo(t, "Promise"),
                Sn = lo(t, "Set"),
                _n = lo(t, "WeakMap"),
                Tn = lo(we, "create"),
                Fn = _n && new _n(),
                kn = {},
                On = $o(xn),
                Bn = $o(wn),
                Pn = $o(An),
                Nn = $o(Sn),
                Mn = $o(_n),
                In = ze ? ze.prototype : i,
                jn = In ? In.valueOf : i,
                Ln = In ? In.toString : i;
              function $n(e) {
                if (na(e) && !Us(e) && !(e instanceof qn)) {
                  if (e instanceof Vn) return e;
                  if (Pe.call(e, "__wrapped__")) return Ro(e);
                }
                return new Vn(e);
              }
              var Rn = (function () {
                function e() {}
                return function (t) {
                  if (!ta(t)) return {};
                  if (Ye) return Ye(t);
                  e.prototype = t;
                  var n = new e();
                  return (e.prototype = i), n;
                };
              })();
              function zn() {}
              function Vn(e, t) {
                (this.__wrapped__ = e),
                  (this.__actions__ = []),
                  (this.__chain__ = !!t),
                  (this.__index__ = 0),
                  (this.__values__ = i);
              }
              function qn(e) {
                (this.__wrapped__ = e),
                  (this.__actions__ = []),
                  (this.__dir__ = 1),
                  (this.__filtered__ = !1),
                  (this.__iteratees__ = []),
                  (this.__takeCount__ = d),
                  (this.__views__ = []);
              }
              function Wn(e) {
                var t = -1,
                  n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n; ) {
                  var r = e[t];
                  this.set(r[0], r[1]);
                }
              }
              function Un(e) {
                var t = -1,
                  n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n; ) {
                  var r = e[t];
                  this.set(r[0], r[1]);
                }
              }
              function Hn(e) {
                var t = -1,
                  n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n; ) {
                  var r = e[t];
                  this.set(r[0], r[1]);
                }
              }
              function Gn(e) {
                var t = -1,
                  n = null == e ? 0 : e.length;
                for (this.__data__ = new Hn(); ++t < n; ) this.add(e[t]);
              }
              function Yn(e) {
                var t = (this.__data__ = new Un(e));
                this.size = t.size;
              }
              function Xn(e, t) {
                var n = Us(e),
                  r = !n && Ws(e),
                  i = !n && !r && Xs(e),
                  o = !n && !r && !i && ca(e),
                  s = n || r || i || o,
                  a = s ? zt(e.length, Se) : [],
                  u = a.length;
                for (var l in e)
                  (!t && !Pe.call(e, l)) ||
                    (s &&
                      ("length" == l ||
                        (i && ("offset" == l || "parent" == l)) ||
                        (o &&
                          ("buffer" == l ||
                            "byteLength" == l ||
                            "byteOffset" == l)) ||
                        yo(l, u))) ||
                    a.push(l);
                return a;
              }
              function Jn(e) {
                var t = e.length;
                return t ? e[Hr(0, t - 1)] : i;
              }
              function Zn(e, t) {
                return No(_i(e), sr(t, 0, e.length));
              }
              function Kn(e) {
                return No(_i(e));
              }
              function Qn(e, t, n) {
                ((n !== i && !zs(e[t], n)) || (n === i && !(t in e))) &&
                  ir(e, t, n);
              }
              function er(e, t, n) {
                var r = e[t];
                (Pe.call(e, t) && zs(r, n) && (n !== i || t in e)) ||
                  ir(e, t, n);
              }
              function tr(e, t) {
                for (var n = e.length; n--; ) if (zs(e[n][0], t)) return n;
                return -1;
              }
              function nr(e, t, n, r) {
                return (
                  pr(e, function (e, i, o) {
                    t(r, e, n(e), o);
                  }),
                  r
                );
              }
              function rr(e, t) {
                return e && Ti(t, Ba(t), e);
              }
              function ir(e, t, n) {
                "__proto__" == t && lt
                  ? lt(e, t, {
                      configurable: !0,
                      enumerable: !0,
                      value: n,
                      writable: !0,
                    })
                  : (e[t] = n);
              }
              function or(e, t) {
                for (
                  var n = -1, o = t.length, s = r(o), a = null == e;
                  ++n < o;

                )
                  s[n] = a ? i : _a(e, t[n]);
                return s;
              }
              function sr(e, t, n) {
                return (
                  e == e &&
                    (n !== i && (e = e <= n ? e : n),
                    t !== i && (e = e >= t ? e : t)),
                  e
                );
              }
              function ar(e, t, n, r, o, s) {
                var a,
                  u = 1 & t,
                  l = 2 & t,
                  c = 4 & t;
                if ((n && (a = o ? n(e, r, o, s) : n(e)), a !== i)) return a;
                if (!ta(e)) return e;
                var p = Us(e);
                if (p) {
                  if (
                    ((a = (function (e) {
                      var t = e.length,
                        n = new e.constructor(t);
                      return (
                        t &&
                          "string" == typeof e[0] &&
                          Pe.call(e, "index") &&
                          ((n.index = e.index), (n.input = e.input)),
                        n
                      );
                    })(e)),
                    !u)
                  )
                    return _i(e, a);
                } else {
                  var f = fo(e),
                    d = f == b || f == E;
                  if (Xs(e)) return Ei(e, u);
                  if (f == w || f == m || (d && !o)) {
                    if (((a = l || d ? {} : mo(e)), !u))
                      return l
                        ? (function (e, t) {
                            return Ti(e, po(e), t);
                          })(
                            e,
                            (function (e, t) {
                              return e && Ti(t, Pa(t), e);
                            })(a, e)
                          )
                        : (function (e, t) {
                            return Ti(e, co(e), t);
                          })(e, rr(a, e));
                  } else {
                    if (!Qe[f]) return o ? e : {};
                    a = (function (e, t, n) {
                      var r,
                        i = e.constructor;
                      switch (t) {
                        case O:
                          return Ci(e);
                        case y:
                        case v:
                          return new i(+e);
                        case B:
                          return (function (e, t) {
                            var n = t ? Ci(e.buffer) : e.buffer;
                            return new e.constructor(
                              n,
                              e.byteOffset,
                              e.byteLength
                            );
                          })(e, n);
                        case P:
                        case N:
                        case M:
                        case I:
                        case j:
                        case L:
                        case $:
                        case R:
                        case z:
                          return xi(e, n);
                        case C:
                          return new i();
                        case x:
                        case T:
                          return new i(e);
                        case S:
                          return (function (e) {
                            var t = new e.constructor(e.source, fe.exec(e));
                            return (t.lastIndex = e.lastIndex), t;
                          })(e);
                        case _:
                          return new i();
                        case F:
                          return (r = e), jn ? we(jn.call(r)) : {};
                      }
                    })(e, f, u);
                  }
                }
                s || (s = new Yn());
                var h = s.get(e);
                if (h) return h;
                s.set(e, a),
                  aa(e)
                    ? e.forEach(function (r) {
                        a.add(ar(r, t, n, r, e, s));
                      })
                    : ra(e) &&
                      e.forEach(function (r, i) {
                        a.set(i, ar(r, t, n, i, e, s));
                      });
                var g = p ? i : (c ? (l ? no : to) : l ? Pa : Ba)(e);
                return (
                  Dt(g || e, function (r, i) {
                    g && (r = e[(i = r)]), er(a, i, ar(r, t, n, i, e, s));
                  }),
                  a
                );
              }
              function ur(e, t, n) {
                var r = n.length;
                if (null == e) return !r;
                for (e = we(e); r--; ) {
                  var o = n[r],
                    s = t[o],
                    a = e[o];
                  if ((a === i && !(o in e)) || !s(a)) return !1;
                }
                return !0;
              }
              function lr(e, t, n) {
                if ("function" != typeof e) throw new _e(o);
                return ko(function () {
                  e.apply(i, n);
                }, t);
              }
              function cr(e, t, n, r) {
                var i = -1,
                  o = xt,
                  s = !0,
                  a = e.length,
                  u = [],
                  l = t.length;
                if (!a) return u;
                n && (t = At(t, qt(n))),
                  r
                    ? ((o = wt), (s = !1))
                    : t.length >= 200 && ((o = Ut), (s = !1), (t = new Gn(t)));
                e: for (; ++i < a; ) {
                  var c = e[i],
                    p = null == n ? c : n(c);
                  if (((c = r || 0 !== c ? c : 0), s && p == p)) {
                    for (var f = l; f--; ) if (t[f] === p) continue e;
                    u.push(c);
                  } else o(t, p, r) || u.push(c);
                }
                return u;
              }
              ($n.templateSettings = {
                escape: X,
                evaluate: J,
                interpolate: Z,
                variable: "",
                imports: { _: $n },
              }),
                ($n.prototype = zn.prototype),
                ($n.prototype.constructor = $n),
                (Vn.prototype = Rn(zn.prototype)),
                (Vn.prototype.constructor = Vn),
                (qn.prototype = Rn(zn.prototype)),
                (qn.prototype.constructor = qn),
                (Wn.prototype.clear = function () {
                  (this.__data__ = Tn ? Tn(null) : {}), (this.size = 0);
                }),
                (Wn.prototype.delete = function (e) {
                  var t = this.has(e) && delete this.__data__[e];
                  return (this.size -= t ? 1 : 0), t;
                }),
                (Wn.prototype.get = function (e) {
                  var t = this.__data__;
                  if (Tn) {
                    var n = t[e];
                    return n === s ? i : n;
                  }
                  return Pe.call(t, e) ? t[e] : i;
                }),
                (Wn.prototype.has = function (e) {
                  var t = this.__data__;
                  return Tn ? t[e] !== i : Pe.call(t, e);
                }),
                (Wn.prototype.set = function (e, t) {
                  var n = this.__data__;
                  return (
                    (this.size += this.has(e) ? 0 : 1),
                    (n[e] = Tn && t === i ? s : t),
                    this
                  );
                }),
                (Un.prototype.clear = function () {
                  (this.__data__ = []), (this.size = 0);
                }),
                (Un.prototype.delete = function (e) {
                  var t = this.__data__,
                    n = tr(t, e);
                  return !(
                    n < 0 ||
                    (n == t.length - 1 ? t.pop() : rt.call(t, n, 1),
                    --this.size,
                    0)
                  );
                }),
                (Un.prototype.get = function (e) {
                  var t = this.__data__,
                    n = tr(t, e);
                  return n < 0 ? i : t[n][1];
                }),
                (Un.prototype.has = function (e) {
                  return tr(this.__data__, e) > -1;
                }),
                (Un.prototype.set = function (e, t) {
                  var n = this.__data__,
                    r = tr(n, e);
                  return (
                    r < 0 ? (++this.size, n.push([e, t])) : (n[r][1] = t), this
                  );
                }),
                (Hn.prototype.clear = function () {
                  (this.size = 0),
                    (this.__data__ = {
                      hash: new Wn(),
                      map: new (wn || Un)(),
                      string: new Wn(),
                    });
                }),
                (Hn.prototype.delete = function (e) {
                  var t = ao(this, e).delete(e);
                  return (this.size -= t ? 1 : 0), t;
                }),
                (Hn.prototype.get = function (e) {
                  return ao(this, e).get(e);
                }),
                (Hn.prototype.has = function (e) {
                  return ao(this, e).has(e);
                }),
                (Hn.prototype.set = function (e, t) {
                  var n = ao(this, e),
                    r = n.size;
                  return n.set(e, t), (this.size += n.size == r ? 0 : 1), this;
                }),
                (Gn.prototype.add = Gn.prototype.push =
                  function (e) {
                    return this.__data__.set(e, s), this;
                  }),
                (Gn.prototype.has = function (e) {
                  return this.__data__.has(e);
                }),
                (Yn.prototype.clear = function () {
                  (this.__data__ = new Un()), (this.size = 0);
                }),
                (Yn.prototype.delete = function (e) {
                  var t = this.__data__,
                    n = t.delete(e);
                  return (this.size = t.size), n;
                }),
                (Yn.prototype.get = function (e) {
                  return this.__data__.get(e);
                }),
                (Yn.prototype.has = function (e) {
                  return this.__data__.has(e);
                }),
                (Yn.prototype.set = function (e, t) {
                  var n = this.__data__;
                  if (n instanceof Un) {
                    var r = n.__data__;
                    if (!wn || r.length < 199)
                      return r.push([e, t]), (this.size = ++n.size), this;
                    n = this.__data__ = new Hn(r);
                  }
                  return n.set(e, t), (this.size = n.size), this;
                });
              var pr = Oi(Dr),
                fr = Oi(br, !0);
              function dr(e, t) {
                var n = !0;
                return (
                  pr(e, function (e, r, i) {
                    return (n = !!t(e, r, i));
                  }),
                  n
                );
              }
              function hr(e, t, n) {
                for (var r = -1, o = e.length; ++r < o; ) {
                  var s = e[r],
                    a = t(s);
                  if (null != a && (u === i ? a == a && !la(a) : n(a, u)))
                    var u = a,
                      l = s;
                }
                return l;
              }
              function mr(e, t) {
                var n = [];
                return (
                  pr(e, function (e, r, i) {
                    t(e, r, i) && n.push(e);
                  }),
                  n
                );
              }
              function gr(e, t, n, r, i) {
                var o = -1,
                  s = e.length;
                for (n || (n = go), i || (i = []); ++o < s; ) {
                  var a = e[o];
                  t > 0 && n(a)
                    ? t > 1
                      ? gr(a, t - 1, n, r, i)
                      : St(i, a)
                    : r || (i[i.length] = a);
                }
                return i;
              }
              var yr = Bi(),
                vr = Bi(!0);
              function Dr(e, t) {
                return e && yr(e, t, Ba);
              }
              function br(e, t) {
                return e && vr(e, t, Ba);
              }
              function Er(e, t) {
                return Ct(t, function (t) {
                  return Ks(e[t]);
                });
              }
              function Cr(e, t) {
                for (var n = 0, r = (t = yi(t, e)).length; null != e && n < r; )
                  e = e[Lo(t[n++])];
                return n && n == r ? e : i;
              }
              function xr(e, t, n) {
                var r = t(e);
                return Us(e) ? r : St(r, n(e));
              }
              function wr(e) {
                return null == e
                  ? e === i
                    ? "[object Undefined]"
                    : "[object Null]"
                  : at && at in we(e)
                  ? (function (e) {
                      var t = Pe.call(e, at),
                        n = e[at];
                      try {
                        e[at] = i;
                        var r = !0;
                      } catch (e) {}
                      var o = Ie.call(e);
                      return r && (t ? (e[at] = n) : delete e[at]), o;
                    })(e)
                  : (function (e) {
                      return Ie.call(e);
                    })(e);
              }
              function Ar(e, t) {
                return e > t;
              }
              function Sr(e, t) {
                return null != e && Pe.call(e, t);
              }
              function _r(e, t) {
                return null != e && t in we(e);
              }
              function Tr(e, t, n) {
                for (
                  var o = n ? wt : xt,
                    s = e[0].length,
                    a = e.length,
                    u = a,
                    l = r(a),
                    c = 1 / 0,
                    p = [];
                  u--;

                ) {
                  var f = e[u];
                  u && t && (f = At(f, qt(t))),
                    (c = vn(f.length, c)),
                    (l[u] =
                      !n && (t || (s >= 120 && f.length >= 120))
                        ? new Gn(u && f)
                        : i);
                }
                f = e[0];
                var d = -1,
                  h = l[0];
                e: for (; ++d < s && p.length < c; ) {
                  var m = f[d],
                    g = t ? t(m) : m;
                  if (
                    ((m = n || 0 !== m ? m : 0), !(h ? Ut(h, g) : o(p, g, n)))
                  ) {
                    for (u = a; --u; ) {
                      var y = l[u];
                      if (!(y ? Ut(y, g) : o(e[u], g, n))) continue e;
                    }
                    h && h.push(g), p.push(m);
                  }
                }
                return p;
              }
              function Fr(e, t, n) {
                var r = null == (e = So(e, (t = yi(t, e)))) ? e : e[Lo(Zo(t))];
                return null == r ? i : yt(r, e, n);
              }
              function kr(e) {
                return na(e) && wr(e) == m;
              }
              function Or(e, t, n, r, o) {
                return (
                  e === t ||
                  (null == e || null == t || (!na(e) && !na(t))
                    ? e != e && t != t
                    : (function (e, t, n, r, o, s) {
                        var a = Us(e),
                          u = Us(t),
                          l = a ? g : fo(e),
                          c = u ? g : fo(t),
                          p = (l = l == m ? w : l) == w,
                          f = (c = c == m ? w : c) == w,
                          d = l == c;
                        if (d && Xs(e)) {
                          if (!Xs(t)) return !1;
                          (a = !0), (p = !1);
                        }
                        if (d && !p)
                          return (
                            s || (s = new Yn()),
                            a || ca(e)
                              ? Qi(e, t, n, r, o, s)
                              : (function (e, t, n, r, i, o, s) {
                                  switch (n) {
                                    case B:
                                      if (
                                        e.byteLength != t.byteLength ||
                                        e.byteOffset != t.byteOffset
                                      )
                                        return !1;
                                      (e = e.buffer), (t = t.buffer);
                                    case O:
                                      return !(
                                        e.byteLength != t.byteLength ||
                                        !o(new Ve(e), new Ve(t))
                                      );
                                    case y:
                                    case v:
                                    case x:
                                      return zs(+e, +t);
                                    case D:
                                      return (
                                        e.name == t.name &&
                                        e.message == t.message
                                      );
                                    case S:
                                    case T:
                                      return e == t + "";
                                    case C:
                                      var a = Qt;
                                    case _:
                                      var u = 1 & r;
                                      if (
                                        (a || (a = nn), e.size != t.size && !u)
                                      )
                                        return !1;
                                      var l = s.get(e);
                                      if (l) return l == t;
                                      (r |= 2), s.set(e, t);
                                      var c = Qi(a(e), a(t), r, i, o, s);
                                      return s.delete(e), c;
                                    case F:
                                      if (jn) return jn.call(e) == jn.call(t);
                                  }
                                  return !1;
                                })(e, t, l, n, r, o, s)
                          );
                        if (!(1 & n)) {
                          var h = p && Pe.call(e, "__wrapped__"),
                            b = f && Pe.call(t, "__wrapped__");
                          if (h || b) {
                            var E = h ? e.value() : e,
                              A = b ? t.value() : t;
                            return s || (s = new Yn()), o(E, A, n, r, s);
                          }
                        }
                        return (
                          !!d &&
                          (s || (s = new Yn()),
                          (function (e, t, n, r, o, s) {
                            var a = 1 & n,
                              u = to(e),
                              l = u.length;
                            if (l != to(t).length && !a) return !1;
                            for (var c = l; c--; ) {
                              var p = u[c];
                              if (!(a ? p in t : Pe.call(t, p))) return !1;
                            }
                            var f = s.get(e),
                              d = s.get(t);
                            if (f && d) return f == t && d == e;
                            var h = !0;
                            s.set(e, t), s.set(t, e);
                            for (var m = a; ++c < l; ) {
                              var g = e[(p = u[c])],
                                y = t[p];
                              if (r)
                                var v = a
                                  ? r(y, g, p, t, e, s)
                                  : r(g, y, p, e, t, s);
                              if (
                                !(v === i ? g === y || o(g, y, n, r, s) : v)
                              ) {
                                h = !1;
                                break;
                              }
                              m || (m = "constructor" == p);
                            }
                            if (h && !m) {
                              var D = e.constructor,
                                b = t.constructor;
                              D == b ||
                                !("constructor" in e) ||
                                !("constructor" in t) ||
                                ("function" == typeof D &&
                                  D instanceof D &&
                                  "function" == typeof b &&
                                  b instanceof b) ||
                                (h = !1);
                            }
                            return s.delete(e), s.delete(t), h;
                          })(e, t, n, r, o, s))
                        );
                      })(e, t, n, r, Or, o))
                );
              }
              function Br(e, t, n, r) {
                var o = n.length,
                  s = o,
                  a = !r;
                if (null == e) return !s;
                for (e = we(e); o--; ) {
                  var u = n[o];
                  if (a && u[2] ? u[1] !== e[u[0]] : !(u[0] in e)) return !1;
                }
                for (; ++o < s; ) {
                  var l = (u = n[o])[0],
                    c = e[l],
                    p = u[1];
                  if (a && u[2]) {
                    if (c === i && !(l in e)) return !1;
                  } else {
                    var f = new Yn();
                    if (r) var d = r(c, p, l, e, t, f);
                    if (!(d === i ? Or(p, c, 3, r, f) : d)) return !1;
                  }
                }
                return !0;
              }
              function Pr(e) {
                return (
                  !(!ta(e) || ((t = e), Me && Me in t)) &&
                  (Ks(e) ? $e : me).test($o(e))
                );
                var t;
              }
              function Nr(e) {
                return "function" == typeof e
                  ? e
                  : null == e
                  ? iu
                  : "object" == typeof e
                  ? Us(e)
                    ? $r(e[0], e[1])
                    : Lr(e)
                  : du(e);
              }
              function Mr(e) {
                if (!Co(e)) return gn(e);
                var t = [];
                for (var n in we(e))
                  Pe.call(e, n) && "constructor" != n && t.push(n);
                return t;
              }
              function Ir(e, t) {
                return e < t;
              }
              function jr(e, t) {
                var n = -1,
                  i = Gs(e) ? r(e.length) : [];
                return (
                  pr(e, function (e, r, o) {
                    i[++n] = t(e, r, o);
                  }),
                  i
                );
              }
              function Lr(e) {
                var t = uo(e);
                return 1 == t.length && t[0][2]
                  ? wo(t[0][0], t[0][1])
                  : function (n) {
                      return n === e || Br(n, e, t);
                    };
              }
              function $r(e, t) {
                return Do(e) && xo(t)
                  ? wo(Lo(e), t)
                  : function (n) {
                      var r = _a(n, e);
                      return r === i && r === t ? Ta(n, e) : Or(t, r, 3);
                    };
              }
              function Rr(e, t, n, r, o) {
                e !== t &&
                  yr(
                    t,
                    function (s, a) {
                      if ((o || (o = new Yn()), ta(s)))
                        !(function (e, t, n, r, o, s, a) {
                          var u = To(e, n),
                            l = To(t, n),
                            c = a.get(l);
                          if (c) Qn(e, n, c);
                          else {
                            var p = s ? s(u, l, n + "", e, t, a) : i,
                              f = p === i;
                            if (f) {
                              var d = Us(l),
                                h = !d && Xs(l),
                                m = !d && !h && ca(l);
                              (p = l),
                                d || h || m
                                  ? Us(u)
                                    ? (p = u)
                                    : Ys(u)
                                    ? (p = _i(u))
                                    : h
                                    ? ((f = !1), (p = Ei(l, !0)))
                                    : m
                                    ? ((f = !1), (p = xi(l, !0)))
                                    : (p = [])
                                  : oa(l) || Ws(l)
                                  ? ((p = u),
                                    Ws(u)
                                      ? (p = va(u))
                                      : (ta(u) && !Ks(u)) || (p = mo(l)))
                                  : (f = !1);
                            }
                            f && (a.set(l, p), o(p, l, r, s, a), a.delete(l)),
                              Qn(e, n, p);
                          }
                        })(e, t, a, n, Rr, r, o);
                      else {
                        var u = r ? r(To(e, a), s, a + "", e, t, o) : i;
                        u === i && (u = s), Qn(e, a, u);
                      }
                    },
                    Pa
                  );
              }
              function zr(e, t) {
                var n = e.length;
                if (n) return yo((t += t < 0 ? n : 0), n) ? e[t] : i;
              }
              function Vr(e, t, n) {
                t = t.length
                  ? At(t, function (e) {
                      return Us(e)
                        ? function (t) {
                            return Cr(t, 1 === e.length ? e[0] : e);
                          }
                        : e;
                    })
                  : [iu];
                var r = -1;
                t = At(t, qt(so()));
                var i = jr(e, function (e, n, i) {
                  var o = At(t, function (t) {
                    return t(e);
                  });
                  return { criteria: o, index: ++r, value: e };
                });
                return (function (e, t) {
                  var r = e.length;
                  for (
                    e.sort(function (e, t) {
                      return (function (e, t, n) {
                        for (
                          var r = -1,
                            i = e.criteria,
                            o = t.criteria,
                            s = i.length,
                            a = n.length;
                          ++r < s;

                        ) {
                          var u = wi(i[r], o[r]);
                          if (u)
                            return r >= a ? u : u * ("desc" == n[r] ? -1 : 1);
                        }
                        return e.index - t.index;
                      })(e, t, n);
                    });
                    r--;

                  )
                    e[r] = e[r].value;
                  return e;
                })(i);
              }
              function qr(e, t, n) {
                for (var r = -1, i = t.length, o = {}; ++r < i; ) {
                  var s = t[r],
                    a = Cr(e, s);
                  n(a, s) && Zr(o, yi(s, e), a);
                }
                return o;
              }
              function Wr(e, t, n, r) {
                var i = r ? Nt : Pt,
                  o = -1,
                  s = t.length,
                  a = e;
                for (e === t && (t = _i(t)), n && (a = At(e, qt(n))); ++o < s; )
                  for (
                    var u = 0, l = t[o], c = n ? n(l) : l;
                    (u = i(a, c, u, r)) > -1;

                  )
                    a !== e && rt.call(a, u, 1), rt.call(e, u, 1);
                return e;
              }
              function Ur(e, t) {
                for (var n = e ? t.length : 0, r = n - 1; n--; ) {
                  var i = t[n];
                  if (n == r || i !== o) {
                    var o = i;
                    yo(i) ? rt.call(e, i, 1) : li(e, i);
                  }
                }
                return e;
              }
              function Hr(e, t) {
                return e + pn(En() * (t - e + 1));
              }
              function Gr(e, t) {
                var n = "";
                if (!e || t < 1 || t > p) return n;
                do {
                  t % 2 && (n += e), (t = pn(t / 2)) && (e += e);
                } while (t);
                return n;
              }
              function Yr(e, t) {
                return Oo(Ao(e, t, iu), e + "");
              }
              function Xr(e) {
                return Jn(za(e));
              }
              function Jr(e, t) {
                var n = za(e);
                return No(n, sr(t, 0, n.length));
              }
              function Zr(e, t, n, r) {
                if (!ta(e)) return e;
                for (
                  var o = -1, s = (t = yi(t, e)).length, a = s - 1, u = e;
                  null != u && ++o < s;

                ) {
                  var l = Lo(t[o]),
                    c = n;
                  if (
                    "__proto__" === l ||
                    "constructor" === l ||
                    "prototype" === l
                  )
                    return e;
                  if (o != a) {
                    var p = u[l];
                    (c = r ? r(p, l, u) : i) === i &&
                      (c = ta(p) ? p : yo(t[o + 1]) ? [] : {});
                  }
                  er(u, l, c), (u = u[l]);
                }
                return e;
              }
              var Kr = Fn
                  ? function (e, t) {
                      return Fn.set(e, t), e;
                    }
                  : iu,
                Qr = lt
                  ? function (e, t) {
                      return lt(e, "toString", {
                        configurable: !0,
                        enumerable: !1,
                        value: tu(t),
                        writable: !0,
                      });
                    }
                  : iu;
              function ei(e) {
                return No(za(e));
              }
              function ti(e, t, n) {
                var i = -1,
                  o = e.length;
                t < 0 && (t = -t > o ? 0 : o + t),
                  (n = n > o ? o : n) < 0 && (n += o),
                  (o = t > n ? 0 : (n - t) >>> 0),
                  (t >>>= 0);
                for (var s = r(o); ++i < o; ) s[i] = e[i + t];
                return s;
              }
              function ni(e, t) {
                var n;
                return (
                  pr(e, function (e, r, i) {
                    return !(n = t(e, r, i));
                  }),
                  !!n
                );
              }
              function ri(e, t, n) {
                var r = 0,
                  i = null == e ? r : e.length;
                if ("number" == typeof t && t == t && i <= 2147483647) {
                  for (; r < i; ) {
                    var o = (r + i) >>> 1,
                      s = e[o];
                    null !== s && !la(s) && (n ? s <= t : s < t)
                      ? (r = o + 1)
                      : (i = o);
                  }
                  return i;
                }
                return ii(e, t, iu, n);
              }
              function ii(e, t, n, r) {
                var o = 0,
                  s = null == e ? 0 : e.length;
                if (0 === s) return 0;
                for (
                  var a = (t = n(t)) != t,
                    u = null === t,
                    l = la(t),
                    c = t === i;
                  o < s;

                ) {
                  var p = pn((o + s) / 2),
                    f = n(e[p]),
                    d = f !== i,
                    h = null === f,
                    m = f == f,
                    g = la(f);
                  if (a) var y = r || m;
                  else
                    y = c
                      ? m && (r || d)
                      : u
                      ? m && d && (r || !h)
                      : l
                      ? m && d && !h && (r || !g)
                      : !h && !g && (r ? f <= t : f < t);
                  y ? (o = p + 1) : (s = p);
                }
                return vn(s, 4294967294);
              }
              function oi(e, t) {
                for (var n = -1, r = e.length, i = 0, o = []; ++n < r; ) {
                  var s = e[n],
                    a = t ? t(s) : s;
                  if (!n || !zs(a, u)) {
                    var u = a;
                    o[i++] = 0 === s ? 0 : s;
                  }
                }
                return o;
              }
              function si(e) {
                return "number" == typeof e ? e : la(e) ? f : +e;
              }
              function ai(e) {
                if ("string" == typeof e) return e;
                if (Us(e)) return At(e, ai) + "";
                if (la(e)) return Ln ? Ln.call(e) : "";
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
              }
              function ui(e, t, n) {
                var r = -1,
                  i = xt,
                  o = e.length,
                  s = !0,
                  a = [],
                  u = a;
                if (n) (s = !1), (i = wt);
                else if (o >= 200) {
                  var l = t ? null : Gi(e);
                  if (l) return nn(l);
                  (s = !1), (i = Ut), (u = new Gn());
                } else u = t ? [] : a;
                e: for (; ++r < o; ) {
                  var c = e[r],
                    p = t ? t(c) : c;
                  if (((c = n || 0 !== c ? c : 0), s && p == p)) {
                    for (var f = u.length; f--; ) if (u[f] === p) continue e;
                    t && u.push(p), a.push(c);
                  } else i(u, p, n) || (u !== a && u.push(p), a.push(c));
                }
                return a;
              }
              function li(e, t) {
                return (
                  null == (e = So(e, (t = yi(t, e)))) || delete e[Lo(Zo(t))]
                );
              }
              function ci(e, t, n, r) {
                return Zr(e, t, n(Cr(e, t)), r);
              }
              function pi(e, t, n, r) {
                for (
                  var i = e.length, o = r ? i : -1;
                  (r ? o-- : ++o < i) && t(e[o], o, e);

                );
                return n
                  ? ti(e, r ? 0 : o, r ? o + 1 : i)
                  : ti(e, r ? o + 1 : 0, r ? i : o);
              }
              function fi(e, t) {
                var n = e;
                return (
                  n instanceof qn && (n = n.value()),
                  _t(
                    t,
                    function (e, t) {
                      return t.func.apply(t.thisArg, St([e], t.args));
                    },
                    n
                  )
                );
              }
              function di(e, t, n) {
                var i = e.length;
                if (i < 2) return i ? ui(e[0]) : [];
                for (var o = -1, s = r(i); ++o < i; )
                  for (var a = e[o], u = -1; ++u < i; )
                    u != o && (s[o] = cr(s[o] || a, e[u], t, n));
                return ui(gr(s, 1), t, n);
              }
              function hi(e, t, n) {
                for (
                  var r = -1, o = e.length, s = t.length, a = {};
                  ++r < o;

                ) {
                  var u = r < s ? t[r] : i;
                  n(a, e[r], u);
                }
                return a;
              }
              function mi(e) {
                return Ys(e) ? e : [];
              }
              function gi(e) {
                return "function" == typeof e ? e : iu;
              }
              function yi(e, t) {
                return Us(e) ? e : Do(e, t) ? [e] : jo(Da(e));
              }
              var vi = Yr;
              function Di(e, t, n) {
                var r = e.length;
                return (n = n === i ? r : n), !t && n >= r ? e : ti(e, t, n);
              }
              var bi =
                ct ||
                function (e) {
                  return ot.clearTimeout(e);
                };
              function Ei(e, t) {
                if (t) return e.slice();
                var n = e.length,
                  r = qe ? qe(n) : new e.constructor(n);
                return e.copy(r), r;
              }
              function Ci(e) {
                var t = new e.constructor(e.byteLength);
                return new Ve(t).set(new Ve(e)), t;
              }
              function xi(e, t) {
                var n = t ? Ci(e.buffer) : e.buffer;
                return new e.constructor(n, e.byteOffset, e.length);
              }
              function wi(e, t) {
                if (e !== t) {
                  var n = e !== i,
                    r = null === e,
                    o = e == e,
                    s = la(e),
                    a = t !== i,
                    u = null === t,
                    l = t == t,
                    c = la(t);
                  if (
                    (!u && !c && !s && e > t) ||
                    (s && a && l && !u && !c) ||
                    (r && a && l) ||
                    (!n && l) ||
                    !o
                  )
                    return 1;
                  if (
                    (!r && !s && !c && e < t) ||
                    (c && n && o && !r && !s) ||
                    (u && n && o) ||
                    (!a && o) ||
                    !l
                  )
                    return -1;
                }
                return 0;
              }
              function Ai(e, t, n, i) {
                for (
                  var o = -1,
                    s = e.length,
                    a = n.length,
                    u = -1,
                    l = t.length,
                    c = yn(s - a, 0),
                    p = r(l + c),
                    f = !i;
                  ++u < l;

                )
                  p[u] = t[u];
                for (; ++o < a; ) (f || o < s) && (p[n[o]] = e[o]);
                for (; c--; ) p[u++] = e[o++];
                return p;
              }
              function Si(e, t, n, i) {
                for (
                  var o = -1,
                    s = e.length,
                    a = -1,
                    u = n.length,
                    l = -1,
                    c = t.length,
                    p = yn(s - u, 0),
                    f = r(p + c),
                    d = !i;
                  ++o < p;

                )
                  f[o] = e[o];
                for (var h = o; ++l < c; ) f[h + l] = t[l];
                for (; ++a < u; ) (d || o < s) && (f[h + n[a]] = e[o++]);
                return f;
              }
              function _i(e, t) {
                var n = -1,
                  i = e.length;
                for (t || (t = r(i)); ++n < i; ) t[n] = e[n];
                return t;
              }
              function Ti(e, t, n, r) {
                var o = !n;
                n || (n = {});
                for (var s = -1, a = t.length; ++s < a; ) {
                  var u = t[s],
                    l = r ? r(n[u], e[u], u, n, e) : i;
                  l === i && (l = e[u]), o ? ir(n, u, l) : er(n, u, l);
                }
                return n;
              }
              function Fi(e, t) {
                return function (n, r) {
                  var i = Us(n) ? vt : nr,
                    o = t ? t() : {};
                  return i(n, e, so(r, 2), o);
                };
              }
              function ki(e) {
                return Yr(function (t, n) {
                  var r = -1,
                    o = n.length,
                    s = o > 1 ? n[o - 1] : i,
                    a = o > 2 ? n[2] : i;
                  for (
                    s = e.length > 3 && "function" == typeof s ? (o--, s) : i,
                      a && vo(n[0], n[1], a) && ((s = o < 3 ? i : s), (o = 1)),
                      t = we(t);
                    ++r < o;

                  ) {
                    var u = n[r];
                    u && e(t, u, r, s);
                  }
                  return t;
                });
              }
              function Oi(e, t) {
                return function (n, r) {
                  if (null == n) return n;
                  if (!Gs(n)) return e(n, r);
                  for (
                    var i = n.length, o = t ? i : -1, s = we(n);
                    (t ? o-- : ++o < i) && !1 !== r(s[o], o, s);

                  );
                  return n;
                };
              }
              function Bi(e) {
                return function (t, n, r) {
                  for (var i = -1, o = we(t), s = r(t), a = s.length; a--; ) {
                    var u = s[e ? a : ++i];
                    if (!1 === n(o[u], u, o)) break;
                  }
                  return t;
                };
              }
              function Pi(e) {
                return function (t) {
                  var n = Kt((t = Da(t))) ? sn(t) : i,
                    r = n ? n[0] : t.charAt(0),
                    o = n ? Di(n, 1).join("") : t.slice(1);
                  return r[e]() + o;
                };
              }
              function Ni(e) {
                return function (t) {
                  return _t(Ka(Wa(t).replace(We, "")), e, "");
                };
              }
              function Mi(e) {
                return function () {
                  var t = arguments;
                  switch (t.length) {
                    case 0:
                      return new e();
                    case 1:
                      return new e(t[0]);
                    case 2:
                      return new e(t[0], t[1]);
                    case 3:
                      return new e(t[0], t[1], t[2]);
                    case 4:
                      return new e(t[0], t[1], t[2], t[3]);
                    case 5:
                      return new e(t[0], t[1], t[2], t[3], t[4]);
                    case 6:
                      return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                    case 7:
                      return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                  }
                  var n = Rn(e.prototype),
                    r = e.apply(n, t);
                  return ta(r) ? r : n;
                };
              }
              function Ii(e) {
                return function (t, n, r) {
                  var o = we(t);
                  if (!Gs(t)) {
                    var s = so(n, 3);
                    (t = Ba(t)),
                      (n = function (e) {
                        return s(o[e], e, o);
                      });
                  }
                  var a = e(t, n, r);
                  return a > -1 ? o[s ? t[a] : a] : i;
                };
              }
              function ji(e) {
                return eo(function (t) {
                  var n = t.length,
                    r = n,
                    s = Vn.prototype.thru;
                  for (e && t.reverse(); r--; ) {
                    var a = t[r];
                    if ("function" != typeof a) throw new _e(o);
                    if (s && !u && "wrapper" == io(a)) var u = new Vn([], !0);
                  }
                  for (r = u ? r : n; ++r < n; ) {
                    var l = io((a = t[r])),
                      c = "wrapper" == l ? ro(a) : i;
                    u =
                      c && bo(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9]
                        ? u[io(c[0])].apply(u, c[3])
                        : 1 == a.length && bo(a)
                        ? u[l]()
                        : u.thru(a);
                  }
                  return function () {
                    var e = arguments,
                      r = e[0];
                    if (u && 1 == e.length && Us(r)) return u.plant(r).value();
                    for (var i = 0, o = n ? t[i].apply(this, e) : r; ++i < n; )
                      o = t[i].call(this, o);
                    return o;
                  };
                });
              }
              function Li(e, t, n, o, s, a, u, c, p, f) {
                var d = t & l,
                  h = 1 & t,
                  m = 2 & t,
                  g = 24 & t,
                  y = 512 & t,
                  v = m ? i : Mi(e);
                return function i() {
                  for (var l = arguments.length, D = r(l), b = l; b--; )
                    D[b] = arguments[b];
                  if (g)
                    var E = oo(i),
                      C = Yt(D, E);
                  if (
                    (o && (D = Ai(D, o, s, g)),
                    a && (D = Si(D, a, u, g)),
                    (l -= C),
                    g && l < f)
                  ) {
                    var x = tn(D, E);
                    return Ui(e, t, Li, i.placeholder, n, D, x, c, p, f - l);
                  }
                  var w = h ? n : this,
                    A = m ? w[e] : e;
                  return (
                    (l = D.length),
                    c ? (D = _o(D, c)) : y && l > 1 && D.reverse(),
                    d && p < l && (D.length = p),
                    this &&
                      this !== ot &&
                      this instanceof i &&
                      (A = v || Mi(A)),
                    A.apply(w, D)
                  );
                };
              }
              function $i(e, t) {
                return function (n, r) {
                  return (function (e, t, n, r) {
                    return (
                      Dr(e, function (e, i, o) {
                        t(r, n(e), i, o);
                      }),
                      r
                    );
                  })(n, e, t(r), {});
                };
              }
              function Ri(e, t) {
                return function (n, r) {
                  var o;
                  if (n === i && r === i) return t;
                  if ((n !== i && (o = n), r !== i)) {
                    if (o === i) return r;
                    "string" == typeof n || "string" == typeof r
                      ? ((n = ai(n)), (r = ai(r)))
                      : ((n = si(n)), (r = si(r))),
                      (o = e(n, r));
                  }
                  return o;
                };
              }
              function zi(e) {
                return eo(function (t) {
                  return (
                    (t = At(t, qt(so()))),
                    Yr(function (n) {
                      var r = this;
                      return e(t, function (e) {
                        return yt(e, r, n);
                      });
                    })
                  );
                });
              }
              function Vi(e, t) {
                var n = (t = t === i ? " " : ai(t)).length;
                if (n < 2) return n ? Gr(t, e) : t;
                var r = Gr(t, cn(e / on(t)));
                return Kt(t) ? Di(sn(r), 0, e).join("") : r.slice(0, e);
              }
              function qi(e) {
                return function (t, n, o) {
                  return (
                    o && "number" != typeof o && vo(t, n, o) && (n = o = i),
                    (t = ha(t)),
                    n === i ? ((n = t), (t = 0)) : (n = ha(n)),
                    (function (e, t, n, i) {
                      for (
                        var o = -1, s = yn(cn((t - e) / (n || 1)), 0), a = r(s);
                        s--;

                      )
                        (a[i ? s : ++o] = e), (e += n);
                      return a;
                    })(t, n, (o = o === i ? (t < n ? 1 : -1) : ha(o)), e)
                  );
                };
              }
              function Wi(e) {
                return function (t, n) {
                  return (
                    ("string" == typeof t && "string" == typeof n) ||
                      ((t = ya(t)), (n = ya(n))),
                    e(t, n)
                  );
                };
              }
              function Ui(e, t, n, r, o, s, a, l, c, p) {
                var f = 8 & t;
                (t |= f ? u : 64), 4 & (t &= ~(f ? 64 : u)) || (t &= -4);
                var d = [
                    e,
                    t,
                    o,
                    f ? s : i,
                    f ? a : i,
                    f ? i : s,
                    f ? i : a,
                    l,
                    c,
                    p,
                  ],
                  h = n.apply(i, d);
                return bo(e) && Fo(h, d), (h.placeholder = r), Bo(h, e, t);
              }
              function Hi(e) {
                var t = xe[e];
                return function (e, n) {
                  if (
                    ((e = ya(e)), (n = null == n ? 0 : vn(ma(n), 292)) && hn(e))
                  ) {
                    var r = (Da(e) + "e").split("e");
                    return +(
                      (r = (Da(t(r[0] + "e" + (+r[1] + n))) + "e").split(
                        "e"
                      ))[0] +
                      "e" +
                      (+r[1] - n)
                    );
                  }
                  return t(e);
                };
              }
              var Gi =
                Sn && 1 / nn(new Sn([, -0]))[1] == c
                  ? function (e) {
                      return new Sn(e);
                    }
                  : lu;
              function Yi(e) {
                return function (t) {
                  var n = fo(t);
                  return n == C
                    ? Qt(t)
                    : n == _
                    ? rn(t)
                    : (function (e, t) {
                        return At(t, function (t) {
                          return [t, e[t]];
                        });
                      })(t, e(t));
                };
              }
              function Xi(e, t, n, s, c, p, f, d) {
                var h = 2 & t;
                if (!h && "function" != typeof e) throw new _e(o);
                var m = s ? s.length : 0;
                if (
                  (m || ((t &= -97), (s = c = i)),
                  (f = f === i ? f : yn(ma(f), 0)),
                  (d = d === i ? d : ma(d)),
                  (m -= c ? c.length : 0),
                  64 & t)
                ) {
                  var g = s,
                    y = c;
                  s = c = i;
                }
                var v = h ? i : ro(e),
                  D = [e, t, n, s, c, g, y, p, f, d];
                if (
                  (v &&
                    (function (e, t) {
                      var n = e[1],
                        r = t[1],
                        i = n | r,
                        o = i < 131,
                        s =
                          (r == l && 8 == n) ||
                          (r == l && 256 == n && e[7].length <= t[8]) ||
                          (384 == r && t[7].length <= t[8] && 8 == n);
                      if (!o && !s) return e;
                      1 & r && ((e[2] = t[2]), (i |= 1 & n ? 0 : 4));
                      var u = t[3];
                      if (u) {
                        var c = e[3];
                        (e[3] = c ? Ai(c, u, t[4]) : u),
                          (e[4] = c ? tn(e[3], a) : t[4]);
                      }
                      (u = t[5]) &&
                        ((c = e[5]),
                        (e[5] = c ? Si(c, u, t[6]) : u),
                        (e[6] = c ? tn(e[5], a) : t[6])),
                        (u = t[7]) && (e[7] = u),
                        r & l && (e[8] = null == e[8] ? t[8] : vn(e[8], t[8])),
                        null == e[9] && (e[9] = t[9]),
                        (e[0] = t[0]),
                        (e[1] = i);
                    })(D, v),
                  (e = D[0]),
                  (t = D[1]),
                  (n = D[2]),
                  (s = D[3]),
                  (c = D[4]),
                  !(d = D[9] =
                    D[9] === i ? (h ? 0 : e.length) : yn(D[9] - m, 0)) &&
                    24 & t &&
                    (t &= -25),
                  t && 1 != t)
                )
                  b =
                    8 == t || 16 == t
                      ? (function (e, t, n) {
                          var o = Mi(e);
                          return function s() {
                            for (
                              var a = arguments.length,
                                u = r(a),
                                l = a,
                                c = oo(s);
                              l--;

                            )
                              u[l] = arguments[l];
                            var p =
                              a < 3 && u[0] !== c && u[a - 1] !== c
                                ? []
                                : tn(u, c);
                            return (a -= p.length) < n
                              ? Ui(
                                  e,
                                  t,
                                  Li,
                                  s.placeholder,
                                  i,
                                  u,
                                  p,
                                  i,
                                  i,
                                  n - a
                                )
                              : yt(
                                  this && this !== ot && this instanceof s
                                    ? o
                                    : e,
                                  this,
                                  u
                                );
                          };
                        })(e, t, d)
                      : (t != u && 33 != t) || c.length
                      ? Li.apply(i, D)
                      : (function (e, t, n, i) {
                          var o = 1 & t,
                            s = Mi(e);
                          return function t() {
                            for (
                              var a = -1,
                                u = arguments.length,
                                l = -1,
                                c = i.length,
                                p = r(c + u),
                                f =
                                  this && this !== ot && this instanceof t
                                    ? s
                                    : e;
                              ++l < c;

                            )
                              p[l] = i[l];
                            for (; u--; ) p[l++] = arguments[++a];
                            return yt(f, o ? n : this, p);
                          };
                        })(e, t, n, s);
                else
                  var b = (function (e, t, n) {
                    var r = 1 & t,
                      i = Mi(e);
                    return function t() {
                      return (
                        this && this !== ot && this instanceof t ? i : e
                      ).apply(r ? n : this, arguments);
                    };
                  })(e, t, n);
                return Bo((v ? Kr : Fo)(b, D), e, t);
              }
              function Ji(e, t, n, r) {
                return e === i || (zs(e, ke[n]) && !Pe.call(r, n)) ? t : e;
              }
              function Zi(e, t, n, r, o, s) {
                return (
                  ta(e) &&
                    ta(t) &&
                    (s.set(t, e), Rr(e, t, i, Zi, s), s.delete(t)),
                  e
                );
              }
              function Ki(e) {
                return oa(e) ? i : e;
              }
              function Qi(e, t, n, r, o, s) {
                var a = 1 & n,
                  u = e.length,
                  l = t.length;
                if (u != l && !(a && l > u)) return !1;
                var c = s.get(e),
                  p = s.get(t);
                if (c && p) return c == t && p == e;
                var f = -1,
                  d = !0,
                  h = 2 & n ? new Gn() : i;
                for (s.set(e, t), s.set(t, e); ++f < u; ) {
                  var m = e[f],
                    g = t[f];
                  if (r) var y = a ? r(g, m, f, t, e, s) : r(m, g, f, e, t, s);
                  if (y !== i) {
                    if (y) continue;
                    d = !1;
                    break;
                  }
                  if (h) {
                    if (
                      !Ft(t, function (e, t) {
                        if (!Ut(h, t) && (m === e || o(m, e, n, r, s)))
                          return h.push(t);
                      })
                    ) {
                      d = !1;
                      break;
                    }
                  } else if (m !== g && !o(m, g, n, r, s)) {
                    d = !1;
                    break;
                  }
                }
                return s.delete(e), s.delete(t), d;
              }
              function eo(e) {
                return Oo(Ao(e, i, Ho), e + "");
              }
              function to(e) {
                return xr(e, Ba, co);
              }
              function no(e) {
                return xr(e, Pa, po);
              }
              var ro = Fn
                ? function (e) {
                    return Fn.get(e);
                  }
                : lu;
              function io(e) {
                for (
                  var t = e.name + "",
                    n = kn[t],
                    r = Pe.call(kn, t) ? n.length : 0;
                  r--;

                ) {
                  var i = n[r],
                    o = i.func;
                  if (null == o || o == e) return i.name;
                }
                return t;
              }
              function oo(e) {
                return (Pe.call($n, "placeholder") ? $n : e).placeholder;
              }
              function so() {
                var e = $n.iteratee || ou;
                return (
                  (e = e === ou ? Nr : e),
                  arguments.length ? e(arguments[0], arguments[1]) : e
                );
              }
              function ao(e, t) {
                var n,
                  r,
                  i = e.__data__;
                return (
                  "string" == (r = typeof (n = t)) ||
                  "number" == r ||
                  "symbol" == r ||
                  "boolean" == r
                    ? "__proto__" !== n
                    : null === n
                )
                  ? i["string" == typeof t ? "string" : "hash"]
                  : i.map;
              }
              function uo(e) {
                for (var t = Ba(e), n = t.length; n--; ) {
                  var r = t[n],
                    i = e[r];
                  t[n] = [r, i, xo(i)];
                }
                return t;
              }
              function lo(e, t) {
                var n = (function (e, t) {
                  return null == e ? i : e[t];
                })(e, t);
                return Pr(n) ? n : i;
              }
              var co = fn
                  ? function (e) {
                      return null == e
                        ? []
                        : ((e = we(e)),
                          Ct(fn(e), function (t) {
                            return et.call(e, t);
                          }));
                    }
                  : gu,
                po = fn
                  ? function (e) {
                      for (var t = []; e; ) St(t, co(e)), (e = He(e));
                      return t;
                    }
                  : gu,
                fo = wr;
              function ho(e, t, n) {
                for (var r = -1, i = (t = yi(t, e)).length, o = !1; ++r < i; ) {
                  var s = Lo(t[r]);
                  if (!(o = null != e && n(e, s))) break;
                  e = e[s];
                }
                return o || ++r != i
                  ? o
                  : !!(i = null == e ? 0 : e.length) &&
                      ea(i) &&
                      yo(s, i) &&
                      (Us(e) || Ws(e));
              }
              function mo(e) {
                return "function" != typeof e.constructor || Co(e)
                  ? {}
                  : Rn(He(e));
              }
              function go(e) {
                return Us(e) || Ws(e) || !!(it && e && e[it]);
              }
              function yo(e, t) {
                var n = typeof e;
                return (
                  !!(t = null == t ? p : t) &&
                  ("number" == n || ("symbol" != n && ye.test(e))) &&
                  e > -1 &&
                  e % 1 == 0 &&
                  e < t
                );
              }
              function vo(e, t, n) {
                if (!ta(n)) return !1;
                var r = typeof t;
                return (
                  !!("number" == r
                    ? Gs(n) && yo(t, n.length)
                    : "string" == r && t in n) && zs(n[t], e)
                );
              }
              function Do(e, t) {
                if (Us(e)) return !1;
                var n = typeof e;
                return (
                  !(
                    "number" != n &&
                    "symbol" != n &&
                    "boolean" != n &&
                    null != e &&
                    !la(e)
                  ) ||
                  Q.test(e) ||
                  !K.test(e) ||
                  (null != t && e in we(t))
                );
              }
              function bo(e) {
                var t = io(e),
                  n = $n[t];
                if ("function" != typeof n || !(t in qn.prototype)) return !1;
                if (e === n) return !0;
                var r = ro(n);
                return !!r && e === r[0];
              }
              ((xn && fo(new xn(new ArrayBuffer(1))) != B) ||
                (wn && fo(new wn()) != C) ||
                (An && fo(An.resolve()) != A) ||
                (Sn && fo(new Sn()) != _) ||
                (_n && fo(new _n()) != k)) &&
                (fo = function (e) {
                  var t = wr(e),
                    n = t == w ? e.constructor : i,
                    r = n ? $o(n) : "";
                  if (r)
                    switch (r) {
                      case On:
                        return B;
                      case Bn:
                        return C;
                      case Pn:
                        return A;
                      case Nn:
                        return _;
                      case Mn:
                        return k;
                    }
                  return t;
                });
              var Eo = Oe ? Ks : yu;
              function Co(e) {
                var t = e && e.constructor;
                return e === (("function" == typeof t && t.prototype) || ke);
              }
              function xo(e) {
                return e == e && !ta(e);
              }
              function wo(e, t) {
                return function (n) {
                  return null != n && n[e] === t && (t !== i || e in we(n));
                };
              }
              function Ao(e, t, n) {
                return (
                  (t = yn(t === i ? e.length - 1 : t, 0)),
                  function () {
                    for (
                      var i = arguments,
                        o = -1,
                        s = yn(i.length - t, 0),
                        a = r(s);
                      ++o < s;

                    )
                      a[o] = i[t + o];
                    o = -1;
                    for (var u = r(t + 1); ++o < t; ) u[o] = i[o];
                    return (u[t] = n(a)), yt(e, this, u);
                  }
                );
              }
              function So(e, t) {
                return t.length < 2 ? e : Cr(e, ti(t, 0, -1));
              }
              function _o(e, t) {
                for (var n = e.length, r = vn(t.length, n), o = _i(e); r--; ) {
                  var s = t[r];
                  e[r] = yo(s, n) ? o[s] : i;
                }
                return e;
              }
              function To(e, t) {
                if (
                  ("constructor" !== t || "function" != typeof e[t]) &&
                  "__proto__" != t
                )
                  return e[t];
              }
              var Fo = Po(Kr),
                ko =
                  Lt ||
                  function (e, t) {
                    return ot.setTimeout(e, t);
                  },
                Oo = Po(Qr);
              function Bo(e, t, n) {
                var r = t + "";
                return Oo(
                  e,
                  (function (e, t) {
                    var n = t.length;
                    if (!n) return e;
                    var r = n - 1;
                    return (
                      (t[r] = (n > 1 ? "& " : "") + t[r]),
                      (t = t.join(n > 2 ? ", " : " ")),
                      e.replace(oe, "{\n/* [wrapped with " + t + "] */\n")
                    );
                  })(
                    r,
                    (function (e, t) {
                      return (
                        Dt(h, function (n) {
                          var r = "_." + n[0];
                          t & n[1] && !xt(e, r) && e.push(r);
                        }),
                        e.sort()
                      );
                    })(
                      (function (e) {
                        var t = e.match(se);
                        return t ? t[1].split(ae) : [];
                      })(r),
                      n
                    )
                  )
                );
              }
              function Po(e) {
                var t = 0,
                  n = 0;
                return function () {
                  var r = Dn(),
                    o = 16 - (r - n);
                  if (((n = r), o > 0)) {
                    if (++t >= 800) return arguments[0];
                  } else t = 0;
                  return e.apply(i, arguments);
                };
              }
              function No(e, t) {
                var n = -1,
                  r = e.length,
                  o = r - 1;
                for (t = t === i ? r : t; ++n < t; ) {
                  var s = Hr(n, o),
                    a = e[s];
                  (e[s] = e[n]), (e[n] = a);
                }
                return (e.length = t), e;
              }
              var Mo,
                Io,
                jo =
                  ((Mo = Ms(
                    function (e) {
                      var t = [];
                      return (
                        46 === e.charCodeAt(0) && t.push(""),
                        e.replace(ee, function (e, n, r, i) {
                          t.push(r ? i.replace(ce, "$1") : n || e);
                        }),
                        t
                      );
                    },
                    function (e) {
                      return 500 === Io.size && Io.clear(), e;
                    }
                  )),
                  (Io = Mo.cache),
                  Mo);
              function Lo(e) {
                if ("string" == typeof e || la(e)) return e;
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
              }
              function $o(e) {
                if (null != e) {
                  try {
                    return Be.call(e);
                  } catch (e) {}
                  try {
                    return e + "";
                  } catch (e) {}
                }
                return "";
              }
              function Ro(e) {
                if (e instanceof qn) return e.clone();
                var t = new Vn(e.__wrapped__, e.__chain__);
                return (
                  (t.__actions__ = _i(e.__actions__)),
                  (t.__index__ = e.__index__),
                  (t.__values__ = e.__values__),
                  t
                );
              }
              var zo = Yr(function (e, t) {
                  return Ys(e) ? cr(e, gr(t, 1, Ys, !0)) : [];
                }),
                Vo = Yr(function (e, t) {
                  var n = Zo(t);
                  return (
                    Ys(n) && (n = i),
                    Ys(e) ? cr(e, gr(t, 1, Ys, !0), so(n, 2)) : []
                  );
                }),
                qo = Yr(function (e, t) {
                  var n = Zo(t);
                  return (
                    Ys(n) && (n = i), Ys(e) ? cr(e, gr(t, 1, Ys, !0), i, n) : []
                  );
                });
              function Wo(e, t, n) {
                var r = null == e ? 0 : e.length;
                if (!r) return -1;
                var i = null == n ? 0 : ma(n);
                return i < 0 && (i = yn(r + i, 0)), Bt(e, so(t, 3), i);
              }
              function Uo(e, t, n) {
                var r = null == e ? 0 : e.length;
                if (!r) return -1;
                var o = r - 1;
                return (
                  n !== i &&
                    ((o = ma(n)), (o = n < 0 ? yn(r + o, 0) : vn(o, r - 1))),
                  Bt(e, so(t, 3), o, !0)
                );
              }
              function Ho(e) {
                return null != e && e.length ? gr(e, 1) : [];
              }
              function Go(e) {
                return e && e.length ? e[0] : i;
              }
              var Yo = Yr(function (e) {
                  var t = At(e, mi);
                  return t.length && t[0] === e[0] ? Tr(t) : [];
                }),
                Xo = Yr(function (e) {
                  var t = Zo(e),
                    n = At(e, mi);
                  return (
                    t === Zo(n) ? (t = i) : n.pop(),
                    n.length && n[0] === e[0] ? Tr(n, so(t, 2)) : []
                  );
                }),
                Jo = Yr(function (e) {
                  var t = Zo(e),
                    n = At(e, mi);
                  return (
                    (t = "function" == typeof t ? t : i) && n.pop(),
                    n.length && n[0] === e[0] ? Tr(n, i, t) : []
                  );
                });
              function Zo(e) {
                var t = null == e ? 0 : e.length;
                return t ? e[t - 1] : i;
              }
              var Ko = Yr(Qo);
              function Qo(e, t) {
                return e && e.length && t && t.length ? Wr(e, t) : e;
              }
              var es = eo(function (e, t) {
                var n = null == e ? 0 : e.length,
                  r = or(e, t);
                return (
                  Ur(
                    e,
                    At(t, function (e) {
                      return yo(e, n) ? +e : e;
                    }).sort(wi)
                  ),
                  r
                );
              });
              function ts(e) {
                return null == e ? e : Cn.call(e);
              }
              var ns = Yr(function (e) {
                  return ui(gr(e, 1, Ys, !0));
                }),
                rs = Yr(function (e) {
                  var t = Zo(e);
                  return Ys(t) && (t = i), ui(gr(e, 1, Ys, !0), so(t, 2));
                }),
                is = Yr(function (e) {
                  var t = Zo(e);
                  return (
                    (t = "function" == typeof t ? t : i),
                    ui(gr(e, 1, Ys, !0), i, t)
                  );
                });
              function os(e) {
                if (!e || !e.length) return [];
                var t = 0;
                return (
                  (e = Ct(e, function (e) {
                    if (Ys(e)) return (t = yn(e.length, t)), !0;
                  })),
                  zt(t, function (t) {
                    return At(e, jt(t));
                  })
                );
              }
              function ss(e, t) {
                if (!e || !e.length) return [];
                var n = os(e);
                return null == t
                  ? n
                  : At(n, function (e) {
                      return yt(t, i, e);
                    });
              }
              var as = Yr(function (e, t) {
                  return Ys(e) ? cr(e, t) : [];
                }),
                us = Yr(function (e) {
                  return di(Ct(e, Ys));
                }),
                ls = Yr(function (e) {
                  var t = Zo(e);
                  return Ys(t) && (t = i), di(Ct(e, Ys), so(t, 2));
                }),
                cs = Yr(function (e) {
                  var t = Zo(e);
                  return (
                    (t = "function" == typeof t ? t : i), di(Ct(e, Ys), i, t)
                  );
                }),
                ps = Yr(os),
                fs = Yr(function (e) {
                  var t = e.length,
                    n = t > 1 ? e[t - 1] : i;
                  return (
                    (n = "function" == typeof n ? (e.pop(), n) : i), ss(e, n)
                  );
                });
              function ds(e) {
                var t = $n(e);
                return (t.__chain__ = !0), t;
              }
              function hs(e, t) {
                return t(e);
              }
              var ms = eo(function (e) {
                  var t = e.length,
                    n = t ? e[0] : 0,
                    r = this.__wrapped__,
                    o = function (t) {
                      return or(t, e);
                    };
                  return !(t > 1 || this.__actions__.length) &&
                    r instanceof qn &&
                    yo(n)
                    ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({
                        func: hs,
                        args: [o],
                        thisArg: i,
                      }),
                      new Vn(r, this.__chain__).thru(function (e) {
                        return t && !e.length && e.push(i), e;
                      }))
                    : this.thru(o);
                }),
                gs = Fi(function (e, t, n) {
                  Pe.call(e, n) ? ++e[n] : ir(e, n, 1);
                }),
                ys = Ii(Wo),
                vs = Ii(Uo);
              function Ds(e, t) {
                return (Us(e) ? Dt : pr)(e, so(t, 3));
              }
              function bs(e, t) {
                return (Us(e) ? bt : fr)(e, so(t, 3));
              }
              var Es = Fi(function (e, t, n) {
                  Pe.call(e, n) ? e[n].push(t) : ir(e, n, [t]);
                }),
                Cs = Yr(function (e, t, n) {
                  var i = -1,
                    o = "function" == typeof t,
                    s = Gs(e) ? r(e.length) : [];
                  return (
                    pr(e, function (e) {
                      s[++i] = o ? yt(t, e, n) : Fr(e, t, n);
                    }),
                    s
                  );
                }),
                xs = Fi(function (e, t, n) {
                  ir(e, n, t);
                });
              function ws(e, t) {
                return (Us(e) ? At : jr)(e, so(t, 3));
              }
              var As = Fi(
                  function (e, t, n) {
                    e[n ? 0 : 1].push(t);
                  },
                  function () {
                    return [[], []];
                  }
                ),
                Ss = Yr(function (e, t) {
                  if (null == e) return [];
                  var n = t.length;
                  return (
                    n > 1 && vo(e, t[0], t[1])
                      ? (t = [])
                      : n > 2 && vo(t[0], t[1], t[2]) && (t = [t[0]]),
                    Vr(e, gr(t, 1), [])
                  );
                }),
                _s =
                  kt ||
                  function () {
                    return ot.Date.now();
                  };
              function Ts(e, t, n) {
                return (
                  (t = n ? i : t),
                  (t = e && null == t ? e.length : t),
                  Xi(e, l, i, i, i, i, t)
                );
              }
              function Fs(e, t) {
                var n;
                if ("function" != typeof t) throw new _e(o);
                return (
                  (e = ma(e)),
                  function () {
                    return (
                      --e > 0 && (n = t.apply(this, arguments)),
                      e <= 1 && (t = i),
                      n
                    );
                  }
                );
              }
              var ks = Yr(function (e, t, n) {
                  var r = 1;
                  if (n.length) {
                    var i = tn(n, oo(ks));
                    r |= u;
                  }
                  return Xi(e, r, t, n, i);
                }),
                Os = Yr(function (e, t, n) {
                  var r = 3;
                  if (n.length) {
                    var i = tn(n, oo(Os));
                    r |= u;
                  }
                  return Xi(t, r, e, n, i);
                });
              function Bs(e, t, n) {
                var r,
                  s,
                  a,
                  u,
                  l,
                  c,
                  p = 0,
                  f = !1,
                  d = !1,
                  h = !0;
                if ("function" != typeof e) throw new _e(o);
                function m(t) {
                  var n = r,
                    o = s;
                  return (r = s = i), (p = t), (u = e.apply(o, n));
                }
                function g(e) {
                  return (p = e), (l = ko(v, t)), f ? m(e) : u;
                }
                function y(e) {
                  var n = e - c;
                  return c === i || n >= t || n < 0 || (d && e - p >= a);
                }
                function v() {
                  var e = _s();
                  if (y(e)) return D(e);
                  l = ko(
                    v,
                    (function (e) {
                      var n = t - (e - c);
                      return d ? vn(n, a - (e - p)) : n;
                    })(e)
                  );
                }
                function D(e) {
                  return (l = i), h && r ? m(e) : ((r = s = i), u);
                }
                function b() {
                  var e = _s(),
                    n = y(e);
                  if (((r = arguments), (s = this), (c = e), n)) {
                    if (l === i) return g(c);
                    if (d) return bi(l), (l = ko(v, t)), m(c);
                  }
                  return l === i && (l = ko(v, t)), u;
                }
                return (
                  (t = ya(t) || 0),
                  ta(n) &&
                    ((f = !!n.leading),
                    (a = (d = "maxWait" in n) ? yn(ya(n.maxWait) || 0, t) : a),
                    (h = "trailing" in n ? !!n.trailing : h)),
                  (b.cancel = function () {
                    l !== i && bi(l), (p = 0), (r = c = s = l = i);
                  }),
                  (b.flush = function () {
                    return l === i ? u : D(_s());
                  }),
                  b
                );
              }
              var Ps = Yr(function (e, t) {
                  return lr(e, 1, t);
                }),
                Ns = Yr(function (e, t, n) {
                  return lr(e, ya(t) || 0, n);
                });
              function Ms(e, t) {
                if (
                  "function" != typeof e ||
                  (null != t && "function" != typeof t)
                )
                  throw new _e(o);
                var n = function () {
                  var r = arguments,
                    i = t ? t.apply(this, r) : r[0],
                    o = n.cache;
                  if (o.has(i)) return o.get(i);
                  var s = e.apply(this, r);
                  return (n.cache = o.set(i, s) || o), s;
                };
                return (n.cache = new (Ms.Cache || Hn)()), n;
              }
              function Is(e) {
                if ("function" != typeof e) throw new _e(o);
                return function () {
                  var t = arguments;
                  switch (t.length) {
                    case 0:
                      return !e.call(this);
                    case 1:
                      return !e.call(this, t[0]);
                    case 2:
                      return !e.call(this, t[0], t[1]);
                    case 3:
                      return !e.call(this, t[0], t[1], t[2]);
                  }
                  return !e.apply(this, t);
                };
              }
              Ms.Cache = Hn;
              var js = vi(function (e, t) {
                  var n = (t =
                    1 == t.length && Us(t[0])
                      ? At(t[0], qt(so()))
                      : At(gr(t, 1), qt(so()))).length;
                  return Yr(function (r) {
                    for (var i = -1, o = vn(r.length, n); ++i < o; )
                      r[i] = t[i].call(this, r[i]);
                    return yt(e, this, r);
                  });
                }),
                Ls = Yr(function (e, t) {
                  var n = tn(t, oo(Ls));
                  return Xi(e, u, i, t, n);
                }),
                $s = Yr(function (e, t) {
                  var n = tn(t, oo($s));
                  return Xi(e, 64, i, t, n);
                }),
                Rs = eo(function (e, t) {
                  return Xi(e, 256, i, i, i, t);
                });
              function zs(e, t) {
                return e === t || (e != e && t != t);
              }
              var Vs = Wi(Ar),
                qs = Wi(function (e, t) {
                  return e >= t;
                }),
                Ws = kr(
                  (function () {
                    return arguments;
                  })()
                )
                  ? kr
                  : function (e) {
                      return (
                        na(e) && Pe.call(e, "callee") && !et.call(e, "callee")
                      );
                    },
                Us = r.isArray,
                Hs = pt
                  ? qt(pt)
                  : function (e) {
                      return na(e) && wr(e) == O;
                    };
              function Gs(e) {
                return null != e && ea(e.length) && !Ks(e);
              }
              function Ys(e) {
                return na(e) && Gs(e);
              }
              var Xs = dn || yu,
                Js = ft
                  ? qt(ft)
                  : function (e) {
                      return na(e) && wr(e) == v;
                    };
              function Zs(e) {
                if (!na(e)) return !1;
                var t = wr(e);
                return (
                  t == D ||
                  "[object DOMException]" == t ||
                  ("string" == typeof e.message &&
                    "string" == typeof e.name &&
                    !oa(e))
                );
              }
              function Ks(e) {
                if (!ta(e)) return !1;
                var t = wr(e);
                return (
                  t == b ||
                  t == E ||
                  "[object AsyncFunction]" == t ||
                  "[object Proxy]" == t
                );
              }
              function Qs(e) {
                return "number" == typeof e && e == ma(e);
              }
              function ea(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= p;
              }
              function ta(e) {
                var t = typeof e;
                return null != e && ("object" == t || "function" == t);
              }
              function na(e) {
                return null != e && "object" == typeof e;
              }
              var ra = dt
                ? qt(dt)
                : function (e) {
                    return na(e) && fo(e) == C;
                  };
              function ia(e) {
                return "number" == typeof e || (na(e) && wr(e) == x);
              }
              function oa(e) {
                if (!na(e) || wr(e) != w) return !1;
                var t = He(e);
                if (null === t) return !0;
                var n = Pe.call(t, "constructor") && t.constructor;
                return (
                  "function" == typeof n && n instanceof n && Be.call(n) == je
                );
              }
              var sa = ht
                  ? qt(ht)
                  : function (e) {
                      return na(e) && wr(e) == S;
                    },
                aa = mt
                  ? qt(mt)
                  : function (e) {
                      return na(e) && fo(e) == _;
                    };
              function ua(e) {
                return "string" == typeof e || (!Us(e) && na(e) && wr(e) == T);
              }
              function la(e) {
                return "symbol" == typeof e || (na(e) && wr(e) == F);
              }
              var ca = gt
                  ? qt(gt)
                  : function (e) {
                      return na(e) && ea(e.length) && !!Ke[wr(e)];
                    },
                pa = Wi(Ir),
                fa = Wi(function (e, t) {
                  return e <= t;
                });
              function da(e) {
                if (!e) return [];
                if (Gs(e)) return ua(e) ? sn(e) : _i(e);
                if (st && e[st])
                  return (function (e) {
                    for (var t, n = []; !(t = e.next()).done; ) n.push(t.value);
                    return n;
                  })(e[st]());
                var t = fo(e);
                return (t == C ? Qt : t == _ ? nn : za)(e);
              }
              function ha(e) {
                return e
                  ? (e = ya(e)) === c || e === -1 / 0
                    ? 17976931348623157e292 * (e < 0 ? -1 : 1)
                    : e == e
                    ? e
                    : 0
                  : 0 === e
                  ? e
                  : 0;
              }
              function ma(e) {
                var t = ha(e),
                  n = t % 1;
                return t == t ? (n ? t - n : t) : 0;
              }
              function ga(e) {
                return e ? sr(ma(e), 0, d) : 0;
              }
              function ya(e) {
                if ("number" == typeof e) return e;
                if (la(e)) return f;
                if (ta(e)) {
                  var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                  e = ta(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = Vt(e);
                var n = he.test(e);
                return n || ge.test(e)
                  ? nt(e.slice(2), n ? 2 : 8)
                  : de.test(e)
                  ? f
                  : +e;
              }
              function va(e) {
                return Ti(e, Pa(e));
              }
              function Da(e) {
                return null == e ? "" : ai(e);
              }
              var ba = ki(function (e, t) {
                  if (Co(t) || Gs(t)) Ti(t, Ba(t), e);
                  else for (var n in t) Pe.call(t, n) && er(e, n, t[n]);
                }),
                Ea = ki(function (e, t) {
                  Ti(t, Pa(t), e);
                }),
                Ca = ki(function (e, t, n, r) {
                  Ti(t, Pa(t), e, r);
                }),
                xa = ki(function (e, t, n, r) {
                  Ti(t, Ba(t), e, r);
                }),
                wa = eo(or),
                Aa = Yr(function (e, t) {
                  e = we(e);
                  var n = -1,
                    r = t.length,
                    o = r > 2 ? t[2] : i;
                  for (o && vo(t[0], t[1], o) && (r = 1); ++n < r; )
                    for (
                      var s = t[n], a = Pa(s), u = -1, l = a.length;
                      ++u < l;

                    ) {
                      var c = a[u],
                        p = e[c];
                      (p === i || (zs(p, ke[c]) && !Pe.call(e, c))) &&
                        (e[c] = s[c]);
                    }
                  return e;
                }),
                Sa = Yr(function (e) {
                  return e.push(i, Zi), yt(Ma, i, e);
                });
              function _a(e, t, n) {
                var r = null == e ? i : Cr(e, t);
                return r === i ? n : r;
              }
              function Ta(e, t) {
                return null != e && ho(e, t, _r);
              }
              var Fa = $i(function (e, t, n) {
                  null != t &&
                    "function" != typeof t.toString &&
                    (t = Ie.call(t)),
                    (e[t] = n);
                }, tu(iu)),
                ka = $i(function (e, t, n) {
                  null != t &&
                    "function" != typeof t.toString &&
                    (t = Ie.call(t)),
                    Pe.call(e, t) ? e[t].push(n) : (e[t] = [n]);
                }, so),
                Oa = Yr(Fr);
              function Ba(e) {
                return Gs(e) ? Xn(e) : Mr(e);
              }
              function Pa(e) {
                return Gs(e)
                  ? Xn(e, !0)
                  : (function (e) {
                      if (!ta(e))
                        return (function (e) {
                          var t = [];
                          if (null != e) for (var n in we(e)) t.push(n);
                          return t;
                        })(e);
                      var t = Co(e),
                        n = [];
                      for (var r in e)
                        ("constructor" != r || (!t && Pe.call(e, r))) &&
                          n.push(r);
                      return n;
                    })(e);
              }
              var Na = ki(function (e, t, n) {
                  Rr(e, t, n);
                }),
                Ma = ki(function (e, t, n, r) {
                  Rr(e, t, n, r);
                }),
                Ia = eo(function (e, t) {
                  var n = {};
                  if (null == e) return n;
                  var r = !1;
                  (t = At(t, function (t) {
                    return (t = yi(t, e)), r || (r = t.length > 1), t;
                  })),
                    Ti(e, no(e), n),
                    r && (n = ar(n, 7, Ki));
                  for (var i = t.length; i--; ) li(n, t[i]);
                  return n;
                }),
                ja = eo(function (e, t) {
                  return null == e
                    ? {}
                    : (function (e, t) {
                        return qr(e, t, function (t, n) {
                          return Ta(e, n);
                        });
                      })(e, t);
                });
              function La(e, t) {
                if (null == e) return {};
                var n = At(no(e), function (e) {
                  return [e];
                });
                return (
                  (t = so(t)),
                  qr(e, n, function (e, n) {
                    return t(e, n[0]);
                  })
                );
              }
              var $a = Yi(Ba),
                Ra = Yi(Pa);
              function za(e) {
                return null == e ? [] : Wt(e, Ba(e));
              }
              var Va = Ni(function (e, t, n) {
                return (t = t.toLowerCase()), e + (n ? qa(t) : t);
              });
              function qa(e) {
                return Za(Da(e).toLowerCase());
              }
              function Wa(e) {
                return (e = Da(e)) && e.replace(ve, Xt).replace(Ue, "");
              }
              var Ua = Ni(function (e, t, n) {
                  return e + (n ? "-" : "") + t.toLowerCase();
                }),
                Ha = Ni(function (e, t, n) {
                  return e + (n ? " " : "") + t.toLowerCase();
                }),
                Ga = Pi("toLowerCase"),
                Ya = Ni(function (e, t, n) {
                  return e + (n ? "_" : "") + t.toLowerCase();
                }),
                Xa = Ni(function (e, t, n) {
                  return e + (n ? " " : "") + Za(t);
                }),
                Ja = Ni(function (e, t, n) {
                  return e + (n ? " " : "") + t.toUpperCase();
                }),
                Za = Pi("toUpperCase");
              function Ka(e, t, n) {
                return (
                  (e = Da(e)),
                  (t = n ? i : t) === i
                    ? (function (e) {
                        return Xe.test(e);
                      })(e)
                      ? (function (e) {
                          return e.match(Ge) || [];
                        })(e)
                      : (function (e) {
                          return e.match(ue) || [];
                        })(e)
                    : e.match(t) || []
                );
              }
              var Qa = Yr(function (e, t) {
                  try {
                    return yt(e, i, t);
                  } catch (e) {
                    return Zs(e) ? e : new Ee(e);
                  }
                }),
                eu = eo(function (e, t) {
                  return (
                    Dt(t, function (t) {
                      (t = Lo(t)), ir(e, t, ks(e[t], e));
                    }),
                    e
                  );
                });
              function tu(e) {
                return function () {
                  return e;
                };
              }
              var nu = ji(),
                ru = ji(!0);
              function iu(e) {
                return e;
              }
              function ou(e) {
                return Nr("function" == typeof e ? e : ar(e, 1));
              }
              var su = Yr(function (e, t) {
                  return function (n) {
                    return Fr(n, e, t);
                  };
                }),
                au = Yr(function (e, t) {
                  return function (n) {
                    return Fr(e, n, t);
                  };
                });
              function uu(e, t, n) {
                var r = Ba(t),
                  i = Er(t, r);
                null != n ||
                  (ta(t) && (i.length || !r.length)) ||
                  ((n = t), (t = e), (e = this), (i = Er(t, Ba(t))));
                var o = !(ta(n) && "chain" in n && !n.chain),
                  s = Ks(e);
                return (
                  Dt(i, function (n) {
                    var r = t[n];
                    (e[n] = r),
                      s &&
                        (e.prototype[n] = function () {
                          var t = this.__chain__;
                          if (o || t) {
                            var n = e(this.__wrapped__),
                              i = (n.__actions__ = _i(this.__actions__));
                            return (
                              i.push({ func: r, args: arguments, thisArg: e }),
                              (n.__chain__ = t),
                              n
                            );
                          }
                          return r.apply(e, St([this.value()], arguments));
                        });
                  }),
                  e
                );
              }
              function lu() {}
              var cu = zi(At),
                pu = zi(Et),
                fu = zi(Ft);
              function du(e) {
                return Do(e)
                  ? jt(Lo(e))
                  : (function (e) {
                      return function (t) {
                        return Cr(t, e);
                      };
                    })(e);
              }
              var hu = qi(),
                mu = qi(!0);
              function gu() {
                return [];
              }
              function yu() {
                return !1;
              }
              var vu,
                Du = Ri(function (e, t) {
                  return e + t;
                }, 0),
                bu = Hi("ceil"),
                Eu = Ri(function (e, t) {
                  return e / t;
                }, 1),
                Cu = Hi("floor"),
                xu = Ri(function (e, t) {
                  return e * t;
                }, 1),
                wu = Hi("round"),
                Au = Ri(function (e, t) {
                  return e - t;
                }, 0);
              return (
                ($n.after = function (e, t) {
                  if ("function" != typeof t) throw new _e(o);
                  return (
                    (e = ma(e)),
                    function () {
                      if (--e < 1) return t.apply(this, arguments);
                    }
                  );
                }),
                ($n.ary = Ts),
                ($n.assign = ba),
                ($n.assignIn = Ea),
                ($n.assignInWith = Ca),
                ($n.assignWith = xa),
                ($n.at = wa),
                ($n.before = Fs),
                ($n.bind = ks),
                ($n.bindAll = eu),
                ($n.bindKey = Os),
                ($n.castArray = function () {
                  if (!arguments.length) return [];
                  var e = arguments[0];
                  return Us(e) ? e : [e];
                }),
                ($n.chain = ds),
                ($n.chunk = function (e, t, n) {
                  t = (n ? vo(e, t, n) : t === i) ? 1 : yn(ma(t), 0);
                  var o = null == e ? 0 : e.length;
                  if (!o || t < 1) return [];
                  for (var s = 0, a = 0, u = r(cn(o / t)); s < o; )
                    u[a++] = ti(e, s, (s += t));
                  return u;
                }),
                ($n.compact = function (e) {
                  for (
                    var t = -1, n = null == e ? 0 : e.length, r = 0, i = [];
                    ++t < n;

                  ) {
                    var o = e[t];
                    o && (i[r++] = o);
                  }
                  return i;
                }),
                ($n.concat = function () {
                  var e = arguments.length;
                  if (!e) return [];
                  for (var t = r(e - 1), n = arguments[0], i = e; i--; )
                    t[i - 1] = arguments[i];
                  return St(Us(n) ? _i(n) : [n], gr(t, 1));
                }),
                ($n.cond = function (e) {
                  var t = null == e ? 0 : e.length,
                    n = so();
                  return (
                    (e = t
                      ? At(e, function (e) {
                          if ("function" != typeof e[1]) throw new _e(o);
                          return [n(e[0]), e[1]];
                        })
                      : []),
                    Yr(function (n) {
                      for (var r = -1; ++r < t; ) {
                        var i = e[r];
                        if (yt(i[0], this, n)) return yt(i[1], this, n);
                      }
                    })
                  );
                }),
                ($n.conforms = function (e) {
                  return (function (e) {
                    var t = Ba(e);
                    return function (n) {
                      return ur(n, e, t);
                    };
                  })(ar(e, 1));
                }),
                ($n.constant = tu),
                ($n.countBy = gs),
                ($n.create = function (e, t) {
                  var n = Rn(e);
                  return null == t ? n : rr(n, t);
                }),
                ($n.curry = function e(t, n, r) {
                  var o = Xi(t, 8, i, i, i, i, i, (n = r ? i : n));
                  return (o.placeholder = e.placeholder), o;
                }),
                ($n.curryRight = function e(t, n, r) {
                  var o = Xi(t, 16, i, i, i, i, i, (n = r ? i : n));
                  return (o.placeholder = e.placeholder), o;
                }),
                ($n.debounce = Bs),
                ($n.defaults = Aa),
                ($n.defaultsDeep = Sa),
                ($n.defer = Ps),
                ($n.delay = Ns),
                ($n.difference = zo),
                ($n.differenceBy = Vo),
                ($n.differenceWith = qo),
                ($n.drop = function (e, t, n) {
                  var r = null == e ? 0 : e.length;
                  return r
                    ? ti(e, (t = n || t === i ? 1 : ma(t)) < 0 ? 0 : t, r)
                    : [];
                }),
                ($n.dropRight = function (e, t, n) {
                  var r = null == e ? 0 : e.length;
                  return r
                    ? ti(
                        e,
                        0,
                        (t = r - (t = n || t === i ? 1 : ma(t))) < 0 ? 0 : t
                      )
                    : [];
                }),
                ($n.dropRightWhile = function (e, t) {
                  return e && e.length ? pi(e, so(t, 3), !0, !0) : [];
                }),
                ($n.dropWhile = function (e, t) {
                  return e && e.length ? pi(e, so(t, 3), !0) : [];
                }),
                ($n.fill = function (e, t, n, r) {
                  var o = null == e ? 0 : e.length;
                  return o
                    ? (n &&
                        "number" != typeof n &&
                        vo(e, t, n) &&
                        ((n = 0), (r = o)),
                      (function (e, t, n, r) {
                        var o = e.length;
                        for (
                          (n = ma(n)) < 0 && (n = -n > o ? 0 : o + n),
                            (r = r === i || r > o ? o : ma(r)) < 0 && (r += o),
                            r = n > r ? 0 : ga(r);
                          n < r;

                        )
                          e[n++] = t;
                        return e;
                      })(e, t, n, r))
                    : [];
                }),
                ($n.filter = function (e, t) {
                  return (Us(e) ? Ct : mr)(e, so(t, 3));
                }),
                ($n.flatMap = function (e, t) {
                  return gr(ws(e, t), 1);
                }),
                ($n.flatMapDeep = function (e, t) {
                  return gr(ws(e, t), c);
                }),
                ($n.flatMapDepth = function (e, t, n) {
                  return (n = n === i ? 1 : ma(n)), gr(ws(e, t), n);
                }),
                ($n.flatten = Ho),
                ($n.flattenDeep = function (e) {
                  return null != e && e.length ? gr(e, c) : [];
                }),
                ($n.flattenDepth = function (e, t) {
                  return null != e && e.length
                    ? gr(e, (t = t === i ? 1 : ma(t)))
                    : [];
                }),
                ($n.flip = function (e) {
                  return Xi(e, 512);
                }),
                ($n.flow = nu),
                ($n.flowRight = ru),
                ($n.fromPairs = function (e) {
                  for (
                    var t = -1, n = null == e ? 0 : e.length, r = {};
                    ++t < n;

                  ) {
                    var i = e[t];
                    r[i[0]] = i[1];
                  }
                  return r;
                }),
                ($n.functions = function (e) {
                  return null == e ? [] : Er(e, Ba(e));
                }),
                ($n.functionsIn = function (e) {
                  return null == e ? [] : Er(e, Pa(e));
                }),
                ($n.groupBy = Es),
                ($n.initial = function (e) {
                  return null != e && e.length ? ti(e, 0, -1) : [];
                }),
                ($n.intersection = Yo),
                ($n.intersectionBy = Xo),
                ($n.intersectionWith = Jo),
                ($n.invert = Fa),
                ($n.invertBy = ka),
                ($n.invokeMap = Cs),
                ($n.iteratee = ou),
                ($n.keyBy = xs),
                ($n.keys = Ba),
                ($n.keysIn = Pa),
                ($n.map = ws),
                ($n.mapKeys = function (e, t) {
                  var n = {};
                  return (
                    (t = so(t, 3)),
                    Dr(e, function (e, r, i) {
                      ir(n, t(e, r, i), e);
                    }),
                    n
                  );
                }),
                ($n.mapValues = function (e, t) {
                  var n = {};
                  return (
                    (t = so(t, 3)),
                    Dr(e, function (e, r, i) {
                      ir(n, r, t(e, r, i));
                    }),
                    n
                  );
                }),
                ($n.matches = function (e) {
                  return Lr(ar(e, 1));
                }),
                ($n.matchesProperty = function (e, t) {
                  return $r(e, ar(t, 1));
                }),
                ($n.memoize = Ms),
                ($n.merge = Na),
                ($n.mergeWith = Ma),
                ($n.method = su),
                ($n.methodOf = au),
                ($n.mixin = uu),
                ($n.negate = Is),
                ($n.nthArg = function (e) {
                  return (
                    (e = ma(e)),
                    Yr(function (t) {
                      return zr(t, e);
                    })
                  );
                }),
                ($n.omit = Ia),
                ($n.omitBy = function (e, t) {
                  return La(e, Is(so(t)));
                }),
                ($n.once = function (e) {
                  return Fs(2, e);
                }),
                ($n.orderBy = function (e, t, n, r) {
                  return null == e
                    ? []
                    : (Us(t) || (t = null == t ? [] : [t]),
                      Us((n = r ? i : n)) || (n = null == n ? [] : [n]),
                      Vr(e, t, n));
                }),
                ($n.over = cu),
                ($n.overArgs = js),
                ($n.overEvery = pu),
                ($n.overSome = fu),
                ($n.partial = Ls),
                ($n.partialRight = $s),
                ($n.partition = As),
                ($n.pick = ja),
                ($n.pickBy = La),
                ($n.property = du),
                ($n.propertyOf = function (e) {
                  return function (t) {
                    return null == e ? i : Cr(e, t);
                  };
                }),
                ($n.pull = Ko),
                ($n.pullAll = Qo),
                ($n.pullAllBy = function (e, t, n) {
                  return e && e.length && t && t.length
                    ? Wr(e, t, so(n, 2))
                    : e;
                }),
                ($n.pullAllWith = function (e, t, n) {
                  return e && e.length && t && t.length ? Wr(e, t, i, n) : e;
                }),
                ($n.pullAt = es),
                ($n.range = hu),
                ($n.rangeRight = mu),
                ($n.rearg = Rs),
                ($n.reject = function (e, t) {
                  return (Us(e) ? Ct : mr)(e, Is(so(t, 3)));
                }),
                ($n.remove = function (e, t) {
                  var n = [];
                  if (!e || !e.length) return n;
                  var r = -1,
                    i = [],
                    o = e.length;
                  for (t = so(t, 3); ++r < o; ) {
                    var s = e[r];
                    t(s, r, e) && (n.push(s), i.push(r));
                  }
                  return Ur(e, i), n;
                }),
                ($n.rest = function (e, t) {
                  if ("function" != typeof e) throw new _e(o);
                  return Yr(e, (t = t === i ? t : ma(t)));
                }),
                ($n.reverse = ts),
                ($n.sampleSize = function (e, t, n) {
                  return (
                    (t = (n ? vo(e, t, n) : t === i) ? 1 : ma(t)),
                    (Us(e) ? Zn : Jr)(e, t)
                  );
                }),
                ($n.set = function (e, t, n) {
                  return null == e ? e : Zr(e, t, n);
                }),
                ($n.setWith = function (e, t, n, r) {
                  return (
                    (r = "function" == typeof r ? r : i),
                    null == e ? e : Zr(e, t, n, r)
                  );
                }),
                ($n.shuffle = function (e) {
                  return (Us(e) ? Kn : ei)(e);
                }),
                ($n.slice = function (e, t, n) {
                  var r = null == e ? 0 : e.length;
                  return r
                    ? (n && "number" != typeof n && vo(e, t, n)
                        ? ((t = 0), (n = r))
                        : ((t = null == t ? 0 : ma(t)),
                          (n = n === i ? r : ma(n))),
                      ti(e, t, n))
                    : [];
                }),
                ($n.sortBy = Ss),
                ($n.sortedUniq = function (e) {
                  return e && e.length ? oi(e) : [];
                }),
                ($n.sortedUniqBy = function (e, t) {
                  return e && e.length ? oi(e, so(t, 2)) : [];
                }),
                ($n.split = function (e, t, n) {
                  return (
                    n && "number" != typeof n && vo(e, t, n) && (t = n = i),
                    (n = n === i ? d : n >>> 0)
                      ? (e = Da(e)) &&
                        ("string" == typeof t || (null != t && !sa(t))) &&
                        !(t = ai(t)) &&
                        Kt(e)
                        ? Di(sn(e), 0, n)
                        : e.split(t, n)
                      : []
                  );
                }),
                ($n.spread = function (e, t) {
                  if ("function" != typeof e) throw new _e(o);
                  return (
                    (t = null == t ? 0 : yn(ma(t), 0)),
                    Yr(function (n) {
                      var r = n[t],
                        i = Di(n, 0, t);
                      return r && St(i, r), yt(e, this, i);
                    })
                  );
                }),
                ($n.tail = function (e) {
                  var t = null == e ? 0 : e.length;
                  return t ? ti(e, 1, t) : [];
                }),
                ($n.take = function (e, t, n) {
                  return e && e.length
                    ? ti(e, 0, (t = n || t === i ? 1 : ma(t)) < 0 ? 0 : t)
                    : [];
                }),
                ($n.takeRight = function (e, t, n) {
                  var r = null == e ? 0 : e.length;
                  return r
                    ? ti(
                        e,
                        (t = r - (t = n || t === i ? 1 : ma(t))) < 0 ? 0 : t,
                        r
                      )
                    : [];
                }),
                ($n.takeRightWhile = function (e, t) {
                  return e && e.length ? pi(e, so(t, 3), !1, !0) : [];
                }),
                ($n.takeWhile = function (e, t) {
                  return e && e.length ? pi(e, so(t, 3)) : [];
                }),
                ($n.tap = function (e, t) {
                  return t(e), e;
                }),
                ($n.throttle = function (e, t, n) {
                  var r = !0,
                    i = !0;
                  if ("function" != typeof e) throw new _e(o);
                  return (
                    ta(n) &&
                      ((r = "leading" in n ? !!n.leading : r),
                      (i = "trailing" in n ? !!n.trailing : i)),
                    Bs(e, t, { leading: r, maxWait: t, trailing: i })
                  );
                }),
                ($n.thru = hs),
                ($n.toArray = da),
                ($n.toPairs = $a),
                ($n.toPairsIn = Ra),
                ($n.toPath = function (e) {
                  return Us(e) ? At(e, Lo) : la(e) ? [e] : _i(jo(Da(e)));
                }),
                ($n.toPlainObject = va),
                ($n.transform = function (e, t, n) {
                  var r = Us(e),
                    i = r || Xs(e) || ca(e);
                  if (((t = so(t, 4)), null == n)) {
                    var o = e && e.constructor;
                    n = i
                      ? r
                        ? new o()
                        : []
                      : ta(e) && Ks(o)
                      ? Rn(He(e))
                      : {};
                  }
                  return (
                    (i ? Dt : Dr)(e, function (e, r, i) {
                      return t(n, e, r, i);
                    }),
                    n
                  );
                }),
                ($n.unary = function (e) {
                  return Ts(e, 1);
                }),
                ($n.union = ns),
                ($n.unionBy = rs),
                ($n.unionWith = is),
                ($n.uniq = function (e) {
                  return e && e.length ? ui(e) : [];
                }),
                ($n.uniqBy = function (e, t) {
                  return e && e.length ? ui(e, so(t, 2)) : [];
                }),
                ($n.uniqWith = function (e, t) {
                  return (
                    (t = "function" == typeof t ? t : i),
                    e && e.length ? ui(e, i, t) : []
                  );
                }),
                ($n.unset = function (e, t) {
                  return null == e || li(e, t);
                }),
                ($n.unzip = os),
                ($n.unzipWith = ss),
                ($n.update = function (e, t, n) {
                  return null == e ? e : ci(e, t, gi(n));
                }),
                ($n.updateWith = function (e, t, n, r) {
                  return (
                    (r = "function" == typeof r ? r : i),
                    null == e ? e : ci(e, t, gi(n), r)
                  );
                }),
                ($n.values = za),
                ($n.valuesIn = function (e) {
                  return null == e ? [] : Wt(e, Pa(e));
                }),
                ($n.without = as),
                ($n.words = Ka),
                ($n.wrap = function (e, t) {
                  return Ls(gi(t), e);
                }),
                ($n.xor = us),
                ($n.xorBy = ls),
                ($n.xorWith = cs),
                ($n.zip = ps),
                ($n.zipObject = function (e, t) {
                  return hi(e || [], t || [], er);
                }),
                ($n.zipObjectDeep = function (e, t) {
                  return hi(e || [], t || [], Zr);
                }),
                ($n.zipWith = fs),
                ($n.entries = $a),
                ($n.entriesIn = Ra),
                ($n.extend = Ea),
                ($n.extendWith = Ca),
                uu($n, $n),
                ($n.add = Du),
                ($n.attempt = Qa),
                ($n.camelCase = Va),
                ($n.capitalize = qa),
                ($n.ceil = bu),
                ($n.clamp = function (e, t, n) {
                  return (
                    n === i && ((n = t), (t = i)),
                    n !== i && (n = (n = ya(n)) == n ? n : 0),
                    t !== i && (t = (t = ya(t)) == t ? t : 0),
                    sr(ya(e), t, n)
                  );
                }),
                ($n.clone = function (e) {
                  return ar(e, 4);
                }),
                ($n.cloneDeep = function (e) {
                  return ar(e, 5);
                }),
                ($n.cloneDeepWith = function (e, t) {
                  return ar(e, 5, (t = "function" == typeof t ? t : i));
                }),
                ($n.cloneWith = function (e, t) {
                  return ar(e, 4, (t = "function" == typeof t ? t : i));
                }),
                ($n.conformsTo = function (e, t) {
                  return null == t || ur(e, t, Ba(t));
                }),
                ($n.deburr = Wa),
                ($n.defaultTo = function (e, t) {
                  return null == e || e != e ? t : e;
                }),
                ($n.divide = Eu),
                ($n.endsWith = function (e, t, n) {
                  (e = Da(e)), (t = ai(t));
                  var r = e.length,
                    o = (n = n === i ? r : sr(ma(n), 0, r));
                  return (n -= t.length) >= 0 && e.slice(n, o) == t;
                }),
                ($n.eq = zs),
                ($n.escape = function (e) {
                  return (e = Da(e)) && Y.test(e) ? e.replace(H, Jt) : e;
                }),
                ($n.escapeRegExp = function (e) {
                  return (e = Da(e)) && ne.test(e) ? e.replace(te, "\\$&") : e;
                }),
                ($n.every = function (e, t, n) {
                  var r = Us(e) ? Et : dr;
                  return n && vo(e, t, n) && (t = i), r(e, so(t, 3));
                }),
                ($n.find = ys),
                ($n.findIndex = Wo),
                ($n.findKey = function (e, t) {
                  return Ot(e, so(t, 3), Dr);
                }),
                ($n.findLast = vs),
                ($n.findLastIndex = Uo),
                ($n.findLastKey = function (e, t) {
                  return Ot(e, so(t, 3), br);
                }),
                ($n.floor = Cu),
                ($n.forEach = Ds),
                ($n.forEachRight = bs),
                ($n.forIn = function (e, t) {
                  return null == e ? e : yr(e, so(t, 3), Pa);
                }),
                ($n.forInRight = function (e, t) {
                  return null == e ? e : vr(e, so(t, 3), Pa);
                }),
                ($n.forOwn = function (e, t) {
                  return e && Dr(e, so(t, 3));
                }),
                ($n.forOwnRight = function (e, t) {
                  return e && br(e, so(t, 3));
                }),
                ($n.get = _a),
                ($n.gt = Vs),
                ($n.gte = qs),
                ($n.has = function (e, t) {
                  return null != e && ho(e, t, Sr);
                }),
                ($n.hasIn = Ta),
                ($n.head = Go),
                ($n.identity = iu),
                ($n.includes = function (e, t, n, r) {
                  (e = Gs(e) ? e : za(e)), (n = n && !r ? ma(n) : 0);
                  var i = e.length;
                  return (
                    n < 0 && (n = yn(i + n, 0)),
                    ua(e)
                      ? n <= i && e.indexOf(t, n) > -1
                      : !!i && Pt(e, t, n) > -1
                  );
                }),
                ($n.indexOf = function (e, t, n) {
                  var r = null == e ? 0 : e.length;
                  if (!r) return -1;
                  var i = null == n ? 0 : ma(n);
                  return i < 0 && (i = yn(r + i, 0)), Pt(e, t, i);
                }),
                ($n.inRange = function (e, t, n) {
                  return (
                    (t = ha(t)),
                    n === i ? ((n = t), (t = 0)) : (n = ha(n)),
                    (function (e, t, n) {
                      return e >= vn(t, n) && e < yn(t, n);
                    })((e = ya(e)), t, n)
                  );
                }),
                ($n.invoke = Oa),
                ($n.isArguments = Ws),
                ($n.isArray = Us),
                ($n.isArrayBuffer = Hs),
                ($n.isArrayLike = Gs),
                ($n.isArrayLikeObject = Ys),
                ($n.isBoolean = function (e) {
                  return !0 === e || !1 === e || (na(e) && wr(e) == y);
                }),
                ($n.isBuffer = Xs),
                ($n.isDate = Js),
                ($n.isElement = function (e) {
                  return na(e) && 1 === e.nodeType && !oa(e);
                }),
                ($n.isEmpty = function (e) {
                  if (null == e) return !0;
                  if (
                    Gs(e) &&
                    (Us(e) ||
                      "string" == typeof e ||
                      "function" == typeof e.splice ||
                      Xs(e) ||
                      ca(e) ||
                      Ws(e))
                  )
                    return !e.length;
                  var t = fo(e);
                  if (t == C || t == _) return !e.size;
                  if (Co(e)) return !Mr(e).length;
                  for (var n in e) if (Pe.call(e, n)) return !1;
                  return !0;
                }),
                ($n.isEqual = function (e, t) {
                  return Or(e, t);
                }),
                ($n.isEqualWith = function (e, t, n) {
                  var r = (n = "function" == typeof n ? n : i) ? n(e, t) : i;
                  return r === i ? Or(e, t, i, n) : !!r;
                }),
                ($n.isError = Zs),
                ($n.isFinite = function (e) {
                  return "number" == typeof e && hn(e);
                }),
                ($n.isFunction = Ks),
                ($n.isInteger = Qs),
                ($n.isLength = ea),
                ($n.isMap = ra),
                ($n.isMatch = function (e, t) {
                  return e === t || Br(e, t, uo(t));
                }),
                ($n.isMatchWith = function (e, t, n) {
                  return (
                    (n = "function" == typeof n ? n : i), Br(e, t, uo(t), n)
                  );
                }),
                ($n.isNaN = function (e) {
                  return ia(e) && e != +e;
                }),
                ($n.isNative = function (e) {
                  if (Eo(e))
                    throw new Ee(
                      "Unsupported core-js use. Try https://npms.io/search?q=ponyfill."
                    );
                  return Pr(e);
                }),
                ($n.isNil = function (e) {
                  return null == e;
                }),
                ($n.isNull = function (e) {
                  return null === e;
                }),
                ($n.isNumber = ia),
                ($n.isObject = ta),
                ($n.isObjectLike = na),
                ($n.isPlainObject = oa),
                ($n.isRegExp = sa),
                ($n.isSafeInteger = function (e) {
                  return Qs(e) && e >= -9007199254740991 && e <= p;
                }),
                ($n.isSet = aa),
                ($n.isString = ua),
                ($n.isSymbol = la),
                ($n.isTypedArray = ca),
                ($n.isUndefined = function (e) {
                  return e === i;
                }),
                ($n.isWeakMap = function (e) {
                  return na(e) && fo(e) == k;
                }),
                ($n.isWeakSet = function (e) {
                  return na(e) && "[object WeakSet]" == wr(e);
                }),
                ($n.join = function (e, t) {
                  return null == e ? "" : mn.call(e, t);
                }),
                ($n.kebabCase = Ua),
                ($n.last = Zo),
                ($n.lastIndexOf = function (e, t, n) {
                  var r = null == e ? 0 : e.length;
                  if (!r) return -1;
                  var o = r;
                  return (
                    n !== i &&
                      (o = (o = ma(n)) < 0 ? yn(r + o, 0) : vn(o, r - 1)),
                    t == t
                      ? (function (e, t, n) {
                          for (var r = n + 1; r--; ) if (e[r] === t) return r;
                          return r;
                        })(e, t, o)
                      : Bt(e, Mt, o, !0)
                  );
                }),
                ($n.lowerCase = Ha),
                ($n.lowerFirst = Ga),
                ($n.lt = pa),
                ($n.lte = fa),
                ($n.max = function (e) {
                  return e && e.length ? hr(e, iu, Ar) : i;
                }),
                ($n.maxBy = function (e, t) {
                  return e && e.length ? hr(e, so(t, 2), Ar) : i;
                }),
                ($n.mean = function (e) {
                  return It(e, iu);
                }),
                ($n.meanBy = function (e, t) {
                  return It(e, so(t, 2));
                }),
                ($n.min = function (e) {
                  return e && e.length ? hr(e, iu, Ir) : i;
                }),
                ($n.minBy = function (e, t) {
                  return e && e.length ? hr(e, so(t, 2), Ir) : i;
                }),
                ($n.stubArray = gu),
                ($n.stubFalse = yu),
                ($n.stubObject = function () {
                  return {};
                }),
                ($n.stubString = function () {
                  return "";
                }),
                ($n.stubTrue = function () {
                  return !0;
                }),
                ($n.multiply = xu),
                ($n.nth = function (e, t) {
                  return e && e.length ? zr(e, ma(t)) : i;
                }),
                ($n.noConflict = function () {
                  return ot._ === this && (ot._ = Le), this;
                }),
                ($n.noop = lu),
                ($n.now = _s),
                ($n.pad = function (e, t, n) {
                  e = Da(e);
                  var r = (t = ma(t)) ? on(e) : 0;
                  if (!t || r >= t) return e;
                  var i = (t - r) / 2;
                  return Vi(pn(i), n) + e + Vi(cn(i), n);
                }),
                ($n.padEnd = function (e, t, n) {
                  e = Da(e);
                  var r = (t = ma(t)) ? on(e) : 0;
                  return t && r < t ? e + Vi(t - r, n) : e;
                }),
                ($n.padStart = function (e, t, n) {
                  e = Da(e);
                  var r = (t = ma(t)) ? on(e) : 0;
                  return t && r < t ? Vi(t - r, n) + e : e;
                }),
                ($n.parseInt = function (e, t, n) {
                  return (
                    n || null == t ? (t = 0) : t && (t = +t),
                    bn(Da(e).replace(re, ""), t || 0)
                  );
                }),
                ($n.random = function (e, t, n) {
                  if (
                    (n && "boolean" != typeof n && vo(e, t, n) && (t = n = i),
                    n === i &&
                      ("boolean" == typeof t
                        ? ((n = t), (t = i))
                        : "boolean" == typeof e && ((n = e), (e = i))),
                    e === i && t === i
                      ? ((e = 0), (t = 1))
                      : ((e = ha(e)),
                        t === i ? ((t = e), (e = 0)) : (t = ha(t))),
                    e > t)
                  ) {
                    var r = e;
                    (e = t), (t = r);
                  }
                  if (n || e % 1 || t % 1) {
                    var o = En();
                    return vn(
                      e + o * (t - e + tt("1e-" + ((o + "").length - 1))),
                      t
                    );
                  }
                  return Hr(e, t);
                }),
                ($n.reduce = function (e, t, n) {
                  var r = Us(e) ? _t : $t,
                    i = arguments.length < 3;
                  return r(e, so(t, 4), n, i, pr);
                }),
                ($n.reduceRight = function (e, t, n) {
                  var r = Us(e) ? Tt : $t,
                    i = arguments.length < 3;
                  return r(e, so(t, 4), n, i, fr);
                }),
                ($n.repeat = function (e, t, n) {
                  return (
                    (t = (n ? vo(e, t, n) : t === i) ? 1 : ma(t)), Gr(Da(e), t)
                  );
                }),
                ($n.replace = function () {
                  var e = arguments,
                    t = Da(e[0]);
                  return e.length < 3 ? t : t.replace(e[1], e[2]);
                }),
                ($n.result = function (e, t, n) {
                  var r = -1,
                    o = (t = yi(t, e)).length;
                  for (o || ((o = 1), (e = i)); ++r < o; ) {
                    var s = null == e ? i : e[Lo(t[r])];
                    s === i && ((r = o), (s = n)), (e = Ks(s) ? s.call(e) : s);
                  }
                  return e;
                }),
                ($n.round = wu),
                ($n.runInContext = e),
                ($n.sample = function (e) {
                  return (Us(e) ? Jn : Xr)(e);
                }),
                ($n.size = function (e) {
                  if (null == e) return 0;
                  if (Gs(e)) return ua(e) ? on(e) : e.length;
                  var t = fo(e);
                  return t == C || t == _ ? e.size : Mr(e).length;
                }),
                ($n.snakeCase = Ya),
                ($n.some = function (e, t, n) {
                  var r = Us(e) ? Ft : ni;
                  return n && vo(e, t, n) && (t = i), r(e, so(t, 3));
                }),
                ($n.sortedIndex = function (e, t) {
                  return ri(e, t);
                }),
                ($n.sortedIndexBy = function (e, t, n) {
                  return ii(e, t, so(n, 2));
                }),
                ($n.sortedIndexOf = function (e, t) {
                  var n = null == e ? 0 : e.length;
                  if (n) {
                    var r = ri(e, t);
                    if (r < n && zs(e[r], t)) return r;
                  }
                  return -1;
                }),
                ($n.sortedLastIndex = function (e, t) {
                  return ri(e, t, !0);
                }),
                ($n.sortedLastIndexBy = function (e, t, n) {
                  return ii(e, t, so(n, 2), !0);
                }),
                ($n.sortedLastIndexOf = function (e, t) {
                  if (null != e && e.length) {
                    var n = ri(e, t, !0) - 1;
                    if (zs(e[n], t)) return n;
                  }
                  return -1;
                }),
                ($n.startCase = Xa),
                ($n.startsWith = function (e, t, n) {
                  return (
                    (e = Da(e)),
                    (n = null == n ? 0 : sr(ma(n), 0, e.length)),
                    (t = ai(t)),
                    e.slice(n, n + t.length) == t
                  );
                }),
                ($n.subtract = Au),
                ($n.sum = function (e) {
                  return e && e.length ? Rt(e, iu) : 0;
                }),
                ($n.sumBy = function (e, t) {
                  return e && e.length ? Rt(e, so(t, 2)) : 0;
                }),
                ($n.template = function (e, t, n) {
                  var r = $n.templateSettings;
                  n && vo(e, t, n) && (t = i),
                    (e = Da(e)),
                    (t = Ca({}, t, r, Ji));
                  var o,
                    s,
                    a = Ca({}, t.imports, r.imports, Ji),
                    u = Ba(a),
                    l = Wt(a, u),
                    c = 0,
                    p = t.interpolate || De,
                    f = "__p += '",
                    d = Ae(
                      (t.escape || De).source +
                        "|" +
                        p.source +
                        "|" +
                        (p === Z ? pe : De).source +
                        "|" +
                        (t.evaluate || De).source +
                        "|$",
                      "g"
                    ),
                    h =
                      "//# sourceURL=" +
                      (Pe.call(t, "sourceURL")
                        ? (t.sourceURL + "").replace(/\s/g, " ")
                        : "lodash.templateSources[" + ++Ze + "]") +
                      "\n";
                  e.replace(d, function (t, n, r, i, a, u) {
                    return (
                      r || (r = i),
                      (f += e.slice(c, u).replace(be, Zt)),
                      n && ((o = !0), (f += "' +\n__e(" + n + ") +\n'")),
                      a && ((s = !0), (f += "';\n" + a + ";\n__p += '")),
                      r &&
                        (f +=
                          "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"),
                      (c = u + t.length),
                      t
                    );
                  }),
                    (f += "';\n");
                  var m = Pe.call(t, "variable") && t.variable;
                  if (m) {
                    if (le.test(m))
                      throw new Ee(
                        "Invalid `variable` option passed into `_.template`"
                      );
                  } else f = "with (obj) {\n" + f + "\n}\n";
                  (f = (s ? f.replace(V, "") : f)
                    .replace(q, "$1")
                    .replace(W, "$1;")),
                    (f =
                      "function(" +
                      (m || "obj") +
                      ") {\n" +
                      (m ? "" : "obj || (obj = {});\n") +
                      "var __t, __p = ''" +
                      (o ? ", __e = _.escape" : "") +
                      (s
                        ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n"
                        : ";\n") +
                      f +
                      "return __p\n}");
                  var g = Qa(function () {
                    return Ce(u, h + "return " + f).apply(i, l);
                  });
                  if (((g.source = f), Zs(g))) throw g;
                  return g;
                }),
                ($n.times = function (e, t) {
                  if ((e = ma(e)) < 1 || e > p) return [];
                  var n = d,
                    r = vn(e, d);
                  (t = so(t)), (e -= d);
                  for (var i = zt(r, t); ++n < e; ) t(n);
                  return i;
                }),
                ($n.toFinite = ha),
                ($n.toInteger = ma),
                ($n.toLength = ga),
                ($n.toLower = function (e) {
                  return Da(e).toLowerCase();
                }),
                ($n.toNumber = ya),
                ($n.toSafeInteger = function (e) {
                  return e ? sr(ma(e), -9007199254740991, p) : 0 === e ? e : 0;
                }),
                ($n.toString = Da),
                ($n.toUpper = function (e) {
                  return Da(e).toUpperCase();
                }),
                ($n.trim = function (e, t, n) {
                  if ((e = Da(e)) && (n || t === i)) return Vt(e);
                  if (!e || !(t = ai(t))) return e;
                  var r = sn(e),
                    o = sn(t);
                  return Di(r, Ht(r, o), Gt(r, o) + 1).join("");
                }),
                ($n.trimEnd = function (e, t, n) {
                  if ((e = Da(e)) && (n || t === i))
                    return e.slice(0, an(e) + 1);
                  if (!e || !(t = ai(t))) return e;
                  var r = sn(e);
                  return Di(r, 0, Gt(r, sn(t)) + 1).join("");
                }),
                ($n.trimStart = function (e, t, n) {
                  if ((e = Da(e)) && (n || t === i)) return e.replace(re, "");
                  if (!e || !(t = ai(t))) return e;
                  var r = sn(e);
                  return Di(r, Ht(r, sn(t))).join("");
                }),
                ($n.truncate = function (e, t) {
                  var n = 30,
                    r = "...";
                  if (ta(t)) {
                    var o = "separator" in t ? t.separator : o;
                    (n = "length" in t ? ma(t.length) : n),
                      (r = "omission" in t ? ai(t.omission) : r);
                  }
                  var s = (e = Da(e)).length;
                  if (Kt(e)) {
                    var a = sn(e);
                    s = a.length;
                  }
                  if (n >= s) return e;
                  var u = n - on(r);
                  if (u < 1) return r;
                  var l = a ? Di(a, 0, u).join("") : e.slice(0, u);
                  if (o === i) return l + r;
                  if ((a && (u += l.length - u), sa(o))) {
                    if (e.slice(u).search(o)) {
                      var c,
                        p = l;
                      for (
                        o.global || (o = Ae(o.source, Da(fe.exec(o)) + "g")),
                          o.lastIndex = 0;
                        (c = o.exec(p));

                      )
                        var f = c.index;
                      l = l.slice(0, f === i ? u : f);
                    }
                  } else if (e.indexOf(ai(o), u) != u) {
                    var d = l.lastIndexOf(o);
                    d > -1 && (l = l.slice(0, d));
                  }
                  return l + r;
                }),
                ($n.unescape = function (e) {
                  return (e = Da(e)) && G.test(e) ? e.replace(U, un) : e;
                }),
                ($n.uniqueId = function (e) {
                  var t = ++Ne;
                  return Da(e) + t;
                }),
                ($n.upperCase = Ja),
                ($n.upperFirst = Za),
                ($n.each = Ds),
                ($n.eachRight = bs),
                ($n.first = Go),
                uu(
                  $n,
                  ((vu = {}),
                  Dr($n, function (e, t) {
                    Pe.call($n.prototype, t) || (vu[t] = e);
                  }),
                  vu),
                  { chain: !1 }
                ),
                ($n.VERSION = "4.17.21"),
                Dt(
                  [
                    "bind",
                    "bindKey",
                    "curry",
                    "curryRight",
                    "partial",
                    "partialRight",
                  ],
                  function (e) {
                    $n[e].placeholder = $n;
                  }
                ),
                Dt(["drop", "take"], function (e, t) {
                  (qn.prototype[e] = function (n) {
                    n = n === i ? 1 : yn(ma(n), 0);
                    var r =
                      this.__filtered__ && !t ? new qn(this) : this.clone();
                    return (
                      r.__filtered__
                        ? (r.__takeCount__ = vn(n, r.__takeCount__))
                        : r.__views__.push({
                            size: vn(n, d),
                            type: e + (r.__dir__ < 0 ? "Right" : ""),
                          }),
                      r
                    );
                  }),
                    (qn.prototype[e + "Right"] = function (t) {
                      return this.reverse()[e](t).reverse();
                    });
                }),
                Dt(["filter", "map", "takeWhile"], function (e, t) {
                  var n = t + 1,
                    r = 1 == n || 3 == n;
                  qn.prototype[e] = function (e) {
                    var t = this.clone();
                    return (
                      t.__iteratees__.push({ iteratee: so(e, 3), type: n }),
                      (t.__filtered__ = t.__filtered__ || r),
                      t
                    );
                  };
                }),
                Dt(["head", "last"], function (e, t) {
                  var n = "take" + (t ? "Right" : "");
                  qn.prototype[e] = function () {
                    return this[n](1).value()[0];
                  };
                }),
                Dt(["initial", "tail"], function (e, t) {
                  var n = "drop" + (t ? "" : "Right");
                  qn.prototype[e] = function () {
                    return this.__filtered__ ? new qn(this) : this[n](1);
                  };
                }),
                (qn.prototype.compact = function () {
                  return this.filter(iu);
                }),
                (qn.prototype.find = function (e) {
                  return this.filter(e).head();
                }),
                (qn.prototype.findLast = function (e) {
                  return this.reverse().find(e);
                }),
                (qn.prototype.invokeMap = Yr(function (e, t) {
                  return "function" == typeof e
                    ? new qn(this)
                    : this.map(function (n) {
                        return Fr(n, e, t);
                      });
                })),
                (qn.prototype.reject = function (e) {
                  return this.filter(Is(so(e)));
                }),
                (qn.prototype.slice = function (e, t) {
                  e = ma(e);
                  var n = this;
                  return n.__filtered__ && (e > 0 || t < 0)
                    ? new qn(n)
                    : (e < 0 ? (n = n.takeRight(-e)) : e && (n = n.drop(e)),
                      t !== i &&
                        (n = (t = ma(t)) < 0 ? n.dropRight(-t) : n.take(t - e)),
                      n);
                }),
                (qn.prototype.takeRightWhile = function (e) {
                  return this.reverse().takeWhile(e).reverse();
                }),
                (qn.prototype.toArray = function () {
                  return this.take(d);
                }),
                Dr(qn.prototype, function (e, t) {
                  var n = /^(?:filter|find|map|reject)|While$/.test(t),
                    r = /^(?:head|last)$/.test(t),
                    o = $n[r ? "take" + ("last" == t ? "Right" : "") : t],
                    s = r || /^find/.test(t);
                  o &&
                    ($n.prototype[t] = function () {
                      var t = this.__wrapped__,
                        a = r ? [1] : arguments,
                        u = t instanceof qn,
                        l = a[0],
                        c = u || Us(t),
                        p = function (e) {
                          var t = o.apply($n, St([e], a));
                          return r && f ? t[0] : t;
                        };
                      c &&
                        n &&
                        "function" == typeof l &&
                        1 != l.length &&
                        (u = c = !1);
                      var f = this.__chain__,
                        d = !!this.__actions__.length,
                        h = s && !f,
                        m = u && !d;
                      if (!s && c) {
                        t = m ? t : new qn(this);
                        var g = e.apply(t, a);
                        return (
                          g.__actions__.push({
                            func: hs,
                            args: [p],
                            thisArg: i,
                          }),
                          new Vn(g, f)
                        );
                      }
                      return h && m
                        ? e.apply(this, a)
                        : ((g = this.thru(p)),
                          h ? (r ? g.value()[0] : g.value()) : g);
                    });
                }),
                Dt(
                  ["pop", "push", "shift", "sort", "splice", "unshift"],
                  function (e) {
                    var t = Te[e],
                      n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                      r = /^(?:pop|shift)$/.test(e);
                    $n.prototype[e] = function () {
                      var e = arguments;
                      if (r && !this.__chain__) {
                        var i = this.value();
                        return t.apply(Us(i) ? i : [], e);
                      }
                      return this[n](function (n) {
                        return t.apply(Us(n) ? n : [], e);
                      });
                    };
                  }
                ),
                Dr(qn.prototype, function (e, t) {
                  var n = $n[t];
                  if (n) {
                    var r = n.name + "";
                    Pe.call(kn, r) || (kn[r] = []),
                      kn[r].push({ name: t, func: n });
                  }
                }),
                (kn[Li(i, 2).name] = [{ name: "wrapper", func: i }]),
                (qn.prototype.clone = function () {
                  var e = new qn(this.__wrapped__);
                  return (
                    (e.__actions__ = _i(this.__actions__)),
                    (e.__dir__ = this.__dir__),
                    (e.__filtered__ = this.__filtered__),
                    (e.__iteratees__ = _i(this.__iteratees__)),
                    (e.__takeCount__ = this.__takeCount__),
                    (e.__views__ = _i(this.__views__)),
                    e
                  );
                }),
                (qn.prototype.reverse = function () {
                  if (this.__filtered__) {
                    var e = new qn(this);
                    (e.__dir__ = -1), (e.__filtered__ = !0);
                  } else (e = this.clone()).__dir__ *= -1;
                  return e;
                }),
                (qn.prototype.value = function () {
                  var e = this.__wrapped__.value(),
                    t = this.__dir__,
                    n = Us(e),
                    r = t < 0,
                    i = n ? e.length : 0,
                    o = (function (e, t, n) {
                      for (var r = -1, i = n.length; ++r < i; ) {
                        var o = n[r],
                          s = o.size;
                        switch (o.type) {
                          case "drop":
                            e += s;
                            break;
                          case "dropRight":
                            t -= s;
                            break;
                          case "take":
                            t = vn(t, e + s);
                            break;
                          case "takeRight":
                            e = yn(e, t - s);
                        }
                      }
                      return { start: e, end: t };
                    })(0, i, this.__views__),
                    s = o.start,
                    a = o.end,
                    u = a - s,
                    l = r ? a : s - 1,
                    c = this.__iteratees__,
                    p = c.length,
                    f = 0,
                    d = vn(u, this.__takeCount__);
                  if (!n || (!r && i == u && d == u))
                    return fi(e, this.__actions__);
                  var h = [];
                  e: for (; u-- && f < d; ) {
                    for (var m = -1, g = e[(l += t)]; ++m < p; ) {
                      var y = c[m],
                        v = y.iteratee,
                        D = y.type,
                        b = v(g);
                      if (2 == D) g = b;
                      else if (!b) {
                        if (1 == D) continue e;
                        break e;
                      }
                    }
                    h[f++] = g;
                  }
                  return h;
                }),
                ($n.prototype.at = ms),
                ($n.prototype.chain = function () {
                  return ds(this);
                }),
                ($n.prototype.commit = function () {
                  return new Vn(this.value(), this.__chain__);
                }),
                ($n.prototype.next = function () {
                  this.__values__ === i && (this.__values__ = da(this.value()));
                  var e = this.__index__ >= this.__values__.length;
                  return {
                    done: e,
                    value: e ? i : this.__values__[this.__index__++],
                  };
                }),
                ($n.prototype.plant = function (e) {
                  for (var t, n = this; n instanceof zn; ) {
                    var r = Ro(n);
                    (r.__index__ = 0),
                      (r.__values__ = i),
                      t ? (o.__wrapped__ = r) : (t = r);
                    var o = r;
                    n = n.__wrapped__;
                  }
                  return (o.__wrapped__ = e), t;
                }),
                ($n.prototype.reverse = function () {
                  var e = this.__wrapped__;
                  if (e instanceof qn) {
                    var t = e;
                    return (
                      this.__actions__.length && (t = new qn(this)),
                      (t = t.reverse()).__actions__.push({
                        func: hs,
                        args: [ts],
                        thisArg: i,
                      }),
                      new Vn(t, this.__chain__)
                    );
                  }
                  return this.thru(ts);
                }),
                ($n.prototype.toJSON =
                  $n.prototype.valueOf =
                  $n.prototype.value =
                    function () {
                      return fi(this.__wrapped__, this.__actions__);
                    }),
                ($n.prototype.first = $n.prototype.head),
                st &&
                  ($n.prototype[st] = function () {
                    return this;
                  }),
                $n
              );
            })();
          (ot._ = ln),
            (r = function () {
              return ln;
            }.call(t, n, t, e)) === i || (e.exports = r);
        }.call(this);
    },
    3945: function (e, t, n) {
      e.exports = (function () {
        "use strict";
        var e =
          "undefined" != typeof globalThis
            ? globalThis
            : "undefined" != typeof window
            ? window
            : void 0 !== n.g
            ? n.g
            : "undefined" != typeof self
            ? self
            : {};
        function t(e) {
          return e && Object.prototype.hasOwnProperty.call(e, "default")
            ? e.default
            : e;
        }
        var r = { version: "2.5.1" },
          i = {},
          o = {};
        !(function (e) {
          function t() {}
          function n(e, t, n, r, i) {
            for (var o = 0, s = t.length, a = 0, u = 0; o < s; o++) {
              var l = t[o];
              if (l.removed) {
                if (
                  ((l.value = e.join(r.slice(u, u + l.count))),
                  (u += l.count),
                  o && t[o - 1].added)
                ) {
                  var c = t[o - 1];
                  (t[o - 1] = t[o]), (t[o] = c);
                }
              } else {
                if (!l.added && i) {
                  var p = n.slice(a, a + l.count);
                  (p = p.map(function (e, t) {
                    var n = r[u + t];
                    return n.length > e.length ? n : e;
                  })),
                    (l.value = e.join(p));
                } else l.value = e.join(n.slice(a, a + l.count));
                (a += l.count), l.added || (u += l.count);
              }
            }
            var f = t[s - 1];
            return (
              s > 1 &&
                "string" == typeof f.value &&
                (f.added || f.removed) &&
                e.equals("", f.value) &&
                ((t[s - 2].value += f.value), t.pop()),
              t
            );
          }
          function r(e) {
            return { newPos: e.newPos, components: e.components.slice(0) };
          }
          Object.defineProperty(e, "__esModule", { value: !0 }),
            (e.default = t),
            (t.prototype = {
              diff: function (e, t) {
                var i =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {},
                  o = i.callback;
                "function" == typeof i && ((o = i), (i = {})),
                  (this.options = i);
                var s = this;
                function a(e) {
                  return o
                    ? (setTimeout(function () {
                        o(void 0, e);
                      }, 0),
                      !0)
                    : e;
                }
                (e = this.castInput(e)),
                  (t = this.castInput(t)),
                  (e = this.removeEmpty(this.tokenize(e)));
                var u = (t = this.removeEmpty(this.tokenize(t))).length,
                  l = e.length,
                  c = 1,
                  p = u + l,
                  f = [{ newPos: -1, components: [] }],
                  d = this.extractCommon(f[0], t, e, 0);
                if (f[0].newPos + 1 >= u && d + 1 >= l)
                  return a([{ value: this.join(t), count: t.length }]);
                function h() {
                  for (var i = -1 * c; i <= c; i += 2) {
                    var o = void 0,
                      p = f[i - 1],
                      d = f[i + 1],
                      h = (d ? d.newPos : 0) - i;
                    p && (f[i - 1] = void 0);
                    var m = p && p.newPos + 1 < u,
                      g = d && 0 <= h && h < l;
                    if (m || g) {
                      if (
                        (!m || (g && p.newPos < d.newPos)
                          ? ((o = r(d)),
                            s.pushComponent(o.components, void 0, !0))
                          : ((o = p).newPos++,
                            s.pushComponent(o.components, !0, void 0)),
                        (h = s.extractCommon(o, t, e, i)),
                        o.newPos + 1 >= u && h + 1 >= l)
                      )
                        return a(n(s, o.components, t, e, s.useLongestToken));
                      f[i] = o;
                    } else f[i] = void 0;
                  }
                  c++;
                }
                if (o)
                  !(function e() {
                    setTimeout(function () {
                      if (c > p) return o();
                      h() || e();
                    }, 0);
                  })();
                else
                  for (; c <= p; ) {
                    var m = h();
                    if (m) return m;
                  }
              },
              pushComponent: function (e, t, n) {
                var r = e[e.length - 1];
                r && r.added === t && r.removed === n
                  ? (e[e.length - 1] = {
                      count: r.count + 1,
                      added: t,
                      removed: n,
                    })
                  : e.push({ count: 1, added: t, removed: n });
              },
              extractCommon: function (e, t, n, r) {
                for (
                  var i = t.length,
                    o = n.length,
                    s = e.newPos,
                    a = s - r,
                    u = 0;
                  s + 1 < i && a + 1 < o && this.equals(t[s + 1], n[a + 1]);

                )
                  s++, a++, u++;
                return u && e.components.push({ count: u }), (e.newPos = s), a;
              },
              equals: function (e, t) {
                return this.options.comparator
                  ? this.options.comparator(e, t)
                  : e === t ||
                      (this.options.ignoreCase &&
                        e.toLowerCase() === t.toLowerCase());
              },
              removeEmpty: function (e) {
                for (var t = [], n = 0; n < e.length; n++) e[n] && t.push(e[n]);
                return t;
              },
              castInput: function (e) {
                return e;
              },
              tokenize: function (e) {
                return e.split("");
              },
              join: function (e) {
                return e.join("");
              },
            });
        })(o);
        var s,
          a = {};
        Object.defineProperty(a, "__esModule", { value: !0 }),
          (a.diffChars = function (e, t, n) {
            return u.diff(e, t, n);
          }),
          (a.characterDiff = void 0);
        var u = new ((s = o) && s.__esModule ? s : { default: s }).default();
        a.characterDiff = u;
        var l = {},
          c = {};
        Object.defineProperty(c, "__esModule", { value: !0 }),
          (c.generateOptions = function (e, t) {
            if ("function" == typeof e) t.callback = e;
            else if (e) for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            return t;
          }),
          Object.defineProperty(l, "__esModule", { value: !0 }),
          (l.diffWords = function (e, t, n) {
            return (
              (n = (0, f.generateOptions)(n, { ignoreWhitespace: !0 })),
              m.diff(e, t, n)
            );
          }),
          (l.diffWordsWithSpace = function (e, t, n) {
            return m.diff(e, t, n);
          }),
          (l.wordDiff = void 0);
        var p = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(o),
          f = c,
          d = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/,
          h = /\S/,
          m = new p.default();
        (l.wordDiff = m),
          (m.equals = function (e, t) {
            return (
              this.options.ignoreCase &&
                ((e = e.toLowerCase()), (t = t.toLowerCase())),
              e === t ||
                (this.options.ignoreWhitespace && !h.test(e) && !h.test(t))
            );
          }),
          (m.tokenize = function (e) {
            for (
              var t = e.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), n = 0;
              n < t.length - 1;
              n++
            )
              !t[n + 1] &&
                t[n + 2] &&
                d.test(t[n]) &&
                d.test(t[n + 2]) &&
                ((t[n] += t[n + 2]), t.splice(n + 1, 2), n--);
            return t;
          });
        var g = {};
        Object.defineProperty(g, "__esModule", { value: !0 }),
          (g.diffLines = function (e, t, n) {
            return D.diff(e, t, n);
          }),
          (g.diffTrimmedLines = function (e, t, n) {
            var r = (0, v.generateOptions)(n, { ignoreWhitespace: !0 });
            return D.diff(e, t, r);
          }),
          (g.lineDiff = void 0);
        var y = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(o),
          v = c,
          D = new y.default();
        (g.lineDiff = D),
          (D.tokenize = function (e) {
            var t = [],
              n = e.split(/(\n|\r\n)/);
            n[n.length - 1] || n.pop();
            for (var r = 0; r < n.length; r++) {
              var i = n[r];
              r % 2 && !this.options.newlineIsToken
                ? (t[t.length - 1] += i)
                : (this.options.ignoreWhitespace && (i = i.trim()), t.push(i));
            }
            return t;
          });
        var b = {};
        Object.defineProperty(b, "__esModule", { value: !0 }),
          (b.diffSentences = function (e, t, n) {
            return C.diff(e, t, n);
          }),
          (b.sentenceDiff = void 0);
        var E = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(o),
          C = new E.default();
        (b.sentenceDiff = C),
          (C.tokenize = function (e) {
            return e.split(/(\S.+?[.!?])(?=\s+|$)/);
          });
        var x = {};
        Object.defineProperty(x, "__esModule", { value: !0 }),
          (x.diffCss = function (e, t, n) {
            return A.diff(e, t, n);
          }),
          (x.cssDiff = void 0);
        var w = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(o),
          A = new w.default();
        (x.cssDiff = A),
          (A.tokenize = function (e) {
            return e.split(/([{}:;,]|\s+)/);
          });
        var S = function (e) {
            return e && e.Math == Math && e;
          },
          _ =
            S("object" == typeof globalThis && globalThis) ||
            S("object" == typeof window && window) ||
            S("object" == typeof self && self) ||
            S("object" == typeof e && e) ||
            (function () {
              return this;
            })() ||
            Function("return this")(),
          T = {},
          F = function (e) {
            try {
              return !!e();
            } catch (e) {
              return !0;
            }
          },
          k = !F(function () {
            return (
              7 !=
              Object.defineProperty({}, 1, {
                get: function () {
                  return 7;
                },
              })[1]
            );
          }),
          O = Function.prototype.call,
          B = O.bind
            ? O.bind(O)
            : function () {
                return O.apply(O, arguments);
              },
          P = {},
          N = {}.propertyIsEnumerable,
          M = Object.getOwnPropertyDescriptor,
          I = M && !N.call({ 1: 2 }, 1);
        P.f = I
          ? function (e) {
              var t = M(this, e);
              return !!t && t.enumerable;
            }
          : N;
        var j,
          L,
          $ = function (e, t) {
            return {
              enumerable: !(1 & e),
              configurable: !(2 & e),
              writable: !(4 & e),
              value: t,
            };
          },
          R = Function.prototype,
          z = R.bind,
          V = R.call,
          q = z && z.bind(V),
          W = z
            ? function (e) {
                return e && q(V, e);
              }
            : function (e) {
                return (
                  e &&
                  function () {
                    return V.apply(e, arguments);
                  }
                );
              },
          U = W,
          H = U({}.toString),
          G = U("".slice),
          Y = function (e) {
            return G(H(e), 8, -1);
          },
          X = W,
          J = F,
          Z = Y,
          K = _.Object,
          Q = X("".split),
          ee = J(function () {
            return !K("z").propertyIsEnumerable(0);
          })
            ? function (e) {
                return "String" == Z(e) ? Q(e, "") : K(e);
              }
            : K,
          te = _.TypeError,
          ne = function (e) {
            if (null == e) throw te("Can't call method on " + e);
            return e;
          },
          re = ee,
          ie = ne,
          oe = function (e) {
            return re(ie(e));
          },
          se = function (e) {
            return "function" == typeof e;
          },
          ae = se,
          ue = function (e) {
            return "object" == typeof e ? null !== e : ae(e);
          },
          le = _,
          ce = se,
          pe = function (e) {
            return ce(e) ? e : void 0;
          },
          fe = function (e, t) {
            return arguments.length < 2 ? pe(le[e]) : le[e] && le[e][t];
          },
          de = W({}.isPrototypeOf),
          he = fe("navigator", "userAgent") || "",
          me = _,
          ge = he,
          ye = me.process,
          ve = me.Deno,
          De = (ye && ye.versions) || (ve && ve.version),
          be = De && De.v8;
        be && (L = (j = be.split("."))[0] > 0 && j[0] < 4 ? 1 : +(j[0] + j[1])),
          !L &&
            ge &&
            (!(j = ge.match(/Edge\/(\d+)/)) || j[1] >= 74) &&
            (j = ge.match(/Chrome\/(\d+)/)) &&
            (L = +j[1]);
        var Ee = L,
          Ce = Ee,
          xe = F,
          we =
            !!Object.getOwnPropertySymbols &&
            !xe(function () {
              var e = Symbol();
              return (
                !String(e) ||
                !(Object(e) instanceof Symbol) ||
                (!Symbol.sham && Ce && Ce < 41)
              );
            }),
          Ae = we && !Symbol.sham && "symbol" == typeof Symbol.iterator,
          Se = fe,
          _e = se,
          Te = de,
          Fe = Ae,
          ke = _.Object,
          Oe = Fe
            ? function (e) {
                return "symbol" == typeof e;
              }
            : function (e) {
                var t = Se("Symbol");
                return _e(t) && Te(t.prototype, ke(e));
              },
          Be = _.String,
          Pe = function (e) {
            try {
              return Be(e);
            } catch (e) {
              return "Object";
            }
          },
          Ne = se,
          Me = Pe,
          Ie = _.TypeError,
          je = function (e) {
            if (Ne(e)) return e;
            throw Ie(Me(e) + " is not a function");
          },
          Le = je,
          $e = function (e, t) {
            var n = e[t];
            return null == n ? void 0 : Le(n);
          },
          Re = B,
          ze = se,
          Ve = ue,
          qe = _.TypeError,
          We = { exports: {} },
          Ue = _,
          He = Object.defineProperty,
          Ge = function (e, t) {
            try {
              He(Ue, e, { value: t, configurable: !0, writable: !0 });
            } catch (n) {
              Ue[e] = t;
            }
            return t;
          },
          Ye = Ge,
          Xe = "__core-js_shared__",
          Je = _[Xe] || Ye(Xe, {}),
          Ze = Je;
        (We.exports = function (e, t) {
          return Ze[e] || (Ze[e] = void 0 !== t ? t : {});
        })("versions", []).push({
          version: "3.19.1",
          mode: "global",
          copyright: "© 2021 Denis Pushkarev (zloirock.ru)",
        });
        var Ke = ne,
          Qe = _.Object,
          et = function (e) {
            return Qe(Ke(e));
          },
          tt = et,
          nt = W({}.hasOwnProperty),
          rt =
            Object.hasOwn ||
            function (e, t) {
              return nt(tt(e), t);
            },
          it = W,
          ot = 0,
          st = Math.random(),
          at = it((1).toString),
          ut = function (e) {
            return (
              "Symbol(" + (void 0 === e ? "" : e) + ")_" + at(++ot + st, 36)
            );
          },
          lt = _,
          ct = We.exports,
          pt = rt,
          ft = ut,
          dt = we,
          ht = Ae,
          mt = ct("wks"),
          gt = lt.Symbol,
          yt = gt && gt.for,
          vt = ht ? gt : (gt && gt.withoutSetter) || ft,
          Dt = function (e) {
            if (!pt(mt, e) || (!dt && "string" != typeof mt[e])) {
              var t = "Symbol." + e;
              dt && pt(gt, e)
                ? (mt[e] = gt[e])
                : (mt[e] = ht && yt ? yt(t) : vt(t));
            }
            return mt[e];
          },
          bt = B,
          Et = ue,
          Ct = Oe,
          xt = $e,
          wt = Dt,
          At = _.TypeError,
          St = wt("toPrimitive"),
          _t = function (e, t) {
            if (!Et(e) || Ct(e)) return e;
            var n,
              r = xt(e, St);
            if (r) {
              if (
                (void 0 === t && (t = "default"),
                (n = bt(r, e, t)),
                !Et(n) || Ct(n))
              )
                return n;
              throw At("Can't convert object to primitive value");
            }
            return (
              void 0 === t && (t = "number"),
              (function (e, t) {
                var n, r;
                if (
                  "string" === t &&
                  ze((n = e.toString)) &&
                  !Ve((r = Re(n, e)))
                )
                  return r;
                if (ze((n = e.valueOf)) && !Ve((r = Re(n, e)))) return r;
                if (
                  "string" !== t &&
                  ze((n = e.toString)) &&
                  !Ve((r = Re(n, e)))
                )
                  return r;
                throw qe("Can't convert object to primitive value");
              })(e, t)
            );
          },
          Tt = Oe,
          Ft = function (e) {
            var t = _t(e, "string");
            return Tt(t) ? t : t + "";
          },
          kt = ue,
          Ot = _.document,
          Bt = kt(Ot) && kt(Ot.createElement),
          Pt = function (e) {
            return Bt ? Ot.createElement(e) : {};
          },
          Nt = Pt,
          Mt =
            !k &&
            !F(function () {
              return (
                7 !=
                Object.defineProperty(Nt("div"), "a", {
                  get: function () {
                    return 7;
                  },
                }).a
              );
            }),
          It = k,
          jt = B,
          Lt = P,
          $t = $,
          Rt = oe,
          zt = Ft,
          Vt = rt,
          qt = Mt,
          Wt = Object.getOwnPropertyDescriptor;
        T.f = It
          ? Wt
          : function (e, t) {
              if (((e = Rt(e)), (t = zt(t)), qt))
                try {
                  return Wt(e, t);
                } catch (e) {}
              if (Vt(e, t)) return $t(!jt(Lt.f, e, t), e[t]);
            };
        var Ut = {},
          Ht = _,
          Gt = ue,
          Yt = Ht.String,
          Xt = Ht.TypeError,
          Jt = function (e) {
            if (Gt(e)) return e;
            throw Xt(Yt(e) + " is not an object");
          },
          Zt = k,
          Kt = Mt,
          Qt = Jt,
          en = Ft,
          tn = _.TypeError,
          nn = Object.defineProperty;
        Ut.f = Zt
          ? nn
          : function (e, t, n) {
              if ((Qt(e), (t = en(t)), Qt(n), Kt))
                try {
                  return nn(e, t, n);
                } catch (e) {}
              if ("get" in n || "set" in n) throw tn("Accessors not supported");
              return "value" in n && (e[t] = n.value), e;
            };
        var rn = Ut,
          on = $,
          sn = k
            ? function (e, t, n) {
                return rn.f(e, t, on(1, n));
              }
            : function (e, t, n) {
                return (e[t] = n), e;
              },
          an = { exports: {} },
          un = se,
          ln = Je,
          cn = W(Function.toString);
        un(ln.inspectSource) ||
          (ln.inspectSource = function (e) {
            return cn(e);
          });
        var pn,
          fn,
          dn,
          hn = ln.inspectSource,
          mn = se,
          gn = hn,
          yn = _.WeakMap,
          vn = mn(yn) && /native code/.test(gn(yn)),
          Dn = We.exports,
          bn = ut,
          En = Dn("keys"),
          Cn = function (e) {
            return En[e] || (En[e] = bn(e));
          },
          xn = {},
          wn = vn,
          An = _,
          Sn = W,
          _n = ue,
          Tn = sn,
          Fn = rt,
          kn = Je,
          On = Cn,
          Bn = xn,
          Pn = "Object already initialized",
          Nn = An.TypeError,
          Mn = An.WeakMap;
        if (wn || kn.state) {
          var In = kn.state || (kn.state = new Mn()),
            jn = Sn(In.get),
            Ln = Sn(In.has),
            $n = Sn(In.set);
          (pn = function (e, t) {
            if (Ln(In, e)) throw new Nn(Pn);
            return (t.facade = e), $n(In, e, t), t;
          }),
            (fn = function (e) {
              return jn(In, e) || {};
            }),
            (dn = function (e) {
              return Ln(In, e);
            });
        } else {
          var Rn = On("state");
          (Bn[Rn] = !0),
            (pn = function (e, t) {
              if (Fn(e, Rn)) throw new Nn(Pn);
              return (t.facade = e), Tn(e, Rn, t), t;
            }),
            (fn = function (e) {
              return Fn(e, Rn) ? e[Rn] : {};
            }),
            (dn = function (e) {
              return Fn(e, Rn);
            });
        }
        var zn = {
            set: pn,
            get: fn,
            has: dn,
            enforce: function (e) {
              return dn(e) ? fn(e) : pn(e, {});
            },
            getterFor: function (e) {
              return function (t) {
                var n;
                if (!_n(t) || (n = fn(t)).type !== e)
                  throw Nn("Incompatible receiver, " + e + " required");
                return n;
              };
            },
          },
          Vn = k,
          qn = rt,
          Wn = Function.prototype,
          Un = Vn && Object.getOwnPropertyDescriptor,
          Hn = qn(Wn, "name"),
          Gn = Hn && (!Vn || (Vn && Un(Wn, "name").configurable)),
          Yn = _,
          Xn = se,
          Jn = rt,
          Zn = sn,
          Kn = Ge,
          Qn = hn,
          er = Gn,
          tr = zn.get,
          nr = zn.enforce,
          rr = String(String).split("String");
        (an.exports = function (e, t, n, r) {
          var i,
            o = !!r && !!r.unsafe,
            s = !!r && !!r.enumerable,
            a = !!r && !!r.noTargetGet,
            u = r && void 0 !== r.name ? r.name : t;
          Xn(n) &&
            ("Symbol(" === String(u).slice(0, 7) &&
              (u = "[" + String(u).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
            (!Jn(n, "name") || (er && n.name !== u)) && Zn(n, "name", u),
            (i = nr(n)).source ||
              (i.source = rr.join("string" == typeof u ? u : ""))),
            e !== Yn
              ? (o ? !a && e[t] && (s = !0) : delete e[t],
                s ? (e[t] = n) : Zn(e, t, n))
              : s
              ? (e[t] = n)
              : Kn(t, n);
        })(Function.prototype, "toString", function () {
          return (Xn(this) && tr(this).source) || Qn(this);
        });
        var ir = {},
          or = Math.ceil,
          sr = Math.floor,
          ar = function (e) {
            var t = +e;
            return t != t || 0 === t ? 0 : (t > 0 ? sr : or)(t);
          },
          ur = ar,
          lr = Math.max,
          cr = Math.min,
          pr = ar,
          fr = Math.min,
          dr = function (e) {
            return (function (e) {
              return e > 0 ? fr(pr(e), 9007199254740991) : 0;
            })(e.length);
          },
          hr = oe,
          mr = dr,
          gr = function (e) {
            return function (t, n, r) {
              var i,
                o = hr(t),
                s = mr(o),
                a = (function (e, t) {
                  var n = ur(e);
                  return n < 0 ? lr(n + t, 0) : cr(n, t);
                })(r, s);
              if (e && n != n) {
                for (; s > a; ) if ((i = o[a++]) != i) return !0;
              } else
                for (; s > a; a++)
                  if ((e || a in o) && o[a] === n) return e || a || 0;
              return !e && -1;
            };
          },
          yr = { includes: gr(!0), indexOf: gr(!1) },
          vr = rt,
          Dr = oe,
          br = yr.indexOf,
          Er = xn,
          Cr = W([].push),
          xr = function (e, t) {
            var n,
              r = Dr(e),
              i = 0,
              o = [];
            for (n in r) !vr(Er, n) && vr(r, n) && Cr(o, n);
            for (; t.length > i; )
              vr(r, (n = t[i++])) && (~br(o, n) || Cr(o, n));
            return o;
          },
          wr = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf",
          ],
          Ar = xr,
          Sr = wr.concat("length", "prototype");
        ir.f =
          Object.getOwnPropertyNames ||
          function (e) {
            return Ar(e, Sr);
          };
        var _r = {};
        _r.f = Object.getOwnPropertySymbols;
        var Tr = fe,
          Fr = ir,
          kr = _r,
          Or = Jt,
          Br = W([].concat),
          Pr =
            Tr("Reflect", "ownKeys") ||
            function (e) {
              var t = Fr.f(Or(e)),
                n = kr.f;
              return n ? Br(t, n(e)) : t;
            },
          Nr = rt,
          Mr = Pr,
          Ir = T,
          jr = Ut,
          Lr = F,
          $r = se,
          Rr = /#|\.prototype\./,
          zr = function (e, t) {
            var n = qr[Vr(e)];
            return n == Ur || (n != Wr && ($r(t) ? Lr(t) : !!t));
          },
          Vr = (zr.normalize = function (e) {
            return String(e).replace(Rr, ".").toLowerCase();
          }),
          qr = (zr.data = {}),
          Wr = (zr.NATIVE = "N"),
          Ur = (zr.POLYFILL = "P"),
          Hr = zr,
          Gr = _,
          Yr = T.f,
          Xr = sn,
          Jr = an.exports,
          Zr = Ge,
          Kr = function (e, t) {
            for (var n = Mr(t), r = jr.f, i = Ir.f, o = 0; o < n.length; o++) {
              var s = n[o];
              Nr(e, s) || r(e, s, i(t, s));
            }
          },
          Qr = Hr,
          ei = function (e, t) {
            var n,
              r,
              i,
              o,
              s,
              a = e.target,
              u = e.global,
              l = e.stat;
            if ((n = u ? Gr : l ? Gr[a] || Zr(a, {}) : (Gr[a] || {}).prototype))
              for (r in t) {
                if (
                  ((o = t[r]),
                  (i = e.noTargetGet ? (s = Yr(n, r)) && s.value : n[r]),
                  !Qr(u ? r : a + (l ? "." : "#") + r, e.forced) &&
                    void 0 !== i)
                ) {
                  if (typeof o == typeof i) continue;
                  Kr(o, i);
                }
                (e.sham || (i && i.sham)) && Xr(o, "sham", !0), Jr(n, r, o, e);
              }
          },
          ti = {};
        ti[Dt("toStringTag")] = "z";
        var ni = _,
          ri = "[object z]" === String(ti),
          ii = se,
          oi = Y,
          si = Dt("toStringTag"),
          ai = ni.Object,
          ui =
            "Arguments" ==
            oi(
              (function () {
                return arguments;
              })()
            ),
          li = ri
            ? oi
            : function (e) {
                var t, n, r;
                return void 0 === e
                  ? "Undefined"
                  : null === e
                  ? "Null"
                  : "string" ==
                    typeof (n = (function (e, t) {
                      try {
                        return e[t];
                      } catch (e) {}
                    })((t = ai(e)), si))
                  ? n
                  : ui
                  ? oi(t)
                  : "Object" == (r = oi(t)) && ii(t.callee)
                  ? "Arguments"
                  : r;
              },
          ci = li,
          pi = _.String,
          fi = W([].slice),
          di = Math.floor,
          hi = function (e, t) {
            var n = e.length,
              r = di(n / 2);
            return n < 8
              ? mi(e, t)
              : gi(e, hi(fi(e, 0, r), t), hi(fi(e, r), t), t);
          },
          mi = function (e, t) {
            for (var n, r, i = e.length, o = 1; o < i; ) {
              for (r = o, n = e[o]; r && t(e[r - 1], n) > 0; ) e[r] = e[--r];
              r !== o++ && (e[r] = n);
            }
            return e;
          },
          gi = function (e, t, n, r) {
            for (var i = t.length, o = n.length, s = 0, a = 0; s < i || a < o; )
              e[s + a] =
                s < i && a < o
                  ? r(t[s], n[a]) <= 0
                    ? t[s++]
                    : n[a++]
                  : s < i
                  ? t[s++]
                  : n[a++];
            return e;
          },
          yi = hi,
          vi = F,
          Di = he.match(/firefox\/(\d+)/i),
          bi = !!Di && +Di[1],
          Ei = /MSIE|Trident/.test(he),
          Ci = he.match(/AppleWebKit\/(\d+)\./),
          xi = !!Ci && +Ci[1],
          wi = ei,
          Ai = W,
          Si = je,
          _i = et,
          Ti = dr,
          Fi = function (e) {
            if ("Symbol" === ci(e))
              throw TypeError("Cannot convert a Symbol value to a string");
            return pi(e);
          },
          ki = F,
          Oi = yi,
          Bi = bi,
          Pi = Ei,
          Ni = Ee,
          Mi = xi,
          Ii = [],
          ji = Ai(Ii.sort),
          Li = Ai(Ii.push),
          $i = ki(function () {
            Ii.sort(void 0);
          }),
          Ri = ki(function () {
            Ii.sort(null);
          }),
          zi = (function (e, t) {
            var n = [][e];
            return (
              !!n &&
              vi(function () {
                n.call(
                  null,
                  t ||
                    function () {
                      throw 1;
                    },
                  1
                );
              })
            );
          })("sort"),
          Vi = !ki(function () {
            if (Ni) return Ni < 70;
            if (!(Bi && Bi > 3)) {
              if (Pi) return !0;
              if (Mi) return Mi < 603;
              var e,
                t,
                n,
                r,
                i = "";
              for (e = 65; e < 76; e++) {
                switch (((t = String.fromCharCode(e)), e)) {
                  case 66:
                  case 69:
                  case 70:
                  case 72:
                    n = 3;
                    break;
                  case 68:
                  case 71:
                    n = 4;
                    break;
                  default:
                    n = 2;
                }
                for (r = 0; r < 47; r++) Ii.push({ k: t + r, v: n });
              }
              for (
                Ii.sort(function (e, t) {
                  return t.v - e.v;
                }),
                  r = 0;
                r < Ii.length;
                r++
              )
                (t = Ii[r].k.charAt(0)),
                  i.charAt(i.length - 1) !== t && (i += t);
              return "DGBEFHACIJK" !== i;
            }
          });
        wi(
          { target: "Array", proto: !0, forced: $i || !Ri || !zi || !Vi },
          {
            sort: function (e) {
              void 0 !== e && Si(e);
              var t = _i(this);
              if (Vi) return void 0 === e ? ji(t) : ji(t, e);
              var n,
                r,
                i = [],
                o = Ti(t);
              for (r = 0; r < o; r++) r in t && Li(i, t[r]);
              for (
                Oi(
                  i,
                  (function (e) {
                    return function (t, n) {
                      return void 0 === n
                        ? -1
                        : void 0 === t
                        ? 1
                        : void 0 !== e
                        ? +e(t, n) || 0
                        : Fi(t) > Fi(n)
                        ? 1
                        : -1;
                    };
                  })(e)
                ),
                  n = i.length,
                  r = 0;
                r < n;

              )
                t[r] = i[r++];
              for (; r < o; ) delete t[r++];
              return t;
            },
          }
        );
        var qi = {};
        Object.defineProperty(qi, "__esModule", { value: !0 }),
          (qi.diffJson = function (e, t, n) {
            return Yi.diff(e, t, n);
          }),
          (qi.canonicalize = Xi),
          (qi.jsonDiff = void 0);
        var Wi = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(o),
          Ui = g;
        function Hi(e) {
          return (
            (Hi =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            Hi(e)
          );
        }
        var Gi = Object.prototype.toString,
          Yi = new Wi.default();
        function Xi(e, t, n, r, i) {
          var o, s;
          for (
            t = t || [], n = n || [], r && (e = r(i, e)), o = 0;
            o < t.length;
            o += 1
          )
            if (t[o] === e) return n[o];
          if ("[object Array]" === Gi.call(e)) {
            for (
              t.push(e), s = new Array(e.length), n.push(s), o = 0;
              o < e.length;
              o += 1
            )
              s[o] = Xi(e[o], t, n, r, i);
            return t.pop(), n.pop(), s;
          }
          if (
            (e && e.toJSON && (e = e.toJSON()),
            "object" === Hi(e) && null !== e)
          ) {
            t.push(e), (s = {}), n.push(s);
            var a,
              u = [];
            for (a in e) e.hasOwnProperty(a) && u.push(a);
            for (u.sort(), o = 0; o < u.length; o += 1)
              s[(a = u[o])] = Xi(e[a], t, n, r, a);
            t.pop(), n.pop();
          } else s = e;
          return s;
        }
        (qi.jsonDiff = Yi),
          (Yi.useLongestToken = !0),
          (Yi.tokenize = Ui.lineDiff.tokenize),
          (Yi.castInput = function (e) {
            var t = this.options,
              n = t.undefinedReplacement,
              r = t.stringifyReplacer,
              i =
                void 0 === r
                  ? function (e, t) {
                      return void 0 === t ? n : t;
                    }
                  : r;
            return "string" == typeof e
              ? e
              : JSON.stringify(Xi(e, null, null, i), i, "  ");
          }),
          (Yi.equals = function (e, t) {
            return Wi.default.prototype.equals.call(
              Yi,
              e.replace(/,([\r\n])/g, "$1"),
              t.replace(/,([\r\n])/g, "$1")
            );
          });
        var Ji = {};
        Object.defineProperty(Ji, "__esModule", { value: !0 }),
          (Ji.diffArrays = function (e, t, n) {
            return Ki.diff(e, t, n);
          }),
          (Ji.arrayDiff = void 0);
        var Zi = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(o),
          Ki = new Zi.default();
        (Ji.arrayDiff = Ki),
          (Ki.tokenize = function (e) {
            return e.slice();
          }),
          (Ki.join = Ki.removeEmpty =
            function (e) {
              return e;
            });
        var Qi = {},
          eo = {};
        Object.defineProperty(eo, "__esModule", { value: !0 }),
          (eo.parsePatch = function (e) {
            var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              n = e.split(/\r\n|[\n\v\f\r\x85]/),
              r = e.match(/\r\n|[\n\v\f\r\x85]/g) || [],
              i = [],
              o = 0;
            function s() {
              var e = {};
              for (i.push(e); o < n.length; ) {
                var r = n[o];
                if (/^(\-\-\-|\+\+\+|@@)\s/.test(r)) break;
                var s = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(r);
                s && (e.index = s[1]), o++;
              }
              for (a(e), a(e), e.hunks = []; o < n.length; ) {
                var l = n[o];
                if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(l)) break;
                if (/^@@/.test(l)) e.hunks.push(u());
                else {
                  if (l && t.strict)
                    throw new Error(
                      "Unknown line " + (o + 1) + " " + JSON.stringify(l)
                    );
                  o++;
                }
              }
            }
            function a(e) {
              var t = /^(---|\+\+\+)\s+(.*)$/.exec(n[o]);
              if (t) {
                var r = "---" === t[1] ? "old" : "new",
                  i = t[2].split("\t", 2),
                  s = i[0].replace(/\\\\/g, "\\");
                /^".*"$/.test(s) && (s = s.substr(1, s.length - 2)),
                  (e[r + "FileName"] = s),
                  (e[r + "Header"] = (i[1] || "").trim()),
                  o++;
              }
            }
            function u() {
              var e = o,
                i = n[o++].split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/),
                s = {
                  oldStart: +i[1],
                  oldLines: void 0 === i[2] ? 1 : +i[2],
                  newStart: +i[3],
                  newLines: void 0 === i[4] ? 1 : +i[4],
                  lines: [],
                  linedelimiters: [],
                };
              0 === s.oldLines && (s.oldStart += 1),
                0 === s.newLines && (s.newStart += 1);
              for (
                var a = 0, u = 0;
                o < n.length &&
                !(
                  0 === n[o].indexOf("--- ") &&
                  o + 2 < n.length &&
                  0 === n[o + 1].indexOf("+++ ") &&
                  0 === n[o + 2].indexOf("@@")
                );
                o++
              ) {
                var l = 0 == n[o].length && o != n.length - 1 ? " " : n[o][0];
                if ("+" !== l && "-" !== l && " " !== l && "\\" !== l) break;
                s.lines.push(n[o]),
                  s.linedelimiters.push(r[o] || "\n"),
                  "+" === l ? a++ : "-" === l ? u++ : " " === l && (a++, u++);
              }
              if (
                (a || 1 !== s.newLines || (s.newLines = 0),
                u || 1 !== s.oldLines || (s.oldLines = 0),
                t.strict)
              ) {
                if (a !== s.newLines)
                  throw new Error(
                    "Added line count did not match for hunk at line " + (e + 1)
                  );
                if (u !== s.oldLines)
                  throw new Error(
                    "Removed line count did not match for hunk at line " +
                      (e + 1)
                  );
              }
              return s;
            }
            for (; o < n.length; ) s();
            return i;
          });
        var to = {};
        !(function (e) {
          Object.defineProperty(e, "__esModule", { value: !0 }),
            (e.default = function (e, t, n) {
              var r = !0,
                i = !1,
                o = !1,
                s = 1;
              return function a() {
                if (r && !o) {
                  if ((i ? s++ : (r = !1), e + s <= n)) return s;
                  o = !0;
                }
                if (!i)
                  return o || (r = !0), t <= e - s ? -s++ : ((i = !0), a());
              };
            });
        })(to),
          Object.defineProperty(Qi, "__esModule", { value: !0 }),
          (Qi.applyPatch = io),
          (Qi.applyPatches = function (e, t) {
            "string" == typeof e && (e = (0, no.parsePatch)(e));
            var n = 0;
            !(function r() {
              var i = e[n++];
              if (!i) return t.complete();
              t.loadFile(i, function (e, n) {
                if (e) return t.complete(e);
                var o = io(n, i, t);
                t.patched(i, o, function (e) {
                  if (e) return t.complete(e);
                  r();
                });
              });
            })();
          });
        var no = eo,
          ro = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(to);
        function io(e, t) {
          var n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (
            ("string" == typeof t && (t = (0, no.parsePatch)(t)),
            Array.isArray(t))
          ) {
            if (t.length > 1)
              throw new Error("applyPatch only works with a single input.");
            t = t[0];
          }
          var r,
            i,
            o = e.split(/\r\n|[\n\v\f\r\x85]/),
            s = e.match(/\r\n|[\n\v\f\r\x85]/g) || [],
            a = t.hunks,
            u =
              n.compareLine ||
              function (e, t, n, r) {
                return t === r;
              },
            l = 0,
            c = n.fuzzFactor || 0,
            p = 0,
            f = 0;
          function d(e, t) {
            for (var n = 0; n < e.lines.length; n++) {
              var r = e.lines[n],
                i = r.length > 0 ? r[0] : " ",
                s = r.length > 0 ? r.substr(1) : r;
              if (" " === i || "-" === i) {
                if (!u(t + 1, o[t], i, s) && ++l > c) return !1;
                t++;
              }
            }
            return !0;
          }
          for (var h = 0; h < a.length; h++) {
            for (
              var m = a[h],
                g = o.length - m.oldLines,
                y = 0,
                v = f + m.oldStart - 1,
                D = (0, ro.default)(v, p, g);
              void 0 !== y;
              y = D()
            )
              if (d(m, v + y)) {
                m.offset = f += y;
                break;
              }
            if (void 0 === y) return !1;
            p = m.offset + m.oldStart + m.oldLines;
          }
          for (var b = 0, E = 0; E < a.length; E++) {
            var C = a[E],
              x = C.oldStart + C.offset + b - 1;
            b += C.newLines - C.oldLines;
            for (var w = 0; w < C.lines.length; w++) {
              var A = C.lines[w],
                S = A.length > 0 ? A[0] : " ",
                _ = A.length > 0 ? A.substr(1) : A,
                T = C.linedelimiters[w];
              if (" " === S) x++;
              else if ("-" === S) o.splice(x, 1), s.splice(x, 1);
              else if ("+" === S) o.splice(x, 0, _), s.splice(x, 0, T), x++;
              else if ("\\" === S) {
                var F = C.lines[w - 1] ? C.lines[w - 1][0] : null;
                "+" === F ? (r = !0) : "-" === F && (i = !0);
              }
            }
          }
          if (r) for (; !o[o.length - 1]; ) o.pop(), s.pop();
          else i && (o.push(""), s.push("\n"));
          for (var k = 0; k < o.length - 1; k++) o[k] = o[k] + s[k];
          return o.join("");
        }
        var oo = {},
          so = {};
        Object.defineProperty(so, "__esModule", { value: !0 }),
          (so.structuredPatch = co),
          (so.formatPatch = po),
          (so.createTwoFilesPatch = fo),
          (so.createPatch = function (e, t, n, r, i, o) {
            return fo(e, e, t, n, r, i, o);
          });
        var ao = g;
        function uo(e) {
          return (
            (function (e) {
              if (Array.isArray(e)) return lo(e);
            })(e) ||
            (function (e) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
                return Array.from(e);
            })(e) ||
            (function (e, t) {
              if (e) {
                if ("string" == typeof e) return lo(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return (
                  "Object" === n && e.constructor && (n = e.constructor.name),
                  "Map" === n || "Set" === n
                    ? Array.from(e)
                    : "Arguments" === n ||
                      /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                    ? lo(e, t)
                    : void 0
                );
              }
            })(e) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function lo(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function co(e, t, n, r, i, o, s) {
          s || (s = {}), void 0 === s.context && (s.context = 4);
          var a = (0, ao.diffLines)(n, r, s);
          function u(e) {
            return e.map(function (e) {
              return " " + e;
            });
          }
          a.push({ value: "", lines: [] });
          for (
            var l = [],
              c = 0,
              p = 0,
              f = [],
              d = 1,
              h = 1,
              m = function (e) {
                var t = a[e],
                  i = t.lines || t.value.replace(/\n$/, "").split("\n");
                if (((t.lines = i), t.added || t.removed)) {
                  var o;
                  if (!c) {
                    var m = a[e - 1];
                    (c = d),
                      (p = h),
                      m &&
                        ((f =
                          s.context > 0 ? u(m.lines.slice(-s.context)) : []),
                        (c -= f.length),
                        (p -= f.length));
                  }
                  (o = f).push.apply(
                    o,
                    uo(
                      i.map(function (e) {
                        return (t.added ? "+" : "-") + e;
                      })
                    )
                  ),
                    t.added ? (h += i.length) : (d += i.length);
                } else {
                  if (c)
                    if (i.length <= 2 * s.context && e < a.length - 2) {
                      var g;
                      (g = f).push.apply(g, uo(u(i)));
                    } else {
                      var y,
                        v = Math.min(i.length, s.context);
                      (y = f).push.apply(y, uo(u(i.slice(0, v))));
                      var D = {
                        oldStart: c,
                        oldLines: d - c + v,
                        newStart: p,
                        newLines: h - p + v,
                        lines: f,
                      };
                      if (e >= a.length - 2 && i.length <= s.context) {
                        var b = /\n$/.test(n),
                          E = /\n$/.test(r),
                          C = 0 == i.length && f.length > D.oldLines;
                        !b &&
                          C &&
                          n.length > 0 &&
                          f.splice(
                            D.oldLines,
                            0,
                            "\\ No newline at end of file"
                          ),
                          ((b || C) && E) ||
                            f.push("\\ No newline at end of file");
                      }
                      l.push(D), (c = 0), (p = 0), (f = []);
                    }
                  (d += i.length), (h += i.length);
                }
              },
              g = 0;
            g < a.length;
            g++
          )
            m(g);
          return {
            oldFileName: e,
            newFileName: t,
            oldHeader: i,
            newHeader: o,
            hunks: l,
          };
        }
        function po(e) {
          var t = [];
          e.oldFileName == e.newFileName && t.push("Index: " + e.oldFileName),
            t.push(
              "==================================================================="
            ),
            t.push(
              "--- " +
                e.oldFileName +
                (void 0 === e.oldHeader ? "" : "\t" + e.oldHeader)
            ),
            t.push(
              "+++ " +
                e.newFileName +
                (void 0 === e.newHeader ? "" : "\t" + e.newHeader)
            );
          for (var n = 0; n < e.hunks.length; n++) {
            var r = e.hunks[n];
            0 === r.oldLines && (r.oldStart -= 1),
              0 === r.newLines && (r.newStart -= 1),
              t.push(
                "@@ -" +
                  r.oldStart +
                  "," +
                  r.oldLines +
                  " +" +
                  r.newStart +
                  "," +
                  r.newLines +
                  " @@"
              ),
              t.push.apply(t, r.lines);
          }
          return t.join("\n") + "\n";
        }
        function fo(e, t, n, r, i, o, s) {
          return po(co(e, t, n, r, i, o, s));
        }
        var ho = {};
        function mo(e, t) {
          if (t.length > e.length) return !1;
          for (var n = 0; n < t.length; n++) if (t[n] !== e[n]) return !1;
          return !0;
        }
        Object.defineProperty(ho, "__esModule", { value: !0 }),
          (ho.arrayEqual = function (e, t) {
            return e.length === t.length && mo(e, t);
          }),
          (ho.arrayStartsWith = mo),
          Object.defineProperty(oo, "__esModule", { value: !0 }),
          (oo.calcLineCount = Eo),
          (oo.merge = function (e, t, n) {
            (e = Co(e, n)), (t = Co(t, n));
            var r = {};
            (e.index || t.index) && (r.index = e.index || t.index),
              (e.newFileName || t.newFileName) &&
                (xo(e)
                  ? xo(t)
                    ? ((r.oldFileName = wo(r, e.oldFileName, t.oldFileName)),
                      (r.newFileName = wo(r, e.newFileName, t.newFileName)),
                      (r.oldHeader = wo(r, e.oldHeader, t.oldHeader)),
                      (r.newHeader = wo(r, e.newHeader, t.newHeader)))
                    : ((r.oldFileName = e.oldFileName),
                      (r.newFileName = e.newFileName),
                      (r.oldHeader = e.oldHeader),
                      (r.newHeader = e.newHeader))
                  : ((r.oldFileName = t.oldFileName || e.oldFileName),
                    (r.newFileName = t.newFileName || e.newFileName),
                    (r.oldHeader = t.oldHeader || e.oldHeader),
                    (r.newHeader = t.newHeader || e.newHeader))),
              (r.hunks = []);
            for (
              var i = 0, o = 0, s = 0, a = 0;
              i < e.hunks.length || o < t.hunks.length;

            ) {
              var u = e.hunks[i] || { oldStart: 1 / 0 },
                l = t.hunks[o] || { oldStart: 1 / 0 };
              if (Ao(u, l))
                r.hunks.push(So(u, s)), i++, (a += u.newLines - u.oldLines);
              else if (Ao(l, u))
                r.hunks.push(So(l, a)), o++, (s += l.newLines - l.oldLines);
              else {
                var c = {
                  oldStart: Math.min(u.oldStart, l.oldStart),
                  oldLines: 0,
                  newStart: Math.min(u.newStart + s, l.oldStart + a),
                  newLines: 0,
                  lines: [],
                };
                _o(c, u.oldStart, u.lines, l.oldStart, l.lines),
                  o++,
                  i++,
                  r.hunks.push(c);
              }
            }
            return r;
          });
        var go = so,
          yo = eo,
          vo = ho;
        function Do(e) {
          return (
            (function (e) {
              if (Array.isArray(e)) return bo(e);
            })(e) ||
            (function (e) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
                return Array.from(e);
            })(e) ||
            (function (e, t) {
              if (e) {
                if ("string" == typeof e) return bo(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return (
                  "Object" === n && e.constructor && (n = e.constructor.name),
                  "Map" === n || "Set" === n
                    ? Array.from(e)
                    : "Arguments" === n ||
                      /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                    ? bo(e, t)
                    : void 0
                );
              }
            })(e) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function bo(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function Eo(e) {
          var t = Io(e.lines),
            n = t.oldLines,
            r = t.newLines;
          void 0 !== n ? (e.oldLines = n) : delete e.oldLines,
            void 0 !== r ? (e.newLines = r) : delete e.newLines;
        }
        function Co(e, t) {
          if ("string" == typeof e) {
            if (/^@@/m.test(e) || /^Index:/m.test(e))
              return (0, yo.parsePatch)(e)[0];
            if (!t)
              throw new Error(
                "Must provide a base reference or pass in a patch"
              );
            return (0, go.structuredPatch)(void 0, void 0, t, e);
          }
          return e;
        }
        function xo(e) {
          return e.newFileName && e.newFileName !== e.oldFileName;
        }
        function wo(e, t, n) {
          return t === n ? t : ((e.conflict = !0), { mine: t, theirs: n });
        }
        function Ao(e, t) {
          return (
            e.oldStart < t.oldStart && e.oldStart + e.oldLines < t.oldStart
          );
        }
        function So(e, t) {
          return {
            oldStart: e.oldStart,
            oldLines: e.oldLines,
            newStart: e.newStart + t,
            newLines: e.newLines,
            lines: e.lines,
          };
        }
        function _o(e, t, n, r, i) {
          var o = { offset: t, lines: n, index: 0 },
            s = { offset: r, lines: i, index: 0 };
          for (
            Oo(e, o, s), Oo(e, s, o);
            o.index < o.lines.length && s.index < s.lines.length;

          ) {
            var a = o.lines[o.index],
              u = s.lines[s.index];
            if (
              ("-" !== a[0] && "+" !== a[0]) ||
              ("-" !== u[0] && "+" !== u[0])
            )
              if ("+" === a[0] && " " === u[0]) {
                var l;
                (l = e.lines).push.apply(l, Do(Po(o)));
              } else if ("+" === u[0] && " " === a[0]) {
                var c;
                (c = e.lines).push.apply(c, Do(Po(s)));
              } else
                "-" === a[0] && " " === u[0]
                  ? Fo(e, o, s)
                  : "-" === u[0] && " " === a[0]
                  ? Fo(e, s, o, !0)
                  : a === u
                  ? (e.lines.push(a), o.index++, s.index++)
                  : ko(e, Po(o), Po(s));
            else To(e, o, s);
          }
          Bo(e, o), Bo(e, s), Eo(e);
        }
        function To(e, t, n) {
          var r = Po(t),
            i = Po(n);
          if (No(r) && No(i)) {
            var o, s;
            if ((0, vo.arrayStartsWith)(r, i) && Mo(n, r, r.length - i.length))
              return void (o = e.lines).push.apply(o, Do(r));
            if ((0, vo.arrayStartsWith)(i, r) && Mo(t, i, i.length - r.length))
              return void (s = e.lines).push.apply(s, Do(i));
          } else if ((0, vo.arrayEqual)(r, i)) {
            var a;
            return void (a = e.lines).push.apply(a, Do(r));
          }
          ko(e, r, i);
        }
        function Fo(e, t, n, r) {
          var i,
            o = Po(t),
            s = (function (e, t) {
              for (
                var n = [], r = [], i = 0, o = !1, s = !1;
                i < t.length && e.index < e.lines.length;

              ) {
                var a = e.lines[e.index],
                  u = t[i];
                if ("+" === u[0]) break;
                if (((o = o || " " !== a[0]), r.push(u), i++, "+" === a[0]))
                  for (s = !0; "+" === a[0]; )
                    n.push(a), (a = e.lines[++e.index]);
                u.substr(1) === a.substr(1) ? (n.push(a), e.index++) : (s = !0);
              }
              if (("+" === (t[i] || "")[0] && o && (s = !0), s)) return n;
              for (; i < t.length; ) r.push(t[i++]);
              return { merged: r, changes: n };
            })(n, o);
          s.merged
            ? (i = e.lines).push.apply(i, Do(s.merged))
            : ko(e, r ? s : o, r ? o : s);
        }
        function ko(e, t, n) {
          (e.conflict = !0), e.lines.push({ conflict: !0, mine: t, theirs: n });
        }
        function Oo(e, t, n) {
          for (; t.offset < n.offset && t.index < t.lines.length; ) {
            var r = t.lines[t.index++];
            e.lines.push(r), t.offset++;
          }
        }
        function Bo(e, t) {
          for (; t.index < t.lines.length; ) {
            var n = t.lines[t.index++];
            e.lines.push(n);
          }
        }
        function Po(e) {
          for (
            var t = [], n = e.lines[e.index][0];
            e.index < e.lines.length;

          ) {
            var r = e.lines[e.index];
            if (("-" === n && "+" === r[0] && (n = "+"), n !== r[0])) break;
            t.push(r), e.index++;
          }
          return t;
        }
        function No(e) {
          return e.reduce(function (e, t) {
            return e && "-" === t[0];
          }, !0);
        }
        function Mo(e, t, n) {
          for (var r = 0; r < n; r++) {
            var i = t[t.length - n + r].substr(1);
            if (e.lines[e.index + r] !== " " + i) return !1;
          }
          return (e.index += n), !0;
        }
        function Io(e) {
          var t = 0,
            n = 0;
          return (
            e.forEach(function (e) {
              if ("string" != typeof e) {
                var r = Io(e.mine),
                  i = Io(e.theirs);
                void 0 !== t &&
                  (r.oldLines === i.oldLines
                    ? (t += r.oldLines)
                    : (t = void 0)),
                  void 0 !== n &&
                    (r.newLines === i.newLines
                      ? (n += r.newLines)
                      : (n = void 0));
              } else void 0 === n || ("+" !== e[0] && " " !== e[0]) || n++, void 0 === t || ("-" !== e[0] && " " !== e[0]) || t++;
            }),
            { oldLines: t, newLines: n }
          );
        }
        var jo = {};
        Object.defineProperty(jo, "__esModule", { value: !0 }),
          (jo.convertChangesToDMP = function (e) {
            for (var t, n, r = [], i = 0; i < e.length; i++)
              (n = (t = e[i]).added ? 1 : t.removed ? -1 : 0),
                r.push([n, t.value]);
            return r;
          });
        var Lo = {};
        function $o(e) {
          return e
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
        }
        function Ro(e) {
          return { type: "concat", parts: e };
        }
        function zo(e) {
          return { type: "indent", contents: e };
        }
        function Vo(e, t) {
          return { type: "align", contents: t, n: e };
        }
        function qo(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return {
            type: "group",
            id: t.id,
            contents: e,
            break: Boolean(t.shouldBreak),
            expandedStates: t.expandedStates,
          };
        }
        Object.defineProperty(Lo, "__esModule", { value: !0 }),
          (Lo.convertChangesToXML = function (e) {
            for (var t = [], n = 0; n < e.length; n++) {
              var r = e[n];
              r.added ? t.push("<ins>") : r.removed && t.push("<del>"),
                t.push($o(r.value)),
                r.added ? t.push("</ins>") : r.removed && t.push("</del>");
            }
            return t.join("");
          }),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 }),
              Object.defineProperty(e, "Diff", {
                enumerable: !0,
                get: function () {
                  return t.default;
                },
              }),
              Object.defineProperty(e, "diffChars", {
                enumerable: !0,
                get: function () {
                  return n.diffChars;
                },
              }),
              Object.defineProperty(e, "diffWords", {
                enumerable: !0,
                get: function () {
                  return r.diffWords;
                },
              }),
              Object.defineProperty(e, "diffWordsWithSpace", {
                enumerable: !0,
                get: function () {
                  return r.diffWordsWithSpace;
                },
              }),
              Object.defineProperty(e, "diffLines", {
                enumerable: !0,
                get: function () {
                  return i.diffLines;
                },
              }),
              Object.defineProperty(e, "diffTrimmedLines", {
                enumerable: !0,
                get: function () {
                  return i.diffTrimmedLines;
                },
              }),
              Object.defineProperty(e, "diffSentences", {
                enumerable: !0,
                get: function () {
                  return s.diffSentences;
                },
              }),
              Object.defineProperty(e, "diffCss", {
                enumerable: !0,
                get: function () {
                  return u.diffCss;
                },
              }),
              Object.defineProperty(e, "diffJson", {
                enumerable: !0,
                get: function () {
                  return c.diffJson;
                },
              }),
              Object.defineProperty(e, "canonicalize", {
                enumerable: !0,
                get: function () {
                  return c.canonicalize;
                },
              }),
              Object.defineProperty(e, "diffArrays", {
                enumerable: !0,
                get: function () {
                  return p.diffArrays;
                },
              }),
              Object.defineProperty(e, "applyPatch", {
                enumerable: !0,
                get: function () {
                  return f.applyPatch;
                },
              }),
              Object.defineProperty(e, "applyPatches", {
                enumerable: !0,
                get: function () {
                  return f.applyPatches;
                },
              }),
              Object.defineProperty(e, "parsePatch", {
                enumerable: !0,
                get: function () {
                  return d.parsePatch;
                },
              }),
              Object.defineProperty(e, "merge", {
                enumerable: !0,
                get: function () {
                  return h.merge;
                },
              }),
              Object.defineProperty(e, "structuredPatch", {
                enumerable: !0,
                get: function () {
                  return m.structuredPatch;
                },
              }),
              Object.defineProperty(e, "createTwoFilesPatch", {
                enumerable: !0,
                get: function () {
                  return m.createTwoFilesPatch;
                },
              }),
              Object.defineProperty(e, "createPatch", {
                enumerable: !0,
                get: function () {
                  return m.createPatch;
                },
              }),
              Object.defineProperty(e, "convertChangesToDMP", {
                enumerable: !0,
                get: function () {
                  return y.convertChangesToDMP;
                },
              }),
              Object.defineProperty(e, "convertChangesToXML", {
                enumerable: !0,
                get: function () {
                  return v.convertChangesToXML;
                },
              });
            var t = (function (e) {
                return e && e.__esModule ? e : { default: e };
              })(o),
              n = a,
              r = l,
              i = g,
              s = b,
              u = x,
              c = qi,
              p = Ji,
              f = Qi,
              d = eo,
              h = oo,
              m = so,
              y = jo,
              v = Lo;
          })(i);
        const Wo = { type: "break-parent" },
          Uo = { type: "line", hard: !0 },
          Ho = { type: "line", hard: !0, literal: !0 },
          Go = Ro([Uo, Wo]),
          Yo = Ro([Ho, Wo]);
        var Xo = {
            concat: Ro,
            join: function (e, t) {
              const n = [];
              for (let r = 0; r < t.length; r++)
                0 !== r && n.push(e), n.push(t[r]);
              return Ro(n);
            },
            line: { type: "line" },
            softline: { type: "line", soft: !0 },
            hardline: Go,
            literalline: Yo,
            group: qo,
            conditionalGroup: function (e, t) {
              return qo(
                e[0],
                Object.assign(Object.assign({}, t), {}, { expandedStates: e })
              );
            },
            fill: function (e) {
              return { type: "fill", parts: e };
            },
            lineSuffix: function (e) {
              return { type: "line-suffix", contents: e };
            },
            lineSuffixBoundary: { type: "line-suffix-boundary" },
            cursor: { type: "cursor", placeholder: Symbol("cursor") },
            breakParent: Wo,
            ifBreak: function (e, t) {
              return {
                type: "if-break",
                breakContents: e,
                flatContents: t,
                groupId: (arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : {}
                ).groupId,
              };
            },
            trim: { type: "trim" },
            indent: zo,
            indentIfBreak: function (e, t) {
              return {
                type: "indent-if-break",
                contents: e,
                groupId: t.groupId,
                negate: t.negate,
              };
            },
            align: Vo,
            addAlignmentToDoc: function (e, t, n) {
              let r = e;
              if (t > 0) {
                for (let e = 0; e < Math.floor(t / n); ++e) r = zo(r);
                (r = Vo(t % n, r)), (r = Vo(Number.NEGATIVE_INFINITY, r));
              }
              return r;
            },
            markAsRoot: function (e) {
              return Vo({ type: "root" }, e);
            },
            dedentToRoot: function (e) {
              return Vo(Number.NEGATIVE_INFINITY, e);
            },
            dedent: function (e) {
              return Vo(-1, e);
            },
            hardlineWithoutBreakParent: Uo,
            literallineWithoutBreakParent: Ho,
            label: function (e, t) {
              return { type: "label", label: e, contents: t };
            },
          },
          Jo = { exports: {} };
        var Zo = { exports: {} };
        const Ko = (e) =>
          !Number.isNaN(e) &&
          e >= 4352 &&
          (e <= 4447 ||
            9001 === e ||
            9002 === e ||
            (11904 <= e && e <= 12871 && 12351 !== e) ||
            (12880 <= e && e <= 19903) ||
            (19968 <= e && e <= 42182) ||
            (43360 <= e && e <= 43388) ||
            (44032 <= e && e <= 55203) ||
            (63744 <= e && e <= 64255) ||
            (65040 <= e && e <= 65049) ||
            (65072 <= e && e <= 65131) ||
            (65281 <= e && e <= 65376) ||
            (65504 <= e && e <= 65510) ||
            (110592 <= e && e <= 110593) ||
            (127488 <= e && e <= 127569) ||
            (131072 <= e && e <= 262141));
        (Zo.exports = Ko), (Zo.exports.default = Ko);
        const Qo = (e) =>
            "string" == typeof e
              ? e.replace(
                  (function () {
                    let { onlyFirst: e = !1 } =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : {};
                    const t = [
                      "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
                      "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))",
                    ].join("|");
                    return new RegExp(t, e ? void 0 : "g");
                  })(),
                  ""
                )
              : e,
          es = Zo.exports,
          ts = (e) => {
            if ("string" != typeof e || 0 === e.length) return 0;
            if (0 === (e = Qo(e)).length) return 0;
            e = e.replace(
              /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g,
              "  "
            );
            let t = 0;
            for (let n = 0; n < e.length; n++) {
              const r = e.codePointAt(n);
              r <= 31 ||
                (r >= 127 && r <= 159) ||
                (r >= 768 && r <= 879) ||
                (r > 65535 && n++, (t += es(r) ? 2 : 1));
            }
            return t;
          };
        (Jo.exports = ts), (Jo.exports.default = ts);
        var ns = (e) => e[e.length - 1];
        function rs(e, t) {
          if (null == e) return {};
          var n,
            r,
            i = (function (e, t) {
              if (null == e) return {};
              var n,
                r,
                i = {},
                o = Object.keys(e);
              for (r = 0; r < o.length; r++)
                (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
              return i;
            })(e, t);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]),
                t.indexOf(n) >= 0 ||
                  (Object.prototype.propertyIsEnumerable.call(e, n) &&
                    (i[n] = e[n]));
          }
          return i;
        }
        function is(e, t) {
          return (
            t || (t = e.slice(0)),
            Object.freeze(
              Object.defineProperties(e, { raw: { value: Object.freeze(t) } })
            )
          );
        }
        var os = Y,
          ss =
            Array.isArray ||
            function (e) {
              return "Array" == os(e);
            },
          as = je,
          us = W(W.bind),
          ls = function (e, t) {
            return (
              as(e),
              void 0 === t
                ? e
                : us
                ? us(e, t)
                : function () {
                    return e.apply(t, arguments);
                  }
            );
          },
          cs = ss,
          ps = dr,
          fs = ls,
          ds = _.TypeError,
          hs = function (e, t, n, r, i, o, s, a) {
            for (var u, l, c = i, p = 0, f = !!s && fs(s, a); p < r; ) {
              if (p in n) {
                if (((u = f ? f(n[p], p, t) : n[p]), o > 0 && cs(u)))
                  (l = ps(u)), (c = hs(e, t, u, l, c, o - 1) - 1);
                else {
                  if (c >= 9007199254740991)
                    throw ds("Exceed the acceptable array length");
                  e[c] = u;
                }
                c++;
              }
              p++;
            }
            return c;
          },
          ms = hs,
          gs = W,
          ys = F,
          vs = se,
          Ds = li,
          bs = hn,
          Es = function () {},
          Cs = [],
          xs = fe("Reflect", "construct"),
          ws = /^\s*(?:class|function)\b/,
          As = gs(ws.exec),
          Ss = !ws.exec(Es),
          _s = function (e) {
            if (!vs(e)) return !1;
            try {
              return xs(Es, Cs, e), !0;
            } catch (e) {
              return !1;
            }
          },
          Ts =
            !xs ||
            ys(function () {
              var e;
              return (
                _s(_s.call) ||
                !_s(Object) ||
                !_s(function () {
                  e = !0;
                }) ||
                e
              );
            })
              ? function (e) {
                  if (!vs(e)) return !1;
                  switch (Ds(e)) {
                    case "AsyncFunction":
                    case "GeneratorFunction":
                    case "AsyncGeneratorFunction":
                      return !1;
                  }
                  return Ss || !!As(ws, bs(e));
                }
              : _s,
          Fs = _,
          ks = ss,
          Os = Ts,
          Bs = ue,
          Ps = Dt("species"),
          Ns = Fs.Array,
          Ms = function (e, t) {
            return new ((function (e) {
              var t;
              return (
                ks(e) &&
                  ((t = e.constructor),
                  ((Os(t) && (t === Ns || ks(t.prototype))) ||
                    (Bs(t) && null === (t = t[Ps]))) &&
                    (t = void 0)),
                void 0 === t ? Ns : t
              );
            })(e))(0 === t ? 0 : t);
          },
          Is = ms,
          js = je,
          Ls = et,
          $s = dr,
          Rs = Ms;
        ei(
          { target: "Array", proto: !0 },
          {
            flatMap: function (e) {
              var t,
                n = Ls(this),
                r = $s(n);
              return (
                js(e),
                ((t = Rs(n, 0)).length = Is(
                  t,
                  n,
                  n,
                  r,
                  0,
                  1,
                  e,
                  arguments.length > 1 ? arguments[1] : void 0
                )),
                t
              );
            },
          }
        );
        var zs = {},
          Vs = zs,
          qs = Dt("iterator"),
          Ws = Array.prototype,
          Us = li,
          Hs = $e,
          Gs = zs,
          Ys = Dt("iterator"),
          Xs = function (e) {
            if (null != e) return Hs(e, Ys) || Hs(e, "@@iterator") || Gs[Us(e)];
          },
          Js = B,
          Zs = je,
          Ks = Jt,
          Qs = Pe,
          ea = Xs,
          ta = _.TypeError,
          na = B,
          ra = Jt,
          ia = $e,
          oa = ls,
          sa = B,
          aa = Jt,
          ua = Pe,
          la = dr,
          ca = de,
          pa = Xs,
          fa = function (e, t, n) {
            var r, i;
            ra(e);
            try {
              if (!(r = ia(e, "return"))) {
                if ("throw" === t) throw n;
                return n;
              }
              r = na(r, e);
            } catch (e) {
              (i = !0), (r = e);
            }
            if ("throw" === t) throw n;
            if (i) throw r;
            return ra(r), n;
          },
          da = _.TypeError,
          ha = function (e, t) {
            (this.stopped = e), (this.result = t);
          },
          ma = ha.prototype,
          ga = Ft,
          ya = Ut,
          va = $,
          Da = function (e, t, n) {
            var r,
              i,
              o,
              s,
              a,
              u,
              l,
              c = n && n.that,
              p = !(!n || !n.AS_ENTRIES),
              f = !(!n || !n.IS_ITERATOR),
              d = !(!n || !n.INTERRUPTED),
              h = oa(t, c),
              m = function (e) {
                return r && fa(r, "normal", e), new ha(!0, e);
              },
              g = function (e) {
                return p
                  ? (aa(e), d ? h(e[0], e[1], m) : h(e[0], e[1]))
                  : d
                  ? h(e, m)
                  : h(e);
              };
            if (f) r = e;
            else {
              if (!(i = pa(e))) throw da(ua(e) + " is not iterable");
              if (
                (function (e) {
                  return void 0 !== e && (Vs.Array === e || Ws[qs] === e);
                })(i)
              ) {
                for (o = 0, s = la(e); s > o; o++)
                  if ((a = g(e[o])) && ca(ma, a)) return a;
                return new ha(!1);
              }
              r = (function (e, t) {
                var n = arguments.length < 2 ? ea(e) : t;
                if (Zs(n)) return Ks(Js(n, e));
                throw ta(Qs(e) + " is not iterable");
              })(e, i);
            }
            for (u = r.next; !(l = sa(u, r)).done; ) {
              try {
                a = g(l.value);
              } catch (e) {
                fa(r, "throw", e);
              }
              if ("object" == typeof a && a && ca(ma, a)) return a;
            }
            return new ha(!1);
          };
        ei(
          { target: "Object", stat: !0 },
          {
            fromEntries: function (e) {
              var t = {};
              return (
                Da(
                  e,
                  function (e, n) {
                    !(function (e, t, n) {
                      var r = ga(t);
                      r in e ? ya.f(e, r, va(0, n)) : (e[r] = n);
                    })(t, e, n);
                  },
                  { AS_ENTRIES: !0 }
                ),
                t
              );
            },
          }
        );
        var ba =
          void 0 !== ba
            ? ba
            : "undefined" != typeof self
            ? self
            : "undefined" != typeof window
            ? window
            : {};
        function Ea() {
          throw new Error("setTimeout has not been defined");
        }
        function Ca() {
          throw new Error("clearTimeout has not been defined");
        }
        var xa = Ea,
          wa = Ca;
        function Aa(e) {
          if (xa === setTimeout) return setTimeout(e, 0);
          if ((xa === Ea || !xa) && setTimeout)
            return (xa = setTimeout), setTimeout(e, 0);
          try {
            return xa(e, 0);
          } catch (t) {
            try {
              return xa.call(null, e, 0);
            } catch (t) {
              return xa.call(this, e, 0);
            }
          }
        }
        "function" == typeof ba.setTimeout && (xa = setTimeout),
          "function" == typeof ba.clearTimeout && (wa = clearTimeout);
        var Sa,
          _a = [],
          Ta = !1,
          Fa = -1;
        function ka() {
          Ta &&
            Sa &&
            ((Ta = !1),
            Sa.length ? (_a = Sa.concat(_a)) : (Fa = -1),
            _a.length && Oa());
        }
        function Oa() {
          if (!Ta) {
            var e = Aa(ka);
            Ta = !0;
            for (var t = _a.length; t; ) {
              for (Sa = _a, _a = []; ++Fa < t; ) Sa && Sa[Fa].run();
              (Fa = -1), (t = _a.length);
            }
            (Sa = null),
              (Ta = !1),
              (function (e) {
                if (wa === clearTimeout) return clearTimeout(e);
                if ((wa === Ca || !wa) && clearTimeout)
                  return (wa = clearTimeout), clearTimeout(e);
                try {
                  wa(e);
                } catch (t) {
                  try {
                    return wa.call(null, e);
                  } catch (t) {
                    return wa.call(this, e);
                  }
                }
              })(e);
          }
        }
        function Ba(e, t) {
          (this.fun = e), (this.array = t);
        }
        function Pa() {}
        Ba.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        var Na = Pa,
          Ma = Pa,
          Ia = Pa,
          ja = Pa,
          La = Pa,
          $a = Pa,
          Ra = Pa,
          za = ba.performance || {},
          Va =
            za.now ||
            za.mozNow ||
            za.msNow ||
            za.oNow ||
            za.webkitNow ||
            function () {
              return new Date().getTime();
            },
          qa = new Date(),
          Wa = {
            nextTick: function (e) {
              var t = new Array(arguments.length - 1);
              if (arguments.length > 1)
                for (var n = 1; n < arguments.length; n++)
                  t[n - 1] = arguments[n];
              _a.push(new Ba(e, t)), 1 !== _a.length || Ta || Aa(Oa);
            },
            title: "browser",
            browser: !0,
            env: {},
            argv: [],
            version: "",
            versions: {},
            on: Na,
            addListener: Ma,
            once: Ia,
            off: ja,
            removeListener: La,
            removeAllListeners: $a,
            emit: Ra,
            binding: function (e) {
              throw new Error("process.binding is not supported");
            },
            cwd: function () {
              return "/";
            },
            chdir: function (e) {
              throw new Error("process.chdir is not supported");
            },
            umask: function () {
              return 0;
            },
            hrtime: function (e) {
              var t = 0.001 * Va.call(za),
                n = Math.floor(t),
                r = Math.floor((t % 1) * 1e9);
              return (
                e && ((n -= e[0]), (r -= e[1]) < 0 && (n--, (r += 1e9))), [n, r]
              );
            },
            platform: "browser",
            release: {},
            config: {},
            uptime: function () {
              return (new Date() - qa) / 1e3;
            },
          },
          Ua = Wa;
        const Ha =
          "object" == typeof Ua &&
          Ua.env &&
          Ua.env.NODE_DEBUG &&
          /\bsemver\b/i.test(Ua.env.NODE_DEBUG)
            ? function () {
                for (
                  var e = arguments.length, t = new Array(e), n = 0;
                  n < e;
                  n++
                )
                  t[n] = arguments[n];
                return console.error("SEMVER", ...t);
              }
            : () => {};
        var Ga = Ha,
          Ya = {
            SEMVER_SPEC_VERSION: "2.0.0",
            MAX_LENGTH: 256,
            MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991,
            MAX_SAFE_COMPONENT_LENGTH: 16,
          },
          Xa = { exports: {} };
        !(function (e, t) {
          const { MAX_SAFE_COMPONENT_LENGTH: n } = Ya,
            r = Ga,
            i = ((t = e.exports = {}).re = []),
            o = (t.src = []),
            s = (t.t = {});
          let a = 0;
          const u = (e, t, n) => {
            const u = a++;
            r(u, t),
              (s[e] = u),
              (o[u] = t),
              (i[u] = new RegExp(t, n ? "g" : void 0));
          };
          u("NUMERICIDENTIFIER", "0|[1-9]\\d*"),
            u("NUMERICIDENTIFIERLOOSE", "[0-9]+"),
            u("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"),
            u(
              "MAINVERSION",
              "(".concat(o[s.NUMERICIDENTIFIER], ")\\.") +
                "(".concat(o[s.NUMERICIDENTIFIER], ")\\.") +
                "(".concat(o[s.NUMERICIDENTIFIER], ")")
            ),
            u(
              "MAINVERSIONLOOSE",
              "(".concat(o[s.NUMERICIDENTIFIERLOOSE], ")\\.") +
                "(".concat(o[s.NUMERICIDENTIFIERLOOSE], ")\\.") +
                "(".concat(o[s.NUMERICIDENTIFIERLOOSE], ")")
            ),
            u(
              "PRERELEASEIDENTIFIER",
              "(?:"
                .concat(o[s.NUMERICIDENTIFIER], "|")
                .concat(o[s.NONNUMERICIDENTIFIER], ")")
            ),
            u(
              "PRERELEASEIDENTIFIERLOOSE",
              "(?:"
                .concat(o[s.NUMERICIDENTIFIERLOOSE], "|")
                .concat(o[s.NONNUMERICIDENTIFIER], ")")
            ),
            u(
              "PRERELEASE",
              "(?:-("
                .concat(o[s.PRERELEASEIDENTIFIER], "(?:\\.")
                .concat(o[s.PRERELEASEIDENTIFIER], ")*))")
            ),
            u(
              "PRERELEASELOOSE",
              "(?:-?("
                .concat(o[s.PRERELEASEIDENTIFIERLOOSE], "(?:\\.")
                .concat(o[s.PRERELEASEIDENTIFIERLOOSE], ")*))")
            ),
            u("BUILDIDENTIFIER", "[0-9A-Za-z-]+"),
            u(
              "BUILD",
              "(?:\\+("
                .concat(o[s.BUILDIDENTIFIER], "(?:\\.")
                .concat(o[s.BUILDIDENTIFIER], ")*))")
            ),
            u(
              "FULLPLAIN",
              "v?"
                .concat(o[s.MAINVERSION])
                .concat(o[s.PRERELEASE], "?")
                .concat(o[s.BUILD], "?")
            ),
            u("FULL", "^".concat(o[s.FULLPLAIN], "$")),
            u(
              "LOOSEPLAIN",
              "[v=\\s]*"
                .concat(o[s.MAINVERSIONLOOSE])
                .concat(o[s.PRERELEASELOOSE], "?")
                .concat(o[s.BUILD], "?")
            ),
            u("LOOSE", "^".concat(o[s.LOOSEPLAIN], "$")),
            u("GTLT", "((?:<|>)?=?)"),
            u(
              "XRANGEIDENTIFIERLOOSE",
              "".concat(o[s.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")
            ),
            u(
              "XRANGEIDENTIFIER",
              "".concat(o[s.NUMERICIDENTIFIER], "|x|X|\\*")
            ),
            u(
              "XRANGEPLAIN",
              "[v=\\s]*(".concat(o[s.XRANGEIDENTIFIER], ")") +
                "(?:\\.(".concat(o[s.XRANGEIDENTIFIER], ")") +
                "(?:\\.(".concat(o[s.XRANGEIDENTIFIER], ")") +
                "(?:".concat(o[s.PRERELEASE], ")?").concat(o[s.BUILD], "?") +
                ")?)?"
            ),
            u(
              "XRANGEPLAINLOOSE",
              "[v=\\s]*(".concat(o[s.XRANGEIDENTIFIERLOOSE], ")") +
                "(?:\\.(".concat(o[s.XRANGEIDENTIFIERLOOSE], ")") +
                "(?:\\.(".concat(o[s.XRANGEIDENTIFIERLOOSE], ")") +
                "(?:"
                  .concat(o[s.PRERELEASELOOSE], ")?")
                  .concat(o[s.BUILD], "?") +
                ")?)?"
            ),
            u(
              "XRANGE",
              "^".concat(o[s.GTLT], "\\s*").concat(o[s.XRANGEPLAIN], "$")
            ),
            u(
              "XRANGELOOSE",
              "^".concat(o[s.GTLT], "\\s*").concat(o[s.XRANGEPLAINLOOSE], "$")
            ),
            u(
              "COERCE",
              "".concat("(^|[^\\d])(\\d{1,").concat(n, "})") +
                "(?:\\.(\\d{1,".concat(n, "}))?") +
                "(?:\\.(\\d{1,".concat(n, "}))?") +
                "(?:$|[^\\d])"
            ),
            u("COERCERTL", o[s.COERCE], !0),
            u("LONETILDE", "(?:~>?)"),
            u("TILDETRIM", "(\\s*)".concat(o[s.LONETILDE], "\\s+"), !0),
            (t.tildeTrimReplace = "$1~"),
            u(
              "TILDE",
              "^".concat(o[s.LONETILDE]).concat(o[s.XRANGEPLAIN], "$")
            ),
            u(
              "TILDELOOSE",
              "^".concat(o[s.LONETILDE]).concat(o[s.XRANGEPLAINLOOSE], "$")
            ),
            u("LONECARET", "(?:\\^)"),
            u("CARETTRIM", "(\\s*)".concat(o[s.LONECARET], "\\s+"), !0),
            (t.caretTrimReplace = "$1^"),
            u(
              "CARET",
              "^".concat(o[s.LONECARET]).concat(o[s.XRANGEPLAIN], "$")
            ),
            u(
              "CARETLOOSE",
              "^".concat(o[s.LONECARET]).concat(o[s.XRANGEPLAINLOOSE], "$")
            ),
            u(
              "COMPARATORLOOSE",
              "^".concat(o[s.GTLT], "\\s*(").concat(o[s.LOOSEPLAIN], ")$|^$")
            ),
            u(
              "COMPARATOR",
              "^".concat(o[s.GTLT], "\\s*(").concat(o[s.FULLPLAIN], ")$|^$")
            ),
            u(
              "COMPARATORTRIM",
              "(\\s*)"
                .concat(o[s.GTLT], "\\s*(")
                .concat(o[s.LOOSEPLAIN], "|")
                .concat(o[s.XRANGEPLAIN], ")"),
              !0
            ),
            (t.comparatorTrimReplace = "$1$2$3"),
            u(
              "HYPHENRANGE",
              "^\\s*(".concat(o[s.XRANGEPLAIN], ")") +
                "\\s+-\\s+" +
                "(".concat(o[s.XRANGEPLAIN], ")") +
                "\\s*$"
            ),
            u(
              "HYPHENRANGELOOSE",
              "^\\s*(".concat(o[s.XRANGEPLAINLOOSE], ")") +
                "\\s+-\\s+" +
                "(".concat(o[s.XRANGEPLAINLOOSE], ")") +
                "\\s*$"
            ),
            u("STAR", "(<|>)?=?\\s*\\*"),
            u("GTE0", "^\\s*>=\\s*0.0.0\\s*$"),
            u("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
        })(Xa, Xa.exports);
        const Ja = ["includePrerelease", "loose", "rtl"];
        const Za = /^[0-9]+$/,
          Ka = (e, t) => {
            const n = Za.test(e),
              r = Za.test(t);
            return (
              n && r && ((e = +e), (t = +t)),
              e === t ? 0 : n && !r ? -1 : r && !n ? 1 : e < t ? -1 : 1
            );
          };
        var Qa = {
          compareIdentifiers: Ka,
          rcompareIdentifiers: (e, t) => Ka(t, e),
        };
        const eu = Ga,
          { MAX_LENGTH: tu, MAX_SAFE_INTEGER: nu } = Ya,
          { re: ru, t: iu } = Xa.exports,
          ou = (e) =>
            e
              ? "object" != typeof e
                ? { loose: !0 }
                : Ja.filter((t) => e[t]).reduce((e, t) => ((e[t] = !0), e), {})
              : {},
          { compareIdentifiers: su } = Qa;
        class au {
          constructor(e, t) {
            if (((t = ou(t)), e instanceof au)) {
              if (
                e.loose === !!t.loose &&
                e.includePrerelease === !!t.includePrerelease
              )
                return e;
              e = e.version;
            } else if ("string" != typeof e)
              throw new TypeError("Invalid Version: ".concat(e));
            if (e.length > tu)
              throw new TypeError(
                "version is longer than ".concat(tu, " characters")
              );
            eu("SemVer", e, t),
              (this.options = t),
              (this.loose = !!t.loose),
              (this.includePrerelease = !!t.includePrerelease);
            const n = e.trim().match(t.loose ? ru[iu.LOOSE] : ru[iu.FULL]);
            if (!n) throw new TypeError("Invalid Version: ".concat(e));
            if (
              ((this.raw = e),
              (this.major = +n[1]),
              (this.minor = +n[2]),
              (this.patch = +n[3]),
              this.major > nu || this.major < 0)
            )
              throw new TypeError("Invalid major version");
            if (this.minor > nu || this.minor < 0)
              throw new TypeError("Invalid minor version");
            if (this.patch > nu || this.patch < 0)
              throw new TypeError("Invalid patch version");
            n[4]
              ? (this.prerelease = n[4].split(".").map((e) => {
                  if (/^[0-9]+$/.test(e)) {
                    const t = +e;
                    if (t >= 0 && t < nu) return t;
                  }
                  return e;
                }))
              : (this.prerelease = []),
              (this.build = n[5] ? n[5].split(".") : []),
              this.format();
          }
          format() {
            return (
              (this.version = ""
                .concat(this.major, ".")
                .concat(this.minor, ".")
                .concat(this.patch)),
              this.prerelease.length &&
                (this.version += "-".concat(this.prerelease.join("."))),
              this.version
            );
          }
          toString() {
            return this.version;
          }
          compare(e) {
            if (
              (eu("SemVer.compare", this.version, this.options, e),
              !(e instanceof au))
            ) {
              if ("string" == typeof e && e === this.version) return 0;
              e = new au(e, this.options);
            }
            return e.version === this.version
              ? 0
              : this.compareMain(e) || this.comparePre(e);
          }
          compareMain(e) {
            return (
              e instanceof au || (e = new au(e, this.options)),
              su(this.major, e.major) ||
                su(this.minor, e.minor) ||
                su(this.patch, e.patch)
            );
          }
          comparePre(e) {
            if (
              (e instanceof au || (e = new au(e, this.options)),
              this.prerelease.length && !e.prerelease.length)
            )
              return -1;
            if (!this.prerelease.length && e.prerelease.length) return 1;
            if (!this.prerelease.length && !e.prerelease.length) return 0;
            let t = 0;
            do {
              const n = this.prerelease[t],
                r = e.prerelease[t];
              if (
                (eu("prerelease compare", t, n, r),
                void 0 === n && void 0 === r)
              )
                return 0;
              if (void 0 === r) return 1;
              if (void 0 === n) return -1;
              if (n !== r) return su(n, r);
            } while (++t);
          }
          compareBuild(e) {
            e instanceof au || (e = new au(e, this.options));
            let t = 0;
            do {
              const n = this.build[t],
                r = e.build[t];
              if (
                (eu("prerelease compare", t, n, r),
                void 0 === n && void 0 === r)
              )
                return 0;
              if (void 0 === r) return 1;
              if (void 0 === n) return -1;
              if (n !== r) return su(n, r);
            } while (++t);
          }
          inc(e, t) {
            switch (e) {
              case "premajor":
                (this.prerelease.length = 0),
                  (this.patch = 0),
                  (this.minor = 0),
                  this.major++,
                  this.inc("pre", t);
                break;
              case "preminor":
                (this.prerelease.length = 0),
                  (this.patch = 0),
                  this.minor++,
                  this.inc("pre", t);
                break;
              case "prepatch":
                (this.prerelease.length = 0),
                  this.inc("patch", t),
                  this.inc("pre", t);
                break;
              case "prerelease":
                0 === this.prerelease.length && this.inc("patch", t),
                  this.inc("pre", t);
                break;
              case "major":
                (0 === this.minor &&
                  0 === this.patch &&
                  0 !== this.prerelease.length) ||
                  this.major++,
                  (this.minor = 0),
                  (this.patch = 0),
                  (this.prerelease = []);
                break;
              case "minor":
                (0 === this.patch && 0 !== this.prerelease.length) ||
                  this.minor++,
                  (this.patch = 0),
                  (this.prerelease = []);
                break;
              case "patch":
                0 === this.prerelease.length && this.patch++,
                  (this.prerelease = []);
                break;
              case "pre":
                if (0 === this.prerelease.length) this.prerelease = [0];
                else {
                  let e = this.prerelease.length;
                  for (; --e >= 0; )
                    "number" == typeof this.prerelease[e] &&
                      (this.prerelease[e]++, (e = -2));
                  -1 === e && this.prerelease.push(0);
                }
                t &&
                  (this.prerelease[0] === t
                    ? isNaN(this.prerelease[1]) && (this.prerelease = [t, 0])
                    : (this.prerelease = [t, 0]));
                break;
              default:
                throw new Error("invalid increment argument: ".concat(e));
            }
            return this.format(), (this.raw = this.version), this;
          }
        }
        const uu = au;
        var lu = (e, t, n) => new uu(e, n).compare(new uu(t, n));
        const cu = lu;
        const pu = lu;
        var fu,
          du,
          hu,
          mu,
          gu,
          yu,
          vu = { exports: {} };
        !(function (e, t) {
          function n() {
            for (var e = [], t = 0; t < arguments.length; t++)
              e[t] = arguments[t];
          }
          function r() {
            return "undefined" != typeof WeakMap
              ? new WeakMap()
              : {
                  add: n,
                  delete: n,
                  get: n,
                  set: n,
                  has: function (e) {
                    return !1;
                  },
                };
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.outdent = void 0);
          var i = Object.prototype.hasOwnProperty,
            o = function (e, t) {
              return i.call(e, t);
            };
          function s(e, t) {
            for (var n in t) o(t, n) && (e[n] = t[n]);
            return e;
          }
          var a = /^[ \t]*(?:\r\n|\r|\n)/,
            u = /(?:\r\n|\r|\n)[ \t]*$/,
            l = /^(?:[\r\n]|$)/,
            c = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/,
            p = /^[ \t]*[\r\n][ \t\r\n]*$/;
          function f(e, t, n) {
            var r = 0,
              i = e[0].match(c);
            i && (r = i[1].length);
            var o = new RegExp("(\\r\\n|\\r|\\n).{0," + r + "}", "g");
            t && (e = e.slice(1));
            var s = n.newline,
              l = n.trimLeadingNewline,
              p = n.trimTrailingNewline,
              f = "string" == typeof s,
              d = e.length;
            return e.map(function (e, t) {
              return (
                (e = e.replace(o, "$1")),
                0 === t && l && (e = e.replace(a, "")),
                t === d - 1 && p && (e = e.replace(u, "")),
                f &&
                  (e = e.replace(/\r\n|\n|\r/g, function (e) {
                    return s;
                  })),
                e
              );
            });
          }
          function d(e, t) {
            for (var n = "", r = 0, i = e.length; r < i; r++)
              (n += e[r]), r < i - 1 && (n += t[r]);
            return n;
          }
          function h(e) {
            return o(e, "raw") && o(e, "length");
          }
          var m = (function e(t) {
            var n = r(),
              i = r(),
              o = s(
                function r(o) {
                  for (var a = [], u = 1; u < arguments.length; u++)
                    a[u - 1] = arguments[u];
                  if (h(o)) {
                    var c = o,
                      g =
                        (a[0] === r || a[0] === m) &&
                        p.test(c[0]) &&
                        l.test(c[1]),
                      y = g ? i : n,
                      v = y.get(c);
                    return (
                      v || ((v = f(c, g, t)), y.set(c, v)),
                      0 === a.length ? v[0] : d(v, g ? a.slice(1) : a)
                    );
                  }
                  return e(s(s({}, t), o || {}));
                },
                {
                  string: function (e) {
                    return f([e], !1, t)[0];
                  },
                }
              );
            return o;
          })({ trimLeadingNewline: !0, trimTrailingNewline: !0 });
          (t.outdent = m), (t.default = m);
          try {
            (e.exports = m),
              Object.defineProperty(m, "__esModule", { value: !0 }),
              (m.default = m),
              (m.outdent = m);
          } catch (e) {}
        })(vu, vu.exports);
        const { outdent: Du } = vu.exports,
          bu = "Config",
          Eu = "Editor",
          Cu = "Other",
          xu = "Global",
          wu = "Special",
          Au = {
            cursorOffset: {
              since: "1.4.0",
              category: wu,
              type: "int",
              default: -1,
              range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 },
              description: Du(
                fu ||
                  (fu = is([
                    "\n      Print (to stderr) where a cursor at the given position would move to after formatting.\n      This option cannot be used with --range-start and --range-end.\n    ",
                  ]))
              ),
              cliCategory: Eu,
            },
            endOfLine: {
              since: "1.15.0",
              category: xu,
              type: "choice",
              default: [
                { since: "1.15.0", value: "auto" },
                { since: "2.0.0", value: "lf" },
              ],
              description: "Which end of line characters to apply.",
              choices: [
                {
                  value: "lf",
                  description:
                    "Line Feed only (\\n), common on Linux and macOS as well as inside git repos",
                },
                {
                  value: "crlf",
                  description:
                    "Carriage Return + Line Feed characters (\\r\\n), common on Windows",
                },
                {
                  value: "cr",
                  description:
                    "Carriage Return character only (\\r), used very rarely",
                },
                {
                  value: "auto",
                  description: Du(
                    du ||
                      (du = is([
                        "\n          Maintain existing\n          (mixed values within one file are normalised by looking at what's used after the first line)\n        ",
                      ]))
                  ),
                },
              ],
            },
            filepath: {
              since: "1.4.0",
              category: wu,
              type: "path",
              description:
                "Specify the input filepath. This will be used to do parser inference.",
              cliName: "stdin-filepath",
              cliCategory: Cu,
              cliDescription:
                "Path to the file to pretend that stdin comes from.",
            },
            insertPragma: {
              since: "1.8.0",
              category: wu,
              type: "boolean",
              default: !1,
              description:
                "Insert @format pragma into file's first docblock comment.",
              cliCategory: Cu,
            },
            parser: {
              since: "0.0.10",
              category: xu,
              type: "choice",
              default: [
                { since: "0.0.10", value: "babylon" },
                { since: "1.13.0", value: void 0 },
              ],
              description: "Which parser to use.",
              exception: (e) => "string" == typeof e || "function" == typeof e,
              choices: [
                { value: "flow", description: "Flow" },
                { value: "babel", since: "1.16.0", description: "JavaScript" },
                { value: "babel-flow", since: "1.16.0", description: "Flow" },
                {
                  value: "babel-ts",
                  since: "2.0.0",
                  description: "TypeScript",
                },
                {
                  value: "typescript",
                  since: "1.4.0",
                  description: "TypeScript",
                },
                { value: "espree", since: "2.2.0", description: "JavaScript" },
                { value: "meriyah", since: "2.2.0", description: "JavaScript" },
                { value: "css", since: "1.7.1", description: "CSS" },
                { value: "less", since: "1.7.1", description: "Less" },
                { value: "scss", since: "1.7.1", description: "SCSS" },
                { value: "json", since: "1.5.0", description: "JSON" },
                { value: "json5", since: "1.13.0", description: "JSON5" },
                {
                  value: "json-stringify",
                  since: "1.13.0",
                  description: "JSON.stringify",
                },
                { value: "graphql", since: "1.5.0", description: "GraphQL" },
                { value: "markdown", since: "1.8.0", description: "Markdown" },
                { value: "mdx", since: "1.15.0", description: "MDX" },
                { value: "vue", since: "1.10.0", description: "Vue" },
                { value: "yaml", since: "1.14.0", description: "YAML" },
                {
                  value: "glimmer",
                  since: "2.3.0",
                  description: "Ember / Handlebars",
                },
                { value: "html", since: "1.15.0", description: "HTML" },
                { value: "angular", since: "1.15.0", description: "Angular" },
                {
                  value: "lwc",
                  since: "1.17.0",
                  description: "Lightning Web Components",
                },
              ],
            },
            plugins: {
              since: "1.10.0",
              type: "path",
              array: !0,
              default: [{ value: [] }],
              category: xu,
              description:
                "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
              exception: (e) => "string" == typeof e || "object" == typeof e,
              cliName: "plugin",
              cliCategory: bu,
            },
            pluginSearchDirs: {
              since: "1.13.0",
              type: "path",
              array: !0,
              default: [{ value: [] }],
              category: xu,
              description: Du(
                hu ||
                  (hu = is([
                    "\n      Custom directory that contains prettier plugins in node_modules subdirectory.\n      Overrides default behavior when plugins are searched relatively to the location of Prettier.\n      Multiple values are accepted.\n    ",
                  ]))
              ),
              exception: (e) => "string" == typeof e || "object" == typeof e,
              cliName: "plugin-search-dir",
              cliCategory: bu,
            },
            printWidth: {
              since: "0.0.0",
              category: xu,
              type: "int",
              default: 80,
              description: "The line length where Prettier will try wrap.",
              range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 },
            },
            rangeEnd: {
              since: "1.4.0",
              category: wu,
              type: "int",
              default: Number.POSITIVE_INFINITY,
              range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 },
              description: Du(
                mu ||
                  (mu = is([
                    "\n      Format code ending at a given character offset (exclusive).\n      The range will extend forwards to the end of the selected statement.\n      This option cannot be used with --cursor-offset.\n    ",
                  ]))
              ),
              cliCategory: Eu,
            },
            rangeStart: {
              since: "1.4.0",
              category: wu,
              type: "int",
              default: 0,
              range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 },
              description: Du(
                gu ||
                  (gu = is([
                    "\n      Format code starting at a given character offset.\n      The range will extend backwards to the start of the first line containing the selected statement.\n      This option cannot be used with --cursor-offset.\n    ",
                  ]))
              ),
              cliCategory: Eu,
            },
            requirePragma: {
              since: "1.7.0",
              category: wu,
              type: "boolean",
              default: !1,
              description: Du(
                yu ||
                  (yu = is([
                    "\n      Require either '@prettier' or '@format' to be present in the file's first docblock comment\n      in order for it to be formatted.\n    ",
                  ]))
              ),
              cliCategory: Cu,
            },
            tabWidth: {
              type: "int",
              category: xu,
              default: 2,
              description: "Number of spaces per indentation level.",
              range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 },
            },
            useTabs: {
              since: "1.0.0",
              category: xu,
              type: "boolean",
              default: !1,
              description: "Indent with tabs instead of spaces.",
            },
            embeddedLanguageFormatting: {
              since: "2.1.0",
              category: xu,
              type: "choice",
              default: [{ since: "2.1.0", value: "auto" }],
              description:
                "Control how Prettier formats quoted code embedded in the file.",
              choices: [
                {
                  value: "auto",
                  description:
                    "Format embedded code if Prettier can automatically identify it.",
                },
                {
                  value: "off",
                  description: "Never automatically format embedded code.",
                },
              ],
            },
          },
          Su = ["cliName", "cliCategory", "cliDescription"],
          _u = lu,
          Tu = (e, t, n) => cu(e, t, n) < 0,
          Fu = (e, t, n) => pu(e, t, n) >= 0,
          ku = (e, t) =>
            Object.entries(e).map((e) => {
              let [n, r] = e;
              return Object.assign({ [t]: n }, r);
            }),
          Ou = r.version,
          Bu = Au;
        function Pu(e, t, n) {
          const r = new Set(e.choices.map((e) => e.value));
          for (const i of t)
            if (i.parsers)
              for (const t of i.parsers)
                if (!r.has(t)) {
                  r.add(t);
                  const o = n.find((e) => e.parsers && e.parsers[t]);
                  let s = i.name;
                  o && o.name && (s += " (plugin: ".concat(o.name, ")")),
                    e.choices.push({ value: t, description: s });
                }
        }
        var Nu = {
          getSupportInfo: function () {
            let {
              plugins: e = [],
              showUnreleased: t = !1,
              showDeprecated: n = !1,
              showInternal: r = !1,
            } = arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : {};
            const i = Ou.split("-", 1)[0],
              o = e.flatMap((e) => e.languages || []).filter(a),
              s = ku(
                Object.assign(
                  {},
                  ...e.map((e) => {
                    let { options: t } = e;
                    return t;
                  }),
                  Bu
                ),
                "name"
              )
                .filter((e) => a(e) && u(e))
                .sort((e, t) =>
                  e.name === t.name ? 0 : e.name < t.name ? -1 : 1
                )
                .map(l)
                .map((t) => {
                  (t = Object.assign({}, t)),
                    Array.isArray(t.default) &&
                      (t.default =
                        1 === t.default.length
                          ? t.default[0].value
                          : t.default
                              .filter(a)
                              .sort((e, t) => _u(t.since, e.since))[0].value),
                    Array.isArray(t.choices) &&
                      ((t.choices = t.choices.filter((e) => a(e) && u(e))),
                      "parser" === t.name && Pu(t, o, e));
                  const n = Object.fromEntries(
                    e
                      .filter(
                        (e) =>
                          e.defaultOptions &&
                          void 0 !== e.defaultOptions[t.name]
                      )
                      .map((e) => [e.name, e.defaultOptions[t.name]])
                  );
                  return Object.assign(
                    Object.assign({}, t),
                    {},
                    { pluginDefaults: n }
                  );
                });
            return { languages: o, options: s };
            function a(e) {
              return t || !("since" in e) || (e.since && Fu(i, e.since));
            }
            function u(e) {
              return (
                n ||
                !("deprecated" in e) ||
                (e.deprecated && Tu(i, e.deprecated))
              );
            }
            function l(e) {
              return r ? e : rs(e, Su);
            }
          },
        };
        const Mu = Jo.exports,
          Iu = (e) => {
            if ("string" != typeof e) throw new TypeError("Expected a string");
            return e
              .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&")
              .replace(/-/g, "\\x2d");
          },
          ju = ns,
          { getSupportInfo: Lu } = Nu,
          $u = /[^\x20-\x7F]/;
        function Ru(e) {
          return (t, n, r) => {
            const i = r && r.backwards;
            if (!1 === n) return !1;
            const { length: o } = t;
            let s = n;
            for (; s >= 0 && s < o; ) {
              const n = t.charAt(s);
              if (e instanceof RegExp) {
                if (!e.test(n)) return s;
              } else if (!e.includes(n)) return s;
              i ? s-- : s++;
            }
            return (-1 === s || s === o) && s;
          };
        }
        const zu = Ru(/\s/),
          Vu = Ru(" \t"),
          qu = Ru(",; \t"),
          Wu = Ru(/[^\n\r]/);
        function Uu(e, t) {
          if (!1 === t) return !1;
          if ("/" === e.charAt(t) && "*" === e.charAt(t + 1))
            for (let n = t + 2; n < e.length; ++n)
              if ("*" === e.charAt(n) && "/" === e.charAt(n + 1)) return n + 2;
          return t;
        }
        function Hu(e, t) {
          return (
            !1 !== t &&
            ("/" === e.charAt(t) && "/" === e.charAt(t + 1) ? Wu(e, t) : t)
          );
        }
        function Gu(e, t, n) {
          const r = n && n.backwards;
          if (!1 === t) return !1;
          const i = e.charAt(t);
          if (r) {
            if ("\r" === e.charAt(t - 1) && "\n" === i) return t - 2;
            if ("\n" === i || "\r" === i || "\u2028" === i || "\u2029" === i)
              return t - 1;
          } else {
            if ("\r" === i && "\n" === e.charAt(t + 1)) return t + 2;
            if ("\n" === i || "\r" === i || "\u2028" === i || "\u2029" === i)
              return t + 1;
          }
          return t;
        }
        function Yu(e, t) {
          let n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          const r = Vu(e, n.backwards ? t - 1 : t, n);
          return r !== Gu(e, r, n);
        }
        function Xu(e, t) {
          let n = null,
            r = t;
          for (; r !== n; )
            (n = r), (r = qu(e, r)), (r = Uu(e, r)), (r = Vu(e, r));
          return (r = Hu(e, r)), (r = Gu(e, r)), !1 !== r && Yu(e, r);
        }
        function Ju(e, t) {
          let n = null,
            r = t;
          for (; r !== n; )
            (n = r),
              (r = Vu(e, r)),
              (r = Uu(e, r)),
              (r = Hu(e, r)),
              (r = Gu(e, r));
          return r;
        }
        function Zu(e, t, n) {
          return Ju(e, n(t));
        }
        function Ku(e, t) {
          let n = 0;
          for (
            let r =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : 0;
            r < e.length;
            ++r
          )
            "\t" === e[r] ? (n = n + t - (n % t)) : n++;
          return n;
        }
        function Qu(e, t) {
          const n = { quote: '"', regex: /"/g, escaped: "&quot;" },
            r = { quote: "'", regex: /'/g, escaped: "&apos;" },
            i = "'" === t ? r : n,
            o = i === r ? n : r;
          let s = i;
          return (
            (e.includes(i.quote) || e.includes(o.quote)) &&
              (s =
                (e.match(i.regex) || []).length >
                (e.match(o.regex) || []).length
                  ? o
                  : i),
            s
          );
        }
        function el(e, t, n) {
          const r = '"' === t ? "'" : '"',
            i = e.replace(/\\(.)|(["'])/gs, (e, i, o) =>
              i === r
                ? i
                : o === t
                ? "\\" + o
                : o ||
                  (n && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(i)
                    ? i
                    : "\\" + i)
            );
          return t + i + t;
        }
        function tl(e, t) {
          (e.comments || (e.comments = [])).push(t),
            (t.printed = !1),
            (t.nodeDescription = (function (e) {
              const t = e.type || e.kind || "(unknown type)";
              let n = String(
                e.name ||
                  (e.id && ("object" == typeof e.id ? e.id.name : e.id)) ||
                  (e.key && ("object" == typeof e.key ? e.key.name : e.key)) ||
                  (e.value &&
                    ("object" == typeof e.value ? "" : String(e.value))) ||
                  e.operator ||
                  ""
              );
              return (
                n.length > 20 && (n = n.slice(0, 19) + "…"),
                t + (n ? " " + n : "")
              );
            })(e));
        }
        var nl = {
            inferParserByLanguage: function (e, t) {
              const { languages: n } = Lu({ plugins: t.plugins }),
                r =
                  n.find((t) => {
                    let { name: n } = t;
                    return n.toLowerCase() === e;
                  }) ||
                  n.find((t) => {
                    let { aliases: n } = t;
                    return Array.isArray(n) && n.includes(e);
                  }) ||
                  n.find((t) => {
                    let { extensions: n } = t;
                    return Array.isArray(n) && n.includes(".".concat(e));
                  });
              return r && r.parsers[0];
            },
            getStringWidth: function (e) {
              return e ? ($u.test(e) ? Mu(e) : e.length) : 0;
            },
            getMaxContinuousCount: function (e, t) {
              const n = e.match(new RegExp("(".concat(Iu(t), ")+"), "g"));
              return null === n
                ? 0
                : n.reduce((e, n) => Math.max(e, n.length / t.length), 0);
            },
            getMinNotPresentContinuousCount: function (e, t) {
              const n = e.match(new RegExp("(".concat(Iu(t), ")+"), "g"));
              if (null === n) return 0;
              const r = new Map();
              let i = 0;
              for (const e of n) {
                const n = e.length / t.length;
                r.set(n, !0), n > i && (i = n);
              }
              for (let e = 1; e < i; e++) if (!r.get(e)) return e;
              return i + 1;
            },
            getPenultimate: (e) => e[e.length - 2],
            getLast: ju,
            getNextNonSpaceNonCommentCharacterIndexWithStartIndex: Ju,
            getNextNonSpaceNonCommentCharacterIndex: Zu,
            getNextNonSpaceNonCommentCharacter: function (e, t, n) {
              return e.charAt(Zu(e, t, n));
            },
            skip: Ru,
            skipWhitespace: zu,
            skipSpaces: Vu,
            skipToLineEnd: qu,
            skipEverythingButNewLine: Wu,
            skipInlineComment: Uu,
            skipTrailingComment: Hu,
            skipNewline: Gu,
            isNextLineEmptyAfterIndex: Xu,
            isNextLineEmpty: function (e, t, n) {
              return Xu(e, n(t));
            },
            isPreviousLineEmpty: function (e, t, n) {
              let r = n(t) - 1;
              return (
                (r = Vu(e, r, { backwards: !0 })),
                (r = Gu(e, r, { backwards: !0 })),
                (r = Vu(e, r, { backwards: !0 })),
                r !== Gu(e, r, { backwards: !0 })
              );
            },
            hasNewline: Yu,
            hasNewlineInRange: function (e, t, n) {
              for (let r = t; r < n; ++r) if ("\n" === e.charAt(r)) return !0;
              return !1;
            },
            hasSpaces: function (e, t) {
              let n =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : {};
              return Vu(e, n.backwards ? t - 1 : t, n) !== t;
            },
            getAlignmentSize: Ku,
            getIndentSize: function (e, t) {
              const n = e.lastIndexOf("\n");
              return -1 === n ? 0 : Ku(e.slice(n + 1).match(/^[\t ]*/)[0], t);
            },
            getPreferredQuote: Qu,
            printString: function (e, t) {
              const n = e.slice(1, -1);
              return el(
                n,
                "json" === t.parser ||
                  ("json5" === t.parser &&
                    "preserve" === t.quoteProps &&
                    !t.singleQuote)
                  ? '"'
                  : t.__isInHtmlAttribute
                  ? "'"
                  : Qu(n, t.singleQuote ? "'" : '"').quote,
                !(
                  "css" === t.parser ||
                  "less" === t.parser ||
                  "scss" === t.parser ||
                  t.__embeddedInHtml
                )
              );
            },
            printNumber: function (e) {
              return e
                .toLowerCase()
                .replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3")
                .replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1")
                .replace(/^([+-])?\./, "$10.")
                .replace(/(\.\d+?)0+(?=e|$)/, "$1")
                .replace(/\.(?=e|$)/, "");
            },
            makeString: el,
            addLeadingComment: function (e, t) {
              (t.leading = !0), (t.trailing = !1), tl(e, t);
            },
            addDanglingComment: function (e, t, n) {
              (t.leading = !1),
                (t.trailing = !1),
                n && (t.marker = n),
                tl(e, t);
            },
            addTrailingComment: function (e, t) {
              (t.leading = !1), (t.trailing = !0), tl(e, t);
            },
            isFrontMatterNode: function (e) {
              return e && "front-matter" === e.type;
            },
            getShebang: function (e) {
              if (!e.startsWith("#!")) return "";
              const t = e.indexOf("\n");
              return -1 === t ? e : e.slice(0, t);
            },
            isNonEmptyArray: function (e) {
              return Array.isArray(e) && e.length > 0;
            },
            createGroupIdMapper: function (e) {
              const t = new WeakMap();
              return function (n) {
                return t.has(n) || t.set(n, Symbol(e)), t.get(n);
              };
            },
          },
          rl = {
            guessEndOfLine: function (e) {
              const t = e.indexOf("\r");
              return t >= 0 ? ("\n" === e.charAt(t + 1) ? "crlf" : "cr") : "lf";
            },
            convertEndOfLineToChars: function (e) {
              switch (e) {
                case "cr":
                  return "\r";
                case "crlf":
                  return "\r\n";
                default:
                  return "\n";
              }
            },
            countEndOfLineChars: function (e, t) {
              let n;
              if ("\n" === t) n = /\n/g;
              else if ("\r" === t) n = /\r/g;
              else {
                if ("\r\n" !== t)
                  throw new Error(
                    'Unexpected "eol" '.concat(JSON.stringify(t), ".")
                  );
                n = /\r\n/g;
              }
              const r = e.match(n);
              return r ? r.length : 0;
            },
            normalizeEndOfLine: function (e) {
              return e.replace(/\r\n?/g, "\n");
            },
          };
        const il = ns,
          { literalline: ol, join: sl } = Xo,
          al = (e) => Array.isArray(e) || (e && "concat" === e.type),
          ul = (e) => {
            if (Array.isArray(e)) return e;
            if ("concat" !== e.type && "fill" !== e.type)
              throw new Error("Expect doc type to be `concat` or `fill`.");
            return e.parts;
          },
          ll = {};
        function cl(e, t, n, r) {
          const i = [e];
          for (; i.length > 0; ) {
            const e = i.pop();
            if (e !== ll) {
              if ((n && i.push(e, ll), !t || !1 !== t(e)))
                if (al(e) || "fill" === e.type) {
                  const t = ul(e);
                  for (let e = t.length - 1; e >= 0; --e) i.push(t[e]);
                } else if ("if-break" === e.type)
                  e.flatContents && i.push(e.flatContents),
                    e.breakContents && i.push(e.breakContents);
                else if ("group" === e.type && e.expandedStates)
                  if (r)
                    for (let t = e.expandedStates.length - 1; t >= 0; --t)
                      i.push(e.expandedStates[t]);
                  else i.push(e.contents);
                else e.contents && i.push(e.contents);
            } else n(i.pop());
          }
        }
        function pl(e, t) {
          const n = new Map();
          return (function e(r) {
            if (n.has(r)) return n.get(r);
            const i = (function (n) {
              if (Array.isArray(n)) return t(n.map(e));
              if ("concat" === n.type || "fill" === n.type) {
                const r = n.parts.map(e);
                return t(Object.assign(Object.assign({}, n), {}, { parts: r }));
              }
              if ("if-break" === n.type) {
                const r = n.breakContents && e(n.breakContents),
                  i = n.flatContents && e(n.flatContents);
                return t(
                  Object.assign(
                    Object.assign({}, n),
                    {},
                    { breakContents: r, flatContents: i }
                  )
                );
              }
              if ("group" === n.type && n.expandedStates) {
                const r = n.expandedStates.map(e),
                  i = r[0];
                return t(
                  Object.assign(
                    Object.assign({}, n),
                    {},
                    { contents: i, expandedStates: r }
                  )
                );
              }
              if (n.contents) {
                const r = e(n.contents);
                return t(
                  Object.assign(Object.assign({}, n), {}, { contents: r })
                );
              }
              return t(n);
            })(r);
            return n.set(r, i), i;
          })(e);
        }
        function fl(e, t, n) {
          let r = n,
            i = !1;
          return (
            cl(e, function (e) {
              const n = t(e);
              if ((void 0 !== n && ((i = !0), (r = n)), i)) return !1;
            }),
            r
          );
        }
        function dl(e) {
          return (
            !("group" !== e.type || !e.break) ||
            !("line" !== e.type || !e.hard) ||
            "break-parent" === e.type ||
            void 0
          );
        }
        function hl(e) {
          if (e.length > 0) {
            const t = il(e);
            t.expandedStates || t.break || (t.break = "propagated");
          }
          return null;
        }
        function ml(e) {
          return "line" !== e.type || e.hard
            ? "if-break" === e.type
              ? e.flatContents || ""
              : e
            : e.soft
            ? ""
            : " ";
        }
        const gl = (e, t) =>
          e && "line" === e.type && e.hard && t && "break-parent" === t.type;
        function yl(e) {
          if (!e) return e;
          if (al(e) || "fill" === e.type) {
            const t = ul(e);
            for (; t.length > 1 && gl(...t.slice(-2)); ) t.length -= 2;
            if (t.length > 0) {
              const e = yl(il(t));
              t[t.length - 1] = e;
            }
            return Array.isArray(e)
              ? t
              : Object.assign(Object.assign({}, e), {}, { parts: t });
          }
          switch (e.type) {
            case "align":
            case "indent":
            case "indent-if-break":
            case "group":
            case "line-suffix":
            case "label": {
              const t = yl(e.contents);
              return Object.assign(Object.assign({}, e), {}, { contents: t });
            }
            case "if-break": {
              const t = yl(e.breakContents),
                n = yl(e.flatContents);
              return Object.assign(
                Object.assign({}, e),
                {},
                { breakContents: t, flatContents: n }
              );
            }
          }
          return e;
        }
        function vl(e) {
          return pl(e, (e) =>
            (function (e) {
              switch (e.type) {
                case "fill":
                  if (e.parts.every((e) => "" === e)) return "";
                  break;
                case "group":
                  if (!(e.contents || e.id || e.break || e.expandedStates))
                    return "";
                  if (
                    "group" === e.contents.type &&
                    e.contents.id === e.id &&
                    e.contents.break === e.break &&
                    e.contents.expandedStates === e.expandedStates
                  )
                    return e.contents;
                  break;
                case "align":
                case "indent":
                case "indent-if-break":
                case "line-suffix":
                  if (!e.contents) return "";
                  break;
                case "if-break":
                  if (!e.flatContents && !e.breakContents) return "";
              }
              if (!al(e)) return e;
              const t = [];
              for (const n of ul(e)) {
                if (!n) continue;
                const [e, ...r] = al(n) ? ul(n) : [n];
                "string" == typeof e && "string" == typeof il(t)
                  ? (t[t.length - 1] += e)
                  : t.push(e),
                  t.push(...r);
              }
              return 0 === t.length
                ? ""
                : 1 === t.length
                ? t[0]
                : Array.isArray(e)
                ? t
                : Object.assign(Object.assign({}, e), {}, { parts: t });
            })(e)
          );
        }
        function Dl(e) {
          const t = [],
            n = e.filter(Boolean);
          for (; n.length > 0; ) {
            const e = n.shift();
            e &&
              (al(e)
                ? n.unshift(...ul(e))
                : t.length > 0 &&
                  "string" == typeof il(t) &&
                  "string" == typeof e
                ? (t[t.length - 1] += e)
                : t.push(e));
          }
          return t;
        }
        function bl(e) {
          return sl(
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ol,
            e.split("\n")
          ).parts;
        }
        function El(e) {
          if ("line" === e.type) return !0;
        }
        var Cl = {
          isConcat: al,
          getDocParts: ul,
          willBreak: function (e) {
            return fl(e, dl, !1);
          },
          traverseDoc: cl,
          findInDoc: fl,
          mapDoc: pl,
          propagateBreaks: function (e) {
            const t = new Set(),
              n = [];
            cl(
              e,
              function (e) {
                if (("break-parent" === e.type && hl(n), "group" === e.type)) {
                  if ((n.push(e), t.has(e))) return !1;
                  t.add(e);
                }
              },
              function (e) {
                "group" === e.type && n.pop().break && hl(n);
              },
              !0
            );
          },
          removeLines: function (e) {
            return pl(e, ml);
          },
          stripTrailingHardline: function (e) {
            return yl(vl(e));
          },
          normalizeParts: Dl,
          normalizeDoc: function (e) {
            return pl(e, (e) =>
              Array.isArray(e)
                ? Dl(e)
                : e.parts
                ? Object.assign(
                    Object.assign({}, e),
                    {},
                    { parts: Dl(e.parts) }
                  )
                : e
            );
          },
          cleanDoc: vl,
          replaceTextEndOfLine: bl,
          replaceEndOfLine: function (e) {
            return pl(e, (e) =>
              "string" == typeof e && e.includes("\n") ? bl(e) : e
            );
          },
          canBreak: function (e) {
            return fl(e, El, !1);
          },
        };
        const { getStringWidth: xl, getLast: wl } = nl,
          { convertEndOfLineToChars: Al } = rl,
          { fill: Sl, cursor: _l, indent: Tl } = Xo,
          { isConcat: Fl, getDocParts: kl } = Cl;
        let Ol;
        function Bl(e, t) {
          return Nl(e, { type: "indent" }, t);
        }
        function Pl(e, t, n) {
          return t === Number.NEGATIVE_INFINITY
            ? e.root || { value: "", length: 0, queue: [] }
            : t < 0
            ? Nl(e, { type: "dedent" }, n)
            : t
            ? "root" === t.type
              ? Object.assign(Object.assign({}, e), {}, { root: e })
              : Nl(
                  e,
                  {
                    type: "string" == typeof t ? "stringAlign" : "numberAlign",
                    n: t,
                  },
                  n
                )
            : e;
        }
        function Nl(e, t, n) {
          const r =
            "dedent" === t.type ? e.queue.slice(0, -1) : [...e.queue, t];
          let i = "",
            o = 0,
            s = 0,
            a = 0;
          for (const e of r)
            switch (e.type) {
              case "indent":
                c(), n.useTabs ? u(1) : l(n.tabWidth);
                break;
              case "stringAlign":
                c(), (i += e.n), (o += e.n.length);
                break;
              case "numberAlign":
                (s += 1), (a += e.n);
                break;
              default:
                throw new Error("Unexpected type '".concat(e.type, "'"));
            }
          return (
            p(),
            Object.assign(
              Object.assign({}, e),
              {},
              { value: i, length: o, queue: r }
            )
          );
          function u(e) {
            (i += "\t".repeat(e)), (o += n.tabWidth * e);
          }
          function l(e) {
            (i += " ".repeat(e)), (o += e);
          }
          function c() {
            n.useTabs ? (s > 0 && u(s), f()) : p();
          }
          function p() {
            a > 0 && l(a), f();
          }
          function f() {
            (s = 0), (a = 0);
          }
        }
        function Ml(e) {
          if (0 === e.length) return 0;
          let t = 0;
          for (
            ;
            e.length > 0 && "string" == typeof wl(e) && /^[\t ]*$/.test(wl(e));

          )
            t += e.pop().length;
          if (e.length > 0 && "string" == typeof wl(e)) {
            const n = wl(e).replace(/[\t ]*$/, "");
            (t += wl(e).length - n.length), (e[e.length - 1] = n);
          }
          return t;
        }
        function Il(e, t, n, r, i, o) {
          let s = t.length;
          const a = [e],
            u = [];
          for (; n >= 0; ) {
            if (0 === a.length) {
              if (0 === s) return !0;
              a.push(t[s - 1]), s--;
              continue;
            }
            const [e, l, c] = a.pop();
            if ("string" == typeof c) u.push(c), (n -= xl(c));
            else if (Fl(c)) {
              const t = kl(c);
              for (let n = t.length - 1; n >= 0; n--) a.push([e, l, t[n]]);
            } else
              switch (c.type) {
                case "indent":
                  a.push([Bl(e, r), l, c.contents]);
                  break;
                case "align":
                  a.push([Pl(e, c.n, r), l, c.contents]);
                  break;
                case "trim":
                  n += Ml(u);
                  break;
                case "group": {
                  if (o && c.break) return !1;
                  const t = c.break ? 1 : l;
                  a.push([
                    e,
                    t,
                    c.expandedStates && 1 === t
                      ? wl(c.expandedStates)
                      : c.contents,
                  ]),
                    c.id && (Ol[c.id] = t);
                  break;
                }
                case "fill":
                  for (let t = c.parts.length - 1; t >= 0; t--)
                    a.push([e, l, c.parts[t]]);
                  break;
                case "if-break":
                case "indent-if-break": {
                  const t = c.groupId ? Ol[c.groupId] : l;
                  if (1 === t) {
                    const t =
                      "if-break" === c.type
                        ? c.breakContents
                        : c.negate
                        ? c.contents
                        : Tl(c.contents);
                    t && a.push([e, l, t]);
                  }
                  if (2 === t) {
                    const t =
                      "if-break" === c.type
                        ? c.flatContents
                        : c.negate
                        ? Tl(c.contents)
                        : c.contents;
                    t && a.push([e, l, t]);
                  }
                  break;
                }
                case "line":
                  switch (l) {
                    case 2:
                      if (!c.hard) {
                        c.soft || (u.push(" "), (n -= 1));
                        break;
                      }
                      return !0;
                    case 1:
                      return !0;
                  }
                  break;
                case "line-suffix":
                  i = !0;
                  break;
                case "line-suffix-boundary":
                  if (i) return !1;
                  break;
                case "label":
                  a.push([e, l, c.contents]);
              }
          }
          return !1;
        }
        var jl = {
          printDocToString: function (e, t) {
            Ol = {};
            const n = t.printWidth,
              r = Al(t.endOfLine);
            let i = 0;
            const o = [[{ value: "", length: 0, queue: [] }, 1, e]],
              s = [];
            let a = !1,
              u = [];
            for (; o.length > 0; ) {
              const [e, l, c] = o.pop();
              if ("string" == typeof c) {
                const e = "\n" !== r ? c.replace(/\n/g, r) : c;
                s.push(e), (i += xl(e));
              } else if (Fl(c)) {
                const t = kl(c);
                for (let n = t.length - 1; n >= 0; n--) o.push([e, l, t[n]]);
              } else
                switch (c.type) {
                  case "cursor":
                    s.push(_l.placeholder);
                    break;
                  case "indent":
                    o.push([Bl(e, t), l, c.contents]);
                    break;
                  case "align":
                    o.push([Pl(e, c.n, t), l, c.contents]);
                    break;
                  case "trim":
                    i -= Ml(s);
                    break;
                  case "group":
                    switch (l) {
                      case 2:
                        if (!a) {
                          o.push([e, c.break ? 1 : 2, c.contents]);
                          break;
                        }
                      case 1: {
                        a = !1;
                        const r = [e, 2, c.contents],
                          s = n - i,
                          l = u.length > 0;
                        if (!c.break && Il(r, o, s, t, l)) o.push(r);
                        else if (c.expandedStates) {
                          const n = wl(c.expandedStates);
                          if (c.break) {
                            o.push([e, 1, n]);
                            break;
                          }
                          for (
                            let r = 1;
                            r < c.expandedStates.length + 1;
                            r++
                          ) {
                            if (r >= c.expandedStates.length) {
                              o.push([e, 1, n]);
                              break;
                            }
                            {
                              const n = [e, 2, c.expandedStates[r]];
                              if (Il(n, o, s, t, l)) {
                                o.push(n);
                                break;
                              }
                            }
                          }
                        } else o.push([e, 1, c.contents]);
                        break;
                      }
                    }
                    c.id && (Ol[c.id] = wl(o)[1]);
                    break;
                  case "fill": {
                    const r = n - i,
                      { parts: s } = c;
                    if (0 === s.length) break;
                    const [a, p] = s,
                      f = [e, 2, a],
                      d = [e, 1, a],
                      h = Il(f, [], r, t, u.length > 0, !0);
                    if (1 === s.length) {
                      h ? o.push(f) : o.push(d);
                      break;
                    }
                    const m = [e, 2, p],
                      g = [e, 1, p];
                    if (2 === s.length) {
                      h ? o.push(m, f) : o.push(g, d);
                      break;
                    }
                    s.splice(0, 2);
                    const y = [e, l, Sl(s)];
                    Il([e, 2, [a, p, s[0]]], [], r, t, u.length > 0, !0)
                      ? o.push(y, m, f)
                      : h
                      ? o.push(y, g, f)
                      : o.push(y, g, d);
                    break;
                  }
                  case "if-break":
                  case "indent-if-break": {
                    const t = c.groupId ? Ol[c.groupId] : l;
                    if (1 === t) {
                      const t =
                        "if-break" === c.type
                          ? c.breakContents
                          : c.negate
                          ? c.contents
                          : Tl(c.contents);
                      t && o.push([e, l, t]);
                    }
                    if (2 === t) {
                      const t =
                        "if-break" === c.type
                          ? c.flatContents
                          : c.negate
                          ? Tl(c.contents)
                          : c.contents;
                      t && o.push([e, l, t]);
                    }
                    break;
                  }
                  case "line-suffix":
                    u.push([e, l, c.contents]);
                    break;
                  case "line-suffix-boundary":
                    u.length > 0 && o.push([e, l, { type: "line", hard: !0 }]);
                    break;
                  case "line":
                    switch (l) {
                      case 2:
                        if (!c.hard) {
                          c.soft || (s.push(" "), (i += 1));
                          break;
                        }
                        a = !0;
                      case 1:
                        if (u.length > 0) {
                          o.push([e, l, c], ...u.reverse()), (u = []);
                          break;
                        }
                        c.literal
                          ? e.root
                            ? (s.push(r, e.root.value), (i = e.root.length))
                            : (s.push(r), (i = 0))
                          : ((i -= Ml(s)), s.push(r + e.value), (i = e.length));
                    }
                    break;
                  case "label":
                    o.push([e, l, c.contents]);
                }
              0 === o.length &&
                u.length > 0 &&
                (o.push(...u.reverse()), (u = []));
            }
            const l = s.indexOf(_l.placeholder);
            if (-1 !== l) {
              const e = s.indexOf(_l.placeholder, l + 1),
                t = s.slice(0, l).join(""),
                n = s.slice(l + 1, e).join("");
              return {
                formatted: t + n + s.slice(e + 1).join(""),
                cursorNodeStart: t.length,
                cursorNodeText: n,
              };
            }
            return { formatted: s.join("") };
          },
        };
        const { isConcat: Ll, getDocParts: $l } = Cl;
        function Rl(e) {
          if (!e) return "";
          if (Ll(e)) {
            const t = [];
            for (const n of $l(e))
              if (Ll(n)) t.push(...Rl(n).parts);
              else {
                const e = Rl(n);
                "" !== e && t.push(e);
              }
            return { type: "concat", parts: t };
          }
          return "if-break" === e.type
            ? Object.assign(
                Object.assign({}, e),
                {},
                {
                  breakContents: Rl(e.breakContents),
                  flatContents: Rl(e.flatContents),
                }
              )
            : "group" === e.type
            ? Object.assign(
                Object.assign({}, e),
                {},
                {
                  contents: Rl(e.contents),
                  expandedStates: e.expandedStates && e.expandedStates.map(Rl),
                }
              )
            : "fill" === e.type
            ? { type: "fill", parts: e.parts.map(Rl) }
            : e.contents
            ? Object.assign(
                Object.assign({}, e),
                {},
                { contents: Rl(e.contents) }
              )
            : e;
        }
        var zl = {
            printDocToDebug: function (e) {
              const t = Object.create(null),
                n = new Set();
              return (function e(t, n, i) {
                if ("string" == typeof t) return JSON.stringify(t);
                if (Ll(t)) {
                  const n = $l(t).map(e).filter(Boolean);
                  return 1 === n.length ? n[0] : "[".concat(n.join(", "), "]");
                }
                if ("line" === t.type) {
                  const e =
                    Array.isArray(i) &&
                    i[n + 1] &&
                    "break-parent" === i[n + 1].type;
                  return t.literal
                    ? e
                      ? "literalline"
                      : "literallineWithoutBreakParent"
                    : t.hard
                    ? e
                      ? "hardline"
                      : "hardlineWithoutBreakParent"
                    : t.soft
                    ? "softline"
                    : "line";
                }
                if ("break-parent" === t.type)
                  return Array.isArray(i) &&
                    i[n - 1] &&
                    "line" === i[n - 1].type &&
                    i[n - 1].hard
                    ? void 0
                    : "breakParent";
                if ("trim" === t.type) return "trim";
                if ("indent" === t.type) return "indent(" + e(t.contents) + ")";
                if ("align" === t.type)
                  return t.n === Number.NEGATIVE_INFINITY
                    ? "dedentToRoot(" + e(t.contents) + ")"
                    : t.n < 0
                    ? "dedent(" + e(t.contents) + ")"
                    : "root" === t.n.type
                    ? "markAsRoot(" + e(t.contents) + ")"
                    : "align(" +
                      JSON.stringify(t.n) +
                      ", " +
                      e(t.contents) +
                      ")";
                if ("if-break" === t.type)
                  return (
                    "ifBreak(" +
                    e(t.breakContents) +
                    (t.flatContents ? ", " + e(t.flatContents) : "") +
                    (t.groupId
                      ? (t.flatContents ? "" : ', ""') +
                        ", { groupId: ".concat(r(t.groupId), " }")
                      : "") +
                    ")"
                  );
                if ("indent-if-break" === t.type) {
                  const n = [];
                  t.negate && n.push("negate: true"),
                    t.groupId && n.push("groupId: ".concat(r(t.groupId)));
                  const i =
                    n.length > 0 ? ", { ".concat(n.join(", "), " }") : "";
                  return "indentIfBreak(".concat(e(t.contents)).concat(i, ")");
                }
                if ("group" === t.type) {
                  const n = [];
                  t.break &&
                    "propagated" !== t.break &&
                    n.push("shouldBreak: true"),
                    t.id && n.push("id: ".concat(r(t.id)));
                  const i =
                    n.length > 0 ? ", { ".concat(n.join(", "), " }") : "";
                  return t.expandedStates
                    ? "conditionalGroup(["
                        .concat(
                          t.expandedStates.map((t) => e(t)).join(","),
                          "]"
                        )
                        .concat(i, ")")
                    : "group(".concat(e(t.contents)).concat(i, ")");
                }
                if ("fill" === t.type)
                  return "fill([".concat(
                    t.parts.map((t) => e(t)).join(", "),
                    "])"
                  );
                if ("line-suffix" === t.type)
                  return "lineSuffix(" + e(t.contents) + ")";
                if ("line-suffix-boundary" === t.type)
                  return "lineSuffixBoundary";
                if ("label" === t.type)
                  return "label("
                    .concat(JSON.stringify(t.label), ", ")
                    .concat(e(t.contents), ")");
                throw new Error("Unknown doc type " + t.type);
              })(Rl(e));
              function r(e) {
                if ("symbol" != typeof e) return JSON.stringify(String(e));
                if (e in t) return t[e];
                const r = String(e).slice(7, -1) || "symbol";
                for (let i = 0; ; i++) {
                  const o = r + (i > 0 ? " #".concat(i) : "");
                  if (!n.has(o))
                    return (
                      n.add(o),
                      (t[e] = "Symbol.for(".concat(JSON.stringify(o), ")"))
                    );
                }
              }
            },
          },
          Vl = { builders: Xo, printer: jl, utils: Cl, debug: zl },
          ql = t(Object.freeze({ __proto__: null, default: {} }));
        function Wl(e, t) {
          for (var n = 0, r = e.length - 1; r >= 0; r--) {
            var i = e[r];
            "." === i
              ? e.splice(r, 1)
              : ".." === i
              ? (e.splice(r, 1), n++)
              : n && (e.splice(r, 1), n--);
          }
          if (t) for (; n--; n) e.unshift("..");
          return e;
        }
        var Ul =
            /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,
          Hl = function (e) {
            return Ul.exec(e).slice(1);
          };
        function Gl() {
          for (
            var e = "", t = !1, n = arguments.length - 1;
            n >= -1 && !t;
            n--
          ) {
            var r = n >= 0 ? arguments[n] : "/";
            if ("string" != typeof r)
              throw new TypeError("Arguments to path.resolve must be strings");
            r && ((e = r + "/" + e), (t = "/" === r.charAt(0)));
          }
          return (
            (t ? "/" : "") +
              (e = Wl(
                nc(e.split("/"), function (e) {
                  return !!e;
                }),
                !t
              ).join("/")) || "."
          );
        }
        function Yl(e) {
          var t = Xl(e),
            n = "/" === rc(e, -1);
          return (
            (e = Wl(
              nc(e.split("/"), function (e) {
                return !!e;
              }),
              !t
            ).join("/")) ||
              t ||
              (e = "."),
            e && n && (e += "/"),
            (t ? "/" : "") + e
          );
        }
        function Xl(e) {
          return "/" === e.charAt(0);
        }
        function Jl() {
          return Yl(
            nc(Array.prototype.slice.call(arguments, 0), function (e, t) {
              if ("string" != typeof e)
                throw new TypeError("Arguments to path.join must be strings");
              return e;
            }).join("/")
          );
        }
        function Zl(e, t) {
          function n(e) {
            for (var t = 0; t < e.length && "" === e[t]; t++);
            for (var n = e.length - 1; n >= 0 && "" === e[n]; n--);
            return t > n ? [] : e.slice(t, n - t + 1);
          }
          (e = Gl(e).substr(1)), (t = Gl(t).substr(1));
          for (
            var r = n(e.split("/")),
              i = n(t.split("/")),
              o = Math.min(r.length, i.length),
              s = o,
              a = 0;
            a < o;
            a++
          )
            if (r[a] !== i[a]) {
              s = a;
              break;
            }
          var u = [];
          for (a = s; a < r.length; a++) u.push("..");
          return (u = u.concat(i.slice(s))).join("/");
        }
        function Kl(e) {
          var t = Hl(e),
            n = t[0],
            r = t[1];
          return n || r ? (r && (r = r.substr(0, r.length - 1)), n + r) : ".";
        }
        function Ql(e, t) {
          var n = Hl(e)[2];
          return (
            t &&
              n.substr(-1 * t.length) === t &&
              (n = n.substr(0, n.length - t.length)),
            n
          );
        }
        function ec(e) {
          return Hl(e)[3];
        }
        var tc = {
          extname: ec,
          basename: Ql,
          dirname: Kl,
          sep: "/",
          delimiter: ":",
          relative: Zl,
          join: Jl,
          isAbsolute: Xl,
          normalize: Yl,
          resolve: Gl,
        };
        function nc(e, t) {
          if (e.filter) return e.filter(t);
          for (var n = [], r = 0; r < e.length; r++)
            t(e[r], r, e) && n.push(e[r]);
          return n;
        }
        var rc = function (e, t, n) {
            return e.substr(t, n);
          },
          ic = t(
            Object.freeze({
              __proto__: null,
              resolve: Gl,
              normalize: Yl,
              isAbsolute: Xl,
              join: Jl,
              relative: Zl,
              sep: "/",
              delimiter: ":",
              dirname: Kl,
              basename: Ql,
              extname: ec,
              default: tc,
            })
          ),
          oc = [],
          sc = [],
          ac = "undefined" != typeof Uint8Array ? Uint8Array : Array,
          uc = !1;
        function lc() {
          uc = !0;
          for (
            var e =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
              t = 0,
              n = e.length;
            t < n;
            ++t
          )
            (oc[t] = e[t]), (sc[e.charCodeAt(t)] = t);
          (sc["-".charCodeAt(0)] = 62), (sc["_".charCodeAt(0)] = 63);
        }
        function cc(e, t, n) {
          for (var r, i, o = [], s = t; s < n; s += 3)
            (r = (e[s] << 16) + (e[s + 1] << 8) + e[s + 2]),
              o.push(
                oc[((i = r) >> 18) & 63] +
                  oc[(i >> 12) & 63] +
                  oc[(i >> 6) & 63] +
                  oc[63 & i]
              );
          return o.join("");
        }
        function pc(e) {
          var t;
          uc || lc();
          for (
            var n = e.length,
              r = n % 3,
              i = "",
              o = [],
              s = 16383,
              a = 0,
              u = n - r;
            a < u;
            a += s
          )
            o.push(cc(e, a, a + s > u ? u : a + s));
          return (
            1 === r
              ? ((t = e[n - 1]),
                (i += oc[t >> 2]),
                (i += oc[(t << 4) & 63]),
                (i += "=="))
              : 2 === r &&
                ((t = (e[n - 2] << 8) + e[n - 1]),
                (i += oc[t >> 10]),
                (i += oc[(t >> 4) & 63]),
                (i += oc[(t << 2) & 63]),
                (i += "=")),
            o.push(i),
            o.join("")
          );
        }
        function fc(e, t, n, r, i) {
          var o,
            s,
            a = 8 * i - r - 1,
            u = (1 << a) - 1,
            l = u >> 1,
            c = -7,
            p = n ? i - 1 : 0,
            f = n ? -1 : 1,
            d = e[t + p];
          for (
            p += f, o = d & ((1 << -c) - 1), d >>= -c, c += a;
            c > 0;
            o = 256 * o + e[t + p], p += f, c -= 8
          );
          for (
            s = o & ((1 << -c) - 1), o >>= -c, c += r;
            c > 0;
            s = 256 * s + e[t + p], p += f, c -= 8
          );
          if (0 === o) o = 1 - l;
          else {
            if (o === u) return s ? NaN : (1 / 0) * (d ? -1 : 1);
            (s += Math.pow(2, r)), (o -= l);
          }
          return (d ? -1 : 1) * s * Math.pow(2, o - r);
        }
        function dc(e, t, n, r, i, o) {
          var s,
            a,
            u,
            l = 8 * o - i - 1,
            c = (1 << l) - 1,
            p = c >> 1,
            f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            d = r ? 0 : o - 1,
            h = r ? 1 : -1,
            m = t < 0 || (0 === t && 1 / t < 0) ? 1 : 0;
          for (
            t = Math.abs(t),
              isNaN(t) || t === 1 / 0
                ? ((a = isNaN(t) ? 1 : 0), (s = c))
                : ((s = Math.floor(Math.log(t) / Math.LN2)),
                  t * (u = Math.pow(2, -s)) < 1 && (s--, (u *= 2)),
                  (t += s + p >= 1 ? f / u : f * Math.pow(2, 1 - p)) * u >= 2 &&
                    (s++, (u /= 2)),
                  s + p >= c
                    ? ((a = 0), (s = c))
                    : s + p >= 1
                    ? ((a = (t * u - 1) * Math.pow(2, i)), (s += p))
                    : ((a = t * Math.pow(2, p - 1) * Math.pow(2, i)), (s = 0)));
            i >= 8;
            e[n + d] = 255 & a, d += h, a /= 256, i -= 8
          );
          for (
            s = (s << i) | a, l += i;
            l > 0;
            e[n + d] = 255 & s, d += h, s /= 256, l -= 8
          );
          e[n + d - h] |= 128 * m;
        }
        var hc = {}.toString,
          mc =
            Array.isArray ||
            function (e) {
              return "[object Array]" == hc.call(e);
            };
        function gc() {
          return vc.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }
        function yc(e, t) {
          if (gc() < t) throw new RangeError("Invalid typed array length");
          return (
            vc.TYPED_ARRAY_SUPPORT
              ? ((e = new Uint8Array(t)).__proto__ = vc.prototype)
              : (null === e && (e = new vc(t)), (e.length = t)),
            e
          );
        }
        function vc(e, t, n) {
          if (!(vc.TYPED_ARRAY_SUPPORT || this instanceof vc))
            return new vc(e, t, n);
          if ("number" == typeof e) {
            if ("string" == typeof t)
              throw new Error(
                "If encoding is specified then the first argument must be a string"
              );
            return Ec(this, e);
          }
          return Dc(this, e, t, n);
        }
        function Dc(e, t, n, r) {
          if ("number" == typeof t)
            throw new TypeError('"value" argument must not be a number');
          return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer
            ? (function (e, t, n, r) {
                if ((t.byteLength, n < 0 || t.byteLength < n))
                  throw new RangeError("'offset' is out of bounds");
                if (t.byteLength < n + (r || 0))
                  throw new RangeError("'length' is out of bounds");
                return (
                  (t =
                    void 0 === n && void 0 === r
                      ? new Uint8Array(t)
                      : void 0 === r
                      ? new Uint8Array(t, n)
                      : new Uint8Array(t, n, r)),
                  vc.TYPED_ARRAY_SUPPORT
                    ? ((e = t).__proto__ = vc.prototype)
                    : (e = Cc(e, t)),
                  e
                );
              })(e, t, n, r)
            : "string" == typeof t
            ? (function (e, t, n) {
                if (
                  (("string" == typeof n && "" !== n) || (n = "utf8"),
                  !vc.isEncoding(n))
                )
                  throw new TypeError(
                    '"encoding" must be a valid string encoding'
                  );
                var r = 0 | Ac(t, n),
                  i = (e = yc(e, r)).write(t, n);
                return i !== r && (e = e.slice(0, i)), e;
              })(e, t, n)
            : (function (e, t) {
                if (wc(t)) {
                  var n = 0 | xc(t.length);
                  return 0 === (e = yc(e, n)).length || t.copy(e, 0, 0, n), e;
                }
                if (t) {
                  if (
                    ("undefined" != typeof ArrayBuffer &&
                      t.buffer instanceof ArrayBuffer) ||
                    "length" in t
                  )
                    return "number" != typeof t.length || (r = t.length) != r
                      ? yc(e, 0)
                      : Cc(e, t);
                  if ("Buffer" === t.type && mc(t.data)) return Cc(e, t.data);
                }
                var r;
                throw new TypeError(
                  "First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object."
                );
              })(e, t);
        }
        function bc(e) {
          if ("number" != typeof e)
            throw new TypeError('"size" argument must be a number');
          if (e < 0)
            throw new RangeError('"size" argument must not be negative');
        }
        function Ec(e, t) {
          if (
            (bc(t), (e = yc(e, t < 0 ? 0 : 0 | xc(t))), !vc.TYPED_ARRAY_SUPPORT)
          )
            for (var n = 0; n < t; ++n) e[n] = 0;
          return e;
        }
        function Cc(e, t) {
          var n = t.length < 0 ? 0 : 0 | xc(t.length);
          e = yc(e, n);
          for (var r = 0; r < n; r += 1) e[r] = 255 & t[r];
          return e;
        }
        function xc(e) {
          if (e >= gc())
            throw new RangeError(
              "Attempt to allocate Buffer larger than maximum size: 0x" +
                gc().toString(16) +
                " bytes"
            );
          return 0 | e;
        }
        function wc(e) {
          return !(null == e || !e._isBuffer);
        }
        function Ac(e, t) {
          if (wc(e)) return e.length;
          if (
            "undefined" != typeof ArrayBuffer &&
            "function" == typeof ArrayBuffer.isView &&
            (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)
          )
            return e.byteLength;
          "string" != typeof e && (e = "" + e);
          var n = e.length;
          if (0 === n) return 0;
          for (var r = !1; ; )
            switch (t) {
              case "ascii":
              case "latin1":
              case "binary":
                return n;
              case "utf8":
              case "utf-8":
              case void 0:
                return Kc(e).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * n;
              case "hex":
                return n >>> 1;
              case "base64":
                return Qc(e).length;
              default:
                if (r) return Kc(e).length;
                (t = ("" + t).toLowerCase()), (r = !0);
            }
        }
        function Sc(e, t, n) {
          var r = !1;
          if (((void 0 === t || t < 0) && (t = 0), t > this.length)) return "";
          if (((void 0 === n || n > this.length) && (n = this.length), n <= 0))
            return "";
          if ((n >>>= 0) <= (t >>>= 0)) return "";
          for (e || (e = "utf8"); ; )
            switch (e) {
              case "hex":
                return zc(this, t, n);
              case "utf8":
              case "utf-8":
                return jc(this, t, n);
              case "ascii":
                return $c(this, t, n);
              case "latin1":
              case "binary":
                return Rc(this, t, n);
              case "base64":
                return Ic(this, t, n);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return Vc(this, t, n);
              default:
                if (r) throw new TypeError("Unknown encoding: " + e);
                (e = (e + "").toLowerCase()), (r = !0);
            }
        }
        function _c(e, t, n) {
          var r = e[t];
          (e[t] = e[n]), (e[n] = r);
        }
        function Tc(e, t, n, r, i) {
          if (0 === e.length) return -1;
          if (
            ("string" == typeof n
              ? ((r = n), (n = 0))
              : n > 2147483647
              ? (n = 2147483647)
              : n < -2147483648 && (n = -2147483648),
            (n = +n),
            isNaN(n) && (n = i ? 0 : e.length - 1),
            n < 0 && (n = e.length + n),
            n >= e.length)
          ) {
            if (i) return -1;
            n = e.length - 1;
          } else if (n < 0) {
            if (!i) return -1;
            n = 0;
          }
          if (("string" == typeof t && (t = vc.from(t, r)), wc(t)))
            return 0 === t.length ? -1 : Fc(e, t, n, r, i);
          if ("number" == typeof t)
            return (
              (t &= 255),
              vc.TYPED_ARRAY_SUPPORT &&
              "function" == typeof Uint8Array.prototype.indexOf
                ? i
                  ? Uint8Array.prototype.indexOf.call(e, t, n)
                  : Uint8Array.prototype.lastIndexOf.call(e, t, n)
                : Fc(e, [t], n, r, i)
            );
          throw new TypeError("val must be string, number or Buffer");
        }
        function Fc(e, t, n, r, i) {
          var o,
            s = 1,
            a = e.length,
            u = t.length;
          if (
            void 0 !== r &&
            ("ucs2" === (r = String(r).toLowerCase()) ||
              "ucs-2" === r ||
              "utf16le" === r ||
              "utf-16le" === r)
          ) {
            if (e.length < 2 || t.length < 2) return -1;
            (s = 2), (a /= 2), (u /= 2), (n /= 2);
          }
          function l(e, t) {
            return 1 === s ? e[t] : e.readUInt16BE(t * s);
          }
          if (i) {
            var c = -1;
            for (o = n; o < a; o++)
              if (l(e, o) === l(t, -1 === c ? 0 : o - c)) {
                if ((-1 === c && (c = o), o - c + 1 === u)) return c * s;
              } else -1 !== c && (o -= o - c), (c = -1);
          } else
            for (n + u > a && (n = a - u), o = n; o >= 0; o--) {
              for (var p = !0, f = 0; f < u; f++)
                if (l(e, o + f) !== l(t, f)) {
                  p = !1;
                  break;
                }
              if (p) return o;
            }
          return -1;
        }
        function kc(e, t, n, r) {
          n = Number(n) || 0;
          var i = e.length - n;
          r ? (r = Number(r)) > i && (r = i) : (r = i);
          var o = t.length;
          if (o % 2 != 0) throw new TypeError("Invalid hex string");
          r > o / 2 && (r = o / 2);
          for (var s = 0; s < r; ++s) {
            var a = parseInt(t.substr(2 * s, 2), 16);
            if (isNaN(a)) return s;
            e[n + s] = a;
          }
          return s;
        }
        function Oc(e, t, n, r) {
          return ep(Kc(t, e.length - n), e, n, r);
        }
        function Bc(e, t, n, r) {
          return ep(
            (function (e) {
              for (var t = [], n = 0; n < e.length; ++n)
                t.push(255 & e.charCodeAt(n));
              return t;
            })(t),
            e,
            n,
            r
          );
        }
        function Pc(e, t, n, r) {
          return Bc(e, t, n, r);
        }
        function Nc(e, t, n, r) {
          return ep(Qc(t), e, n, r);
        }
        function Mc(e, t, n, r) {
          return ep(
            (function (e, t) {
              for (
                var n, r, i, o = [], s = 0;
                s < e.length && !((t -= 2) < 0);
                ++s
              )
                (r = (n = e.charCodeAt(s)) >> 8),
                  (i = n % 256),
                  o.push(i),
                  o.push(r);
              return o;
            })(t, e.length - n),
            e,
            n,
            r
          );
        }
        function Ic(e, t, n) {
          return 0 === t && n === e.length ? pc(e) : pc(e.slice(t, n));
        }
        function jc(e, t, n) {
          n = Math.min(e.length, n);
          for (var r = [], i = t; i < n; ) {
            var o,
              s,
              a,
              u,
              l = e[i],
              c = null,
              p = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
            if (i + p <= n)
              switch (p) {
                case 1:
                  l < 128 && (c = l);
                  break;
                case 2:
                  128 == (192 & (o = e[i + 1])) &&
                    (u = ((31 & l) << 6) | (63 & o)) > 127 &&
                    (c = u);
                  break;
                case 3:
                  (o = e[i + 1]),
                    (s = e[i + 2]),
                    128 == (192 & o) &&
                      128 == (192 & s) &&
                      (u = ((15 & l) << 12) | ((63 & o) << 6) | (63 & s)) >
                        2047 &&
                      (u < 55296 || u > 57343) &&
                      (c = u);
                  break;
                case 4:
                  (o = e[i + 1]),
                    (s = e[i + 2]),
                    (a = e[i + 3]),
                    128 == (192 & o) &&
                      128 == (192 & s) &&
                      128 == (192 & a) &&
                      (u =
                        ((15 & l) << 18) |
                        ((63 & o) << 12) |
                        ((63 & s) << 6) |
                        (63 & a)) > 65535 &&
                      u < 1114112 &&
                      (c = u);
              }
            null === c
              ? ((c = 65533), (p = 1))
              : c > 65535 &&
                ((c -= 65536),
                r.push(((c >>> 10) & 1023) | 55296),
                (c = 56320 | (1023 & c))),
              r.push(c),
              (i += p);
          }
          return (function (e) {
            var t = e.length;
            if (t <= Lc) return String.fromCharCode.apply(String, e);
            for (var n = "", r = 0; r < t; )
              n += String.fromCharCode.apply(String, e.slice(r, (r += Lc)));
            return n;
          })(r);
        }
        (vc.TYPED_ARRAY_SUPPORT =
          void 0 === ba.TYPED_ARRAY_SUPPORT || ba.TYPED_ARRAY_SUPPORT),
          (vc.poolSize = 8192),
          (vc._augment = function (e) {
            return (e.__proto__ = vc.prototype), e;
          }),
          (vc.from = function (e, t, n) {
            return Dc(null, e, t, n);
          }),
          vc.TYPED_ARRAY_SUPPORT &&
            ((vc.prototype.__proto__ = Uint8Array.prototype),
            (vc.__proto__ = Uint8Array)),
          (vc.alloc = function (e, t, n) {
            return (function (e, t, n, r) {
              return (
                bc(t),
                t <= 0
                  ? yc(e, t)
                  : void 0 !== n
                  ? "string" == typeof r
                    ? yc(e, t).fill(n, r)
                    : yc(e, t).fill(n)
                  : yc(e, t)
              );
            })(null, e, t, n);
          }),
          (vc.allocUnsafe = function (e) {
            return Ec(null, e);
          }),
          (vc.allocUnsafeSlow = function (e) {
            return Ec(null, e);
          }),
          (vc.isBuffer = tp),
          (vc.compare = function (e, t) {
            if (!wc(e) || !wc(t))
              throw new TypeError("Arguments must be Buffers");
            if (e === t) return 0;
            for (
              var n = e.length, r = t.length, i = 0, o = Math.min(n, r);
              i < o;
              ++i
            )
              if (e[i] !== t[i]) {
                (n = e[i]), (r = t[i]);
                break;
              }
            return n < r ? -1 : r < n ? 1 : 0;
          }),
          (vc.isEncoding = function (e) {
            switch (String(e).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }),
          (vc.concat = function (e, t) {
            if (!mc(e))
              throw new TypeError(
                '"list" argument must be an Array of Buffers'
              );
            if (0 === e.length) return vc.alloc(0);
            var n;
            if (void 0 === t)
              for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
            var r = vc.allocUnsafe(t),
              i = 0;
            for (n = 0; n < e.length; ++n) {
              var o = e[n];
              if (!wc(o))
                throw new TypeError(
                  '"list" argument must be an Array of Buffers'
                );
              o.copy(r, i), (i += o.length);
            }
            return r;
          }),
          (vc.byteLength = Ac),
          (vc.prototype._isBuffer = !0),
          (vc.prototype.swap16 = function () {
            var e = this.length;
            if (e % 2 != 0)
              throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var t = 0; t < e; t += 2) _c(this, t, t + 1);
            return this;
          }),
          (vc.prototype.swap32 = function () {
            var e = this.length;
            if (e % 4 != 0)
              throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var t = 0; t < e; t += 4)
              _c(this, t, t + 3), _c(this, t + 1, t + 2);
            return this;
          }),
          (vc.prototype.swap64 = function () {
            var e = this.length;
            if (e % 8 != 0)
              throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var t = 0; t < e; t += 8)
              _c(this, t, t + 7),
                _c(this, t + 1, t + 6),
                _c(this, t + 2, t + 5),
                _c(this, t + 3, t + 4);
            return this;
          }),
          (vc.prototype.toString = function () {
            var e = 0 | this.length;
            return 0 === e
              ? ""
              : 0 === arguments.length
              ? jc(this, 0, e)
              : Sc.apply(this, arguments);
          }),
          (vc.prototype.equals = function (e) {
            if (!wc(e)) throw new TypeError("Argument must be a Buffer");
            return this === e || 0 === vc.compare(this, e);
          }),
          (vc.prototype.inspect = function () {
            var e = "";
            return (
              this.length > 0 &&
                ((e = this.toString("hex", 0, 50).match(/.{2}/g).join(" ")),
                this.length > 50 && (e += " ... ")),
              "<Buffer " + e + ">"
            );
          }),
          (vc.prototype.compare = function (e, t, n, r, i) {
            if (!wc(e)) throw new TypeError("Argument must be a Buffer");
            if (
              (void 0 === t && (t = 0),
              void 0 === n && (n = e ? e.length : 0),
              void 0 === r && (r = 0),
              void 0 === i && (i = this.length),
              t < 0 || n > e.length || r < 0 || i > this.length)
            )
              throw new RangeError("out of range index");
            if (r >= i && t >= n) return 0;
            if (r >= i) return -1;
            if (t >= n) return 1;
            if (this === e) return 0;
            for (
              var o = (i >>>= 0) - (r >>>= 0),
                s = (n >>>= 0) - (t >>>= 0),
                a = Math.min(o, s),
                u = this.slice(r, i),
                l = e.slice(t, n),
                c = 0;
              c < a;
              ++c
            )
              if (u[c] !== l[c]) {
                (o = u[c]), (s = l[c]);
                break;
              }
            return o < s ? -1 : s < o ? 1 : 0;
          }),
          (vc.prototype.includes = function (e, t, n) {
            return -1 !== this.indexOf(e, t, n);
          }),
          (vc.prototype.indexOf = function (e, t, n) {
            return Tc(this, e, t, n, !0);
          }),
          (vc.prototype.lastIndexOf = function (e, t, n) {
            return Tc(this, e, t, n, !1);
          }),
          (vc.prototype.write = function (e, t, n, r) {
            if (void 0 === t) (r = "utf8"), (n = this.length), (t = 0);
            else if (void 0 === n && "string" == typeof t)
              (r = t), (n = this.length), (t = 0);
            else {
              if (!isFinite(t))
                throw new Error(
                  "Buffer.write(string, encoding, offset[, length]) is no longer supported"
                );
              (t |= 0),
                isFinite(n)
                  ? ((n |= 0), void 0 === r && (r = "utf8"))
                  : ((r = n), (n = void 0));
            }
            var i = this.length - t;
            if (
              ((void 0 === n || n > i) && (n = i),
              (e.length > 0 && (n < 0 || t < 0)) || t > this.length)
            )
              throw new RangeError("Attempt to write outside buffer bounds");
            r || (r = "utf8");
            for (var o = !1; ; )
              switch (r) {
                case "hex":
                  return kc(this, e, t, n);
                case "utf8":
                case "utf-8":
                  return Oc(this, e, t, n);
                case "ascii":
                  return Bc(this, e, t, n);
                case "latin1":
                case "binary":
                  return Pc(this, e, t, n);
                case "base64":
                  return Nc(this, e, t, n);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return Mc(this, e, t, n);
                default:
                  if (o) throw new TypeError("Unknown encoding: " + r);
                  (r = ("" + r).toLowerCase()), (o = !0);
              }
          }),
          (vc.prototype.toJSON = function () {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0),
            };
          });
        var Lc = 4096;
        function $c(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);
          for (var i = t; i < n; ++i) r += String.fromCharCode(127 & e[i]);
          return r;
        }
        function Rc(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);
          for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
          return r;
        }
        function zc(e, t, n) {
          var r = e.length;
          (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
          for (var i = "", o = t; o < n; ++o) i += Zc(e[o]);
          return i;
        }
        function Vc(e, t, n) {
          for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2)
            i += String.fromCharCode(r[o] + 256 * r[o + 1]);
          return i;
        }
        function qc(e, t, n) {
          if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
          if (e + t > n)
            throw new RangeError("Trying to access beyond buffer length");
        }
        function Wc(e, t, n, r, i, o) {
          if (!wc(e))
            throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t > i || t < o)
            throw new RangeError('"value" argument is out of bounds');
          if (n + r > e.length) throw new RangeError("Index out of range");
        }
        function Uc(e, t, n, r) {
          t < 0 && (t = 65535 + t + 1);
          for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i)
            e[n + i] =
              (t & (255 << (8 * (r ? i : 1 - i)))) >>> (8 * (r ? i : 1 - i));
        }
        function Hc(e, t, n, r) {
          t < 0 && (t = 4294967295 + t + 1);
          for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i)
            e[n + i] = (t >>> (8 * (r ? i : 3 - i))) & 255;
        }
        function Gc(e, t, n, r, i, o) {
          if (n + r > e.length) throw new RangeError("Index out of range");
          if (n < 0) throw new RangeError("Index out of range");
        }
        function Yc(e, t, n, r, i) {
          return i || Gc(e, 0, n, 4), dc(e, t, n, r, 23, 4), n + 4;
        }
        function Xc(e, t, n, r, i) {
          return i || Gc(e, 0, n, 8), dc(e, t, n, r, 52, 8), n + 8;
        }
        (vc.prototype.slice = function (e, t) {
          var n,
            r = this.length;
          if (
            ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r),
            (t = void 0 === t ? r : ~~t) < 0
              ? (t += r) < 0 && (t = 0)
              : t > r && (t = r),
            t < e && (t = e),
            vc.TYPED_ARRAY_SUPPORT)
          )
            (n = this.subarray(e, t)).__proto__ = vc.prototype;
          else {
            var i = t - e;
            n = new vc(i, void 0);
            for (var o = 0; o < i; ++o) n[o] = this[o + e];
          }
          return n;
        }),
          (vc.prototype.readUIntLE = function (e, t, n) {
            (e |= 0), (t |= 0), n || qc(e, t, this.length);
            for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256); )
              r += this[e + o] * i;
            return r;
          }),
          (vc.prototype.readUIntBE = function (e, t, n) {
            (e |= 0), (t |= 0), n || qc(e, t, this.length);
            for (var r = this[e + --t], i = 1; t > 0 && (i *= 256); )
              r += this[e + --t] * i;
            return r;
          }),
          (vc.prototype.readUInt8 = function (e, t) {
            return t || qc(e, 1, this.length), this[e];
          }),
          (vc.prototype.readUInt16LE = function (e, t) {
            return t || qc(e, 2, this.length), this[e] | (this[e + 1] << 8);
          }),
          (vc.prototype.readUInt16BE = function (e, t) {
            return t || qc(e, 2, this.length), (this[e] << 8) | this[e + 1];
          }),
          (vc.prototype.readUInt32LE = function (e, t) {
            return (
              t || qc(e, 4, this.length),
              (this[e] | (this[e + 1] << 8) | (this[e + 2] << 16)) +
                16777216 * this[e + 3]
            );
          }),
          (vc.prototype.readUInt32BE = function (e, t) {
            return (
              t || qc(e, 4, this.length),
              16777216 * this[e] +
                ((this[e + 1] << 16) | (this[e + 2] << 8) | this[e + 3])
            );
          }),
          (vc.prototype.readIntLE = function (e, t, n) {
            (e |= 0), (t |= 0), n || qc(e, t, this.length);
            for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256); )
              r += this[e + o] * i;
            return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
          }),
          (vc.prototype.readIntBE = function (e, t, n) {
            (e |= 0), (t |= 0), n || qc(e, t, this.length);
            for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256); )
              o += this[e + --r] * i;
            return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
          }),
          (vc.prototype.readInt8 = function (e, t) {
            return (
              t || qc(e, 1, this.length),
              128 & this[e] ? -1 * (255 - this[e] + 1) : this[e]
            );
          }),
          (vc.prototype.readInt16LE = function (e, t) {
            t || qc(e, 2, this.length);
            var n = this[e] | (this[e + 1] << 8);
            return 32768 & n ? 4294901760 | n : n;
          }),
          (vc.prototype.readInt16BE = function (e, t) {
            t || qc(e, 2, this.length);
            var n = this[e + 1] | (this[e] << 8);
            return 32768 & n ? 4294901760 | n : n;
          }),
          (vc.prototype.readInt32LE = function (e, t) {
            return (
              t || qc(e, 4, this.length),
              this[e] |
                (this[e + 1] << 8) |
                (this[e + 2] << 16) |
                (this[e + 3] << 24)
            );
          }),
          (vc.prototype.readInt32BE = function (e, t) {
            return (
              t || qc(e, 4, this.length),
              (this[e] << 24) |
                (this[e + 1] << 16) |
                (this[e + 2] << 8) |
                this[e + 3]
            );
          }),
          (vc.prototype.readFloatLE = function (e, t) {
            return t || qc(e, 4, this.length), fc(this, e, !0, 23, 4);
          }),
          (vc.prototype.readFloatBE = function (e, t) {
            return t || qc(e, 4, this.length), fc(this, e, !1, 23, 4);
          }),
          (vc.prototype.readDoubleLE = function (e, t) {
            return t || qc(e, 8, this.length), fc(this, e, !0, 52, 8);
          }),
          (vc.prototype.readDoubleBE = function (e, t) {
            return t || qc(e, 8, this.length), fc(this, e, !1, 52, 8);
          }),
          (vc.prototype.writeUIntLE = function (e, t, n, r) {
            (e = +e),
              (t |= 0),
              (n |= 0),
              r || Wc(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
            var i = 1,
              o = 0;
            for (this[t] = 255 & e; ++o < n && (i *= 256); )
              this[t + o] = (e / i) & 255;
            return t + n;
          }),
          (vc.prototype.writeUIntBE = function (e, t, n, r) {
            (e = +e),
              (t |= 0),
              (n |= 0),
              r || Wc(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
            var i = n - 1,
              o = 1;
            for (this[t + i] = 255 & e; --i >= 0 && (o *= 256); )
              this[t + i] = (e / o) & 255;
            return t + n;
          }),
          (vc.prototype.writeUInt8 = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 1, 255, 0),
              vc.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)),
              (this[t] = 255 & e),
              t + 1
            );
          }),
          (vc.prototype.writeUInt16LE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 2, 65535, 0),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t] = 255 & e), (this[t + 1] = e >>> 8))
                : Uc(this, e, t, !0),
              t + 2
            );
          }),
          (vc.prototype.writeUInt16BE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 2, 65535, 0),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 8), (this[t + 1] = 255 & e))
                : Uc(this, e, t, !1),
              t + 2
            );
          }),
          (vc.prototype.writeUInt32LE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 4, 4294967295, 0),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t + 3] = e >>> 24),
                  (this[t + 2] = e >>> 16),
                  (this[t + 1] = e >>> 8),
                  (this[t] = 255 & e))
                : Hc(this, e, t, !0),
              t + 4
            );
          }),
          (vc.prototype.writeUInt32BE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 4, 4294967295, 0),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 24),
                  (this[t + 1] = e >>> 16),
                  (this[t + 2] = e >>> 8),
                  (this[t + 3] = 255 & e))
                : Hc(this, e, t, !1),
              t + 4
            );
          }),
          (vc.prototype.writeIntLE = function (e, t, n, r) {
            if (((e = +e), (t |= 0), !r)) {
              var i = Math.pow(2, 8 * n - 1);
              Wc(this, e, t, n, i - 1, -i);
            }
            var o = 0,
              s = 1,
              a = 0;
            for (this[t] = 255 & e; ++o < n && (s *= 256); )
              e < 0 && 0 === a && 0 !== this[t + o - 1] && (a = 1),
                (this[t + o] = (((e / s) >> 0) - a) & 255);
            return t + n;
          }),
          (vc.prototype.writeIntBE = function (e, t, n, r) {
            if (((e = +e), (t |= 0), !r)) {
              var i = Math.pow(2, 8 * n - 1);
              Wc(this, e, t, n, i - 1, -i);
            }
            var o = n - 1,
              s = 1,
              a = 0;
            for (this[t + o] = 255 & e; --o >= 0 && (s *= 256); )
              e < 0 && 0 === a && 0 !== this[t + o + 1] && (a = 1),
                (this[t + o] = (((e / s) >> 0) - a) & 255);
            return t + n;
          }),
          (vc.prototype.writeInt8 = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 1, 127, -128),
              vc.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)),
              e < 0 && (e = 255 + e + 1),
              (this[t] = 255 & e),
              t + 1
            );
          }),
          (vc.prototype.writeInt16LE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 2, 32767, -32768),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t] = 255 & e), (this[t + 1] = e >>> 8))
                : Uc(this, e, t, !0),
              t + 2
            );
          }),
          (vc.prototype.writeInt16BE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 2, 32767, -32768),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 8), (this[t + 1] = 255 & e))
                : Uc(this, e, t, !1),
              t + 2
            );
          }),
          (vc.prototype.writeInt32LE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 4, 2147483647, -2147483648),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t] = 255 & e),
                  (this[t + 1] = e >>> 8),
                  (this[t + 2] = e >>> 16),
                  (this[t + 3] = e >>> 24))
                : Hc(this, e, t, !0),
              t + 4
            );
          }),
          (vc.prototype.writeInt32BE = function (e, t, n) {
            return (
              (e = +e),
              (t |= 0),
              n || Wc(this, e, t, 4, 2147483647, -2147483648),
              e < 0 && (e = 4294967295 + e + 1),
              vc.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 24),
                  (this[t + 1] = e >>> 16),
                  (this[t + 2] = e >>> 8),
                  (this[t + 3] = 255 & e))
                : Hc(this, e, t, !1),
              t + 4
            );
          }),
          (vc.prototype.writeFloatLE = function (e, t, n) {
            return Yc(this, e, t, !0, n);
          }),
          (vc.prototype.writeFloatBE = function (e, t, n) {
            return Yc(this, e, t, !1, n);
          }),
          (vc.prototype.writeDoubleLE = function (e, t, n) {
            return Xc(this, e, t, !0, n);
          }),
          (vc.prototype.writeDoubleBE = function (e, t, n) {
            return Xc(this, e, t, !1, n);
          }),
          (vc.prototype.copy = function (e, t, n, r) {
            if (
              (n || (n = 0),
              r || 0 === r || (r = this.length),
              t >= e.length && (t = e.length),
              t || (t = 0),
              r > 0 && r < n && (r = n),
              r === n)
            )
              return 0;
            if (0 === e.length || 0 === this.length) return 0;
            if (t < 0) throw new RangeError("targetStart out of bounds");
            if (n < 0 || n >= this.length)
              throw new RangeError("sourceStart out of bounds");
            if (r < 0) throw new RangeError("sourceEnd out of bounds");
            r > this.length && (r = this.length),
              e.length - t < r - n && (r = e.length - t + n);
            var i,
              o = r - n;
            if (this === e && n < t && t < r)
              for (i = o - 1; i >= 0; --i) e[i + t] = this[i + n];
            else if (o < 1e3 || !vc.TYPED_ARRAY_SUPPORT)
              for (i = 0; i < o; ++i) e[i + t] = this[i + n];
            else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
            return o;
          }),
          (vc.prototype.fill = function (e, t, n, r) {
            if ("string" == typeof e) {
              if (
                ("string" == typeof t
                  ? ((r = t), (t = 0), (n = this.length))
                  : "string" == typeof n && ((r = n), (n = this.length)),
                1 === e.length)
              ) {
                var i = e.charCodeAt(0);
                i < 256 && (e = i);
              }
              if (void 0 !== r && "string" != typeof r)
                throw new TypeError("encoding must be a string");
              if ("string" == typeof r && !vc.isEncoding(r))
                throw new TypeError("Unknown encoding: " + r);
            } else "number" == typeof e && (e &= 255);
            if (t < 0 || this.length < t || this.length < n)
              throw new RangeError("Out of range index");
            if (n <= t) return this;
            var o;
            if (
              ((t >>>= 0),
              (n = void 0 === n ? this.length : n >>> 0),
              e || (e = 0),
              "number" == typeof e)
            )
              for (o = t; o < n; ++o) this[o] = e;
            else {
              var s = wc(e) ? e : Kc(new vc(e, r).toString()),
                a = s.length;
              for (o = 0; o < n - t; ++o) this[o + t] = s[o % a];
            }
            return this;
          });
        var Jc = /[^+\/0-9A-Za-z-_]/g;
        function Zc(e) {
          return e < 16 ? "0" + e.toString(16) : e.toString(16);
        }
        function Kc(e, t) {
          var n;
          t = t || 1 / 0;
          for (var r = e.length, i = null, o = [], s = 0; s < r; ++s) {
            if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
              if (!i) {
                if (n > 56319) {
                  (t -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }
                if (s + 1 === r) {
                  (t -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }
                i = n;
                continue;
              }
              if (n < 56320) {
                (t -= 3) > -1 && o.push(239, 191, 189), (i = n);
                continue;
              }
              n = 65536 + (((i - 55296) << 10) | (n - 56320));
            } else i && (t -= 3) > -1 && o.push(239, 191, 189);
            if (((i = null), n < 128)) {
              if ((t -= 1) < 0) break;
              o.push(n);
            } else if (n < 2048) {
              if ((t -= 2) < 0) break;
              o.push((n >> 6) | 192, (63 & n) | 128);
            } else if (n < 65536) {
              if ((t -= 3) < 0) break;
              o.push((n >> 12) | 224, ((n >> 6) & 63) | 128, (63 & n) | 128);
            } else {
              if (!(n < 1114112)) throw new Error("Invalid code point");
              if ((t -= 4) < 0) break;
              o.push(
                (n >> 18) | 240,
                ((n >> 12) & 63) | 128,
                ((n >> 6) & 63) | 128,
                (63 & n) | 128
              );
            }
          }
          return o;
        }
        function Qc(e) {
          return (function (e) {
            var t, n, r, i, o, s;
            uc || lc();
            var a = e.length;
            if (a % 4 > 0)
              throw new Error("Invalid string. Length must be a multiple of 4");
            (o = "=" === e[a - 2] ? 2 : "=" === e[a - 1] ? 1 : 0),
              (s = new ac((3 * a) / 4 - o)),
              (r = o > 0 ? a - 4 : a);
            var u = 0;
            for (t = 0, n = 0; t < r; t += 4, n += 3)
              (i =
                (sc[e.charCodeAt(t)] << 18) |
                (sc[e.charCodeAt(t + 1)] << 12) |
                (sc[e.charCodeAt(t + 2)] << 6) |
                sc[e.charCodeAt(t + 3)]),
                (s[u++] = (i >> 16) & 255),
                (s[u++] = (i >> 8) & 255),
                (s[u++] = 255 & i);
            return (
              2 === o
                ? ((i =
                    (sc[e.charCodeAt(t)] << 2) |
                    (sc[e.charCodeAt(t + 1)] >> 4)),
                  (s[u++] = 255 & i))
                : 1 === o &&
                  ((i =
                    (sc[e.charCodeAt(t)] << 10) |
                    (sc[e.charCodeAt(t + 1)] << 4) |
                    (sc[e.charCodeAt(t + 2)] >> 2)),
                  (s[u++] = (i >> 8) & 255),
                  (s[u++] = 255 & i)),
              s
            );
          })(
            (function (e) {
              if (
                (e = (function (e) {
                  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
                })(e).replace(Jc, "")).length < 2
              )
                return "";
              for (; e.length % 4 != 0; ) e += "=";
              return e;
            })(e)
          );
        }
        function ep(e, t, n, r) {
          for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i)
            t[i + n] = e[i];
          return i;
        }
        function tp(e) {
          return (
            null != e &&
            (!!e._isBuffer ||
              np(e) ||
              (function (e) {
                return (
                  "function" == typeof e.readFloatLE &&
                  "function" == typeof e.slice &&
                  np(e.slice(0, 0))
                );
              })(e))
          );
        }
        function np(e) {
          return (
            !!e.constructor &&
            "function" == typeof e.constructor.isBuffer &&
            e.constructor.isBuffer(e)
          );
        }
        const rp = ql;
        class ip extends Error {}
        class op extends Error {}
        class sp extends Error {}
        class ap extends Error {}
        var up = {
            ConfigError: ip,
            DebugError: op,
            UndefinedParserError: sp,
            ArgExpansionBailout: ap,
          },
          lp = {},
          cp = function (e, t) {
            return (
              (cp =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                  function (e, t) {
                    e.__proto__ = t;
                  }) ||
                function (e, t) {
                  for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                }),
              cp(e, t)
            );
          },
          pp = function () {
            return (
              (pp =
                Object.assign ||
                function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++)
                    for (var i in (t = arguments[n]))
                      Object.prototype.hasOwnProperty.call(t, i) &&
                        (e[i] = t[i]);
                  return e;
                }),
              pp.apply(this, arguments)
            );
          };
        function fp(e) {
          var t = "function" == typeof Symbol && Symbol.iterator,
            n = t && e[t],
            r = 0;
          if (n) return n.call(e);
          if (e && "number" == typeof e.length)
            return {
              next: function () {
                return (
                  e && r >= e.length && (e = void 0),
                  { value: e && e[r++], done: !e }
                );
              },
            };
          throw new TypeError(
            t ? "Object is not iterable." : "Symbol.iterator is not defined."
          );
        }
        function dp(e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            i,
            o = n.call(e),
            s = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = o.next()).done; )
              s.push(r.value);
          } catch (e) {
            i = { error: e };
          } finally {
            try {
              r && !r.done && (n = o.return) && n.call(o);
            } finally {
              if (i) throw i.error;
            }
          }
          return s;
        }
        function hp(e) {
          return this instanceof hp ? ((this.v = e), this) : new hp(e);
        }
        var mp = Object.freeze({
            __proto__: null,
            __extends: function (e, t) {
              function n() {
                this.constructor = e;
              }
              cp(e, t),
                (e.prototype =
                  null === t
                    ? Object.create(t)
                    : ((n.prototype = t.prototype), new n()));
            },
            get __assign() {
              return pp;
            },
            __rest: function (e, t) {
              var n = {};
              for (var r in e)
                Object.prototype.hasOwnProperty.call(e, r) &&
                  t.indexOf(r) < 0 &&
                  (n[r] = e[r]);
              if (
                null != e &&
                "function" == typeof Object.getOwnPropertySymbols
              ) {
                var i = 0;
                for (r = Object.getOwnPropertySymbols(e); i < r.length; i++)
                  t.indexOf(r[i]) < 0 &&
                    Object.prototype.propertyIsEnumerable.call(e, r[i]) &&
                    (n[r[i]] = e[r[i]]);
              }
              return n;
            },
            __decorate: function (e, t, n, r) {
              var i,
                o = arguments.length,
                s =
                  o < 3
                    ? t
                    : null === r
                    ? (r = Object.getOwnPropertyDescriptor(t, n))
                    : r;
              if (
                "object" == typeof Reflect &&
                "function" == typeof Reflect.decorate
              )
                s = Reflect.decorate(e, t, n, r);
              else
                for (var a = e.length - 1; a >= 0; a--)
                  (i = e[a]) &&
                    (s = (o < 3 ? i(s) : o > 3 ? i(t, n, s) : i(t, n)) || s);
              return o > 3 && s && Object.defineProperty(t, n, s), s;
            },
            __param: function (e, t) {
              return function (n, r) {
                t(n, r, e);
              };
            },
            __metadata: function (e, t) {
              if (
                "object" == typeof Reflect &&
                "function" == typeof Reflect.metadata
              )
                return Reflect.metadata(e, t);
            },
            __awaiter: function (e, t, n, r) {
              return new (n || (n = Promise))(function (i, o) {
                function s(e) {
                  try {
                    u(r.next(e));
                  } catch (e) {
                    o(e);
                  }
                }
                function a(e) {
                  try {
                    u(r.throw(e));
                  } catch (e) {
                    o(e);
                  }
                }
                function u(e) {
                  var t;
                  e.done
                    ? i(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function (e) {
                            e(t);
                          })).then(s, a);
                }
                u((r = r.apply(e, t || [])).next());
              });
            },
            __generator: function (e, t) {
              var n,
                r,
                i,
                o,
                s = {
                  label: 0,
                  sent: function () {
                    if (1 & i[0]) throw i[1];
                    return i[1];
                  },
                  trys: [],
                  ops: [],
                };
              return (
                (o = { next: a(0), throw: a(1), return: a(2) }),
                "function" == typeof Symbol &&
                  (o[Symbol.iterator] = function () {
                    return this;
                  }),
                o
              );
              function a(o) {
                return function (a) {
                  return (function (o) {
                    if (n)
                      throw new TypeError("Generator is already executing.");
                    for (; s; )
                      try {
                        if (
                          ((n = 1),
                          r &&
                            (i =
                              2 & o[0]
                                ? r.return
                                : o[0]
                                ? r.throw || ((i = r.return) && i.call(r), 0)
                                : r.next) &&
                            !(i = i.call(r, o[1])).done)
                        )
                          return i;
                        switch (
                          ((r = 0), i && (o = [2 & o[0], i.value]), o[0])
                        ) {
                          case 0:
                          case 1:
                            i = o;
                            break;
                          case 4:
                            return s.label++, { value: o[1], done: !1 };
                          case 5:
                            s.label++, (r = o[1]), (o = [0]);
                            continue;
                          case 7:
                            (o = s.ops.pop()), s.trys.pop();
                            continue;
                          default:
                            if (
                              !(
                                (i =
                                  (i = s.trys).length > 0 && i[i.length - 1]) ||
                                (6 !== o[0] && 2 !== o[0])
                              )
                            ) {
                              s = 0;
                              continue;
                            }
                            if (
                              3 === o[0] &&
                              (!i || (o[1] > i[0] && o[1] < i[3]))
                            ) {
                              s.label = o[1];
                              break;
                            }
                            if (6 === o[0] && s.label < i[1]) {
                              (s.label = i[1]), (i = o);
                              break;
                            }
                            if (i && s.label < i[2]) {
                              (s.label = i[2]), s.ops.push(o);
                              break;
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue;
                        }
                        o = t.call(e, s);
                      } catch (e) {
                        (o = [6, e]), (r = 0);
                      } finally {
                        n = i = 0;
                      }
                    if (5 & o[0]) throw o[1];
                    return { value: o[0] ? o[1] : void 0, done: !0 };
                  })([o, a]);
                };
              }
            },
            __createBinding: function (e, t, n, r) {
              void 0 === r && (r = n), (e[r] = t[n]);
            },
            __exportStar: function (e, t) {
              for (var n in e)
                "default" === n || t.hasOwnProperty(n) || (t[n] = e[n]);
            },
            __values: fp,
            __read: dp,
            __spread: function () {
              for (var e = [], t = 0; t < arguments.length; t++)
                e = e.concat(dp(arguments[t]));
              return e;
            },
            __spreadArrays: function () {
              for (var e = 0, t = 0, n = arguments.length; t < n; t++)
                e += arguments[t].length;
              var r = Array(e),
                i = 0;
              for (t = 0; t < n; t++)
                for (var o = arguments[t], s = 0, a = o.length; s < a; s++, i++)
                  r[i] = o[s];
              return r;
            },
            __await: hp,
            __asyncGenerator: function (e, t, n) {
              if (!Symbol.asyncIterator)
                throw new TypeError("Symbol.asyncIterator is not defined.");
              var r,
                i = n.apply(e, t || []),
                o = [];
              return (
                (r = {}),
                s("next"),
                s("throw"),
                s("return"),
                (r[Symbol.asyncIterator] = function () {
                  return this;
                }),
                r
              );
              function s(e) {
                i[e] &&
                  (r[e] = function (t) {
                    return new Promise(function (n, r) {
                      o.push([e, t, n, r]) > 1 || a(e, t);
                    });
                  });
              }
              function a(e, t) {
                try {
                  (n = i[e](t)).value instanceof hp
                    ? Promise.resolve(n.value.v).then(u, l)
                    : c(o[0][2], n);
                } catch (e) {
                  c(o[0][3], e);
                }
                var n;
              }
              function u(e) {
                a("next", e);
              }
              function l(e) {
                a("throw", e);
              }
              function c(e, t) {
                e(t), o.shift(), o.length && a(o[0][0], o[0][1]);
              }
            },
            __asyncDelegator: function (e) {
              var t, n;
              return (
                (t = {}),
                r("next"),
                r("throw", function (e) {
                  throw e;
                }),
                r("return"),
                (t[Symbol.iterator] = function () {
                  return this;
                }),
                t
              );
              function r(r, i) {
                t[r] = e[r]
                  ? function (t) {
                      return (n = !n)
                        ? { value: hp(e[r](t)), done: "return" === r }
                        : i
                        ? i(t)
                        : t;
                    }
                  : i;
              }
            },
            __asyncValues: function (e) {
              if (!Symbol.asyncIterator)
                throw new TypeError("Symbol.asyncIterator is not defined.");
              var t,
                n = e[Symbol.asyncIterator];
              return n
                ? n.call(e)
                : ((e = fp(e)),
                  (t = {}),
                  r("next"),
                  r("throw"),
                  r("return"),
                  (t[Symbol.asyncIterator] = function () {
                    return this;
                  }),
                  t);
              function r(n) {
                t[n] =
                  e[n] &&
                  function (t) {
                    return new Promise(function (r, i) {
                      !(function (e, t, n, r) {
                        Promise.resolve(r).then(function (t) {
                          e({ value: t, done: n });
                        }, t);
                      })(r, i, (t = e[n](t)).done, t.value);
                    });
                  };
              }
            },
            __makeTemplateObject: function (e, t) {
              return (
                Object.defineProperty
                  ? Object.defineProperty(e, "raw", { value: t })
                  : (e.raw = t),
                e
              );
            },
            __importStar: function (e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e)
                for (var n in e)
                  Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
              return (t.default = e), t;
            },
            __importDefault: function (e) {
              return e && e.__esModule ? e : { default: e };
            },
            __classPrivateFieldGet: function (e, t) {
              if (!t.has(e))
                throw new TypeError(
                  "attempted to get private field on non-instance"
                );
              return t.get(e);
            },
            __classPrivateFieldSet: function (e, t, n) {
              if (!t.has(e))
                throw new TypeError(
                  "attempted to set private field on non-instance"
                );
              return t.set(e, n), n;
            },
          }),
          gp = {},
          yp = {};
        !(function (e) {
          Object.defineProperty(e, "__esModule", { value: !0 }),
            (e.apiDescriptor = {
              key: (e) =>
                /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(e) ? e : JSON.stringify(e),
              value(t) {
                if (null === t || "object" != typeof t)
                  return JSON.stringify(t);
                if (Array.isArray(t))
                  return "[".concat(
                    t.map((t) => e.apiDescriptor.value(t)).join(", "),
                    "]"
                  );
                const n = Object.keys(t);
                return 0 === n.length
                  ? "{}"
                  : "{ ".concat(
                      n
                        .map((n) =>
                          ""
                            .concat(e.apiDescriptor.key(n), ": ")
                            .concat(e.apiDescriptor.value(t[n]))
                        )
                        .join(", "),
                      " }"
                    );
              },
              pair: (t) => {
                let { key: n, value: r } = t;
                return e.apiDescriptor.value({ [n]: r });
              },
            });
        })(yp),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 }),
              mp.__exportStar(yp, e);
          })(gp);
        var vp = {},
          Dp = {},
          bp = {},
          Ep = { exports: {} },
          Cp = /[|\\{}()[\]^$+*?.]/g,
          xp = function (e) {
            if ("string" != typeof e) throw new TypeError("Expected a string");
            return e.replace(Cp, "\\$&");
          },
          wp = { exports: {} },
          Ap = { exports: {} },
          Sp = {
            aliceblue: [240, 248, 255],
            antiquewhite: [250, 235, 215],
            aqua: [0, 255, 255],
            aquamarine: [127, 255, 212],
            azure: [240, 255, 255],
            beige: [245, 245, 220],
            bisque: [255, 228, 196],
            black: [0, 0, 0],
            blanchedalmond: [255, 235, 205],
            blue: [0, 0, 255],
            blueviolet: [138, 43, 226],
            brown: [165, 42, 42],
            burlywood: [222, 184, 135],
            cadetblue: [95, 158, 160],
            chartreuse: [127, 255, 0],
            chocolate: [210, 105, 30],
            coral: [255, 127, 80],
            cornflowerblue: [100, 149, 237],
            cornsilk: [255, 248, 220],
            crimson: [220, 20, 60],
            cyan: [0, 255, 255],
            darkblue: [0, 0, 139],
            darkcyan: [0, 139, 139],
            darkgoldenrod: [184, 134, 11],
            darkgray: [169, 169, 169],
            darkgreen: [0, 100, 0],
            darkgrey: [169, 169, 169],
            darkkhaki: [189, 183, 107],
            darkmagenta: [139, 0, 139],
            darkolivegreen: [85, 107, 47],
            darkorange: [255, 140, 0],
            darkorchid: [153, 50, 204],
            darkred: [139, 0, 0],
            darksalmon: [233, 150, 122],
            darkseagreen: [143, 188, 143],
            darkslateblue: [72, 61, 139],
            darkslategray: [47, 79, 79],
            darkslategrey: [47, 79, 79],
            darkturquoise: [0, 206, 209],
            darkviolet: [148, 0, 211],
            deeppink: [255, 20, 147],
            deepskyblue: [0, 191, 255],
            dimgray: [105, 105, 105],
            dimgrey: [105, 105, 105],
            dodgerblue: [30, 144, 255],
            firebrick: [178, 34, 34],
            floralwhite: [255, 250, 240],
            forestgreen: [34, 139, 34],
            fuchsia: [255, 0, 255],
            gainsboro: [220, 220, 220],
            ghostwhite: [248, 248, 255],
            gold: [255, 215, 0],
            goldenrod: [218, 165, 32],
            gray: [128, 128, 128],
            green: [0, 128, 0],
            greenyellow: [173, 255, 47],
            grey: [128, 128, 128],
            honeydew: [240, 255, 240],
            hotpink: [255, 105, 180],
            indianred: [205, 92, 92],
            indigo: [75, 0, 130],
            ivory: [255, 255, 240],
            khaki: [240, 230, 140],
            lavender: [230, 230, 250],
            lavenderblush: [255, 240, 245],
            lawngreen: [124, 252, 0],
            lemonchiffon: [255, 250, 205],
            lightblue: [173, 216, 230],
            lightcoral: [240, 128, 128],
            lightcyan: [224, 255, 255],
            lightgoldenrodyellow: [250, 250, 210],
            lightgray: [211, 211, 211],
            lightgreen: [144, 238, 144],
            lightgrey: [211, 211, 211],
            lightpink: [255, 182, 193],
            lightsalmon: [255, 160, 122],
            lightseagreen: [32, 178, 170],
            lightskyblue: [135, 206, 250],
            lightslategray: [119, 136, 153],
            lightslategrey: [119, 136, 153],
            lightsteelblue: [176, 196, 222],
            lightyellow: [255, 255, 224],
            lime: [0, 255, 0],
            limegreen: [50, 205, 50],
            linen: [250, 240, 230],
            magenta: [255, 0, 255],
            maroon: [128, 0, 0],
            mediumaquamarine: [102, 205, 170],
            mediumblue: [0, 0, 205],
            mediumorchid: [186, 85, 211],
            mediumpurple: [147, 112, 219],
            mediumseagreen: [60, 179, 113],
            mediumslateblue: [123, 104, 238],
            mediumspringgreen: [0, 250, 154],
            mediumturquoise: [72, 209, 204],
            mediumvioletred: [199, 21, 133],
            midnightblue: [25, 25, 112],
            mintcream: [245, 255, 250],
            mistyrose: [255, 228, 225],
            moccasin: [255, 228, 181],
            navajowhite: [255, 222, 173],
            navy: [0, 0, 128],
            oldlace: [253, 245, 230],
            olive: [128, 128, 0],
            olivedrab: [107, 142, 35],
            orange: [255, 165, 0],
            orangered: [255, 69, 0],
            orchid: [218, 112, 214],
            palegoldenrod: [238, 232, 170],
            palegreen: [152, 251, 152],
            paleturquoise: [175, 238, 238],
            palevioletred: [219, 112, 147],
            papayawhip: [255, 239, 213],
            peachpuff: [255, 218, 185],
            peru: [205, 133, 63],
            pink: [255, 192, 203],
            plum: [221, 160, 221],
            powderblue: [176, 224, 230],
            purple: [128, 0, 128],
            rebeccapurple: [102, 51, 153],
            red: [255, 0, 0],
            rosybrown: [188, 143, 143],
            royalblue: [65, 105, 225],
            saddlebrown: [139, 69, 19],
            salmon: [250, 128, 114],
            sandybrown: [244, 164, 96],
            seagreen: [46, 139, 87],
            seashell: [255, 245, 238],
            sienna: [160, 82, 45],
            silver: [192, 192, 192],
            skyblue: [135, 206, 235],
            slateblue: [106, 90, 205],
            slategray: [112, 128, 144],
            slategrey: [112, 128, 144],
            snow: [255, 250, 250],
            springgreen: [0, 255, 127],
            steelblue: [70, 130, 180],
            tan: [210, 180, 140],
            teal: [0, 128, 128],
            thistle: [216, 191, 216],
            tomato: [255, 99, 71],
            turquoise: [64, 224, 208],
            violet: [238, 130, 238],
            wheat: [245, 222, 179],
            white: [255, 255, 255],
            whitesmoke: [245, 245, 245],
            yellow: [255, 255, 0],
            yellowgreen: [154, 205, 50],
          },
          _p = {};
        for (var Tp in Sp) Sp.hasOwnProperty(Tp) && (_p[Sp[Tp]] = Tp);
        var Fp = (Ap.exports = {
          rgb: { channels: 3, labels: "rgb" },
          hsl: { channels: 3, labels: "hsl" },
          hsv: { channels: 3, labels: "hsv" },
          hwb: { channels: 3, labels: "hwb" },
          cmyk: { channels: 4, labels: "cmyk" },
          xyz: { channels: 3, labels: "xyz" },
          lab: { channels: 3, labels: "lab" },
          lch: { channels: 3, labels: "lch" },
          hex: { channels: 1, labels: ["hex"] },
          keyword: { channels: 1, labels: ["keyword"] },
          ansi16: { channels: 1, labels: ["ansi16"] },
          ansi256: { channels: 1, labels: ["ansi256"] },
          hcg: { channels: 3, labels: ["h", "c", "g"] },
          apple: { channels: 3, labels: ["r16", "g16", "b16"] },
          gray: { channels: 1, labels: ["gray"] },
        });
        for (var kp in Fp)
          if (Fp.hasOwnProperty(kp)) {
            if (!("channels" in Fp[kp]))
              throw new Error("missing channels property: " + kp);
            if (!("labels" in Fp[kp]))
              throw new Error("missing channel labels property: " + kp);
            if (Fp[kp].labels.length !== Fp[kp].channels)
              throw new Error("channel and label counts mismatch: " + kp);
            var Op = Fp[kp].channels,
              Bp = Fp[kp].labels;
            delete Fp[kp].channels,
              delete Fp[kp].labels,
              Object.defineProperty(Fp[kp], "channels", { value: Op }),
              Object.defineProperty(Fp[kp], "labels", { value: Bp });
          }
        (Fp.rgb.hsl = function (e) {
          var t,
            n,
            r = e[0] / 255,
            i = e[1] / 255,
            o = e[2] / 255,
            s = Math.min(r, i, o),
            a = Math.max(r, i, o),
            u = a - s;
          return (
            a === s
              ? (t = 0)
              : r === a
              ? (t = (i - o) / u)
              : i === a
              ? (t = 2 + (o - r) / u)
              : o === a && (t = 4 + (r - i) / u),
            (t = Math.min(60 * t, 360)) < 0 && (t += 360),
            (n = (s + a) / 2),
            [
              t,
              100 * (a === s ? 0 : n <= 0.5 ? u / (a + s) : u / (2 - a - s)),
              100 * n,
            ]
          );
        }),
          (Fp.rgb.hsv = function (e) {
            var t,
              n,
              r,
              i,
              o,
              s = e[0] / 255,
              a = e[1] / 255,
              u = e[2] / 255,
              l = Math.max(s, a, u),
              c = l - Math.min(s, a, u),
              p = function (e) {
                return (l - e) / 6 / c + 0.5;
              };
            return (
              0 === c
                ? (i = o = 0)
                : ((o = c / l),
                  (t = p(s)),
                  (n = p(a)),
                  (r = p(u)),
                  s === l
                    ? (i = r - n)
                    : a === l
                    ? (i = 1 / 3 + t - r)
                    : u === l && (i = 2 / 3 + n - t),
                  i < 0 ? (i += 1) : i > 1 && (i -= 1)),
              [360 * i, 100 * o, 100 * l]
            );
          }),
          (Fp.rgb.hwb = function (e) {
            var t = e[0],
              n = e[1],
              r = e[2];
            return [
              Fp.rgb.hsl(e)[0],
              (1 / 255) * Math.min(t, Math.min(n, r)) * 100,
              100 * (r = 1 - (1 / 255) * Math.max(t, Math.max(n, r))),
            ];
          }),
          (Fp.rgb.cmyk = function (e) {
            var t,
              n = e[0] / 255,
              r = e[1] / 255,
              i = e[2] / 255;
            return [
              100 *
                ((1 - n - (t = Math.min(1 - n, 1 - r, 1 - i))) / (1 - t) || 0),
              100 * ((1 - r - t) / (1 - t) || 0),
              100 * ((1 - i - t) / (1 - t) || 0),
              100 * t,
            ];
          }),
          (Fp.rgb.keyword = function (e) {
            var t = _p[e];
            if (t) return t;
            var n,
              r,
              i,
              o = 1 / 0;
            for (var s in Sp)
              if (Sp.hasOwnProperty(s)) {
                var a =
                  ((r = e),
                  (i = Sp[s]),
                  Math.pow(r[0] - i[0], 2) +
                    Math.pow(r[1] - i[1], 2) +
                    Math.pow(r[2] - i[2], 2));
                a < o && ((o = a), (n = s));
              }
            return n;
          }),
          (Fp.keyword.rgb = function (e) {
            return Sp[e];
          }),
          (Fp.rgb.xyz = function (e) {
            var t = e[0] / 255,
              n = e[1] / 255,
              r = e[2] / 255;
            return [
              100 *
                (0.4124 *
                  (t =
                    t > 0.04045
                      ? Math.pow((t + 0.055) / 1.055, 2.4)
                      : t / 12.92) +
                  0.3576 *
                    (n =
                      n > 0.04045
                        ? Math.pow((n + 0.055) / 1.055, 2.4)
                        : n / 12.92) +
                  0.1805 *
                    (r =
                      r > 0.04045
                        ? Math.pow((r + 0.055) / 1.055, 2.4)
                        : r / 12.92)),
              100 * (0.2126 * t + 0.7152 * n + 0.0722 * r),
              100 * (0.0193 * t + 0.1192 * n + 0.9505 * r),
            ];
          }),
          (Fp.rgb.lab = function (e) {
            var t = Fp.rgb.xyz(e),
              n = t[0],
              r = t[1],
              i = t[2];
            return (
              (r /= 100),
              (i /= 108.883),
              (n =
                (n /= 95.047) > 0.008856
                  ? Math.pow(n, 1 / 3)
                  : 7.787 * n + 16 / 116),
              [
                116 *
                  (r =
                    r > 0.008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116) -
                  16,
                500 * (n - r),
                200 *
                  (r -
                    (i =
                      i > 0.008856
                        ? Math.pow(i, 1 / 3)
                        : 7.787 * i + 16 / 116)),
              ]
            );
          }),
          (Fp.hsl.rgb = function (e) {
            var t,
              n,
              r,
              i,
              o,
              s = e[0] / 360,
              a = e[1] / 100,
              u = e[2] / 100;
            if (0 === a) return [(o = 255 * u), o, o];
            (t = 2 * u - (n = u < 0.5 ? u * (1 + a) : u + a - u * a)),
              (i = [0, 0, 0]);
            for (var l = 0; l < 3; l++)
              (r = s + (1 / 3) * -(l - 1)) < 0 && r++,
                r > 1 && r--,
                (o =
                  6 * r < 1
                    ? t + 6 * (n - t) * r
                    : 2 * r < 1
                    ? n
                    : 3 * r < 2
                    ? t + (n - t) * (2 / 3 - r) * 6
                    : t),
                (i[l] = 255 * o);
            return i;
          }),
          (Fp.hsl.hsv = function (e) {
            var t = e[0],
              n = e[1] / 100,
              r = e[2] / 100,
              i = n,
              o = Math.max(r, 0.01);
            return (
              (n *= (r *= 2) <= 1 ? r : 2 - r),
              (i *= o <= 1 ? o : 2 - o),
              [
                t,
                100 * (0 === r ? (2 * i) / (o + i) : (2 * n) / (r + n)),
                ((r + n) / 2) * 100,
              ]
            );
          }),
          (Fp.hsv.rgb = function (e) {
            var t = e[0] / 60,
              n = e[1] / 100,
              r = e[2] / 100,
              i = Math.floor(t) % 6,
              o = t - Math.floor(t),
              s = 255 * r * (1 - n),
              a = 255 * r * (1 - n * o),
              u = 255 * r * (1 - n * (1 - o));
            switch (((r *= 255), i)) {
              case 0:
                return [r, u, s];
              case 1:
                return [a, r, s];
              case 2:
                return [s, r, u];
              case 3:
                return [s, a, r];
              case 4:
                return [u, s, r];
              case 5:
                return [r, s, a];
            }
          }),
          (Fp.hsv.hsl = function (e) {
            var t,
              n,
              r,
              i = e[0],
              o = e[1] / 100,
              s = e[2] / 100,
              a = Math.max(s, 0.01);
            return (
              (r = (2 - o) * s),
              (n = o * a),
              [
                i,
                100 * (n = (n /= (t = (2 - o) * a) <= 1 ? t : 2 - t) || 0),
                100 * (r /= 2),
              ]
            );
          }),
          (Fp.hwb.rgb = function (e) {
            var t,
              n,
              r,
              i,
              o,
              s,
              a,
              u = e[0] / 360,
              l = e[1] / 100,
              c = e[2] / 100,
              p = l + c;
            switch (
              (p > 1 && ((l /= p), (c /= p)),
              (r = 6 * u - (t = Math.floor(6 * u))),
              0 != (1 & t) && (r = 1 - r),
              (i = l + r * ((n = 1 - c) - l)),
              t)
            ) {
              default:
              case 6:
              case 0:
                (o = n), (s = i), (a = l);
                break;
              case 1:
                (o = i), (s = n), (a = l);
                break;
              case 2:
                (o = l), (s = n), (a = i);
                break;
              case 3:
                (o = l), (s = i), (a = n);
                break;
              case 4:
                (o = i), (s = l), (a = n);
                break;
              case 5:
                (o = n), (s = l), (a = i);
            }
            return [255 * o, 255 * s, 255 * a];
          }),
          (Fp.cmyk.rgb = function (e) {
            var t = e[0] / 100,
              n = e[1] / 100,
              r = e[2] / 100,
              i = e[3] / 100;
            return [
              255 * (1 - Math.min(1, t * (1 - i) + i)),
              255 * (1 - Math.min(1, n * (1 - i) + i)),
              255 * (1 - Math.min(1, r * (1 - i) + i)),
            ];
          }),
          (Fp.xyz.rgb = function (e) {
            var t,
              n,
              r,
              i = e[0] / 100,
              o = e[1] / 100,
              s = e[2] / 100;
            return (
              (n = -0.9689 * i + 1.8758 * o + 0.0415 * s),
              (r = 0.0557 * i + -0.204 * o + 1.057 * s),
              (t =
                (t = 3.2406 * i + -1.5372 * o + -0.4986 * s) > 0.0031308
                  ? 1.055 * Math.pow(t, 1 / 2.4) - 0.055
                  : 12.92 * t),
              (n =
                n > 0.0031308
                  ? 1.055 * Math.pow(n, 1 / 2.4) - 0.055
                  : 12.92 * n),
              (r =
                r > 0.0031308
                  ? 1.055 * Math.pow(r, 1 / 2.4) - 0.055
                  : 12.92 * r),
              [
                255 * (t = Math.min(Math.max(0, t), 1)),
                255 * (n = Math.min(Math.max(0, n), 1)),
                255 * (r = Math.min(Math.max(0, r), 1)),
              ]
            );
          }),
          (Fp.xyz.lab = function (e) {
            var t = e[0],
              n = e[1],
              r = e[2];
            return (
              (n /= 100),
              (r /= 108.883),
              (t =
                (t /= 95.047) > 0.008856
                  ? Math.pow(t, 1 / 3)
                  : 7.787 * t + 16 / 116),
              [
                116 *
                  (n =
                    n > 0.008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) -
                  16,
                500 * (t - n),
                200 *
                  (n -
                    (r =
                      r > 0.008856
                        ? Math.pow(r, 1 / 3)
                        : 7.787 * r + 16 / 116)),
              ]
            );
          }),
          (Fp.lab.xyz = function (e) {
            var t,
              n,
              r,
              i = e[0];
            (t = e[1] / 500 + (n = (i + 16) / 116)), (r = n - e[2] / 200);
            var o = Math.pow(n, 3),
              s = Math.pow(t, 3),
              a = Math.pow(r, 3);
            return (
              (n = o > 0.008856 ? o : (n - 16 / 116) / 7.787),
              (t = s > 0.008856 ? s : (t - 16 / 116) / 7.787),
              (r = a > 0.008856 ? a : (r - 16 / 116) / 7.787),
              [(t *= 95.047), (n *= 100), (r *= 108.883)]
            );
          }),
          (Fp.lab.lch = function (e) {
            var t,
              n = e[0],
              r = e[1],
              i = e[2];
            return (
              (t = (360 * Math.atan2(i, r)) / 2 / Math.PI) < 0 && (t += 360),
              [n, Math.sqrt(r * r + i * i), t]
            );
          }),
          (Fp.lch.lab = function (e) {
            var t,
              n = e[0],
              r = e[1];
            return (
              (t = (e[2] / 360) * 2 * Math.PI),
              [n, r * Math.cos(t), r * Math.sin(t)]
            );
          }),
          (Fp.rgb.ansi16 = function (e) {
            var t = e[0],
              n = e[1],
              r = e[2],
              i = 1 in arguments ? arguments[1] : Fp.rgb.hsv(e)[2];
            if (0 === (i = Math.round(i / 50))) return 30;
            var o =
              30 +
              ((Math.round(r / 255) << 2) |
                (Math.round(n / 255) << 1) |
                Math.round(t / 255));
            return 2 === i && (o += 60), o;
          }),
          (Fp.hsv.ansi16 = function (e) {
            return Fp.rgb.ansi16(Fp.hsv.rgb(e), e[2]);
          }),
          (Fp.rgb.ansi256 = function (e) {
            var t = e[0],
              n = e[1],
              r = e[2];
            return t === n && n === r
              ? t < 8
                ? 16
                : t > 248
                ? 231
                : Math.round(((t - 8) / 247) * 24) + 232
              : 16 +
                  36 * Math.round((t / 255) * 5) +
                  6 * Math.round((n / 255) * 5) +
                  Math.round((r / 255) * 5);
          }),
          (Fp.ansi16.rgb = function (e) {
            var t = e % 10;
            if (0 === t || 7 === t)
              return e > 50 && (t += 3.5), [(t = (t / 10.5) * 255), t, t];
            var n = 0.5 * (1 + ~~(e > 50));
            return [
              (1 & t) * n * 255,
              ((t >> 1) & 1) * n * 255,
              ((t >> 2) & 1) * n * 255,
            ];
          }),
          (Fp.ansi256.rgb = function (e) {
            if (e >= 232) {
              var t = 10 * (e - 232) + 8;
              return [t, t, t];
            }
            var n;
            return (
              (e -= 16),
              [
                (Math.floor(e / 36) / 5) * 255,
                (Math.floor((n = e % 36) / 6) / 5) * 255,
                ((n % 6) / 5) * 255,
              ]
            );
          }),
          (Fp.rgb.hex = function (e) {
            var t = (
              ((255 & Math.round(e[0])) << 16) +
              ((255 & Math.round(e[1])) << 8) +
              (255 & Math.round(e[2]))
            )
              .toString(16)
              .toUpperCase();
            return "000000".substring(t.length) + t;
          }),
          (Fp.hex.rgb = function (e) {
            var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!t) return [0, 0, 0];
            var n = t[0];
            3 === t[0].length &&
              (n = n
                .split("")
                .map(function (e) {
                  return e + e;
                })
                .join(""));
            var r = parseInt(n, 16);
            return [(r >> 16) & 255, (r >> 8) & 255, 255 & r];
          }),
          (Fp.rgb.hcg = function (e) {
            var t,
              n = e[0] / 255,
              r = e[1] / 255,
              i = e[2] / 255,
              o = Math.max(Math.max(n, r), i),
              s = Math.min(Math.min(n, r), i),
              a = o - s;
            return (
              (t =
                a <= 0
                  ? 0
                  : o === n
                  ? ((r - i) / a) % 6
                  : o === r
                  ? 2 + (i - n) / a
                  : 4 + (n - r) / a + 4),
              (t /= 6),
              [360 * (t %= 1), 100 * a, 100 * (a < 1 ? s / (1 - a) : 0)]
            );
          }),
          (Fp.hsl.hcg = function (e) {
            var t,
              n = e[1] / 100,
              r = e[2] / 100,
              i = 0;
            return (
              (t = r < 0.5 ? 2 * n * r : 2 * n * (1 - r)) < 1 &&
                (i = (r - 0.5 * t) / (1 - t)),
              [e[0], 100 * t, 100 * i]
            );
          }),
          (Fp.hsv.hcg = function (e) {
            var t = e[1] / 100,
              n = e[2] / 100,
              r = t * n,
              i = 0;
            return r < 1 && (i = (n - r) / (1 - r)), [e[0], 100 * r, 100 * i];
          }),
          (Fp.hcg.rgb = function (e) {
            var t = e[0] / 360,
              n = e[1] / 100,
              r = e[2] / 100;
            if (0 === n) return [255 * r, 255 * r, 255 * r];
            var i,
              o = [0, 0, 0],
              s = (t % 1) * 6,
              a = s % 1,
              u = 1 - a;
            switch (Math.floor(s)) {
              case 0:
                (o[0] = 1), (o[1] = a), (o[2] = 0);
                break;
              case 1:
                (o[0] = u), (o[1] = 1), (o[2] = 0);
                break;
              case 2:
                (o[0] = 0), (o[1] = 1), (o[2] = a);
                break;
              case 3:
                (o[0] = 0), (o[1] = u), (o[2] = 1);
                break;
              case 4:
                (o[0] = a), (o[1] = 0), (o[2] = 1);
                break;
              default:
                (o[0] = 1), (o[1] = 0), (o[2] = u);
            }
            return (
              (i = (1 - n) * r),
              [255 * (n * o[0] + i), 255 * (n * o[1] + i), 255 * (n * o[2] + i)]
            );
          }),
          (Fp.hcg.hsv = function (e) {
            var t = e[1] / 100,
              n = t + (e[2] / 100) * (1 - t),
              r = 0;
            return n > 0 && (r = t / n), [e[0], 100 * r, 100 * n];
          }),
          (Fp.hcg.hsl = function (e) {
            var t = e[1] / 100,
              n = (e[2] / 100) * (1 - t) + 0.5 * t,
              r = 0;
            return (
              n > 0 && n < 0.5
                ? (r = t / (2 * n))
                : n >= 0.5 && n < 1 && (r = t / (2 * (1 - n))),
              [e[0], 100 * r, 100 * n]
            );
          }),
          (Fp.hcg.hwb = function (e) {
            var t = e[1] / 100,
              n = t + (e[2] / 100) * (1 - t);
            return [e[0], 100 * (n - t), 100 * (1 - n)];
          }),
          (Fp.hwb.hcg = function (e) {
            var t = e[1] / 100,
              n = 1 - e[2] / 100,
              r = n - t,
              i = 0;
            return r < 1 && (i = (n - r) / (1 - r)), [e[0], 100 * r, 100 * i];
          }),
          (Fp.apple.rgb = function (e) {
            return [
              (e[0] / 65535) * 255,
              (e[1] / 65535) * 255,
              (e[2] / 65535) * 255,
            ];
          }),
          (Fp.rgb.apple = function (e) {
            return [
              (e[0] / 255) * 65535,
              (e[1] / 255) * 65535,
              (e[2] / 255) * 65535,
            ];
          }),
          (Fp.gray.rgb = function (e) {
            return [(e[0] / 100) * 255, (e[0] / 100) * 255, (e[0] / 100) * 255];
          }),
          (Fp.gray.hsl = Fp.gray.hsv =
            function (e) {
              return [0, 0, e[0]];
            }),
          (Fp.gray.hwb = function (e) {
            return [0, 100, e[0]];
          }),
          (Fp.gray.cmyk = function (e) {
            return [0, 0, 0, e[0]];
          }),
          (Fp.gray.lab = function (e) {
            return [e[0], 0, 0];
          }),
          (Fp.gray.hex = function (e) {
            var t = 255 & Math.round((e[0] / 100) * 255),
              n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
            return "000000".substring(n.length) + n;
          }),
          (Fp.rgb.gray = function (e) {
            return [((e[0] + e[1] + e[2]) / 3 / 255) * 100];
          });
        var Pp = Ap.exports;
        function Np(e, t) {
          return function (n) {
            return t(e(n));
          };
        }
        function Mp(e, t) {
          for (
            var n = [t[e].parent, e], r = Pp[t[e].parent][e], i = t[e].parent;
            t[i].parent;

          )
            n.unshift(t[i].parent),
              (r = Np(Pp[t[i].parent][i], r)),
              (i = t[i].parent);
          return (r.conversion = n), r;
        }
        var Ip = Ap.exports,
          jp = function (e) {
            for (
              var t = (function (e) {
                  var t = (function () {
                      for (
                        var e = {}, t = Object.keys(Pp), n = t.length, r = 0;
                        r < n;
                        r++
                      )
                        e[t[r]] = { distance: -1, parent: null };
                      return e;
                    })(),
                    n = [e];
                  for (t[e].distance = 0; n.length; )
                    for (
                      var r = n.pop(),
                        i = Object.keys(Pp[r]),
                        o = i.length,
                        s = 0;
                      s < o;
                      s++
                    ) {
                      var a = i[s],
                        u = t[a];
                      -1 === u.distance &&
                        ((u.distance = t[r].distance + 1),
                        (u.parent = r),
                        n.unshift(a));
                    }
                  return t;
                })(e),
                n = {},
                r = Object.keys(t),
                i = r.length,
                o = 0;
              o < i;
              o++
            ) {
              var s = r[o];
              null !== t[s].parent && (n[s] = Mp(s, t));
            }
            return n;
          },
          Lp = {};
        Object.keys(Ip).forEach(function (e) {
          (Lp[e] = {}),
            Object.defineProperty(Lp[e], "channels", { value: Ip[e].channels }),
            Object.defineProperty(Lp[e], "labels", { value: Ip[e].labels });
          var t = jp(e);
          Object.keys(t).forEach(function (n) {
            var r = t[n];
            (Lp[e][n] = (function (e) {
              var t = function (t) {
                if (null == t) return t;
                arguments.length > 1 &&
                  (t = Array.prototype.slice.call(arguments));
                var n = e(t);
                if ("object" == typeof n)
                  for (var r = n.length, i = 0; i < r; i++)
                    n[i] = Math.round(n[i]);
                return n;
              };
              return "conversion" in e && (t.conversion = e.conversion), t;
            })(r)),
              (Lp[e][n].raw = (function (e) {
                var t = function (t) {
                  return null == t
                    ? t
                    : (arguments.length > 1 &&
                        (t = Array.prototype.slice.call(arguments)),
                      e(t));
                };
                return "conversion" in e && (t.conversion = e.conversion), t;
              })(r));
          });
        });
        var $p,
          Rp = Lp;
        function zp() {
          if (void 0 === $p) {
            var e = new ArrayBuffer(2),
              t = new Uint8Array(e),
              n = new Uint16Array(e);
            if (((t[0] = 1), (t[1] = 2), 258 === n[0])) $p = "BE";
            else {
              if (513 !== n[0])
                throw new Error("unable to figure out endianess");
              $p = "LE";
            }
          }
          return $p;
        }
        function Vp() {
          return void 0 !== ba.location ? ba.location.hostname : "";
        }
        function qp() {
          return [];
        }
        function Wp() {
          return 0;
        }
        function Up() {
          return Number.MAX_VALUE;
        }
        function Hp() {
          return Number.MAX_VALUE;
        }
        function Gp() {
          return [];
        }
        function Yp() {
          return "Browser";
        }
        function Xp() {
          return void 0 !== ba.navigator ? ba.navigator.appVersion : "";
        }
        function Jp() {}
        function Zp() {}
        function Kp() {
          return "javascript";
        }
        function Qp() {
          return "browser";
        }
        function ef() {
          return "/tmp";
        }
        !(function (e) {
          const t = Rp,
            n = (e, n) =>
              function () {
                const r = e.apply(t, arguments);
                return "[".concat(r + n, "m");
              },
            r = (e, n) =>
              function () {
                const r = e.apply(t, arguments);
                return "[".concat(38 + n, ";5;").concat(r, "m");
              },
            i = (e, n) =>
              function () {
                const r = e.apply(t, arguments);
                return "["
                  .concat(38 + n, ";2;")
                  .concat(r[0], ";")
                  .concat(r[1], ";")
                  .concat(r[2], "m");
              };
          Object.defineProperty(e, "exports", {
            enumerable: !0,
            get: function () {
              const e = new Map(),
                o = {
                  modifier: {
                    reset: [0, 0],
                    bold: [1, 22],
                    dim: [2, 22],
                    italic: [3, 23],
                    underline: [4, 24],
                    inverse: [7, 27],
                    hidden: [8, 28],
                    strikethrough: [9, 29],
                  },
                  color: {
                    black: [30, 39],
                    red: [31, 39],
                    green: [32, 39],
                    yellow: [33, 39],
                    blue: [34, 39],
                    magenta: [35, 39],
                    cyan: [36, 39],
                    white: [37, 39],
                    gray: [90, 39],
                    redBright: [91, 39],
                    greenBright: [92, 39],
                    yellowBright: [93, 39],
                    blueBright: [94, 39],
                    magentaBright: [95, 39],
                    cyanBright: [96, 39],
                    whiteBright: [97, 39],
                  },
                  bgColor: {
                    bgBlack: [40, 49],
                    bgRed: [41, 49],
                    bgGreen: [42, 49],
                    bgYellow: [43, 49],
                    bgBlue: [44, 49],
                    bgMagenta: [45, 49],
                    bgCyan: [46, 49],
                    bgWhite: [47, 49],
                    bgBlackBright: [100, 49],
                    bgRedBright: [101, 49],
                    bgGreenBright: [102, 49],
                    bgYellowBright: [103, 49],
                    bgBlueBright: [104, 49],
                    bgMagentaBright: [105, 49],
                    bgCyanBright: [106, 49],
                    bgWhiteBright: [107, 49],
                  },
                };
              o.color.grey = o.color.gray;
              for (const t of Object.keys(o)) {
                const n = o[t];
                for (const t of Object.keys(n)) {
                  const r = n[t];
                  (o[t] = {
                    open: "[".concat(r[0], "m"),
                    close: "[".concat(r[1], "m"),
                  }),
                    (n[t] = o[t]),
                    e.set(r[0], r[1]);
                }
                Object.defineProperty(o, t, { value: n, enumerable: !1 }),
                  Object.defineProperty(o, "codes", {
                    value: e,
                    enumerable: !1,
                  });
              }
              const s = (e) => e,
                a = (e, t, n) => [e, t, n];
              (o.color.close = "[39m"),
                (o.bgColor.close = "[49m"),
                (o.color.ansi = { ansi: n(s, 0) }),
                (o.color.ansi256 = { ansi256: r(s, 0) }),
                (o.color.ansi16m = { rgb: i(a, 0) }),
                (o.bgColor.ansi = { ansi: n(s, 10) }),
                (o.bgColor.ansi256 = { ansi256: r(s, 10) }),
                (o.bgColor.ansi16m = { rgb: i(a, 10) });
              for (let e of Object.keys(t)) {
                if ("object" != typeof t[e]) continue;
                const s = t[e];
                "ansi16" === e && (e = "ansi"),
                  "ansi16" in s &&
                    ((o.color.ansi[e] = n(s.ansi16, 0)),
                    (o.bgColor.ansi[e] = n(s.ansi16, 10))),
                  "ansi256" in s &&
                    ((o.color.ansi256[e] = r(s.ansi256, 0)),
                    (o.bgColor.ansi256[e] = r(s.ansi256, 10))),
                  "rgb" in s &&
                    ((o.color.ansi16m[e] = i(s.rgb, 0)),
                    (o.bgColor.ansi16m[e] = i(s.rgb, 10)));
              }
              return o;
            },
          });
        })(wp);
        var tf = ef,
          nf = {
            EOL: "\n",
            arch: Kp,
            platform: Qp,
            tmpdir: tf,
            tmpDir: ef,
            networkInterfaces: Jp,
            getNetworkInterfaces: Zp,
            release: Xp,
            type: Yp,
            cpus: Gp,
            totalmem: Hp,
            freemem: Up,
            uptime: Wp,
            loadavg: qp,
            hostname: Vp,
            endianness: zp,
          },
          rf = t(
            Object.freeze({
              __proto__: null,
              endianness: zp,
              hostname: Vp,
              loadavg: qp,
              uptime: Wp,
              freemem: Up,
              totalmem: Hp,
              cpus: Gp,
              type: Yp,
              release: Xp,
              networkInterfaces: Jp,
              getNetworkInterfaces: Zp,
              arch: Kp,
              platform: Qp,
              tmpDir: ef,
              tmpdir: tf,
              EOL: "\n",
              default: nf,
            })
          );
        const of = rf,
          sf = (e, t) => {
            t = t || Ua.argv;
            const n = e.startsWith("-") ? "" : 1 === e.length ? "-" : "--",
              r = t.indexOf(n + e),
              i = t.indexOf("--");
            return -1 !== r && (-1 === i || r < i);
          },
          af = Ua.env;
        let uf;
        function lf(e) {
          const t = (function (e) {
            if (!1 === uf) return 0;
            if (sf("color=16m") || sf("color=full") || sf("color=truecolor"))
              return 3;
            if (sf("color=256")) return 2;
            if (e && !e.isTTY && !0 !== uf) return 0;
            const t = uf ? 1 : 0;
            if ("win32" === Ua.platform) {
              const e = of.release().split(".");
              return Number(Ua.versions.node.split(".")[0]) >= 8 &&
                Number(e[0]) >= 10 &&
                Number(e[2]) >= 10586
                ? Number(e[2]) >= 14931
                  ? 3
                  : 2
                : 1;
            }
            if ("CI" in af)
              return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(
                (e) => e in af
              ) || "codeship" === af.CI_NAME
                ? 1
                : t;
            if ("TEAMCITY_VERSION" in af)
              return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(af.TEAMCITY_VERSION)
                ? 1
                : 0;
            if ("truecolor" === af.COLORTERM) return 3;
            if ("TERM_PROGRAM" in af) {
              const e = parseInt(
                (af.TERM_PROGRAM_VERSION || "").split(".")[0],
                10
              );
              switch (af.TERM_PROGRAM) {
                case "iTerm.app":
                  return e >= 3 ? 3 : 2;
                case "Apple_Terminal":
                  return 2;
              }
            }
            return /-256(color)?$/i.test(af.TERM)
              ? 2
              : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(
                  af.TERM
                ) || "COLORTERM" in af
              ? 1
              : (af.TERM, t);
          })(e);
          return (function (e) {
            return (
              0 !== e && {
                level: e,
                hasBasic: !0,
                has256: e >= 2,
                has16m: e >= 3,
              }
            );
          })(t);
        }
        sf("no-color") || sf("no-colors") || sf("color=false")
          ? (uf = !1)
          : (sf("color") ||
              sf("colors") ||
              sf("color=true") ||
              sf("color=always")) &&
            (uf = !0),
          "FORCE_COLOR" in af &&
            (uf =
              0 === af.FORCE_COLOR.length ||
              0 !== parseInt(af.FORCE_COLOR, 10));
        var cf = {
          supportsColor: lf,
          stdout: lf(Ua.stdout),
          stderr: lf(Ua.stderr),
        };
        const pf =
            /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
          ff = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g,
          df = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/,
          hf = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi,
          mf = new Map([
            ["n", "\n"],
            ["r", "\r"],
            ["t", "\t"],
            ["b", "\b"],
            ["f", "\f"],
            ["v", "\v"],
            ["0", "\0"],
            ["\\", "\\"],
            ["e", ""],
            ["a", ""],
          ]);
        function gf(e) {
          return ("u" === e[0] && 5 === e.length) ||
            ("x" === e[0] && 3 === e.length)
            ? String.fromCharCode(parseInt(e.slice(1), 16))
            : mf.get(e) || e;
        }
        function yf(e, t) {
          const n = [],
            r = t.trim().split(/\s*,\s*/g);
          let i;
          for (const t of r)
            if (isNaN(t)) {
              if (!(i = t.match(df)))
                throw new Error(
                  "Invalid Chalk template style argument: "
                    .concat(t, " (in style '")
                    .concat(e, "')")
                );
              n.push(i[2].replace(hf, (e, t, n) => (t ? gf(t) : n)));
            } else n.push(Number(t));
          return n;
        }
        function vf(e) {
          ff.lastIndex = 0;
          const t = [];
          let n;
          for (; null !== (n = ff.exec(e)); ) {
            const e = n[1];
            if (n[2]) {
              const r = yf(e, n[2]);
              t.push([e].concat(r));
            } else t.push([e]);
          }
          return t;
        }
        function Df(e, t) {
          const n = {};
          for (const e of t)
            for (const t of e.styles) n[t[0]] = e.inverse ? null : t.slice(1);
          let r = e;
          for (const e of Object.keys(n))
            if (Array.isArray(n[e])) {
              if (!(e in r)) throw new Error("Unknown Chalk style: ".concat(e));
              r = n[e].length > 0 ? r[e].apply(r, n[e]) : r[e];
            }
          return r;
        }
        var bf = (e, t) => {
          const n = [],
            r = [];
          let i = [];
          if (
            (t.replace(pf, (t, o, s, a, u, l) => {
              if (o) i.push(gf(o));
              else if (a) {
                const t = i.join("");
                (i = []),
                  r.push(0 === n.length ? t : Df(e, n)(t)),
                  n.push({ inverse: s, styles: vf(a) });
              } else if (u) {
                if (0 === n.length)
                  throw new Error(
                    "Found extraneous } in Chalk template literal"
                  );
                r.push(Df(e, n)(i.join(""))), (i = []), n.pop();
              } else i.push(l);
            }),
            r.push(i.join("")),
            n.length > 0)
          ) {
            const e = "Chalk template literal is missing "
              .concat(n.length, " closing bracket")
              .concat(1 === n.length ? "" : "s", " (`}`)");
            throw new Error(e);
          }
          return r.join("");
        };
        !(function (e) {
          const t = xp,
            n = wp.exports,
            r = cf.stdout,
            i = bf,
            o =
              "win32" === Ua.platform &&
              !(Ua.env.TERM || "").toLowerCase().startsWith("xterm"),
            s = ["ansi", "ansi", "ansi256", "ansi16m"],
            a = new Set(["gray"]),
            u = Object.create(null);
          function l(e, t) {
            t = t || {};
            const n = r ? r.level : 0;
            (e.level = void 0 === t.level ? n : t.level),
              (e.enabled = "enabled" in t ? t.enabled : e.level > 0);
          }
          function c(e) {
            if (!this || !(this instanceof c) || this.template) {
              const t = {};
              return (
                l(t, e),
                (t.template = function () {
                  const e = [].slice.call(arguments);
                  return h.apply(null, [t.template].concat(e));
                }),
                Object.setPrototypeOf(t, c.prototype),
                Object.setPrototypeOf(t.template, t),
                (t.template.constructor = c),
                t.template
              );
            }
            l(this, e);
          }
          o && (n.blue.open = "[94m");
          for (const e of Object.keys(n))
            (n[e].closeRe = new RegExp(t(n[e].close), "g")),
              (u[e] = {
                get() {
                  const t = n[e];
                  return f.call(
                    this,
                    this._styles ? this._styles.concat(t) : [t],
                    this._empty,
                    e
                  );
                },
              });
          (u.visible = {
            get() {
              return f.call(this, this._styles || [], !0, "visible");
            },
          }),
            (n.color.closeRe = new RegExp(t(n.color.close), "g"));
          for (const e of Object.keys(n.color.ansi))
            a.has(e) ||
              (u[e] = {
                get() {
                  const t = this.level;
                  return function () {
                    const r = {
                      open: n.color[s[t]][e].apply(null, arguments),
                      close: n.color.close,
                      closeRe: n.color.closeRe,
                    };
                    return f.call(
                      this,
                      this._styles ? this._styles.concat(r) : [r],
                      this._empty,
                      e
                    );
                  };
                },
              });
          n.bgColor.closeRe = new RegExp(t(n.bgColor.close), "g");
          for (const e of Object.keys(n.bgColor.ansi))
            a.has(e) ||
              (u["bg" + e[0].toUpperCase() + e.slice(1)] = {
                get() {
                  const t = this.level;
                  return function () {
                    const r = {
                      open: n.bgColor[s[t]][e].apply(null, arguments),
                      close: n.bgColor.close,
                      closeRe: n.bgColor.closeRe,
                    };
                    return f.call(
                      this,
                      this._styles ? this._styles.concat(r) : [r],
                      this._empty,
                      e
                    );
                  };
                },
              });
          const p = Object.defineProperties(() => {}, u);
          function f(e, t, n) {
            const r = function () {
              return d.apply(r, arguments);
            };
            (r._styles = e), (r._empty = t);
            const i = this;
            return (
              Object.defineProperty(r, "level", {
                enumerable: !0,
                get: () => i.level,
                set(e) {
                  i.level = e;
                },
              }),
              Object.defineProperty(r, "enabled", {
                enumerable: !0,
                get: () => i.enabled,
                set(e) {
                  i.enabled = e;
                },
              }),
              (r.hasGrey = this.hasGrey || "gray" === n || "grey" === n),
              (r.__proto__ = p),
              r
            );
          }
          function d() {
            const e = arguments,
              t = e.length;
            let r = String(arguments[0]);
            if (0 === t) return "";
            if (t > 1) for (let n = 1; n < t; n++) r += " " + e[n];
            if (!this.enabled || this.level <= 0 || !r)
              return this._empty ? "" : r;
            const i = n.dim.open;
            o && this.hasGrey && (n.dim.open = "");
            for (const e of this._styles.slice().reverse())
              (r = e.open + r.replace(e.closeRe, e.open) + e.close),
                (r = r.replace(
                  /\r?\n/g,
                  "".concat(e.close, "$&").concat(e.open)
                ));
            return (n.dim.open = i), r;
          }
          function h(e, t) {
            if (!Array.isArray(t)) return [].slice.call(arguments, 1).join(" ");
            const n = [].slice.call(arguments, 2),
              r = [t.raw[0]];
            for (let e = 1; e < t.length; e++)
              r.push(String(n[e - 1]).replace(/[{}\\]/g, "\\$&")),
                r.push(String(t.raw[e]));
            return i(e, r.join(""));
          }
          Object.defineProperties(c.prototype, u),
            (e.exports = c()),
            (e.exports.supportsColor = r),
            (e.exports.default = e.exports);
        })(Ep),
          Object.defineProperty(bp, "__esModule", { value: !0 });
        const Ef = Ep.exports;
        (bp.commonDeprecatedHandler = (e, t, n) => {
          let { descriptor: r } = n;
          const i = [
            "".concat(
              Ef.default.yellow("string" == typeof e ? r.key(e) : r.pair(e)),
              " is deprecated"
            ),
          ];
          return (
            t &&
              i.push(
                "we now treat it as ".concat(
                  Ef.default.blue("string" == typeof t ? r.key(t) : r.pair(t))
                )
              ),
            i.join("; ") + "."
          );
        }),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 }),
              mp.__exportStar(bp, e);
          })(Dp);
        var Cf = {},
          xf = {};
        Object.defineProperty(xf, "__esModule", { value: !0 });
        const wf = Ep.exports;
        (xf.commonInvalidHandler = (e, t, n) =>
          [
            "Invalid ".concat(wf.default.red(n.descriptor.key(e)), " value."),
            "Expected ".concat(wf.default.blue(n.schemas[e].expected(n)), ","),
            "but received ".concat(wf.default.red(n.descriptor.value(t)), "."),
          ].join(" ")),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 }),
              mp.__exportStar(xf, e);
          })(Cf);
        var Af = {},
          Sf = {},
          _f = [],
          Tf = [];
        Object.defineProperty(Sf, "__esModule", { value: !0 });
        const Ff = Ep.exports;
        (Sf.levenUnknownHandler = (e, t, n) => {
          let { descriptor: r, logger: i, schemas: o } = n;
          const s = [
              "Ignored unknown option ".concat(
                Ff.default.yellow(r.pair({ key: e, value: t })),
                "."
              ),
            ],
            a = Object.keys(o)
              .sort()
              .find(
                (t) =>
                  (function (e, t) {
                    if (e === t) return 0;
                    var n = e;
                    e.length > t.length && ((e = t), (t = n));
                    var r = e.length,
                      i = t.length;
                    if (0 === r) return i;
                    if (0 === i) return r;
                    for (; r > 0 && e.charCodeAt(~-r) === t.charCodeAt(~-i); )
                      r--, i--;
                    if (0 === r) return i;
                    for (
                      var o, s, a, u, l = 0;
                      l < r && e.charCodeAt(l) === t.charCodeAt(l);

                    )
                      l++;
                    if (((i -= l), 0 == (r -= l))) return i;
                    for (var c = 0, p = 0; c < r; )
                      (Tf[l + c] = e.charCodeAt(l + c)), (_f[c] = ++c);
                    for (; p < i; )
                      for (
                        o = t.charCodeAt(l + p), a = p++, s = p, c = 0;
                        c < r;
                        c++
                      )
                        (u = o === Tf[l + c] ? a : a + 1),
                          (a = _f[c]),
                          (s = _f[c] =
                            a > s ? (u > s ? s + 1 : u) : u > a ? a + 1 : u);
                    return s;
                  })(e, t) < 3
              );
          a && s.push("Did you mean ".concat(Ff.default.blue(r.key(a)), "?")),
            i.warn(s.join(" "));
        }),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 }),
              mp.__exportStar(Sf, e);
          })(Af),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 });
            const t = mp;
            t.__exportStar(Dp, e), t.__exportStar(Cf, e), t.__exportStar(Af, e);
          })(vp);
        var kf = {},
          Of = {},
          Bf = {};
        Object.defineProperty(Bf, "__esModule", { value: !0 });
        const Pf = [
          "default",
          "expected",
          "validate",
          "deprecated",
          "forward",
          "redirect",
          "overlap",
          "preprocess",
          "postprocess",
        ];
        function Nf(e, t) {
          const n = new e(t),
            r = Object.create(n);
          for (const e of Pf)
            e in t && (r[e] = If(t[e], n, Mf.prototype[e].length));
          return r;
        }
        Bf.createSchema = Nf;
        class Mf {
          constructor(e) {
            this.name = e.name;
          }
          static create(e) {
            return Nf(this, e);
          }
          default(e) {}
          expected(e) {
            return "nothing";
          }
          validate(e, t) {
            return !1;
          }
          deprecated(e, t) {
            return !1;
          }
          forward(e, t) {}
          redirect(e, t) {}
          overlap(e, t, n) {
            return e;
          }
          preprocess(e, t) {
            return e;
          }
          postprocess(e, t) {
            return e;
          }
        }
        function If(e, t, n) {
          return "function" == typeof e
            ? function () {
                for (
                  var r = arguments.length, i = new Array(r), o = 0;
                  o < r;
                  o++
                )
                  i[o] = arguments[o];
                return e(...i.slice(0, n - 1), t, ...i.slice(n - 1));
              }
            : () => e;
        }
        (Bf.Schema = Mf),
          Object.defineProperty(Of, "__esModule", { value: !0 });
        const jf = Bf;
        class Lf extends jf.Schema {
          constructor(e) {
            super(e), (this._sourceName = e.sourceName);
          }
          expected(e) {
            return e.schemas[this._sourceName].expected(e);
          }
          validate(e, t) {
            return t.schemas[this._sourceName].validate(e, t);
          }
          redirect(e, t) {
            return this._sourceName;
          }
        }
        Of.AliasSchema = Lf;
        var $f = {};
        Object.defineProperty($f, "__esModule", { value: !0 });
        const Rf = Bf;
        class zf extends Rf.Schema {
          expected() {
            return "anything";
          }
          validate() {
            return !0;
          }
        }
        $f.AnySchema = zf;
        var Vf = {};
        Object.defineProperty(Vf, "__esModule", { value: !0 });
        const qf = mp,
          Wf = Bf;
        class Uf extends Wf.Schema {
          constructor(e) {
            var { valueSchema: t, name: n = t.name } = e,
              r = qf.__rest(e, ["valueSchema", "name"]);
            super(Object.assign({}, r, { name: n })), (this._valueSchema = t);
          }
          expected(e) {
            return "an array of ".concat(this._valueSchema.expected(e));
          }
          validate(e, t) {
            if (!Array.isArray(e)) return !1;
            const n = [];
            for (const r of e) {
              const e = t.normalizeValidateResult(
                this._valueSchema.validate(r, t),
                r
              );
              !0 !== e && n.push(e.value);
            }
            return 0 === n.length || { value: n };
          }
          deprecated(e, t) {
            const n = [];
            for (const r of e) {
              const e = t.normalizeDeprecatedResult(
                this._valueSchema.deprecated(r, t),
                r
              );
              !1 !== e &&
                n.push(
                  ...e.map((e) => {
                    let { value: t } = e;
                    return { value: [t] };
                  })
                );
            }
            return n;
          }
          forward(e, t) {
            const n = [];
            for (const r of e) {
              const e = t.normalizeForwardResult(
                this._valueSchema.forward(r, t),
                r
              );
              n.push(...e.map(Hf));
            }
            return n;
          }
          redirect(e, t) {
            const n = [],
              r = [];
            for (const i of e) {
              const e = t.normalizeRedirectResult(
                this._valueSchema.redirect(i, t),
                i
              );
              "remain" in e && n.push(e.remain), r.push(...e.redirect.map(Hf));
            }
            return 0 === n.length
              ? { redirect: r }
              : { redirect: r, remain: n };
          }
          overlap(e, t) {
            return e.concat(t);
          }
        }
        function Hf(e) {
          let { from: t, to: n } = e;
          return { from: [t], to: n };
        }
        Vf.ArraySchema = Uf;
        var Gf = {};
        Object.defineProperty(Gf, "__esModule", { value: !0 });
        const Yf = Bf;
        class Xf extends Yf.Schema {
          expected() {
            return "true or false";
          }
          validate(e) {
            return "boolean" == typeof e;
          }
        }
        Gf.BooleanSchema = Xf;
        var Jf = {},
          Zf = {};
        function Kf(e, t) {
          return "string" == typeof e || "key" in e
            ? { from: t, to: e }
            : "from" in e
            ? { from: e.from, to: e.to }
            : { from: t, to: e.to };
        }
        function Qf(e, t) {
          return void 0 === e
            ? []
            : Array.isArray(e)
            ? e.map((e) => Kf(e, t))
            : [Kf(e, t)];
        }
        Object.defineProperty(Zf, "__esModule", { value: !0 }),
          (Zf.recordFromArray = function (e, t) {
            const n = Object.create(null);
            for (const r of e) {
              const e = r[t];
              if (n[e])
                throw new Error(
                  "Duplicate ".concat(t, " ").concat(JSON.stringify(e))
                );
              n[e] = r;
            }
            return n;
          }),
          (Zf.mapFromArray = function (e, t) {
            const n = new Map();
            for (const r of e) {
              const e = r[t];
              if (n.has(e))
                throw new Error(
                  "Duplicate ".concat(t, " ").concat(JSON.stringify(e))
                );
              n.set(e, r);
            }
            return n;
          }),
          (Zf.createAutoChecklist = function () {
            const e = Object.create(null);
            return (t) => {
              const n = JSON.stringify(t);
              return !!e[n] || ((e[n] = !0), !1);
            };
          }),
          (Zf.partition = function (e, t) {
            const n = [],
              r = [];
            for (const i of e) t(i) ? n.push(i) : r.push(i);
            return [n, r];
          }),
          (Zf.isInt = function (e) {
            return e === Math.floor(e);
          }),
          (Zf.comparePrimitive = function (e, t) {
            if (e === t) return 0;
            const n = typeof e,
              r = typeof t,
              i = ["undefined", "object", "boolean", "number", "string"];
            return n !== r
              ? i.indexOf(n) - i.indexOf(r)
              : "string" !== n
              ? Number(e) - Number(t)
              : e.localeCompare(t);
          }),
          (Zf.normalizeDefaultResult = function (e) {
            return void 0 === e ? {} : e;
          }),
          (Zf.normalizeValidateResult = function (e, t) {
            return !0 === e || (!1 === e ? { value: t } : e);
          }),
          (Zf.normalizeDeprecatedResult = function (e, t) {
            return (
              !1 !== e &&
              (!0 === e
                ? !!(
                    arguments.length > 2 &&
                    void 0 !== arguments[2] &&
                    arguments[2]
                  ) || [{ value: t }]
                : "value" in e
                ? [e]
                : 0 !== e.length && e)
            );
          }),
          (Zf.normalizeTransferResult = Kf),
          (Zf.normalizeForwardResult = Qf),
          (Zf.normalizeRedirectResult = function (e, t) {
            const n = Qf(
              "object" == typeof e && "redirect" in e ? e.redirect : e,
              t
            );
            return 0 === n.length
              ? { remain: t, redirect: n }
              : "object" == typeof e && "remain" in e
              ? { remain: e.remain, redirect: n }
              : { redirect: n };
          }),
          Object.defineProperty(Jf, "__esModule", { value: !0 });
        const ed = Bf,
          td = Zf;
        class nd extends ed.Schema {
          constructor(e) {
            super(e),
              (this._choices = td.mapFromArray(
                e.choices.map((e) =>
                  e && "object" == typeof e ? e : { value: e }
                ),
                "value"
              ));
          }
          expected(e) {
            let { descriptor: t } = e;
            const n = Array.from(this._choices.keys())
                .map((e) => this._choices.get(e))
                .filter((e) => !e.deprecated)
                .map((e) => e.value)
                .sort(td.comparePrimitive)
                .map(t.value),
              r = n.slice(0, -2),
              i = n.slice(-2);
            return r.concat(i.join(" or ")).join(", ");
          }
          validate(e) {
            return this._choices.has(e);
          }
          deprecated(e) {
            const t = this._choices.get(e);
            return !(!t || !t.deprecated) && { value: e };
          }
          forward(e) {
            const t = this._choices.get(e);
            return t ? t.forward : void 0;
          }
          redirect(e) {
            const t = this._choices.get(e);
            return t ? t.redirect : void 0;
          }
        }
        Jf.ChoiceSchema = nd;
        var rd = {},
          id = {};
        Object.defineProperty(id, "__esModule", { value: !0 });
        const od = Bf;
        class sd extends od.Schema {
          expected() {
            return "a number";
          }
          validate(e, t) {
            return "number" == typeof e;
          }
        }
        (id.NumberSchema = sd),
          Object.defineProperty(rd, "__esModule", { value: !0 });
        const ad = Zf,
          ud = id;
        class ld extends ud.NumberSchema {
          expected() {
            return "an integer";
          }
          validate(e, t) {
            return (
              !0 === t.normalizeValidateResult(super.validate(e, t), e) &&
              ad.isInt(e)
            );
          }
        }
        rd.IntegerSchema = ld;
        var cd = {};
        Object.defineProperty(cd, "__esModule", { value: !0 });
        const pd = Bf;
        class fd extends pd.Schema {
          expected() {
            return "a string";
          }
          validate(e) {
            return "string" == typeof e;
          }
        }
        (cd.StringSchema = fd),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 });
            const t = mp;
            t.__exportStar(Of, e),
              t.__exportStar($f, e),
              t.__exportStar(Vf, e),
              t.__exportStar(Gf, e),
              t.__exportStar(Jf, e),
              t.__exportStar(rd, e),
              t.__exportStar(id, e),
              t.__exportStar(cd, e);
          })(kf);
        var dd = {},
          hd = {};
        Object.defineProperty(hd, "__esModule", { value: !0 });
        const md = yp,
          gd = bp,
          yd = Cf,
          vd = Sf;
        (hd.defaultDescriptor = md.apiDescriptor),
          (hd.defaultUnknownHandler = vd.levenUnknownHandler),
          (hd.defaultInvalidHandler = yd.commonInvalidHandler),
          (hd.defaultDeprecatedHandler = gd.commonDeprecatedHandler),
          Object.defineProperty(dd, "__esModule", { value: !0 });
        const Dd = hd,
          bd = Zf;
        dd.normalize = (e, t, n) => new Ed(t, n).normalize(e);
        class Ed {
          constructor(e, t) {
            const {
              logger: n = console,
              descriptor: r = Dd.defaultDescriptor,
              unknown: i = Dd.defaultUnknownHandler,
              invalid: o = Dd.defaultInvalidHandler,
              deprecated: s = Dd.defaultDeprecatedHandler,
            } = t || {};
            (this._utils = {
              descriptor: r,
              logger: n || { warn: () => {} },
              schemas: bd.recordFromArray(e, "name"),
              normalizeDefaultResult: bd.normalizeDefaultResult,
              normalizeDeprecatedResult: bd.normalizeDeprecatedResult,
              normalizeForwardResult: bd.normalizeForwardResult,
              normalizeRedirectResult: bd.normalizeRedirectResult,
              normalizeValidateResult: bd.normalizeValidateResult,
            }),
              (this._unknownHandler = i),
              (this._invalidHandler = o),
              (this._deprecatedHandler = s),
              this.cleanHistory();
          }
          cleanHistory() {
            this._hasDeprecationWarned = bd.createAutoChecklist();
          }
          normalize(e) {
            const t = {},
              n = [e],
              r = () => {
                for (; 0 !== n.length; ) {
                  const e = n.shift(),
                    r = this._applyNormalization(e, t);
                  n.push(...r);
                }
              };
            r();
            for (const e of Object.keys(this._utils.schemas)) {
              const r = this._utils.schemas[e];
              if (!(e in t)) {
                const t = bd.normalizeDefaultResult(r.default(this._utils));
                "value" in t && n.push({ [e]: t.value });
              }
            }
            r();
            for (const e of Object.keys(this._utils.schemas)) {
              const n = this._utils.schemas[e];
              e in t && (t[e] = n.postprocess(t[e], this._utils));
            }
            return t;
          }
          _applyNormalization(e, t) {
            const n = [],
              [r, i] = bd.partition(
                Object.keys(e),
                (e) => e in this._utils.schemas
              );
            for (const i of r) {
              const r = this._utils.schemas[i],
                o = r.preprocess(e[i], this._utils),
                s = bd.normalizeValidateResult(r.validate(o, this._utils), o);
              if (!0 !== s) {
                const { value: e } = s,
                  t = this._invalidHandler(i, e, this._utils);
                throw "string" == typeof t ? new Error(t) : t;
              }
              const a = (e) => {
                  let { from: t, to: r } = e;
                  n.push(
                    "string" == typeof r ? { [r]: t } : { [r.key]: r.value }
                  );
                },
                u = (e) => {
                  let { value: t, redirectTo: n } = e;
                  const s = bd.normalizeDeprecatedResult(
                    r.deprecated(t, this._utils),
                    o,
                    !0
                  );
                  if (!1 !== s)
                    if (!0 === s)
                      this._hasDeprecationWarned(i) ||
                        this._utils.logger.warn(
                          this._deprecatedHandler(i, n, this._utils)
                        );
                    else
                      for (const { value: e } of s) {
                        const t = { key: i, value: e };
                        if (!this._hasDeprecationWarned(t)) {
                          const r =
                            "string" == typeof n ? { key: n, value: e } : n;
                          this._utils.logger.warn(
                            this._deprecatedHandler(t, r, this._utils)
                          );
                        }
                      }
                };
              bd.normalizeForwardResult(r.forward(o, this._utils), o).forEach(
                a
              );
              const l = bd.normalizeRedirectResult(
                r.redirect(o, this._utils),
                o
              );
              if ((l.redirect.forEach(a), "remain" in l)) {
                const e = l.remain;
                (t[i] = i in t ? r.overlap(t[i], e, this._utils) : e),
                  u({ value: e });
              }
              for (const { from: e, to: t } of l.redirect)
                u({ value: e, redirectTo: t });
            }
            for (const r of i) {
              const i = e[r],
                o = this._unknownHandler(r, i, this._utils);
              if (o)
                for (const e of Object.keys(o)) {
                  const r = { [e]: o[e] };
                  e in this._utils.schemas ? n.push(r) : Object.assign(t, r);
                }
            }
            return n;
          }
        }
        (dd.Normalizer = Ed),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 });
            const t = mp;
            t.__exportStar(gp, e),
              t.__exportStar(vp, e),
              t.__exportStar(kf, e),
              t.__exportStar(dd, e),
              t.__exportStar(Bf, e);
          })(lp);
        var Cd = { exports: {} };
        const xd = [],
          wd = [],
          Ad = (e, t) => {
            if (e === t) return 0;
            const n = e;
            e.length > t.length && ((e = t), (t = n));
            let r = e.length,
              i = t.length;
            for (; r > 0 && e.charCodeAt(~-r) === t.charCodeAt(~-i); ) r--, i--;
            let o,
              s,
              a,
              u,
              l = 0;
            for (; l < r && e.charCodeAt(l) === t.charCodeAt(l); ) l++;
            if (((r -= l), (i -= l), 0 === r)) return i;
            let c = 0,
              p = 0;
            for (; c < r; ) (wd[c] = e.charCodeAt(l + c)), (xd[c] = ++c);
            for (; p < i; )
              for (o = t.charCodeAt(l + p), a = p++, s = p, c = 0; c < r; c++)
                (u = o === wd[c] ? a : a + 1),
                  (a = xd[c]),
                  (s = xd[c] = a > s ? (u > s ? s + 1 : u) : u > a ? a + 1 : u);
            return s;
          };
        (Cd.exports = Ad), (Cd.exports.default = Ad);
        var Sd = { exports: {} };
        const _d = {
            aliceblue: [240, 248, 255],
            antiquewhite: [250, 235, 215],
            aqua: [0, 255, 255],
            aquamarine: [127, 255, 212],
            azure: [240, 255, 255],
            beige: [245, 245, 220],
            bisque: [255, 228, 196],
            black: [0, 0, 0],
            blanchedalmond: [255, 235, 205],
            blue: [0, 0, 255],
            blueviolet: [138, 43, 226],
            brown: [165, 42, 42],
            burlywood: [222, 184, 135],
            cadetblue: [95, 158, 160],
            chartreuse: [127, 255, 0],
            chocolate: [210, 105, 30],
            coral: [255, 127, 80],
            cornflowerblue: [100, 149, 237],
            cornsilk: [255, 248, 220],
            crimson: [220, 20, 60],
            cyan: [0, 255, 255],
            darkblue: [0, 0, 139],
            darkcyan: [0, 139, 139],
            darkgoldenrod: [184, 134, 11],
            darkgray: [169, 169, 169],
            darkgreen: [0, 100, 0],
            darkgrey: [169, 169, 169],
            darkkhaki: [189, 183, 107],
            darkmagenta: [139, 0, 139],
            darkolivegreen: [85, 107, 47],
            darkorange: [255, 140, 0],
            darkorchid: [153, 50, 204],
            darkred: [139, 0, 0],
            darksalmon: [233, 150, 122],
            darkseagreen: [143, 188, 143],
            darkslateblue: [72, 61, 139],
            darkslategray: [47, 79, 79],
            darkslategrey: [47, 79, 79],
            darkturquoise: [0, 206, 209],
            darkviolet: [148, 0, 211],
            deeppink: [255, 20, 147],
            deepskyblue: [0, 191, 255],
            dimgray: [105, 105, 105],
            dimgrey: [105, 105, 105],
            dodgerblue: [30, 144, 255],
            firebrick: [178, 34, 34],
            floralwhite: [255, 250, 240],
            forestgreen: [34, 139, 34],
            fuchsia: [255, 0, 255],
            gainsboro: [220, 220, 220],
            ghostwhite: [248, 248, 255],
            gold: [255, 215, 0],
            goldenrod: [218, 165, 32],
            gray: [128, 128, 128],
            green: [0, 128, 0],
            greenyellow: [173, 255, 47],
            grey: [128, 128, 128],
            honeydew: [240, 255, 240],
            hotpink: [255, 105, 180],
            indianred: [205, 92, 92],
            indigo: [75, 0, 130],
            ivory: [255, 255, 240],
            khaki: [240, 230, 140],
            lavender: [230, 230, 250],
            lavenderblush: [255, 240, 245],
            lawngreen: [124, 252, 0],
            lemonchiffon: [255, 250, 205],
            lightblue: [173, 216, 230],
            lightcoral: [240, 128, 128],
            lightcyan: [224, 255, 255],
            lightgoldenrodyellow: [250, 250, 210],
            lightgray: [211, 211, 211],
            lightgreen: [144, 238, 144],
            lightgrey: [211, 211, 211],
            lightpink: [255, 182, 193],
            lightsalmon: [255, 160, 122],
            lightseagreen: [32, 178, 170],
            lightskyblue: [135, 206, 250],
            lightslategray: [119, 136, 153],
            lightslategrey: [119, 136, 153],
            lightsteelblue: [176, 196, 222],
            lightyellow: [255, 255, 224],
            lime: [0, 255, 0],
            limegreen: [50, 205, 50],
            linen: [250, 240, 230],
            magenta: [255, 0, 255],
            maroon: [128, 0, 0],
            mediumaquamarine: [102, 205, 170],
            mediumblue: [0, 0, 205],
            mediumorchid: [186, 85, 211],
            mediumpurple: [147, 112, 219],
            mediumseagreen: [60, 179, 113],
            mediumslateblue: [123, 104, 238],
            mediumspringgreen: [0, 250, 154],
            mediumturquoise: [72, 209, 204],
            mediumvioletred: [199, 21, 133],
            midnightblue: [25, 25, 112],
            mintcream: [245, 255, 250],
            mistyrose: [255, 228, 225],
            moccasin: [255, 228, 181],
            navajowhite: [255, 222, 173],
            navy: [0, 0, 128],
            oldlace: [253, 245, 230],
            olive: [128, 128, 0],
            olivedrab: [107, 142, 35],
            orange: [255, 165, 0],
            orangered: [255, 69, 0],
            orchid: [218, 112, 214],
            palegoldenrod: [238, 232, 170],
            palegreen: [152, 251, 152],
            paleturquoise: [175, 238, 238],
            palevioletred: [219, 112, 147],
            papayawhip: [255, 239, 213],
            peachpuff: [255, 218, 185],
            peru: [205, 133, 63],
            pink: [255, 192, 203],
            plum: [221, 160, 221],
            powderblue: [176, 224, 230],
            purple: [128, 0, 128],
            rebeccapurple: [102, 51, 153],
            red: [255, 0, 0],
            rosybrown: [188, 143, 143],
            royalblue: [65, 105, 225],
            saddlebrown: [139, 69, 19],
            salmon: [250, 128, 114],
            sandybrown: [244, 164, 96],
            seagreen: [46, 139, 87],
            seashell: [255, 245, 238],
            sienna: [160, 82, 45],
            silver: [192, 192, 192],
            skyblue: [135, 206, 235],
            slateblue: [106, 90, 205],
            slategray: [112, 128, 144],
            slategrey: [112, 128, 144],
            snow: [255, 250, 250],
            springgreen: [0, 255, 127],
            steelblue: [70, 130, 180],
            tan: [210, 180, 140],
            teal: [0, 128, 128],
            thistle: [216, 191, 216],
            tomato: [255, 99, 71],
            turquoise: [64, 224, 208],
            violet: [238, 130, 238],
            wheat: [245, 222, 179],
            white: [255, 255, 255],
            whitesmoke: [245, 245, 245],
            yellow: [255, 255, 0],
            yellowgreen: [154, 205, 50],
          },
          Td = {};
        for (const e of Object.keys(_d)) Td[_d[e]] = e;
        const Fd = {
          rgb: { channels: 3, labels: "rgb" },
          hsl: { channels: 3, labels: "hsl" },
          hsv: { channels: 3, labels: "hsv" },
          hwb: { channels: 3, labels: "hwb" },
          cmyk: { channels: 4, labels: "cmyk" },
          xyz: { channels: 3, labels: "xyz" },
          lab: { channels: 3, labels: "lab" },
          lch: { channels: 3, labels: "lch" },
          hex: { channels: 1, labels: ["hex"] },
          keyword: { channels: 1, labels: ["keyword"] },
          ansi16: { channels: 1, labels: ["ansi16"] },
          ansi256: { channels: 1, labels: ["ansi256"] },
          hcg: { channels: 3, labels: ["h", "c", "g"] },
          apple: { channels: 3, labels: ["r16", "g16", "b16"] },
          gray: { channels: 1, labels: ["gray"] },
        };
        var kd = Fd;
        for (const e of Object.keys(Fd)) {
          if (!("channels" in Fd[e]))
            throw new Error("missing channels property: " + e);
          if (!("labels" in Fd[e]))
            throw new Error("missing channel labels property: " + e);
          if (Fd[e].labels.length !== Fd[e].channels)
            throw new Error("channel and label counts mismatch: " + e);
          const { channels: t, labels: n } = Fd[e];
          delete Fd[e].channels,
            delete Fd[e].labels,
            Object.defineProperty(Fd[e], "channels", { value: t }),
            Object.defineProperty(Fd[e], "labels", { value: n });
        }
        (Fd.rgb.hsl = function (e) {
          const t = e[0] / 255,
            n = e[1] / 255,
            r = e[2] / 255,
            i = Math.min(t, n, r),
            o = Math.max(t, n, r),
            s = o - i;
          let a, u;
          o === i
            ? (a = 0)
            : t === o
            ? (a = (n - r) / s)
            : n === o
            ? (a = 2 + (r - t) / s)
            : r === o && (a = 4 + (t - n) / s),
            (a = Math.min(60 * a, 360)),
            a < 0 && (a += 360);
          const l = (i + o) / 2;
          return (
            (u = o === i ? 0 : l <= 0.5 ? s / (o + i) : s / (2 - o - i)),
            [a, 100 * u, 100 * l]
          );
        }),
          (Fd.rgb.hsv = function (e) {
            let t, n, r, i, o;
            const s = e[0] / 255,
              a = e[1] / 255,
              u = e[2] / 255,
              l = Math.max(s, a, u),
              c = l - Math.min(s, a, u),
              p = function (e) {
                return (l - e) / 6 / c + 0.5;
              };
            return (
              0 === c
                ? ((i = 0), (o = 0))
                : ((o = c / l),
                  (t = p(s)),
                  (n = p(a)),
                  (r = p(u)),
                  s === l
                    ? (i = r - n)
                    : a === l
                    ? (i = 1 / 3 + t - r)
                    : u === l && (i = 2 / 3 + n - t),
                  i < 0 ? (i += 1) : i > 1 && (i -= 1)),
              [360 * i, 100 * o, 100 * l]
            );
          }),
          (Fd.rgb.hwb = function (e) {
            const t = e[0],
              n = e[1];
            let r = e[2];
            const i = Fd.rgb.hsl(e)[0],
              o = (1 / 255) * Math.min(t, Math.min(n, r));
            return (
              (r = 1 - (1 / 255) * Math.max(t, Math.max(n, r))),
              [i, 100 * o, 100 * r]
            );
          }),
          (Fd.rgb.cmyk = function (e) {
            const t = e[0] / 255,
              n = e[1] / 255,
              r = e[2] / 255,
              i = Math.min(1 - t, 1 - n, 1 - r);
            return [
              100 * ((1 - t - i) / (1 - i) || 0),
              100 * ((1 - n - i) / (1 - i) || 0),
              100 * ((1 - r - i) / (1 - i) || 0),
              100 * i,
            ];
          }),
          (Fd.rgb.keyword = function (e) {
            const t = Td[e];
            if (t) return t;
            let n,
              r = 1 / 0;
            for (const t of Object.keys(_d)) {
              const s =
                ((o = _d[t]),
                ((i = e)[0] - o[0]) ** 2 +
                  (i[1] - o[1]) ** 2 +
                  (i[2] - o[2]) ** 2);
              s < r && ((r = s), (n = t));
            }
            var i, o;
            return n;
          }),
          (Fd.keyword.rgb = function (e) {
            return _d[e];
          }),
          (Fd.rgb.xyz = function (e) {
            let t = e[0] / 255,
              n = e[1] / 255,
              r = e[2] / 255;
            return (
              (t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92),
              (n = n > 0.04045 ? ((n + 0.055) / 1.055) ** 2.4 : n / 12.92),
              (r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92),
              [
                100 * (0.4124 * t + 0.3576 * n + 0.1805 * r),
                100 * (0.2126 * t + 0.7152 * n + 0.0722 * r),
                100 * (0.0193 * t + 0.1192 * n + 0.9505 * r),
              ]
            );
          }),
          (Fd.rgb.lab = function (e) {
            const t = Fd.rgb.xyz(e);
            let n = t[0],
              r = t[1],
              i = t[2];
            return (
              (n /= 95.047),
              (r /= 100),
              (i /= 108.883),
              (n = n > 0.008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116),
              (r = r > 0.008856 ? r ** (1 / 3) : 7.787 * r + 16 / 116),
              (i = i > 0.008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116),
              [116 * r - 16, 500 * (n - r), 200 * (r - i)]
            );
          }),
          (Fd.hsl.rgb = function (e) {
            const t = e[0] / 360,
              n = e[1] / 100,
              r = e[2] / 100;
            let i, o, s;
            if (0 === n) return (s = 255 * r), [s, s, s];
            i = r < 0.5 ? r * (1 + n) : r + n - r * n;
            const a = 2 * r - i,
              u = [0, 0, 0];
            for (let e = 0; e < 3; e++)
              (o = t + (1 / 3) * -(e - 1)),
                o < 0 && o++,
                o > 1 && o--,
                (s =
                  6 * o < 1
                    ? a + 6 * (i - a) * o
                    : 2 * o < 1
                    ? i
                    : 3 * o < 2
                    ? a + (i - a) * (2 / 3 - o) * 6
                    : a),
                (u[e] = 255 * s);
            return u;
          }),
          (Fd.hsl.hsv = function (e) {
            const t = e[0];
            let n = e[1] / 100,
              r = e[2] / 100,
              i = n;
            const o = Math.max(r, 0.01);
            return (
              (r *= 2),
              (n *= r <= 1 ? r : 2 - r),
              (i *= o <= 1 ? o : 2 - o),
              [
                t,
                100 * (0 === r ? (2 * i) / (o + i) : (2 * n) / (r + n)),
                ((r + n) / 2) * 100,
              ]
            );
          }),
          (Fd.hsv.rgb = function (e) {
            const t = e[0] / 60,
              n = e[1] / 100;
            let r = e[2] / 100;
            const i = Math.floor(t) % 6,
              o = t - Math.floor(t),
              s = 255 * r * (1 - n),
              a = 255 * r * (1 - n * o),
              u = 255 * r * (1 - n * (1 - o));
            switch (((r *= 255), i)) {
              case 0:
                return [r, u, s];
              case 1:
                return [a, r, s];
              case 2:
                return [s, r, u];
              case 3:
                return [s, a, r];
              case 4:
                return [u, s, r];
              case 5:
                return [r, s, a];
            }
          }),
          (Fd.hsv.hsl = function (e) {
            const t = e[0],
              n = e[1] / 100,
              r = e[2] / 100,
              i = Math.max(r, 0.01);
            let o, s;
            s = (2 - n) * r;
            const a = (2 - n) * i;
            return (
              (o = n * i),
              (o /= a <= 1 ? a : 2 - a),
              (o = o || 0),
              (s /= 2),
              [t, 100 * o, 100 * s]
            );
          }),
          (Fd.hwb.rgb = function (e) {
            const t = e[0] / 360;
            let n = e[1] / 100,
              r = e[2] / 100;
            const i = n + r;
            let o;
            i > 1 && ((n /= i), (r /= i));
            const s = Math.floor(6 * t),
              a = 1 - r;
            (o = 6 * t - s), 0 != (1 & s) && (o = 1 - o);
            const u = n + o * (a - n);
            let l, c, p;
            switch (s) {
              default:
              case 6:
              case 0:
                (l = a), (c = u), (p = n);
                break;
              case 1:
                (l = u), (c = a), (p = n);
                break;
              case 2:
                (l = n), (c = a), (p = u);
                break;
              case 3:
                (l = n), (c = u), (p = a);
                break;
              case 4:
                (l = u), (c = n), (p = a);
                break;
              case 5:
                (l = a), (c = n), (p = u);
            }
            return [255 * l, 255 * c, 255 * p];
          }),
          (Fd.cmyk.rgb = function (e) {
            const t = e[0] / 100,
              n = e[1] / 100,
              r = e[2] / 100,
              i = e[3] / 100;
            return [
              255 * (1 - Math.min(1, t * (1 - i) + i)),
              255 * (1 - Math.min(1, n * (1 - i) + i)),
              255 * (1 - Math.min(1, r * (1 - i) + i)),
            ];
          }),
          (Fd.xyz.rgb = function (e) {
            const t = e[0] / 100,
              n = e[1] / 100,
              r = e[2] / 100;
            let i, o, s;
            return (
              (i = 3.2406 * t + -1.5372 * n + -0.4986 * r),
              (o = -0.9689 * t + 1.8758 * n + 0.0415 * r),
              (s = 0.0557 * t + -0.204 * n + 1.057 * r),
              (i = i > 0.0031308 ? 1.055 * i ** (1 / 2.4) - 0.055 : 12.92 * i),
              (o = o > 0.0031308 ? 1.055 * o ** (1 / 2.4) - 0.055 : 12.92 * o),
              (s = s > 0.0031308 ? 1.055 * s ** (1 / 2.4) - 0.055 : 12.92 * s),
              (i = Math.min(Math.max(0, i), 1)),
              (o = Math.min(Math.max(0, o), 1)),
              (s = Math.min(Math.max(0, s), 1)),
              [255 * i, 255 * o, 255 * s]
            );
          }),
          (Fd.xyz.lab = function (e) {
            let t = e[0],
              n = e[1],
              r = e[2];
            return (
              (t /= 95.047),
              (n /= 100),
              (r /= 108.883),
              (t = t > 0.008856 ? t ** (1 / 3) : 7.787 * t + 16 / 116),
              (n = n > 0.008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116),
              (r = r > 0.008856 ? r ** (1 / 3) : 7.787 * r + 16 / 116),
              [116 * n - 16, 500 * (t - n), 200 * (n - r)]
            );
          }),
          (Fd.lab.xyz = function (e) {
            let t, n, r;
            (n = (e[0] + 16) / 116), (t = e[1] / 500 + n), (r = n - e[2] / 200);
            const i = n ** 3,
              o = t ** 3,
              s = r ** 3;
            return (
              (n = i > 0.008856 ? i : (n - 16 / 116) / 7.787),
              (t = o > 0.008856 ? o : (t - 16 / 116) / 7.787),
              (r = s > 0.008856 ? s : (r - 16 / 116) / 7.787),
              (t *= 95.047),
              (n *= 100),
              (r *= 108.883),
              [t, n, r]
            );
          }),
          (Fd.lab.lch = function (e) {
            const t = e[0],
              n = e[1],
              r = e[2];
            let i;
            return (
              (i = (360 * Math.atan2(r, n)) / 2 / Math.PI),
              i < 0 && (i += 360),
              [t, Math.sqrt(n * n + r * r), i]
            );
          }),
          (Fd.lch.lab = function (e) {
            const t = e[0],
              n = e[1],
              r = (e[2] / 360) * 2 * Math.PI;
            return [t, n * Math.cos(r), n * Math.sin(r)];
          }),
          (Fd.rgb.ansi16 = function (e) {
            let t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : null;
            const [n, r, i] = e;
            let o = null === t ? Fd.rgb.hsv(e)[2] : t;
            if (((o = Math.round(o / 50)), 0 === o)) return 30;
            let s =
              30 +
              ((Math.round(i / 255) << 2) |
                (Math.round(r / 255) << 1) |
                Math.round(n / 255));
            return 2 === o && (s += 60), s;
          }),
          (Fd.hsv.ansi16 = function (e) {
            return Fd.rgb.ansi16(Fd.hsv.rgb(e), e[2]);
          }),
          (Fd.rgb.ansi256 = function (e) {
            const t = e[0],
              n = e[1],
              r = e[2];
            return t === n && n === r
              ? t < 8
                ? 16
                : t > 248
                ? 231
                : Math.round(((t - 8) / 247) * 24) + 232
              : 16 +
                  36 * Math.round((t / 255) * 5) +
                  6 * Math.round((n / 255) * 5) +
                  Math.round((r / 255) * 5);
          }),
          (Fd.ansi16.rgb = function (e) {
            let t = e % 10;
            if (0 === t || 7 === t)
              return e > 50 && (t += 3.5), (t = (t / 10.5) * 255), [t, t, t];
            const n = 0.5 * (1 + ~~(e > 50));
            return [
              (1 & t) * n * 255,
              ((t >> 1) & 1) * n * 255,
              ((t >> 2) & 1) * n * 255,
            ];
          }),
          (Fd.ansi256.rgb = function (e) {
            if (e >= 232) {
              const t = 10 * (e - 232) + 8;
              return [t, t, t];
            }
            let t;
            return (
              (e -= 16),
              [
                (Math.floor(e / 36) / 5) * 255,
                (Math.floor((t = e % 36) / 6) / 5) * 255,
                ((t % 6) / 5) * 255,
              ]
            );
          }),
          (Fd.rgb.hex = function (e) {
            const t = (
              ((255 & Math.round(e[0])) << 16) +
              ((255 & Math.round(e[1])) << 8) +
              (255 & Math.round(e[2]))
            )
              .toString(16)
              .toUpperCase();
            return "000000".substring(t.length) + t;
          }),
          (Fd.hex.rgb = function (e) {
            const t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!t) return [0, 0, 0];
            let n = t[0];
            3 === t[0].length &&
              (n = n
                .split("")
                .map((e) => e + e)
                .join(""));
            const r = parseInt(n, 16);
            return [(r >> 16) & 255, (r >> 8) & 255, 255 & r];
          }),
          (Fd.rgb.hcg = function (e) {
            const t = e[0] / 255,
              n = e[1] / 255,
              r = e[2] / 255,
              i = Math.max(Math.max(t, n), r),
              o = Math.min(Math.min(t, n), r),
              s = i - o;
            let a, u;
            return (
              (a = s < 1 ? o / (1 - s) : 0),
              (u =
                s <= 0
                  ? 0
                  : i === t
                  ? ((n - r) / s) % 6
                  : i === n
                  ? 2 + (r - t) / s
                  : 4 + (t - n) / s),
              (u /= 6),
              (u %= 1),
              [360 * u, 100 * s, 100 * a]
            );
          }),
          (Fd.hsl.hcg = function (e) {
            const t = e[1] / 100,
              n = e[2] / 100,
              r = n < 0.5 ? 2 * t * n : 2 * t * (1 - n);
            let i = 0;
            return (
              r < 1 && (i = (n - 0.5 * r) / (1 - r)), [e[0], 100 * r, 100 * i]
            );
          }),
          (Fd.hsv.hcg = function (e) {
            const t = e[1] / 100,
              n = e[2] / 100,
              r = t * n;
            let i = 0;
            return r < 1 && (i = (n - r) / (1 - r)), [e[0], 100 * r, 100 * i];
          }),
          (Fd.hcg.rgb = function (e) {
            const t = e[0] / 360,
              n = e[1] / 100,
              r = e[2] / 100;
            if (0 === n) return [255 * r, 255 * r, 255 * r];
            const i = [0, 0, 0],
              o = (t % 1) * 6,
              s = o % 1,
              a = 1 - s;
            let u = 0;
            switch (Math.floor(o)) {
              case 0:
                (i[0] = 1), (i[1] = s), (i[2] = 0);
                break;
              case 1:
                (i[0] = a), (i[1] = 1), (i[2] = 0);
                break;
              case 2:
                (i[0] = 0), (i[1] = 1), (i[2] = s);
                break;
              case 3:
                (i[0] = 0), (i[1] = a), (i[2] = 1);
                break;
              case 4:
                (i[0] = s), (i[1] = 0), (i[2] = 1);
                break;
              default:
                (i[0] = 1), (i[1] = 0), (i[2] = a);
            }
            return (
              (u = (1 - n) * r),
              [255 * (n * i[0] + u), 255 * (n * i[1] + u), 255 * (n * i[2] + u)]
            );
          }),
          (Fd.hcg.hsv = function (e) {
            const t = e[1] / 100,
              n = t + (e[2] / 100) * (1 - t);
            let r = 0;
            return n > 0 && (r = t / n), [e[0], 100 * r, 100 * n];
          }),
          (Fd.hcg.hsl = function (e) {
            const t = e[1] / 100,
              n = (e[2] / 100) * (1 - t) + 0.5 * t;
            let r = 0;
            return (
              n > 0 && n < 0.5
                ? (r = t / (2 * n))
                : n >= 0.5 && n < 1 && (r = t / (2 * (1 - n))),
              [e[0], 100 * r, 100 * n]
            );
          }),
          (Fd.hcg.hwb = function (e) {
            const t = e[1] / 100,
              n = t + (e[2] / 100) * (1 - t);
            return [e[0], 100 * (n - t), 100 * (1 - n)];
          }),
          (Fd.hwb.hcg = function (e) {
            const t = e[1] / 100,
              n = 1 - e[2] / 100,
              r = n - t;
            let i = 0;
            return r < 1 && (i = (n - r) / (1 - r)), [e[0], 100 * r, 100 * i];
          }),
          (Fd.apple.rgb = function (e) {
            return [
              (e[0] / 65535) * 255,
              (e[1] / 65535) * 255,
              (e[2] / 65535) * 255,
            ];
          }),
          (Fd.rgb.apple = function (e) {
            return [
              (e[0] / 255) * 65535,
              (e[1] / 255) * 65535,
              (e[2] / 255) * 65535,
            ];
          }),
          (Fd.gray.rgb = function (e) {
            return [(e[0] / 100) * 255, (e[0] / 100) * 255, (e[0] / 100) * 255];
          }),
          (Fd.gray.hsl = function (e) {
            return [0, 0, e[0]];
          }),
          (Fd.gray.hsv = Fd.gray.hsl),
          (Fd.gray.hwb = function (e) {
            return [0, 100, e[0]];
          }),
          (Fd.gray.cmyk = function (e) {
            return [0, 0, 0, e[0]];
          }),
          (Fd.gray.lab = function (e) {
            return [e[0], 0, 0];
          }),
          (Fd.gray.hex = function (e) {
            const t = 255 & Math.round((e[0] / 100) * 255),
              n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
            return "000000".substring(n.length) + n;
          }),
          (Fd.rgb.gray = function (e) {
            return [((e[0] + e[1] + e[2]) / 3 / 255) * 100];
          });
        const Od = kd;
        function Bd(e, t) {
          return function (n) {
            return t(e(n));
          };
        }
        function Pd(e, t) {
          const n = [t[e].parent, e];
          let r = Od[t[e].parent][e],
            i = t[e].parent;
          for (; t[i].parent; )
            n.unshift(t[i].parent),
              (r = Bd(Od[t[i].parent][i], r)),
              (i = t[i].parent);
          return (r.conversion = n), r;
        }
        const Nd = kd,
          Md = function (e) {
            const t = (function (e) {
                const t = (function () {
                    const e = {},
                      t = Object.keys(Od);
                    for (let n = t.length, r = 0; r < n; r++)
                      e[t[r]] = { distance: -1, parent: null };
                    return e;
                  })(),
                  n = [e];
                for (t[e].distance = 0; n.length; ) {
                  const e = n.pop(),
                    r = Object.keys(Od[e]);
                  for (let i = r.length, o = 0; o < i; o++) {
                    const i = r[o],
                      s = t[i];
                    -1 === s.distance &&
                      ((s.distance = t[e].distance + 1),
                      (s.parent = e),
                      n.unshift(i));
                  }
                }
                return t;
              })(e),
              n = {},
              r = Object.keys(t);
            for (let e = r.length, i = 0; i < e; i++) {
              const e = r[i];
              null !== t[e].parent && (n[e] = Pd(e, t));
            }
            return n;
          },
          Id = {};
        Object.keys(Nd).forEach((e) => {
          (Id[e] = {}),
            Object.defineProperty(Id[e], "channels", { value: Nd[e].channels }),
            Object.defineProperty(Id[e], "labels", { value: Nd[e].labels });
          const t = Md(e);
          Object.keys(t).forEach((n) => {
            const r = t[n];
            (Id[e][n] = (function (e) {
              const t = function () {
                for (
                  var t = arguments.length, n = new Array(t), r = 0;
                  r < t;
                  r++
                )
                  n[r] = arguments[r];
                const i = n[0];
                if (null == i) return i;
                i.length > 1 && (n = i);
                const o = e(n);
                if ("object" == typeof o)
                  for (let e = o.length, t = 0; t < e; t++)
                    o[t] = Math.round(o[t]);
                return o;
              };
              return "conversion" in e && (t.conversion = e.conversion), t;
            })(r)),
              (Id[e][n].raw = (function (e) {
                const t = function () {
                  for (
                    var t = arguments.length, n = new Array(t), r = 0;
                    r < t;
                    r++
                  )
                    n[r] = arguments[r];
                  const i = n[0];
                  return null == i ? i : (i.length > 1 && (n = i), e(n));
                };
                return "conversion" in e && (t.conversion = e.conversion), t;
              })(r));
          });
        });
        var jd = Id;
        function Ld() {
          return !1;
        }
        function $d() {
          throw new Error("tty.ReadStream is not implemented");
        }
        function Rd() {
          throw new Error("tty.ReadStream is not implemented");
        }
        !(function (e) {
          const t = (e, t) =>
              function () {
                const n = e(...arguments);
                return "[".concat(n + t, "m");
              },
            n = (e, t) =>
              function () {
                const n = e(...arguments);
                return "[".concat(38 + t, ";5;").concat(n, "m");
              },
            r = (e, t) =>
              function () {
                const n = e(...arguments);
                return "["
                  .concat(38 + t, ";2;")
                  .concat(n[0], ";")
                  .concat(n[1], ";")
                  .concat(n[2], "m");
              },
            i = (e) => e,
            o = (e, t, n) => [e, t, n],
            s = (e, t, n) => {
              Object.defineProperty(e, t, {
                get: () => {
                  const r = n();
                  return (
                    Object.defineProperty(e, t, {
                      value: r,
                      enumerable: !0,
                      configurable: !0,
                    }),
                    r
                  );
                },
                enumerable: !0,
                configurable: !0,
              });
            };
          let a;
          const u = (e, t, n, r) => {
            void 0 === a && (a = jd);
            const i = r ? 10 : 0,
              o = {};
            for (const [r, s] of Object.entries(a)) {
              const a = "ansi16" === r ? "ansi" : r;
              r === t
                ? (o[a] = e(n, i))
                : "object" == typeof s && (o[a] = e(s[t], i));
            }
            return o;
          };
          Object.defineProperty(e, "exports", {
            enumerable: !0,
            get: function () {
              const e = new Map(),
                a = {
                  modifier: {
                    reset: [0, 0],
                    bold: [1, 22],
                    dim: [2, 22],
                    italic: [3, 23],
                    underline: [4, 24],
                    inverse: [7, 27],
                    hidden: [8, 28],
                    strikethrough: [9, 29],
                  },
                  color: {
                    black: [30, 39],
                    red: [31, 39],
                    green: [32, 39],
                    yellow: [33, 39],
                    blue: [34, 39],
                    magenta: [35, 39],
                    cyan: [36, 39],
                    white: [37, 39],
                    blackBright: [90, 39],
                    redBright: [91, 39],
                    greenBright: [92, 39],
                    yellowBright: [93, 39],
                    blueBright: [94, 39],
                    magentaBright: [95, 39],
                    cyanBright: [96, 39],
                    whiteBright: [97, 39],
                  },
                  bgColor: {
                    bgBlack: [40, 49],
                    bgRed: [41, 49],
                    bgGreen: [42, 49],
                    bgYellow: [43, 49],
                    bgBlue: [44, 49],
                    bgMagenta: [45, 49],
                    bgCyan: [46, 49],
                    bgWhite: [47, 49],
                    bgBlackBright: [100, 49],
                    bgRedBright: [101, 49],
                    bgGreenBright: [102, 49],
                    bgYellowBright: [103, 49],
                    bgBlueBright: [104, 49],
                    bgMagentaBright: [105, 49],
                    bgCyanBright: [106, 49],
                    bgWhiteBright: [107, 49],
                  },
                };
              (a.color.gray = a.color.blackBright),
                (a.bgColor.bgGray = a.bgColor.bgBlackBright),
                (a.color.grey = a.color.blackBright),
                (a.bgColor.bgGrey = a.bgColor.bgBlackBright);
              for (const [t, n] of Object.entries(a)) {
                for (const [t, r] of Object.entries(n))
                  (a[t] = {
                    open: "[".concat(r[0], "m"),
                    close: "[".concat(r[1], "m"),
                  }),
                    (n[t] = a[t]),
                    e.set(r[0], r[1]);
                Object.defineProperty(a, t, { value: n, enumerable: !1 });
              }
              return (
                Object.defineProperty(a, "codes", { value: e, enumerable: !1 }),
                (a.color.close = "[39m"),
                (a.bgColor.close = "[49m"),
                s(a.color, "ansi", () => u(t, "ansi16", i, !1)),
                s(a.color, "ansi256", () => u(n, "ansi256", i, !1)),
                s(a.color, "ansi16m", () => u(r, "rgb", o, !1)),
                s(a.bgColor, "ansi", () => u(t, "ansi16", i, !0)),
                s(a.bgColor, "ansi256", () => u(n, "ansi256", i, !0)),
                s(a.bgColor, "ansi16m", () => u(r, "rgb", o, !0)),
                a
              );
            },
          });
        })(Sd);
        var zd = { isatty: Ld, ReadStream: $d, WriteStream: Rd };
        const Vd = rf,
          qd = t(
            Object.freeze({
              __proto__: null,
              isatty: Ld,
              ReadStream: $d,
              WriteStream: Rd,
              default: zd,
            })
          ),
          Wd = function (e) {
            let t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : Ua.argv;
            const n = e.startsWith("-") ? "" : 1 === e.length ? "-" : "--",
              r = t.indexOf(n + e),
              i = t.indexOf("--");
            return -1 !== r && (-1 === i || r < i);
          },
          { env: Ud } = Ua;
        let Hd;
        function Gd(e) {
          return (
            0 !== e && {
              level: e,
              hasBasic: !0,
              has256: e >= 2,
              has16m: e >= 3,
            }
          );
        }
        function Yd(e, t) {
          if (0 === Hd) return 0;
          if (Wd("color=16m") || Wd("color=full") || Wd("color=truecolor"))
            return 3;
          if (Wd("color=256")) return 2;
          if (e && !t && void 0 === Hd) return 0;
          const n = Hd || 0;
          if ("dumb" === Ud.TERM) return n;
          if ("win32" === Ua.platform) {
            const e = Vd.release().split(".");
            return Number(e[0]) >= 10 && Number(e[2]) >= 10586
              ? Number(e[2]) >= 14931
                ? 3
                : 2
              : 1;
          }
          if ("CI" in Ud)
            return [
              "TRAVIS",
              "CIRCLECI",
              "APPVEYOR",
              "GITLAB_CI",
              "GITHUB_ACTIONS",
              "BUILDKITE",
            ].some((e) => e in Ud) || "codeship" === Ud.CI_NAME
              ? 1
              : n;
          if ("TEAMCITY_VERSION" in Ud)
            return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(Ud.TEAMCITY_VERSION)
              ? 1
              : 0;
          if ("truecolor" === Ud.COLORTERM) return 3;
          if ("TERM_PROGRAM" in Ud) {
            const e = parseInt(
              (Ud.TERM_PROGRAM_VERSION || "").split(".")[0],
              10
            );
            switch (Ud.TERM_PROGRAM) {
              case "iTerm.app":
                return e >= 3 ? 3 : 2;
              case "Apple_Terminal":
                return 2;
            }
          }
          return /-256(color)?$/i.test(Ud.TERM)
            ? 2
            : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(
                Ud.TERM
              ) || "COLORTERM" in Ud
            ? 1
            : n;
        }
        Wd("no-color") ||
        Wd("no-colors") ||
        Wd("color=false") ||
        Wd("color=never")
          ? (Hd = 0)
          : (Wd("color") ||
              Wd("colors") ||
              Wd("color=true") ||
              Wd("color=always")) &&
            (Hd = 1),
          "FORCE_COLOR" in Ud &&
            (Hd =
              "true" === Ud.FORCE_COLOR
                ? 1
                : "false" === Ud.FORCE_COLOR
                ? 0
                : 0 === Ud.FORCE_COLOR.length
                ? 1
                : Math.min(parseInt(Ud.FORCE_COLOR, 10), 3));
        var Xd = {
          supportsColor: function (e) {
            return Gd(Yd(e, e && e.isTTY));
          },
          stdout: Gd(Yd(!0, qd.isatty(1))),
          stderr: Gd(Yd(!0, qd.isatty(2))),
        };
        const Jd =
            /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
          Zd = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g,
          Kd = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/,
          Qd = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi,
          eh = new Map([
            ["n", "\n"],
            ["r", "\r"],
            ["t", "\t"],
            ["b", "\b"],
            ["f", "\f"],
            ["v", "\v"],
            ["0", "\0"],
            ["\\", "\\"],
            ["e", ""],
            ["a", ""],
          ]);
        function th(e) {
          const t = "u" === e[0],
            n = "{" === e[1];
          return (t && !n && 5 === e.length) || ("x" === e[0] && 3 === e.length)
            ? String.fromCharCode(parseInt(e.slice(1), 16))
            : t && n
            ? String.fromCodePoint(parseInt(e.slice(2, -1), 16))
            : eh.get(e) || e;
        }
        function nh(e, t) {
          const n = [],
            r = t.trim().split(/\s*,\s*/g);
          let i;
          for (const t of r) {
            const r = Number(t);
            if (Number.isNaN(r)) {
              if (!(i = t.match(Kd)))
                throw new Error(
                  "Invalid Chalk template style argument: "
                    .concat(t, " (in style '")
                    .concat(e, "')")
                );
              n.push(i[2].replace(Qd, (e, t, n) => (t ? th(t) : n)));
            } else n.push(r);
          }
          return n;
        }
        function rh(e) {
          Zd.lastIndex = 0;
          const t = [];
          let n;
          for (; null !== (n = Zd.exec(e)); ) {
            const e = n[1];
            if (n[2]) {
              const r = nh(e, n[2]);
              t.push([e].concat(r));
            } else t.push([e]);
          }
          return t;
        }
        function ih(e, t) {
          const n = {};
          for (const e of t)
            for (const t of e.styles) n[t[0]] = e.inverse ? null : t.slice(1);
          let r = e;
          for (const [e, t] of Object.entries(n))
            if (Array.isArray(t)) {
              if (!(e in r)) throw new Error("Unknown Chalk style: ".concat(e));
              r = t.length > 0 ? r[e](...t) : r[e];
            }
          return r;
        }
        var oh = (e, t) => {
          const n = [],
            r = [];
          let i = [];
          if (
            (t.replace(Jd, (t, o, s, a, u, l) => {
              if (o) i.push(th(o));
              else if (a) {
                const t = i.join("");
                (i = []),
                  r.push(0 === n.length ? t : ih(e, n)(t)),
                  n.push({ inverse: s, styles: rh(a) });
              } else if (u) {
                if (0 === n.length)
                  throw new Error(
                    "Found extraneous } in Chalk template literal"
                  );
                r.push(ih(e, n)(i.join(""))), (i = []), n.pop();
              } else i.push(l);
            }),
            r.push(i.join("")),
            n.length > 0)
          ) {
            const e = "Chalk template literal is missing "
              .concat(n.length, " closing bracket")
              .concat(1 === n.length ? "" : "s", " (`}`)");
            throw new Error(e);
          }
          return r.join("");
        };
        const sh = Sd.exports,
          { stdout: ah, stderr: uh } = Xd,
          { stringReplaceAll: lh, stringEncaseCRLFWithFirstIndex: ch } = {
            stringReplaceAll: (e, t, n) => {
              let r = e.indexOf(t);
              if (-1 === r) return e;
              const i = t.length;
              let o = 0,
                s = "";
              do {
                (s += e.substr(o, r - o) + t + n),
                  (o = r + i),
                  (r = e.indexOf(t, o));
              } while (-1 !== r);
              return (s += e.substr(o)), s;
            },
            stringEncaseCRLFWithFirstIndex: (e, t, n, r) => {
              let i = 0,
                o = "";
              do {
                const s = "\r" === e[r - 1];
                (o +=
                  e.substr(i, (s ? r - 1 : r) - i) +
                  t +
                  (s ? "\r\n" : "\n") +
                  n),
                  (i = r + 1),
                  (r = e.indexOf("\n", i));
              } while (-1 !== r);
              return (o += e.substr(i)), o;
            },
          },
          { isArray: ph } = Array,
          fh = ["ansi", "ansi", "ansi256", "ansi16m"],
          dh = Object.create(null);
        class hh {
          constructor(e) {
            return mh(e);
          }
        }
        const mh = (e) => {
          const t = {};
          return (
            (function (e) {
              let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              if (
                t.level &&
                !(Number.isInteger(t.level) && t.level >= 0 && t.level <= 3)
              )
                throw new Error(
                  "The `level` option should be an integer from 0 to 3"
                );
              const n = ah ? ah.level : 0;
              e.level = void 0 === t.level ? n : t.level;
            })(t, e),
            (t.template = function () {
              for (
                var e = arguments.length, n = new Array(e), r = 0;
                r < e;
                r++
              )
                n[r] = arguments[r];
              return xh(t.template, ...n);
            }),
            Object.setPrototypeOf(t, gh.prototype),
            Object.setPrototypeOf(t.template, t),
            (t.template.constructor = () => {
              throw new Error(
                "`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead."
              );
            }),
            (t.template.Instance = hh),
            t.template
          );
        };
        function gh(e) {
          return mh(e);
        }
        for (const [e, t] of Object.entries(sh))
          dh[e] = {
            get() {
              const n = bh(
                this,
                Dh(t.open, t.close, this._styler),
                this._isEmpty
              );
              return Object.defineProperty(this, e, { value: n }), n;
            },
          };
        dh.visible = {
          get() {
            const e = bh(this, this._styler, !0);
            return Object.defineProperty(this, "visible", { value: e }), e;
          },
        };
        const yh = [
          "rgb",
          "hex",
          "keyword",
          "hsl",
          "hsv",
          "hwb",
          "ansi",
          "ansi256",
        ];
        for (const e of yh)
          dh[e] = {
            get() {
              const { level: t } = this;
              return function () {
                const n = Dh(
                  sh.color[fh[t]][e](...arguments),
                  sh.color.close,
                  this._styler
                );
                return bh(this, n, this._isEmpty);
              };
            },
          };
        for (const e of yh)
          dh["bg" + e[0].toUpperCase() + e.slice(1)] = {
            get() {
              const { level: t } = this;
              return function () {
                const n = Dh(
                  sh.bgColor[fh[t]][e](...arguments),
                  sh.bgColor.close,
                  this._styler
                );
                return bh(this, n, this._isEmpty);
              };
            },
          };
        const vh = Object.defineProperties(
            () => {},
            Object.assign(
              Object.assign({}, dh),
              {},
              {
                level: {
                  enumerable: !0,
                  get() {
                    return this._generator.level;
                  },
                  set(e) {
                    this._generator.level = e;
                  },
                },
              }
            )
          ),
          Dh = (e, t, n) => {
            let r, i;
            return (
              void 0 === n
                ? ((r = e), (i = t))
                : ((r = n.openAll + e), (i = t + n.closeAll)),
              { open: e, close: t, openAll: r, closeAll: i, parent: n }
            );
          },
          bh = (e, t, n) => {
            const r = function () {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              return ph(t[0]) && ph(t[0].raw)
                ? Eh(r, xh(r, ...t))
                : Eh(r, 1 === t.length ? "" + t[0] : t.join(" "));
            };
            return (
              Object.setPrototypeOf(r, vh),
              (r._generator = e),
              (r._styler = t),
              (r._isEmpty = n),
              r
            );
          },
          Eh = (e, t) => {
            if (e.level <= 0 || !t) return e._isEmpty ? "" : t;
            let n = e._styler;
            if (void 0 === n) return t;
            const { openAll: r, closeAll: i } = n;
            if (-1 !== t.indexOf(""))
              for (; void 0 !== n; )
                (t = lh(t, n.close, n.open)), (n = n.parent);
            const o = t.indexOf("\n");
            return -1 !== o && (t = ch(t, i, r, o)), r + t + i;
          };
        let Ch;
        const xh = function (e) {
          for (
            var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1;
            r < t;
            r++
          )
            n[r - 1] = arguments[r];
          const [i] = n;
          if (!ph(i) || !ph(i.raw)) return n.join(" ");
          const o = n.slice(1),
            s = [i.raw[0]];
          for (let e = 1; e < i.length; e++)
            s.push(
              String(o[e - 1]).replace(/[{}\\]/g, "\\$&"),
              String(i.raw[e])
            );
          return void 0 === Ch && (Ch = oh), Ch(e, s.join(""));
        };
        Object.defineProperties(gh.prototype, dh);
        const wh = gh();
        (wh.supportsColor = ah),
          (wh.stderr = gh({ level: uh ? uh.level : 0 })),
          (wh.stderr.supportsColor = uh);
        var Ah = wh;
        const Sh = ["_"],
          _h = lp,
          Th = Cd.exports,
          Fh = Ah,
          kh = ns,
          Oh = {
            key: (e) => (1 === e.length ? "-".concat(e) : "--".concat(e)),
            value: (e) => _h.apiDescriptor.value(e),
            pair: (e) => {
              let { key: t, value: n } = e;
              return !1 === n
                ? "--no-".concat(t)
                : !0 === n
                ? Oh.key(t)
                : "" === n
                ? "".concat(Oh.key(t), " without an argument")
                : "".concat(Oh.key(t), "=").concat(n);
            },
          };
        class Bh extends _h.ChoiceSchema {
          constructor(e) {
            let { name: t, flags: n } = e;
            super({ name: t, choices: n }), (this._flags = [...n].sort());
          }
          preprocess(e, t) {
            if (
              "string" == typeof e &&
              e.length > 0 &&
              !this._flags.includes(e)
            ) {
              const n = this._flags.find((t) => Th(t, e) < 3);
              if (n)
                return (
                  t.logger.warn(
                    [
                      "Unknown flag ".concat(
                        Fh.yellow(t.descriptor.value(e)),
                        ","
                      ),
                      "did you mean ".concat(
                        Fh.blue(t.descriptor.value(n)),
                        "?"
                      ),
                    ].join(" ")
                  ),
                  n
                );
            }
            return e;
          }
          expected() {
            return "a flag";
          }
        }
        let Ph;
        function Nh(e, t) {
          let {
            logger: n,
            isCLI: r = !1,
            passThrough: i = !1,
          } = arguments.length > 2 && void 0 !== arguments[2]
            ? arguments[2]
            : {};
          const o = i
              ? Array.isArray(i)
                ? (e, t) => (i.includes(e) ? { [e]: t } : void 0)
                : (e, t) => ({ [e]: t })
              : (e, t, n) => {
                  const r = rs(n.schemas, Sh);
                  return _h.levenUnknownHandler(
                    e,
                    t,
                    Object.assign(Object.assign({}, n), {}, { schemas: r })
                  );
                },
            s = r ? Oh : _h.apiDescriptor,
            a = Mh(t, { isCLI: r }),
            u = new _h.Normalizer(a, { logger: n, unknown: o, descriptor: s }),
            l = !1 !== n;
          l && Ph && (u._hasDeprecationWarned = Ph);
          const c = u.normalize(e);
          return l && (Ph = u._hasDeprecationWarned), c;
        }
        function Mh(e, t) {
          let { isCLI: n } = t;
          const r = [];
          n && r.push(_h.AnySchema.create({ name: "_" }));
          for (const t of e)
            r.push(Ih(t, { isCLI: n, optionInfos: e })),
              t.alias &&
                n &&
                r.push(
                  _h.AliasSchema.create({ name: t.alias, sourceName: t.name })
                );
          return r;
        }
        function Ih(e, t) {
          let n,
            { isCLI: r, optionInfos: i } = t;
          const o = { name: e.name },
            s = {};
          switch (e.type) {
            case "int":
              (n = _h.IntegerSchema), r && (o.preprocess = (e) => Number(e));
              break;
            case "string":
            case "path":
              n = _h.StringSchema;
              break;
            case "choice":
              (n = _h.ChoiceSchema),
                (o.choices = e.choices.map((t) =>
                  "object" == typeof t && t.redirect
                    ? Object.assign(
                        Object.assign({}, t),
                        {},
                        { redirect: { to: { key: e.name, value: t.redirect } } }
                      )
                    : t
                ));
              break;
            case "boolean":
              n = _h.BooleanSchema;
              break;
            case "flag":
              (n = Bh),
                (o.flags = i.flatMap((e) =>
                  [
                    e.alias,
                    e.description && e.name,
                    e.oppositeDescription && "no-".concat(e.name),
                  ].filter(Boolean)
                ));
              break;
            default:
              throw new Error("Unexpected type ".concat(e.type));
          }
          if (
            (e.exception
              ? (o.validate = (t, n, r) => e.exception(t) || n.validate(t, r))
              : (o.validate = (e, t, n) => void 0 === e || t.validate(e, n)),
            e.redirect &&
              (s.redirect = (t) =>
                t
                  ? { to: { key: e.redirect.option, value: e.redirect.value } }
                  : void 0),
            e.deprecated && (s.deprecated = !0),
            r && !e.array)
          ) {
            const e = o.preprocess || ((e) => e);
            o.preprocess = (t, n, r) =>
              n.preprocess(e(Array.isArray(t) ? kh(t) : t), r);
          }
          return e.array
            ? _h.ArraySchema.create(
                Object.assign(
                  Object.assign(
                    Object.assign(
                      {},
                      r
                        ? { preprocess: (e) => (Array.isArray(e) ? e : [e]) }
                        : {}
                    ),
                    s
                  ),
                  {},
                  { valueSchema: n.create(o) }
                )
              )
            : n.create(Object.assign(Object.assign({}, o), s));
        }
        var jh = {
          normalizeApiOptions: function (e, t, n) {
            return Nh(e, t, n);
          },
          normalizeCliOptions: function (e, t, n) {
            return Nh(e, t, Object.assign({ isCLI: !0 }, n));
          },
        };
        const { isNonEmptyArray: Lh } = nl;
        function $h(e, t) {
          const { ignoreDecorators: n } = t || {};
          if (!n) {
            const t =
              (e.declaration && e.declaration.decorators) || e.decorators;
            if (Lh(t)) return $h(t[0]);
          }
          return e.range ? e.range[0] : e.start;
        }
        function Rh(e) {
          return e.range ? e.range[1] : e.end;
        }
        function zh(e, t) {
          return $h(e) === $h(t);
        }
        var Vh = {
            locStart: $h,
            locEnd: Rh,
            hasSameLocStart: zh,
            hasSameLoc: function (e, t) {
              return (
                zh(e, t) &&
                (function (e, t) {
                  return Rh(e) === Rh(t);
                })(e, t)
              );
            },
          },
          qh = {},
          Wh = {},
          Uh = {};
        Object.defineProperty(Uh, "__esModule", { value: !0 }),
          (Uh.default =
            /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyus]{1,6}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g),
          (Uh.matchToToken = function (e) {
            var t = { type: "invalid", value: e[0], closed: void 0 };
            return (
              e[1]
                ? ((t.type = "string"), (t.closed = !(!e[3] && !e[4])))
                : e[5]
                ? (t.type = "comment")
                : e[6]
                ? ((t.type = "comment"), (t.closed = !!e[7]))
                : e[8]
                ? (t.type = "regex")
                : e[9]
                ? (t.type = "number")
                : e[10]
                ? (t.type = "name")
                : e[11]
                ? (t.type = "punctuator")
                : e[12] && (t.type = "whitespace"),
              t
            );
          });
        var Hh = {},
          Gh = {};
        Object.defineProperty(Gh, "__esModule", { value: !0 }),
          (Gh.isIdentifierStart = tm),
          (Gh.isIdentifierChar = nm),
          (Gh.isIdentifierName = function (e) {
            let t = !0;
            for (let n = 0; n < e.length; n++) {
              let r = e.charCodeAt(n);
              if (55296 == (64512 & r) && n + 1 < e.length) {
                const t = e.charCodeAt(++n);
                56320 == (64512 & t) &&
                  (r = 65536 + ((1023 & r) << 10) + (1023 & t));
              }
              if (t) {
                if (((t = !1), !tm(r))) return !1;
              } else if (!nm(r)) return !1;
            }
            return !t;
          });
        let Yh =
            "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
          Xh =
            "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-ໍ໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿";
        const Jh = new RegExp("[" + Yh + "]"),
          Zh = new RegExp("[" + Yh + Xh + "]");
        Yh = Xh = null;
        const Kh = [
            0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28,
            4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157,
            19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2,
            14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5,
            3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11,
            21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28,
            36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14,
            50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28,
            22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34,
            4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3,
            2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19,
            0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42,
            3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63,
            32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2,
            0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36,
            18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15,
            0, 328, 18, 190, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1070,
            4050, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20,
            6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9,
            1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 46, 2, 18, 3, 9, 395,
            2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3,
            3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2,
            0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2,
            24, 2, 30, 2, 24, 2, 7, 1845, 30, 482, 44, 11, 6, 17, 0, 322, 29,
            19, 43, 1269, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3,
            2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0,
            2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3,
            3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421,
            42719, 33, 4152, 8, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938,
          ],
          Qh = [
            509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0,
            166, 1, 574, 3, 9, 9, 370, 1, 154, 10, 50, 3, 123, 2, 54, 14, 32,
            10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45,
            0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3,
            56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9,
            5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9,
            9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13,
            9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15,
            406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0,
            9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 87, 9, 39, 4, 60,
            6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3,
            22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5,
            49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4,
            262, 6, 10, 9, 357, 0, 62, 13, 1495, 6, 110, 6, 6, 9, 4759, 9,
            787719, 239,
          ];
        function em(e, t) {
          let n = 65536;
          for (let r = 0, i = t.length; r < i; r += 2) {
            if (((n += t[r]), n > e)) return !1;
            if (((n += t[r + 1]), n >= e)) return !0;
          }
          return !1;
        }
        function tm(e) {
          return e < 65
            ? 36 === e
            : e <= 90 ||
                (e < 97
                  ? 95 === e
                  : e <= 122 ||
                    (e <= 65535
                      ? e >= 170 && Jh.test(String.fromCharCode(e))
                      : em(e, Kh)));
        }
        function nm(e) {
          return e < 48
            ? 36 === e
            : e < 58 ||
                (!(e < 65) &&
                  (e <= 90 ||
                    (e < 97
                      ? 95 === e
                      : e <= 122 ||
                        (e <= 65535
                          ? e >= 170 && Zh.test(String.fromCharCode(e))
                          : em(e, Kh) || em(e, Qh)))));
        }
        var rm = {};
        Object.defineProperty(rm, "__esModule", { value: !0 }),
          (rm.isReservedWord = am),
          (rm.isStrictReservedWord = um),
          (rm.isStrictBindOnlyReservedWord = lm),
          (rm.isStrictBindReservedWord = function (e, t) {
            return um(e, t) || lm(e);
          }),
          (rm.isKeyword = function (e) {
            return im.has(e);
          });
        const im = new Set([
            "break",
            "case",
            "catch",
            "continue",
            "debugger",
            "default",
            "do",
            "else",
            "finally",
            "for",
            "function",
            "if",
            "return",
            "switch",
            "throw",
            "try",
            "var",
            "const",
            "while",
            "with",
            "new",
            "this",
            "super",
            "class",
            "extends",
            "export",
            "import",
            "null",
            "true",
            "false",
            "in",
            "instanceof",
            "typeof",
            "void",
            "delete",
          ]),
          om = new Set([
            "implements",
            "interface",
            "let",
            "package",
            "private",
            "protected",
            "public",
            "static",
            "yield",
          ]),
          sm = new Set(["eval", "arguments"]);
        function am(e, t) {
          return (t && "await" === e) || "enum" === e;
        }
        function um(e, t) {
          return am(e, t) || om.has(e);
        }
        function lm(e) {
          return sm.has(e);
        }
        !(function (e) {
          Object.defineProperty(e, "__esModule", { value: !0 }),
            Object.defineProperty(e, "isIdentifierName", {
              enumerable: !0,
              get: function () {
                return t.isIdentifierName;
              },
            }),
            Object.defineProperty(e, "isIdentifierChar", {
              enumerable: !0,
              get: function () {
                return t.isIdentifierChar;
              },
            }),
            Object.defineProperty(e, "isIdentifierStart", {
              enumerable: !0,
              get: function () {
                return t.isIdentifierStart;
              },
            }),
            Object.defineProperty(e, "isReservedWord", {
              enumerable: !0,
              get: function () {
                return n.isReservedWord;
              },
            }),
            Object.defineProperty(e, "isStrictBindOnlyReservedWord", {
              enumerable: !0,
              get: function () {
                return n.isStrictBindOnlyReservedWord;
              },
            }),
            Object.defineProperty(e, "isStrictBindReservedWord", {
              enumerable: !0,
              get: function () {
                return n.isStrictBindReservedWord;
              },
            }),
            Object.defineProperty(e, "isStrictReservedWord", {
              enumerable: !0,
              get: function () {
                return n.isStrictReservedWord;
              },
            }),
            Object.defineProperty(e, "isKeyword", {
              enumerable: !0,
              get: function () {
                return n.isKeyword;
              },
            });
          var t = Gh,
            n = rm;
        })(Hh);
        var cm = { exports: {} },
          pm = /[|\\{}()[\]^$+*?.]/g,
          fm = function (e) {
            if ("string" != typeof e) throw new TypeError("Expected a string");
            return e.replace(pm, "\\$&");
          };
        const dm = rf,
          hm = (e, t) => {
            t = t || Ua.argv;
            const n = e.startsWith("-") ? "" : 1 === e.length ? "-" : "--",
              r = t.indexOf(n + e),
              i = t.indexOf("--");
            return -1 !== r && (-1 === i || r < i);
          },
          mm = Ua.env;
        let gm;
        function ym(e) {
          const t = (function (e) {
            if (!1 === gm) return 0;
            if (hm("color=16m") || hm("color=full") || hm("color=truecolor"))
              return 3;
            if (hm("color=256")) return 2;
            if (e && !e.isTTY && !0 !== gm) return 0;
            const t = gm ? 1 : 0;
            if ("win32" === Ua.platform) {
              const e = dm.release().split(".");
              return Number(Ua.versions.node.split(".")[0]) >= 8 &&
                Number(e[0]) >= 10 &&
                Number(e[2]) >= 10586
                ? Number(e[2]) >= 14931
                  ? 3
                  : 2
                : 1;
            }
            if ("CI" in mm)
              return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(
                (e) => e in mm
              ) || "codeship" === mm.CI_NAME
                ? 1
                : t;
            if ("TEAMCITY_VERSION" in mm)
              return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(mm.TEAMCITY_VERSION)
                ? 1
                : 0;
            if ("truecolor" === mm.COLORTERM) return 3;
            if ("TERM_PROGRAM" in mm) {
              const e = parseInt(
                (mm.TERM_PROGRAM_VERSION || "").split(".")[0],
                10
              );
              switch (mm.TERM_PROGRAM) {
                case "iTerm.app":
                  return e >= 3 ? 3 : 2;
                case "Apple_Terminal":
                  return 2;
              }
            }
            return /-256(color)?$/i.test(mm.TERM)
              ? 2
              : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(
                  mm.TERM
                ) || "COLORTERM" in mm
              ? 1
              : (mm.TERM, t);
          })(e);
          return (function (e) {
            return (
              0 !== e && {
                level: e,
                hasBasic: !0,
                has256: e >= 2,
                has16m: e >= 3,
              }
            );
          })(t);
        }
        hm("no-color") || hm("no-colors") || hm("color=false")
          ? (gm = !1)
          : (hm("color") ||
              hm("colors") ||
              hm("color=true") ||
              hm("color=always")) &&
            (gm = !0),
          "FORCE_COLOR" in mm &&
            (gm =
              0 === mm.FORCE_COLOR.length ||
              0 !== parseInt(mm.FORCE_COLOR, 10));
        var vm = {
          supportsColor: ym,
          stdout: ym(Ua.stdout),
          stderr: ym(Ua.stderr),
        };
        const Dm =
            /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
          bm = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g,
          Em = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/,
          Cm = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi,
          xm = new Map([
            ["n", "\n"],
            ["r", "\r"],
            ["t", "\t"],
            ["b", "\b"],
            ["f", "\f"],
            ["v", "\v"],
            ["0", "\0"],
            ["\\", "\\"],
            ["e", ""],
            ["a", ""],
          ]);
        function wm(e) {
          return ("u" === e[0] && 5 === e.length) ||
            ("x" === e[0] && 3 === e.length)
            ? String.fromCharCode(parseInt(e.slice(1), 16))
            : xm.get(e) || e;
        }
        function Am(e, t) {
          const n = [],
            r = t.trim().split(/\s*,\s*/g);
          let i;
          for (const t of r)
            if (isNaN(t)) {
              if (!(i = t.match(Em)))
                throw new Error(
                  "Invalid Chalk template style argument: "
                    .concat(t, " (in style '")
                    .concat(e, "')")
                );
              n.push(i[2].replace(Cm, (e, t, n) => (t ? wm(t) : n)));
            } else n.push(Number(t));
          return n;
        }
        function Sm(e) {
          bm.lastIndex = 0;
          const t = [];
          let n;
          for (; null !== (n = bm.exec(e)); ) {
            const e = n[1];
            if (n[2]) {
              const r = Am(e, n[2]);
              t.push([e].concat(r));
            } else t.push([e]);
          }
          return t;
        }
        function _m(e, t) {
          const n = {};
          for (const e of t)
            for (const t of e.styles) n[t[0]] = e.inverse ? null : t.slice(1);
          let r = e;
          for (const e of Object.keys(n))
            if (Array.isArray(n[e])) {
              if (!(e in r)) throw new Error("Unknown Chalk style: ".concat(e));
              r = n[e].length > 0 ? r[e].apply(r, n[e]) : r[e];
            }
          return r;
        }
        var Tm = (e, t) => {
          const n = [],
            r = [];
          let i = [];
          if (
            (t.replace(Dm, (t, o, s, a, u, l) => {
              if (o) i.push(wm(o));
              else if (a) {
                const t = i.join("");
                (i = []),
                  r.push(0 === n.length ? t : _m(e, n)(t)),
                  n.push({ inverse: s, styles: Sm(a) });
              } else if (u) {
                if (0 === n.length)
                  throw new Error(
                    "Found extraneous } in Chalk template literal"
                  );
                r.push(_m(e, n)(i.join(""))), (i = []), n.pop();
              } else i.push(l);
            }),
            r.push(i.join("")),
            n.length > 0)
          ) {
            const e = "Chalk template literal is missing "
              .concat(n.length, " closing bracket")
              .concat(1 === n.length ? "" : "s", " (`}`)");
            throw new Error(e);
          }
          return r.join("");
        };
        !(function (e) {
          const t = fm,
            n = wp.exports,
            r = vm.stdout,
            i = Tm,
            o =
              "win32" === Ua.platform &&
              !(Ua.env.TERM || "").toLowerCase().startsWith("xterm"),
            s = ["ansi", "ansi", "ansi256", "ansi16m"],
            a = new Set(["gray"]),
            u = Object.create(null);
          function l(e, t) {
            t = t || {};
            const n = r ? r.level : 0;
            (e.level = void 0 === t.level ? n : t.level),
              (e.enabled = "enabled" in t ? t.enabled : e.level > 0);
          }
          function c(e) {
            if (!this || !(this instanceof c) || this.template) {
              const t = {};
              return (
                l(t, e),
                (t.template = function () {
                  const e = [].slice.call(arguments);
                  return h.apply(null, [t.template].concat(e));
                }),
                Object.setPrototypeOf(t, c.prototype),
                Object.setPrototypeOf(t.template, t),
                (t.template.constructor = c),
                t.template
              );
            }
            l(this, e);
          }
          o && (n.blue.open = "[94m");
          for (const e of Object.keys(n))
            (n[e].closeRe = new RegExp(t(n[e].close), "g")),
              (u[e] = {
                get() {
                  const t = n[e];
                  return f.call(
                    this,
                    this._styles ? this._styles.concat(t) : [t],
                    this._empty,
                    e
                  );
                },
              });
          (u.visible = {
            get() {
              return f.call(this, this._styles || [], !0, "visible");
            },
          }),
            (n.color.closeRe = new RegExp(t(n.color.close), "g"));
          for (const e of Object.keys(n.color.ansi))
            a.has(e) ||
              (u[e] = {
                get() {
                  const t = this.level;
                  return function () {
                    const r = {
                      open: n.color[s[t]][e].apply(null, arguments),
                      close: n.color.close,
                      closeRe: n.color.closeRe,
                    };
                    return f.call(
                      this,
                      this._styles ? this._styles.concat(r) : [r],
                      this._empty,
                      e
                    );
                  };
                },
              });
          n.bgColor.closeRe = new RegExp(t(n.bgColor.close), "g");
          for (const e of Object.keys(n.bgColor.ansi))
            a.has(e) ||
              (u["bg" + e[0].toUpperCase() + e.slice(1)] = {
                get() {
                  const t = this.level;
                  return function () {
                    const r = {
                      open: n.bgColor[s[t]][e].apply(null, arguments),
                      close: n.bgColor.close,
                      closeRe: n.bgColor.closeRe,
                    };
                    return f.call(
                      this,
                      this._styles ? this._styles.concat(r) : [r],
                      this._empty,
                      e
                    );
                  };
                },
              });
          const p = Object.defineProperties(() => {}, u);
          function f(e, t, n) {
            const r = function () {
              return d.apply(r, arguments);
            };
            (r._styles = e), (r._empty = t);
            const i = this;
            return (
              Object.defineProperty(r, "level", {
                enumerable: !0,
                get: () => i.level,
                set(e) {
                  i.level = e;
                },
              }),
              Object.defineProperty(r, "enabled", {
                enumerable: !0,
                get: () => i.enabled,
                set(e) {
                  i.enabled = e;
                },
              }),
              (r.hasGrey = this.hasGrey || "gray" === n || "grey" === n),
              (r.__proto__ = p),
              r
            );
          }
          function d() {
            const e = arguments,
              t = e.length;
            let r = String(arguments[0]);
            if (0 === t) return "";
            if (t > 1) for (let n = 1; n < t; n++) r += " " + e[n];
            if (!this.enabled || this.level <= 0 || !r)
              return this._empty ? "" : r;
            const i = n.dim.open;
            o && this.hasGrey && (n.dim.open = "");
            for (const e of this._styles.slice().reverse())
              (r = e.open + r.replace(e.closeRe, e.open) + e.close),
                (r = r.replace(
                  /\r?\n/g,
                  "".concat(e.close, "$&").concat(e.open)
                ));
            return (n.dim.open = i), r;
          }
          function h(e, t) {
            if (!Array.isArray(t)) return [].slice.call(arguments, 1).join(" ");
            const n = [].slice.call(arguments, 2),
              r = [t.raw[0]];
            for (let e = 1; e < t.length; e++)
              r.push(String(n[e - 1]).replace(/[{}\\]/g, "\\$&")),
                r.push(String(t.raw[e]));
            return i(e, r.join(""));
          }
          Object.defineProperties(c.prototype, u),
            (e.exports = c()),
            (e.exports.supportsColor = r),
            (e.exports.default = e.exports);
        })(cm),
          Object.defineProperty(Wh, "__esModule", { value: !0 }),
          (Wh.default = function (e) {
            let t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            return Lm(t) ? jm(Pm($m(t)), e) : e;
          }),
          (Wh.getChalk = $m),
          (Wh.shouldHighlight = Lm);
        var Fm = Uh,
          km = Hh,
          Om = cm.exports;
        const Bm = new Set(["as", "async", "from", "get", "of", "set"]);
        function Pm(e) {
          return {
            keyword: e.cyan,
            capitalized: e.yellow,
            jsxIdentifier: e.yellow,
            punctuator: e.yellow,
            number: e.magenta,
            string: e.green,
            regex: e.magenta,
            comment: e.grey,
            invalid: e.white.bgRed.bold,
          };
        }
        const Nm = /\r\n|[\n\r\u2028\u2029]/,
          Mm = /^[()[\]{}]$/;
        let Im;
        {
          const e = /^[a-z][\w-]*$/i,
            t = function (t, n, r) {
              if ("name" === t.type) {
                if (
                  (0, km.isKeyword)(t.value) ||
                  (0, km.isStrictReservedWord)(t.value, !0) ||
                  Bm.has(t.value)
                )
                  return "keyword";
                if (
                  e.test(t.value) &&
                  ("<" === r[n - 1] || "</" == r.substr(n - 2, 2))
                )
                  return "jsxIdentifier";
                if (t.value[0] !== t.value[0].toLowerCase())
                  return "capitalized";
              }
              return "punctuator" === t.type && Mm.test(t.value)
                ? "bracket"
                : "invalid" !== t.type || ("@" !== t.value && "#" !== t.value)
                ? t.type
                : "punctuator";
            };
          Im = function* (e) {
            let n;
            for (; (n = Fm.default.exec(e)); ) {
              const r = Fm.matchToToken(n);
              yield { type: t(r, n.index, e), value: r.value };
            }
          };
        }
        function jm(e, t) {
          let n = "";
          for (const { type: r, value: i } of Im(t)) {
            const t = e[r];
            n += t
              ? i
                  .split(Nm)
                  .map((e) => t(e))
                  .join("\n")
              : i;
          }
          return n;
        }
        function Lm(e) {
          return !!Om.supportsColor || e.forceColor;
        }
        function $m(e) {
          return e.forceColor
            ? new Om.constructor({ enabled: !0, level: 1 })
            : Om;
        }
        Object.defineProperty(qh, "__esModule", { value: !0 }),
          (qh.codeFrameColumns = Um),
          (qh.default = function (e, t, n) {
            let r =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : {};
            if (!zm) {
              zm = !0;
              const e =
                "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
              Ua.emitWarning
                ? Ua.emitWarning(e, "DeprecationWarning")
                : ((new Error(e).name = "DeprecationWarning"),
                  console.warn(new Error(e)));
            }
            return Um(
              e,
              { start: { column: (n = Math.max(n, 0)), line: t } },
              r
            );
          });
        var Rm = Wh;
        let zm = !1;
        function Vm(e) {
          return { gutter: e.grey, marker: e.red.bold, message: e.red.bold };
        }
        const qm = /\r\n|[\n\r\u2028\u2029]/;
        function Wm(e, t, n) {
          const r = Object.assign({ column: 0, line: -1 }, e.start),
            i = Object.assign({}, r, e.end),
            { linesAbove: o = 2, linesBelow: s = 3 } = n || {},
            a = r.line,
            u = r.column,
            l = i.line,
            c = i.column;
          let p = Math.max(a - (o + 1), 0),
            f = Math.min(t.length, l + s);
          -1 === a && (p = 0), -1 === l && (f = t.length);
          const d = l - a,
            h = {};
          if (d)
            for (let e = 0; e <= d; e++) {
              const n = e + a;
              if (u)
                if (0 === e) {
                  const e = t[n - 1].length;
                  h[n] = [u, e - u + 1];
                } else if (e === d) h[n] = [0, c];
                else {
                  const r = t[n - e].length;
                  h[n] = [0, r];
                }
              else h[n] = !0;
            }
          else h[a] = u === c ? !u || [u, 0] : [u, c - u];
          return { start: p, end: f, markerLines: h };
        }
        function Um(e, t) {
          let n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          const r =
              (n.highlightCode || n.forceColor) && (0, Rm.shouldHighlight)(n),
            i = (0, Rm.getChalk)(n),
            o = Vm(i),
            s = (e, t) => (r ? e(t) : t),
            a = e.split(qm),
            { start: u, end: l, markerLines: c } = Wm(t, a, n),
            p = t.start && "number" == typeof t.start.column,
            f = String(l).length;
          let d = (r ? (0, Rm.default)(e, n) : e)
            .split(qm, l)
            .slice(u, l)
            .map((e, t) => {
              const r = u + 1 + t,
                i = " ".concat(r).slice(-f),
                a = " ".concat(i, " |"),
                l = c[r],
                p = !c[r + 1];
              if (l) {
                let t = "";
                if (Array.isArray(l)) {
                  const r = e
                      .slice(0, Math.max(l[0] - 1, 0))
                      .replace(/[^\t]/g, " "),
                    i = l[1] || 1;
                  (t = [
                    "\n ",
                    s(o.gutter, a.replace(/\d/g, " ")),
                    " ",
                    r,
                    s(o.marker, "^").repeat(i),
                  ].join("")),
                    p && n.message && (t += " " + s(o.message, n.message));
                }
                return [
                  s(o.marker, ">"),
                  s(o.gutter, a),
                  e.length > 0 ? " ".concat(e) : "",
                  t,
                ].join("");
              }
              return " "
                .concat(s(o.gutter, a))
                .concat(e.length > 0 ? " ".concat(e) : "");
            })
            .join("\n");
          return (
            n.message &&
              !p &&
              (d = ""
                .concat(" ".repeat(f + 1))
                .concat(n.message, "\n")
                .concat(d)),
            r ? i.reset(d) : d
          );
        }
        const { ConfigError: Hm } = up,
          Gm = Vh,
          { locStart: Ym, locEnd: Xm } = Gm,
          Jm = Object.getOwnPropertyNames,
          Zm = Object.getOwnPropertyDescriptor;
        function Km(e) {
          const t = {};
          for (const n of e.plugins)
            if (n.parsers)
              for (const e of Jm(n.parsers))
                Object.defineProperty(t, e, Zm(n.parsers, e));
          return t;
        }
        function Qm(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : Km(e);
          if ("function" == typeof e.parser)
            return {
              parse: e.parser,
              astFormat: "estree",
              locStart: Ym,
              locEnd: Xm,
            };
          if ("string" == typeof e.parser) {
            if (Object.prototype.hasOwnProperty.call(t, e.parser))
              return t[e.parser];
            throw new Hm(
              "Couldn't resolve parser \"".concat(
                e.parser,
                '". Parsers must be explicitly added to the standalone bundle.'
              )
            );
          }
        }
        var eg = {
          parse: function (e, t) {
            const n = Km(t),
              r = Object.defineProperties(
                {},
                Object.fromEntries(
                  Object.keys(n).map((e) => [
                    e,
                    { enumerable: !0, get: () => n[e].parse },
                  ])
                )
              ),
              i = Qm(t, n);
            try {
              return (
                i.preprocess && (e = i.preprocess(e, t)),
                { text: e, ast: i.parse(e, r, t) }
              );
            } catch (t) {
              const { loc: n } = t;
              if (n) {
                const { codeFrameColumns: r } = qh;
                throw (
                  ((t.codeFrame = r(e, n, { highlightCode: !0 })),
                  (t.message += "\n" + t.codeFrame),
                  t)
                );
              }
              throw t.stack;
            }
          },
          resolveParser: Qm,
        };
        const tg = ql,
          ng = ic,
          rg = class {
            constructor(e, t) {
              (t = t || {}).readChunk || (t.readChunk = 1024),
                t.newLineCharacter
                  ? (t.newLineCharacter = t.newLineCharacter.charCodeAt(0))
                  : (t.newLineCharacter = 10),
                (this.fd = "number" == typeof e ? e : rp.openSync(e, "r")),
                (this.options = t),
                (this.newLineCharacter = t.newLineCharacter),
                this.reset();
            }
            _searchInBuffer(e, t) {
              let n = -1;
              for (let r = 0; r <= e.length; r++)
                if (e[r] === t) {
                  n = r;
                  break;
                }
              return n;
            }
            reset() {
              (this.eofReached = !1),
                (this.linesCache = []),
                (this.fdPosition = 0);
            }
            close() {
              rp.closeSync(this.fd), (this.fd = null);
            }
            _extractLines(e) {
              let t;
              const n = [];
              let r = 0,
                i = 0;
              for (;;) {
                let o = e[r++];
                if (o === this.newLineCharacter)
                  (t = e.slice(i, r)), n.push(t), (i = r);
                else if (void 0 === o) break;
              }
              let o = e.slice(i, r);
              return o.length && n.push(o), n;
            }
            _readChunk(e) {
              let t,
                n = 0;
              const r = [];
              do {
                const e = new vc(this.options.readChunk);
                (t = rp.readSync(
                  this.fd,
                  e,
                  0,
                  this.options.readChunk,
                  this.fdPosition
                )),
                  (n += t),
                  (this.fdPosition = this.fdPosition + t),
                  r.push(e);
              } while (
                t &&
                -1 ===
                  this._searchInBuffer(
                    r[r.length - 1],
                    this.options.newLineCharacter
                  )
              );
              let i = vc.concat(r);
              return (
                t < this.options.readChunk &&
                  ((this.eofReached = !0), (i = i.slice(0, n))),
                n &&
                  ((this.linesCache = this._extractLines(i)),
                  e &&
                    (this.linesCache[0] = vc.concat([e, this.linesCache[0]]))),
                n
              );
            }
            next() {
              if (!this.fd) return !1;
              let e,
                t = !1;
              return (
                (this.eofReached && 0 === this.linesCache.length) ||
                  (this.linesCache.length || (e = this._readChunk()),
                  this.linesCache.length &&
                    ((t = this.linesCache.shift()),
                    t[t.length - 1] !== this.newLineCharacter &&
                      ((e = this._readChunk(t)),
                      e && (t = this.linesCache.shift()))),
                  this.eofReached &&
                    0 === this.linesCache.length &&
                    this.close(),
                  t &&
                    t[t.length - 1] === this.newLineCharacter &&
                    (t = t.slice(0, t.length - 1))),
                t
              );
            }
          },
          { UndefinedParserError: ig } = up,
          { getSupportInfo: og } = Nu,
          sg = jh,
          { resolveParser: ag } = eg,
          ug = {
            astFormat: "estree",
            printer: {},
            originalText: void 0,
            locStart: null,
            locEnd: null,
          };
        function lg(e) {
          const { astFormat: t } = e;
          if (!t) throw new Error("getPlugin() requires astFormat to be set");
          const n = e.plugins.find((e) => e.printers && e.printers[t]);
          if (!n)
            throw new Error(
              "Couldn't find plugin for AST format \"".concat(t, '"')
            );
          return n;
        }
        function cg(e, t) {
          const n = ng.basename(e).toLowerCase(),
            r = og({ plugins: t }).languages.filter((e) => null !== e.since);
          let i = r.find(
            (e) =>
              (e.extensions && e.extensions.some((e) => n.endsWith(e))) ||
              (e.filenames && e.filenames.some((e) => e.toLowerCase() === n))
          );
          if (!i && !n.includes(".")) {
            const t = (function (e) {
              if ("string" != typeof e) return "";
              let t;
              try {
                t = tg.openSync(e, "r");
              } catch {
                return "";
              }
              try {
                const e = new rg(t).next().toString("utf8"),
                  n = e.match(/^#!\/(?:usr\/)?bin\/env\s+(\S+)/);
                if (n) return n[1];
                const r = e.match(/^#!\/(?:usr\/(?:local\/)?)?bin\/(\S+)/);
                return r ? r[1] : "";
              } catch {
                return "";
              } finally {
                try {
                  tg.closeSync(t);
                } catch {}
              }
            })(e);
            i = r.find((e) => e.interpreters && e.interpreters.includes(t));
          }
          return i && i.parsers[0];
        }
        var pg = {
            normalize: function (e) {
              let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              const n = Object.assign({}, e),
                r = og({
                  plugins: e.plugins,
                  showUnreleased: !0,
                  showDeprecated: !0,
                }).options,
                i = Object.assign(
                  Object.assign({}, ug),
                  Object.fromEntries(
                    r
                      .filter((e) => void 0 !== e.default)
                      .map((e) => [e.name, e.default])
                  )
                );
              if (!n.parser)
                if (n.filepath) {
                  if (((n.parser = cg(n.filepath, n.plugins)), !n.parser))
                    throw new ig(
                      "No parser could be inferred for file: ".concat(
                        n.filepath
                      )
                    );
                } else
                  (t.logger || console).warn(
                    "No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."
                  ),
                    (n.parser = "babel");
              const o = ag(
                sg.normalizeApiOptions(
                  n,
                  [r.find((e) => "parser" === e.name)],
                  { passThrough: !0, logger: !1 }
                )
              );
              (n.astFormat = o.astFormat),
                (n.locEnd = o.locEnd),
                (n.locStart = o.locStart);
              const s = lg(n);
              n.printer = s.printers[n.astFormat];
              const a = Object.fromEntries(
                  r
                    .filter(
                      (e) =>
                        e.pluginDefaults && void 0 !== e.pluginDefaults[s.name]
                    )
                    .map((e) => [e.name, e.pluginDefaults[s.name]])
                ),
                u = Object.assign(Object.assign({}, i), a);
              for (const [e, t] of Object.entries(u))
                (null !== n[e] && void 0 !== n[e]) || (n[e] = t);
              return (
                "json" === n.parser && (n.trailingComma = "none"),
                sg.normalizeApiOptions(
                  n,
                  r,
                  Object.assign({ passThrough: Object.keys(ug) }, t)
                )
              );
            },
            hiddenDefaults: ug,
            inferParser: cg,
          },
          fg =
            "function" == typeof Object.create
              ? function (e, t) {
                  (e.super_ = t),
                    (e.prototype = Object.create(t.prototype, {
                      constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                      },
                    }));
                }
              : function (e, t) {
                  e.super_ = t;
                  var n = function () {};
                  (n.prototype = t.prototype),
                    (e.prototype = new n()),
                    (e.prototype.constructor = e);
                };
        function dg(e, t) {
          var n = { seen: [], stylize: mg };
          return (
            arguments.length >= 3 && (n.depth = arguments[2]),
            arguments.length >= 4 && (n.colors = arguments[3]),
            Dg(t) ? (n.showHidden = t) : t && kg(n, t),
            Cg(n.showHidden) && (n.showHidden = !1),
            Cg(n.depth) && (n.depth = 2),
            Cg(n.colors) && (n.colors = !1),
            Cg(n.customInspect) && (n.customInspect = !0),
            n.colors && (n.stylize = hg),
            gg(n, e, n.depth)
          );
        }
        function hg(e, t) {
          var n = dg.styles[t];
          return n
            ? "[" + dg.colors[n][0] + "m" + e + "[" + dg.colors[n][1] + "m"
            : e;
        }
        function mg(e, t) {
          return e;
        }
        function gg(e, t, n) {
          if (
            e.customInspect &&
            t &&
            _g(t.inspect) &&
            t.inspect !== dg &&
            (!t.constructor || t.constructor.prototype !== t)
          ) {
            var r = t.inspect(n, e);
            return Eg(r) || (r = gg(e, r, n)), r;
          }
          var i = (function (e, t) {
            if (Cg(t)) return e.stylize("undefined", "undefined");
            if (Eg(t)) {
              var n =
                "'" +
                JSON.stringify(t)
                  .replace(/^"|"$/g, "")
                  .replace(/'/g, "\\'")
                  .replace(/\\"/g, '"') +
                "'";
              return e.stylize(n, "string");
            }
            return "number" == typeof t
              ? e.stylize("" + t, "number")
              : Dg(t)
              ? e.stylize("" + t, "boolean")
              : bg(t)
              ? e.stylize("null", "null")
              : void 0;
          })(e, t);
          if (i) return i;
          var o = Object.keys(t),
            s = (function (e) {
              var t = {};
              return (
                e.forEach(function (e, n) {
                  t[e] = !0;
                }),
                t
              );
            })(o);
          if (
            (e.showHidden && (o = Object.getOwnPropertyNames(t)),
            Sg(t) &&
              (o.indexOf("message") >= 0 || o.indexOf("description") >= 0))
          )
            return yg(t);
          if (0 === o.length) {
            if (_g(t)) {
              var a = t.name ? ": " + t.name : "";
              return e.stylize("[Function" + a + "]", "special");
            }
            if (xg(t))
              return e.stylize(RegExp.prototype.toString.call(t), "regexp");
            if (Ag(t))
              return e.stylize(Date.prototype.toString.call(t), "date");
            if (Sg(t)) return yg(t);
          }
          var u,
            l,
            c = "",
            p = !1,
            f = ["{", "}"];
          return (
            (u = t),
            Array.isArray(u) && ((p = !0), (f = ["[", "]"])),
            _g(t) && (c = " [Function" + (t.name ? ": " + t.name : "") + "]"),
            xg(t) && (c = " " + RegExp.prototype.toString.call(t)),
            Ag(t) && (c = " " + Date.prototype.toUTCString.call(t)),
            Sg(t) && (c = " " + yg(t)),
            0 !== o.length || (p && 0 != t.length)
              ? n < 0
                ? xg(t)
                  ? e.stylize(RegExp.prototype.toString.call(t), "regexp")
                  : e.stylize("[Object]", "special")
                : (e.seen.push(t),
                  (l = p
                    ? (function (e, t, n, r, i) {
                        for (var o = [], s = 0, a = t.length; s < a; ++s)
                          Og(t, String(s))
                            ? o.push(vg(e, t, n, r, String(s), !0))
                            : o.push("");
                        return (
                          i.forEach(function (i) {
                            i.match(/^\d+$/) || o.push(vg(e, t, n, r, i, !0));
                          }),
                          o
                        );
                      })(e, t, n, s, o)
                    : o.map(function (r) {
                        return vg(e, t, n, s, r, p);
                      })),
                  e.seen.pop(),
                  (function (e, t, n) {
                    return e.reduce(function (e, t) {
                      return (
                        t.indexOf("\n"),
                        e + t.replace(/\u001b\[\d\d?m/g, "").length + 1
                      );
                    }, 0) > 60
                      ? n[0] +
                          ("" === t ? "" : t + "\n ") +
                          " " +
                          e.join(",\n  ") +
                          " " +
                          n[1]
                      : n[0] + t + " " + e.join(", ") + " " + n[1];
                  })(l, c, f))
              : f[0] + c + f[1]
          );
        }
        function yg(e) {
          return "[" + Error.prototype.toString.call(e) + "]";
        }
        function vg(e, t, n, r, i, o) {
          var s, a, u;
          if (
            ((u = Object.getOwnPropertyDescriptor(t, i) || { value: t[i] }).get
              ? (a = u.set
                  ? e.stylize("[Getter/Setter]", "special")
                  : e.stylize("[Getter]", "special"))
              : u.set && (a = e.stylize("[Setter]", "special")),
            Og(r, i) || (s = "[" + i + "]"),
            a ||
              (e.seen.indexOf(u.value) < 0
                ? (a = bg(n)
                    ? gg(e, u.value, null)
                    : gg(e, u.value, n - 1)).indexOf("\n") > -1 &&
                  (a = o
                    ? a
                        .split("\n")
                        .map(function (e) {
                          return "  " + e;
                        })
                        .join("\n")
                        .substr(2)
                    : "\n" +
                      a
                        .split("\n")
                        .map(function (e) {
                          return "   " + e;
                        })
                        .join("\n"))
                : (a = e.stylize("[Circular]", "special"))),
            Cg(s))
          ) {
            if (o && i.match(/^\d+$/)) return a;
            (s = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)
              ? ((s = s.substr(1, s.length - 2)), (s = e.stylize(s, "name")))
              : ((s = s
                  .replace(/'/g, "\\'")
                  .replace(/\\"/g, '"')
                  .replace(/(^"|"$)/g, "'")),
                (s = e.stylize(s, "string")));
          }
          return s + ": " + a;
        }
        function Dg(e) {
          return "boolean" == typeof e;
        }
        function bg(e) {
          return null === e;
        }
        function Eg(e) {
          return "string" == typeof e;
        }
        function Cg(e) {
          return void 0 === e;
        }
        function xg(e) {
          return wg(e) && "[object RegExp]" === Fg(e);
        }
        function wg(e) {
          return "object" == typeof e && null !== e;
        }
        function Ag(e) {
          return wg(e) && "[object Date]" === Fg(e);
        }
        function Sg(e) {
          return wg(e) && ("[object Error]" === Fg(e) || e instanceof Error);
        }
        function _g(e) {
          return "function" == typeof e;
        }
        function Tg(e) {
          return (
            null === e ||
            "boolean" == typeof e ||
            "number" == typeof e ||
            "string" == typeof e ||
            "symbol" == typeof e ||
            void 0 === e
          );
        }
        function Fg(e) {
          return Object.prototype.toString.call(e);
        }
        function kg(e, t) {
          if (!t || !wg(t)) return e;
          for (var n = Object.keys(t), r = n.length; r--; ) e[n[r]] = t[n[r]];
          return e;
        }
        function Og(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
        function Bg(e, t) {
          if (e === t) return 0;
          for (
            var n = e.length, r = t.length, i = 0, o = Math.min(n, r);
            i < o;
            ++i
          )
            if (e[i] !== t[i]) {
              (n = e[i]), (r = t[i]);
              break;
            }
          return n < r ? -1 : r < n ? 1 : 0;
        }
        (dg.colors = {
          bold: [1, 22],
          italic: [3, 23],
          underline: [4, 24],
          inverse: [7, 27],
          white: [37, 39],
          grey: [90, 39],
          black: [30, 39],
          blue: [34, 39],
          cyan: [36, 39],
          green: [32, 39],
          magenta: [35, 39],
          red: [31, 39],
          yellow: [33, 39],
        }),
          (dg.styles = {
            special: "cyan",
            number: "yellow",
            boolean: "yellow",
            undefined: "grey",
            null: "bold",
            string: "green",
            date: "magenta",
            regexp: "red",
          });
        var Pg,
          Ng = Object.prototype.hasOwnProperty,
          Mg =
            Object.keys ||
            function (e) {
              var t = [];
              for (var n in e) Ng.call(e, n) && t.push(n);
              return t;
            },
          Ig = Array.prototype.slice;
        function jg() {
          return void 0 !== Pg ? Pg : (Pg = "foo" === function () {}.name);
        }
        function Lg(e) {
          return Object.prototype.toString.call(e);
        }
        function $g(e) {
          return (
            !tp(e) &&
            "function" == typeof ba.ArrayBuffer &&
            ("function" == typeof ArrayBuffer.isView
              ? ArrayBuffer.isView(e)
              : !!e &&
                (e instanceof DataView ||
                  !!(e.buffer && e.buffer instanceof ArrayBuffer)))
          );
        }
        function Rg(e, t) {
          e || Hg(e, !0, t, "==", Gg);
        }
        var zg = /\s*function\s+([^\(\s]*)\s*/;
        function Vg(e) {
          if (_g(e)) {
            if (jg()) return e.name;
            var t = e.toString().match(zg);
            return t && t[1];
          }
        }
        function qg(e) {
          (this.name = "AssertionError"),
            (this.actual = e.actual),
            (this.expected = e.expected),
            (this.operator = e.operator),
            e.message
              ? ((this.message = e.message), (this.generatedMessage = !1))
              : ((this.message = (function (e) {
                  return (
                    Wg(Ug(e.actual), 128) +
                    " " +
                    e.operator +
                    " " +
                    Wg(Ug(e.expected), 128)
                  );
                })(this)),
                (this.generatedMessage = !0));
          var t = e.stackStartFunction || Hg;
          if (Error.captureStackTrace) Error.captureStackTrace(this, t);
          else {
            var n = new Error();
            if (n.stack) {
              var r = n.stack,
                i = Vg(t),
                o = r.indexOf("\n" + i);
              if (o >= 0) {
                var s = r.indexOf("\n", o + 1);
                r = r.substring(s + 1);
              }
              this.stack = r;
            }
          }
        }
        function Wg(e, t) {
          return "string" == typeof e ? (e.length < t ? e : e.slice(0, t)) : e;
        }
        function Ug(e) {
          if (jg() || !_g(e)) return dg(e);
          var t = Vg(e);
          return "[Function" + (t ? ": " + t : "") + "]";
        }
        function Hg(e, t, n, r, i) {
          throw new qg({
            message: n,
            actual: e,
            expected: t,
            operator: r,
            stackStartFunction: i,
          });
        }
        function Gg(e, t) {
          e || Hg(e, !0, t, "==", Gg);
        }
        function Yg(e, t, n) {
          e != t && Hg(e, t, n, "==", Yg);
        }
        function Xg(e, t, n) {
          e == t && Hg(e, t, n, "!=", Xg);
        }
        function Jg(e, t, n) {
          Kg(e, t, !1) || Hg(e, t, n, "deepEqual", Jg);
        }
        function Zg(e, t, n) {
          Kg(e, t, !0) || Hg(e, t, n, "deepStrictEqual", Zg);
        }
        function Kg(e, t, n, r) {
          if (e === t) return !0;
          if (tp(e) && tp(t)) return 0 === Bg(e, t);
          if (Ag(e) && Ag(t)) return e.getTime() === t.getTime();
          if (xg(e) && xg(t))
            return (
              e.source === t.source &&
              e.global === t.global &&
              e.multiline === t.multiline &&
              e.lastIndex === t.lastIndex &&
              e.ignoreCase === t.ignoreCase
            );
          if (
            (null !== e && "object" == typeof e) ||
            (null !== t && "object" == typeof t)
          ) {
            if (
              $g(e) &&
              $g(t) &&
              Lg(e) === Lg(t) &&
              !(e instanceof Float32Array || e instanceof Float64Array)
            )
              return (
                0 === Bg(new Uint8Array(e.buffer), new Uint8Array(t.buffer))
              );
            if (tp(e) !== tp(t)) return !1;
            var i = (r = r || { actual: [], expected: [] }).actual.indexOf(e);
            return (
              (-1 !== i && i === r.expected.indexOf(t)) ||
              (r.actual.push(e),
              r.expected.push(t),
              (function (e, t, n, r) {
                if (null == e || null == t) return !1;
                if (Tg(e) || Tg(t)) return e === t;
                if (n && Object.getPrototypeOf(e) !== Object.getPrototypeOf(t))
                  return !1;
                var i = Qg(e),
                  o = Qg(t);
                if ((i && !o) || (!i && o)) return !1;
                if (i) return Kg((e = Ig.call(e)), (t = Ig.call(t)), n);
                var s,
                  a,
                  u = Mg(e),
                  l = Mg(t);
                if (u.length !== l.length) return !1;
                for (u.sort(), l.sort(), a = u.length - 1; a >= 0; a--)
                  if (u[a] !== l[a]) return !1;
                for (a = u.length - 1; a >= 0; a--)
                  if (!Kg(e[(s = u[a])], t[s], n, r)) return !1;
                return !0;
              })(e, t, n, r))
            );
          }
          return n ? e === t : e == t;
        }
        function Qg(e) {
          return "[object Arguments]" == Object.prototype.toString.call(e);
        }
        function ey(e, t, n) {
          Kg(e, t, !1) && Hg(e, t, n, "notDeepEqual", ey);
        }
        function ty(e, t, n) {
          Kg(e, t, !0) && Hg(e, t, n, "notDeepStrictEqual", ty);
        }
        function ny(e, t, n) {
          e !== t && Hg(e, t, n, "===", ny);
        }
        function ry(e, t, n) {
          e === t && Hg(e, t, n, "!==", ry);
        }
        function iy(e, t) {
          if (!e || !t) return !1;
          if ("[object RegExp]" == Object.prototype.toString.call(t))
            return t.test(e);
          try {
            if (e instanceof t) return !0;
          } catch (e) {}
          return !Error.isPrototypeOf(t) && !0 === t.call({}, e);
        }
        function oy(e, t, n, r) {
          var i;
          if ("function" != typeof t)
            throw new TypeError('"block" argument must be a function');
          "string" == typeof n && ((r = n), (n = null)),
            (i = (function (e) {
              var t;
              try {
                e();
              } catch (e) {
                t = e;
              }
              return t;
            })(t)),
            (r =
              (n && n.name ? " (" + n.name + ")." : ".") + (r ? " " + r : ".")),
            e && !i && Hg(i, n, "Missing expected exception" + r);
          var o = "string" == typeof r,
            s = !e && i && !n;
          if (
            (((!e && Sg(i) && o && iy(i, n)) || s) &&
              Hg(i, n, "Got unwanted exception" + r),
            (e && i && n && !iy(i, n)) || (!e && i))
          )
            throw i;
        }
        function sy(e, t, n) {
          oy(!0, e, t, n);
        }
        function ay(e, t, n) {
          oy(!1, e, t, n);
        }
        function uy(e) {
          if (e) throw e;
        }
        (Rg.AssertionError = qg),
          fg(qg, Error),
          (Rg.fail = Hg),
          (Rg.ok = Gg),
          (Rg.equal = Yg),
          (Rg.notEqual = Xg),
          (Rg.deepEqual = Jg),
          (Rg.deepStrictEqual = Zg),
          (Rg.notDeepEqual = ey),
          (Rg.notDeepStrictEqual = ty),
          (Rg.strictEqual = ny),
          (Rg.notStrictEqual = ry),
          (Rg.throws = sy),
          (Rg.doesNotThrow = ay),
          (Rg.ifError = uy);
        var ly = t(
          Object.freeze({
            __proto__: null,
            default: Rg,
            AssertionError: qg,
            fail: Hg,
            ok: Gg,
            assert: Gg,
            equal: Yg,
            notEqual: Xg,
            deepEqual: Jg,
            deepStrictEqual: Zg,
            notDeepEqual: ey,
            notDeepStrictEqual: ty,
            strictEqual: ny,
            notStrictEqual: ry,
            throws: sy,
            doesNotThrow: ay,
            ifError: uy,
          })
        );
        const cy = ly,
          {
            builders: {
              line: py,
              hardline: fy,
              breakParent: dy,
              indent: hy,
              lineSuffix: my,
              join: gy,
              cursor: yy,
            },
          } = Vl,
          {
            hasNewline: vy,
            skipNewline: Dy,
            skipSpaces: by,
            isPreviousLineEmpty: Ey,
            addLeadingComment: Cy,
            addDanglingComment: xy,
            addTrailingComment: wy,
          } = nl,
          Ay = new WeakMap();
        function Sy(e, t, n) {
          if (!e) return;
          const { printer: r, locStart: i, locEnd: o } = t;
          if (n) {
            if (r.canAttachComment && r.canAttachComment(e)) {
              let t;
              for (
                t = n.length - 1;
                t >= 0 && !(i(n[t]) <= i(e) && o(n[t]) <= o(e));
                --t
              );
              return void n.splice(t + 1, 0, e);
            }
          } else if (Ay.has(e)) return Ay.get(e);
          const s =
            (r.getCommentChildNodes && r.getCommentChildNodes(e, t)) ||
            ("object" == typeof e &&
              Object.entries(e)
                .filter((e) => {
                  let [t] = e;
                  return (
                    "enclosingNode" !== t &&
                    "precedingNode" !== t &&
                    "followingNode" !== t &&
                    "tokens" !== t &&
                    "comments" !== t
                  );
                })
                .map((e) => {
                  let [, t] = e;
                  return t;
                }));
          if (s) {
            n || ((n = []), Ay.set(e, n));
            for (const e of s) Sy(e, t, n);
            return n;
          }
        }
        function _y(e, t, n, r) {
          const { locStart: i, locEnd: o } = n,
            s = i(t),
            a = o(t),
            u = Sy(e, n);
          let l,
            c,
            p = 0,
            f = u.length;
          for (; p < f; ) {
            const e = (p + f) >> 1,
              r = u[e],
              d = i(r),
              h = o(r);
            if (d <= s && a <= h) return _y(r, t, n, r);
            if (h <= s) (l = r), (p = e + 1);
            else {
              if (!(a <= d))
                throw new Error("Comment location overlaps with node location");
              (c = r), (f = e);
            }
          }
          if (r && "TemplateLiteral" === r.type) {
            const { quasis: e } = r,
              i = Ny(e, t, n);
            l && Ny(e, l, n) !== i && (l = null),
              c && Ny(e, c, n) !== i && (c = null);
          }
          return { enclosingNode: r, precedingNode: l, followingNode: c };
        }
        const Ty = () => !1,
          Fy = (e) => !/[\S\n\u2028\u2029]/.test(e);
        function ky(e, t, n, r) {
          const { comment: i, precedingNode: o } = n[r],
            { locStart: s, locEnd: a } = t;
          let u = s(i);
          if (o)
            for (let t = r - 1; t >= 0; t--) {
              const { comment: r, precedingNode: i } = n[t];
              if (i !== o || !Fy(e.slice(a(r), u))) break;
              u = s(r);
            }
          return vy(e, u, { backwards: !0 });
        }
        function Oy(e, t, n, r) {
          const { comment: i, followingNode: o } = n[r],
            { locStart: s, locEnd: a } = t;
          let u = a(i);
          if (o)
            for (let t = r + 1; t < n.length; t++) {
              const { comment: r, followingNode: i } = n[t];
              if (i !== o || !Fy(e.slice(u, s(r)))) break;
              u = a(r);
            }
          return vy(e, u);
        }
        function By(e, t, n) {
          const r = e.length;
          if (0 === r) return;
          const { precedingNode: i, followingNode: o, enclosingNode: s } = e[0],
            a =
              (n.printer.getGapRegex && n.printer.getGapRegex(s)) || /^[\s(]*$/;
          let u,
            l = n.locStart(o);
          for (u = r; u > 0; --u) {
            const { comment: r, precedingNode: s, followingNode: c } = e[u - 1];
            cy.strictEqual(s, i), cy.strictEqual(c, o);
            const p = t.slice(n.locEnd(r), l);
            if (!a.test(p)) break;
            l = n.locStart(r);
          }
          for (const [t, { comment: n }] of e.entries())
            t < u ? wy(i, n) : Cy(o, n);
          for (const e of [i, o])
            e.comments &&
              e.comments.length > 1 &&
              e.comments.sort((e, t) => n.locStart(e) - n.locStart(t));
          e.length = 0;
        }
        function Py(e, t) {
          return (e.getValue().printed = !0), t.printer.printComment(e, t);
        }
        function Ny(e, t, n) {
          const r = n.locStart(t) - 1;
          for (let t = 1; t < e.length; ++t)
            if (r < n.locStart(e[t])) return t - 1;
          return 0;
        }
        function My(e, t, n) {
          const r = e.getValue();
          if (!r) return {};
          let i = r.comments || [];
          n && (i = i.filter((e) => !n.has(e)));
          const o = r === t.cursorNode;
          if (0 === i.length) {
            const e = o ? yy : "";
            return { leading: e, trailing: e };
          }
          const s = [],
            a = [];
          return (
            e.each(() => {
              const r = e.getValue();
              if (n && n.has(r)) return;
              const { leading: i, trailing: o } = r;
              i
                ? s.push(
                    (function (e, t) {
                      const n = e.getValue(),
                        r = [Py(e, t)],
                        {
                          printer: i,
                          originalText: o,
                          locStart: s,
                          locEnd: a,
                        } = t;
                      if (i.isBlockComment && i.isBlockComment(n)) {
                        const e = vy(o, a(n))
                          ? vy(o, s(n), { backwards: !0 })
                            ? fy
                            : py
                          : " ";
                        r.push(e);
                      } else r.push(fy);
                      const u = Dy(o, by(o, a(n)));
                      return !1 !== u && vy(o, u) && r.push(fy), r;
                    })(e, t)
                  )
                : o &&
                  a.push(
                    (function (e, t) {
                      const n = e.getValue(),
                        r = Py(e, t),
                        { printer: i, originalText: o, locStart: s } = t,
                        a = i.isBlockComment && i.isBlockComment(n);
                      if (vy(o, s(n), { backwards: !0 })) {
                        const e = Ey(o, n, s);
                        return my([fy, e ? fy : "", r]);
                      }
                      let u = [" ", r];
                      return a || (u = [my(u), dy]), u;
                    })(e, t)
                  );
            }, "comments"),
            o && (s.unshift(yy), a.push(yy)),
            { leading: s, trailing: a }
          );
        }
        var Iy = {
          attach: function (e, t, n, r) {
            if (!Array.isArray(e)) return;
            const i = [],
              {
                locStart: o,
                locEnd: s,
                printer: { handleComments: a = {} },
              } = r,
              {
                avoidAstMutation: u,
                ownLine: l = Ty,
                endOfLine: c = Ty,
                remaining: p = Ty,
              } = a,
              f = e.map((i, o) =>
                Object.assign(
                  Object.assign({}, _y(t, i, r)),
                  {},
                  {
                    comment: i,
                    text: n,
                    options: r,
                    ast: t,
                    isLastComment: e.length - 1 === o,
                  }
                )
              );
            for (const [e, t] of f.entries()) {
              const {
                comment: n,
                precedingNode: r,
                enclosingNode: a,
                followingNode: d,
                text: h,
                options: m,
                ast: g,
                isLastComment: y,
              } = t;
              if (
                "json" === m.parser ||
                "json5" === m.parser ||
                "__js_expression" === m.parser ||
                "__vue_expression" === m.parser
              ) {
                if (o(n) - o(g) <= 0) {
                  Cy(g, n);
                  continue;
                }
                if (s(n) - s(g) >= 0) {
                  wy(g, n);
                  continue;
                }
              }
              let v;
              if (
                (u
                  ? (v = [t])
                  : ((n.enclosingNode = a),
                    (n.precedingNode = r),
                    (n.followingNode = d),
                    (v = [n, h, m, g, y])),
                ky(h, m, f, e))
              )
                (n.placement = "ownLine"),
                  l(...v) || (d ? Cy(d, n) : r ? wy(r, n) : xy(a || g, n));
              else if (Oy(h, m, f, e))
                (n.placement = "endOfLine"),
                  c(...v) || (r ? wy(r, n) : d ? Cy(d, n) : xy(a || g, n));
              else if (((n.placement = "remaining"), p(...v)));
              else if (r && d) {
                const e = i.length;
                e > 0 && i[e - 1].followingNode !== d && By(i, h, m), i.push(t);
              } else r ? wy(r, n) : d ? Cy(d, n) : xy(a || g, n);
            }
            if ((By(i, n, r), !u))
              for (const t of e)
                delete t.precedingNode,
                  delete t.enclosingNode,
                  delete t.followingNode;
          },
          printComments: function (e, t, n, r) {
            const { leading: i, trailing: o } = My(e, n, r);
            return i || o ? [i, t, o] : t;
          },
          printCommentsSeparately: My,
          printDanglingComments: function (e, t, n, r) {
            const i = [],
              o = e.getValue();
            return o && o.comments
              ? (e.each(() => {
                  const n = e.getValue();
                  n.leading || n.trailing || (r && !r(n)) || i.push(Py(e, t));
                }, "comments"),
                0 === i.length ? "" : n ? gy(fy, i) : hy([fy, gy(fy, i)]))
              : "";
          },
          getSortedChildNodes: Sy,
          ensureAllCommentsPrinted: function (e) {
            if (e)
              for (const t of e) {
                if (!t.printed)
                  throw new Error(
                    'Comment "' +
                      t.value.trim() +
                      '" was not printed. Please report this error!'
                  );
                delete t.printed;
              }
          },
        };
        const jy = ns;
        function Ly(e, t) {
          const n = $y(e.stack, t);
          return -1 === n ? null : e.stack[n];
        }
        function $y(e, t) {
          for (let n = e.length - 1; n >= 0; n -= 2) {
            const r = e[n];
            if (r && !Array.isArray(r) && --t < 0) return n;
          }
          return -1;
        }
        const {
            utils: { stripTrailingHardline: Ry },
          } = Vl,
          { normalize: zy } = pg,
          Vy = Iy;
        var qy = {
          printSubtree: function (e, t, n, r) {
            if (n.printer.embed && "auto" === n.embeddedLanguageFormatting)
              return n.printer.embed(
                e,
                t,
                (e, t, i) =>
                  (function (e, t, n, r) {
                    let { stripTrailingHardline: i = !1 } =
                      arguments.length > 4 && void 0 !== arguments[4]
                        ? arguments[4]
                        : {};
                    const o = zy(
                        Object.assign(
                          Object.assign(Object.assign({}, n), t),
                          {},
                          { parentParser: n.parser, originalText: e }
                        ),
                        { passThrough: !0 }
                      ),
                      s = eg.parse(e, o),
                      { ast: a } = s;
                    e = s.text;
                    const u = a.comments;
                    delete a.comments,
                      Vy.attach(u, a, e, o),
                      (o[Symbol.for("comments")] = u || []),
                      (o[Symbol.for("tokens")] = a.tokens || []);
                    const l = r(a, o);
                    return (
                      Vy.ensureAllCommentsPrinted(u),
                      i
                        ? "string" == typeof l
                          ? l.replace(/(?:\r?\n)*$/, "")
                          : Ry(l)
                        : l
                    );
                  })(e, t, n, r, i),
                n
              );
          },
        };
        const Wy = class {
            constructor(e) {
              this.stack = [e];
            }
            getName() {
              const { stack: e } = this,
                { length: t } = e;
              return t > 1 ? e[t - 2] : null;
            }
            getValue() {
              return jy(this.stack);
            }
            getNode() {
              return Ly(
                this,
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : 0
              );
            }
            getParentNode() {
              return Ly(
                this,
                (arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : 0) + 1
              );
            }
            call(e) {
              const { stack: t } = this,
                { length: n } = t;
              let r = jy(t);
              for (
                var i = arguments.length,
                  o = new Array(i > 1 ? i - 1 : 0),
                  s = 1;
                s < i;
                s++
              )
                o[s - 1] = arguments[s];
              for (const e of o) (r = r[e]), t.push(e, r);
              const a = e(this);
              return (t.length = n), a;
            }
            callParent(e) {
              let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0;
              const n = $y(this.stack, t + 1),
                r = this.stack.splice(n + 1),
                i = e(this);
              return this.stack.push(...r), i;
            }
            each(e) {
              const { stack: t } = this,
                { length: n } = t;
              let r = jy(t);
              for (
                var i = arguments.length,
                  o = new Array(i > 1 ? i - 1 : 0),
                  s = 1;
                s < i;
                s++
              )
                o[s - 1] = arguments[s];
              for (const e of o) (r = r[e]), t.push(e, r);
              for (let n = 0; n < r.length; ++n)
                t.push(n, r[n]), e(this, n, r), (t.length -= 2);
              t.length = n;
            }
            map(e) {
              const t = [];
              for (
                var n = arguments.length,
                  r = new Array(n > 1 ? n - 1 : 0),
                  i = 1;
                i < n;
                i++
              )
                r[i - 1] = arguments[i];
              return (
                this.each((n, r, i) => {
                  t[r] = e(n, r, i);
                }, ...r),
                t
              );
            }
            try(e) {
              const { stack: t } = this,
                n = [...t];
              try {
                return e();
              } finally {
                (t.length = 0), t.push(...n);
              }
            }
            match() {
              let e = this.stack.length - 1,
                t = null,
                n = this.stack[e--];
              for (
                var r = arguments.length, i = new Array(r), o = 0;
                o < r;
                o++
              )
                i[o] = arguments[o];
              for (const r of i) {
                if (void 0 === n) return !1;
                let i = null;
                if (
                  ("number" == typeof t &&
                    ((i = t), (t = this.stack[e--]), (n = this.stack[e--])),
                  r && !r(n, t, i))
                )
                  return !1;
                (t = this.stack[e--]), (n = this.stack[e--]);
              }
              return !0;
            }
            findAncestor(e) {
              let t = this.stack.length - 1,
                n = null,
                r = this.stack[t--];
              for (; r; ) {
                let i = null;
                if (
                  ("number" == typeof n &&
                    ((i = n), (n = this.stack[t--]), (r = this.stack[t--])),
                  null !== n && e(r, n, i))
                )
                  return r;
                (n = this.stack[t--]), (r = this.stack[t--]);
              }
            }
          },
          {
            builders: { hardline: Uy, addAlignmentToDoc: Hy },
            utils: { propagateBreaks: Gy },
          } = Vl,
          { printComments: Yy } = Iy,
          Xy = qy;
        function Jy(e, t) {
          let n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
          const { printer: r } = t;
          r.preprocess && (e = r.preprocess(e, t));
          const i = new Map(),
            o = new Wy(e);
          let s = a();
          return n > 0 && (s = Hy([Uy, s], n, t.tabWidth)), Gy(s), s;
          function a(e, t) {
            return void 0 === e || e === o
              ? u(t)
              : Array.isArray(e)
              ? o.call(() => u(t), ...e)
              : o.call(() => u(t), e);
          }
          function u(e) {
            const n = o.getValue(),
              r = n && "object" == typeof n && void 0 === e;
            if (r && i.has(n)) return i.get(n);
            const s = Zy(o, t, a, e);
            return r && i.set(n, s), s;
          }
        }
        function Zy(t, n, r, i) {
          const o = t.getValue(),
            { printer: s } = n;
          let a, u;
          if (s.hasPrettierIgnore && s.hasPrettierIgnore(t))
            ({ doc: a, printedComments: u } = (function (e, t) {
              const {
                  originalText: n,
                  [Symbol.for("comments")]: r,
                  locStart: i,
                  locEnd: o,
                } = t,
                s = i(e),
                a = o(e),
                u = new Set();
              for (const e of r)
                i(e) >= s && o(e) <= a && ((e.printed = !0), u.add(e));
              return { doc: n.slice(s, a), printedComments: u };
            })(o, n));
          else {
            if (o)
              try {
                a = Xy.printSubtree(t, r, n, Jy);
              } catch (t) {
                if (e.PRETTIER_DEBUG) throw t;
              }
            a || (a = s.print(t, n, r, i));
          }
          return (
            (s.willPrintOwnComments && s.willPrintOwnComments(t, n)) ||
              (a = Yy(t, a, n, u)),
            a
          );
        }
        var Ky = Jy;
        const Qy = ly,
          ev = Iy;
        function tv(e) {
          let t = e.length - 1;
          for (;;) {
            const n = e[t];
            if (!n || ("Program" !== n.type && "File" !== n.type)) break;
            t--;
          }
          return e.slice(0, t + 1);
        }
        function nv(e, t, n, r) {
          let i =
              arguments.length > 4 && void 0 !== arguments[4]
                ? arguments[4]
                : [],
            o = arguments.length > 5 ? arguments[5] : void 0;
          const { locStart: s, locEnd: a } = n,
            u = s(e),
            l = a(e);
          if (
            !(
              t > l ||
              t < u ||
              ("rangeEnd" === o && t === u) ||
              ("rangeStart" === o && t === l)
            )
          ) {
            for (const s of ev.getSortedChildNodes(e, n)) {
              const a = nv(s, t, n, r, [e, ...i], o);
              if (a) return a;
            }
            return !r || r(e, i[0]) ? { node: e, parentNodes: i } : void 0;
          }
        }
        const rv = new Set([
            "ObjectExpression",
            "ArrayExpression",
            "StringLiteral",
            "NumericLiteral",
            "BooleanLiteral",
            "NullLiteral",
            "UnaryExpression",
            "TemplateLiteral",
          ]),
          iv = new Set([
            "OperationDefinition",
            "FragmentDefinition",
            "VariableDefinition",
            "TypeExtensionDefinition",
            "ObjectTypeDefinition",
            "FieldDefinition",
            "DirectiveDefinition",
            "EnumTypeDefinition",
            "EnumValueDefinition",
            "InputValueDefinition",
            "InputObjectTypeDefinition",
            "SchemaDefinition",
            "OperationTypeDefinition",
            "InterfaceTypeDefinition",
            "UnionTypeDefinition",
            "ScalarTypeDefinition",
          ]);
        function ov(e, t, n) {
          if (!t) return !1;
          switch (e.parser) {
            case "flow":
            case "babel":
            case "babel-flow":
            case "babel-ts":
            case "typescript":
            case "espree":
            case "meriyah":
            case "__babel_estree":
              return (function (e, t) {
                return (
                  "DeclareExportDeclaration" !== t &&
                  "TypeParameterDeclaration" !== e &&
                  ("Directive" === e ||
                    "TypeAlias" === e ||
                    "TSExportAssignment" === e ||
                    e.startsWith("Declare") ||
                    e.startsWith("TSDeclare") ||
                    e.endsWith("Statement") ||
                    e.endsWith("Declaration"))
                );
              })(t.type, n && n.type);
            case "json":
            case "json5":
            case "json-stringify":
              return rv.has(t.type);
            case "graphql":
              return iv.has(t.kind);
            case "vue":
              return "root" !== t.tag;
          }
          return !1;
        }
        var sv = {
          calculateRange: function (e, t, n) {
            let { rangeStart: r, rangeEnd: i, locStart: o, locEnd: s } = t;
            Qy.ok(i > r);
            const a = e.slice(r, i).search(/\S/),
              u = -1 === a;
            if (!u) for (r += a; i > r && !/\S/.test(e[i - 1]); --i);
            const l = nv(n, r, t, (e, n) => ov(t, e, n), [], "rangeStart"),
              c = u ? l : nv(n, i, t, (e) => ov(t, e), [], "rangeEnd");
            if (!l || !c) return { rangeStart: 0, rangeEnd: 0 };
            let p, f;
            if (
              ((e) => {
                let { parser: t } = e;
                return "json" === t || "json5" === t || "json-stringify" === t;
              })(t)
            ) {
              const e = (function (e, t) {
                const n = [e.node, ...e.parentNodes],
                  r = new Set([t.node, ...t.parentNodes]);
                return n.find((e) => rv.has(e.type) && r.has(e));
              })(l, c);
              (p = e), (f = e);
            } else
              ({ startNode: p, endNode: f } = (function (e, t, n) {
                let { locStart: r, locEnd: i } = n,
                  o = e.node,
                  s = t.node;
                if (o === s) return { startNode: o, endNode: s };
                const a = r(e.node);
                for (const e of tv(t.parentNodes)) {
                  if (!(r(e) >= a)) break;
                  s = e;
                }
                const u = i(t.node);
                for (const t of tv(e.parentNodes)) {
                  if (!(i(t) <= u)) break;
                  o = t;
                }
                return { startNode: o, endNode: s };
              })(l, c, t));
            return {
              rangeStart: Math.min(o(p), o(f)),
              rangeEnd: Math.max(s(p), s(f)),
            };
          },
          findNodeAtOffset: nv,
        };
        const av = i,
          {
            printer: { printDocToString: uv },
            debug: { printDocToDebug: lv },
          } = Vl,
          { getAlignmentSize: cv } = nl,
          {
            guessEndOfLine: pv,
            convertEndOfLineToChars: fv,
            countEndOfLineChars: dv,
            normalizeEndOfLine: hv,
          } = rl,
          mv = pg.normalize,
          gv = function e(t, n, r) {
            if (Array.isArray(t))
              return t.map((t) => e(t, n, r)).filter(Boolean);
            if (!t || "object" != typeof t) return t;
            const i = n.printer.massageAstNode;
            let o;
            o = i && i.ignoredProperties ? i.ignoredProperties : new Set();
            const s = {};
            for (const [r, i] of Object.entries(t))
              o.has(r) || "function" == typeof i || (s[r] = e(i, n, t));
            if (i) {
              const e = i(t, s, r);
              if (null === e) return;
              if (e) return e;
            }
            return s;
          },
          yv = Iy,
          vv = eg,
          Dv = Ky,
          bv = sv,
          Ev = Symbol("cursor");
        function Cv(e, t, n) {
          const r = t.comments;
          return (
            r && (delete t.comments, yv.attach(r, t, e, n)),
            (n[Symbol.for("comments")] = r || []),
            (n[Symbol.for("tokens")] = t.tokens || []),
            (n.originalText = e),
            r
          );
        }
        function xv(e, t) {
          let n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
          if (!e || 0 === e.trim().length)
            return { formatted: "", cursorOffset: -1, comments: [] };
          const { ast: r, text: i } = vv.parse(e, t);
          if (t.cursorOffset >= 0) {
            const e = bv.findNodeAtOffset(r, t.cursorOffset, t);
            e && e.node && (t.cursorNode = e.node);
          }
          const o = Cv(i, r, t),
            s = Dv(r, t, n),
            a = uv(s, t);
          if ((yv.ensureAllCommentsPrinted(o), n > 0)) {
            const e = a.formatted.trim();
            void 0 !== a.cursorNodeStart &&
              (a.cursorNodeStart -= a.formatted.indexOf(e)),
              (a.formatted = e + fv(t.endOfLine));
          }
          if (t.cursorOffset >= 0) {
            let e, n, r, s, u;
            if (
              (t.cursorNode && a.cursorNodeText
                ? ((e = t.locStart(t.cursorNode)),
                  (n = i.slice(e, t.locEnd(t.cursorNode))),
                  (r = t.cursorOffset - e),
                  (s = a.cursorNodeStart),
                  (u = a.cursorNodeText))
                : ((e = 0),
                  (n = i),
                  (r = t.cursorOffset),
                  (s = 0),
                  (u = a.formatted)),
              n === u)
            )
              return {
                formatted: a.formatted,
                cursorOffset: s + r,
                comments: o,
              };
            const l = [...n];
            l.splice(r, 0, Ev);
            const c = [...u],
              p = av.diffArrays(l, c);
            let f = s;
            for (const e of p)
              if (e.removed) {
                if (e.value.includes(Ev)) break;
              } else f += e.count;
            return { formatted: a.formatted, cursorOffset: f, comments: o };
          }
          return { formatted: a.formatted, cursorOffset: -1, comments: o };
        }
        function wv(e, t, n) {
          return "number" != typeof t ||
            Number.isNaN(t) ||
            t < 0 ||
            t > e.length
            ? n
            : t;
        }
        function Av(e, t) {
          let { cursorOffset: n, rangeStart: r, rangeEnd: i } = t;
          return (
            (n = wv(e, n, -1)),
            (r = wv(e, r, 0)),
            (i = wv(e, i, e.length)),
            Object.assign(
              Object.assign({}, t),
              {},
              { cursorOffset: n, rangeStart: r, rangeEnd: i }
            )
          );
        }
        function Sv(e, t) {
          let {
            cursorOffset: n,
            rangeStart: r,
            rangeEnd: i,
            endOfLine: o,
          } = Av(e, t);
          const s = "\ufeff" === e.charAt(0);
          if (
            (s && ((e = e.slice(1)), n--, r--, i--),
            "auto" === o && (o = pv(e)),
            e.includes("\r"))
          ) {
            const t = (t) => dv(e.slice(0, Math.max(t, 0)), "\r\n");
            (n -= t(n)), (r -= t(r)), (i -= t(i)), (e = hv(e));
          }
          return {
            hasBOM: s,
            text: e,
            options: Av(
              e,
              Object.assign(
                Object.assign({}, t),
                {},
                { cursorOffset: n, rangeStart: r, rangeEnd: i, endOfLine: o }
              )
            ),
          };
        }
        function _v(e, t) {
          const n = vv.resolveParser(t);
          return !n.hasPragma || n.hasPragma(e);
        }
        function Tv(e, t) {
          let n,
            { hasBOM: r, text: i, options: o } = Sv(e, mv(t));
          return (o.rangeStart >= o.rangeEnd && "" !== i) ||
            (o.requirePragma && !_v(i, o))
            ? { formatted: e, cursorOffset: t.cursorOffset, comments: [] }
            : (o.rangeStart > 0 || o.rangeEnd < i.length
                ? (n = (function (e, t) {
                    const { ast: n, text: r } = vv.parse(e, t),
                      { rangeStart: i, rangeEnd: o } = bv.calculateRange(
                        r,
                        t,
                        n
                      ),
                      s = r.slice(i, o),
                      a = Math.min(i, r.lastIndexOf("\n", i) + 1),
                      u = r.slice(a, i).match(/^\s*/)[0],
                      l = cv(u, t.tabWidth),
                      c = xv(
                        s,
                        Object.assign(
                          Object.assign({}, t),
                          {},
                          {
                            rangeStart: 0,
                            rangeEnd: Number.POSITIVE_INFINITY,
                            cursorOffset:
                              t.cursorOffset > i && t.cursorOffset <= o
                                ? t.cursorOffset - i
                                : -1,
                            endOfLine: "lf",
                          }
                        ),
                        l
                      ),
                      p = c.formatted.trimEnd();
                    let { cursorOffset: f } = t;
                    f > o
                      ? (f += p.length - s.length)
                      : c.cursorOffset >= 0 && (f = c.cursorOffset + i);
                    let d = r.slice(0, i) + p + r.slice(o);
                    if ("lf" !== t.endOfLine) {
                      const e = fv(t.endOfLine);
                      f >= 0 && "\r\n" === e && (f += dv(d.slice(0, f), "\n")),
                        (d = d.replace(/\n/g, e));
                    }
                    return {
                      formatted: d,
                      cursorOffset: f,
                      comments: c.comments,
                    };
                  })(i, o))
                : (!o.requirePragma &&
                    o.insertPragma &&
                    o.printer.insertPragma &&
                    !_v(i, o) &&
                    (i = o.printer.insertPragma(i)),
                  (n = xv(i, o))),
              r &&
                ((n.formatted = "\ufeff" + n.formatted),
                n.cursorOffset >= 0 && n.cursorOffset++),
              n);
        }
        var Fv = {
          formatWithCursor: Tv,
          parse(e, t, n) {
            const { text: r, options: i } = Sv(e, mv(t)),
              o = vv.parse(r, i);
            return n && (o.ast = gv(o.ast, i)), o;
          },
          formatAST(e, t) {
            t = mv(t);
            const n = Dv(e, t);
            return uv(n, t);
          },
          formatDoc: (e, t) =>
            Tv(
              lv(e),
              Object.assign(
                Object.assign({}, t),
                {},
                { parser: "__js_expression" }
              )
            ).formatted,
          printToDoc(e, t) {
            t = mv(t);
            const { ast: n, text: r } = vv.parse(e, t);
            return Cv(r, n, t), Dv(n, t);
          },
          printDocToString: (e, t) => uv(e, mv(t)),
        };
        const {
          getMaxContinuousCount: kv,
          getStringWidth: Ov,
          getAlignmentSize: Bv,
          getIndentSize: Pv,
          skip: Nv,
          skipWhitespace: Mv,
          skipSpaces: Iv,
          skipNewline: jv,
          skipToLineEnd: Lv,
          skipEverythingButNewLine: $v,
          skipInlineComment: Rv,
          skipTrailingComment: zv,
          hasNewline: Vv,
          hasNewlineInRange: qv,
          hasSpaces: Wv,
          isNextLineEmpty: Uv,
          isNextLineEmptyAfterIndex: Hv,
          isPreviousLineEmpty: Gv,
          getNextNonSpaceNonCommentCharacterIndex: Yv,
          makeString: Xv,
          addLeadingComment: Jv,
          addDanglingComment: Zv,
          addTrailingComment: Kv,
        } = nl;
        var Qv = {
          getMaxContinuousCount: kv,
          getStringWidth: Ov,
          getAlignmentSize: Bv,
          getIndentSize: Pv,
          skip: Nv,
          skipWhitespace: Mv,
          skipSpaces: Iv,
          skipNewline: jv,
          skipToLineEnd: Lv,
          skipEverythingButNewLine: $v,
          skipInlineComment: Rv,
          skipTrailingComment: zv,
          hasNewline: Vv,
          hasNewlineInRange: qv,
          hasSpaces: Wv,
          isNextLineEmpty: Uv,
          isNextLineEmptyAfterIndex: Hv,
          isPreviousLineEmpty: Gv,
          getNextNonSpaceNonCommentCharacterIndex: Yv,
          makeString: Xv,
          addLeadingComment: Jv,
          addDanglingComment: Zv,
          addTrailingComment: Kv,
        };
        const eD = ["languageId"];
        var tD = function (e, t) {
            const { languageId: n } = e,
              r = rs(e, eD);
            return Object.assign(
              Object.assign({ linguistLanguageId: n }, r),
              t(e)
            );
          },
          nD = {},
          rD = { exports: {} };
        !(function () {
          function e(e) {
            if (null == e) return !1;
            switch (e.type) {
              case "BlockStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "DebuggerStatement":
              case "DoWhileStatement":
              case "EmptyStatement":
              case "ExpressionStatement":
              case "ForInStatement":
              case "ForStatement":
              case "IfStatement":
              case "LabeledStatement":
              case "ReturnStatement":
              case "SwitchStatement":
              case "ThrowStatement":
              case "TryStatement":
              case "VariableDeclaration":
              case "WhileStatement":
              case "WithStatement":
                return !0;
            }
            return !1;
          }
          function t(e) {
            switch (e.type) {
              case "IfStatement":
                return null != e.alternate ? e.alternate : e.consequent;
              case "LabeledStatement":
              case "ForStatement":
              case "ForInStatement":
              case "WhileStatement":
              case "WithStatement":
                return e.body;
            }
            return null;
          }
          rD.exports = {
            isExpression: function (e) {
              if (null == e) return !1;
              switch (e.type) {
                case "ArrayExpression":
                case "AssignmentExpression":
                case "BinaryExpression":
                case "CallExpression":
                case "ConditionalExpression":
                case "FunctionExpression":
                case "Identifier":
                case "Literal":
                case "LogicalExpression":
                case "MemberExpression":
                case "NewExpression":
                case "ObjectExpression":
                case "SequenceExpression":
                case "ThisExpression":
                case "UnaryExpression":
                case "UpdateExpression":
                  return !0;
              }
              return !1;
            },
            isStatement: e,
            isIterationStatement: function (e) {
              if (null == e) return !1;
              switch (e.type) {
                case "DoWhileStatement":
                case "ForInStatement":
                case "ForStatement":
                case "WhileStatement":
                  return !0;
              }
              return !1;
            },
            isSourceElement: function (t) {
              return e(t) || (null != t && "FunctionDeclaration" === t.type);
            },
            isProblematicIfStatement: function (e) {
              var n;
              if ("IfStatement" !== e.type) return !1;
              if (null == e.alternate) return !1;
              n = e.consequent;
              do {
                if ("IfStatement" === n.type && null == n.alternate) return !0;
                n = t(n);
              } while (n);
              return !1;
            },
            trailingStatement: t,
          };
        })();
        var iD = { exports: {} };
        !(function () {
          var e, t, n, r, i, o;
          function s(e) {
            return e <= 65535
              ? String.fromCharCode(e)
              : String.fromCharCode(Math.floor((e - 65536) / 1024) + 55296) +
                  String.fromCharCode(((e - 65536) % 1024) + 56320);
          }
          for (
            t = {
              NonAsciiIdentifierStart:
                /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
              NonAsciiIdentifierPart:
                /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
            },
              e = {
                NonAsciiIdentifierStart:
                  /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
                NonAsciiIdentifierPart:
                  /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/,
              },
              n = [
                5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200,
                8201, 8202, 8239, 8287, 12288, 65279,
              ],
              r = new Array(128),
              o = 0;
            o < 128;
            ++o
          )
            r[o] =
              (o >= 97 && o <= 122) ||
              (o >= 65 && o <= 90) ||
              36 === o ||
              95 === o;
          for (i = new Array(128), o = 0; o < 128; ++o)
            i[o] =
              (o >= 97 && o <= 122) ||
              (o >= 65 && o <= 90) ||
              (o >= 48 && o <= 57) ||
              36 === o ||
              95 === o;
          iD.exports = {
            isDecimalDigit: function (e) {
              return 48 <= e && e <= 57;
            },
            isHexDigit: function (e) {
              return (
                (48 <= e && e <= 57) ||
                (97 <= e && e <= 102) ||
                (65 <= e && e <= 70)
              );
            },
            isOctalDigit: function (e) {
              return e >= 48 && e <= 55;
            },
            isWhiteSpace: function (e) {
              return (
                32 === e ||
                9 === e ||
                11 === e ||
                12 === e ||
                160 === e ||
                (e >= 5760 && n.indexOf(e) >= 0)
              );
            },
            isLineTerminator: function (e) {
              return 10 === e || 13 === e || 8232 === e || 8233 === e;
            },
            isIdentifierStartES5: function (e) {
              return e < 128 ? r[e] : t.NonAsciiIdentifierStart.test(s(e));
            },
            isIdentifierPartES5: function (e) {
              return e < 128 ? i[e] : t.NonAsciiIdentifierPart.test(s(e));
            },
            isIdentifierStartES6: function (t) {
              return t < 128 ? r[t] : e.NonAsciiIdentifierStart.test(s(t));
            },
            isIdentifierPartES6: function (t) {
              return t < 128 ? i[t] : e.NonAsciiIdentifierPart.test(s(t));
            },
          };
        })();
        var oD = { exports: {} };
        !(function () {
          var e = iD.exports;
          function t(e, t) {
            return !(!t && "yield" === e) && n(e, t);
          }
          function n(e, t) {
            if (
              t &&
              (function (e) {
                switch (e) {
                  case "implements":
                  case "interface":
                  case "package":
                  case "private":
                  case "protected":
                  case "public":
                  case "static":
                  case "let":
                    return !0;
                  default:
                    return !1;
                }
              })(e)
            )
              return !0;
            switch (e.length) {
              case 2:
                return "if" === e || "in" === e || "do" === e;
              case 3:
                return "var" === e || "for" === e || "new" === e || "try" === e;
              case 4:
                return (
                  "this" === e ||
                  "else" === e ||
                  "case" === e ||
                  "void" === e ||
                  "with" === e ||
                  "enum" === e
                );
              case 5:
                return (
                  "while" === e ||
                  "break" === e ||
                  "catch" === e ||
                  "throw" === e ||
                  "const" === e ||
                  "yield" === e ||
                  "class" === e ||
                  "super" === e
                );
              case 6:
                return (
                  "return" === e ||
                  "typeof" === e ||
                  "delete" === e ||
                  "switch" === e ||
                  "export" === e ||
                  "import" === e
                );
              case 7:
                return "default" === e || "finally" === e || "extends" === e;
              case 8:
                return "function" === e || "continue" === e || "debugger" === e;
              case 10:
                return "instanceof" === e;
              default:
                return !1;
            }
          }
          function r(e, n) {
            return "null" === e || "true" === e || "false" === e || t(e, n);
          }
          function i(e, t) {
            return "null" === e || "true" === e || "false" === e || n(e, t);
          }
          function o(t) {
            var n, r, i;
            if (0 === t.length) return !1;
            if (((i = t.charCodeAt(0)), !e.isIdentifierStartES5(i))) return !1;
            for (n = 1, r = t.length; n < r; ++n)
              if (((i = t.charCodeAt(n)), !e.isIdentifierPartES5(i))) return !1;
            return !0;
          }
          function s(t) {
            var n, r, i, o, s;
            if (0 === t.length) return !1;
            for (s = e.isIdentifierStartES6, n = 0, r = t.length; n < r; ++n) {
              if (55296 <= (i = t.charCodeAt(n)) && i <= 56319) {
                if (++n >= r) return !1;
                if (!(56320 <= (o = t.charCodeAt(n)) && o <= 57343)) return !1;
                i = 1024 * (i - 55296) + (o - 56320) + 65536;
              }
              if (!s(i)) return !1;
              s = e.isIdentifierPartES6;
            }
            return !0;
          }
          oD.exports = {
            isKeywordES5: t,
            isKeywordES6: n,
            isReservedWordES5: r,
            isReservedWordES6: i,
            isRestrictedWord: function (e) {
              return "eval" === e || "arguments" === e;
            },
            isIdentifierNameES5: o,
            isIdentifierNameES6: s,
            isIdentifierES5: function (e, t) {
              return o(e) && !r(e, t);
            },
            isIdentifierES6: function (e, t) {
              return s(e) && !i(e, t);
            },
          };
        })(),
          (nD.ast = rD.exports),
          (nD.code = iD.exports),
          (nD.keyword = oD.exports);
        const sD = nD.keyword.isIdentifierNameES5,
          {
            getLast: aD,
            hasNewline: uD,
            skipWhitespace: lD,
            isNonEmptyArray: cD,
            isNextLineEmptyAfterIndex: pD,
            getStringWidth: fD,
          } = nl,
          { locStart: dD, locEnd: hD, hasSameLocStart: mD } = Vh,
          gD = "(?:(?=.)\\s)",
          yD = new RegExp("^".concat(gD, "*:")),
          vD = new RegExp("^".concat(gD, "*::"));
        function DD(e) {
          return (
            "Block" === e.type ||
            "CommentBlock" === e.type ||
            "MultiLine" === e.type
          );
        }
        function bD(e) {
          return (
            "Line" === e.type ||
            "CommentLine" === e.type ||
            "SingleLine" === e.type ||
            "HashbangComment" === e.type ||
            "HTMLOpen" === e.type ||
            "HTMLClose" === e.type
          );
        }
        const ED = new Set([
          "ExportDefaultDeclaration",
          "ExportDefaultSpecifier",
          "DeclareExportDeclaration",
          "ExportNamedDeclaration",
          "ExportAllDeclaration",
        ]);
        function CD(e) {
          return e && ED.has(e.type);
        }
        function xD(e) {
          return (
            "NumericLiteral" === e.type ||
            ("Literal" === e.type && "number" == typeof e.value)
          );
        }
        function wD(e) {
          return (
            "StringLiteral" === e.type ||
            ("Literal" === e.type && "string" == typeof e.value)
          );
        }
        function AD(e) {
          return (
            "FunctionExpression" === e.type ||
            "ArrowFunctionExpression" === e.type
          );
        }
        function SD(e) {
          return (
            PD(e) &&
            "Identifier" === e.callee.type &&
            ("async" === e.callee.name ||
              "inject" === e.callee.name ||
              "fakeAsync" === e.callee.name)
          );
        }
        function _D(e) {
          return "JSXElement" === e.type || "JSXFragment" === e.type;
        }
        function TD(e) {
          return "get" === e.kind || "set" === e.kind;
        }
        function FD(e) {
          return TD(e) || mD(e, e.value);
        }
        const kD = new Set([
            "BinaryExpression",
            "LogicalExpression",
            "NGPipeExpression",
          ]),
          OD = new Set([
            "AnyTypeAnnotation",
            "TSAnyKeyword",
            "NullLiteralTypeAnnotation",
            "TSNullKeyword",
            "ThisTypeAnnotation",
            "TSThisType",
            "NumberTypeAnnotation",
            "TSNumberKeyword",
            "VoidTypeAnnotation",
            "TSVoidKeyword",
            "BooleanTypeAnnotation",
            "TSBooleanKeyword",
            "BigIntTypeAnnotation",
            "TSBigIntKeyword",
            "SymbolTypeAnnotation",
            "TSSymbolKeyword",
            "StringTypeAnnotation",
            "TSStringKeyword",
            "BooleanLiteralTypeAnnotation",
            "StringLiteralTypeAnnotation",
            "BigIntLiteralTypeAnnotation",
            "NumberLiteralTypeAnnotation",
            "TSLiteralType",
            "TSTemplateLiteralType",
            "EmptyTypeAnnotation",
            "MixedTypeAnnotation",
            "TSNeverKeyword",
            "TSObjectKeyword",
            "TSUndefinedKeyword",
            "TSUnknownKeyword",
          ]),
          BD = /^(?:skip|[fx]?(?:it|describe|test))$/;
        function PD(e) {
          return (
            e &&
            ("CallExpression" === e.type || "OptionalCallExpression" === e.type)
          );
        }
        function ND(e) {
          return (
            e &&
            ("MemberExpression" === e.type ||
              "OptionalMemberExpression" === e.type)
          );
        }
        function MD(e) {
          return /^(?:\d+|\d+\.\d+)$/.test(e);
        }
        function ID(e) {
          return e.quasis.some((e) => e.value.raw.includes("\n"));
        }
        function jD(e) {
          return e.extra ? e.extra.raw : e.raw;
        }
        const LD = { "==": !0, "!=": !0, "===": !0, "!==": !0 },
          $D = { "*": !0, "/": !0, "%": !0 },
          RD = { ">>": !0, ">>>": !0, "<<": !0 },
          zD = {};
        for (const [e, t] of [
          ["|>"],
          ["??"],
          ["||"],
          ["&&"],
          ["|"],
          ["^"],
          ["&"],
          ["==", "===", "!=", "!=="],
          ["<", ">", "<=", ">=", "in", "instanceof"],
          [">>", "<<", ">>>"],
          ["+", "-"],
          ["*", "/", "%"],
          ["**"],
        ].entries())
          for (const n of t) zD[n] = e;
        function VD(e) {
          return zD[e];
        }
        const qD = new WeakMap();
        function WD(e) {
          if (qD.has(e)) return qD.get(e);
          const t = [];
          return (
            e.this && t.push(e.this),
            Array.isArray(e.parameters)
              ? t.push(...e.parameters)
              : Array.isArray(e.params) && t.push(...e.params),
            e.rest && t.push(e.rest),
            qD.set(e, t),
            t
          );
        }
        const UD = new WeakMap();
        function HD(e) {
          if (UD.has(e)) return UD.get(e);
          let t = e.arguments;
          return (
            "ImportExpression" === e.type &&
              ((t = [e.source]), e.attributes && t.push(e.attributes)),
            UD.set(e, t),
            t
          );
        }
        function GD(e) {
          return "prettier-ignore" === e.value.trim() && !e.unignore;
        }
        function YD(e) {
          return e && (e.prettierIgnore || ZD(e, XD.PrettierIgnore));
        }
        const XD = {
            Leading: 2,
            Trailing: 4,
            Dangling: 8,
            Block: 16,
            Line: 32,
            PrettierIgnore: 64,
            First: 128,
            Last: 256,
          },
          JD = (e, t) => {
            if (("function" == typeof e && ((t = e), (e = 0)), e || t))
              return (n, r, i) =>
                !(
                  (e & XD.Leading && !n.leading) ||
                  (e & XD.Trailing && !n.trailing) ||
                  (e & XD.Dangling && (n.leading || n.trailing)) ||
                  (e & XD.Block && !DD(n)) ||
                  (e & XD.Line && !bD(n)) ||
                  (e & XD.First && 0 !== r) ||
                  (e & XD.Last && r !== i.length - 1) ||
                  (e & XD.PrettierIgnore && !GD(n)) ||
                  (t && !t(n))
                );
          };
        function ZD(e, t, n) {
          if (!e || !cD(e.comments)) return !1;
          const r = JD(t, n);
          return !r || e.comments.some(r);
        }
        function KD(e, t, n) {
          if (!e || !Array.isArray(e.comments)) return [];
          const r = JD(t, n);
          return r ? e.comments.filter(r) : e.comments;
        }
        function QD(e) {
          return (
            PD(e) || "NewExpression" === e.type || "ImportExpression" === e.type
          );
        }
        var eb = {
          getFunctionParameters: WD,
          iterateFunctionParametersPath: function (e, t) {
            const n = e.getValue();
            let r = 0;
            const i = (e) => t(e, r++);
            n.this && e.call(i, "this"),
              Array.isArray(n.parameters)
                ? e.each(i, "parameters")
                : Array.isArray(n.params) && e.each(i, "params"),
              n.rest && e.call(i, "rest");
          },
          getCallArguments: HD,
          iterateCallArgumentsPath: function (e, t) {
            const n = e.getValue();
            "ImportExpression" === n.type
              ? (e.call((e) => t(e, 0), "source"),
                n.attributes && e.call((e) => t(e, 1), "attributes"))
              : e.each(t, "arguments");
          },
          hasRestParameter: function (e) {
            if (e.rest) return !0;
            const t = WD(e);
            return t.length > 0 && "RestElement" === aD(t).type;
          },
          getLeftSide: function (e) {
            return e.expressions
              ? e.expressions[0]
              : e.left ||
                  e.test ||
                  e.callee ||
                  e.object ||
                  e.tag ||
                  e.argument ||
                  e.expression;
          },
          getLeftSidePathName: function (e, t) {
            if (t.expressions) return ["expressions", 0];
            if (t.left) return ["left"];
            if (t.test) return ["test"];
            if (t.object) return ["object"];
            if (t.callee) return ["callee"];
            if (t.tag) return ["tag"];
            if (t.argument) return ["argument"];
            if (t.expression) return ["expression"];
            throw new Error("Unexpected node has no left side.");
          },
          getParentExportDeclaration: function (e) {
            const t = e.getParentNode();
            return "declaration" === e.getName() && CD(t) ? t : null;
          },
          getTypeScriptMappedTypeModifier: function (e, t) {
            return "+" === e ? "+" + t : "-" === e ? "-" + t : t;
          },
          hasFlowAnnotationComment: function (e) {
            return cD(e) && DD(e[0]) && vD.test(e[0].value);
          },
          hasFlowShorthandAnnotationComment: function (e) {
            return (
              e.extra &&
              e.extra.parenthesized &&
              cD(e.trailingComments) &&
              DD(e.trailingComments[0]) &&
              yD.test(e.trailingComments[0].value)
            );
          },
          hasLeadingOwnLineComment: function (e, t) {
            return _D(t) ? YD(t) : ZD(t, XD.Leading, (t) => uD(e, hD(t)));
          },
          hasNakedLeftSide: function (e) {
            return (
              "AssignmentExpression" === e.type ||
              "BinaryExpression" === e.type ||
              "LogicalExpression" === e.type ||
              "NGPipeExpression" === e.type ||
              "ConditionalExpression" === e.type ||
              PD(e) ||
              ND(e) ||
              "SequenceExpression" === e.type ||
              "TaggedTemplateExpression" === e.type ||
              "BindExpression" === e.type ||
              ("UpdateExpression" === e.type && !e.prefix) ||
              "TSAsExpression" === e.type ||
              "TSNonNullExpression" === e.type
            );
          },
          hasNode: function e(t, n) {
            if (!t || "object" != typeof t) return !1;
            if (Array.isArray(t)) return t.some((t) => e(t, n));
            const r = n(t);
            return "boolean" == typeof r
              ? r
              : Object.values(t).some((t) => e(t, n));
          },
          hasIgnoreComment: function (e) {
            return YD(e.getValue());
          },
          hasNodeIgnoreComment: YD,
          identity: function (e) {
            return e;
          },
          isBinaryish: function (e) {
            return kD.has(e.type);
          },
          isBlockComment: DD,
          isCallLikeExpression: QD,
          isEnabledHackPipeline: function (e) {
            return Boolean(e.__isUsingHackPipeline);
          },
          isLineComment: bD,
          isPrettierIgnoreComment: GD,
          isCallExpression: PD,
          isMemberExpression: ND,
          isExportDeclaration: CD,
          isFlowAnnotationComment: function (e, t) {
            const n = dD(t),
              r = lD(e, hD(t));
            return (
              !1 !== r &&
              "/*" === e.slice(n, n + 2) &&
              "*/" === e.slice(r, r + 2)
            );
          },
          isFunctionCompositionArgs: function (e) {
            if (e.length <= 1) return !1;
            let t = 0;
            for (const n of e)
              if (AD(n)) {
                if (((t += 1), t > 1)) return !0;
              } else if (PD(n))
                for (const e of n.arguments) if (AD(e)) return !0;
            return !1;
          },
          isFunctionNotation: FD,
          isFunctionOrArrowExpression: AD,
          isGetterOrSetter: TD,
          isJestEachTemplateLiteral: function (e, t) {
            const n = /^[fx]?(?:describe|it|test)$/;
            return (
              "TaggedTemplateExpression" === t.type &&
              t.quasi === e &&
              "MemberExpression" === t.tag.type &&
              "Identifier" === t.tag.property.type &&
              "each" === t.tag.property.name &&
              (("Identifier" === t.tag.object.type &&
                n.test(t.tag.object.name)) ||
                ("MemberExpression" === t.tag.object.type &&
                  "Identifier" === t.tag.object.property.type &&
                  ("only" === t.tag.object.property.name ||
                    "skip" === t.tag.object.property.name) &&
                  "Identifier" === t.tag.object.object.type &&
                  n.test(t.tag.object.object.name)))
            );
          },
          isJsxNode: _D,
          isLiteral: function (e) {
            return (
              "BooleanLiteral" === e.type ||
              "DirectiveLiteral" === e.type ||
              "Literal" === e.type ||
              "NullLiteral" === e.type ||
              "NumericLiteral" === e.type ||
              "BigIntLiteral" === e.type ||
              "DecimalLiteral" === e.type ||
              "RegExpLiteral" === e.type ||
              "StringLiteral" === e.type ||
              "TemplateLiteral" === e.type ||
              "TSTypeLiteral" === e.type ||
              "JSXText" === e.type
            );
          },
          isLongCurriedCallExpression: function (e) {
            const t = e.getValue(),
              n = e.getParentNode();
            return (
              PD(t) &&
              PD(n) &&
              n.callee === t &&
              t.arguments.length > n.arguments.length &&
              n.arguments.length > 0
            );
          },
          isSimpleCallArgument: function e(t, n) {
            if (n >= 2) return !1;
            const r = (t) => e(t, n + 1),
              i =
                ("Literal" === t.type && "regex" in t && t.regex.pattern) ||
                ("RegExpLiteral" === t.type && t.pattern);
            return (
              !(i && fD(i) > 5) &&
              ("Literal" === t.type ||
                "BigIntLiteral" === t.type ||
                "DecimalLiteral" === t.type ||
                "BooleanLiteral" === t.type ||
                "NullLiteral" === t.type ||
                "NumericLiteral" === t.type ||
                "RegExpLiteral" === t.type ||
                "StringLiteral" === t.type ||
                "Identifier" === t.type ||
                "ThisExpression" === t.type ||
                "Super" === t.type ||
                "PrivateName" === t.type ||
                "PrivateIdentifier" === t.type ||
                "ArgumentPlaceholder" === t.type ||
                "Import" === t.type ||
                ("TemplateLiteral" === t.type
                  ? t.quasis.every((e) => !e.value.raw.includes("\n")) &&
                    t.expressions.every(r)
                  : "ObjectExpression" === t.type
                  ? t.properties.every(
                      (e) =>
                        !e.computed && (e.shorthand || (e.value && r(e.value)))
                    )
                  : "ArrayExpression" === t.type
                  ? t.elements.every((e) => null === e || r(e))
                  : QD(t)
                  ? ("ImportExpression" === t.type || e(t.callee, n)) &&
                    HD(t).every(r)
                  : ND(t)
                  ? e(t.object, n) && e(t.property, n)
                  : "UnaryExpression" !== t.type ||
                    ("!" !== t.operator && "-" !== t.operator)
                  ? "TSNonNullExpression" === t.type && e(t.expression, n)
                  : e(t.argument, n)))
            );
          },
          isMemberish: function (e) {
            return ND(e) || ("BindExpression" === e.type && Boolean(e.object));
          },
          isNumericLiteral: xD,
          isSignedNumericLiteral: function (e) {
            return (
              "UnaryExpression" === e.type &&
              ("+" === e.operator || "-" === e.operator) &&
              xD(e.argument)
            );
          },
          isObjectProperty: function (e) {
            return (
              e &&
              ("ObjectProperty" === e.type ||
                ("Property" === e.type && !e.method && "init" === e.kind))
            );
          },
          isObjectType: function (e) {
            return (
              "ObjectTypeAnnotation" === e.type ||
              "TSTypeLiteral" === e.type ||
              "TSMappedType" === e.type
            );
          },
          isObjectTypePropertyAFunction: function (e) {
            return !(
              ("ObjectTypeProperty" !== e.type &&
                "ObjectTypeInternalSlot" !== e.type) ||
              "FunctionTypeAnnotation" !== e.value.type ||
              e.static ||
              FD(e)
            );
          },
          isSimpleType: function (e) {
            return !(
              !e ||
              ((("GenericTypeAnnotation" !== e.type &&
                "TSTypeReference" !== e.type) ||
                e.typeParameters) &&
                !OD.has(e.type))
            );
          },
          isSimpleNumber: MD,
          isSimpleTemplateLiteral: function (e) {
            let t = "expressions";
            "TSTemplateLiteralType" === e.type && (t = "types");
            const n = e[t];
            return (
              0 !== n.length &&
              n.every((e) => {
                if (ZD(e)) return !1;
                if ("Identifier" === e.type || "ThisExpression" === e.type)
                  return !0;
                if (ND(e)) {
                  let t = e;
                  for (; ND(t); ) {
                    if (
                      "Identifier" !== t.property.type &&
                      "Literal" !== t.property.type &&
                      "StringLiteral" !== t.property.type &&
                      "NumericLiteral" !== t.property.type
                    )
                      return !1;
                    if (((t = t.object), ZD(t))) return !1;
                  }
                  return "Identifier" === t.type || "ThisExpression" === t.type;
                }
                return !1;
              })
            );
          },
          isStringLiteral: wD,
          isStringPropSafeToUnquote: function (e, t) {
            return (
              "json" !== t.parser &&
              wD(e.key) &&
              jD(e.key).slice(1, -1) === e.key.value &&
              ((sD(e.key.value) &&
                !(
                  ("babel-ts" === t.parser && "ClassProperty" === e.type) ||
                  ("typescript" === t.parser && "PropertyDefinition" === e.type)
                )) ||
                (MD(e.key.value) &&
                  String(Number(e.key.value)) === e.key.value &&
                  ("babel" === t.parser ||
                    "espree" === t.parser ||
                    "meriyah" === t.parser ||
                    "__babel_estree" === t.parser)))
            );
          },
          isTemplateOnItsOwnLine: function (e, t) {
            return (
              (("TemplateLiteral" === e.type && ID(e)) ||
                ("TaggedTemplateExpression" === e.type && ID(e.quasi))) &&
              !uD(t, dD(e), { backwards: !0 })
            );
          },
          isTestCall: function e(t, n) {
            if ("CallExpression" !== t.type) return !1;
            if (1 === t.arguments.length) {
              if (SD(t) && n && e(n)) return AD(t.arguments[0]);
              if (
                (function (e) {
                  return (
                    "Identifier" === e.callee.type &&
                    /^(?:before|after)(?:Each|All)$/.test(e.callee.name) &&
                    1 === e.arguments.length
                  );
                })(t)
              )
                return SD(t.arguments[0]);
            } else if (
              (2 === t.arguments.length || 3 === t.arguments.length) &&
              (("Identifier" === t.callee.type && BD.test(t.callee.name)) ||
                (function (e) {
                  return (
                    ND(e.callee) &&
                    "Identifier" === e.callee.object.type &&
                    "Identifier" === e.callee.property.type &&
                    BD.test(e.callee.object.name) &&
                    ("only" === e.callee.property.name ||
                      "skip" === e.callee.property.name)
                  );
                })(t)) &&
              ((function (e) {
                return "TemplateLiteral" === e.type;
              })(t.arguments[0]) ||
                wD(t.arguments[0]))
            )
              return (
                !(t.arguments[2] && !xD(t.arguments[2])) &&
                ((2 === t.arguments.length
                  ? AD(t.arguments[1])
                  : (function (e) {
                      return (
                        "FunctionExpression" === e.type ||
                        ("ArrowFunctionExpression" === e.type &&
                          "BlockStatement" === e.body.type)
                      );
                    })(t.arguments[1]) && WD(t.arguments[1]).length <= 1) ||
                  SD(t.arguments[1]))
              );
            return !1;
          },
          isTheOnlyJsxElementInMarkdown: function (e, t) {
            if ("markdown" !== e.parentParser && "mdx" !== e.parentParser)
              return !1;
            const n = t.getNode();
            if (!n.expression || !_D(n.expression)) return !1;
            const r = t.getParentNode();
            return "Program" === r.type && 1 === r.body.length;
          },
          isTSXFile: function (e) {
            return e.filepath && /\.tsx$/i.test(e.filepath);
          },
          isTypeAnnotationAFunction: function (e) {
            return !(
              ("TypeAnnotation" !== e.type && "TSTypeAnnotation" !== e.type) ||
              "FunctionTypeAnnotation" !== e.typeAnnotation.type ||
              e.static ||
              mD(e, e.typeAnnotation)
            );
          },
          isNextLineEmpty: (e, t) => {
            let { originalText: n } = t;
            return pD(n, hD(e));
          },
          needsHardlineAfterDanglingComment: function (e) {
            if (!ZD(e)) return !1;
            const t = aD(KD(e, XD.Dangling));
            return t && !DD(t);
          },
          rawText: jD,
          shouldPrintComma: function (e) {
            let t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : "es5";
            return (
              ("es5" === e.trailingComma && "es5" === t) ||
              ("all" === e.trailingComma && ("all" === t || "es5" === t))
            );
          },
          isBitwiseOperator: function (e) {
            return Boolean(RD[e]) || "|" === e || "^" === e || "&" === e;
          },
          shouldFlatten: function (e, t) {
            return !(
              VD(t) !== VD(e) ||
              "**" === e ||
              (LD[e] && LD[t]) ||
              ("%" === t && $D[e]) ||
              ("%" === e && $D[t]) ||
              (t !== e && $D[t] && $D[e]) ||
              (RD[e] && RD[t])
            );
          },
          startsWithNoLookaheadToken: function e(t, n) {
            switch (
              (t = (function (e) {
                for (; e.left; ) e = e.left;
                return e;
              })(t)).type
            ) {
              case "FunctionExpression":
              case "ClassExpression":
              case "DoExpression":
                return n;
              case "ObjectExpression":
                return !0;
              case "MemberExpression":
              case "OptionalMemberExpression":
                return e(t.object, n);
              case "TaggedTemplateExpression":
                return "FunctionExpression" !== t.tag.type && e(t.tag, n);
              case "CallExpression":
              case "OptionalCallExpression":
                return "FunctionExpression" !== t.callee.type && e(t.callee, n);
              case "ConditionalExpression":
                return e(t.test, n);
              case "UpdateExpression":
                return !t.prefix && e(t.argument, n);
              case "BindExpression":
                return t.object && e(t.object, n);
              case "SequenceExpression":
                return e(t.expressions[0], n);
              case "TSAsExpression":
              case "TSNonNullExpression":
                return e(t.expression, n);
              default:
                return !1;
            }
          },
          getPrecedence: VD,
          hasComment: ZD,
          getComments: KD,
          CommentCheckFlags: XD,
        };
        const tb = ns,
          { getStringWidth: nb, getIndentSize: rb } = nl,
          {
            builders: {
              join: ib,
              hardline: ob,
              softline: sb,
              group: ab,
              indent: ub,
              align: lb,
              lineSuffixBoundary: cb,
              addAlignmentToDoc: pb,
            },
            printer: { printDocToString: fb },
            utils: { mapDoc: db },
          } = Vl,
          {
            isBinaryish: hb,
            isJestEachTemplateLiteral: mb,
            isSimpleTemplateLiteral: gb,
            hasComment: yb,
            isMemberExpression: vb,
          } = eb;
        function Db(e) {
          return e.replace(/([\\`]|\${)/g, "\\$1");
        }
        var bb = {
          printTemplateLiteral: function (e, t, n) {
            const r = e.getValue();
            if ("TemplateLiteral" === r.type && mb(r, e.getParentNode())) {
              const r = (function (e, t, n) {
                const r = e.getNode(),
                  i = r.quasis[0].value.raw.trim().split(/\s*\|\s*/);
                if (i.length > 1 || i.some((e) => e.length > 0)) {
                  t.__inJestEach = !0;
                  const o = e.map(n, "expressions");
                  t.__inJestEach = !1;
                  const s = [],
                    a = o.map(
                      (e) =>
                        "${" +
                        fb(
                          e,
                          Object.assign(
                            Object.assign({}, t),
                            {},
                            {
                              printWidth: Number.POSITIVE_INFINITY,
                              endOfLine: "lf",
                            }
                          )
                        ).formatted +
                        "}"
                    ),
                    u = [{ hasLineBreak: !1, cells: [] }];
                  for (let e = 1; e < r.quasis.length; e++) {
                    const t = tb(u),
                      n = a[e - 1];
                    t.cells.push(n),
                      n.includes("\n") && (t.hasLineBreak = !0),
                      r.quasis[e].value.raw.includes("\n") &&
                        u.push({ hasLineBreak: !1, cells: [] });
                  }
                  const l = Math.max(i.length, ...u.map((e) => e.cells.length)),
                    c = Array.from({ length: l }).fill(0),
                    p = [{ cells: i }, ...u.filter((e) => e.cells.length > 0)];
                  for (const { cells: e } of p.filter((e) => !e.hasLineBreak))
                    for (const [t, n] of e.entries())
                      c[t] = Math.max(c[t], nb(n));
                  return (
                    s.push(
                      cb,
                      "`",
                      ub([
                        ob,
                        ib(
                          ob,
                          p.map((e) =>
                            ib(
                              " | ",
                              e.cells.map((t, n) =>
                                e.hasLineBreak
                                  ? t
                                  : t + " ".repeat(c[n] - nb(t))
                              )
                            )
                          )
                        ),
                      ]),
                      ob,
                      "`"
                    ),
                    s
                  );
                }
              })(e, n, t);
              if (r) return r;
            }
            let i = "expressions";
            "TSTemplateLiteralType" === r.type && (i = "types");
            const o = [];
            let s = e.map(t, i);
            const a = gb(r);
            return (
              a &&
                (s = s.map(
                  (e) =>
                    fb(
                      e,
                      Object.assign(
                        Object.assign({}, n),
                        {},
                        { printWidth: Number.POSITIVE_INFINITY }
                      )
                    ).formatted
                )),
              o.push(cb, "`"),
              e.each((e) => {
                const u = e.getName();
                if ((o.push(t()), u < s.length)) {
                  const { tabWidth: t } = n,
                    l = e.getValue(),
                    c = rb(l.value.raw, t);
                  let p = s[u];
                  if (!a) {
                    const e = r[i][u];
                    (yb(e) ||
                      vb(e) ||
                      "ConditionalExpression" === e.type ||
                      "SequenceExpression" === e.type ||
                      "TSAsExpression" === e.type ||
                      hb(e)) &&
                      (p = [ub([sb, p]), sb]);
                  }
                  const f =
                    0 === c && l.value.raw.endsWith("\n")
                      ? lb(Number.NEGATIVE_INFINITY, p)
                      : pb(p, c, t);
                  o.push(ab(["${", f, cb, "}"]));
                }
              }, "quasis"),
              o.push("`"),
              o
            );
          },
          printTemplateExpressions: function (e, t) {
            return e.map(
              (e) =>
                (function (e, t) {
                  const n = e.getValue();
                  let r = t();
                  return (
                    yb(n) && (r = ab([ub([sb, r]), sb])), ["${", r, cb, "}"]
                  );
                })(e, t),
              "expressions"
            );
          },
          escapeTemplateCharacters: function (e, t) {
            return db(e, (e) =>
              "string" == typeof e
                ? t
                  ? e.replace(/(\\*)`/g, "$1$1\\`")
                  : Db(e)
                : e
            );
          },
          uncookTemplateElementValue: Db,
        };
        const {
            builders: {
              indent: Eb,
              softline: Cb,
              literalline: xb,
              dedentToRoot: wb,
            },
          } = Vl,
          { escapeTemplateCharacters: Ab } = bb;
        const { isNonEmptyArray: Sb } = nl,
          {
            builders: { indent: _b, hardline: Tb, softline: Fb },
            utils: { mapDoc: kb, replaceEndOfLine: Ob, cleanDoc: Bb },
          } = Vl,
          { printTemplateExpressions: Pb } = bb;
        const {
            builders: { indent: Nb, join: Mb, hardline: Ib },
          } = Vl,
          { escapeTemplateCharacters: jb, printTemplateExpressions: Lb } = bb;
        function $b(e) {
          const t = [];
          let n = !1;
          const r = e.map((e) => e.trim());
          for (const [e, i] of r.entries())
            "" !== i &&
              ("" === r[e - 1] && n ? t.push([Ib, i]) : t.push(i), (n = !0));
          return 0 === t.length ? null : Mb(Ib, t);
        }
        const {
            builders: { indent: Rb, line: zb, hardline: Vb, group: qb },
            utils: { mapDoc: Wb },
          } = Vl,
          { printTemplateExpressions: Ub, uncookTemplateElementValue: Hb } = bb;
        let Gb = 0;
        const {
            hasComment: Yb,
            CommentCheckFlags: Xb,
            isObjectProperty: Jb,
          } = eb,
          Zb = function (e, t, n) {
            let r = e
              .getValue()
              .quasis[0].value.raw.replace(
                /((?:\\\\)*)\\`/g,
                (e, t) => "\\".repeat(t.length / 2) + "`"
              );
            const i = (function (e) {
                const t = e.match(/^([^\S\n]*)\S/m);
                return null === t ? "" : t[1];
              })(r),
              o = "" !== i;
            o && (r = r.replace(new RegExp("^".concat(i), "gm"), ""));
            const s = Ab(
              n(
                r,
                { parser: "markdown", __inJsTemplate: !0 },
                { stripTrailingHardline: !0 }
              ),
              !0
            );
            return ["`", o ? Eb([Cb, s]) : [xb, wb(s)], Cb, "`"];
          },
          Kb = function (e, t, n) {
            const r = e.getValue(),
              i = r.quasis.map((e) => e.value.raw);
            let o = 0;
            return (function (e, t, n) {
              if (1 === t.quasis.length && !t.quasis[0].value.raw.trim())
                return "``";
              const r = (function (e, t) {
                if (!Sb(t)) return e;
                let n = 0;
                const r = kb(Bb(e), (e) =>
                  "string" == typeof e && e.includes("@prettier-placeholder")
                    ? e
                        .split(/@prettier-placeholder-(\d+)-id/)
                        .map((e, r) => (r % 2 == 0 ? Ob(e) : (n++, t[e])))
                    : e
                );
                return t.length === n ? r : null;
              })(e, n);
              if (!r) throw new Error("Couldn't insert all the expressions");
              return ["`", _b([Tb, r]), Fb, "`"];
            })(
              n(
                i.reduce(
                  (e, t, n) =>
                    0 === n
                      ? t
                      : e + "@prettier-placeholder-" + o++ + "-id" + t,
                  ""
                ),
                { parser: "scss" },
                { stripTrailingHardline: !0 }
              ),
              r,
              Pb(e, t)
            );
          },
          Qb = function (e, t, n) {
            const r = e.getValue(),
              i = r.quasis.length;
            if (1 === i && "" === r.quasis[0].value.raw.trim()) return "``";
            const o = Lb(e, t),
              s = [];
            for (let e = 0; e < i; e++) {
              const t = 0 === e,
                a = e === i - 1,
                u = r.quasis[e].value.cooked,
                l = u.split("\n"),
                c = l.length,
                p = o[e],
                f = c > 2 && "" === l[0].trim() && "" === l[1].trim(),
                d = c > 2 && "" === l[c - 1].trim() && "" === l[c - 2].trim(),
                h = l.every((e) => /^\s*(?:#[^\n\r]*)?$/.test(e));
              if (!a && /#[^\n\r]*$/.test(l[c - 1])) return null;
              let m = null;
              (m = h
                ? $b(l)
                : n(u, { parser: "graphql" }, { stripTrailingHardline: !0 })),
                m
                  ? ((m = jb(m, !1)),
                    !t && f && s.push(""),
                    s.push(m),
                    !a && d && s.push(""))
                  : t || a || !f || s.push(""),
                p && s.push(p);
            }
            return ["`", Nb([Ib, Mb(Ib, s)]), Ib, "`"];
          },
          eE = function (e, t, n, r, i) {
            let { parser: o } = i;
            const s = e.getValue(),
              a = Gb;
            Gb = (Gb + 1) >>> 0;
            const u = (e) =>
                "PRETTIER_HTML_PLACEHOLDER_".concat(e, "_").concat(a, "_IN_JS"),
              l = s.quasis
                .map((e, t, n) =>
                  t === n.length - 1 ? e.value.cooked : e.value.cooked + u(t)
                )
                .join(""),
              c = Ub(e, t);
            if (0 === c.length && 0 === l.trim().length) return "``";
            const p = new RegExp(u("(\\d+)"), "g");
            let f = 0;
            const d = n(
                l,
                {
                  parser: o,
                  __onHtmlRoot(e) {
                    f = e.children.length;
                  },
                },
                { stripTrailingHardline: !0 }
              ),
              h = Wb(d, (e) => {
                if ("string" != typeof e) return e;
                const t = [],
                  n = e.split(p);
                for (let e = 0; e < n.length; e++) {
                  let i = n[e];
                  if (e % 2 == 0) {
                    i &&
                      ((i = Hb(i)),
                      r.__embeddedInHtml &&
                        (i = i.replace(/<\/(script)\b/gi, "<\\/$1")),
                      t.push(i));
                    continue;
                  }
                  const o = Number(i);
                  t.push(c[o]);
                }
                return t;
              }),
              m = /^\s/.test(l) ? " " : "",
              g = /\s$/.test(l) ? " " : "",
              y =
                "ignore" === r.htmlWhitespaceSensitivity
                  ? Vb
                  : m && g
                  ? zb
                  : null;
            return qb(
              y
                ? ["`", Rb([y, qb(h)]), y, "`"]
                : ["`", m, f > 1 ? Rb(qb(h)) : qb(h), g, "`"]
            );
          };
        const tE = [
          (e, t) => "ObjectExpression" === e.type && "properties" === t,
          (e, t) =>
            "CallExpression" === e.type &&
            "Identifier" === e.callee.type &&
            "Component" === e.callee.name &&
            "arguments" === t,
          (e, t) => "Decorator" === e.type && "expression" === t,
        ];
        function nE(e) {
          return "Identifier" === e.type && "styled" === e.name;
        }
        function rE(e) {
          return /^[A-Z]/.test(e.object.name) && "extend" === e.property.name;
        }
        function iE(e, t) {
          return Yb(e, Xb.Block | Xb.Leading, (e) => {
            let { value: n } = e;
            return n === " ".concat(t, " ");
          });
        }
        const { isBlockComment: oE } = eb,
          sE = new Set([
            "range",
            "raw",
            "comments",
            "leadingComments",
            "trailingComments",
            "innerComments",
            "extra",
            "start",
            "end",
            "loc",
            "flags",
            "errors",
            "tokens",
          ]),
          aE = (e) => {
            for (const t of e.quasis) delete t.value;
          };
        function uE(e, t, n) {
          if (
            ("Program" === e.type && delete t.sourceType,
            ("BigIntLiteral" !== e.type &&
              "BigIntLiteralTypeAnnotation" !== e.type) ||
              (t.value && (t.value = t.value.toLowerCase())),
            ("BigIntLiteral" !== e.type && "Literal" !== e.type) ||
              (t.bigint && (t.bigint = t.bigint.toLowerCase())),
            "DecimalLiteral" === e.type && (t.value = Number(t.value)),
            "Literal" === e.type &&
              t.decimal &&
              (t.decimal = Number(t.decimal)),
            "EmptyStatement" === e.type)
          )
            return null;
          if ("JSXText" === e.type) return null;
          if (
            "JSXExpressionContainer" === e.type &&
            ("Literal" === e.expression.type ||
              "StringLiteral" === e.expression.type) &&
            " " === e.expression.value
          )
            return null;
          if (
            (("Property" !== e.type &&
              "ObjectProperty" !== e.type &&
              "MethodDefinition" !== e.type &&
              "ClassProperty" !== e.type &&
              "ClassMethod" !== e.type &&
              "PropertyDefinition" !== e.type &&
              "TSDeclareMethod" !== e.type &&
              "TSPropertySignature" !== e.type &&
              "ObjectTypeProperty" !== e.type) ||
              "object" != typeof e.key ||
              !e.key ||
              ("Literal" !== e.key.type &&
                "NumericLiteral" !== e.key.type &&
                "StringLiteral" !== e.key.type &&
                "Identifier" !== e.key.type) ||
              delete t.key,
            "JSXElement" === e.type &&
              "style" === e.openingElement.name.name &&
              e.openingElement.attributes.some((e) => "jsx" === e.name.name))
          )
            for (const { type: e, expression: n } of t.children)
              "JSXExpressionContainer" === e &&
                "TemplateLiteral" === n.type &&
                aE(n);
          "JSXAttribute" === e.type &&
            "css" === e.name.name &&
            "JSXExpressionContainer" === e.value.type &&
            "TemplateLiteral" === e.value.expression.type &&
            aE(t.value.expression),
            "JSXAttribute" === e.type &&
              e.value &&
              "Literal" === e.value.type &&
              /["']|&quot;|&apos;/.test(e.value.value) &&
              (t.value.value = t.value.value.replace(
                /["']|&quot;|&apos;/g,
                '"'
              ));
          const r = e.expression || e.callee;
          if (
            "Decorator" === e.type &&
            "CallExpression" === r.type &&
            "Component" === r.callee.name &&
            1 === r.arguments.length
          ) {
            const n = e.expression.arguments[0].properties;
            for (const [e, r] of t.expression.arguments[0].properties.entries())
              switch (n[e].key.name) {
                case "styles":
                  "ArrayExpression" === r.value.type && aE(r.value.elements[0]);
                  break;
                case "template":
                  "TemplateLiteral" === r.value.type && aE(r.value);
              }
          }
          if (
            ("TaggedTemplateExpression" !== e.type ||
              ("MemberExpression" !== e.tag.type &&
                ("Identifier" !== e.tag.type ||
                  ("gql" !== e.tag.name &&
                    "graphql" !== e.tag.name &&
                    "css" !== e.tag.name &&
                    "md" !== e.tag.name &&
                    "markdown" !== e.tag.name &&
                    "html" !== e.tag.name)) &&
                "CallExpression" !== e.tag.type) ||
              aE(t.quasi),
            "TemplateLiteral" === e.type)
          ) {
            const r =
              e.leadingComments &&
              e.leadingComments.some(
                (e) =>
                  oE(e) &&
                  ["GraphQL", "HTML"].some(
                    (t) => e.value === " ".concat(t, " ")
                  )
              );
            (r ||
              ("CallExpression" === n.type && "graphql" === n.callee.name) ||
              !e.leadingComments) &&
              aE(t);
          }
          return (
            "InterpreterDirective" === e.type && (t.value = t.value.trimEnd()),
            ("TSIntersectionType" !== e.type && "TSUnionType" !== e.type) ||
            1 !== e.types.length
              ? void 0
              : t.types[0]
          );
        }
        uE.ignoredProperties = sE;
        var lE = uE,
          cE = {},
          pE = { exports: {} };
        const fE = (e) => {
          if ("string" != typeof e) throw new TypeError("Expected a string");
          const t = e.match(/(?:\r?\n)/g) || [];
          if (0 === t.length) return;
          const n = t.filter((e) => "\r\n" === e).length;
          return n > t.length - n ? "\r\n" : "\n";
        };
        function dE() {
          const e = rf;
          return (
            (dE = function () {
              return e;
            }),
            e
          );
        }
        function hE() {
          const e = (function (e) {
            return e && e.__esModule ? e : { default: e };
          })(pE.exports);
          return (
            (hE = function () {
              return e;
            }),
            e
          );
        }
        (pE.exports = fE),
          (pE.exports.graceful = (e) =>
            ("string" == typeof e && fE(e)) || "\n"),
          Object.defineProperty(cE, "__esModule", { value: !0 }),
          (cE.extract = function (e) {
            const t = e.match(yE);
            return t ? t[0].trimLeft() : "";
          }),
          (cE.strip = function (e) {
            const t = e.match(yE);
            return t && t[0] ? e.substring(t[0].length) : e;
          }),
          (cE.parse = function (e) {
            return wE(e).pragmas;
          }),
          (cE.parseWithComments = wE),
          (cE.print = function (e) {
            let { comments: t = "", pragmas: n = {} } = e;
            const r = (0, hE().default)(t) || dE().EOL,
              i = Object.keys(n),
              o = i
                .map((e) => AE(e, n[e]))
                .reduce((e, t) => e.concat(t), [])
                .map((e) => " * " + e + r)
                .join("");
            if (!t) {
              if (0 === i.length) return "";
              if (1 === i.length && !Array.isArray(n[i[0]])) {
                const e = n[i[0]];
                return ""
                  .concat("/**", " ")
                  .concat(AE(i[0], e)[0])
                  .concat(" */");
              }
            }
            const s =
              t
                .split(r)
                .map((e) => "".concat(" *", " ").concat(e))
                .join(r) + r;
            return (
              "/**" +
              r +
              (t ? s : "") +
              (t && i.length ? " *" + r : "") +
              o +
              " */"
            );
          });
        const mE = /\*\/$/,
          gE = /^\/\*\*/,
          yE = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/,
          vE = /(^|\s+)\/\/([^\r\n]*)/g,
          DE = /^(\r?\n)+/,
          bE =
            /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g,
          EE = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g,
          CE = /(\r?\n|^) *\* ?/g,
          xE = [];
        function wE(e) {
          const t = (0, hE().default)(e) || dE().EOL;
          e = e.replace(gE, "").replace(mE, "").replace(CE, "$1");
          let n = "";
          for (; n !== e; )
            (n = e), (e = e.replace(bE, "".concat(t, "$1 $2").concat(t)));
          e = e.replace(DE, "").trimRight();
          const r = Object.create(null),
            i = e.replace(EE, "").replace(DE, "").trimRight();
          let o;
          for (; (o = EE.exec(e)); ) {
            const e = o[2].replace(vE, "");
            "string" == typeof r[o[1]] || Array.isArray(r[o[1]])
              ? (r[o[1]] = xE.concat(r[o[1]], e))
              : (r[o[1]] = e);
          }
          return { comments: i, pragmas: r };
        }
        function AE(e, t) {
          return xE.concat(t).map((t) => "@".concat(e, " ").concat(t).trim());
        }
        const { parseWithComments: SE, strip: _E, extract: TE, print: FE } = cE,
          { getShebang: kE } = nl,
          { normalizeEndOfLine: OE } = rl;
        function BE(e) {
          const t = kE(e);
          t && (e = e.slice(t.length + 1));
          const n = TE(e),
            { pragmas: r, comments: i } = SE(n);
          return { shebang: t, text: e, pragmas: r, comments: i };
        }
        var PE = {
          hasPragma: function (e) {
            const t = Object.keys(BE(e).pragmas);
            return t.includes("prettier") || t.includes("format");
          },
          insertPragma: function (e) {
            const { shebang: t, text: n, pragmas: r, comments: i } = BE(e),
              o = _E(n),
              s = FE({
                pragmas: Object.assign({ format: "" }, r),
                comments: i.trimStart(),
              });
            return (
              (t ? "".concat(t, "\n") : "") +
              OE(s) +
              (o.startsWith("\n") ? "\n" : "\n\n") +
              o
            );
          },
        };
        const {
            getLast: NE,
            hasNewline: ME,
            getNextNonSpaceNonCommentCharacterIndexWithStartIndex: IE,
            getNextNonSpaceNonCommentCharacter: jE,
            hasNewlineInRange: LE,
            addLeadingComment: $E,
            addTrailingComment: RE,
            addDanglingComment: zE,
            getNextNonSpaceNonCommentCharacterIndex: VE,
            isNonEmptyArray: qE,
          } = nl,
          {
            isBlockComment: WE,
            getFunctionParameters: UE,
            isPrettierIgnoreComment: HE,
            isJsxNode: GE,
            hasFlowShorthandAnnotationComment: YE,
            hasFlowAnnotationComment: XE,
            hasIgnoreComment: JE,
            isCallLikeExpression: ZE,
            getCallArguments: KE,
            isCallExpression: QE,
            isMemberExpression: eC,
            isObjectProperty: tC,
            getComments: nC,
            CommentCheckFlags: rC,
          } = eb,
          { locStart: iC, locEnd: oC } = Vh;
        function sC(e, t) {
          const n = (e.body || e.properties).find((e) => {
            let { type: t } = e;
            return "EmptyStatement" !== t;
          });
          n ? $E(n, t) : zE(e, t);
        }
        function aC(e, t) {
          "BlockStatement" === e.type ? sC(e, t) : $E(e, t);
        }
        function uC(e) {
          let { comment: t, followingNode: n } = e;
          return !(!n || !jC(t) || ($E(n, t), 0));
        }
        function lC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
            text: o,
          } = e;
          return !(
            !r ||
            "IfStatement" !== r.type ||
            !i ||
            (")" === jE(o, t, oC)
              ? (RE(n, t), 0)
              : n === r.consequent && i === r.alternate
              ? ("BlockStatement" === n.type ? RE(n, t) : zE(r, t), 0)
              : "BlockStatement" === i.type
              ? (sC(i, t), 0)
              : "IfStatement" === i.type
              ? (aC(i.consequent, t), 0)
              : r.consequent !== i || ($E(i, t), 0))
          );
        }
        function cC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
            text: o,
          } = e;
          return !(
            !r ||
            "WhileStatement" !== r.type ||
            !i ||
            (")" === jE(o, t, oC)
              ? (RE(n, t), 0)
              : "BlockStatement" === i.type
              ? (sC(i, t), 0)
              : r.body !== i || ($E(i, t), 0))
          );
        }
        function pC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
          } = e;
          return !(
            !r ||
            ("TryStatement" !== r.type && "CatchClause" !== r.type) ||
            !i ||
            ("CatchClause" === r.type && n
              ? (RE(n, t), 0)
              : "BlockStatement" === i.type
              ? (sC(i, t), 0)
              : "TryStatement" === i.type
              ? (aC(i.finalizer, t), 0)
              : "CatchClause" !== i.type || (aC(i.body, t), 0))
          );
        }
        function fC(e) {
          let { comment: t, enclosingNode: n, followingNode: r } = e;
          return !(!eC(n) || !r || "Identifier" !== r.type || ($E(n, t), 0));
        }
        function dC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
            text: o,
          } = e;
          const s = n && !LE(o, oC(n), iC(t));
          return !(
            (n && s) ||
            !r ||
            ("ConditionalExpression" !== r.type &&
              "TSConditionalType" !== r.type) ||
            !i ||
            ($E(i, t), 0)
          );
        }
        function hC(e) {
          let { comment: t, precedingNode: n, enclosingNode: r } = e;
          return !(
            !tC(r) ||
            !r.shorthand ||
            r.key !== n ||
            "AssignmentPattern" !== r.value.type ||
            (RE(r.value.left, t), 0)
          );
        }
        function mC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
          } = e;
          if (
            r &&
            ("ClassDeclaration" === r.type ||
              "ClassExpression" === r.type ||
              "DeclareClass" === r.type ||
              "DeclareInterface" === r.type ||
              "InterfaceDeclaration" === r.type ||
              "TSInterfaceDeclaration" === r.type)
          ) {
            if (qE(r.decorators) && (!i || "Decorator" !== i.type))
              return RE(NE(r.decorators), t), !0;
            if (r.body && i === r.body) return sC(r.body, t), !0;
            if (i)
              for (const e of ["implements", "extends", "mixins"])
                if (r[e] && i === r[e][0])
                  return (
                    !n ||
                    (n !== r.id && n !== r.typeParameters && n !== r.superClass)
                      ? zE(r, t, e)
                      : RE(n, t),
                    !0
                  );
          }
          return !1;
        }
        function gC(e) {
          let { comment: t, precedingNode: n, enclosingNode: r, text: i } = e;
          return (
            ((r &&
              n &&
              ("Property" === r.type ||
                "TSDeclareMethod" === r.type ||
                "TSAbstractMethodDefinition" === r.type) &&
              "Identifier" === n.type &&
              r.key === n &&
              ":" !== jE(i, n, oC)) ||
              !(
                !n ||
                !r ||
                "Decorator" !== n.type ||
                ("ClassMethod" !== r.type &&
                  "ClassProperty" !== r.type &&
                  "PropertyDefinition" !== r.type &&
                  "TSAbstractPropertyDefinition" !== r.type &&
                  "TSAbstractMethodDefinition" !== r.type &&
                  "TSDeclareMethod" !== r.type &&
                  "MethodDefinition" !== r.type)
              )) &&
            (RE(n, t), !0)
          );
        }
        function yC(e) {
          let { comment: t, precedingNode: n, enclosingNode: r, text: i } = e;
          return !(
            "(" !== jE(i, t, oC) ||
            !n ||
            !r ||
            ("FunctionDeclaration" !== r.type &&
              "FunctionExpression" !== r.type &&
              "ClassMethod" !== r.type &&
              "MethodDefinition" !== r.type &&
              "ObjectMethod" !== r.type) ||
            (RE(n, t), 0)
          );
        }
        function vC(e) {
          let { comment: t, enclosingNode: n, text: r } = e;
          if (!n || "ArrowFunctionExpression" !== n.type) return !1;
          const i = VE(r, t, oC);
          return !1 !== i && "=>" === r.slice(i, i + 2) && (zE(n, t), !0);
        }
        function DC(e) {
          let { comment: t, enclosingNode: n, text: r } = e;
          return !(
            ")" !== jE(r, t, oC) ||
            (n &&
            ((IC(n) && 0 === UE(n).length) || (ZE(n) && 0 === KE(n).length))
              ? (zE(n, t), 0)
              : !n ||
                ("MethodDefinition" !== n.type &&
                  "TSAbstractMethodDefinition" !== n.type) ||
                0 !== UE(n.value).length ||
                (zE(n.value, t), 0))
          );
        }
        function bC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
            text: o,
          } = e;
          if (
            n &&
            "FunctionTypeParam" === n.type &&
            r &&
            "FunctionTypeAnnotation" === r.type &&
            i &&
            "FunctionTypeParam" !== i.type
          )
            return RE(n, t), !0;
          if (
            n &&
            ("Identifier" === n.type || "AssignmentPattern" === n.type) &&
            r &&
            IC(r) &&
            ")" === jE(o, t, oC)
          )
            return RE(n, t), !0;
          if (
            r &&
            "FunctionDeclaration" === r.type &&
            i &&
            "BlockStatement" === i.type
          ) {
            const e = (() => {
              const e = UE(r);
              if (e.length > 0) return IE(o, oC(NE(e)));
              const t = IE(o, oC(r.id));
              return !1 !== t && IE(o, t + 1);
            })();
            if (iC(t) > e) return sC(i, t), !0;
          }
          return !1;
        }
        function EC(e) {
          let { comment: t, enclosingNode: n } = e;
          return !(!n || "ImportSpecifier" !== n.type || ($E(n, t), 0));
        }
        function CC(e) {
          let { comment: t, enclosingNode: n } = e;
          return !(!n || "LabeledStatement" !== n.type || ($E(n, t), 0));
        }
        function xC(e) {
          let { comment: t, enclosingNode: n } = e;
          return !(
            !n ||
            ("ContinueStatement" !== n.type && "BreakStatement" !== n.type) ||
            n.label ||
            (RE(n, t), 0)
          );
        }
        function wC(e) {
          let { comment: t, precedingNode: n, enclosingNode: r } = e;
          return (
            !!(QE(r) && n && r.callee === n && r.arguments.length > 0) &&
            ($E(r.arguments[0], t), !0)
          );
        }
        function AC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
          } = e;
          return !r ||
            ("UnionTypeAnnotation" !== r.type && "TSUnionType" !== r.type)
            ? (i &&
                ("UnionTypeAnnotation" === i.type ||
                  "TSUnionType" === i.type) &&
                HE(t) &&
                ((i.types[0].prettierIgnore = !0), (t.unignore = !0)),
              !1)
            : (HE(t) && ((i.prettierIgnore = !0), (t.unignore = !0)),
              !!n && (RE(n, t), !0));
        }
        function SC(e) {
          let { comment: t, enclosingNode: n } = e;
          return !!tC(n) && ($E(n, t), !0);
        }
        function _C(e) {
          let {
            comment: t,
            enclosingNode: n,
            followingNode: r,
            ast: i,
            isLastComment: o,
          } = e;
          return i && i.body && 0 === i.body.length
            ? (o ? zE(i, t) : $E(i, t), !0)
            : n &&
              "Program" === n.type &&
              0 === n.body.length &&
              !qE(n.directives)
            ? (o ? zE(n, t) : $E(n, t), !0)
            : !(
                !r ||
                "Program" !== r.type ||
                0 !== r.body.length ||
                !n ||
                "ModuleExpression" !== n.type ||
                (zE(r, t), 0)
              );
        }
        function TC(e) {
          let { comment: t, enclosingNode: n } = e;
          return !(
            !n ||
            ("ForInStatement" !== n.type && "ForOfStatement" !== n.type) ||
            ($E(n, t), 0)
          );
        }
        function FC(e) {
          let { comment: t, precedingNode: n, enclosingNode: r, text: i } = e;
          return (
            !!(
              n &&
              "ImportSpecifier" === n.type &&
              r &&
              "ImportDeclaration" === r.type &&
              ME(i, oC(t))
            ) && (RE(n, t), !0)
          );
        }
        function kC(e) {
          let { comment: t, enclosingNode: n } = e;
          return !(!n || "AssignmentPattern" !== n.type || ($E(n, t), 0));
        }
        function OC(e) {
          let { comment: t, enclosingNode: n } = e;
          return !(!n || "TypeAlias" !== n.type || ($E(n, t), 0));
        }
        function BC(e) {
          let { comment: t, enclosingNode: n, followingNode: r } = e;
          return !(
            !n ||
            ("VariableDeclarator" !== n.type &&
              "AssignmentExpression" !== n.type) ||
            !r ||
            ("ObjectExpression" !== r.type &&
              "ArrayExpression" !== r.type &&
              "TemplateLiteral" !== r.type &&
              "TaggedTemplateExpression" !== r.type &&
              !WE(t)) ||
            ($E(r, t), 0)
          );
        }
        function PC(e) {
          let { comment: t, enclosingNode: n, followingNode: r, text: i } = e;
          return !(
            r ||
            !n ||
            ("TSMethodSignature" !== n.type &&
              "TSDeclareFunction" !== n.type &&
              "TSAbstractMethodDefinition" !== n.type) ||
            ";" !== jE(i, t, oC) ||
            (RE(n, t), 0)
          );
        }
        function NC(e) {
          let { comment: t, enclosingNode: n, followingNode: r } = e;
          if (
            HE(t) &&
            n &&
            "TSMappedType" === n.type &&
            r &&
            "TSTypeParameter" === r.type &&
            r.constraint
          )
            return (n.prettierIgnore = !0), (t.unignore = !0), !0;
        }
        function MC(e) {
          let {
            comment: t,
            precedingNode: n,
            enclosingNode: r,
            followingNode: i,
          } = e;
          return !(
            !r ||
            "TSMappedType" !== r.type ||
            (i && "TSTypeParameter" === i.type && i.name
              ? ($E(i.name, t), 0)
              : !n ||
                "TSTypeParameter" !== n.type ||
                !n.constraint ||
                (RE(n.constraint, t), 0))
          );
        }
        function IC(e) {
          return (
            "ArrowFunctionExpression" === e.type ||
            "FunctionExpression" === e.type ||
            "FunctionDeclaration" === e.type ||
            "ObjectMethod" === e.type ||
            "ClassMethod" === e.type ||
            "TSDeclareFunction" === e.type ||
            "TSCallSignatureDeclaration" === e.type ||
            "TSConstructSignatureDeclaration" === e.type ||
            "TSMethodSignature" === e.type ||
            "TSConstructorType" === e.type ||
            "TSFunctionType" === e.type ||
            "TSDeclareMethod" === e.type
          );
        }
        function jC(e) {
          return WE(e) && "*" === e.value[0] && /@type\b/.test(e.value);
        }
        var LC = {
          handleOwnLineComment: function (e) {
            return [
              NC,
              bC,
              fC,
              lC,
              cC,
              pC,
              mC,
              EC,
              TC,
              AC,
              _C,
              FC,
              kC,
              gC,
              CC,
            ].some((t) => t(e));
          },
          handleEndOfLineComment: function (e) {
            return [
              uC,
              bC,
              dC,
              EC,
              lC,
              cC,
              pC,
              mC,
              CC,
              wC,
              SC,
              _C,
              OC,
              BC,
            ].some((t) => t(e));
          },
          handleRemainingComment: function (e) {
            return [NC, lC, cC, hC, DC, gC, _C, vC, yC, MC, xC, PC].some((t) =>
              t(e)
            );
          },
          isTypeCastComment: jC,
          getCommentChildNodes: function (e, t) {
            if (
              ("typescript" === t.parser ||
                "flow" === t.parser ||
                "espree" === t.parser ||
                "meriyah" === t.parser ||
                "__babel_estree" === t.parser) &&
              "MethodDefinition" === e.type &&
              e.value &&
              "FunctionExpression" === e.value.type &&
              0 === UE(e.value).length &&
              !e.value.returnType &&
              !qE(e.value.typeParameters) &&
              e.value.body
            )
              return [...(e.decorators || []), e.key, e.value.body];
          },
          willPrintOwnComments: function (e) {
            const t = e.getValue(),
              n = e.getParentNode();
            return (
              ((t &&
                (GE(t) ||
                  YE(t) ||
                  (QE(n) &&
                    ((e) => XE(nC(e, rC.Leading)) || XE(nC(e, rC.Trailing)))(
                      t
                    )))) ||
                (n &&
                  ("JSXSpreadAttribute" === n.type ||
                    "JSXSpreadChild" === n.type ||
                    "UnionTypeAnnotation" === n.type ||
                    "TSUnionType" === n.type ||
                    (("ClassDeclaration" === n.type ||
                      "ClassExpression" === n.type) &&
                      n.superClass === t)))) &&
              (!JE(e) ||
                "UnionTypeAnnotation" === n.type ||
                "TSUnionType" === n.type)
            );
          },
        };
        const $C = ns,
          {
            getFunctionParameters: RC,
            getLeftSidePathName: zC,
            hasFlowShorthandAnnotationComment: VC,
            hasNakedLeftSide: qC,
            hasNode: WC,
            isBitwiseOperator: UC,
            startsWithNoLookaheadToken: HC,
            shouldFlatten: GC,
            getPrecedence: YC,
            isCallExpression: XC,
            isMemberExpression: JC,
            isObjectProperty: ZC,
          } = eb;
        function KC(e, t) {
          const n = e.getParentNode();
          if (!n) return !1;
          const r = e.getName(),
            i = e.getNode();
          if (
            t.__isInHtmlInterpolation &&
            !t.bracketSpacing &&
            (function (e) {
              return "ObjectExpression" === e.type;
            })(i) &&
            QC(e)
          )
            return !0;
          if (
            (function (e) {
              return (
                "BlockStatement" === e.type ||
                "BreakStatement" === e.type ||
                "ClassBody" === e.type ||
                "ClassDeclaration" === e.type ||
                "ClassMethod" === e.type ||
                "ClassProperty" === e.type ||
                "PropertyDefinition" === e.type ||
                "ClassPrivateProperty" === e.type ||
                "ContinueStatement" === e.type ||
                "DebuggerStatement" === e.type ||
                "DeclareClass" === e.type ||
                "DeclareExportAllDeclaration" === e.type ||
                "DeclareExportDeclaration" === e.type ||
                "DeclareFunction" === e.type ||
                "DeclareInterface" === e.type ||
                "DeclareModule" === e.type ||
                "DeclareModuleExports" === e.type ||
                "DeclareVariable" === e.type ||
                "DoWhileStatement" === e.type ||
                "EnumDeclaration" === e.type ||
                "ExportAllDeclaration" === e.type ||
                "ExportDefaultDeclaration" === e.type ||
                "ExportNamedDeclaration" === e.type ||
                "ExpressionStatement" === e.type ||
                "ForInStatement" === e.type ||
                "ForOfStatement" === e.type ||
                "ForStatement" === e.type ||
                "FunctionDeclaration" === e.type ||
                "IfStatement" === e.type ||
                "ImportDeclaration" === e.type ||
                "InterfaceDeclaration" === e.type ||
                "LabeledStatement" === e.type ||
                "MethodDefinition" === e.type ||
                "ReturnStatement" === e.type ||
                "SwitchStatement" === e.type ||
                "ThrowStatement" === e.type ||
                "TryStatement" === e.type ||
                "TSDeclareFunction" === e.type ||
                "TSEnumDeclaration" === e.type ||
                "TSImportEqualsDeclaration" === e.type ||
                "TSInterfaceDeclaration" === e.type ||
                "TSModuleDeclaration" === e.type ||
                "TSNamespaceExportDeclaration" === e.type ||
                "TypeAlias" === e.type ||
                "VariableDeclaration" === e.type ||
                "WhileStatement" === e.type ||
                "WithStatement" === e.type
              );
            })(i)
          )
            return !1;
          if ("flow" !== t.parser && VC(e.getValue())) return !0;
          if ("Identifier" === i.type)
            return (
              !!(
                i.extra &&
                i.extra.parenthesized &&
                /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(i.name)
              ) ||
              ("left" === r &&
                "async" === i.name &&
                "ForOfStatement" === n.type &&
                !n.await)
            );
          switch (n.type) {
            case "ParenthesizedExpression":
              return !1;
            case "ClassDeclaration":
            case "ClassExpression":
              if (
                "superClass" === r &&
                ("ArrowFunctionExpression" === i.type ||
                  "AssignmentExpression" === i.type ||
                  "AwaitExpression" === i.type ||
                  "BinaryExpression" === i.type ||
                  "ConditionalExpression" === i.type ||
                  "LogicalExpression" === i.type ||
                  "NewExpression" === i.type ||
                  "ObjectExpression" === i.type ||
                  "ParenthesizedExpression" === i.type ||
                  "SequenceExpression" === i.type ||
                  "TaggedTemplateExpression" === i.type ||
                  "UnaryExpression" === i.type ||
                  "UpdateExpression" === i.type ||
                  "YieldExpression" === i.type ||
                  "TSNonNullExpression" === i.type)
              )
                return !0;
              break;
            case "ExportDefaultDeclaration":
              return ex(e, t) || "SequenceExpression" === i.type;
            case "Decorator":
              if ("expression" === r) {
                let e = !1,
                  n = !1,
                  r = i;
                for (; r; )
                  switch (r.type) {
                    case "MemberExpression":
                      (n = !0), (r = r.object);
                      break;
                    case "CallExpression":
                      if (n || e) return "typescript" !== t.parser;
                      (e = !0), (r = r.callee);
                      break;
                    case "Identifier":
                      return !1;
                    case "TaggedTemplateExpression":
                      return "typescript" !== t.parser;
                    default:
                      return !0;
                  }
                return !0;
              }
              break;
            case "ExpressionStatement":
              if (HC(i, !0)) return !0;
              break;
            case "ArrowFunctionExpression":
              if ("body" === r && "SequenceExpression" !== i.type && HC(i, !1))
                return !0;
          }
          switch (i.type) {
            case "UpdateExpression":
              if ("UnaryExpression" === n.type)
                return (
                  i.prefix &&
                  (("++" === i.operator && "+" === n.operator) ||
                    ("--" === i.operator && "-" === n.operator))
                );
            case "UnaryExpression":
              switch (n.type) {
                case "UnaryExpression":
                  return (
                    i.operator === n.operator &&
                    ("+" === i.operator || "-" === i.operator)
                  );
                case "BindExpression":
                case "TaggedTemplateExpression":
                case "TSNonNullExpression":
                  return !0;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return "object" === r;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return "callee" === r;
                case "BinaryExpression":
                  return "left" === r && "**" === n.operator;
                default:
                  return !1;
              }
            case "BinaryExpression":
              if ("UpdateExpression" === n.type) return !0;
              if (
                "in" === i.operator &&
                (function (e) {
                  let t = 0,
                    n = e.getValue();
                  for (; n; ) {
                    const r = e.getParentNode(t++);
                    if (r && "ForStatement" === r.type && r.init === n)
                      return !0;
                    n = r;
                  }
                  return !1;
                })(e)
              )
                return !0;
              if ("|>" === i.operator && i.extra && i.extra.parenthesized) {
                const t = e.getParentNode(1);
                if ("BinaryExpression" === t.type && "|>" === t.operator)
                  return !0;
              }
            case "TSTypeAssertion":
            case "TSAsExpression":
            case "LogicalExpression":
              switch (n.type) {
                case "TSAsExpression":
                  return "TSAsExpression" !== i.type;
                case "ConditionalExpression":
                  return "TSAsExpression" === i.type;
                case "CallExpression":
                case "NewExpression":
                case "OptionalCallExpression":
                  return "callee" === r;
                case "ClassExpression":
                case "ClassDeclaration":
                  return "superClass" === r;
                case "TSTypeAssertion":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "JSXSpreadAttribute":
                case "SpreadElement":
                case "SpreadProperty":
                case "BindExpression":
                case "AwaitExpression":
                case "TSNonNullExpression":
                case "UpdateExpression":
                  return !0;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return "object" === r;
                case "AssignmentExpression":
                case "AssignmentPattern":
                  return (
                    "left" === r &&
                    ("TSTypeAssertion" === i.type ||
                      "TSAsExpression" === i.type)
                  );
                case "LogicalExpression":
                  if ("LogicalExpression" === i.type)
                    return n.operator !== i.operator;
                case "BinaryExpression": {
                  const { operator: e, type: t } = i;
                  if (!e && "TSTypeAssertion" !== t) return !0;
                  const o = YC(e),
                    s = n.operator,
                    a = YC(s);
                  return (
                    a > o ||
                    ("right" === r && a === o) ||
                    (a === o && !GC(s, e)) ||
                    (a < o && "%" === e ? "+" === s || "-" === s : !!UC(s))
                  );
                }
                default:
                  return !1;
              }
            case "SequenceExpression":
              switch (n.type) {
                case "ReturnStatement":
                case "ForStatement":
                  return !1;
                case "ExpressionStatement":
                  return "expression" !== r;
                case "ArrowFunctionExpression":
                  return "body" !== r;
                default:
                  return !0;
              }
            case "YieldExpression":
              if (
                "UnaryExpression" === n.type ||
                "AwaitExpression" === n.type ||
                "TSAsExpression" === n.type ||
                "TSNonNullExpression" === n.type
              )
                return !0;
            case "AwaitExpression":
              switch (n.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "TSAsExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                  return !0;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return "object" === r;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return "callee" === r;
                case "ConditionalExpression":
                  return "test" === r;
                case "BinaryExpression":
                  return !(!i.argument && "|>" === n.operator);
                default:
                  return !1;
              }
            case "TSConditionalType":
              if ("extendsType" === r && "TSConditionalType" === n.type)
                return !0;
            case "TSFunctionType":
            case "TSConstructorType":
              if ("checkType" === r && "TSConditionalType" === n.type)
                return !0;
            case "TSUnionType":
            case "TSIntersectionType":
              if (
                ("TSUnionType" === n.type || "TSIntersectionType" === n.type) &&
                n.types.length > 1 &&
                (!i.types || i.types.length > 1)
              )
                return !0;
            case "TSInferType":
              if ("TSInferType" === i.type && "TSRestType" === n.type)
                return !1;
            case "TSTypeOperator":
              return (
                "TSArrayType" === n.type ||
                "TSOptionalType" === n.type ||
                "TSRestType" === n.type ||
                ("objectType" === r && "TSIndexedAccessType" === n.type) ||
                "TSTypeOperator" === n.type ||
                ("TSTypeAnnotation" === n.type &&
                  e.getParentNode(1).type.startsWith("TSJSDoc"))
              );
            case "ArrayTypeAnnotation":
              return "NullableTypeAnnotation" === n.type;
            case "IntersectionTypeAnnotation":
            case "UnionTypeAnnotation":
              return (
                "ArrayTypeAnnotation" === n.type ||
                "NullableTypeAnnotation" === n.type ||
                "IntersectionTypeAnnotation" === n.type ||
                "UnionTypeAnnotation" === n.type ||
                ("objectType" === r &&
                  ("IndexedAccessType" === n.type ||
                    "OptionalIndexedAccessType" === n.type))
              );
            case "NullableTypeAnnotation":
              return (
                "ArrayTypeAnnotation" === n.type ||
                ("objectType" === r &&
                  ("IndexedAccessType" === n.type ||
                    "OptionalIndexedAccessType" === n.type))
              );
            case "FunctionTypeAnnotation": {
              const t =
                "NullableTypeAnnotation" === n.type ? e.getParentNode(1) : n;
              return (
                "UnionTypeAnnotation" === t.type ||
                "IntersectionTypeAnnotation" === t.type ||
                "ArrayTypeAnnotation" === t.type ||
                ("objectType" === r &&
                  ("IndexedAccessType" === t.type ||
                    "OptionalIndexedAccessType" === t.type)) ||
                "NullableTypeAnnotation" === t.type ||
                ("FunctionTypeParam" === n.type &&
                  null === n.name &&
                  RC(i).some(
                    (e) =>
                      e.typeAnnotation &&
                      "NullableTypeAnnotation" === e.typeAnnotation.type
                  ))
              );
            }
            case "OptionalIndexedAccessType":
              return "objectType" === r && "IndexedAccessType" === n.type;
            case "TypeofTypeAnnotation":
              return (
                "objectType" === r &&
                ("IndexedAccessType" === n.type ||
                  "OptionalIndexedAccessType" === n.type)
              );
            case "StringLiteral":
            case "NumericLiteral":
            case "Literal":
              if (
                "string" == typeof i.value &&
                "ExpressionStatement" === n.type &&
                !n.directive
              ) {
                const t = e.getParentNode(1);
                return "Program" === t.type || "BlockStatement" === t.type;
              }
              return (
                "object" === r &&
                "MemberExpression" === n.type &&
                "number" == typeof i.value
              );
            case "AssignmentExpression": {
              const t = e.getParentNode(1);
              return (
                ("body" === r && "ArrowFunctionExpression" === n.type) ||
                (("key" !== r ||
                  ("ClassProperty" !== n.type &&
                    "PropertyDefinition" !== n.type) ||
                  !n.computed) &&
                  (("init" !== r && "update" !== r) ||
                    "ForStatement" !== n.type) &&
                  ("ExpressionStatement" === n.type
                    ? "ObjectPattern" === i.left.type
                    : !(
                        ("key" === r && "TSPropertySignature" === n.type) ||
                        "AssignmentExpression" === n.type ||
                        ("SequenceExpression" === n.type &&
                          t &&
                          "ForStatement" === t.type &&
                          (t.init === n || t.update === n)) ||
                        ("value" === r &&
                          "Property" === n.type &&
                          t &&
                          "ObjectPattern" === t.type &&
                          t.properties.includes(n)) ||
                        "NGChainedExpression" === n.type
                      )))
              );
            }
            case "ConditionalExpression":
              switch (n.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "BinaryExpression":
                case "LogicalExpression":
                case "NGPipeExpression":
                case "ExportDefaultDeclaration":
                case "AwaitExpression":
                case "JSXSpreadAttribute":
                case "TSTypeAssertion":
                case "TypeCastExpression":
                case "TSAsExpression":
                case "TSNonNullExpression":
                  return !0;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return "callee" === r;
                case "ConditionalExpression":
                  return "test" === r;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return "object" === r;
                default:
                  return !1;
              }
            case "FunctionExpression":
              switch (n.type) {
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return "callee" === r;
                case "TaggedTemplateExpression":
                  return !0;
                default:
                  return !1;
              }
            case "ArrowFunctionExpression":
              switch (n.type) {
                case "BinaryExpression":
                  return (
                    "|>" !== n.operator || (i.extra && i.extra.parenthesized)
                  );
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return "callee" === r;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return "object" === r;
                case "TSAsExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "AwaitExpression":
                case "TSTypeAssertion":
                  return !0;
                case "ConditionalExpression":
                  return "test" === r;
                default:
                  return !1;
              }
            case "ClassExpression":
              return "NewExpression" === n.type && "callee" === r;
            case "OptionalMemberExpression":
            case "OptionalCallExpression": {
              const t = e.getParentNode(1);
              if (
                ("object" === r && "MemberExpression" === n.type) ||
                ("callee" === r &&
                  ("CallExpression" === n.type ||
                    "NewExpression" === n.type)) ||
                ("TSNonNullExpression" === n.type &&
                  "MemberExpression" === t.type &&
                  t.object === n)
              )
                return !0;
            }
            case "CallExpression":
            case "MemberExpression":
            case "TaggedTemplateExpression":
            case "TSNonNullExpression":
              if (
                "callee" === r &&
                ("BindExpression" === n.type || "NewExpression" === n.type)
              ) {
                let e = i;
                for (; e; )
                  switch (e.type) {
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return !0;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                    case "BindExpression":
                      e = e.object;
                      break;
                    case "TaggedTemplateExpression":
                      e = e.tag;
                      break;
                    case "TSNonNullExpression":
                      e = e.expression;
                      break;
                    default:
                      return !1;
                  }
              }
              return !1;
            case "BindExpression":
              return (
                ("callee" === r &&
                  ("BindExpression" === n.type ||
                    "NewExpression" === n.type)) ||
                ("object" === r && JC(n))
              );
            case "NGPipeExpression":
              return !(
                "NGRoot" === n.type ||
                "NGMicrosyntaxExpression" === n.type ||
                ("ObjectProperty" === n.type &&
                  (!i.extra || !i.extra.parenthesized)) ||
                "ArrayExpression" === n.type ||
                (XC(n) && n.arguments[r] === i) ||
                ("right" === r && "NGPipeExpression" === n.type) ||
                ("property" === r && "MemberExpression" === n.type) ||
                "AssignmentExpression" === n.type
              );
            case "JSXFragment":
            case "JSXElement":
              return (
                "callee" === r ||
                ("left" === r &&
                  "BinaryExpression" === n.type &&
                  "<" === n.operator) ||
                ("ArrayExpression" !== n.type &&
                  "ArrowFunctionExpression" !== n.type &&
                  "AssignmentExpression" !== n.type &&
                  "AssignmentPattern" !== n.type &&
                  "BinaryExpression" !== n.type &&
                  "NewExpression" !== n.type &&
                  "ConditionalExpression" !== n.type &&
                  "ExpressionStatement" !== n.type &&
                  "JsExpressionRoot" !== n.type &&
                  "JSXAttribute" !== n.type &&
                  "JSXElement" !== n.type &&
                  "JSXExpressionContainer" !== n.type &&
                  "JSXFragment" !== n.type &&
                  "LogicalExpression" !== n.type &&
                  !XC(n) &&
                  !ZC(n) &&
                  "ReturnStatement" !== n.type &&
                  "ThrowStatement" !== n.type &&
                  "TypeCastExpression" !== n.type &&
                  "VariableDeclarator" !== n.type &&
                  "YieldExpression" !== n.type)
              );
            case "TypeAnnotation":
              return (
                "returnType" === r &&
                "ArrowFunctionExpression" === n.type &&
                (function (e) {
                  return WC(
                    e,
                    (e) =>
                      ("ObjectTypeAnnotation" === e.type &&
                        WC(
                          e,
                          (e) => "FunctionTypeAnnotation" === e.type || void 0
                        )) ||
                      void 0
                  );
                })(i)
              );
          }
          return !1;
        }
        function QC(e) {
          const t = e.getValue(),
            n = e.getParentNode(),
            r = e.getName();
          switch (n.type) {
            case "NGPipeExpression":
              if (
                "number" == typeof r &&
                n.arguments[r] === t &&
                n.arguments.length - 1 === r
              )
                return e.callParent(QC);
              break;
            case "ObjectProperty":
              if ("value" === r) {
                const t = e.getParentNode(1);
                return $C(t.properties) === n;
              }
              break;
            case "BinaryExpression":
            case "LogicalExpression":
              if ("right" === r) return e.callParent(QC);
              break;
            case "ConditionalExpression":
              if ("alternate" === r) return e.callParent(QC);
              break;
            case "UnaryExpression":
              if (n.prefix) return e.callParent(QC);
          }
          return !1;
        }
        function ex(e, t) {
          const n = e.getValue(),
            r = e.getParentNode();
          return "FunctionExpression" === n.type || "ClassExpression" === n.type
            ? "ExportDefaultDeclaration" === r.type || !KC(e, t)
            : !(
                !qC(n) ||
                ("ExportDefaultDeclaration" !== r.type && KC(e, t))
              ) && e.call((e) => ex(e, t), ...zC(e, n));
        }
        var tx = KC,
          nx = function (e, t) {
            switch (t.parser) {
              case "json":
              case "json5":
              case "json-stringify":
              case "__js_expression":
              case "__vue_expression":
                return Object.assign(
                  Object.assign({}, e),
                  {},
                  {
                    type: t.parser.startsWith("__")
                      ? "JsExpressionRoot"
                      : "JsonRoot",
                    node: e,
                    comments: [],
                    rootMarker: t.rootMarker,
                  }
                );
              default:
                return e;
            }
          };
        const {
          builders: { join: rx, line: ix, group: ox, softline: sx, indent: ax },
        } = Vl;
        var ux = {
          isVueEventBindingExpression: function e(t) {
            switch (t.type) {
              case "MemberExpression":
                switch (t.property.type) {
                  case "Identifier":
                  case "NumericLiteral":
                  case "StringLiteral":
                    return e(t.object);
                }
                return !1;
              case "Identifier":
                return !0;
              default:
                return !1;
            }
          },
          printHtmlBinding: function (e, t, n) {
            const r = e.getValue();
            if (
              (t.__onHtmlBindingRoot &&
                null === e.getName() &&
                t.__onHtmlBindingRoot(r, t),
              "File" === r.type)
            )
              return t.__isVueForBindingLeft
                ? e.call(
                    (e) => {
                      const t = rx([",", ix], e.map(n, "params")),
                        { params: r } = e.getValue();
                      return 1 === r.length
                        ? t
                        : ["(", ax([sx, ox(t)]), sx, ")"];
                    },
                    "program",
                    "body",
                    0
                  )
                : t.__isVueBindings
                ? e.call(
                    (e) => rx([",", ix], e.map(n, "params")),
                    "program",
                    "body",
                    0
                  )
                : void 0;
          },
        };
        const { printComments: lx } = Iy,
          { getLast: cx } = nl,
          {
            builders: {
              join: px,
              line: fx,
              softline: dx,
              group: hx,
              indent: mx,
              align: gx,
              ifBreak: yx,
              indentIfBreak: vx,
            },
            utils: { cleanDoc: Dx, getDocParts: bx, isConcat: Ex },
          } = Vl,
          {
            hasLeadingOwnLineComment: Cx,
            isBinaryish: xx,
            isJsxNode: wx,
            shouldFlatten: Ax,
            hasComment: Sx,
            CommentCheckFlags: _x,
            isCallExpression: Tx,
            isMemberExpression: Fx,
            isObjectProperty: kx,
            isEnabledHackPipeline: Ox,
          } = eb;
        let Bx = 0;
        function Px(e, t, n, r, i) {
          const o = e.getValue();
          if (!xx(o)) return [hx(t())];
          let s = [];
          Ax(o.operator, o.left.operator)
            ? (s = e.call((e) => Px(e, t, n, !0, i), "left"))
            : s.push(hx(t("left")));
          const a = Nx(o),
            u =
              ("|>" === o.operator ||
                "NGPipeExpression" === o.type ||
                ("|" === o.operator && "__vue_expression" === n.parser)) &&
              !Cx(n.originalText, o.right),
            l = "NGPipeExpression" === o.type ? "|" : o.operator,
            c =
              "NGPipeExpression" === o.type && o.arguments.length > 0
                ? hx(
                    mx([
                      dx,
                      ": ",
                      px(
                        [dx, ":", yx(" ")],
                        e.map(t, "arguments").map((e) => gx(2, hx(e)))
                      ),
                    ])
                  )
                : "";
          let p;
          if (a) p = [l, " ", t("right"), c];
          else {
            const r =
              Ox(n) && "|>" === l
                ? e.call((e) => Px(e, t, n, !0, i), "right")
                : t("right");
            p = [u ? fx : "", l, u ? " " : fx, r, c];
          }
          const f = e.getParentNode(),
            d = Sx(o.left, _x.Trailing | _x.Line),
            h =
              d ||
              (!(i && "LogicalExpression" === o.type) &&
                f.type !== o.type &&
                o.left.type !== o.type &&
                o.right.type !== o.type);
          if (
            (s.push(u ? "" : " ", h ? hx(p, { shouldBreak: d }) : p),
            r && Sx(o))
          ) {
            const t = Dx(lx(e, s, n));
            return Ex(t) || "fill" === t.type ? bx(t) : [t];
          }
          return s;
        }
        function Nx(e) {
          return (
            "LogicalExpression" === e.type &&
            (("ObjectExpression" === e.right.type &&
              e.right.properties.length > 0) ||
              ("ArrayExpression" === e.right.type &&
                e.right.elements.length > 0) ||
              !!wx(e.right))
          );
        }
        var Mx = {
          printBinaryishExpression: function (e, t, n) {
            const r = e.getValue(),
              i = e.getParentNode(),
              o = e.getParentNode(1),
              s =
                r !== i.body &&
                ("IfStatement" === i.type ||
                  "WhileStatement" === i.type ||
                  "SwitchStatement" === i.type ||
                  "DoWhileStatement" === i.type),
              a = Ox(t) && "|>" === r.operator,
              u = Px(e, n, t, !1, s);
            if (s) return u;
            if (a) return hx(u);
            if (
              (Tx(i) && i.callee === r) ||
              "UnaryExpression" === i.type ||
              (Fx(i) && !i.computed)
            )
              return hx([mx([dx, ...u]), dx]);
            const l =
                "ReturnStatement" === i.type ||
                "ThrowStatement" === i.type ||
                ("JSXExpressionContainer" === i.type &&
                  "JSXAttribute" === o.type) ||
                ("|" !== r.operator && "JsExpressionRoot" === i.type) ||
                ("NGPipeExpression" !== r.type &&
                  (("NGRoot" === i.type && "__ng_binding" === t.parser) ||
                    ("NGMicrosyntaxExpression" === i.type &&
                      "NGMicrosyntax" === o.type &&
                      1 === o.body.length))) ||
                (r === i.body && "ArrowFunctionExpression" === i.type) ||
                (r !== i.body && "ForStatement" === i.type) ||
                ("ConditionalExpression" === i.type &&
                  "ReturnStatement" !== o.type &&
                  "ThrowStatement" !== o.type &&
                  !Tx(o)) ||
                "TemplateLiteral" === i.type,
              c =
                "AssignmentExpression" === i.type ||
                "VariableDeclarator" === i.type ||
                "ClassProperty" === i.type ||
                "PropertyDefinition" === i.type ||
                "TSAbstractPropertyDefinition" === i.type ||
                "ClassPrivateProperty" === i.type ||
                kx(i),
              p = xx(r.left) && Ax(r.operator, r.left.operator);
            if (l || (Nx(r) && !p) || (!Nx(r) && c)) return hx(u);
            if (0 === u.length) return "";
            const f = wx(r.right),
              d = u.findIndex(
                (e) =>
                  "string" != typeof e &&
                  !Array.isArray(e) &&
                  "group" === e.type
              ),
              h = u.slice(0, -1 === d ? 1 : d + 1),
              m = u.slice(h.length, f ? -1 : void 0),
              g = Symbol("logicalChain-" + ++Bx),
              y = hx([...h, mx(m)], { id: g });
            if (!f) return y;
            const v = cx(u);
            return hx([y, vx(v, { groupId: g })]);
          },
          shouldInlineLogicalExpression: Nx,
        };
        const {
            builders: { join: Ix, line: jx, group: Lx },
          } = Vl,
          { hasNode: $x, hasComment: Rx, getComments: zx } = eb,
          { printBinaryishExpression: Vx } = Mx;
        function qx(e, t, n) {
          return (
            "NGMicrosyntaxKeyedExpression" === e.type &&
            "of" === e.key.name &&
            1 === t &&
            "NGMicrosyntaxLet" === n.body[0].type &&
            null === n.body[0].value
          );
        }
        var Wx = {
          printAngular: function (e, t, n) {
            const r = e.getValue();
            if (r.type.startsWith("NG"))
              switch (r.type) {
                case "NGRoot":
                  return [
                    n("node"),
                    Rx(r.node) ? " //" + zx(r.node)[0].value.trimEnd() : "",
                  ];
                case "NGPipeExpression":
                  return Vx(e, t, n);
                case "NGChainedExpression":
                  return Lx(
                    Ix(
                      [";", jx],
                      e.map(
                        (e) =>
                          (function (e) {
                            return $x(e.getValue(), (e) => {
                              switch (e.type) {
                                case void 0:
                                  return !1;
                                case "CallExpression":
                                case "OptionalCallExpression":
                                case "AssignmentExpression":
                                  return !0;
                              }
                            });
                          })(e)
                            ? n()
                            : ["(", n(), ")"],
                        "expressions"
                      )
                    )
                  );
                case "NGEmptyExpression":
                  return "";
                case "NGQuotedExpression":
                  return [r.prefix, ": ", r.value.trim()];
                case "NGMicrosyntax":
                  return e.map(
                    (e, t) => [
                      0 === t ? "" : qx(e.getValue(), t, r) ? " " : [";", jx],
                      n(),
                    ],
                    "body"
                  );
                case "NGMicrosyntaxKey":
                  return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(r.name)
                    ? r.name
                    : JSON.stringify(r.name);
                case "NGMicrosyntaxExpression":
                  return [
                    n("expression"),
                    null === r.alias ? "" : [" as ", n("alias")],
                  ];
                case "NGMicrosyntaxKeyedExpression": {
                  const t = e.getName(),
                    i = e.getParentNode(),
                    o =
                      qx(r, t, i) ||
                      (((1 === t &&
                        ("then" === r.key.name || "else" === r.key.name)) ||
                        (2 === t &&
                          "else" === r.key.name &&
                          "NGMicrosyntaxKeyedExpression" ===
                            i.body[t - 1].type &&
                          "then" === i.body[t - 1].key.name)) &&
                        "NGMicrosyntaxExpression" === i.body[0].type);
                  return [n("key"), o ? " " : ": ", n("expression")];
                }
                case "NGMicrosyntaxLet":
                  return [
                    "let ",
                    n("key"),
                    null === r.value ? "" : [" = ", n("value")],
                  ];
                case "NGMicrosyntaxAs":
                  return [n("key"), " as ", n("alias")];
                default:
                  throw new Error(
                    "Unknown Angular node type: ".concat(
                      JSON.stringify(r.type),
                      "."
                    )
                  );
              }
          },
        };
        const { printComments: Ux, printDanglingComments: Hx } = Iy,
          {
            builders: {
              line: Gx,
              hardline: Yx,
              softline: Xx,
              group: Jx,
              indent: Zx,
              conditionalGroup: Kx,
              fill: Qx,
              ifBreak: ew,
              lineSuffixBoundary: tw,
              join: nw,
            },
            utils: { willBreak: rw },
          } = Vl,
          { getLast: iw, getPreferredQuote: ow } = nl,
          {
            isJsxNode: sw,
            rawText: aw,
            isLiteral: uw,
            isCallExpression: lw,
            isStringLiteral: cw,
            isBinaryish: pw,
            hasComment: fw,
            CommentCheckFlags: dw,
            hasNodeIgnoreComment: hw,
          } = eb,
          mw = tx,
          { willPrintOwnComments: gw } = LC,
          yw = (e) => "" === e || e === Gx || e === Yx || e === Xx;
        function vw(e, t, n, r) {
          return e
            ? ""
            : ("JSXElement" === n.type && !n.closingElement) ||
              (r && "JSXElement" === r.type && !r.closingElement)
            ? 1 === t.length
              ? Xx
              : Yx
            : Xx;
        }
        function Dw(e, t, n, r) {
          return e
            ? Yx
            : 1 === t.length
            ? ("JSXElement" === n.type && !n.closingElement) ||
              (r && "JSXElement" === r.type && !r.closingElement)
              ? Yx
              : Xx
            : Yx;
        }
        function bw(e, t, n) {
          return (function (e, t, n) {
            const r = e.getParentNode();
            if (!r) return t;
            if (
              {
                ArrayExpression: !0,
                JSXAttribute: !0,
                JSXElement: !0,
                JSXExpressionContainer: !0,
                JSXFragment: !0,
                ExpressionStatement: !0,
                CallExpression: !0,
                OptionalCallExpression: !0,
                ConditionalExpression: !0,
                JsExpressionRoot: !0,
              }[r.type]
            )
              return t;
            const i = e.match(
                void 0,
                (e) => "ArrowFunctionExpression" === e.type,
                lw,
                (e) => "JSXExpressionContainer" === e.type
              ),
              o = mw(e, n);
            return Jx([o ? "" : ew("("), Zx([Xx, t]), Xx, o ? "" : ew(")")], {
              shouldBreak: i,
            });
          })(
            e,
            Ux(
              e,
              (function (e, t, n) {
                const r = e.getValue();
                if (
                  "JSXElement" === r.type &&
                  (function (e) {
                    if (0 === e.children.length) return !0;
                    if (e.children.length > 1) return !1;
                    const t = e.children[0];
                    return uw(t) && !ww(t);
                  })(r)
                )
                  return [n("openingElement"), n("closingElement")];
                const i =
                    "JSXElement" === r.type
                      ? n("openingElement")
                      : n("openingFragment"),
                  o =
                    "JSXElement" === r.type
                      ? n("closingElement")
                      : n("closingFragment");
                if (
                  1 === r.children.length &&
                  "JSXExpressionContainer" === r.children[0].type &&
                  ("TemplateLiteral" === r.children[0].expression.type ||
                    "TaggedTemplateExpression" ===
                      r.children[0].expression.type)
                )
                  return [i, ...e.map(n, "children"), o];
                r.children = r.children.map((e) =>
                  (function (e) {
                    return (
                      "JSXExpressionContainer" === e.type &&
                      uw(e.expression) &&
                      " " === e.expression.value &&
                      !fw(e.expression)
                    );
                  })(e)
                    ? { type: "JSXText", value: " ", raw: " " }
                    : e
                );
                const s = r.children.some(sw),
                  a =
                    r.children.filter(
                      (e) => "JSXExpressionContainer" === e.type
                    ).length > 1,
                  u =
                    "JSXElement" === r.type &&
                    r.openingElement.attributes.length > 1;
                let l = rw(i) || s || u || a;
                const c = "mdx" === e.getParentNode().rootMarker,
                  p = t.singleQuote ? "{' '}" : '{" "}',
                  f = c ? " " : ew([p, Xx], " "),
                  d = (function (e, t, n, r, i) {
                    const o = [];
                    return (
                      e.each((e, t, s) => {
                        const a = e.getValue();
                        if (uw(a)) {
                          const e = aw(a);
                          if (ww(a)) {
                            const n = e.split(Ew);
                            if ("" === n[0]) {
                              if ((o.push(""), n.shift(), /\n/.test(n[0]))) {
                                const e = s[t + 1];
                                o.push(Dw(i, n[1], a, e));
                              } else o.push(r);
                              n.shift();
                            }
                            let u;
                            if (
                              ("" === iw(n) && (n.pop(), (u = n.pop())),
                              0 === n.length)
                            )
                              return;
                            for (const [e, t] of n.entries())
                              e % 2 == 1 ? o.push(Gx) : o.push(t);
                            if (void 0 !== u)
                              if (/\n/.test(u)) {
                                const e = s[t + 1];
                                o.push(Dw(i, iw(o), a, e));
                              } else o.push(r);
                            else {
                              const e = s[t + 1];
                              o.push(vw(i, iw(o), a, e));
                            }
                          } else
                            /\n/.test(e)
                              ? e.match(/\n/g).length > 1 && o.push("", Yx)
                              : o.push("", r);
                        } else {
                          const e = n();
                          o.push(e);
                          const r = s[t + 1];
                          if (r && ww(r)) {
                            const e = xw(aw(r)).split(Ew)[0];
                            o.push(vw(i, e, a, r));
                          } else o.push(Yx);
                        }
                      }, "children"),
                      o
                    );
                  })(
                    e,
                    0,
                    n,
                    f,
                    r.openingElement &&
                      r.openingElement.name &&
                      "fbt" === r.openingElement.name.name
                  ),
                  h = r.children.some((e) => ww(e));
                for (let e = d.length - 2; e >= 0; e--) {
                  const t = "" === d[e] && "" === d[e + 1],
                    n = d[e] === Yx && "" === d[e + 1] && d[e + 2] === Yx,
                    r =
                      (d[e] === Xx || d[e] === Yx) &&
                      "" === d[e + 1] &&
                      d[e + 2] === f,
                    i =
                      d[e] === f &&
                      "" === d[e + 1] &&
                      (d[e + 2] === Xx || d[e + 2] === Yx),
                    o = d[e] === f && "" === d[e + 1] && d[e + 2] === f,
                    s =
                      (d[e] === Xx && "" === d[e + 1] && d[e + 2] === Yx) ||
                      (d[e] === Yx && "" === d[e + 1] && d[e + 2] === Xx);
                  (n && h) || t || r || o || s
                    ? d.splice(e, 2)
                    : i && d.splice(e + 1, 2);
                }
                for (; d.length > 0 && yw(iw(d)); ) d.pop();
                for (; d.length > 1 && yw(d[0]) && yw(d[1]); )
                  d.shift(), d.shift();
                const m = [];
                for (const [e, t] of d.entries()) {
                  if (t === f) {
                    if (1 === e && "" === d[e - 1]) {
                      if (2 === d.length) {
                        m.push(p);
                        continue;
                      }
                      m.push([p, Yx]);
                      continue;
                    }
                    if (e === d.length - 1) {
                      m.push(p);
                      continue;
                    }
                    if ("" === d[e - 1] && d[e - 2] === Yx) {
                      m.push(p);
                      continue;
                    }
                  }
                  m.push(t), rw(t) && (l = !0);
                }
                const g = h ? Qx(m) : Jx(m, { shouldBreak: !0 });
                if (c) return g;
                const y = Jx([i, Zx([Yx, g]), Yx, o]);
                return l ? y : Kx([Jx([i, ...d, o]), y]);
              })(e, t, n),
              t
            ),
            t
          );
        }
        const Ew = new RegExp("([ \n\r\t]+)"),
          Cw = new RegExp("[^ \n\r\t]"),
          xw = (e) =>
            e.replace(
              new RegExp("(?:^" + Ew.source + "|" + Ew.source + "$)"),
              ""
            );
        function ww(e) {
          return uw(e) && (Cw.test(aw(e)) || !/\n/.test(aw(e)));
        }
        var Aw = {
            hasJsxIgnoreComment: function (e) {
              const t = e.getValue(),
                n = e.getParentNode();
              if (!(n && t && sw(t) && sw(n))) return !1;
              let r = null;
              for (let e = n.children.indexOf(t); e > 0; e--) {
                const t = n.children[e - 1];
                if ("JSXText" !== t.type || ww(t)) {
                  r = t;
                  break;
                }
              }
              return (
                r &&
                "JSXExpressionContainer" === r.type &&
                "JSXEmptyExpression" === r.expression.type &&
                hw(r.expression)
              );
            },
            printJsx: function (e, t, n) {
              const r = e.getValue();
              if (r.type.startsWith("JSX"))
                switch (r.type) {
                  case "JSXAttribute":
                    return (function (e, t, n) {
                      const r = e.getValue(),
                        i = [];
                      if ((i.push(n("name")), r.value)) {
                        let e;
                        if (cw(r.value)) {
                          let n = aw(r.value)
                            .slice(1, -1)
                            .replace(/&apos;/g, "'")
                            .replace(/&quot;/g, '"');
                          const {
                            escaped: i,
                            quote: o,
                            regex: s,
                          } = ow(n, t.jsxSingleQuote ? "'" : '"');
                          (n = n.replace(s, i)), (e = [o, n, o]);
                        } else e = n("value");
                        i.push("=", e);
                      }
                      return i;
                    })(e, t, n);
                  case "JSXIdentifier":
                    return String(r.name);
                  case "JSXNamespacedName":
                    return nw(":", [n("namespace"), n("name")]);
                  case "JSXMemberExpression":
                    return nw(".", [n("object"), n("property")]);
                  case "JSXSpreadAttribute":
                  case "JSXSpreadChild":
                    return (function (e, t, n) {
                      const r = e.getValue();
                      return [
                        "{",
                        e.call(
                          (e) => {
                            const r = ["...", n()],
                              i = e.getValue();
                            return fw(i) && gw(e)
                              ? [Zx([Xx, Ux(e, r, t)]), Xx]
                              : r;
                          },
                          "JSXSpreadAttribute" === r.type
                            ? "argument"
                            : "expression"
                        ),
                        "}",
                      ];
                    })(e, t, n);
                  case "JSXExpressionContainer":
                    return (function (e, t, n) {
                      const r = e.getValue(),
                        i = e.getParentNode(0),
                        o =
                          "JSXEmptyExpression" === r.expression.type ||
                          (!fw(r.expression) &&
                            ("ArrayExpression" === r.expression.type ||
                              "ObjectExpression" === r.expression.type ||
                              "ArrowFunctionExpression" === r.expression.type ||
                              lw(r.expression) ||
                              "FunctionExpression" === r.expression.type ||
                              "TemplateLiteral" === r.expression.type ||
                              "TaggedTemplateExpression" ===
                                r.expression.type ||
                              "DoExpression" === r.expression.type ||
                              (sw(i) &&
                                ("ConditionalExpression" ===
                                  r.expression.type ||
                                  pw(r.expression)))));
                      return Jx(
                        o
                          ? ["{", n("expression"), tw, "}"]
                          : ["{", Zx([Xx, n("expression")]), Xx, tw, "}"]
                      );
                    })(e, 0, n);
                  case "JSXFragment":
                  case "JSXElement":
                    return bw(e, t, n);
                  case "JSXOpeningElement":
                    return (function (e, t, n) {
                      const r = e.getValue(),
                        i =
                          (r.name && fw(r.name)) ||
                          (r.typeParameters && fw(r.typeParameters));
                      if (r.selfClosing && 0 === r.attributes.length && !i)
                        return ["<", n("name"), n("typeParameters"), " />"];
                      if (
                        r.attributes &&
                        1 === r.attributes.length &&
                        r.attributes[0].value &&
                        cw(r.attributes[0].value) &&
                        !r.attributes[0].value.value.includes("\n") &&
                        !i &&
                        !fw(r.attributes[0])
                      )
                        return Jx([
                          "<",
                          n("name"),
                          n("typeParameters"),
                          " ",
                          ...e.map(n, "attributes"),
                          r.selfClosing ? " />" : ">",
                        ]);
                      const o =
                          r.attributes.length > 0 &&
                          fw(iw(r.attributes), dw.Trailing),
                        s =
                          (0 === r.attributes.length && !i) ||
                          ((t.bracketSameLine || t.jsxBracketSameLine) &&
                            (!i || r.attributes.length > 0) &&
                            !o),
                        a =
                          r.attributes &&
                          r.attributes.some(
                            (e) =>
                              e.value &&
                              cw(e.value) &&
                              e.value.value.includes("\n")
                          );
                      return Jx(
                        [
                          "<",
                          n("name"),
                          n("typeParameters"),
                          Zx(e.map(() => [Gx, n()], "attributes")),
                          r.selfClosing ? Gx : s ? ">" : Xx,
                          r.selfClosing ? "/>" : s ? "" : ">",
                        ],
                        { shouldBreak: a }
                      );
                    })(e, t, n);
                  case "JSXClosingElement":
                    return (function (e, t, n) {
                      const r = e.getValue(),
                        i = [];
                      i.push("</");
                      const o = n("name");
                      return (
                        fw(r.name, dw.Leading | dw.Line)
                          ? i.push(Zx([Yx, o]), Yx)
                          : fw(r.name, dw.Leading | dw.Block)
                          ? i.push(" ", o)
                          : i.push(o),
                        i.push(">"),
                        i
                      );
                    })(e, 0, n);
                  case "JSXOpeningFragment":
                  case "JSXClosingFragment":
                    return (function (e, t) {
                      const n = e.getValue(),
                        r = fw(n),
                        i = fw(n, dw.Line),
                        o = "JSXOpeningFragment" === n.type;
                      return [
                        o ? "<" : "</",
                        Zx([i ? Yx : r && !o ? " " : "", Hx(e, t, !0)]),
                        i ? Yx : "",
                        ">",
                      ];
                    })(e, t);
                  case "JSXEmptyExpression":
                    return (function (e, t) {
                      const n = e.getValue(),
                        r = fw(n, dw.Line);
                      return [Hx(e, t, !r), r ? Yx : ""];
                    })(e, t);
                  case "JSXText":
                    throw new Error("JSXTest should be handled by JSXElement");
                  default:
                    throw new Error(
                      "Unknown JSX node type: ".concat(
                        JSON.stringify(r.type),
                        "."
                      )
                    );
                }
            },
          },
          Sw = ms,
          _w = et,
          Tw = dr,
          Fw = ar,
          kw = Ms;
        ei(
          { target: "Array", proto: !0 },
          {
            flat: function () {
              var e = arguments.length ? arguments[0] : void 0,
                t = _w(this),
                n = Tw(t),
                r = kw(t, 0);
              return (
                (r.length = Sw(r, t, t, n, 0, void 0 === e ? 1 : Fw(e))), r
              );
            },
          }
        );
        var Ow,
          Bw = xr,
          Pw = wr,
          Nw =
            Object.keys ||
            function (e) {
              return Bw(e, Pw);
            },
          Mw = Ut,
          Iw = Jt,
          jw = oe,
          Lw = Nw,
          $w = k
            ? Object.defineProperties
            : function (e, t) {
                Iw(e);
                for (var n, r = jw(t), i = Lw(t), o = i.length, s = 0; o > s; )
                  Mw.f(e, (n = i[s++]), r[n]);
                return e;
              },
          Rw = fe("document", "documentElement"),
          zw = Jt,
          Vw = $w,
          qw = wr,
          Ww = xn,
          Uw = Rw,
          Hw = Pt,
          Gw = Cn("IE_PROTO"),
          Yw = function () {},
          Xw = function (e) {
            return "<script>" + e + "</script>";
          },
          Jw = function (e) {
            e.write(Xw("")), e.close();
            var t = e.parentWindow.Object;
            return (e = null), t;
          },
          Zw = function () {
            try {
              Ow = new ActiveXObject("htmlfile");
            } catch (e) {}
            Zw =
              "undefined" != typeof document
                ? document.domain && Ow
                  ? Jw(Ow)
                  : (function () {
                      var e,
                        t = Hw("iframe");
                      return (
                        (t.style.display = "none"),
                        Uw.appendChild(t),
                        (t.src = String("javascript:")),
                        (e = t.contentWindow.document).open(),
                        e.write(Xw("document.F=Object")),
                        e.close(),
                        e.F
                      );
                    })()
                : Jw(Ow);
            for (var e = qw.length; e--; ) delete Zw.prototype[qw[e]];
            return Zw();
          };
        Ww[Gw] = !0;
        var Kw =
            Object.create ||
            function (e, t) {
              var n;
              return (
                null !== e
                  ? ((Yw.prototype = zw(e)),
                    (n = new Yw()),
                    (Yw.prototype = null),
                    (n[Gw] = e))
                  : (n = Zw()),
                void 0 === t ? n : Vw(n, t)
              );
            },
          Qw = Ut,
          eA = Dt("unscopables"),
          tA = Array.prototype;
        null == tA[eA] && Qw.f(tA, eA, { configurable: !0, value: Kw(null) });
        !(function (e) {
          tA[eA][e] = !0;
        })("flat");
        const { isNonEmptyArray: nA } = nl,
          {
            builders: { indent: rA, join: iA, line: oA },
          } = Vl,
          { isFlowAnnotationComment: sA } = eb;
        function aA(e, t, n) {
          const r = e.getValue();
          if (!r.typeAnnotation) return "";
          const i = e.getParentNode(),
            o =
              r.definite ||
              (i && "VariableDeclarator" === i.type && i.definite),
            s = "DeclareFunction" === i.type && i.id === r;
          return sA(t.originalText, r.typeAnnotation)
            ? [" /*: ", n("typeAnnotation"), " */"]
            : [s ? "" : o ? "!: " : ": ", n("typeAnnotation")];
        }
        var uA = {
          printOptionalToken: function (e) {
            const t = e.getValue();
            return !t.optional ||
              ("Identifier" === t.type && t === e.getParentNode().key)
              ? ""
              : "OptionalCallExpression" === t.type ||
                ("OptionalMemberExpression" === t.type && t.computed)
              ? "?."
              : "?";
          },
          printFunctionTypeParameters: function (e, t, n) {
            const r = e.getValue();
            return r.typeArguments
              ? n("typeArguments")
              : r.typeParameters
              ? n("typeParameters")
              : "";
          },
          printBindExpressionCallee: function (e, t, n) {
            return ["::", n("callee")];
          },
          printTypeScriptModifiers: function (e, t, n) {
            const r = e.getValue();
            return nA(r.modifiers) ? [iA(" ", e.map(n, "modifiers")), " "] : "";
          },
          printTypeAnnotation: aA,
          printRestSpread: function (e, t, n) {
            return ["...", n("argument"), aA(e, t, n)];
          },
          adjustClause: function (e, t, n) {
            return "EmptyStatement" === e.type
              ? ";"
              : "BlockStatement" === e.type || n
              ? [" ", t]
              : rA([oA, t]);
          },
        };
        const { printDanglingComments: lA } = Iy,
          {
            builders: {
              line: cA,
              softline: pA,
              hardline: fA,
              group: dA,
              indent: hA,
              ifBreak: mA,
              fill: gA,
            },
          } = Vl,
          { getLast: yA, hasNewline: vA } = nl,
          {
            shouldPrintComma: DA,
            hasComment: bA,
            CommentCheckFlags: EA,
            isNextLineEmpty: CA,
            isNumericLiteral: xA,
            isSignedNumericLiteral: wA,
          } = eb,
          { locStart: AA } = Vh,
          { printOptionalToken: SA, printTypeAnnotation: _A } = uA;
        function TA(e, t) {
          return (
            e.elements.length > 1 &&
            e.elements.every(
              (e) =>
                e &&
                (xA(e) || (wA(e) && !bA(e.argument))) &&
                !bA(
                  e,
                  EA.Trailing | EA.Line,
                  (e) => !vA(t.originalText, AA(e), { backwards: !0 })
                )
            )
          );
        }
        function FA(e, t, n, r) {
          const i = [];
          let o = [];
          return (
            e.each((e) => {
              i.push(o, dA(r())),
                (o = [",", cA]),
                e.getValue() && CA(e.getValue(), t) && o.push(pA);
            }, n),
            i
          );
        }
        function kA(e, t, n, r) {
          const i = [];
          return (
            e.each((e, o, s) => {
              const a = o === s.length - 1;
              i.push([n(), a ? r : ","]),
                a ||
                  i.push(
                    CA(e.getValue(), t)
                      ? [fA, fA]
                      : bA(s[o + 1], EA.Leading | EA.Line)
                      ? fA
                      : cA
                  );
            }, "elements"),
            gA(i)
          );
        }
        var OA = {
          printArray: function (e, t, n) {
            const r = e.getValue(),
              i = [],
              o = "TupleExpression" === r.type ? "#[" : "[";
            if (0 === r.elements.length)
              bA(r, EA.Dangling)
                ? i.push(dA([o, lA(e, t), pA, "]"]))
                : i.push(o, "]");
            else {
              const s = yA(r.elements),
                a = !(s && "RestElement" === s.type),
                u = null === s,
                l = Symbol("array"),
                c =
                  !t.__inJestEach &&
                  r.elements.length > 1 &&
                  r.elements.every((e, t, n) => {
                    const r = e && e.type;
                    if ("ArrayExpression" !== r && "ObjectExpression" !== r)
                      return !1;
                    const i = n[t + 1];
                    if (i && r !== i.type) return !1;
                    const o =
                      "ArrayExpression" === r ? "elements" : "properties";
                    return e[o] && e[o].length > 1;
                  }),
                p = TA(r, t),
                f = a
                  ? u
                    ? ","
                    : DA(t)
                    ? p
                      ? mA(",", "", { groupId: l })
                      : mA(",")
                    : ""
                  : "";
              i.push(
                dA(
                  [
                    o,
                    hA([
                      pA,
                      p ? kA(e, t, n, f) : [FA(e, t, "elements", n), f],
                      lA(e, t, !0),
                    ]),
                    pA,
                    "]",
                  ],
                  { shouldBreak: c, id: l }
                )
              );
            }
            return i.push(SA(e), _A(e, t, n)), i;
          },
          printArrayItems: FA,
          isConciselyPrintedArray: TA,
        };
        const { printDanglingComments: BA } = Iy,
          { getLast: PA, getPenultimate: NA } = nl,
          {
            getFunctionParameters: MA,
            hasComment: IA,
            CommentCheckFlags: jA,
            isFunctionCompositionArgs: LA,
            isJsxNode: $A,
            isLongCurriedCallExpression: RA,
            shouldPrintComma: zA,
            getCallArguments: VA,
            iterateCallArgumentsPath: qA,
            isNextLineEmpty: WA,
            isCallExpression: UA,
            isStringLiteral: HA,
            isObjectProperty: GA,
          } = eb,
          {
            builders: {
              line: YA,
              hardline: XA,
              softline: JA,
              group: ZA,
              indent: KA,
              conditionalGroup: QA,
              ifBreak: eS,
              breakParent: tS,
            },
            utils: { willBreak: nS },
          } = Vl,
          { ArgExpansionBailout: rS } = up,
          { isConciselyPrintedArray: iS } = OA;
        function oS(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          return (
            ("ObjectExpression" === e.type &&
              (e.properties.length > 0 || IA(e))) ||
            ("ArrayExpression" === e.type &&
              (e.elements.length > 0 || IA(e))) ||
            ("TSTypeAssertion" === e.type && oS(e.expression)) ||
            ("TSAsExpression" === e.type && oS(e.expression)) ||
            "FunctionExpression" === e.type ||
            ("ArrowFunctionExpression" === e.type &&
              (!e.returnType ||
                !e.returnType.typeAnnotation ||
                "TSTypeReference" !== e.returnType.typeAnnotation.type ||
                sS(e.body)) &&
              ("BlockStatement" === e.body.type ||
                ("ArrowFunctionExpression" === e.body.type && oS(e.body, !0)) ||
                "ObjectExpression" === e.body.type ||
                "ArrayExpression" === e.body.type ||
                (!t &&
                  (UA(e.body) || "ConditionalExpression" === e.body.type)) ||
                $A(e.body))) ||
            "DoExpression" === e.type ||
            "ModuleExpression" === e.type
          );
        }
        function sS(e) {
          return (
            "BlockStatement" === e.type &&
            (e.body.some((e) => "EmptyStatement" !== e.type) ||
              IA(e, jA.Dangling))
          );
        }
        var aS = function (e, t, n) {
          const r = e.getValue(),
            i = "ImportExpression" === r.type,
            o = VA(r);
          if (0 === o.length) return ["(", BA(e, t, !0), ")"];
          if (
            (function (e) {
              return (
                2 === e.length &&
                "ArrowFunctionExpression" === e[0].type &&
                0 === MA(e[0]).length &&
                "BlockStatement" === e[0].body.type &&
                "ArrayExpression" === e[1].type &&
                !e.some((e) => IA(e))
              );
            })(o)
          )
            return ["(", n(["arguments", 0]), ", ", n(["arguments", 1]), ")"];
          let s = !1,
            a = !1;
          const u = o.length - 1,
            l = [];
          qA(e, (e, r) => {
            const i = e.getNode(),
              o = [n()];
            r === u ||
              (WA(i, t)
                ? (0 === r && (a = !0), (s = !0), o.push(",", XA, XA))
                : o.push(",", YA)),
              l.push(o);
          });
          const c =
            i || (r.callee && "Import" === r.callee.type) || !zA(t, "all")
              ? ""
              : ",";
          function p() {
            return ZA(["(", KA([YA, ...l]), c, YA, ")"], { shouldBreak: !0 });
          }
          if (s || ("Decorator" !== e.getParentNode().type && LA(o)))
            return p();
          const f = (function (e) {
              if (2 !== e.length) return !1;
              const [t, n] = e;
              return (
                !(
                  "ModuleExpression" !== t.type ||
                  !(function (e) {
                    return (
                      "ObjectExpression" === e.type &&
                      1 === e.properties.length &&
                      GA(e.properties[0]) &&
                      "Identifier" === e.properties[0].key.type &&
                      "type" === e.properties[0].key.name &&
                      HA(e.properties[0].value) &&
                      "module" === e.properties[0].value.value
                    );
                  })(n)
                ) ||
                (!IA(t) &&
                  ("FunctionExpression" === t.type ||
                    ("ArrowFunctionExpression" === t.type &&
                      "BlockStatement" === t.body.type)) &&
                  "FunctionExpression" !== n.type &&
                  "ArrowFunctionExpression" !== n.type &&
                  "ConditionalExpression" !== n.type &&
                  !oS(n))
              );
            })(o),
            d = (function (e, t) {
              const n = PA(e),
                r = NA(e);
              return (
                !IA(n, jA.Leading) &&
                !IA(n, jA.Trailing) &&
                oS(n) &&
                (!r || r.type !== n.type) &&
                (2 !== e.length ||
                  "ArrowFunctionExpression" !== r.type ||
                  "ArrayExpression" !== n.type) &&
                !(e.length > 1 && "ArrayExpression" === n.type && iS(n, t))
              );
            })(o, t);
          if (f || d) {
            if (f ? l.slice(1).some(nS) : l.slice(0, -1).some(nS)) return p();
            let t = [];
            try {
              e.try(() => {
                qA(e, (e, r) => {
                  f &&
                    0 === r &&
                    (t = [
                      [
                        n([], { expandFirstArg: !0 }),
                        l.length > 1 ? "," : "",
                        a ? XA : YA,
                        a ? XA : "",
                      ],
                      ...l.slice(1),
                    ]),
                    d &&
                      r === u &&
                      (t = [...l.slice(0, -1), n([], { expandLastArg: !0 })]);
                });
              });
            } catch (e) {
              if (e instanceof rS) return p();
              throw e;
            }
            return [
              l.some(nS) ? tS : "",
              QA([
                ["(", ...t, ")"],
                f
                  ? ["(", ZA(t[0], { shouldBreak: !0 }), ...t.slice(1), ")"]
                  : [
                      "(",
                      ...l.slice(0, -1),
                      ZA(PA(t), { shouldBreak: !0 }),
                      ")",
                    ],
                p(),
              ]),
            ];
          }
          const h = ["(", KA([JA, ...l]), eS(c), JA, ")"];
          return RA(e) ? h : ZA(h, { shouldBreak: l.some(nS) || s });
        };
        const {
            builders: { softline: uS, group: lS, indent: cS, label: pS },
          } = Vl,
          {
            isNumericLiteral: fS,
            isMemberExpression: dS,
            isCallExpression: hS,
          } = eb,
          { printOptionalToken: mS } = uA;
        function gS(e, t, n) {
          const r = n("property"),
            i = e.getValue(),
            o = mS(e);
          return i.computed
            ? !i.property || fS(i.property)
              ? [o, "[", r, "]"]
              : lS([o, "[", cS([uS, r]), uS, "]"])
            : [o, ".", r];
        }
        var yS = {
          printMemberExpression: function (e, t, n) {
            const r = e.getValue(),
              i = e.getParentNode();
            let o,
              s = 0;
            do {
              (o = e.getParentNode(s)), s++;
            } while (o && (dS(o) || "TSNonNullExpression" === o.type));
            const a = n("object"),
              u = gS(e, 0, n),
              l =
                (o &&
                  ("NewExpression" === o.type ||
                    "BindExpression" === o.type ||
                    ("AssignmentExpression" === o.type &&
                      "Identifier" !== o.left.type))) ||
                r.computed ||
                ("Identifier" === r.object.type &&
                  "Identifier" === r.property.type &&
                  !dS(i)) ||
                (("AssignmentExpression" === i.type ||
                  "VariableDeclarator" === i.type) &&
                  ((hS(r.object) && r.object.arguments.length > 0) ||
                    ("TSNonNullExpression" === r.object.type &&
                      hS(r.object.expression) &&
                      r.object.expression.arguments.length > 0) ||
                    "member-chain" === a.label));
            return pS("member-chain" === a.label ? "member-chain" : "member", [
              a,
              l ? u : lS(cS([uS, u])),
            ]);
          },
          printMemberLookup: gS,
        };
        const { printComments: vS } = Iy,
          {
            getLast: DS,
            isNextLineEmptyAfterIndex: bS,
            getNextNonSpaceNonCommentCharacterIndex: ES,
          } = nl,
          CS = tx,
          {
            isCallExpression: xS,
            isMemberExpression: wS,
            isFunctionOrArrowExpression: AS,
            isLongCurriedCallExpression: SS,
            isMemberish: _S,
            isNumericLiteral: TS,
            isSimpleCallArgument: FS,
            hasComment: kS,
            CommentCheckFlags: OS,
            isNextLineEmpty: BS,
          } = eb,
          { locEnd: PS } = Vh,
          {
            builders: {
              join: NS,
              hardline: MS,
              group: IS,
              indent: jS,
              conditionalGroup: LS,
              breakParent: $S,
              label: RS,
            },
            utils: { willBreak: zS },
          } = Vl,
          VS = aS,
          { printMemberLookup: qS } = yS,
          {
            printOptionalToken: WS,
            printFunctionTypeParameters: US,
            printBindExpressionCallee: HS,
          } = uA;
        const {
            builders: { join: GS, group: YS },
          } = Vl,
          XS = tx,
          {
            getCallArguments: JS,
            hasFlowAnnotationComment: ZS,
            isCallExpression: KS,
            isMemberish: QS,
            isStringLiteral: e_,
            isTemplateOnItsOwnLine: t_,
            isTestCall: n_,
            iterateCallArgumentsPath: r_,
          } = eb,
          i_ = function (e, t, n) {
            const r = e.getParentNode(),
              i = !r || "ExpressionStatement" === r.type,
              o = [];
            function s(e) {
              const { originalText: n } = t,
                r = ES(n, e, PS);
              return ")" === n.charAt(r) ? !1 !== r && bS(n, r + 1) : BS(e, t);
            }
            function a(e) {
              const r = e.getValue();
              xS(r) && (_S(r.callee) || xS(r.callee))
                ? (o.unshift({
                    node: r,
                    printed: [
                      vS(e, [WS(e), US(e, t, n), VS(e, t, n)], t),
                      s(r) ? MS : "",
                    ],
                  }),
                  e.call((e) => a(e), "callee"))
                : _S(r)
                ? (o.unshift({
                    node: r,
                    needsParens: CS(e, t),
                    printed: vS(e, wS(r) ? qS(e, t, n) : HS(e, t, n), t),
                  }),
                  e.call((e) => a(e), "object"))
                : "TSNonNullExpression" === r.type
                ? (o.unshift({ node: r, printed: vS(e, "!", t) }),
                  e.call((e) => a(e), "expression"))
                : o.unshift({ node: r, printed: n() });
            }
            const u = e.getValue();
            o.unshift({ node: u, printed: [WS(e), US(e, t, n), VS(e, t, n)] }),
              u.callee && e.call((e) => a(e), "callee");
            const l = [];
            let c = [o[0]],
              p = 1;
            for (
              ;
              p < o.length &&
              ("TSNonNullExpression" === o[p].node.type ||
                xS(o[p].node) ||
                (wS(o[p].node) &&
                  o[p].node.computed &&
                  TS(o[p].node.property)));
              ++p
            )
              c.push(o[p]);
            if (!xS(o[0].node))
              for (
                ;
                p + 1 < o.length && _S(o[p].node) && _S(o[p + 1].node);
                ++p
              )
                c.push(o[p]);
            l.push(c), (c = []);
            let f = !1;
            for (; p < o.length; ++p) {
              if (f && _S(o[p].node)) {
                if (o[p].node.computed && TS(o[p].node.property)) {
                  c.push(o[p]);
                  continue;
                }
                l.push(c), (c = []), (f = !1);
              }
              (xS(o[p].node) || "ImportExpression" === o[p].node.type) &&
                (f = !0),
                c.push(o[p]),
                kS(o[p].node, OS.Trailing) && (l.push(c), (c = []), (f = !1));
            }
            function d(e) {
              return /^[A-Z]|^[$_]+$/.test(e);
            }
            c.length > 0 && l.push(c);
            const h =
              l.length >= 2 &&
              !kS(l[1][0].node) &&
              (function (e) {
                const n = e[1].length > 0 && e[1][0].node.computed;
                if (1 === e[0].length) {
                  const r = e[0][0].node;
                  return (
                    "ThisExpression" === r.type ||
                    ("Identifier" === r.type &&
                      (d(r.name) ||
                        (i &&
                          (function (e) {
                            return e.length <= t.tabWidth;
                          })(r.name)) ||
                        n))
                  );
                }
                const r = DS(e[0]).node;
                return (
                  wS(r) &&
                  "Identifier" === r.property.type &&
                  (d(r.property.name) || n)
                );
              })(l);
            function m(e) {
              const t = e.map((e) => e.printed);
              return e.length > 0 && DS(e).needsParens ? ["(", ...t, ")"] : t;
            }
            const g = l.map(m),
              y = g,
              v = h ? 3 : 2,
              D = l.flat(),
              b =
                D.slice(1, -1).some((e) => kS(e.node, OS.Leading)) ||
                D.slice(0, -1).some((e) => kS(e.node, OS.Trailing)) ||
                (l[v] && kS(l[v][0].node, OS.Leading));
            if (l.length <= v && !b) return SS(e) ? y : IS(y);
            const E = DS(l[h ? 1 : 0]).node,
              C = !xS(E) && s(E),
              x = [
                m(l[0]),
                h ? l.slice(1, 2).map(m) : "",
                C ? MS : "",
                (function (e) {
                  return 0 === e.length ? "" : jS(IS([MS, NS(MS, e.map(m))]));
                })(l.slice(h ? 2 : 1)),
              ],
              w = o
                .map((e) => {
                  let { node: t } = e;
                  return t;
                })
                .filter(xS);
            let A;
            return (
              (A =
                b ||
                (w.length > 2 &&
                  w.some((e) => !e.arguments.every((e) => FS(e, 0)))) ||
                g.slice(0, -1).some(zS) ||
                (function () {
                  const e = DS(DS(l)).node,
                    t = DS(g);
                  return (
                    xS(e) &&
                    zS(t) &&
                    w.slice(0, -1).some((e) => e.arguments.some(AS))
                  );
                })()
                  ? IS(x)
                  : [zS(y) || C ? $S : "", LS([y, x])]),
              RS("member-chain", A)
            );
          },
          o_ = aS,
          { printOptionalToken: s_, printFunctionTypeParameters: a_ } = uA;
        var u_ = {
          printCallExpression: function (e, t, n) {
            const r = e.getValue(),
              i = e.getParentNode(),
              o = "NewExpression" === r.type,
              s = "ImportExpression" === r.type,
              a = s_(e),
              u = JS(r);
            if (
              u.length > 0 &&
              ((!s &&
                !o &&
                (function (e, t) {
                  if ("Identifier" !== e.callee.type) return !1;
                  if ("require" === e.callee.name) return !0;
                  if ("define" === e.callee.name) {
                    const n = JS(e);
                    return (
                      "ExpressionStatement" === t.type &&
                      (1 === n.length ||
                        (2 === n.length && "ArrayExpression" === n[0].type) ||
                        (3 === n.length &&
                          e_(n[0]) &&
                          "ArrayExpression" === n[1].type))
                    );
                  }
                  return !1;
                })(r, i)) ||
                (1 === u.length && t_(u[0], t.originalText)) ||
                (!o && n_(r, i)))
            ) {
              const r = [];
              return (
                r_(e, () => {
                  r.push(n());
                }),
                [
                  o ? "new " : "",
                  n("callee"),
                  a,
                  a_(e, t, n),
                  "(",
                  GS(", ", r),
                  ")",
                ]
              );
            }
            const l =
              ("babel" === t.parser || "babel-flow" === t.parser) &&
              r.callee &&
              "Identifier" === r.callee.type &&
              ZS(r.callee.trailingComments);
            if (
              (l && (r.callee.trailingComments[0].printed = !0),
              !s && !o && QS(r.callee) && !e.call((e) => XS(e, t), "callee"))
            )
              return i_(e, t, n);
            const c = [
              o ? "new " : "",
              s ? "import" : n("callee"),
              a,
              l
                ? "/*:: ".concat(
                    r.callee.trailingComments[0].value.slice(2).trim(),
                    " */"
                  )
                : "",
              a_(e, t, n),
              o_(e, t, n),
            ];
            return s || KS(r.callee) ? YS(c) : c;
          },
        };
        const { isNonEmptyArray: l_, getStringWidth: c_ } = nl,
          {
            builders: { line: p_, group: f_, indent: d_, indentIfBreak: h_ },
            utils: { cleanDoc: m_, willBreak: g_, canBreak: y_ },
          } = Vl,
          {
            hasLeadingOwnLineComment: v_,
            isBinaryish: D_,
            isStringLiteral: b_,
            isLiteral: E_,
            isNumericLiteral: C_,
            isCallExpression: x_,
            isMemberExpression: w_,
            getCallArguments: A_,
            rawText: S_,
            hasComment: __,
            isSignedNumericLiteral: T_,
            isObjectProperty: F_,
          } = eb,
          { shouldInlineLogicalExpression: k_ } = Mx,
          { printCallExpression: O_ } = u_;
        function B_(e, t, n, r, i, o) {
          const s = (function (e, t, n, r, i) {
              const o = e.getValue(),
                s = o[i];
              if (!s) return "only-left";
              const a = !P_(s);
              if (
                e.match(
                  P_,
                  N_,
                  (e) =>
                    !a ||
                    ("ExpressionStatement" !== e.type &&
                      "VariableDeclaration" !== e.type)
                )
              )
                return a
                  ? "ArrowFunctionExpression" === s.type &&
                    "ArrowFunctionExpression" === s.body.type
                    ? "chain-tail-arrow-chain"
                    : "chain-tail"
                  : "chain";
              if ((!a && P_(s.right)) || v_(t.originalText, s))
                return "break-after-operator";
              if (
                ("CallExpression" === s.type && "require" === s.callee.name) ||
                "json5" === t.parser ||
                "json" === t.parser
              )
                return "never-break-after-operator";
              if (
                (function (e) {
                  if (N_(e)) {
                    const t = e.left || e.id;
                    return (
                      "ObjectPattern" === t.type &&
                      t.properties.length > 2 &&
                      t.properties.some(
                        (e) =>
                          F_(e) &&
                          (!e.shorthand ||
                            (e.value && "AssignmentPattern" === e.value.type))
                      )
                    );
                  }
                  return !1;
                })(o) ||
                (function (e) {
                  const t = (function (e) {
                    return (function (e) {
                      return (
                        "TSTypeAliasDeclaration" === e.type ||
                        "TypeAlias" === e.type
                      );
                    })(e) &&
                      e.typeParameters &&
                      e.typeParameters.params
                      ? e.typeParameters.params
                      : null;
                  })(e);
                  if (l_(t)) {
                    const n =
                      "TSTypeAliasDeclaration" === e.type
                        ? "constraint"
                        : "bound";
                    if (t.length > 1 && t.some((e) => e[n] || e.default))
                      return !0;
                  }
                  return !1;
                })(o) ||
                (function (e) {
                  if ("VariableDeclarator" !== e.type) return !1;
                  const { typeAnnotation: t } = e.id;
                  if (!t || !t.typeAnnotation) return !1;
                  const n = I_(t.typeAnnotation);
                  return (
                    l_(n) &&
                    n.length > 1 &&
                    n.some((e) => l_(I_(e)) || "TSConditionalType" === e.type)
                  );
                })(o) ||
                (M_(o) && y_(r))
              )
                return "break-lhs";
              const u = (function (e, t, n) {
                if (!F_(e)) return !1;
                return "string" == typeof (t = m_(t)) && c_(t) < n.tabWidth + 3;
              })(o, r, t);
              return e.call(
                () =>
                  (function (e, t, n, r) {
                    const i = e.getValue();
                    if (D_(i) && !k_(i)) return !0;
                    switch (i.type) {
                      case "StringLiteralTypeAnnotation":
                      case "SequenceExpression":
                        return !0;
                      case "ConditionalExpression": {
                        const { test: e } = i;
                        return D_(e) && !k_(e);
                      }
                      case "ClassExpression":
                        return l_(i.decorators);
                    }
                    if (r) return !1;
                    let o = i;
                    const s = [];
                    for (;;)
                      if ("UnaryExpression" === o.type)
                        (o = o.argument), s.push("argument");
                      else {
                        if ("TSNonNullExpression" !== o.type) break;
                        (o = o.expression), s.push("expression");
                      }
                    return !(!b_(o) && !e.call(() => j_(e, t, n), ...s));
                  })(e, t, n, u),
                i
              )
                ? "break-after-operator"
                : u ||
                  "TemplateLiteral" === s.type ||
                  "TaggedTemplateExpression" === s.type ||
                  "BooleanLiteral" === s.type ||
                  C_(s) ||
                  "ClassExpression" === s.type
                ? "never-break-after-operator"
                : "fluid";
            })(e, t, n, r, o),
            a = n(o, { assignmentLayout: s });
          switch (s) {
            case "break-after-operator":
              return f_([f_(r), i, f_(d_([p_, a]))]);
            case "never-break-after-operator":
              return f_([f_(r), i, " ", a]);
            case "fluid": {
              const e = Symbol("assignment");
              return f_([
                f_(r),
                i,
                f_(d_(p_), { id: e }),
                h_(a, { groupId: e }),
              ]);
            }
            case "break-lhs":
              return f_([r, i, " ", f_(a)]);
            case "chain":
              return [f_(r), i, p_, a];
            case "chain-tail":
              return [f_(r), i, d_([p_, a])];
            case "chain-tail-arrow-chain":
              return [f_(r), i, a];
            case "only-left":
              return r;
          }
        }
        function P_(e) {
          return "AssignmentExpression" === e.type;
        }
        function N_(e) {
          return P_(e) || "VariableDeclarator" === e.type;
        }
        function M_(e) {
          return (
            "VariableDeclarator" === e.type &&
            e.init &&
            "ArrowFunctionExpression" === e.init.type
          );
        }
        function I_(e) {
          return (function (e) {
            return (
              "TSTypeReference" === e.type || "GenericTypeAnnotation" === e.type
            );
          })(e) &&
            e.typeParameters &&
            e.typeParameters.params
            ? e.typeParameters.params
            : null;
        }
        function j_(e, t, n) {
          let r =
            arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          const i = e.getValue(),
            o = () => j_(e, t, n, !0);
          if ("TSNonNullExpression" === i.type) return e.call(o, "expression");
          if (x_(i)) {
            if ("member-chain" === O_(e, t, n).label) return !1;
            const r = A_(i);
            return (
              !!(0 === r.length || (1 === r.length && L_(r[0], t))) &&
              !$_(i, n) &&
              e.call(o, "callee")
            );
          }
          return w_(i)
            ? e.call(o, "object")
            : r && ("Identifier" === i.type || "ThisExpression" === i.type);
        }
        function L_(e, t) {
          let { printWidth: n } = t;
          if (__(e)) return !1;
          const r = 0.25 * n;
          if (
            "ThisExpression" === e.type ||
            ("Identifier" === e.type && e.name.length <= r) ||
            (T_(e) && !__(e.argument))
          )
            return !0;
          const i =
            ("Literal" === e.type && "regex" in e && e.regex.pattern) ||
            ("RegExpLiteral" === e.type && e.pattern);
          return i
            ? i.length <= r
            : b_(e)
            ? S_(e).length <= r
            : "TemplateLiteral" === e.type
            ? 0 === e.expressions.length &&
              e.quasis[0].value.raw.length <= r &&
              !e.quasis[0].value.raw.includes("\n")
            : E_(e);
        }
        function $_(e, t) {
          const n = (function (e) {
            return (
              (e.typeParameters && e.typeParameters.params) ||
              (e.typeArguments && e.typeArguments.params)
            );
          })(e);
          if (l_(n)) {
            if (n.length > 1) return !0;
            if (1 === n.length) {
              const e = n[0];
              if (
                "TSUnionType" === e.type ||
                "UnionTypeAnnotation" === e.type ||
                "TSIntersectionType" === e.type ||
                "IntersectionTypeAnnotation" === e.type
              )
                return !0;
            }
            const r = e.typeParameters ? "typeParameters" : "typeArguments";
            if (g_(t(r))) return !0;
          }
          return !1;
        }
        var R_ = {
          printVariableDeclarator: function (e, t, n) {
            return B_(e, t, n, n("id"), " =", "init");
          },
          printAssignmentExpression: function (e, t, n) {
            const r = e.getValue();
            return B_(e, t, n, n("left"), [" ", r.operator], "right");
          },
          printAssignment: B_,
          isArrowFunctionVariableDeclarator: M_,
        };
        const { getNextNonSpaceNonCommentCharacter: z_ } = nl,
          { printDanglingComments: V_ } = Iy,
          {
            builders: {
              line: q_,
              hardline: W_,
              softline: U_,
              group: H_,
              indent: G_,
              ifBreak: Y_,
            },
            utils: { removeLines: X_, willBreak: J_ },
          } = Vl,
          {
            getFunctionParameters: Z_,
            iterateFunctionParametersPath: K_,
            isSimpleType: Q_,
            isTestCall: eT,
            isTypeAnnotationAFunction: tT,
            isObjectType: nT,
            isObjectTypePropertyAFunction: rT,
            hasRestParameter: iT,
            shouldPrintComma: oT,
            hasComment: sT,
            isNextLineEmpty: aT,
          } = eb,
          { locEnd: uT } = Vh,
          { ArgExpansionBailout: lT } = up,
          { printFunctionTypeParameters: cT } = uA;
        function pT(e) {
          if (!e) return !1;
          const t = Z_(e);
          if (1 !== t.length) return !1;
          const [n] = t;
          return (
            !sT(n) &&
            ("ObjectPattern" === n.type ||
              "ArrayPattern" === n.type ||
              ("Identifier" === n.type &&
                n.typeAnnotation &&
                ("TypeAnnotation" === n.typeAnnotation.type ||
                  "TSTypeAnnotation" === n.typeAnnotation.type) &&
                nT(n.typeAnnotation.typeAnnotation)) ||
              ("FunctionTypeParam" === n.type && nT(n.typeAnnotation)) ||
              ("AssignmentPattern" === n.type &&
                ("ObjectPattern" === n.left.type ||
                  "ArrayPattern" === n.left.type) &&
                ("Identifier" === n.right.type ||
                  ("ObjectExpression" === n.right.type &&
                    0 === n.right.properties.length) ||
                  ("ArrayExpression" === n.right.type &&
                    0 === n.right.elements.length))))
          );
        }
        var fT = {
          printFunctionParameters: function (e, t, n, r, i) {
            const o = e.getValue(),
              s = Z_(o),
              a = i ? cT(e, n, t) : "";
            if (0 === s.length)
              return [
                a,
                "(",
                V_(e, n, !0, (e) => ")" === z_(n.originalText, e, uT)),
                ")",
              ];
            const u = e.getParentNode(),
              l = eT(u),
              c = pT(o),
              p = [];
            if (
              (K_(e, (e, r) => {
                const i = r === s.length - 1;
                i && o.rest && p.push("..."),
                  p.push(t()),
                  i ||
                    (p.push(","),
                    l || c
                      ? p.push(" ")
                      : aT(s[r], n)
                      ? p.push(W_, W_)
                      : p.push(q_));
              }),
              r)
            ) {
              if (J_(a) || J_(p)) throw new lT();
              return H_([X_(a), "(", X_(p), ")"]);
            }
            const f = s.every((e) => !e.decorators);
            return (c && f) || l
              ? [a, "(", ...p, ")"]
              : (rT(u) ||
                  tT(u) ||
                  "TypeAlias" === u.type ||
                  "UnionTypeAnnotation" === u.type ||
                  "TSUnionType" === u.type ||
                  "IntersectionTypeAnnotation" === u.type ||
                  ("FunctionTypeAnnotation" === u.type &&
                    u.returnType === o)) &&
                1 === s.length &&
                null === s[0].name &&
                o.this !== s[0] &&
                s[0].typeAnnotation &&
                null === o.typeParameters &&
                Q_(s[0].typeAnnotation) &&
                !o.rest
              ? "always" === n.arrowParens
                ? ["(", ...p, ")"]
                : p
              : [
                  a,
                  "(",
                  G_([U_, ...p]),
                  Y_(!iT(o) && oT(n, "all") ? "," : ""),
                  U_,
                  ")",
                ];
          },
          shouldHugFunctionParameters: pT,
          shouldGroupFunctionParameters: function (e, t) {
            const n = (function (e) {
              let t;
              return (
                e.returnType
                  ? ((t = e.returnType),
                    t.typeAnnotation && (t = t.typeAnnotation))
                  : e.typeAnnotation && (t = e.typeAnnotation),
                t
              );
            })(e);
            if (!n) return !1;
            const r = e.typeParameters && e.typeParameters.params;
            if (r) {
              if (r.length > 1) return !1;
              if (1 === r.length) {
                const e = r[0];
                if (e.constraint || e.default) return !1;
              }
            }
            return 1 === Z_(e).length && (nT(n) || J_(t));
          },
        };
        const { printComments: dT, printDanglingComments: hT } = Iy,
          { getLast: mT, isNonEmptyArray: gT } = nl,
          {
            builders: {
              group: yT,
              join: vT,
              line: DT,
              softline: bT,
              indent: ET,
              align: CT,
              ifBreak: xT,
            },
          } = Vl,
          wT = tx,
          { locStart: AT } = Vh,
          {
            isSimpleType: ST,
            isObjectType: _T,
            hasLeadingOwnLineComment: TT,
            isObjectTypePropertyAFunction: FT,
            shouldPrintComma: kT,
          } = eb,
          { printAssignment: OT } = R_,
          { printFunctionParameters: BT, shouldGroupFunctionParameters: PT } =
            fT,
          { printArrayItems: NT } = OA;
        function MT(e) {
          if (ST(e) || _T(e)) return !0;
          if ("UnionTypeAnnotation" === e.type || "TSUnionType" === e.type) {
            const t = e.types.filter(
                (e) =>
                  "VoidTypeAnnotation" === e.type ||
                  "TSVoidKeyword" === e.type ||
                  "NullLiteralTypeAnnotation" === e.type ||
                  "TSNullKeyword" === e.type
              ).length,
              n = e.types.some(
                (e) =>
                  "ObjectTypeAnnotation" === e.type ||
                  "TSTypeLiteral" === e.type ||
                  "GenericTypeAnnotation" === e.type ||
                  "TSTypeReference" === e.type
              );
            if (e.types.length - 1 === t && n) return !0;
          }
          return !1;
        }
        var IT = {
          printOpaqueType: function (e, t, n) {
            const r = t.semi ? ";" : "",
              i = e.getValue(),
              o = [];
            return (
              o.push("opaque type ", n("id"), n("typeParameters")),
              i.supertype && o.push(": ", n("supertype")),
              i.impltype && o.push(" = ", n("impltype")),
              o.push(r),
              o
            );
          },
          printTypeAlias: function (e, t, n) {
            const r = t.semi ? ";" : "",
              i = e.getValue(),
              o = [];
            i.declare && o.push("declare "),
              o.push("type ", n("id"), n("typeParameters"));
            const s =
              "TSTypeAliasDeclaration" === i.type ? "typeAnnotation" : "right";
            return [OT(e, t, n, o, " =", s), r];
          },
          printIntersectionType: function (e, t, n) {
            const r = e.getValue(),
              i = e.map(n, "types"),
              o = [];
            let s = !1;
            for (let e = 0; e < i.length; ++e)
              0 === e
                ? o.push(i[e])
                : _T(r.types[e - 1]) && _T(r.types[e])
                ? o.push([" & ", s ? ET(i[e]) : i[e]])
                : _T(r.types[e - 1]) || _T(r.types[e])
                ? (e > 1 && (s = !0), o.push(" & ", e > 1 ? ET(i[e]) : i[e]))
                : o.push(ET([" &", DT, i[e]]));
            return yT(o);
          },
          printUnionType: function (e, t, n) {
            const r = e.getValue(),
              i = e.getParentNode(),
              o = !(
                "TypeParameterInstantiation" === i.type ||
                "TSTypeParameterInstantiation" === i.type ||
                "GenericTypeAnnotation" === i.type ||
                "TSTypeReference" === i.type ||
                "TSTypeAssertion" === i.type ||
                "TupleTypeAnnotation" === i.type ||
                "TSTupleType" === i.type ||
                ("FunctionTypeParam" === i.type &&
                  !i.name &&
                  e.getParentNode(1).this !== i) ||
                (("TypeAlias" === i.type ||
                  "VariableDeclarator" === i.type ||
                  "TSTypeAliasDeclaration" === i.type) &&
                  TT(t.originalText, r))
              ),
              s = MT(r),
              a = e.map((e) => {
                let r = n();
                return s || (r = CT(2, r)), dT(e, r, t);
              }, "types");
            if (s) return vT(" | ", a);
            const u = o && !TT(t.originalText, r),
              l = [xT([u ? DT : "", "| "]), vT([DT, "| "], a)];
            return wT(e, t)
              ? yT([ET(l), bT])
              : ("TupleTypeAnnotation" === i.type && i.types.length > 1) ||
                ("TSTupleType" === i.type && i.elementTypes.length > 1)
              ? yT([ET([xT(["(", bT]), l]), bT, xT(")")])
              : yT(o ? ET(l) : l);
          },
          printFunctionType: function (e, t, n) {
            const r = e.getValue(),
              i = [],
              o = e.getParentNode(0),
              s = e.getParentNode(1),
              a = e.getParentNode(2);
            let u =
                "TSFunctionType" === r.type ||
                !(
                  (("ObjectTypeProperty" === o.type ||
                    "ObjectTypeInternalSlot" === o.type) &&
                    !o.variance &&
                    !o.optional &&
                    AT(o) === AT(r)) ||
                  "ObjectTypeCallProperty" === o.type ||
                  (a && "DeclareFunction" === a.type)
                ),
              l =
                u &&
                ("TypeAnnotation" === o.type || "TSTypeAnnotation" === o.type);
            const c =
              l &&
              u &&
              ("TypeAnnotation" === o.type || "TSTypeAnnotation" === o.type) &&
              "ArrowFunctionExpression" === s.type;
            FT(o) && ((u = !0), (l = !0)), c && i.push("(");
            const p = BT(e, n, t, !1, !0),
              f =
                r.returnType || r.predicate || r.typeAnnotation
                  ? [
                      u ? " => " : ": ",
                      n("returnType"),
                      n("predicate"),
                      n("typeAnnotation"),
                    ]
                  : "",
              d = PT(r, f);
            return (
              i.push(d ? yT(p) : p), f && i.push(f), c && i.push(")"), yT(i)
            );
          },
          printTupleType: function (e, t, n) {
            const r = e.getValue(),
              i = "TSTupleType" === r.type ? "elementTypes" : "types",
              o = r[i],
              s = gT(o),
              a = s && "TSRestType" === mT(o).type,
              u = s ? bT : "";
            return yT([
              "[",
              ET([u, NT(e, t, i, n)]),
              xT(s && kT(t, "all") && !a ? "," : ""),
              hT(e, t, !0),
              u,
              "]",
            ]);
          },
          printIndexedAccessType: function (e, t, n) {
            const r = e.getValue(),
              i =
                "OptionalIndexedAccessType" === r.type && r.optional
                  ? "?.["
                  : "[";
            return [n("objectType"), i, n("indexType"), "]"];
          },
          shouldHugType: MT,
        };
        const { printDanglingComments: jT } = Iy,
          {
            builders: {
              join: LT,
              line: $T,
              hardline: RT,
              softline: zT,
              group: VT,
              indent: qT,
              ifBreak: WT,
            },
          } = Vl,
          {
            isTestCall: UT,
            hasComment: HT,
            CommentCheckFlags: GT,
            isTSXFile: YT,
            shouldPrintComma: XT,
            getFunctionParameters: JT,
            isObjectType: ZT,
          } = eb,
          { createGroupIdMapper: KT } = nl,
          { shouldHugType: QT } = IT,
          { isArrowFunctionVariableDeclarator: eF } = R_,
          tF = KT("typeParameters");
        function nF(e, t) {
          const n = e.getValue();
          if (!HT(n, GT.Dangling)) return "";
          const r = !HT(n, GT.Line),
            i = jT(e, t, r);
          return r ? i : [i, RT];
        }
        var rF = {
          printTypeParameter: function (e, t, n) {
            const r = e.getValue(),
              i = [],
              o = e.getParentNode();
            return "TSMappedType" === o.type
              ? (i.push("[", n("name")),
                r.constraint && i.push(" in ", n("constraint")),
                o.nameType &&
                  i.push(
                    " as ",
                    e.callParent(() => n("nameType"))
                  ),
                i.push("]"),
                i)
              : (r.variance && i.push(n("variance")),
                i.push(n("name")),
                r.bound && i.push(": ", n("bound")),
                r.constraint && i.push(" extends ", n("constraint")),
                r.default && i.push(" = ", n("default")),
                i);
          },
          printTypeParameters: function (e, t, n, r) {
            const i = e.getValue();
            if (!i[r]) return "";
            if (!Array.isArray(i[r])) return n(r);
            const o = e.getNode(2),
              s = o && UT(o),
              a = e.match(
                (e) => !(1 === e[r].length && ZT(e[r][0])),
                void 0,
                (e, t) => "typeAnnotation" === t,
                (e) => "Identifier" === e.type,
                eF
              );
            if (
              !a &&
              (s ||
                0 === i[r].length ||
                (1 === i[r].length &&
                  ("NullableTypeAnnotation" === i[r][0].type || QT(i[r][0]))))
            )
              return ["<", LT(", ", e.map(n, r)), nF(e, t), ">"];
            const u =
              "TSTypeParameterInstantiation" === i.type
                ? ""
                : 1 === JT(i).length &&
                  YT(t) &&
                  !i[r][0].constraint &&
                  "ArrowFunctionExpression" === e.getParentNode().type
                ? ","
                : XT(t, "all")
                ? WT(",")
                : "";
            return VT(["<", qT([zT, LT([",", $T], e.map(n, r))]), u, zT, ">"], {
              id: tF(i),
            });
          },
          getTypeParametersGroupId: tF,
        };
        const { printComments: iF } = Iy,
          { printString: oF, printNumber: sF } = nl,
          {
            isNumericLiteral: aF,
            isSimpleNumber: uF,
            isStringLiteral: lF,
            isStringPropSafeToUnquote: cF,
            rawText: pF,
          } = eb,
          { printAssignment: fF } = R_,
          dF = new WeakMap();
        function hF(e, t, n) {
          const r = e.getNode();
          if (r.computed) return ["[", n("key"), "]"];
          const i = e.getParentNode(),
            { key: o } = r;
          if ("ClassPrivateProperty" === r.type && "Identifier" === o.type)
            return ["#", n("key")];
          if ("consistent" === t.quoteProps && !dF.has(i)) {
            const e = (i.properties || i.body || i.members).some(
              (e) => !e.computed && e.key && lF(e.key) && !cF(e, t)
            );
            dF.set(i, e);
          }
          if (
            ("Identifier" === o.type ||
              (aF(o) &&
                uF(sF(pF(o))) &&
                String(o.value) === sF(pF(o)) &&
                "typescript" !== t.parser &&
                "babel-ts" !== t.parser)) &&
            ("json" === t.parser ||
              ("consistent" === t.quoteProps && dF.get(i)))
          ) {
            const n = oF(
              JSON.stringify(
                "Identifier" === o.type ? o.name : o.value.toString()
              ),
              t
            );
            return e.call((e) => iF(e, n, t), "key");
          }
          return cF(r, t) &&
            ("as-needed" === t.quoteProps ||
              ("consistent" === t.quoteProps && !dF.get(i)))
            ? e.call(
                (e) => iF(e, /^\d/.test(o.value) ? sF(o.value) : o.value, t),
                "key"
              )
            : n("key");
        }
        var mF = {
          printProperty: function (e, t, n) {
            return e.getValue().shorthand
              ? n("value")
              : fF(e, t, n, hF(e, t, n), ":", "value");
          },
          printPropertyKey: hF,
        };
        const gF = ly,
          { printDanglingComments: yF, printCommentsSeparately: vF } = Iy,
          DF = ns,
          { getNextNonSpaceNonCommentCharacterIndex: bF } = nl,
          {
            builders: {
              line: EF,
              softline: CF,
              group: xF,
              indent: wF,
              ifBreak: AF,
              hardline: SF,
              join: _F,
              indentIfBreak: TF,
            },
            utils: { removeLines: FF, willBreak: kF },
          } = Vl,
          { ArgExpansionBailout: OF } = up,
          {
            getFunctionParameters: BF,
            hasLeadingOwnLineComment: PF,
            isFlowAnnotationComment: NF,
            isJsxNode: MF,
            isTemplateOnItsOwnLine: IF,
            shouldPrintComma: jF,
            startsWithNoLookaheadToken: LF,
            isBinaryish: $F,
            isLineComment: RF,
            hasComment: zF,
            getComments: VF,
            CommentCheckFlags: qF,
            isCallLikeExpression: WF,
            isCallExpression: UF,
            getCallArguments: HF,
            hasNakedLeftSide: GF,
            getLeftSide: YF,
          } = eb,
          { locEnd: XF } = Vh,
          { printFunctionParameters: JF, shouldGroupFunctionParameters: ZF } =
            fT,
          { printPropertyKey: KF } = mF,
          { printFunctionTypeParameters: QF } = uA;
        function ek(e, t, n) {
          const r = e.getNode(),
            i = JF(e, n, t),
            o = nk(e, n, t),
            s = ZF(r, o),
            a = [QF(e, t, n), xF([s ? xF(i) : i, o])];
          return r.body ? a.push(" ", n("body")) : a.push(t.semi ? ";" : ""), a;
        }
        function tk(e, t) {
          return (
            "always" !== t.arrowParens &&
            "avoid" === t.arrowParens &&
            (function (e) {
              const t = BF(e);
              return !(
                1 !== t.length ||
                e.typeParameters ||
                zF(e, qF.Dangling) ||
                "Identifier" !== t[0].type ||
                t[0].typeAnnotation ||
                zF(t[0]) ||
                t[0].optional ||
                e.predicate ||
                e.returnType
              );
            })(e.getValue())
          );
        }
        function nk(e, t, n) {
          const r = e.getValue(),
            i = t("returnType");
          if (r.returnType && NF(n.originalText, r.returnType))
            return [" /*: ", i, " */"];
          const o = [i];
          return (
            r.returnType && r.returnType.typeAnnotation && o.unshift(": "),
            r.predicate && o.push(r.returnType ? " " : ": ", t("predicate")),
            o
          );
        }
        function rk(e, t, n) {
          const r = e.getValue(),
            i = t.semi ? ";" : "",
            o = [];
          r.argument &&
            ((function (e, t) {
              if (PF(e.originalText, t)) return !0;
              if (GF(t)) {
                let n,
                  r = t;
                for (; (n = YF(r)); )
                  if (((r = n), PF(e.originalText, r))) return !0;
              }
              return !1;
            })(t, r.argument)
              ? o.push([" (", wF([SF, n("argument")]), SF, ")"])
              : $F(r.argument) || "SequenceExpression" === r.argument.type
              ? o.push(
                  xF([AF(" (", " "), wF([CF, n("argument")]), CF, AF(")")])
                )
              : o.push(" ", n("argument")));
          const s = VF(r),
            a = DF(s),
            u = a && RF(a);
          return (
            u && o.push(i),
            zF(r, qF.Dangling) && o.push(" ", yF(e, t, !0)),
            u || o.push(i),
            o
          );
        }
        var ik = {
          printFunction: function (e, t, n, r) {
            const i = e.getValue();
            let o = !1;
            if (
              ("FunctionDeclaration" === i.type ||
                "FunctionExpression" === i.type) &&
              r &&
              r.expandLastArg
            ) {
              const t = e.getParentNode();
              UF(t) && HF(t).length > 1 && (o = !0);
            }
            const s = [];
            "TSDeclareFunction" === i.type && i.declare && s.push("declare "),
              i.async && s.push("async "),
              i.generator ? s.push("function* ") : s.push("function "),
              i.id && s.push(t("id"));
            const a = JF(e, t, n, o),
              u = nk(e, t, n),
              l = ZF(i, u);
            return (
              s.push(
                QF(e, n, t),
                xF([l ? xF(a) : a, u]),
                i.body ? " " : "",
                t("body")
              ),
              !n.semi || (!i.declare && i.body) || s.push(";"),
              s
            );
          },
          printArrowFunction: function (e, t, n, r) {
            let i = e.getValue();
            const o = [],
              s = [];
            let a = !1;
            if (
              ((function u() {
                const l = (function (e, t, n, r) {
                  const i = [];
                  if ((e.getValue().async && i.push("async "), tk(e, t)))
                    i.push(n(["params", 0]));
                  else {
                    const o = r && (r.expandLastArg || r.expandFirstArg);
                    let s = nk(e, n, t);
                    if (o) {
                      if (kF(s)) throw new OF();
                      s = xF(FF(s));
                    }
                    i.push(xF([JF(e, n, t, o, !0), s]));
                  }
                  const o = yF(e, t, !0, (e) => {
                    const n = bF(t.originalText, e, XF);
                    return !1 !== n && "=>" === t.originalText.slice(n, n + 2);
                  });
                  return o && i.push(" ", o), i;
                })(e, t, n, r);
                if (0 === o.length) o.push(l);
                else {
                  const { leading: n, trailing: r } = vF(e, t);
                  o.push([n, l]), s.unshift(r);
                }
                (a =
                  a ||
                  (i.returnType && BF(i).length > 0) ||
                  i.typeParameters ||
                  BF(i).some((e) => "Identifier" !== e.type)),
                  "ArrowFunctionExpression" !== i.body.type ||
                  (r && r.expandLastArg)
                    ? s.unshift(n("body", r))
                    : ((i = i.body), e.call(u, "body"));
              })(),
              o.length > 1)
            )
              return (function (e, t, n, r, i, o) {
                const s = e.getName(),
                  a = e.getParentNode(),
                  u = WF(a) && "callee" === s,
                  l = Boolean(t && t.assignmentLayout),
                  c =
                    "BlockStatement" !== o.body.type &&
                    "ObjectExpression" !== o.body.type &&
                    "SequenceExpression" !== o.body.type,
                  p =
                    (u && c) ||
                    (t && "chain-tail-arrow-chain" === t.assignmentLayout),
                  f = Symbol("arrow-chain");
                return (
                  "SequenceExpression" === o.body.type &&
                    (i = xF(["(", wF([CF, i]), CF, ")"])),
                  xF([
                    xF(
                      wF([
                        u || l ? CF : "",
                        xF(_F([" =>", EF], n), { shouldBreak: r }),
                      ]),
                      { id: f, shouldBreak: p }
                    ),
                    " =>",
                    TF(c ? wF([EF, i]) : [" ", i], { groupId: f }),
                    u ? AF(CF, "", { groupId: f }) : "",
                  ])
                );
              })(e, r, o, a, s, i);
            const u = o;
            if (
              (u.push(" =>"),
              !PF(t.originalText, i.body) &&
                ("ArrayExpression" === i.body.type ||
                  "ObjectExpression" === i.body.type ||
                  "BlockStatement" === i.body.type ||
                  MF(i.body) ||
                  IF(i.body, t.originalText) ||
                  "ArrowFunctionExpression" === i.body.type ||
                  "DoExpression" === i.body.type))
            )
              return xF([...u, " ", s]);
            if ("SequenceExpression" === i.body.type)
              return xF([...u, xF([" (", wF([CF, s]), CF, ")"])]);
            const l =
                ((r && r.expandLastArg) ||
                  "JSXExpressionContainer" === e.getParentNode().type) &&
                !zF(i),
              c = r && r.expandLastArg && jF(t, "all"),
              p = "ConditionalExpression" === i.body.type && !LF(i.body, !1);
            return xF([
              ...u,
              xF([
                wF([EF, p ? AF("", "(") : "", s, p ? AF("", ")") : ""]),
                l ? [AF(c ? "," : ""), CF] : "",
              ]),
            ]);
          },
          printMethod: function (e, t, n) {
            const r = e.getNode(),
              { kind: i } = r,
              o = r.value || r,
              s = [];
            return (
              i && "init" !== i && "method" !== i && "constructor" !== i
                ? (gF.ok("get" === i || "set" === i), s.push(i, " "))
                : o.async && s.push("async "),
              o.generator && s.push("*"),
              s.push(KF(e, t, n), r.optional || r.key.optional ? "?" : ""),
              r === o
                ? s.push(ek(e, t, n))
                : "FunctionExpression" === o.type
                ? s.push(e.call((e) => ek(e, t, n), "value"))
                : s.push(n("value")),
              s
            );
          },
          printReturnStatement: function (e, t, n) {
            return ["return", rk(e, t, n)];
          },
          printThrowStatement: function (e, t, n) {
            return ["throw", rk(e, t, n)];
          },
          printMethodInternal: ek,
          shouldPrintParamsWithoutParens: tk,
        };
        const { isNonEmptyArray: ok, hasNewline: sk } = nl,
          {
            builders: {
              line: ak,
              hardline: uk,
              join: lk,
              breakParent: ck,
              group: pk,
            },
          } = Vl,
          { locStart: fk, locEnd: dk } = Vh,
          { getParentExportDeclaration: hk } = eb;
        function mk(e, t) {
          return e.decorators.some((e) => sk(t.originalText, dk(e)));
        }
        function gk(e) {
          if (
            "ExportDefaultDeclaration" !== e.type &&
            "ExportNamedDeclaration" !== e.type &&
            "DeclareExportDeclaration" !== e.type
          )
            return !1;
          const t = e.declaration && e.declaration.decorators;
          return ok(t) && fk(e, { ignoreDecorators: !0 }) > fk(t[0]);
        }
        var yk = {
          printDecorators: function (e, t, n) {
            const r = e.getValue(),
              { decorators: i } = r;
            if (!ok(i) || gk(e.getParentNode())) return;
            const o =
              "ClassExpression" === r.type ||
              "ClassDeclaration" === r.type ||
              mk(r, t);
            return [
              hk(e) ? uk : o ? ck : "",
              lk(ak, e.map(n, "decorators")),
              ak,
            ];
          },
          printClassMemberDecorators: function (e, t, n) {
            const r = e.getValue();
            return pk([lk(ak, e.map(n, "decorators")), mk(r, t) ? uk : ak]);
          },
          printDecoratorsBeforeExport: function (e, t, n) {
            return [lk(uk, e.map(n, "declaration", "decorators")), uk];
          },
          hasDecoratorsBeforeExport: gk,
        };
        const { isNonEmptyArray: vk, createGroupIdMapper: Dk } = nl,
          { printComments: bk, printDanglingComments: Ek } = Iy,
          {
            builders: {
              join: Ck,
              line: xk,
              hardline: wk,
              softline: Ak,
              group: Sk,
              indent: _k,
              ifBreak: Tk,
            },
          } = Vl,
          { hasComment: Fk, CommentCheckFlags: kk } = eb,
          { getTypeParametersGroupId: Ok } = rF,
          { printMethod: Bk } = ik,
          { printOptionalToken: Pk, printTypeAnnotation: Nk } = uA,
          { printPropertyKey: Mk } = mF,
          { printAssignment: Ik } = R_,
          { printClassMemberDecorators: jk } = yk,
          Lk = Dk("heritageGroup");
        function $k(e) {
          return (
            e.typeParameters &&
            !Fk(e.typeParameters, kk.Trailing | kk.Line) &&
            !(function (e) {
              return (
                ["superClass", "extends", "mixins", "implements"].filter((t) =>
                  Boolean(e[t])
                ).length > 1
              );
            })(e)
          );
        }
        function Rk(e, t, n, r) {
          const i = e.getValue();
          if (!vk(i[r])) return "";
          const o = Ek(e, t, !0, (e) => {
            let { marker: t } = e;
            return t === r;
          });
          return [
            $k(i) ? Tk(" ", xk, { groupId: Ok(i.typeParameters) }) : xk,
            o,
            o && wk,
            r,
            Sk(_k([xk, Ck([",", xk], e.map(n, r))])),
          ];
        }
        function zk(e, t, n) {
          const r = n("superClass");
          return "AssignmentExpression" === e.getParentNode().type
            ? Sk(Tk(["(", _k([Ak, r]), Ak, ")"], r))
            : r;
        }
        var Vk = {
          printClass: function (e, t, n) {
            const r = e.getValue(),
              i = [];
            r.declare && i.push("declare "),
              r.abstract && i.push("abstract "),
              i.push("class");
            const o =
                (r.id && Fk(r.id, kk.Trailing)) ||
                (r.superClass && Fk(r.superClass)) ||
                vk(r.extends) ||
                vk(r.mixins) ||
                vk(r.implements),
              s = [],
              a = [];
            if (
              (r.id && s.push(" ", n("id")),
              s.push(n("typeParameters")),
              r.superClass)
            ) {
              const r = ["extends ", zk(e, 0, n), n("superTypeParameters")],
                i = e.call((e) => bk(e, r, t), "superClass");
              o ? a.push(xk, Sk(i)) : a.push(" ", i);
            } else a.push(Rk(e, t, n, "extends"));
            if ((a.push(Rk(e, t, n, "mixins"), Rk(e, t, n, "implements")), o)) {
              let e;
              (e = $k(r) ? [...s, _k(a)] : _k([...s, a])),
                i.push(Sk(e, { id: Lk(r) }));
            } else i.push(...s, ...a);
            return i.push(" ", n("body")), i;
          },
          printClassMethod: function (e, t, n) {
            const r = e.getValue(),
              i = [];
            return (
              vk(r.decorators) && i.push(jk(e, t, n)),
              r.accessibility && i.push(r.accessibility + " "),
              r.readonly && i.push("readonly "),
              r.declare && i.push("declare "),
              r.static && i.push("static "),
              ("TSAbstractMethodDefinition" === r.type || r.abstract) &&
                i.push("abstract "),
              r.override && i.push("override "),
              i.push(Bk(e, t, n)),
              i
            );
          },
          printClassProperty: function (e, t, n) {
            const r = e.getValue(),
              i = [],
              o = t.semi ? ";" : "";
            return (
              vk(r.decorators) && i.push(jk(e, t, n)),
              r.accessibility && i.push(r.accessibility + " "),
              r.declare && i.push("declare "),
              r.static && i.push("static "),
              ("TSAbstractPropertyDefinition" === r.type || r.abstract) &&
                i.push("abstract "),
              r.override && i.push("override "),
              r.readonly && i.push("readonly "),
              r.variance && i.push(n("variance")),
              i.push(Mk(e, t, n), Pk(e), Nk(e, t, n)),
              [Ik(e, t, n, i, " =", "value"), o]
            );
          },
          printHardlineAfterHeritage: function (e) {
            return Tk(wk, "", { groupId: Lk(e) });
          },
        };
        const { isNonEmptyArray: qk } = nl,
          {
            builders: {
              join: Wk,
              line: Uk,
              group: Hk,
              indent: Gk,
              ifBreak: Yk,
            },
          } = Vl,
          { hasComment: Xk, identity: Jk, CommentCheckFlags: Zk } = eb,
          { getTypeParametersGroupId: Kk } = rF,
          { printTypeScriptModifiers: Qk } = uA;
        var eO = {
          printInterface: function (e, t, n) {
            const r = e.getValue(),
              i = [];
            r.declare && i.push("declare "),
              "TSInterfaceDeclaration" === r.type &&
                i.push(r.abstract ? "abstract " : "", Qk(e, t, n)),
              i.push("interface");
            const o = [],
              s = [];
            "InterfaceTypeAnnotation" !== r.type &&
              o.push(" ", n("id"), n("typeParameters"));
            const a =
              r.typeParameters && !Xk(r.typeParameters, Zk.Trailing | Zk.Line);
            return (
              qk(r.extends) &&
                s.push(
                  a ? Yk(" ", Uk, { groupId: Kk(r.typeParameters) }) : Uk,
                  "extends ",
                  (1 === r.extends.length ? Jk : Gk)(
                    Wk([",", Uk], e.map(n, "extends"))
                  )
                ),
              (r.id && Xk(r.id, Zk.Trailing)) || qk(r.extends)
                ? a
                  ? i.push(Hk([...o, Gk(s)]))
                  : i.push(Hk(Gk([...o, ...s])))
                : i.push(...o, ...s),
              i.push(" ", n("body")),
              Hk(i)
            );
          },
        };
        const { isNonEmptyArray: tO } = nl,
          {
            builders: {
              softline: nO,
              group: rO,
              indent: iO,
              join: oO,
              line: sO,
              ifBreak: aO,
              hardline: uO,
            },
          } = Vl,
          { printDanglingComments: lO } = Iy,
          {
            hasComment: cO,
            CommentCheckFlags: pO,
            shouldPrintComma: fO,
            needsHardlineAfterDanglingComment: dO,
          } = eb,
          { locStart: hO, hasSameLoc: mO } = Vh,
          { hasDecoratorsBeforeExport: gO, printDecoratorsBeforeExport: yO } =
            yk;
        function vO(e, t, n) {
          const r = e.getValue();
          if (!r.source) return "";
          const i = [];
          return bO(r, t) || i.push(" from"), i.push(" ", n("source")), i;
        }
        function DO(e, t, n) {
          const r = e.getValue();
          if (bO(r, t)) return "";
          const i = [" "];
          if (tO(r.specifiers)) {
            const o = [],
              s = [];
            e.each(() => {
              const t = e.getValue().type;
              if (
                "ExportNamespaceSpecifier" === t ||
                "ExportDefaultSpecifier" === t ||
                "ImportNamespaceSpecifier" === t ||
                "ImportDefaultSpecifier" === t
              )
                o.push(n());
              else {
                if ("ExportSpecifier" !== t && "ImportSpecifier" !== t)
                  throw new Error(
                    "Unknown specifier type ".concat(JSON.stringify(t))
                  );
                s.push(n());
              }
            }, "specifiers"),
              i.push(oO(", ", o)),
              s.length > 0 &&
                (o.length > 0 && i.push(", "),
                s.length > 1 || o.length > 0 || r.specifiers.some((e) => cO(e))
                  ? i.push(
                      rO([
                        "{",
                        iO([t.bracketSpacing ? sO : nO, oO([",", sO], s)]),
                        aO(fO(t) ? "," : ""),
                        t.bracketSpacing ? sO : nO,
                        "}",
                      ])
                    )
                  : i.push([
                      "{",
                      t.bracketSpacing ? " " : "",
                      ...s,
                      t.bracketSpacing ? " " : "",
                      "}",
                    ]));
          } else i.push("{}");
          return i;
        }
        function bO(e, t) {
          const { type: n, importKind: r, source: i, specifiers: o } = e;
          return (
            "ImportDeclaration" === n &&
            !tO(o) &&
            "type" !== r &&
            !/{\s*}/.test(t.originalText.slice(hO(e), hO(i)))
          );
        }
        function EO(e, t, n) {
          const r = e.getNode();
          return tO(r.assertions)
            ? [
                " assert {",
                t.bracketSpacing ? " " : "",
                oO(", ", e.map(n, "assertions")),
                t.bracketSpacing ? " " : "",
                "}",
              ]
            : "";
        }
        var CO = {
          printImportDeclaration: function (e, t, n) {
            const r = e.getValue(),
              i = t.semi ? ";" : "",
              o = [],
              { importKind: s } = r;
            return (
              o.push("import"),
              s && "value" !== s && o.push(" ", s),
              o.push(DO(e, t, n), vO(e, t, n), EO(e, t, n), i),
              o
            );
          },
          printExportDeclaration: function (e, t, n) {
            const r = e.getValue(),
              i = [];
            gO(r) && i.push(yO(e, t, n));
            const { type: o, exportKind: s, declaration: a } = r;
            return (
              i.push("export"),
              (r.default || "ExportDefaultDeclaration" === o) &&
                i.push(" default"),
              cO(r, pO.Dangling) &&
                (i.push(" ", lO(e, t, !0)), dO(r) && i.push(uO)),
              a
                ? i.push(" ", n("declaration"))
                : i.push(
                    "type" === s ? " type" : "",
                    DO(e, t, n),
                    vO(e, t, n),
                    EO(e, t, n)
                  ),
              (function (e, t) {
                if (!t.semi) return !1;
                const { type: n, declaration: r } = e,
                  i = e.default || "ExportDefaultDeclaration" === n;
                if (!r) return !0;
                const { type: o } = r;
                return !(
                  !i ||
                  "ClassDeclaration" === o ||
                  "FunctionDeclaration" === o ||
                  "TSInterfaceDeclaration" === o ||
                  "DeclareClass" === o ||
                  "DeclareFunction" === o ||
                  "TSDeclareFunction" === o ||
                  "EnumDeclaration" === o
                );
              })(r, t) && i.push(";"),
              i
            );
          },
          printExportAllDeclaration: function (e, t, n) {
            const r = e.getValue(),
              i = t.semi ? ";" : "",
              o = [],
              { exportKind: s, exported: a } = r;
            return (
              o.push("export"),
              "type" === s && o.push(" type"),
              o.push(" *"),
              a && o.push(" as ", n("exported")),
              o.push(vO(e, t, n), EO(e, t, n), i),
              o
            );
          },
          printModuleSpecifier: function (e, t, n) {
            const r = e.getNode(),
              { type: i } = r,
              o = [],
              s = "ImportSpecifier" === i ? r.importKind : r.exportKind;
            s && "value" !== s && o.push(s, " ");
            const a = i.startsWith("Import"),
              u = a ? "imported" : "local",
              l = a ? "local" : "exported";
            let c = "",
              p = "";
            return (
              "ExportNamespaceSpecifier" === i ||
              "ImportNamespaceSpecifier" === i
                ? (c = "*")
                : r[u] && (c = n(u)),
              !r[l] || (r[u] && mO(r[u], r[l])) || (p = n(l)),
              o.push(c, c && p ? " as " : "", p),
              o
            );
          },
        };
        const { printDanglingComments: xO } = Iy,
          {
            builders: {
              line: wO,
              softline: AO,
              group: SO,
              indent: _O,
              ifBreak: TO,
              hardline: FO,
            },
          } = Vl,
          {
            getLast: kO,
            hasNewlineInRange: OO,
            hasNewline: BO,
            isNonEmptyArray: PO,
          } = nl,
          {
            shouldPrintComma: NO,
            hasComment: MO,
            getComments: IO,
            CommentCheckFlags: jO,
            isNextLineEmpty: LO,
          } = eb,
          { locStart: $O, locEnd: RO } = Vh,
          { printOptionalToken: zO, printTypeAnnotation: VO } = uA,
          { shouldHugFunctionParameters: qO } = fT,
          { shouldHugType: WO } = IT,
          { printHardlineAfterHeritage: UO } = Vk;
        var HO = {
          printObject: function (e, t, n) {
            const r = t.semi ? ";" : "",
              i = e.getValue();
            let o;
            o =
              "TSTypeLiteral" === i.type
                ? "members"
                : "TSInterfaceBody" === i.type
                ? "body"
                : "properties";
            const s = "ObjectTypeAnnotation" === i.type,
              a = [o];
            s && a.push("indexers", "callProperties", "internalSlots");
            const u = a.map((e) => i[e][0]).sort((e, t) => $O(e) - $O(t))[0],
              l = e.getParentNode(0),
              c =
                s &&
                l &&
                ("InterfaceDeclaration" === l.type ||
                  "DeclareInterface" === l.type ||
                  "DeclareClass" === l.type) &&
                "body" === e.getName(),
              p =
                "TSInterfaceBody" === i.type ||
                c ||
                ("ObjectPattern" === i.type &&
                  "FunctionDeclaration" !== l.type &&
                  "FunctionExpression" !== l.type &&
                  "ArrowFunctionExpression" !== l.type &&
                  "ObjectMethod" !== l.type &&
                  "ClassMethod" !== l.type &&
                  "ClassPrivateMethod" !== l.type &&
                  "AssignmentPattern" !== l.type &&
                  "CatchClause" !== l.type &&
                  i.properties.some(
                    (e) =>
                      e.value &&
                      ("ObjectPattern" === e.value.type ||
                        "ArrayPattern" === e.value.type)
                  )) ||
                ("ObjectPattern" !== i.type &&
                  u &&
                  OO(t.originalText, $O(i), $O(u))),
              f = c
                ? ";"
                : "TSInterfaceBody" === i.type || "TSTypeLiteral" === i.type
                ? TO(r, ";")
                : ",",
              d = "RecordExpression" === i.type ? "#{" : i.exact ? "{|" : "{",
              h = i.exact ? "|}" : "}",
              m = [];
            for (const t of a)
              e.each((e) => {
                const t = e.getValue();
                m.push({ node: t, printed: n(), loc: $O(t) });
              }, t);
            a.length > 1 && m.sort((e, t) => e.loc - t.loc);
            let g = [];
            const y = m.map((e) => {
              const n = [...g, SO(e.printed)];
              return (
                (g = [f, wO]),
                ("TSPropertySignature" !== e.node.type &&
                  "TSMethodSignature" !== e.node.type &&
                  "TSConstructSignatureDeclaration" !== e.node.type) ||
                  !MO(e.node, jO.PrettierIgnore) ||
                  g.shift(),
                LO(e.node, t) && g.push(FO),
                n
              );
            });
            if (i.inexact) {
              let n;
              if (MO(i, jO.Dangling)) {
                const r = MO(i, jO.Line);
                n = [
                  xO(e, t, !0),
                  r || BO(t.originalText, RO(kO(IO(i)))) ? FO : wO,
                  "...",
                ];
              } else n = ["..."];
              y.push([...g, ...n]);
            }
            const v = kO(i[o]),
              D = !(
                i.inexact ||
                (v && "RestElement" === v.type) ||
                (v &&
                  ("TSPropertySignature" === v.type ||
                    "TSCallSignatureDeclaration" === v.type ||
                    "TSMethodSignature" === v.type ||
                    "TSConstructSignatureDeclaration" === v.type) &&
                  MO(v, jO.PrettierIgnore))
              );
            let b;
            if (0 === y.length) {
              if (!MO(i, jO.Dangling)) return [d, h, VO(e, t, n)];
              b = SO([d, xO(e, t), AO, h, zO(e), VO(e, t, n)]);
            } else
              b = [
                c && PO(i.properties) ? UO(l) : "",
                d,
                _O([t.bracketSpacing ? wO : AO, ...y]),
                TO(D && ("," !== f || NO(t)) ? f : ""),
                t.bracketSpacing ? wO : AO,
                h,
                zO(e),
                VO(e, t, n),
              ];
            return e.match(
              (e) => "ObjectPattern" === e.type && !e.decorators,
              (e, t, n) =>
                qO(e) &&
                ("params" === t ||
                  "parameters" === t ||
                  "this" === t ||
                  "rest" === t) &&
                0 === n
            ) ||
              e.match(
                WO,
                (e, t) => "typeAnnotation" === t,
                (e, t) => "typeAnnotation" === t,
                (e, t, n) =>
                  qO(e) &&
                  ("params" === t ||
                    "parameters" === t ||
                    "this" === t ||
                    "rest" === t) &&
                  0 === n
              ) ||
              (!p &&
                e.match(
                  (e) => "ObjectPattern" === e.type,
                  (e) =>
                    "AssignmentExpression" === e.type ||
                    "VariableDeclarator" === e.type
                ))
              ? b
              : SO(b, { shouldBreak: p });
          },
        };
        const GO = ly,
          { printDanglingComments: YO } = Iy,
          { printString: XO, printNumber: JO } = nl,
          {
            builders: { hardline: ZO, softline: KO, group: QO, indent: eB },
          } = Vl,
          {
            getParentExportDeclaration: tB,
            isFunctionNotation: nB,
            isGetterOrSetter: rB,
            rawText: iB,
            shouldPrintComma: oB,
          } = eb,
          { locStart: sB, locEnd: aB } = Vh,
          { printClass: uB } = Vk,
          {
            printOpaqueType: lB,
            printTypeAlias: cB,
            printIntersectionType: pB,
            printUnionType: fB,
            printFunctionType: dB,
            printTupleType: hB,
            printIndexedAccessType: mB,
          } = IT,
          { printInterface: gB } = eO,
          { printTypeParameter: yB, printTypeParameters: vB } = rF,
          { printExportDeclaration: DB, printExportAllDeclaration: bB } = CO,
          { printArrayItems: EB } = OA,
          { printObject: CB } = HO,
          { printPropertyKey: xB } = mF,
          {
            printOptionalToken: wB,
            printTypeAnnotation: AB,
            printRestSpread: SB,
          } = uA;
        function _B(e, t) {
          const n = tB(e);
          return n
            ? (GO.strictEqual(n.type, "DeclareExportDeclaration"), t)
            : ["declare ", t];
        }
        var TB = {
          printFlow: function (e, t, n) {
            const r = e.getValue(),
              i = t.semi ? ";" : "",
              o = [];
            switch (r.type) {
              case "DeclareClass":
                return _B(e, uB(e, t, n));
              case "DeclareFunction":
                return _B(e, [
                  "function ",
                  n("id"),
                  r.predicate ? " " : "",
                  n("predicate"),
                  i,
                ]);
              case "DeclareModule":
                return _B(e, ["module ", n("id"), " ", n("body")]);
              case "DeclareModuleExports":
                return _B(e, ["module.exports", ": ", n("typeAnnotation"), i]);
              case "DeclareVariable":
                return _B(e, ["var ", n("id"), i]);
              case "DeclareOpaqueType":
                return _B(e, lB(e, t, n));
              case "DeclareInterface":
                return _B(e, gB(e, t, n));
              case "DeclareTypeAlias":
                return _B(e, cB(e, t, n));
              case "DeclareExportDeclaration":
                return _B(e, DB(e, t, n));
              case "DeclareExportAllDeclaration":
                return _B(e, bB(e, t, n));
              case "OpaqueType":
                return lB(e, t, n);
              case "TypeAlias":
                return cB(e, t, n);
              case "IntersectionTypeAnnotation":
                return pB(e, t, n);
              case "UnionTypeAnnotation":
                return fB(e, t, n);
              case "FunctionTypeAnnotation":
                return dB(e, t, n);
              case "TupleTypeAnnotation":
                return hB(e, t, n);
              case "GenericTypeAnnotation":
                return [n("id"), vB(e, t, n, "typeParameters")];
              case "IndexedAccessType":
              case "OptionalIndexedAccessType":
                return mB(e, t, n);
              case "TypeAnnotation":
                return n("typeAnnotation");
              case "TypeParameter":
                return yB(e, t, n);
              case "TypeofTypeAnnotation":
                return ["typeof ", n("argument")];
              case "ExistsTypeAnnotation":
                return "*";
              case "EmptyTypeAnnotation":
                return "empty";
              case "MixedTypeAnnotation":
                return "mixed";
              case "ArrayTypeAnnotation":
                return [n("elementType"), "[]"];
              case "BooleanLiteralTypeAnnotation":
                return String(r.value);
              case "EnumDeclaration":
                return ["enum ", n("id"), " ", n("body")];
              case "EnumBooleanBody":
              case "EnumNumberBody":
              case "EnumStringBody":
              case "EnumSymbolBody":
                if ("EnumSymbolBody" === r.type || r.explicitType) {
                  let e = null;
                  switch (r.type) {
                    case "EnumBooleanBody":
                      e = "boolean";
                      break;
                    case "EnumNumberBody":
                      e = "number";
                      break;
                    case "EnumStringBody":
                      e = "string";
                      break;
                    case "EnumSymbolBody":
                      e = "symbol";
                  }
                  o.push("of ", e, " ");
                }
                if (0 !== r.members.length || r.hasUnknownMembers) {
                  const i =
                    r.members.length > 0
                      ? [
                          ZO,
                          EB(e, t, "members", n),
                          r.hasUnknownMembers || oB(t) ? "," : "",
                        ]
                      : [];
                  o.push(
                    QO([
                      "{",
                      eB([...i, ...(r.hasUnknownMembers ? [ZO, "..."] : [])]),
                      YO(e, t, !0),
                      ZO,
                      "}",
                    ])
                  );
                } else o.push(QO(["{", YO(e, t), KO, "}"]));
                return o;
              case "EnumBooleanMember":
              case "EnumNumberMember":
              case "EnumStringMember":
                return [
                  n("id"),
                  " = ",
                  "object" == typeof r.init ? n("init") : String(r.init),
                ];
              case "EnumDefaultedMember":
                return n("id");
              case "FunctionTypeParam": {
                const t = r.name
                  ? n("name")
                  : e.getParentNode().this === r
                  ? "this"
                  : "";
                return [t, wB(e), t ? ": " : "", n("typeAnnotation")];
              }
              case "InterfaceDeclaration":
              case "InterfaceTypeAnnotation":
                return gB(e, t, n);
              case "ClassImplements":
              case "InterfaceExtends":
                return [n("id"), n("typeParameters")];
              case "NullableTypeAnnotation":
                return ["?", n("typeAnnotation")];
              case "Variance": {
                const { kind: e } = r;
                return (
                  GO.ok("plus" === e || "minus" === e), "plus" === e ? "+" : "-"
                );
              }
              case "ObjectTypeCallProperty":
                return r.static && o.push("static "), o.push(n("value")), o;
              case "ObjectTypeIndexer":
                return [
                  r.variance ? n("variance") : "",
                  "[",
                  n("id"),
                  r.id ? ": " : "",
                  n("key"),
                  "]: ",
                  n("value"),
                ];
              case "ObjectTypeProperty": {
                let i = "";
                return (
                  r.proto ? (i = "proto ") : r.static && (i = "static "),
                  [
                    i,
                    rB(r) ? r.kind + " " : "",
                    r.variance ? n("variance") : "",
                    xB(e, t, n),
                    wB(e),
                    nB(r) ? "" : ": ",
                    n("value"),
                  ]
                );
              }
              case "ObjectTypeAnnotation":
                return CB(e, t, n);
              case "ObjectTypeInternalSlot":
                return [
                  r.static ? "static " : "",
                  "[[",
                  n("id"),
                  "]]",
                  wB(e),
                  r.method ? "" : ": ",
                  n("value"),
                ];
              case "ObjectTypeSpreadProperty":
                return SB(e, t, n);
              case "QualifiedTypeIdentifier":
                return [n("qualification"), ".", n("id")];
              case "StringLiteralTypeAnnotation":
                return XO(iB(r), t);
              case "NumberLiteralTypeAnnotation":
                GO.strictEqual(typeof r.value, "number");
              case "BigIntLiteralTypeAnnotation":
                return r.extra ? JO(r.extra.raw) : JO(r.raw);
              case "TypeCastExpression":
                return ["(", n("expression"), AB(e, t, n), ")"];
              case "TypeParameterDeclaration":
              case "TypeParameterInstantiation": {
                const i = vB(e, t, n, "params");
                if ("flow" === t.parser) {
                  const e = sB(r),
                    n = aB(r),
                    o = t.originalText.lastIndexOf("/*", e),
                    s = t.originalText.indexOf("*/", n);
                  if (-1 !== o && -1 !== s) {
                    const e = t.originalText.slice(o + 2, s).trim();
                    if (
                      e.startsWith("::") &&
                      !e.includes("/*") &&
                      !e.includes("*/")
                    )
                      return ["/*:: ", i, " */"];
                  }
                }
                return i;
              }
              case "InferredPredicate":
                return "%checks";
              case "DeclaredPredicate":
                return ["%checks(", n("value"), ")"];
              case "AnyTypeAnnotation":
                return "any";
              case "BooleanTypeAnnotation":
                return "boolean";
              case "BigIntTypeAnnotation":
                return "bigint";
              case "NullLiteralTypeAnnotation":
                return "null";
              case "NumberTypeAnnotation":
                return "number";
              case "SymbolTypeAnnotation":
                return "symbol";
              case "StringTypeAnnotation":
                return "string";
              case "VoidTypeAnnotation":
                return "void";
              case "ThisTypeAnnotation":
                return "this";
              case "Node":
              case "Printable":
              case "SourceLocation":
              case "Position":
              case "Statement":
              case "Function":
              case "Pattern":
              case "Expression":
              case "Declaration":
              case "Specifier":
              case "NamedSpecifier":
              case "Comment":
              case "MemberTypeAnnotation":
              case "Type":
                throw new Error("unprintable type: " + JSON.stringify(r.type));
            }
          },
        };
        const { hasNewlineInRange: FB } = nl,
          {
            isJsxNode: kB,
            isBlockComment: OB,
            getComments: BB,
            isCallExpression: PB,
            isMemberExpression: NB,
          } = eb,
          { locStart: MB, locEnd: IB } = Vh,
          {
            builders: {
              line: jB,
              softline: LB,
              group: $B,
              indent: RB,
              align: zB,
              ifBreak: VB,
              dedent: qB,
              breakParent: WB,
            },
          } = Vl;
        function UB(e, t, n) {
          const r = e.getValue(),
            i = "ConditionalExpression" === r.type,
            o = i ? "alternate" : "falseType",
            s = e.getParentNode(),
            a = i
              ? n("test")
              : [n("checkType"), " ", "extends", " ", n("extendsType")];
          return s.type === r.type && s[o] === r ? zB(2, a) : a;
        }
        const HB = new Map([
          ["AssignmentExpression", "right"],
          ["VariableDeclarator", "init"],
          ["ReturnStatement", "argument"],
          ["ThrowStatement", "argument"],
          ["UnaryExpression", "argument"],
          ["YieldExpression", "argument"],
        ]);
        var GB = {
          printTernary: function (e, t, n) {
            const r = e.getValue(),
              i = "ConditionalExpression" === r.type,
              o = i ? "consequent" : "trueType",
              s = i ? "alternate" : "falseType",
              a = i ? ["test"] : ["checkType", "extendsType"],
              u = r[o],
              l = r[s],
              c = [];
            let p = !1;
            const f = e.getParentNode(),
              d = f.type === r.type && a.some((e) => f[e] === r);
            let h,
              m,
              g = f.type === r.type && !d,
              y = 0;
            do {
              (m = h || r), (h = e.getParentNode(y)), y++;
            } while (h && h.type === r.type && a.every((e) => h[e] !== m));
            const v = h || f,
              D = m;
            if (
              i &&
              (kB(r[a[0]]) ||
                kB(u) ||
                kB(l) ||
                (function (e) {
                  const t = [e];
                  for (let e = 0; e < t.length; e++) {
                    const n = t[e];
                    for (const e of ["test", "consequent", "alternate"]) {
                      const r = n[e];
                      if (kB(r)) return !0;
                      "ConditionalExpression" === r.type && t.push(r);
                    }
                  }
                  return !1;
                })(D))
            ) {
              (p = !0), (g = !0);
              const e = (e) => [VB("("), RB([LB, e]), LB, VB(")")],
                t = (e) =>
                  "NullLiteral" === e.type ||
                  ("Literal" === e.type && null === e.value) ||
                  ("Identifier" === e.type && "undefined" === e.name);
              c.push(
                " ? ",
                t(u) ? n(o) : e(n(o)),
                " : ",
                l.type === r.type || t(l) ? n(s) : e(n(s))
              );
            } else {
              const e = [
                jB,
                "? ",
                u.type === r.type ? VB("", "(") : "",
                zB(2, n(o)),
                u.type === r.type ? VB("", ")") : "",
                jB,
                ": ",
                l.type === r.type ? n(s) : zB(2, n(s)),
              ];
              c.push(
                f.type !== r.type || f[s] === r || d
                  ? e
                  : t.useTabs
                  ? qB(RB(e))
                  : zB(Math.max(0, t.tabWidth - 2), e)
              );
            }
            const b = [...a.map((e) => BB(r[e])), BB(u), BB(l)]
                .flat()
                .some((e) => OB(e) && FB(t.originalText, MB(e), IB(e))),
              E =
                !p &&
                (NB(f) || ("NGPipeExpression" === f.type && f.left === r)) &&
                !f.computed,
              C = (function (e) {
                const t = e.getValue();
                if ("ConditionalExpression" !== t.type) return !1;
                let n,
                  r = t;
                for (let t = 0; !n; t++) {
                  const i = e.getParentNode(t);
                  (PB(i) && i.callee === r) ||
                  (NB(i) && i.object === r) ||
                  ("TSNonNullExpression" === i.type && i.expression === r)
                    ? (r = i)
                    : ("NewExpression" === i.type && i.callee === r) ||
                      ("TSAsExpression" === i.type && i.expression === r)
                    ? ((n = e.getParentNode(t + 1)), (r = i))
                    : (n = i);
                }
                return r !== t && n[HB.get(n.type)] === r;
              })(e),
              x = ((e) =>
                f === v ? $B(e, { shouldBreak: b }) : b ? [e, WB] : e)([
                UB(e, 0, n),
                g ? c : RB(c),
                i && E && !C ? LB : "",
              ]);
            return d || C ? $B([RB([LB, x]), LB]) : x;
          },
        };
        const {
            builders: { hardline: YB },
          } = Vl,
          XB = tx,
          {
            getLeftSidePathName: JB,
            hasNakedLeftSide: ZB,
            isJsxNode: KB,
            isTheOnlyJsxElementInMarkdown: QB,
            hasComment: eP,
            CommentCheckFlags: tP,
            isNextLineEmpty: nP,
          } = eb,
          { shouldPrintParamsWithoutParens: rP } = ik;
        function iP(e, t, n, r) {
          const i = e.getValue(),
            o = [],
            s = "ClassBody" === i.type,
            a = (function (e) {
              for (let t = e.length - 1; t >= 0; t--) {
                const n = e[t];
                if ("EmptyStatement" !== n.type) return n;
              }
            })(i[r]);
          return (
            e.each((e, r, i) => {
              const u = e.getValue();
              if ("EmptyStatement" === u.type) return;
              const l = n();
              t.semi ||
              s ||
              QB(t, e) ||
              !(function (e, t) {
                return (
                  "ExpressionStatement" === e.getNode().type &&
                  e.call((e) => oP(e, t), "expression")
                );
              })(e, t)
                ? o.push(l)
                : eP(u, tP.Leading)
                ? o.push(n([], { needsSemi: !0 }))
                : o.push(";", l),
                !t.semi &&
                  s &&
                  sP(u) &&
                  (function (e, t) {
                    const n = e.key && e.key.name;
                    if (
                      !(
                        ("static" !== n && "get" !== n && "set" !== n) ||
                        e.value ||
                        e.typeAnnotation
                      )
                    )
                      return !0;
                    if (!t) return !1;
                    if (t.static || t.accessibility) return !1;
                    if (!t.computed) {
                      const e = t.key && t.key.name;
                      if ("in" === e || "instanceof" === e) return !0;
                    }
                    if (sP(t) && t.variance && !t.static && !t.declare)
                      return !0;
                    switch (t.type) {
                      case "ClassProperty":
                      case "PropertyDefinition":
                      case "TSAbstractPropertyDefinition":
                        return t.computed;
                      case "MethodDefinition":
                      case "TSAbstractMethodDefinition":
                      case "ClassMethod":
                      case "ClassPrivateMethod": {
                        if (
                          (t.value ? t.value.async : t.async) ||
                          "get" === t.kind ||
                          "set" === t.kind
                        )
                          return !1;
                        const e = t.value ? t.value.generator : t.generator;
                        return !(!t.computed && !e);
                      }
                      case "TSIndexSignature":
                        return !0;
                    }
                    return !1;
                  })(u, i[r + 1]) &&
                  o.push(";"),
                u !== a && (o.push(YB), nP(u, t) && o.push(YB));
            }, r),
            o
          );
        }
        function oP(e, t) {
          const n = e.getValue();
          switch (n.type) {
            case "ParenthesizedExpression":
            case "TypeCastExpression":
            case "ArrayExpression":
            case "ArrayPattern":
            case "TemplateLiteral":
            case "TemplateElement":
            case "RegExpLiteral":
              return !0;
            case "ArrowFunctionExpression":
              if (!rP(e, t)) return !0;
              break;
            case "UnaryExpression": {
              const { prefix: e, operator: t } = n;
              if (e && ("+" === t || "-" === t)) return !0;
              break;
            }
            case "BindExpression":
              if (!n.object) return !0;
              break;
            case "Literal":
              if (n.regex) return !0;
              break;
            default:
              if (KB(n)) return !0;
          }
          return (
            !!XB(e, t) || (!!ZB(n) && e.call((e) => oP(e, t), ...JB(e, n)))
          );
        }
        const sP = (e) => {
          let { type: t } = e;
          return (
            "ClassProperty" === t ||
            "PropertyDefinition" === t ||
            "ClassPrivateProperty" === t
          );
        };
        var aP = {
          printBody: function (e, t, n) {
            return iP(e, t, n, "body");
          },
          printSwitchCaseConsequent: function (e, t, n) {
            return iP(e, t, n, "consequent");
          },
        };
        const { printDanglingComments: uP } = Iy,
          { isNonEmptyArray: lP } = nl,
          {
            builders: { hardline: cP, indent: pP },
          } = Vl,
          { hasComment: fP, CommentCheckFlags: dP, isNextLineEmpty: hP } = eb,
          { printHardlineAfterHeritage: mP } = Vk,
          { printBody: gP } = aP;
        function yP(e, t, n) {
          const r = e.getValue(),
            i = lP(r.directives),
            o = r.body.some((e) => "EmptyStatement" !== e.type),
            s = fP(r, dP.Dangling);
          if (!i && !o && !s) return "";
          const a = [];
          if (
            (i &&
              e.each((e, r, i) => {
                a.push(n()),
                  (r < i.length - 1 || o || s) &&
                    (a.push(cP), hP(e.getValue(), t) && a.push(cP));
              }, "directives"),
            o && a.push(gP(e, t, n)),
            s && a.push(uP(e, t, !0)),
            "Program" === r.type)
          ) {
            const t = e.getParentNode();
            (t && "ModuleExpression" === t.type) || a.push(cP);
          }
          return a;
        }
        var vP = {
          printBlock: function (e, t, n) {
            const r = e.getValue(),
              i = [];
            if (
              ("StaticBlock" === r.type && i.push("static "),
              "ClassBody" === r.type && lP(r.body))
            ) {
              const t = e.getParentNode();
              i.push(mP(t));
            }
            i.push("{");
            const o = yP(e, t, n);
            if (o) i.push(pP([cP, o]), cP);
            else {
              const t = e.getParentNode(),
                n = e.getParentNode(1);
              "ArrowFunctionExpression" === t.type ||
                "FunctionExpression" === t.type ||
                "FunctionDeclaration" === t.type ||
                "ObjectMethod" === t.type ||
                "ClassMethod" === t.type ||
                "ClassPrivateMethod" === t.type ||
                "ForStatement" === t.type ||
                "WhileStatement" === t.type ||
                "DoWhileStatement" === t.type ||
                "DoExpression" === t.type ||
                ("CatchClause" === t.type && !n.finalizer) ||
                "TSModuleDeclaration" === t.type ||
                "TSDeclareFunction" === t.type ||
                "StaticBlock" === r.type ||
                "ClassBody" === r.type ||
                i.push(cP);
            }
            return i.push("}"), i;
          },
          printBlockBody: yP,
        };
        const { printDanglingComments: DP } = Iy,
          { hasNewlineInRange: bP } = nl,
          {
            builders: {
              join: EP,
              line: CP,
              hardline: xP,
              softline: wP,
              group: AP,
              indent: SP,
              conditionalGroup: _P,
              ifBreak: TP,
            },
          } = Vl,
          {
            isLiteral: FP,
            getTypeScriptMappedTypeModifier: kP,
            shouldPrintComma: OP,
            isCallExpression: BP,
            isMemberExpression: PP,
          } = eb,
          { locStart: NP, locEnd: MP } = Vh,
          { printOptionalToken: IP, printTypeScriptModifiers: jP } = uA,
          { printTernary: LP } = GB,
          { printFunctionParameters: $P, shouldGroupFunctionParameters: RP } =
            fT,
          { printTemplateLiteral: zP } = bb,
          { printArrayItems: VP } = OA,
          { printObject: qP } = HO,
          { printClassProperty: WP, printClassMethod: UP } = Vk,
          { printTypeParameter: HP, printTypeParameters: GP } = rF,
          { printPropertyKey: YP } = mF,
          { printFunction: XP, printMethodInternal: JP } = ik,
          { printInterface: ZP } = eO,
          { printBlock: KP } = vP,
          {
            printTypeAlias: QP,
            printIntersectionType: eN,
            printUnionType: tN,
            printFunctionType: nN,
            printTupleType: rN,
            printIndexedAccessType: iN,
          } = IT;
        var oN = {
          printTypescript: function (e, t, n) {
            const r = e.getValue();
            if (!r.type.startsWith("TS")) return;
            if (r.type.endsWith("Keyword"))
              return r.type.slice(2, -7).toLowerCase();
            const i = t.semi ? ";" : "",
              o = [];
            switch (r.type) {
              case "TSThisType":
                return "this";
              case "TSTypeAssertion": {
                const e = !(
                    "ArrayExpression" === r.expression.type ||
                    "ObjectExpression" === r.expression.type
                  ),
                  t = AP(["<", SP([wP, n("typeAnnotation")]), wP, ">"]),
                  i = [TP("("), SP([wP, n("expression")]), wP, TP(")")];
                return e
                  ? _P([
                      [t, n("expression")],
                      [t, AP(i, { shouldBreak: !0 })],
                      [t, n("expression")],
                    ])
                  : AP([t, n("expression")]);
              }
              case "TSDeclareFunction":
                return XP(e, n, t);
              case "TSExportAssignment":
                return ["export = ", n("expression"), i];
              case "TSModuleBlock":
                return KP(e, t, n);
              case "TSInterfaceBody":
              case "TSTypeLiteral":
                return qP(e, t, n);
              case "TSTypeAliasDeclaration":
                return QP(e, t, n);
              case "TSQualifiedName":
                return EP(".", [n("left"), n("right")]);
              case "TSAbstractMethodDefinition":
              case "TSDeclareMethod":
                return UP(e, t, n);
              case "TSAbstractPropertyDefinition":
                return WP(e, t, n);
              case "TSInterfaceHeritage":
              case "TSExpressionWithTypeArguments":
                return (
                  o.push(n("expression")),
                  r.typeParameters && o.push(n("typeParameters")),
                  o
                );
              case "TSTemplateLiteralType":
                return zP(e, n, t);
              case "TSNamedTupleMember":
                return [
                  n("label"),
                  r.optional ? "?" : "",
                  ": ",
                  n("elementType"),
                ];
              case "TSRestType":
                return ["...", n("typeAnnotation")];
              case "TSOptionalType":
                return [n("typeAnnotation"), "?"];
              case "TSInterfaceDeclaration":
                return ZP(e, t, n);
              case "TSClassImplements":
                return [n("expression"), n("typeParameters")];
              case "TSTypeParameterDeclaration":
              case "TSTypeParameterInstantiation":
                return GP(e, t, n, "params");
              case "TSTypeParameter":
                return HP(e, t, n);
              case "TSAsExpression": {
                o.push(n("expression"), " as ", n("typeAnnotation"));
                const t = e.getParentNode();
                return (BP(t) && t.callee === r) || (PP(t) && t.object === r)
                  ? AP([SP([wP, ...o]), wP])
                  : o;
              }
              case "TSArrayType":
                return [n("elementType"), "[]"];
              case "TSPropertySignature":
                return (
                  r.readonly && o.push("readonly "),
                  o.push(YP(e, t, n), IP(e)),
                  r.typeAnnotation && o.push(": ", n("typeAnnotation")),
                  r.initializer && o.push(" = ", n("initializer")),
                  o
                );
              case "TSParameterProperty":
                return (
                  r.accessibility && o.push(r.accessibility + " "),
                  r.export && o.push("export "),
                  r.static && o.push("static "),
                  r.override && o.push("override "),
                  r.readonly && o.push("readonly "),
                  o.push(n("parameter")),
                  o
                );
              case "TSTypeQuery":
                return ["typeof ", n("exprName")];
              case "TSIndexSignature": {
                const o = e.getParentNode(),
                  s = r.parameters.length > 1 ? TP(OP(t) ? "," : "") : "",
                  a = AP([
                    SP([wP, EP([", ", wP], e.map(n, "parameters"))]),
                    s,
                    wP,
                  ]);
                return [
                  r.export ? "export " : "",
                  r.accessibility ? [r.accessibility, " "] : "",
                  r.static ? "static " : "",
                  r.readonly ? "readonly " : "",
                  r.declare ? "declare " : "",
                  "[",
                  r.parameters ? a : "",
                  r.typeAnnotation ? "]: " : "]",
                  r.typeAnnotation ? n("typeAnnotation") : "",
                  "ClassBody" === o.type ? i : "",
                ];
              }
              case "TSTypePredicate":
                return [
                  r.asserts ? "asserts " : "",
                  n("parameterName"),
                  r.typeAnnotation ? [" is ", n("typeAnnotation")] : "",
                ];
              case "TSNonNullExpression":
                return [n("expression"), "!"];
              case "TSImportType":
                return [
                  r.isTypeOf ? "typeof " : "",
                  "import(",
                  n(r.parameter ? "parameter" : "argument"),
                  ")",
                  r.qualifier ? [".", n("qualifier")] : "",
                  GP(e, t, n, "typeParameters"),
                ];
              case "TSLiteralType":
                return n("literal");
              case "TSIndexedAccessType":
                return iN(e, t, n);
              case "TSConstructSignatureDeclaration":
              case "TSCallSignatureDeclaration":
              case "TSConstructorType":
                if (
                  ("TSConstructorType" === r.type &&
                    r.abstract &&
                    o.push("abstract "),
                  "TSCallSignatureDeclaration" !== r.type && o.push("new "),
                  o.push(AP($P(e, n, t, !1, !0))),
                  r.returnType || r.typeAnnotation)
                ) {
                  const e = "TSConstructorType" === r.type;
                  o.push(
                    e ? " => " : ": ",
                    n("returnType"),
                    n("typeAnnotation")
                  );
                }
                return o;
              case "TSTypeOperator":
                return [r.operator, " ", n("typeAnnotation")];
              case "TSMappedType": {
                const o = bP(t.originalText, NP(r), MP(r));
                return AP(
                  [
                    "{",
                    SP([
                      t.bracketSpacing ? CP : wP,
                      r.readonly ? [kP(r.readonly, "readonly"), " "] : "",
                      jP(e, t, n),
                      n("typeParameter"),
                      r.optional ? kP(r.optional, "?") : "",
                      r.typeAnnotation ? ": " : "",
                      n("typeAnnotation"),
                      TP(i),
                    ]),
                    DP(e, t, !0),
                    t.bracketSpacing ? CP : wP,
                    "}",
                  ],
                  { shouldBreak: o }
                );
              }
              case "TSMethodSignature": {
                const i =
                  r.kind && "method" !== r.kind ? "".concat(r.kind, " ") : "";
                o.push(
                  r.accessibility ? [r.accessibility, " "] : "",
                  i,
                  r.export ? "export " : "",
                  r.static ? "static " : "",
                  r.readonly ? "readonly " : "",
                  r.abstract ? "abstract " : "",
                  r.declare ? "declare " : "",
                  r.computed ? "[" : "",
                  n("key"),
                  r.computed ? "]" : "",
                  IP(e)
                );
                const s = $P(e, n, t, !1, !0),
                  a = r.returnType ? "returnType" : "typeAnnotation",
                  u = r[a],
                  l = u ? n(a) : "",
                  c = RP(r, l);
                return o.push(c ? AP(s) : s), u && o.push(": ", AP(l)), AP(o);
              }
              case "TSNamespaceExportDeclaration":
                return (
                  o.push("export as namespace ", n("id")),
                  t.semi && o.push(";"),
                  AP(o)
                );
              case "TSEnumDeclaration":
                return (
                  r.declare && o.push("declare "),
                  r.modifiers && o.push(jP(e, t, n)),
                  r.const && o.push("const "),
                  o.push("enum ", n("id"), " "),
                  0 === r.members.length
                    ? o.push(AP(["{", DP(e, t), wP, "}"]))
                    : o.push(
                        AP([
                          "{",
                          SP([
                            xP,
                            VP(e, t, "members", n),
                            OP(t, "es5") ? "," : "",
                          ]),
                          DP(e, t, !0),
                          xP,
                          "}",
                        ])
                      ),
                  o
                );
              case "TSEnumMember":
                return (
                  o.push(n("id")),
                  r.initializer && o.push(" = ", n("initializer")),
                  o
                );
              case "TSImportEqualsDeclaration":
                return (
                  r.isExport && o.push("export "),
                  o.push("import "),
                  r.importKind &&
                    "value" !== r.importKind &&
                    o.push(r.importKind, " "),
                  o.push(n("id"), " = ", n("moduleReference")),
                  t.semi && o.push(";"),
                  AP(o)
                );
              case "TSExternalModuleReference":
                return ["require(", n("expression"), ")"];
              case "TSModuleDeclaration": {
                const s = e.getParentNode(),
                  a = FP(r.id),
                  u = "TSModuleDeclaration" === s.type,
                  l = r.body && "TSModuleDeclaration" === r.body.type;
                if (u) o.push(".");
                else {
                  r.declare && o.push("declare "), o.push(jP(e, t, n));
                  const i = t.originalText.slice(NP(r), NP(r.id));
                  ("Identifier" === r.id.type &&
                    "global" === r.id.name &&
                    !/namespace|module/.test(i)) ||
                    o.push(
                      a || /(?:^|\s)module(?:\s|$)/.test(i)
                        ? "module "
                        : "namespace "
                    );
                }
                return (
                  o.push(n("id")),
                  l
                    ? o.push(n("body"))
                    : r.body
                    ? o.push(" ", AP(n("body")))
                    : o.push(i),
                  o
                );
              }
              case "TSConditionalType":
                return LP(e, t, n);
              case "TSInferType":
                return ["infer", " ", n("typeParameter")];
              case "TSIntersectionType":
                return eN(e, t, n);
              case "TSUnionType":
                return tN(e, t, n);
              case "TSFunctionType":
                return nN(e, t, n);
              case "TSTupleType":
                return rN(e, t, n);
              case "TSTypeReference":
                return [n("typeName"), GP(e, t, n, "typeParameters")];
              case "TSTypeAnnotation":
                return n("typeAnnotation");
              case "TSEmptyBodyFunctionExpression":
                return JP(e, t, n);
              case "TSJSDocAllType":
                return "*";
              case "TSJSDocUnknownType":
                return "?";
              case "TSJSDocNullableType":
                return ["?", n("typeAnnotation")];
              case "TSJSDocNonNullableType":
                return ["!", n("typeAnnotation")];
              default:
                throw new Error(
                  "Unknown TypeScript node type: ".concat(
                    JSON.stringify(r.type),
                    "."
                  )
                );
            }
          },
        };
        const { hasNewline: sN } = nl,
          {
            builders: { join: aN, hardline: uN },
            utils: { replaceTextEndOfLine: lN },
          } = Vl,
          { isLineComment: cN, isBlockComment: pN } = eb,
          { locStart: fN, locEnd: dN } = Vh;
        var hN = {
          printComment: function (e, t) {
            const n = e.getValue();
            if (cN(n)) return t.originalText.slice(fN(n), dN(n)).trimEnd();
            if (pN(n)) {
              if (
                (function (e) {
                  const t = "*".concat(e.value, "*").split("\n");
                  return t.length > 1 && t.every((e) => "*" === e.trim()[0]);
                })(n)
              ) {
                const e = (function (e) {
                  const t = e.value.split("\n");
                  return [
                    "/*",
                    aN(
                      uN,
                      t.map((e, n) =>
                        0 === n
                          ? e.trimEnd()
                          : " " + (n < t.length - 1 ? e.trim() : e.trimStart())
                      )
                    ),
                    "*/",
                  ];
                })(n);
                return n.trailing &&
                  !sN(t.originalText, fN(n), { backwards: !0 })
                  ? [uN, e]
                  : e;
              }
              const e = dN(n),
                r = "*-/" === t.originalText.slice(e - 3, e);
              return ["/*", lN(n.value), r ? "*-/" : "*/"];
            }
            throw new Error("Not a comment: " + JSON.stringify(n));
          },
        };
        const { printString: mN, printNumber: gN } = nl;
        function yN(e) {
          return e.toLowerCase();
        }
        function vN(e) {
          let { pattern: t, flags: n } = e;
          return (n = [...n].sort().join("")), "/".concat(t, "/").concat(n);
        }
        var DN = {
          printLiteral: function (e, t) {
            const n = e.getNode();
            switch (n.type) {
              case "RegExpLiteral":
                return vN(n);
              case "BigIntLiteral":
                return yN(n.bigint || n.extra.raw);
              case "NumericLiteral":
                return gN(n.extra.raw);
              case "StringLiteral":
                return mN(n.extra.raw, t);
              case "NullLiteral":
                return "null";
              case "BooleanLiteral":
                return String(n.value);
              case "DecimalLiteral":
                return gN(n.value) + "m";
              case "Literal": {
                if (n.regex) return vN(n.regex);
                if (n.bigint) return yN(n.raw);
                if (n.decimal) return gN(n.decimal) + "m";
                const { value: e } = n;
                return "number" == typeof e
                  ? gN(n.raw)
                  : "string" == typeof e
                  ? mN(n.raw, t)
                  : String(e);
              }
            }
          },
        };
        const { printDanglingComments: bN } = Iy,
          { hasNewline: EN } = nl,
          {
            builders: {
              join: CN,
              line: xN,
              hardline: wN,
              softline: AN,
              group: SN,
              indent: _N,
            },
            utils: { replaceTextEndOfLine: TN },
          } = Vl,
          FN = function (e, t, n, r) {
            const i = e.getValue();
            if (
              "TemplateLiteral" !== i.type ||
              (function (e) {
                let { quasis: t } = e;
                return t.some((e) => {
                  let {
                    value: { cooked: t },
                  } = e;
                  return null === t;
                });
              })(i)
            )
              return;
            const o = (function (e) {
              return (function (e) {
                const t = e.getValue(),
                  n = e.getParentNode(),
                  r = e.getParentNode(1);
                return (
                  (r &&
                    t.quasis &&
                    "JSXExpressionContainer" === n.type &&
                    "JSXElement" === r.type &&
                    "style" === r.openingElement.name.name &&
                    r.openingElement.attributes.some(
                      (e) => "jsx" === e.name.name
                    )) ||
                  (n &&
                    "TaggedTemplateExpression" === n.type &&
                    "Identifier" === n.tag.type &&
                    "css" === n.tag.name) ||
                  (n &&
                    "TaggedTemplateExpression" === n.type &&
                    "MemberExpression" === n.tag.type &&
                    "css" === n.tag.object.name &&
                    ("global" === n.tag.property.name ||
                      "resolve" === n.tag.property.name))
                );
              })(e) ||
                (function (e) {
                  const t = e.getParentNode();
                  if (!t || "TaggedTemplateExpression" !== t.type) return !1;
                  const n =
                    "ParenthesizedExpression" === t.tag.type
                      ? t.tag.expression
                      : t.tag;
                  switch (n.type) {
                    case "MemberExpression":
                      return nE(n.object) || rE(n);
                    case "CallExpression":
                      return (
                        nE(n.callee) ||
                        ("MemberExpression" === n.callee.type &&
                          (("MemberExpression" === n.callee.object.type &&
                            (nE(n.callee.object.object) ||
                              rE(n.callee.object))) ||
                            ("CallExpression" === n.callee.object.type &&
                              nE(n.callee.object.callee))))
                      );
                    case "Identifier":
                      return "css" === n.name;
                    default:
                      return !1;
                  }
                })(e) ||
                (function (e) {
                  const t = e.getParentNode(),
                    n = e.getParentNode(1);
                  return (
                    n &&
                    "JSXExpressionContainer" === t.type &&
                    "JSXAttribute" === n.type &&
                    "JSXIdentifier" === n.name.type &&
                    "css" === n.name.name
                  );
                })(e) ||
                (function (e) {
                  return e.match(
                    (e) => "TemplateLiteral" === e.type,
                    (e, t) => "ArrayExpression" === e.type && "elements" === t,
                    (e, t) =>
                      Jb(e) &&
                      "Identifier" === e.key.type &&
                      "styles" === e.key.name &&
                      "value" === t,
                    ...tE
                  );
                })(e)
                ? "css"
                : (function (e) {
                    const t = e.getValue(),
                      n = e.getParentNode();
                    return (
                      iE(t, "GraphQL") ||
                      (n &&
                        (("TaggedTemplateExpression" === n.type &&
                          (("MemberExpression" === n.tag.type &&
                            "graphql" === n.tag.object.name &&
                            "experimental" === n.tag.property.name) ||
                            ("Identifier" === n.tag.type &&
                              ("gql" === n.tag.name ||
                                "graphql" === n.tag.name)))) ||
                          ("CallExpression" === n.type &&
                            "Identifier" === n.callee.type &&
                            "graphql" === n.callee.name)))
                    );
                  })(e)
                ? "graphql"
                : (function (e) {
                    return (
                      iE(e.getValue(), "HTML") ||
                      e.match(
                        (e) => "TemplateLiteral" === e.type,
                        (e, t) =>
                          "TaggedTemplateExpression" === e.type &&
                          "Identifier" === e.tag.type &&
                          "html" === e.tag.name &&
                          "quasi" === t
                      )
                    );
                  })(e)
                ? "html"
                : (function (e) {
                    return e.match(
                      (e) => "TemplateLiteral" === e.type,
                      (e, t) =>
                        Jb(e) &&
                        "Identifier" === e.key.type &&
                        "template" === e.key.name &&
                        "value" === t,
                      ...tE
                    );
                  })(e)
                ? "angular"
                : (function (e) {
                    const t = e.getValue(),
                      n = e.getParentNode();
                    return (
                      n &&
                      "TaggedTemplateExpression" === n.type &&
                      1 === t.quasis.length &&
                      "Identifier" === n.tag.type &&
                      ("md" === n.tag.name || "markdown" === n.tag.name)
                    );
                  })(e)
                ? "markdown"
                : void 0;
            })(e);
            return o
              ? "markdown" === o
                ? Zb(e, t, n)
                : "css" === o
                ? Kb(e, t, n)
                : "graphql" === o
                ? Qb(e, t, n)
                : "html" === o || "angular" === o
                ? eE(e, t, n, r, { parser: o })
                : void 0
              : void 0;
          },
          kN = lE,
          { insertPragma: ON } = PE,
          BN = LC,
          PN = tx,
          NN = nx,
          {
            hasFlowShorthandAnnotationComment: MN,
            hasComment: IN,
            CommentCheckFlags: jN,
            isTheOnlyJsxElementInMarkdown: LN,
            isBlockComment: $N,
            isLineComment: RN,
            isNextLineEmpty: zN,
            needsHardlineAfterDanglingComment: VN,
            rawText: qN,
            hasIgnoreComment: WN,
            isCallExpression: UN,
            isMemberExpression: HN,
          } = eb,
          { locStart: GN, locEnd: YN } = Vh,
          { printHtmlBinding: XN, isVueEventBindingExpression: JN } = ux,
          { printAngular: ZN } = Wx,
          { printJsx: KN, hasJsxIgnoreComment: QN } = Aw,
          { printFlow: eM } = TB,
          { printTypescript: tM } = oN,
          {
            printOptionalToken: nM,
            printBindExpressionCallee: rM,
            printTypeAnnotation: iM,
            adjustClause: oM,
            printRestSpread: sM,
          } = uA,
          {
            printImportDeclaration: aM,
            printExportDeclaration: uM,
            printExportAllDeclaration: lM,
            printModuleSpecifier: cM,
          } = CO,
          { printTernary: pM } = GB,
          { printTemplateLiteral: fM } = bb,
          { printArray: dM } = OA,
          { printObject: hM } = HO,
          { printClass: mM, printClassMethod: gM, printClassProperty: yM } = Vk,
          { printProperty: vM } = mF,
          {
            printFunction: DM,
            printArrowFunction: bM,
            printMethod: EM,
            printReturnStatement: CM,
            printThrowStatement: xM,
          } = ik,
          { printCallExpression: wM } = u_,
          { printVariableDeclarator: AM, printAssignmentExpression: SM } = R_,
          { printBinaryishExpression: _M } = Mx,
          { printSwitchCaseConsequent: TM } = aP,
          { printMemberExpression: FM } = yS,
          { printBlock: kM, printBlockBody: OM } = vP,
          { printComment: BM } = hN,
          { printLiteral: PM } = DN,
          { printDecorators: NM } = yk;
        function MM(e, t) {
          const n = qN(e),
            r = n.slice(1, -1);
          if (r.includes('"') || r.includes("'")) return n;
          const i = t.singleQuote ? "'" : '"';
          return i + r + i;
        }
        var IM = {
          preprocess: NN,
          print: function (e, t, n, r) {
            const i = (function (e, t, n, r) {
              const i = e.getValue(),
                o = t.semi ? ";" : "";
              if (!i) return "";
              if ("string" == typeof i) return i;
              for (const r of [PM, XN, ZN, KN, eM, tM]) {
                const i = r(e, t, n);
                if (void 0 !== i) return i;
              }
              let s = [];
              switch (i.type) {
                case "JsExpressionRoot":
                  return n("node");
                case "JsonRoot":
                  return [n("node"), wN];
                case "File":
                  return (
                    i.program &&
                      i.program.interpreter &&
                      s.push(n(["program", "interpreter"])),
                    s.push(n("program")),
                    s
                  );
                case "Program":
                  return OM(e, t, n);
                case "EmptyStatement":
                  return "";
                case "ExpressionStatement":
                  if (i.directive) return [MM(i.expression, t), o];
                  if ("__vue_event_binding" === t.parser) {
                    const t = e.getParentNode();
                    if (
                      "Program" === t.type &&
                      1 === t.body.length &&
                      t.body[0] === i
                    )
                      return [n("expression"), JN(i.expression) ? ";" : ""];
                  }
                  return [n("expression"), LN(t, e) ? "" : o];
                case "ParenthesizedExpression":
                  return IN(i.expression) ||
                    ("ObjectExpression" !== i.expression.type &&
                      "ArrayExpression" !== i.expression.type)
                    ? SN(["(", _N([AN, n("expression")]), AN, ")"])
                    : ["(", n("expression"), ")"];
                case "AssignmentExpression":
                  return SM(e, t, n);
                case "VariableDeclarator":
                  return AM(e, t, n);
                case "BinaryExpression":
                case "LogicalExpression":
                  return _M(e, t, n);
                case "AssignmentPattern":
                  return [n("left"), " = ", n("right")];
                case "OptionalMemberExpression":
                case "MemberExpression":
                  return FM(e, t, n);
                case "MetaProperty":
                  return [n("meta"), ".", n("property")];
                case "BindExpression":
                  return (
                    i.object && s.push(n("object")),
                    s.push(SN(_N([AN, rM(e, t, n)]))),
                    s
                  );
                case "Identifier":
                  return [i.name, nM(e), iM(e, t, n)];
                case "V8IntrinsicIdentifier":
                  return ["%", i.name];
                case "SpreadElement":
                case "SpreadElementPattern":
                case "SpreadProperty":
                case "SpreadPropertyPattern":
                case "RestElement":
                  return sM(e, t, n);
                case "FunctionDeclaration":
                case "FunctionExpression":
                  return DM(e, n, t, r);
                case "ArrowFunctionExpression":
                  return bM(e, t, n, r);
                case "YieldExpression":
                  return (
                    s.push("yield"),
                    i.delegate && s.push("*"),
                    i.argument && s.push(" ", n("argument")),
                    s
                  );
                case "AwaitExpression":
                  if ((s.push("await"), i.argument)) {
                    s.push(" ", n("argument"));
                    const t = e.getParentNode();
                    if (
                      (UN(t) && t.callee === i) ||
                      (HN(t) && t.object === i)
                    ) {
                      s = [_N([AN, ...s]), AN];
                      const t = e.findAncestor(
                        (e) =>
                          "AwaitExpression" === e.type ||
                          "BlockStatement" === e.type
                      );
                      if (!t || "AwaitExpression" !== t.type) return SN(s);
                    }
                  }
                  return s;
                case "ExportDefaultDeclaration":
                case "ExportNamedDeclaration":
                  return uM(e, t, n);
                case "ExportAllDeclaration":
                  return lM(e, t, n);
                case "ImportDeclaration":
                  return aM(e, t, n);
                case "ImportSpecifier":
                case "ExportSpecifier":
                case "ImportNamespaceSpecifier":
                case "ExportNamespaceSpecifier":
                case "ImportDefaultSpecifier":
                case "ExportDefaultSpecifier":
                  return cM(e, t, n);
                case "ImportAttribute":
                  return [n("key"), ": ", n("value")];
                case "Import":
                  return "import";
                case "BlockStatement":
                case "StaticBlock":
                case "ClassBody":
                  return kM(e, t, n);
                case "ThrowStatement":
                  return xM(e, t, n);
                case "ReturnStatement":
                  return CM(e, t, n);
                case "NewExpression":
                case "ImportExpression":
                case "OptionalCallExpression":
                case "CallExpression":
                  return wM(e, t, n);
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                  return hM(e, t, n);
                case "ObjectProperty":
                case "Property":
                  return i.method || "get" === i.kind || "set" === i.kind
                    ? EM(e, t, n)
                    : vM(e, t, n);
                case "ObjectMethod":
                  return EM(e, t, n);
                case "Decorator":
                  return ["@", n("expression")];
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                  return dM(e, t, n);
                case "SequenceExpression": {
                  const t = e.getParentNode(0);
                  if (
                    "ExpressionStatement" === t.type ||
                    "ForStatement" === t.type
                  ) {
                    const t = [];
                    return (
                      e.each((e, r) => {
                        0 === r ? t.push(n()) : t.push(",", _N([xN, n()]));
                      }, "expressions"),
                      SN(t)
                    );
                  }
                  return SN(CN([",", xN], e.map(n, "expressions")));
                }
                case "ThisExpression":
                  return "this";
                case "Super":
                  return "super";
                case "Directive":
                  return [n("value"), o];
                case "DirectiveLiteral":
                  return MM(i, t);
                case "UnaryExpression":
                  return (
                    s.push(i.operator),
                    /[a-z]$/.test(i.operator) && s.push(" "),
                    IN(i.argument)
                      ? s.push(SN(["(", _N([AN, n("argument")]), AN, ")"]))
                      : s.push(n("argument")),
                    s
                  );
                case "UpdateExpression":
                  return (
                    s.push(n("argument"), i.operator),
                    i.prefix && s.reverse(),
                    s
                  );
                case "ConditionalExpression":
                  return pM(e, t, n);
                case "VariableDeclaration": {
                  const t = e.map(n, "declarations"),
                    r = e.getParentNode(),
                    a =
                      "ForStatement" === r.type ||
                      "ForInStatement" === r.type ||
                      "ForOfStatement" === r.type,
                    u = i.declarations.some((e) => e.init);
                  let l;
                  return (
                    1 !== t.length || IN(i.declarations[0])
                      ? t.length > 0 && (l = _N(t[0]))
                      : (l = t[0]),
                    (s = [
                      i.declare ? "declare " : "",
                      i.kind,
                      l ? [" ", l] : "",
                      _N(t.slice(1).map((e) => [",", u && !a ? wN : xN, e])),
                    ]),
                    (a && r.body !== i) || s.push(o),
                    SN(s)
                  );
                }
                case "WithStatement":
                  return SN([
                    "with (",
                    n("object"),
                    ")",
                    oM(i.body, n("body")),
                  ]);
                case "IfStatement": {
                  const r = oM(i.consequent, n("consequent")),
                    o = SN(["if (", SN([_N([AN, n("test")]), AN]), ")", r]);
                  if ((s.push(o), i.alternate)) {
                    const r = IN(i.consequent, jN.Trailing | jN.Line) || VN(i),
                      o = "BlockStatement" === i.consequent.type && !r;
                    s.push(o ? " " : wN),
                      IN(i, jN.Dangling) && s.push(bN(e, t, !0), r ? wN : " "),
                      s.push(
                        "else",
                        SN(
                          oM(
                            i.alternate,
                            n("alternate"),
                            "IfStatement" === i.alternate.type
                          )
                        )
                      );
                  }
                  return s;
                }
                case "ForStatement": {
                  const r = oM(i.body, n("body")),
                    o = bN(e, t, !0),
                    s = o ? [o, AN] : "";
                  return i.init || i.test || i.update
                    ? [
                        s,
                        SN([
                          "for (",
                          SN([
                            _N([
                              AN,
                              n("init"),
                              ";",
                              xN,
                              n("test"),
                              ";",
                              xN,
                              n("update"),
                            ]),
                            AN,
                          ]),
                          ")",
                          r,
                        ]),
                      ]
                    : [s, SN(["for (;;)", r])];
                }
                case "WhileStatement":
                  return SN([
                    "while (",
                    SN([_N([AN, n("test")]), AN]),
                    ")",
                    oM(i.body, n("body")),
                  ]);
                case "ForInStatement":
                  return SN([
                    "for (",
                    n("left"),
                    " in ",
                    n("right"),
                    ")",
                    oM(i.body, n("body")),
                  ]);
                case "ForOfStatement":
                  return SN([
                    "for",
                    i.await ? " await" : "",
                    " (",
                    n("left"),
                    " of ",
                    n("right"),
                    ")",
                    oM(i.body, n("body")),
                  ]);
                case "DoWhileStatement": {
                  const e = oM(i.body, n("body"));
                  return (
                    (s = [SN(["do", e])]),
                    "BlockStatement" === i.body.type ? s.push(" ") : s.push(wN),
                    s.push("while (", SN([_N([AN, n("test")]), AN]), ")", o),
                    s
                  );
                }
                case "DoExpression":
                  return [i.async ? "async " : "", "do ", n("body")];
                case "BreakStatement":
                  return (
                    s.push("break"),
                    i.label && s.push(" ", n("label")),
                    s.push(o),
                    s
                  );
                case "ContinueStatement":
                  return (
                    s.push("continue"),
                    i.label && s.push(" ", n("label")),
                    s.push(o),
                    s
                  );
                case "LabeledStatement":
                  return "EmptyStatement" === i.body.type
                    ? [n("label"), ":;"]
                    : [n("label"), ": ", n("body")];
                case "TryStatement":
                  return [
                    "try ",
                    n("block"),
                    i.handler ? [" ", n("handler")] : "",
                    i.finalizer ? [" finally ", n("finalizer")] : "",
                  ];
                case "CatchClause":
                  if (i.param) {
                    const e = IN(
                        i.param,
                        (e) =>
                          !$N(e) ||
                          (e.leading && EN(t.originalText, YN(e))) ||
                          (e.trailing &&
                            EN(t.originalText, GN(e), { backwards: !0 }))
                      ),
                      r = n("param");
                    return [
                      "catch ",
                      e ? ["(", _N([AN, r]), AN, ") "] : ["(", r, ") "],
                      n("body"),
                    ];
                  }
                  return ["catch ", n("body")];
                case "SwitchStatement":
                  return [
                    SN(["switch (", _N([AN, n("discriminant")]), AN, ")"]),
                    " {",
                    i.cases.length > 0
                      ? _N([
                          wN,
                          CN(
                            wN,
                            e.map((e, r, i) => {
                              const o = e.getValue();
                              return [
                                n(),
                                r !== i.length - 1 && zN(o, t) ? wN : "",
                              ];
                            }, "cases")
                          ),
                        ])
                      : "",
                    wN,
                    "}",
                  ];
                case "SwitchCase": {
                  i.test ? s.push("case ", n("test"), ":") : s.push("default:");
                  const r = i.consequent.filter(
                    (e) => "EmptyStatement" !== e.type
                  );
                  if (r.length > 0) {
                    const i = TM(e, t, n);
                    s.push(
                      1 === r.length && "BlockStatement" === r[0].type
                        ? [" ", i]
                        : _N([wN, i])
                    );
                  }
                  return s;
                }
                case "DebuggerStatement":
                  return ["debugger", o];
                case "ClassDeclaration":
                case "ClassExpression":
                  return mM(e, t, n);
                case "ClassMethod":
                case "ClassPrivateMethod":
                case "MethodDefinition":
                  return gM(e, t, n);
                case "ClassProperty":
                case "PropertyDefinition":
                case "ClassPrivateProperty":
                  return yM(e, t, n);
                case "TemplateElement":
                  return TN(i.value.raw);
                case "TemplateLiteral":
                  return fM(e, n, t);
                case "TaggedTemplateExpression":
                  return [n("tag"), n("typeParameters"), n("quasi")];
                case "PrivateIdentifier":
                  return ["#", n("name")];
                case "PrivateName":
                  return ["#", n("id")];
                case "InterpreterDirective":
                  return s.push("#!", i.value, wN), zN(i, t) && s.push(wN), s;
                case "TopicReference":
                  return "%";
                case "ArgumentPlaceholder":
                  return "?";
                case "ModuleExpression": {
                  s.push("module {");
                  const e = n("body");
                  return e && s.push(_N([wN, e]), wN), s.push("}"), s;
                }
                default:
                  throw new Error("unknown type: " + JSON.stringify(i.type));
              }
            })(e, t, n, r);
            if (!i) return "";
            const o = e.getValue(),
              { type: s } = o;
            if (
              "ClassMethod" === s ||
              "ClassPrivateMethod" === s ||
              "ClassProperty" === s ||
              "PropertyDefinition" === s ||
              "TSAbstractPropertyDefinition" === s ||
              "ClassPrivateProperty" === s ||
              "MethodDefinition" === s ||
              "TSAbstractMethodDefinition" === s ||
              "TSDeclareMethod" === s
            )
              return i;
            const a = NM(e, t, n);
            if (a) return SN([...a, i]);
            if (!PN(e, t)) return r && r.needsSemi ? [";", i] : i;
            const u = [r && r.needsSemi ? ";(" : "(", i];
            if (MN(o)) {
              const [e] = o.trailingComments;
              u.push(" /*", e.value.trimStart(), "*/"), (e.printed = !0);
            }
            return u.push(")"), u;
          },
          embed: FN,
          insertPragma: ON,
          massageAstNode: kN,
          hasPrettierIgnore: (e) => WN(e) || QN(e),
          willPrintOwnComments: BN.willPrintOwnComments,
          canAttachComment: function (e) {
            return (
              e.type &&
              !$N(e) &&
              !RN(e) &&
              "EmptyStatement" !== e.type &&
              "TemplateElement" !== e.type &&
              "Import" !== e.type &&
              "TSEmptyBodyFunctionExpression" !== e.type
            );
          },
          printComment: BM,
          isBlockComment: $N,
          handleComments: {
            avoidAstMutation: !0,
            ownLine: BN.handleOwnLineComment,
            endOfLine: BN.handleEndOfLineComment,
            remaining: BN.handleRemainingComment,
          },
          getCommentChildNodes: BN.getCommentChildNodes,
        };
        const {
            builders: { hardline: jM, indent: LM, join: $M },
          } = Vl,
          RM = nx,
          zM = new Set([
            "start",
            "end",
            "extra",
            "loc",
            "comments",
            "leadingComments",
            "trailingComments",
            "innerComments",
            "errors",
            "range",
            "tokens",
          ]);
        function VM(e, t) {
          const { type: n } = e;
          if ("ObjectProperty" !== n || "Identifier" !== e.key.type) {
            if ("UnaryExpression" === n && "+" === e.operator)
              return t.argument;
            if ("ArrayExpression" !== n)
              return "TemplateLiteral" === n
                ? { type: "StringLiteral", value: e.quasis[0].value.cooked }
                : void 0;
            for (const [n, r] of e.elements.entries())
              null === r && t.elements.splice(n, 0, { type: "NullLiteral" });
          } else t.key = { type: "StringLiteral", value: e.key.name };
        }
        VM.ignoredProperties = zM;
        var qM = {
          preprocess: RM,
          print: function (e, t, n) {
            const r = e.getValue();
            switch (r.type) {
              case "JsonRoot":
                return [n("node"), jM];
              case "ArrayExpression": {
                if (0 === r.elements.length) return "[]";
                const t = e.map(
                  () => (null === e.getValue() ? "null" : n()),
                  "elements"
                );
                return ["[", LM([jM, $M([",", jM], t)]), jM, "]"];
              }
              case "ObjectExpression":
                return 0 === r.properties.length
                  ? "{}"
                  : [
                      "{",
                      LM([jM, $M([",", jM], e.map(n, "properties"))]),
                      jM,
                      "}",
                    ];
              case "ObjectProperty":
                return [n("key"), ": ", n("value")];
              case "UnaryExpression":
                return ["+" === r.operator ? "" : r.operator, n("argument")];
              case "NullLiteral":
                return "null";
              case "BooleanLiteral":
                return r.value ? "true" : "false";
              case "StringLiteral":
              case "NumericLiteral":
                return JSON.stringify(r.value);
              case "Identifier": {
                const t = e.getParentNode();
                return t && "ObjectProperty" === t.type && t.key === r
                  ? JSON.stringify(r.name)
                  : r.name;
              }
              case "TemplateLiteral":
                return n(["quasis", 0]);
              case "TemplateElement":
                return JSON.stringify(r.value.cooked);
              default:
                throw new Error("unknown type: " + JSON.stringify(r.type));
            }
          },
          massageAstNode: VM,
        };
        const WM = "Common";
        var UM = {
          bracketSpacing: {
            since: "0.0.0",
            category: WM,
            type: "boolean",
            default: !0,
            description: "Print spaces between brackets.",
            oppositeDescription: "Do not print spaces between brackets.",
          },
          singleQuote: {
            since: "0.0.0",
            category: WM,
            type: "boolean",
            default: !1,
            description: "Use single quotes instead of double quotes.",
          },
          proseWrap: {
            since: "1.8.2",
            category: WM,
            type: "choice",
            default: [
              { since: "1.8.2", value: !0 },
              { since: "1.9.0", value: "preserve" },
            ],
            description: "How to wrap prose.",
            choices: [
              {
                since: "1.9.0",
                value: "always",
                description: "Wrap prose if it exceeds the print width.",
              },
              {
                since: "1.9.0",
                value: "never",
                description: "Do not wrap prose.",
              },
              {
                since: "1.9.0",
                value: "preserve",
                description: "Wrap prose as-is.",
              },
            ],
          },
          bracketSameLine: {
            since: "2.4.0",
            category: WM,
            type: "boolean",
            default: !1,
            description:
              "Put > of opening tags on the last line instead of on a new line.",
          },
        };
        const HM = "JavaScript";
        var GM = {
            name: "JavaScript",
            type: "programming",
            tmScope: "source.js",
            aceMode: "javascript",
            codemirrorMode: "javascript",
            codemirrorMimeType: "text/javascript",
            color: "#f1e05a",
            aliases: ["js", "node"],
            extensions: [
              ".js",
              "._js",
              ".bones",
              ".cjs",
              ".es",
              ".es6",
              ".frag",
              ".gs",
              ".jake",
              ".jsb",
              ".jscad",
              ".jsfl",
              ".jsm",
              ".jss",
              ".jsx",
              ".mjs",
              ".njs",
              ".pac",
              ".sjs",
              ".ssjs",
              ".xsjs",
              ".xsjslib",
            ],
            filenames: ["Jakefile"],
            interpreters: [
              "chakra",
              "d8",
              "gjs",
              "js",
              "node",
              "nodejs",
              "qjs",
              "rhino",
              "v8",
              "v8-shell",
            ],
            languageId: 183,
          },
          YM = {
            name: "JSON",
            type: "data",
            tmScope: "source.json",
            aceMode: "json",
            codemirrorMode: "javascript",
            codemirrorMimeType: "application/json",
            extensions: [
              ".json",
              ".avsc",
              ".geojson",
              ".gltf",
              ".har",
              ".ice",
              ".JSON-tmLanguage",
              ".jsonl",
              ".mcmeta",
              ".tfstate",
              ".tfstate.backup",
              ".topojson",
              ".webapp",
              ".webmanifest",
              ".yy",
              ".yyp",
            ],
            filenames: [
              ".arcconfig",
              ".htmlhintrc",
              ".imgbotconfig",
              ".tern-config",
              ".tern-project",
              ".watchmanconfig",
              "Pipfile.lock",
              "composer.lock",
              "mcmod.info",
            ],
            languageId: 174,
          };
        const XM = tD,
          JM = IM,
          ZM = qM,
          KM = {
            arrowParens: {
              since: "1.9.0",
              category: HM,
              type: "choice",
              default: [
                { since: "1.9.0", value: "avoid" },
                { since: "2.0.0", value: "always" },
              ],
              description:
                "Include parentheses around a sole arrow function parameter.",
              choices: [
                {
                  value: "always",
                  description: "Always include parens. Example: `(x) => x`",
                },
                {
                  value: "avoid",
                  description: "Omit parens when possible. Example: `x => x`",
                },
              ],
            },
            bracketSameLine: UM.bracketSameLine,
            bracketSpacing: UM.bracketSpacing,
            jsxBracketSameLine: {
              since: "0.17.0",
              category: HM,
              type: "boolean",
              description: "Put > on the last line instead of at a new line.",
              deprecated: "2.4.0",
            },
            semi: {
              since: "1.0.0",
              category: HM,
              type: "boolean",
              default: !0,
              description: "Print semicolons.",
              oppositeDescription:
                "Do not print semicolons, except at the beginning of lines which may need them.",
            },
            singleQuote: UM.singleQuote,
            jsxSingleQuote: {
              since: "1.15.0",
              category: HM,
              type: "boolean",
              default: !1,
              description: "Use single quotes in JSX.",
            },
            quoteProps: {
              since: "1.17.0",
              category: HM,
              type: "choice",
              default: "as-needed",
              description: "Change when properties in objects are quoted.",
              choices: [
                {
                  value: "as-needed",
                  description:
                    "Only add quotes around object properties where required.",
                },
                {
                  value: "consistent",
                  description:
                    "If at least one property in an object requires quotes, quote all properties.",
                },
                {
                  value: "preserve",
                  description:
                    "Respect the input use of quotes in object properties.",
                },
              ],
            },
            trailingComma: {
              since: "0.0.0",
              category: HM,
              type: "choice",
              default: [
                { since: "0.0.0", value: !1 },
                { since: "0.19.0", value: "none" },
                { since: "2.0.0", value: "es5" },
              ],
              description:
                "Print trailing commas wherever possible when multi-line.",
              choices: [
                {
                  value: "es5",
                  description:
                    "Trailing commas where valid in ES5 (objects, arrays, etc.)",
                },
                { value: "none", description: "No trailing commas." },
                {
                  value: "all",
                  description:
                    "Trailing commas wherever possible (including function arguments).",
                },
              ],
            },
          },
          QM = [
            XM(GM, (e) => ({
              since: "0.0.0",
              parsers: [
                "babel",
                "espree",
                "meriyah",
                "babel-flow",
                "babel-ts",
                "flow",
                "typescript",
              ],
              vscodeLanguageIds: ["javascript", "mongo"],
              interpreters: [...e.interpreters, "zx"],
              extensions: [...e.extensions.filter((e) => ".jsx" !== e), ".wxs"],
            })),
            XM(GM, () => ({
              name: "Flow",
              since: "0.0.0",
              parsers: ["flow", "babel-flow"],
              vscodeLanguageIds: ["javascript"],
              aliases: [],
              filenames: [],
              extensions: [".js.flow"],
            })),
            XM(GM, () => ({
              name: "JSX",
              since: "0.0.0",
              parsers: [
                "babel",
                "babel-flow",
                "babel-ts",
                "flow",
                "typescript",
                "espree",
                "meriyah",
              ],
              vscodeLanguageIds: ["javascriptreact"],
              aliases: void 0,
              filenames: void 0,
              extensions: [".jsx"],
              group: "JavaScript",
              interpreters: void 0,
              tmScope: "source.js.jsx",
              aceMode: "javascript",
              codemirrorMode: "jsx",
              codemirrorMimeType: "text/jsx",
              color: void 0,
            })),
            XM(
              {
                name: "TypeScript",
                type: "programming",
                color: "#2b7489",
                aliases: ["ts"],
                interpreters: ["deno", "ts-node"],
                extensions: [".ts"],
                tmScope: "source.ts",
                aceMode: "typescript",
                codemirrorMode: "javascript",
                codemirrorMimeType: "application/typescript",
                languageId: 378,
              },
              (e) => ({
                since: "1.4.0",
                parsers: ["typescript", "babel-ts"],
                vscodeLanguageIds: ["typescript"],
                extensions: [...e.extensions, ".mts", ".cts"],
              })
            ),
            XM(
              {
                name: "TSX",
                type: "programming",
                group: "TypeScript",
                extensions: [".tsx"],
                tmScope: "source.tsx",
                aceMode: "javascript",
                codemirrorMode: "jsx",
                codemirrorMimeType: "text/jsx",
                languageId: 94901924,
              },
              () => ({
                since: "1.4.0",
                parsers: ["typescript", "babel-ts"],
                vscodeLanguageIds: ["typescriptreact"],
              })
            ),
            XM(YM, () => ({
              name: "JSON.stringify",
              since: "1.13.0",
              parsers: ["json-stringify"],
              vscodeLanguageIds: ["json"],
              extensions: [],
              filenames: ["package.json", "package-lock.json", "composer.json"],
            })),
            XM(YM, (e) => ({
              since: "1.5.0",
              parsers: ["json"],
              vscodeLanguageIds: ["json"],
              extensions: e.extensions.filter((e) => ".jsonl" !== e),
            })),
            XM(
              {
                name: "JSON with Comments",
                type: "data",
                group: "JSON",
                tmScope: "source.js",
                aceMode: "javascript",
                codemirrorMode: "javascript",
                codemirrorMimeType: "text/javascript",
                aliases: ["jsonc"],
                extensions: [
                  ".jsonc",
                  ".sublime-build",
                  ".sublime-commands",
                  ".sublime-completions",
                  ".sublime-keymap",
                  ".sublime-macro",
                  ".sublime-menu",
                  ".sublime-mousemap",
                  ".sublime-project",
                  ".sublime-settings",
                  ".sublime-theme",
                  ".sublime-workspace",
                  ".sublime_metrics",
                  ".sublime_session",
                ],
                filenames: [
                  ".babelrc",
                  ".eslintrc.json",
                  ".jscsrc",
                  ".jshintrc",
                  ".jslintrc",
                  "api-extractor.json",
                  "devcontainer.json",
                  "jsconfig.json",
                  "language-configuration.json",
                  "tsconfig.json",
                  "tslint.json",
                ],
                languageId: 423,
              },
              (e) => ({
                since: "1.5.0",
                parsers: ["json"],
                vscodeLanguageIds: ["jsonc"],
                filenames: [...e.filenames, ".eslintrc"],
              })
            ),
            XM(
              {
                name: "JSON5",
                type: "data",
                extensions: [".json5"],
                tmScope: "source.js",
                aceMode: "javascript",
                codemirrorMode: "javascript",
                codemirrorMimeType: "application/json",
                languageId: 175,
              },
              () => ({
                since: "1.13.0",
                parsers: ["json5"],
                vscodeLanguageIds: ["json5"],
              })
            ),
          ];
        var eI = {
          languages: QM,
          options: KM,
          printers: { estree: JM, "estree-json": ZM },
          parsers: void 0,
        };
        const { isFrontMatterNode: tI } = nl,
          nI = ns,
          rI = new Set([
            "raw",
            "raws",
            "sourceIndex",
            "source",
            "before",
            "after",
            "trailingComma",
          ]);
        function iI(e, t, n) {
          if (
            (tI(e) && "yaml" === e.lang && delete t.value,
            "css-comment" === e.type &&
              "css-root" === n.type &&
              n.nodes.length > 0)
          ) {
            if (
              (n.nodes[0] === e || (tI(n.nodes[0]) && n.nodes[1] === e)) &&
              (delete t.text, /^\*\s*@(?:format|prettier)\s*$/.test(e.text))
            )
              return null;
            if ("css-root" === n.type && nI(n.nodes) === e) return null;
          }
          if (
            ("value-root" === e.type && delete t.text,
            ("media-query" !== e.type &&
              "media-query-list" !== e.type &&
              "media-feature-expression" !== e.type) ||
              delete t.value,
            "css-rule" === e.type && delete t.params,
            "selector-combinator" === e.type &&
              (t.value = t.value.replace(/\s+/g, " ")),
            "media-feature" === e.type && (t.value = t.value.replace(/ /g, "")),
            (("value-word" === e.type &&
              ((e.isColor && e.isHex) ||
                ["initial", "inherit", "unset", "revert"].includes(
                  t.value.replace().toLowerCase()
                ))) ||
              "media-feature" === e.type ||
              "selector-root-invalid" === e.type ||
              "selector-pseudo" === e.type) &&
              (t.value = t.value.toLowerCase()),
            "css-decl" === e.type && (t.prop = t.prop.toLowerCase()),
            ("css-atrule" !== e.type && "css-import" !== e.type) ||
              (t.name = t.name.toLowerCase()),
            "value-number" === e.type && (t.unit = t.unit.toLowerCase()),
            ("media-feature" !== e.type &&
              "media-keyword" !== e.type &&
              "media-type" !== e.type &&
              "media-unknown" !== e.type &&
              "media-url" !== e.type &&
              "media-value" !== e.type &&
              "selector-attribute" !== e.type &&
              "selector-string" !== e.type &&
              "selector-class" !== e.type &&
              "selector-combinator" !== e.type &&
              "value-string" !== e.type) ||
              !t.value ||
              (t.value = t.value
                .replace(/'/g, '"')
                .replace(/\\([^\dA-Fa-f])/g, "$1")),
            "selector-attribute" === e.type &&
              ((t.attribute = t.attribute.trim()),
              t.namespace &&
                "string" == typeof t.namespace &&
                ((t.namespace = t.namespace.trim()),
                0 === t.namespace.length && (t.namespace = !0)),
              t.value &&
                ((t.value = t.value.trim().replace(/^["']|["']$/g, "")),
                delete t.quoted)),
            ("media-value" !== e.type &&
              "media-type" !== e.type &&
              "value-number" !== e.type &&
              "selector-root-invalid" !== e.type &&
              "selector-class" !== e.type &&
              "selector-combinator" !== e.type &&
              "selector-tag" !== e.type) ||
              !t.value ||
              (t.value = t.value.replace(
                /([\d+.Ee-]+)([A-Za-z]*)/g,
                (e, t, n) => {
                  const r = Number(t);
                  return Number.isNaN(r) ? e : r + n.toLowerCase();
                }
              )),
            "selector-tag" === e.type)
          ) {
            const n = e.value.toLowerCase();
            ["from", "to"].includes(n) && (t.value = n);
          }
          "css-atrule" === e.type &&
            "supports" === e.name.toLowerCase() &&
            delete t.value,
            "selector-unknown" === e.type && delete t.value;
        }
        iI.ignoredProperties = rI;
        var oI = iI;
        const {
          builders: { hardline: sI, markAsRoot: aI },
        } = Vl;
        var uI = function (e, t) {
          if ("yaml" === e.lang) {
            const n = e.value.trim(),
              r = n
                ? t(n, { parser: "yaml" }, { stripTrailingHardline: !0 })
                : "";
            return aI([e.startDelimiter, sI, r, r ? sI : "", e.endDelimiter]);
          }
        };
        const {
            builders: { hardline: lI },
          } = Vl,
          cI = uI;
        const pI = new RegExp(
          "^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)",
          "s"
        );
        var fI = function (e) {
          const t = e.match(pI);
          if (!t) return { content: e };
          const {
            startDelimiter: n,
            language: r,
            value: i = "",
            endDelimiter: o,
          } = t.groups;
          let s = r.trim() || "yaml";
          if (("+++" === n && (s = "toml"), "yaml" !== s && n !== o))
            return { content: e };
          const [a] = t;
          return {
            frontMatter: {
              type: "front-matter",
              lang: s,
              value: i,
              startDelimiter: n,
              endDelimiter: o,
              raw: a.replace(/\n$/, ""),
            },
            content: a.replace(/[^\n]/g, " ") + e.slice(a.length),
          };
        };
        const dI = PE,
          hI = fI;
        var mI = {
          hasPragma: function (e) {
            return dI.hasPragma(hI(e).content);
          },
          insertPragma: function (e) {
            const { frontMatter: t, content: n } = hI(e);
            return (t ? t.raw + "\n\n" : "") + dI.insertPragma(n);
          },
        };
        const { isNonEmptyArray: gI } = nl,
          yI = new Set([
            "red",
            "green",
            "blue",
            "alpha",
            "a",
            "rgb",
            "hue",
            "h",
            "saturation",
            "s",
            "lightness",
            "l",
            "whiteness",
            "w",
            "blackness",
            "b",
            "tint",
            "shade",
            "blend",
            "blenda",
            "contrast",
            "hsl",
            "hsla",
            "hwb",
            "hwba",
          ]),
          vI = new Set(["import", "use", "forward"]);
        function DI(e, t) {
          const n = Array.isArray(t) ? t : [t];
          let r,
            i = -1;
          for (; (r = e.getParentNode(++i)); ) if (n.includes(r.type)) return i;
          return -1;
        }
        function bI(e, t) {
          const n = DI(e, t);
          return -1 === n ? null : e.getParentNode(n);
        }
        function EI(e) {
          return "value-operator" === e.type && "*" === e.value;
        }
        function CI(e) {
          return "value-operator" === e.type && "/" === e.value;
        }
        function xI(e) {
          return "value-operator" === e.type && "+" === e.value;
        }
        function wI(e) {
          return "value-operator" === e.type && "-" === e.value;
        }
        function AI(e) {
          return "value-operator" === e.type && "%" === e.value;
        }
        function SI(e) {
          return (
            "value-comma_group" === e.type &&
            e.groups &&
            e.groups[1] &&
            "value-colon" === e.groups[1].type
          );
        }
        function _I(e) {
          return (
            "value-paren_group" === e.type &&
            e.groups &&
            e.groups[0] &&
            SI(e.groups[0])
          );
        }
        function TI(e) {
          return e && "value-colon" === e.type;
        }
        var FI = {
          getAncestorCounter: DI,
          getAncestorNode: bI,
          getPropOfDeclNode: function (e) {
            const t = bI(e, "css-decl");
            return t && t.prop && t.prop.toLowerCase();
          },
          hasSCSSInterpolation: function (e) {
            if (gI(e))
              for (let t = e.length - 1; t > 0; t--)
                if (
                  "word" === e[t].type &&
                  "{" === e[t].value &&
                  "word" === e[t - 1].type &&
                  e[t - 1].value.endsWith("#")
                )
                  return !0;
            return !1;
          },
          hasStringOrFunction: function (e) {
            if (gI(e))
              for (let t = 0; t < e.length; t++)
                if ("string" === e[t].type || "func" === e[t].type) return !0;
            return !1;
          },
          maybeToLowerCase: function (e) {
            return e.includes("$") ||
              e.includes("@") ||
              e.includes("#") ||
              e.startsWith("%") ||
              e.startsWith("--") ||
              e.startsWith(":--") ||
              (e.includes("(") && e.includes(")"))
              ? e
              : e.toLowerCase();
          },
          insideValueFunctionNode: function (e, t) {
            const n = bI(e, "value-func");
            return n && n.value && n.value.toLowerCase() === t;
          },
          insideICSSRuleNode: function (e) {
            const t = bI(e, "css-rule");
            return (
              t &&
              t.raws &&
              t.raws.selector &&
              (t.raws.selector.startsWith(":import") ||
                t.raws.selector.startsWith(":export"))
            );
          },
          insideAtRuleNode: function (e, t) {
            const n = Array.isArray(t) ? t : [t],
              r = bI(e, "css-atrule");
            return r && n.includes(r.name.toLowerCase());
          },
          insideURLFunctionInImportAtRuleNode: function (e) {
            const t = e.getValue(),
              n = bI(e, "css-atrule");
            return (
              n &&
              "import" === n.name &&
              "url" === t.groups[0].value &&
              2 === t.groups.length
            );
          },
          isKeyframeAtRuleKeywords: function (e, t) {
            const n = bI(e, "css-atrule");
            return (
              n &&
              n.name &&
              n.name.toLowerCase().endsWith("keyframes") &&
              ["from", "to"].includes(t.toLowerCase())
            );
          },
          isWideKeywords: function (e) {
            return ["initial", "inherit", "unset", "revert"].includes(
              e.toLowerCase()
            );
          },
          isSCSS: function (e, t) {
            return "less" === e || "scss" === e
              ? "scss" === e
              : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(t);
          },
          isSCSSVariable: function (e) {
            return Boolean(e && "word" === e.type && e.value.startsWith("$"));
          },
          isLastNode: function (e, t) {
            const n = e.getParentNode();
            if (!n) return !1;
            const { nodes: r } = n;
            return r && r.indexOf(t) === r.length - 1;
          },
          isLessParser: function (e) {
            return "css" === e.parser || "less" === e.parser;
          },
          isSCSSControlDirectiveNode: function (e) {
            return (
              "css-atrule" === e.type &&
              ["if", "else", "for", "each", "while"].includes(e.name)
            );
          },
          isDetachedRulesetDeclarationNode: function (e) {
            return (
              !!e.selector &&
              (("string" == typeof e.selector && /^@.+:.*$/.test(e.selector)) ||
                (e.selector.value && /^@.+:.*$/.test(e.selector.value)))
            );
          },
          isRelationalOperatorNode: function (e) {
            return (
              "value-word" === e.type &&
              ["<", ">", "<=", ">="].includes(e.value)
            );
          },
          isEqualityOperatorNode: function (e) {
            return "value-word" === e.type && ["==", "!="].includes(e.value);
          },
          isMultiplicationNode: EI,
          isDivisionNode: CI,
          isAdditionNode: xI,
          isSubtractionNode: wI,
          isModuloNode: AI,
          isMathOperatorNode: function (e) {
            return EI(e) || CI(e) || xI(e) || wI(e) || AI(e);
          },
          isEachKeywordNode: function (e) {
            return "value-word" === e.type && "in" === e.value;
          },
          isForKeywordNode: function (e) {
            return (
              "value-word" === e.type &&
              ["from", "through", "end"].includes(e.value)
            );
          },
          isURLFunctionNode: function (e) {
            return "value-func" === e.type && "url" === e.value.toLowerCase();
          },
          isIfElseKeywordNode: function (e) {
            return (
              "value-word" === e.type && ["and", "or", "not"].includes(e.value)
            );
          },
          hasComposesNode: function (e) {
            return (
              e.value &&
              "value-root" === e.value.type &&
              e.value.group &&
              "value-value" === e.value.group.type &&
              "composes" === e.prop.toLowerCase()
            );
          },
          hasParensAroundNode: function (e) {
            return (
              e.value &&
              e.value.group &&
              e.value.group.group &&
              "value-paren_group" === e.value.group.group.type &&
              null !== e.value.group.group.open &&
              null !== e.value.group.group.close
            );
          },
          hasEmptyRawBefore: function (e) {
            return e.raws && "" === e.raws.before;
          },
          isSCSSNestedPropertyNode: function (e) {
            return (
              !!e.selector &&
              e.selector
                .replace(/\/\*.*?\*\//, "")
                .replace(/\/\/.*?\n/, "")
                .trim()
                .endsWith(":")
            );
          },
          isDetachedRulesetCallNode: function (e) {
            return e.raws && e.raws.params && /^\(\s*\)$/.test(e.raws.params);
          },
          isTemplatePlaceholderNode: function (e) {
            return e.name.startsWith("prettier-placeholder");
          },
          isTemplatePropNode: function (e) {
            return e.prop.startsWith("@prettier-placeholder");
          },
          isPostcssSimpleVarNode: function (e, t) {
            return (
              "$$" === e.value &&
              "value-func" === e.type &&
              t &&
              "value-word" === t.type &&
              !t.raws.before
            );
          },
          isKeyValuePairNode: SI,
          isKeyValuePairInParenGroupNode: _I,
          isKeyInValuePairNode: function (e, t) {
            if (!SI(t)) return !1;
            const { groups: n } = t,
              r = n.indexOf(e);
            return -1 !== r && TI(n[r + 1]);
          },
          isSCSSMapItemNode: function (e) {
            const t = e.getValue();
            if (0 === t.groups.length) return !1;
            const n = e.getParentNode(1);
            if (!(_I(t) || (n && _I(n)))) return !1;
            const r = bI(e, "css-decl");
            return (
              !!(r && r.prop && r.prop.startsWith("$")) ||
              !!_I(n) ||
              "value-func" === n.type
            );
          },
          isInlineValueCommentNode: function (e) {
            return "value-comment" === e.type && e.inline;
          },
          isHashNode: function (e) {
            return "value-word" === e.type && "#" === e.value;
          },
          isLeftCurlyBraceNode: function (e) {
            return "value-word" === e.type && "{" === e.value;
          },
          isRightCurlyBraceNode: function (e) {
            return "value-word" === e.type && "}" === e.value;
          },
          isWordNode: function (e) {
            return ["value-word", "value-atword"].includes(e.type);
          },
          isColonNode: TI,
          isMediaAndSupportsKeywords: function (e) {
            return (
              e.value && ["not", "and", "or"].includes(e.value.toLowerCase())
            );
          },
          isColorAdjusterFuncNode: function (e) {
            return "value-func" === e.type && yI.has(e.value.toLowerCase());
          },
          lastLineHasInlineComment: function (e) {
            return /\/\//.test(e.split(/[\n\r]/).pop());
          },
          stringifyNode: function e(t) {
            if (t.groups)
              return (
                (t.open && t.open.value ? t.open.value : "") +
                t.groups.reduce(
                  (n, r, i) =>
                    n +
                    e(r) +
                    ("comma_group" === t.groups[0].type &&
                    i !== t.groups.length - 1
                      ? ","
                      : ""),
                  ""
                ) +
                (t.close && t.close.value ? t.close.value : "")
              );
            const n = t.raws && t.raws.before ? t.raws.before : "",
              r = t.raws && t.raws.quote ? t.raws.quote : "";
            return (
              n +
              r +
              ("atword" === t.type ? "@" : "") +
              (t.value ? t.value : "") +
              r +
              (t.unit ? t.unit : "") +
              (t.group ? e(t.group) : "") +
              (t.raws && t.raws.after ? t.raws.after : "")
            );
          },
          isAtWordPlaceholderNode: function (e) {
            return (
              e &&
              "value-atword" === e.type &&
              e.value.startsWith("prettier-placeholder-")
            );
          },
          isModuleRuleName: function (e) {
            return vI.has(e);
          },
          isConfigurationNode: function (e, t) {
            if (
              !e.open ||
              "(" !== e.open.value ||
              !e.close ||
              ")" !== e.close.value ||
              e.groups.some((e) => "value-comma_group" !== e.type)
            )
              return !1;
            if ("value-comma_group" === t.type) {
              const n = t.groups.indexOf(e) - 1,
                r = t.groups[n];
              if (r && "value-word" === r.type && "with" === r.value) return !0;
            }
            return !1;
          },
          isParenGroupNode: function (e) {
            return (
              "value-paren_group" === e.type &&
              e.open &&
              "(" === e.open.value &&
              e.close &&
              ")" === e.close.value
            );
          },
        };
        const kI = function (e, t) {
            let n = 0;
            for (let r = 0; r < e.line - 1; ++r) n = t.indexOf("\n", n) + 1;
            return n + e.column;
          },
          { getLast: OI, skipEverythingButNewLine: BI } = nl;
        function PI(e, t) {
          return "number" == typeof e.sourceIndex
            ? e.sourceIndex
            : e.source
            ? kI(e.source.start, t) - 1
            : null;
        }
        function NI(e, t) {
          if ("css-comment" === e.type && e.inline)
            return BI(t, e.source.startOffset);
          const n = e.nodes && OI(e.nodes);
          return (
            n && e.source && !e.source.end && (e = n),
            e.source && e.source.end ? kI(e.source.end, t) : null
          );
        }
        function MI(e, t, n) {
          e.source &&
            ((e.source.startOffset = PI(e, n) + t),
            (e.source.endOffset = NI(e, n) + t));
          for (const r in e) {
            const i = e[r];
            "source" !== r && i && "object" == typeof i && MI(i, t, n);
          }
        }
        function II(e) {
          let t = e.source.startOffset;
          return (
            "string" == typeof e.prop && (t += e.prop.length),
            "css-atrule" === e.type &&
              "string" == typeof e.name &&
              (t +=
                1 +
                e.name.length +
                e.raws.afterName.match(/^\s*:?\s*/)[0].length),
            "css-atrule" !== e.type &&
              e.raws &&
              "string" == typeof e.raws.between &&
              (t += e.raws.between.length),
            t
          );
        }
        var jI = {
          locStart: function (e) {
            return e.source.startOffset;
          },
          locEnd: function (e) {
            return e.source.endOffset;
          },
          calculateLoc: function e(t, n) {
            t.source &&
              ((t.source.startOffset = PI(t, n)),
              (t.source.endOffset = NI(t, n)));
            for (const r in t) {
              const i = t[r];
              "source" !== r &&
                i &&
                "object" == typeof i &&
                ("value-root" === i.type || "value-unknown" === i.type
                  ? MI(i, II(t), i.text || i.value)
                  : e(i, n));
            }
          },
          replaceQuotesInInlineComments: function (e) {
            let t,
              n = "initial",
              r = "initial",
              i = !1;
            const o = [];
            for (let s = 0; s < e.length; s++) {
              const a = e[s];
              switch (n) {
                case "initial":
                  if ("'" === a) {
                    n = "single-quotes";
                    continue;
                  }
                  if ('"' === a) {
                    n = "double-quotes";
                    continue;
                  }
                  if (
                    ("u" === a || "U" === a) &&
                    "url(" === e.slice(s, s + 4).toLowerCase()
                  ) {
                    (n = "url"), (s += 3);
                    continue;
                  }
                  if ("*" === a && "/" === e[s - 1]) {
                    n = "comment-block";
                    continue;
                  }
                  if ("/" === a && "/" === e[s - 1]) {
                    (n = "comment-inline"), (t = s - 1);
                    continue;
                  }
                  continue;
                case "single-quotes":
                  if (
                    ("'" === a &&
                      "\\" !== e[s - 1] &&
                      ((n = r), (r = "initial")),
                    "\n" === a || "\r" === a)
                  )
                    return e;
                  continue;
                case "double-quotes":
                  if (
                    ('"' === a &&
                      "\\" !== e[s - 1] &&
                      ((n = r), (r = "initial")),
                    "\n" === a || "\r" === a)
                  )
                    return e;
                  continue;
                case "url":
                  if ((")" === a && (n = "initial"), "\n" === a || "\r" === a))
                    return e;
                  if ("'" === a) {
                    (n = "single-quotes"), (r = "url");
                    continue;
                  }
                  if ('"' === a) {
                    (n = "double-quotes"), (r = "url");
                    continue;
                  }
                  continue;
                case "comment-block":
                  "/" === a && "*" === e[s - 1] && (n = "initial");
                  continue;
                case "comment-inline":
                  ('"' !== a && "'" !== a && "*" !== a) || (i = !0),
                    ("\n" !== a && "\r" !== a) ||
                      (i && o.push([t, s]), (n = "initial"), (i = !1));
                  continue;
              }
            }
            for (const [t, n] of o)
              e =
                e.slice(0, t) +
                e.slice(t, n).replace(/["'*]/g, " ") +
                e.slice(n);
            return e;
          },
        };
        const LI = ns,
          {
            printNumber: $I,
            printString: RI,
            hasNewline: zI,
            isFrontMatterNode: VI,
            isNextLineEmpty: qI,
            isNonEmptyArray: WI,
          } = nl,
          {
            builders: {
              join: UI,
              line: HI,
              hardline: GI,
              softline: YI,
              group: XI,
              fill: JI,
              indent: ZI,
              dedent: KI,
              ifBreak: QI,
              breakParent: ej,
            },
            utils: { removeLines: tj, getDocParts: nj },
          } = Vl,
          rj = oI,
          ij = function (e, t, n) {
            const r = e.getValue();
            if ("front-matter" === r.type) {
              const e = cI(r, n);
              return e ? [e, lI] : "";
            }
          },
          { insertPragma: oj } = mI,
          {
            getAncestorNode: sj,
            getPropOfDeclNode: aj,
            maybeToLowerCase: uj,
            insideValueFunctionNode: lj,
            insideICSSRuleNode: cj,
            insideAtRuleNode: pj,
            insideURLFunctionInImportAtRuleNode: fj,
            isKeyframeAtRuleKeywords: dj,
            isWideKeywords: hj,
            isSCSS: mj,
            isLastNode: gj,
            isLessParser: yj,
            isSCSSControlDirectiveNode: vj,
            isDetachedRulesetDeclarationNode: Dj,
            isRelationalOperatorNode: bj,
            isEqualityOperatorNode: Ej,
            isMultiplicationNode: Cj,
            isDivisionNode: xj,
            isAdditionNode: wj,
            isSubtractionNode: Aj,
            isMathOperatorNode: Sj,
            isEachKeywordNode: _j,
            isForKeywordNode: Tj,
            isURLFunctionNode: Fj,
            isIfElseKeywordNode: kj,
            hasComposesNode: Oj,
            hasParensAroundNode: Bj,
            hasEmptyRawBefore: Pj,
            isKeyValuePairNode: Nj,
            isKeyInValuePairNode: Mj,
            isDetachedRulesetCallNode: Ij,
            isTemplatePlaceholderNode: jj,
            isTemplatePropNode: Lj,
            isPostcssSimpleVarNode: $j,
            isSCSSMapItemNode: Rj,
            isInlineValueCommentNode: zj,
            isHashNode: Vj,
            isLeftCurlyBraceNode: qj,
            isRightCurlyBraceNode: Wj,
            isWordNode: Uj,
            isColonNode: Hj,
            isMediaAndSupportsKeywords: Gj,
            isColorAdjusterFuncNode: Yj,
            lastLineHasInlineComment: Xj,
            isAtWordPlaceholderNode: Jj,
            isConfigurationNode: Zj,
            isParenGroupNode: Kj,
          } = FI,
          { locStart: Qj, locEnd: eL } = jI;
        function tL(e) {
          return "es5" === e.trailingComma || "all" === e.trailingComma;
        }
        function nL(e, t, n) {
          const r = [];
          return (
            e.each((e, i, o) => {
              const s = o[i - 1];
              if (
                s &&
                "css-comment" === s.type &&
                "prettier-ignore" === s.text.trim()
              ) {
                const n = e.getValue();
                r.push(t.originalText.slice(Qj(n), eL(n)));
              } else r.push(n());
              i !== o.length - 1 &&
                (("css-comment" === o[i + 1].type &&
                  !zI(t.originalText, Qj(o[i + 1]), { backwards: !0 }) &&
                  !VI(o[i])) ||
                ("css-atrule" === o[i + 1].type &&
                  "else" === o[i + 1].name &&
                  "css-comment" !== o[i].type)
                  ? r.push(" ")
                  : (r.push(t.__isHTMLStyleAttribute ? HI : GI),
                    qI(t.originalText, e.getValue(), eL) &&
                      !VI(o[i]) &&
                      r.push(GI)));
            }, "nodes"),
            r
          );
        }
        const rL = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs,
          iL = new RegExp(
            rL.source +
              "|" +
              "(".concat(
                /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g.source,
                ")?"
              ) +
              "(".concat(/(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g.source, ")") +
              "(".concat(/[A-Za-z]+/g.source, ")?"),
            "g"
          );
        function oL(e, t) {
          return e.replace(rL, (e) => RI(e, t));
        }
        function sL(e, t) {
          const n = t.singleQuote ? "'" : '"';
          return e.includes('"') || e.includes("'") ? e : n + e + n;
        }
        function aL(e) {
          return e.replace(iL, (e, t, n, r, i) =>
            !n && r ? uL(r) + uj(i || "") : e
          );
        }
        function uL(e) {
          return $I(e).replace(/\.0(?=$|e)/, "");
        }
        var lL = {
          print: function (e, t, n) {
            const r = e.getValue();
            if (!r) return "";
            if ("string" == typeof r) return r;
            switch (r.type) {
              case "front-matter":
                return [r.raw, GI];
              case "css-root": {
                const i = nL(e, t, n),
                  o = r.raws.after.trim();
                return [i, o ? " ".concat(o) : "", nj(i).length > 0 ? GI : ""];
              }
              case "css-comment": {
                const e = r.inline || r.raws.inline,
                  n = t.originalText.slice(Qj(r), eL(r));
                return e ? n.trimEnd() : n;
              }
              case "css-rule":
                return [
                  n("selector"),
                  r.important ? " !important" : "",
                  r.nodes
                    ? [
                        r.selector &&
                        "selector-unknown" === r.selector.type &&
                        Xj(r.selector.value)
                          ? HI
                          : " ",
                        "{",
                        r.nodes.length > 0 ? ZI([GI, nL(e, t, n)]) : "",
                        GI,
                        "}",
                        Dj(r) ? ";" : "",
                      ]
                    : ";",
                ];
              case "css-decl": {
                const i = e.getParentNode(),
                  { between: o } = r.raws,
                  s = o.trim(),
                  a = ":" === s;
                let u = Oj(r) ? tj(n("value")) : n("value");
                return (
                  !a && Xj(s) && (u = ZI([GI, KI(u)])),
                  [
                    r.raws.before.replace(/[\s;]/g, ""),
                    cj(e) ? r.prop : uj(r.prop),
                    s.startsWith("//") ? " " : "",
                    s,
                    r.extend ? "" : " ",
                    yj(t) && r.extend && r.selector
                      ? ["extend(", n("selector"), ")"]
                      : "",
                    u,
                    r.raws.important
                      ? r.raws.important.replace(
                          /\s*!\s*important/i,
                          " !important"
                        )
                      : r.important
                      ? " !important"
                      : "",
                    r.raws.scssDefault
                      ? r.raws.scssDefault.replace(/\s*!default/i, " !default")
                      : r.scssDefault
                      ? " !default"
                      : "",
                    r.raws.scssGlobal
                      ? r.raws.scssGlobal.replace(/\s*!global/i, " !global")
                      : r.scssGlobal
                      ? " !global"
                      : "",
                    r.nodes
                      ? [" {", ZI([YI, nL(e, t, n)]), YI, "}"]
                      : Lj(r) &&
                        !i.raws.semicolon &&
                        ";" !== t.originalText[eL(r) - 1]
                      ? ""
                      : t.__isHTMLStyleAttribute && gj(e, r)
                      ? QI(";")
                      : ";",
                  ]
                );
              }
              case "css-atrule": {
                const i = e.getParentNode(),
                  o =
                    jj(r) &&
                    !i.raws.semicolon &&
                    ";" !== t.originalText[eL(r) - 1];
                if (yj(t)) {
                  if (r.mixin)
                    return [
                      n("selector"),
                      r.important ? " !important" : "",
                      o ? "" : ";",
                    ];
                  if (r.function) return [r.name, n("params"), o ? "" : ";"];
                  if (r.variable)
                    return [
                      "@",
                      r.name,
                      ": ",
                      r.value ? n("value") : "",
                      r.raws.between.trim() ? r.raws.between.trim() + " " : "",
                      r.nodes
                        ? [
                            "{",
                            ZI([r.nodes.length > 0 ? YI : "", nL(e, t, n)]),
                            YI,
                            "}",
                          ]
                        : "",
                      o ? "" : ";",
                    ];
                }
                return [
                  "@",
                  Ij(r) || r.name.endsWith(":") ? r.name : uj(r.name),
                  r.params
                    ? [
                        Ij(r)
                          ? ""
                          : jj(r)
                          ? "" === r.raws.afterName
                            ? ""
                            : r.name.endsWith(":")
                            ? " "
                            : /^\s*\n\s*\n/.test(r.raws.afterName)
                            ? [GI, GI]
                            : /^\s*\n/.test(r.raws.afterName)
                            ? GI
                            : " "
                          : " ",
                        n("params"),
                      ]
                    : "",
                  r.selector ? ZI([" ", n("selector")]) : "",
                  r.value
                    ? XI([" ", n("value"), vj(r) ? (Bj(r) ? " " : HI) : ""])
                    : "else" === r.name
                    ? " "
                    : "",
                  r.nodes
                    ? [
                        vj(r)
                          ? ""
                          : (r.selector &&
                              !r.selector.nodes &&
                              "string" == typeof r.selector.value &&
                              Xj(r.selector.value)) ||
                            (!r.selector &&
                              "string" == typeof r.params &&
                              Xj(r.params))
                          ? HI
                          : " ",
                        "{",
                        ZI([r.nodes.length > 0 ? YI : "", nL(e, t, n)]),
                        YI,
                        "}",
                      ]
                    : o
                    ? ""
                    : ";",
                ];
              }
              case "media-query-list": {
                const t = [];
                return (
                  e.each((e) => {
                    const r = e.getValue();
                    ("media-query" === r.type && "" === r.value) || t.push(n());
                  }, "nodes"),
                  XI(ZI(UI(HI, t)))
                );
              }
              case "media-query":
                return [UI(" ", e.map(n, "nodes")), gj(e, r) ? "" : ","];
              case "media-type":
              case "media-value":
                return aL(oL(r.value, t));
              case "media-feature-expression":
                return r.nodes ? ["(", ...e.map(n, "nodes"), ")"] : r.value;
              case "media-feature":
                return uj(oL(r.value.replace(/ +/g, " "), t));
              case "media-colon":
              case "value-comma":
                return [r.value, " "];
              case "media-keyword":
              case "selector-string":
                return oL(r.value, t);
              case "media-url":
                return oL(
                  r.value
                    .replace(/^url\(\s+/gi, "url(")
                    .replace(/\s+\)$/g, ")"),
                  t
                );
              case "media-unknown":
              case "selector-comment":
              case "selector-nesting":
              case "value-paren":
              case "value-operator":
              case "value-unicode-range":
              case "value-unknown":
                return r.value;
              case "selector-root":
                return XI([
                  pj(e, "custom-selector")
                    ? [sj(e, "css-atrule").customSelector, HI]
                    : "",
                  UI(
                    [
                      ",",
                      pj(e, ["extend", "custom-selector", "nest"]) ? HI : GI,
                    ],
                    e.map(n, "nodes")
                  ),
                ]);
              case "selector-selector":
                return XI(ZI(e.map(n, "nodes")));
              case "selector-tag": {
                const t = e.getParentNode(),
                  n = t && t.nodes.indexOf(r),
                  i = n && t.nodes[n - 1];
                return [
                  r.namespace
                    ? [!0 === r.namespace ? "" : r.namespace.trim(), "|"]
                    : "",
                  "selector-nesting" === i.type
                    ? r.value
                    : aL(dj(e, r.value) ? r.value.toLowerCase() : r.value),
                ];
              }
              case "selector-id":
                return ["#", r.value];
              case "selector-class":
                return [".", aL(oL(r.value, t))];
              case "selector-attribute":
                return [
                  "[",
                  r.namespace
                    ? [!0 === r.namespace ? "" : r.namespace.trim(), "|"]
                    : "",
                  r.attribute.trim(),
                  r.operator ? r.operator : "",
                  r.value ? sL(oL(r.value.trim(), t), t) : "",
                  r.insensitive ? " i" : "",
                  "]",
                ];
              case "selector-combinator":
                if (
                  "+" === r.value ||
                  ">" === r.value ||
                  "~" === r.value ||
                  ">>>" === r.value
                ) {
                  const t = e.getParentNode();
                  return [
                    "selector-selector" === t.type && t.nodes[0] === r
                      ? ""
                      : HI,
                    r.value,
                    gj(e, r) ? "" : " ",
                  ];
                }
                return [
                  r.value.trim().startsWith("(") ? HI : "",
                  aL(oL(r.value.trim(), t)) || HI,
                ];
              case "selector-universal":
                return [
                  r.namespace
                    ? [!0 === r.namespace ? "" : r.namespace.trim(), "|"]
                    : "",
                  r.value,
                ];
              case "selector-pseudo":
                return [
                  uj(r.value),
                  WI(r.nodes) ? ["(", UI(", ", e.map(n, "nodes")), ")"] : "",
                ];
              case "selector-unknown": {
                const n = sj(e, "css-rule");
                if (n && n.isSCSSNesterProperty) return aL(oL(uj(r.value), t));
                const i = e.getParentNode();
                if (i.raws && i.raws.selector) {
                  const e = Qj(i),
                    n = e + i.raws.selector.length;
                  return t.originalText.slice(e, n).trim();
                }
                const o = e.getParentNode(1);
                if (
                  "value-paren_group" === i.type &&
                  o &&
                  "value-func" === o.type &&
                  "selector" === o.value
                ) {
                  const e = Qj(i.open) + 1,
                    n = eL(i.close) - 1,
                    r = t.originalText.slice(e, n).trim();
                  return Xj(r) ? [ej, r] : r;
                }
                return r.value;
              }
              case "value-value":
              case "value-root":
                return n("group");
              case "value-comment":
                return t.originalText.slice(Qj(r), eL(r));
              case "value-comma_group": {
                const t = e.getParentNode(),
                  i = e.getParentNode(1),
                  o = aj(e),
                  s =
                    o &&
                    "value-value" === t.type &&
                    ("grid" === o || o.startsWith("grid-template")),
                  a = sj(e, "css-atrule"),
                  u = a && vj(a),
                  l = r.groups.some((e) => zj(e)),
                  c = e.map(n, "groups"),
                  p = [],
                  f = lj(e, "url");
                let d = !1,
                  h = !1;
                for (let n = 0; n < r.groups.length; ++n) {
                  p.push(c[n]);
                  const o = r.groups[n - 1],
                    l = r.groups[n],
                    m = r.groups[n + 1],
                    g = r.groups[n + 2];
                  if (f) {
                    ((m && wj(m)) || wj(l)) && p.push(" ");
                    continue;
                  }
                  if (
                    pj(e, "forward") &&
                    "value-word" === l.type &&
                    l.value &&
                    void 0 !== o &&
                    "value-word" === o.type &&
                    "as" === o.value &&
                    "value-operator" === m.type &&
                    "*" === m.value
                  )
                    continue;
                  if (!m) continue;
                  if ("value-word" === l.type && l.value.endsWith("-") && Jj(m))
                    continue;
                  const y =
                      "value-string" === l.type && l.value.startsWith("#{"),
                    v = d && "value-string" === m.type && m.value.endsWith("}");
                  if (y || v) {
                    d = !d;
                    continue;
                  }
                  if (d) continue;
                  if (Hj(l) || Hj(m)) continue;
                  if ("value-atword" === l.type && "" === l.value) continue;
                  if ("~" === l.value) continue;
                  if (
                    l.value &&
                    l.value.includes("\\") &&
                    m &&
                    "value-comment" !== m.type
                  )
                    continue;
                  if (
                    o &&
                    o.value &&
                    o.value.indexOf("\\") === o.value.length - 1 &&
                    "value-operator" === l.type &&
                    "/" === l.value
                  )
                    continue;
                  if ("\\" === l.value) continue;
                  if ($j(l, m)) continue;
                  if (
                    Vj(l) ||
                    qj(l) ||
                    Wj(m) ||
                    (qj(m) && Pj(m)) ||
                    (Wj(l) && Pj(m))
                  )
                    continue;
                  if ("--" === l.value && Vj(m)) continue;
                  const D = Sj(l),
                    b = Sj(m);
                  if (((D && Vj(m)) || (b && Wj(l))) && Pj(m)) continue;
                  if (!o && xj(l)) continue;
                  if (
                    lj(e, "calc") &&
                    (wj(l) || wj(m) || Aj(l) || Aj(m)) &&
                    Pj(m)
                  )
                    continue;
                  const E =
                      (wj(l) || Aj(l)) &&
                      0 === n &&
                      ("value-number" === m.type || m.isHex) &&
                      i &&
                      Yj(i) &&
                      !Pj(m),
                    C =
                      (g && "value-func" === g.type) ||
                      (g && Uj(g)) ||
                      "value-func" === l.type ||
                      Uj(l),
                    x =
                      "value-func" === m.type ||
                      Uj(m) ||
                      (o && "value-func" === o.type) ||
                      (o && Uj(o));
                  if (
                    Cj(m) ||
                    Cj(l) ||
                    lj(e, "calc") ||
                    E ||
                    !(
                      (xj(m) && !C) ||
                      (xj(l) && !x) ||
                      (wj(m) && !C) ||
                      (wj(l) && !x) ||
                      Aj(m) ||
                      Aj(l)
                    ) ||
                    !(Pj(m) || (D && (!o || (o && Sj(o)))))
                  )
                    if (zj(l)) {
                      if ("value-paren_group" === t.type) {
                        p.push(KI(GI));
                        continue;
                      }
                      p.push(GI);
                    } else
                      (u && (Ej(m) || bj(m) || kj(m) || _j(l) || Tj(l))) ||
                      (a && "namespace" === a.name.toLowerCase())
                        ? p.push(" ")
                        : s
                        ? l.source &&
                          m.source &&
                          l.source.start.line !== m.source.start.line
                          ? (p.push(GI), (h = !0))
                          : p.push(" ")
                        : b
                        ? p.push(" ")
                        : (m && "..." === m.value) ||
                          (Jj(l) && Jj(m) && eL(l) === Qj(m)) ||
                          (Jj(l) && Kj(m) && eL(l) === Qj(m.open)
                            ? p.push(YI)
                            : "with" === l.value && Kj(m)
                            ? p.push(" ")
                            : p.push(HI));
                }
                return (
                  l && p.push(ej),
                  h && p.unshift(GI),
                  u ? XI(ZI(p)) : fj(e) ? XI(JI(p)) : XI(ZI(JI(p)))
                );
              }
              case "value-paren_group": {
                const i = e.getParentNode();
                if (
                  i &&
                  Fj(i) &&
                  (1 === r.groups.length ||
                    (r.groups.length > 0 &&
                      "value-comma_group" === r.groups[0].type &&
                      r.groups[0].groups.length > 0 &&
                      "value-word" === r.groups[0].groups[0].type &&
                      r.groups[0].groups[0].value.startsWith("data:")))
                )
                  return [
                    r.open ? n("open") : "",
                    UI(",", e.map(n, "groups")),
                    r.close ? n("close") : "",
                  ];
                if (!r.open) {
                  const t = e.map(n, "groups"),
                    r = [];
                  for (let e = 0; e < t.length; e++)
                    0 !== e && r.push([",", HI]), r.push(t[e]);
                  return XI(ZI(JI(r)));
                }
                const o = Rj(e),
                  s = LI(r.groups),
                  a = s && "value-comment" === s.type,
                  u = Mj(r, i),
                  l = Zj(r, i),
                  c = l || (o && !u),
                  p = l || u,
                  f = XI(
                    [
                      r.open ? n("open") : "",
                      ZI([
                        YI,
                        UI(
                          [",", HI],
                          e.map((e) => {
                            const t = e.getValue(),
                              r = n();
                            if (
                              Nj(t) &&
                              "value-comma_group" === t.type &&
                              t.groups &&
                              "value-paren_group" !== t.groups[0].type &&
                              t.groups[2] &&
                              "value-paren_group" === t.groups[2].type
                            ) {
                              const e = nj(r.contents.contents);
                              return (e[1] = XI(e[1])), XI(KI(r));
                            }
                            return r;
                          }, "groups")
                        ),
                      ]),
                      QI(
                        !a && mj(t.parser, t.originalText) && o && tL(t)
                          ? ","
                          : ""
                      ),
                      YI,
                      r.close ? n("close") : "",
                    ],
                    { shouldBreak: c }
                  );
                return p ? KI(f) : f;
              }
              case "value-func":
                return [
                  r.value,
                  pj(e, "supports") && Gj(r) ? " " : "",
                  n("group"),
                ];
              case "value-number":
                return [uL(r.value), uj(r.unit)];
              case "value-word":
                return (r.isColor && r.isHex) || hj(r.value)
                  ? r.value.toLowerCase()
                  : r.value;
              case "value-colon": {
                const t = e.getParentNode(),
                  n = t && t.groups.indexOf(r),
                  i = n && t.groups[n - 1];
                return [
                  r.value,
                  (i && "string" == typeof i.value && "\\" === LI(i.value)) ||
                  lj(e, "url")
                    ? ""
                    : HI,
                ];
              }
              case "value-string":
                return RI(r.raws.quote + r.value + r.raws.quote, t);
              case "value-atword":
                return ["@", r.value];
              default:
                throw new Error(
                  "Unknown postcss type ".concat(JSON.stringify(r.type))
                );
            }
          },
          embed: ij,
          insertPragma: oj,
          massageAstNode: rj,
        };
        const cL = tD,
          pL = lL,
          fL = { singleQuote: UM.singleQuote },
          dL = [
            cL(
              {
                name: "CSS",
                type: "markup",
                tmScope: "source.css",
                aceMode: "css",
                codemirrorMode: "css",
                codemirrorMimeType: "text/css",
                color: "#563d7c",
                extensions: [".css"],
                languageId: 50,
              },
              (e) => ({
                since: "1.4.0",
                parsers: ["css"],
                vscodeLanguageIds: ["css"],
                extensions: [...e.extensions, ".wxss"],
              })
            ),
            cL(
              {
                name: "PostCSS",
                type: "markup",
                tmScope: "source.postcss",
                group: "CSS",
                extensions: [".pcss", ".postcss"],
                aceMode: "text",
                languageId: 262764437,
              },
              () => ({
                since: "1.4.0",
                parsers: ["css"],
                vscodeLanguageIds: ["postcss"],
              })
            ),
            cL(
              {
                name: "Less",
                type: "markup",
                color: "#1d365d",
                extensions: [".less"],
                tmScope: "source.css.less",
                aceMode: "less",
                codemirrorMode: "css",
                codemirrorMimeType: "text/css",
                languageId: 198,
              },
              () => ({
                since: "1.4.0",
                parsers: ["less"],
                vscodeLanguageIds: ["less"],
              })
            ),
            cL(
              {
                name: "SCSS",
                type: "markup",
                color: "#c6538c",
                tmScope: "source.css.scss",
                aceMode: "scss",
                codemirrorMode: "css",
                codemirrorMimeType: "text/x-scss",
                extensions: [".scss"],
                languageId: 329,
              },
              () => ({
                since: "1.4.0",
                parsers: ["scss"],
                vscodeLanguageIds: ["scss"],
              })
            ),
          ];
        var hL = {
          languages: dL,
          options: fL,
          printers: { postcss: pL },
          parsers: void 0,
        };
        function mL(e, t) {
          if ("TextNode" === e.type) {
            const n = e.chars.trim();
            if (!n) return null;
            t.chars = n.replace(/[\t\n\f\r ]+/g, " ");
          }
          "AttrNode" === e.type &&
            "class" === e.name.toLowerCase() &&
            delete t.value;
        }
        mL.ignoredProperties = new Set(["loc", "selfClosing"]);
        var gL = mL;
        const yL = ns,
          vL = new Set([
            "area",
            "base",
            "basefont",
            "bgsound",
            "br",
            "col",
            "command",
            "embed",
            "frame",
            "hr",
            "image",
            "img",
            "input",
            "isindex",
            "keygen",
            "link",
            "menuitem",
            "meta",
            "nextid",
            "param",
            "source",
            "track",
            "wbr",
          ]);
        function DL(e) {
          return bL(e, ["TextNode"]) && !/\S/.test(e.chars);
        }
        function bL(e, t) {
          return e && t.includes(e.type);
        }
        function EL(e, t) {
          return bL(e.getParentNode(0), t);
        }
        function CL(e, t) {
          const n = e.getValue(),
            r = e.getParentNode(0) || {},
            i = r.children || r.body || r.parts || [],
            o = i.indexOf(n);
          return -1 !== o && i[o + t];
        }
        function xL(e) {
          return CL(
            e,
            -(arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : 1)
          );
        }
        function wL(e) {
          return CL(e, 1);
        }
        function AL(e) {
          return (
            bL(e, ["MustacheCommentStatement"]) &&
            "string" == typeof e.value &&
            "prettier-ignore" === e.value.trim()
          );
        }
        var SL = {
          getNextNode: wL,
          getPreviousNode: xL,
          hasPrettierIgnore: function (e) {
            const t = e.getValue(),
              n = xL(e, 2);
            return AL(t) || AL(n);
          },
          isLastNodeOfSiblings: function (e) {
            const t = e.getValue(),
              n = e.getParentNode(0);
            return (
              !(!EL(e, ["ElementNode"]) || yL(n.children) !== t) ||
              !(!EL(e, ["Block"]) || yL(n.body) !== t)
            );
          },
          isNextNodeOfSomeType: function (e, t) {
            return bL(wL(e), t);
          },
          isNodeOfSomeType: bL,
          isParentOfSomeType: EL,
          isPreviousNodeOfSomeType: function (e, t) {
            return bL(xL(e), t);
          },
          isVoid: function (e) {
            return (
              ((function (e) {
                return (
                  bL(e, ["ElementNode"]) &&
                  "string" == typeof e.tag &&
                  ":" !== e.tag[0] &&
                  ((function (e) {
                    return e.toUpperCase() === e;
                  })(e.tag[0]) ||
                    e.tag.includes("."))
                );
              })(e) &&
                e.children.every((e) => DL(e))) ||
              vL.has(e.tag)
            );
          },
          isWhitespaceNode: DL,
        };
        const {
            builders: {
              dedent: _L,
              fill: TL,
              group: FL,
              hardline: kL,
              ifBreak: OL,
              indent: BL,
              join: PL,
              line: NL,
              softline: ML,
            },
            utils: { getDocParts: IL, replaceTextEndOfLine: jL },
          } = Vl,
          { getPreferredQuote: LL, isNonEmptyArray: $L } = nl,
          { locStart: RL, locEnd: zL } = {
            locStart: function (e) {
              return e.loc.start.offset;
            },
            locEnd: function (e) {
              return e.loc.end.offset;
            },
          },
          VL = gL,
          {
            getNextNode: qL,
            getPreviousNode: WL,
            hasPrettierIgnore: UL,
            isLastNodeOfSiblings: HL,
            isNextNodeOfSomeType: GL,
            isNodeOfSomeType: YL,
            isParentOfSomeType: XL,
            isPreviousNodeOfSomeType: JL,
            isVoid: ZL,
            isWhitespaceNode: KL,
          } = SL;
        function QL(e, t) {
          return RL(e) - RL(t);
        }
        function e$(e, t, n) {
          const r = e.getValue().children.every((e) => KL(e));
          return "ignore" === t.htmlWhitespaceSensitivity && r
            ? ""
            : e.map((e, r) => {
                const i = n();
                return 0 === r && "ignore" === t.htmlWhitespaceSensitivity
                  ? [ML, i]
                  : i;
              }, "children");
        }
        function t$(e) {
          return ZL(e) ? OL([ML, "/>"], [" />", ML]) : OL([ML, ">"], ">");
        }
        function n$(e) {
          return [
            !1 === e.escaped ? "{{{" : "{{",
            e.strip && e.strip.open ? "~" : "",
          ];
        }
        function r$(e) {
          const t = !1 === e.escaped ? "}}}" : "}}";
          return [e.strip && e.strip.close ? "~" : "", t];
        }
        function i$(e) {
          return [n$(e), e.closeStrip.open ? "~" : "", "/"];
        }
        function o$(e) {
          const t = r$(e);
          return [e.closeStrip.close ? "~" : "", t];
        }
        function s$(e) {
          return [n$(e), e.inverseStrip.open ? "~" : ""];
        }
        function a$(e) {
          const t = r$(e);
          return [e.inverseStrip.close ? "~" : "", t];
        }
        function u$(e, t) {
          const n = e.getValue(),
            r = (function (e) {
              return [n$(e), e.openStrip.open ? "~" : "", "#"];
            })(n),
            i = (function (e) {
              const t = r$(e);
              return [e.openStrip.close ? "~" : "", t];
            })(n),
            o = [C$(0, t)],
            s = x$(e, t);
          if ((s && o.push(NL, s), $L(n.program.blockParams))) {
            const e = w$(n.program);
            o.push(NL, e);
          }
          return FL([r, BL(o), ML, i]);
        }
        function l$(e, t) {
          return [
            "ignore" === t.htmlWhitespaceSensitivity ? kL : "",
            s$(e),
            "else",
            a$(e),
          ];
        }
        function c$(e, t) {
          const n = e.getParentNode(1);
          return [s$(n), "else if ", x$(e, t), a$(n)];
        }
        function p$(e, t, n) {
          const r = e.getValue();
          return "ignore" === n.htmlWhitespaceSensitivity
            ? [f$(r) ? ML : kL, i$(r), t("path"), o$(r)]
            : [i$(r), t("path"), o$(r)];
        }
        function f$(e) {
          return (
            YL(e, ["BlockStatement"]) && e.program.body.every((e) => KL(e))
          );
        }
        function d$(e) {
          return YL(e, ["BlockStatement"]) && e.inverse;
        }
        function h$(e, t, n) {
          if (f$(e.getValue())) return "";
          const r = t("program");
          return "ignore" === n.htmlWhitespaceSensitivity ? BL([kL, r]) : BL(r);
        }
        function m$(e, t, n) {
          const r = e.getValue(),
            i = t("inverse"),
            o = "ignore" === n.htmlWhitespaceSensitivity ? [kL, i] : i;
          return (function (e) {
            return (
              d$(e) &&
              1 === e.inverse.body.length &&
              YL(e.inverse.body[0], ["BlockStatement"]) &&
              "if" === e.inverse.body[0].path.parts[0]
            );
          })(r)
            ? o
            : d$(r)
            ? [l$(r, n), BL(o)]
            : "";
        }
        function g$(e) {
          return IL(
            PL(
              NL,
              (function (e) {
                return e.split(/[\t\n\f\r ]+/);
              })(e)
            )
          );
        }
        function y$(e) {
          return (e = "string" == typeof e ? e : "").split("\n").length - 1;
        }
        function v$() {
          let e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
          return Array.from({ length: Math.min(e, 2) }).fill(kL);
        }
        function D$(e, t) {
          const { quote: n, regex: r } = LL(e, t);
          return [n, e.replace(r, "\\".concat(n)), n];
        }
        function b$(e, t) {
          const n = C$(0, t),
            r = x$(e, t);
          return r ? BL([n, NL, FL(r)]) : n;
        }
        function E$(e, t) {
          const n = C$(0, t),
            r = x$(e, t);
          return r ? [BL([n, NL, r]), ML] : n;
        }
        function C$(e, t) {
          return t("path");
        }
        function x$(e, t) {
          const n = e.getValue(),
            r = [];
          if (n.params.length > 0) {
            const n = e.map(t, "params");
            r.push(...n);
          }
          if (n.hash && n.hash.pairs.length > 0) {
            const e = t("hash");
            r.push(e);
          }
          return 0 === r.length ? "" : PL(NL, r);
        }
        function w$(e) {
          return ["as |", e.blockParams.join(" "), "|"];
        }
        var A$ = {
          print: function (e, t, n) {
            const r = e.getValue();
            if (!r) return "";
            if (UL(e)) return t.originalText.slice(RL(r), zL(r));
            const i = t.singleQuote ? "'" : '"';
            switch (r.type) {
              case "Block":
              case "Program":
              case "Template":
                return FL(e.map(n, "body"));
              case "ElementNode": {
                const i = FL(
                    (function (e, t) {
                      const n = e.getValue(),
                        r = ["attributes", "modifiers", "comments"].filter(
                          (e) => $L(n[e])
                        ),
                        i = r.flatMap((e) => n[e]).sort(QL);
                      for (const n of r)
                        e.each((e) => {
                          const n = i.indexOf(e.getValue());
                          i.splice(n, 1, [NL, t()]);
                        }, n);
                      return (
                        $L(n.blockParams) && i.push(NL, w$(n)),
                        ["<", n.tag, BL(i), t$(n)]
                      );
                    })(e, n)
                  ),
                  o =
                    "ignore" === t.htmlWhitespaceSensitivity &&
                    GL(e, ["ElementNode"])
                      ? ML
                      : "";
                if (ZL(r)) return [i, o];
                const s = ["</", r.tag, ">"];
                return 0 === r.children.length
                  ? [i, BL(s), o]
                  : "ignore" === t.htmlWhitespaceSensitivity
                  ? [i, BL(e$(e, t, n)), kL, BL(s), o]
                  : [i, BL(FL(e$(e, t, n))), BL(s), o];
              }
              case "BlockStatement": {
                const i = e.getParentNode(1);
                return i &&
                  i.inverse &&
                  1 === i.inverse.body.length &&
                  i.inverse.body[0] === r &&
                  "if" === i.inverse.body[0].path.parts[0]
                  ? [c$(e, n), h$(e, n, t), m$(e, n, t)]
                  : [u$(e, n), FL([h$(e, n, t), m$(e, n, t), p$(e, n, t)])];
              }
              case "ElementModifierStatement":
                return FL(["{{", E$(e, n), "}}"]);
              case "MustacheStatement":
                return FL([n$(r), E$(e, n), r$(r)]);
              case "SubExpression":
                return FL(["(", b$(e, n), ML, ")"]);
              case "AttrNode": {
                const e = "TextNode" === r.value.type;
                if (e && "" === r.value.chars && RL(r.value) === zL(r.value))
                  return r.name;
                const t = e
                    ? LL(r.value.chars, i).quote
                    : "ConcatStatement" === r.value.type
                    ? LL(
                        r.value.parts
                          .filter((e) => "TextNode" === e.type)
                          .map((e) => e.chars)
                          .join(""),
                        i
                      ).quote
                    : "",
                  o = n("value");
                return [
                  r.name,
                  "=",
                  t,
                  "class" === r.name && t ? FL(BL(o)) : o,
                  t,
                ];
              }
              case "ConcatStatement":
                return e.map(n, "parts");
              case "Hash":
                return PL(NL, e.map(n, "pairs"));
              case "HashPair":
                return [r.key, "=", n("value")];
              case "TextNode": {
                let n = r.chars.replace(/{{/g, "\\{{");
                const i = (function (e) {
                  for (let t = 0; t < 2; t++) {
                    const n = e.getParentNode(t);
                    if (n && "AttrNode" === n.type) return n.name.toLowerCase();
                  }
                })(e);
                if (i) {
                  if ("class" === i) {
                    const t = n.trim().split(/\s+/).join(" ");
                    let r = !1,
                      i = !1;
                    return (
                      XL(e, ["ConcatStatement"]) &&
                        (JL(e, ["MustacheStatement"]) &&
                          /^\s/.test(n) &&
                          (r = !0),
                        GL(e, ["MustacheStatement"]) &&
                          /\s$/.test(n) &&
                          "" !== t &&
                          (i = !0)),
                      [r ? NL : "", t, i ? NL : ""]
                    );
                  }
                  return jL(n);
                }
                const o = /^[\t\n\f\r ]*$/.test(n),
                  s = !WL(e),
                  a = !qL(e);
                if ("ignore" !== t.htmlWhitespaceSensitivity) {
                  const t = /^[\t\n\f\r ]*/,
                    r = /[\t\n\f\r ]*$/,
                    i = a && XL(e, ["Template"]),
                    u = s && XL(e, ["Template"]);
                  if (o) {
                    if (u || i) return "";
                    let t = [NL];
                    const r = y$(n);
                    return (
                      r && (t = v$(r)), HL(e) && (t = t.map((e) => _L(e))), t
                    );
                  }
                  const [l] = n.match(t),
                    [c] = n.match(r);
                  let p = [];
                  if (l) {
                    p = [NL];
                    const e = y$(l);
                    e && (p = v$(e)), (n = n.replace(t, ""));
                  }
                  let f = [];
                  if (c) {
                    if (!i) {
                      f = [NL];
                      const t = y$(c);
                      t && (f = v$(t)), HL(e) && (f = f.map((e) => _L(e)));
                    }
                    n = n.replace(r, "");
                  }
                  return [...p, TL(g$(n)), ...f];
                }
                const u = y$(n);
                let l = (function (e) {
                    return y$(
                      ((e = "string" == typeof e ? e : "").match(
                        /^([^\S\n\r]*[\n\r])+/g
                      ) || [])[0] || ""
                    );
                  })(n),
                  c = (function (e) {
                    return y$(
                      ((e = "string" == typeof e ? e : "").match(
                        /([\n\r][^\S\n\r]*)+$/g
                      ) || [])[0] || ""
                    );
                  })(n);
                if (
                  (s || a) &&
                  o &&
                  XL(e, ["Block", "ElementNode", "Template"])
                )
                  return "";
                o && u
                  ? ((l = Math.min(u, 2)), (c = 0))
                  : (GL(e, ["BlockStatement", "ElementNode"]) &&
                      (c = Math.max(c, 1)),
                    JL(e, ["BlockStatement", "ElementNode"]) &&
                      (l = Math.max(l, 1)));
                let p = "",
                  f = "";
                return (
                  0 === c && GL(e, ["MustacheStatement"]) && (f = " "),
                  0 === l && JL(e, ["MustacheStatement"]) && (p = " "),
                  s && ((l = 0), (p = "")),
                  a && ((c = 0), (f = "")),
                  (n = n
                    .replace(/^[\t\n\f\r ]+/g, p)
                    .replace(/[\t\n\f\r ]+$/, f)),
                  [...v$(l), TL(g$(n)), ...v$(c)]
                );
              }
              case "MustacheCommentStatement": {
                const e = RL(r),
                  n = zL(r),
                  i = "~" === t.originalText.charAt(e + 2),
                  o = "~" === t.originalText.charAt(n - 3),
                  s = r.value.includes("}}") ? "--" : "";
                return [
                  "{{",
                  i ? "~" : "",
                  "!",
                  s,
                  r.value,
                  s,
                  o ? "~" : "",
                  "}}",
                ];
              }
              case "PathExpression":
                return r.original;
              case "BooleanLiteral":
              case "NumberLiteral":
                return String(r.value);
              case "CommentStatement":
                return ["\x3c!--", r.value, "--\x3e"];
              case "StringLiteral":
                if (
                  (function (e) {
                    let t = 0,
                      n = e.getParentNode(t);
                    for (; n && YL(n, ["SubExpression"]); )
                      t++, (n = e.getParentNode(t));
                    return !!(
                      n &&
                      YL(e.getParentNode(t + 1), ["ConcatStatement"]) &&
                      YL(e.getParentNode(t + 2), ["AttrNode"])
                    );
                  })(e)
                ) {
                  const e = t.singleQuote ? '"' : "'";
                  return D$(r.value, e);
                }
                return D$(r.value, i);
              case "UndefinedLiteral":
                return "undefined";
              case "NullLiteral":
                return "null";
              default:
                throw new Error(
                  "unknown glimmer type: " + JSON.stringify(r.type)
                );
            }
          },
          massageAstNode: VL,
        };
        const S$ = A$;
        var _$ = {
          languages: [
            tD(
              {
                name: "Handlebars",
                type: "markup",
                color: "#f7931e",
                aliases: ["hbs", "htmlbars"],
                extensions: [".handlebars", ".hbs"],
                tmScope: "text.html.handlebars",
                aceMode: "handlebars",
                languageId: 155,
              },
              () => ({
                since: "2.3.0",
                parsers: ["glimmer"],
                vscodeLanguageIds: ["handlebars"],
              })
            ),
          ],
          printers: { glimmer: S$ },
          parsers: void 0,
        };
        const {
            builders: {
              join: T$,
              hardline: F$,
              line: k$,
              softline: O$,
              group: B$,
              indent: P$,
              ifBreak: N$,
            },
          } = Vl,
          { isNextLineEmpty: M$, isNonEmptyArray: I$ } = nl,
          { insertPragma: j$ } = {
            hasPragma: function (e) {
              return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(e);
            },
            insertPragma: function (e) {
              return "# @format\n\n" + e;
            },
          },
          { locStart: L$, locEnd: $$ } = {
            locStart: function (e) {
              return "number" == typeof e.start
                ? e.start
                : e.loc && e.loc.start;
            },
            locEnd: function (e) {
              return "number" == typeof e.end ? e.end : e.loc && e.loc.end;
            },
          };
        function R$(e, t, n) {
          if (0 === n.directives.length) return "";
          const r = T$(k$, e.map(t, "directives"));
          return "FragmentDefinition" === n.kind ||
            "OperationDefinition" === n.kind
            ? B$([k$, r])
            : [" ", B$(P$([O$, r]))];
        }
        function z$(e, t, n) {
          const r = e.getValue().length;
          return e.map((e, i) => {
            const o = n();
            return M$(t.originalText, e.getValue(), $$) && i < r - 1
              ? [o, F$]
              : o;
          });
        }
        function V$(e, t, n) {
          const r = e.getNode(),
            i = [],
            { interfaces: o } = r,
            s = e.map((e) => n(e), "interfaces");
          for (let e = 0; e < o.length; e++) {
            const n = o[e];
            i.push(s[e]);
            const r = o[e + 1];
            if (r) {
              const e = t.originalText.slice(n.loc.end, r.loc.start),
                o = e.includes("#"),
                s = e.replace(/#.*/g, "").trim();
              i.push("," === s ? "," : " &", o ? k$ : " ");
            }
          }
          return i;
        }
        function q$() {}
        q$.ignoredProperties = new Set(["loc", "comments"]);
        var W$ = {
          print: function (e, t, n) {
            const r = e.getValue();
            if (!r) return "";
            if ("string" == typeof r) return r;
            switch (r.kind) {
              case "Document": {
                const r = [];
                return (
                  e.each((e, i, o) => {
                    r.push(n()),
                      i !== o.length - 1 &&
                        (r.push(F$),
                        M$(t.originalText, e.getValue(), $$) && r.push(F$));
                  }, "definitions"),
                  [...r, F$]
                );
              }
              case "OperationDefinition": {
                const i = "{" !== t.originalText[L$(r)],
                  o = Boolean(r.name);
                return [
                  i ? r.operation : "",
                  i && o ? [" ", n("name")] : "",
                  i && !o && I$(r.variableDefinitions) ? " " : "",
                  I$(r.variableDefinitions)
                    ? B$([
                        "(",
                        P$([
                          O$,
                          T$(
                            [N$("", ", "), O$],
                            e.map(n, "variableDefinitions")
                          ),
                        ]),
                        O$,
                        ")",
                      ])
                    : "",
                  R$(e, n, r),
                  r.selectionSet && (i || o) ? " " : "",
                  n("selectionSet"),
                ];
              }
              case "FragmentDefinition":
                return [
                  "fragment ",
                  n("name"),
                  I$(r.variableDefinitions)
                    ? B$([
                        "(",
                        P$([
                          O$,
                          T$(
                            [N$("", ", "), O$],
                            e.map(n, "variableDefinitions")
                          ),
                        ]),
                        O$,
                        ")",
                      ])
                    : "",
                  " on ",
                  n("typeCondition"),
                  R$(e, n, r),
                  " ",
                  n("selectionSet"),
                ];
              case "SelectionSet":
                return [
                  "{",
                  P$([
                    F$,
                    T$(
                      F$,
                      e.call((e) => z$(e, t, n), "selections")
                    ),
                  ]),
                  F$,
                  "}",
                ];
              case "Field":
                return B$([
                  r.alias ? [n("alias"), ": "] : "",
                  n("name"),
                  r.arguments.length > 0
                    ? B$([
                        "(",
                        P$([
                          O$,
                          T$(
                            [N$("", ", "), O$],
                            e.call((e) => z$(e, t, n), "arguments")
                          ),
                        ]),
                        O$,
                        ")",
                      ])
                    : "",
                  R$(e, n, r),
                  r.selectionSet ? " " : "",
                  n("selectionSet"),
                ]);
              case "Name":
              case "IntValue":
              case "FloatValue":
              case "EnumValue":
                return r.value;
              case "StringValue":
                return r.block
                  ? [
                      '"""',
                      F$,
                      T$(F$, r.value.replace(/"""/g, "\\$&").split("\n")),
                      F$,
                      '"""',
                    ]
                  : [
                      '"',
                      r.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"),
                      '"',
                    ];
              case "BooleanValue":
                return r.value ? "true" : "false";
              case "NullValue":
                return "null";
              case "Variable":
                return ["$", n("name")];
              case "ListValue":
                return B$([
                  "[",
                  P$([O$, T$([N$("", ", "), O$], e.map(n, "values"))]),
                  O$,
                  "]",
                ]);
              case "ObjectValue":
                return B$([
                  "{",
                  t.bracketSpacing && r.fields.length > 0 ? " " : "",
                  P$([O$, T$([N$("", ", "), O$], e.map(n, "fields"))]),
                  O$,
                  N$("", t.bracketSpacing && r.fields.length > 0 ? " " : ""),
                  "}",
                ]);
              case "ObjectField":
              case "Argument":
                return [n("name"), ": ", n("value")];
              case "Directive":
                return [
                  "@",
                  n("name"),
                  r.arguments.length > 0
                    ? B$([
                        "(",
                        P$([
                          O$,
                          T$(
                            [N$("", ", "), O$],
                            e.call((e) => z$(e, t, n), "arguments")
                          ),
                        ]),
                        O$,
                        ")",
                      ])
                    : "",
                ];
              case "NamedType":
                return n("name");
              case "VariableDefinition":
                return [
                  n("variable"),
                  ": ",
                  n("type"),
                  r.defaultValue ? [" = ", n("defaultValue")] : "",
                  R$(e, n, r),
                ];
              case "ObjectTypeExtension":
              case "ObjectTypeDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  "ObjectTypeExtension" === r.kind ? "extend " : "",
                  "type ",
                  n("name"),
                  r.interfaces.length > 0
                    ? [" implements ", ...V$(e, t, n)]
                    : "",
                  R$(e, n, r),
                  r.fields.length > 0
                    ? [
                        " {",
                        P$([
                          F$,
                          T$(
                            F$,
                            e.call((e) => z$(e, t, n), "fields")
                          ),
                        ]),
                        F$,
                        "}",
                      ]
                    : "",
                ];
              case "FieldDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  n("name"),
                  r.arguments.length > 0
                    ? B$([
                        "(",
                        P$([
                          O$,
                          T$(
                            [N$("", ", "), O$],
                            e.call((e) => z$(e, t, n), "arguments")
                          ),
                        ]),
                        O$,
                        ")",
                      ])
                    : "",
                  ": ",
                  n("type"),
                  R$(e, n, r),
                ];
              case "DirectiveDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  "directive ",
                  "@",
                  n("name"),
                  r.arguments.length > 0
                    ? B$([
                        "(",
                        P$([
                          O$,
                          T$(
                            [N$("", ", "), O$],
                            e.call((e) => z$(e, t, n), "arguments")
                          ),
                        ]),
                        O$,
                        ")",
                      ])
                    : "",
                  r.repeatable ? " repeatable" : "",
                  " on ",
                  T$(" | ", e.map(n, "locations")),
                ];
              case "EnumTypeExtension":
              case "EnumTypeDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  "EnumTypeExtension" === r.kind ? "extend " : "",
                  "enum ",
                  n("name"),
                  R$(e, n, r),
                  r.values.length > 0
                    ? [
                        " {",
                        P$([
                          F$,
                          T$(
                            F$,
                            e.call((e) => z$(e, t, n), "values")
                          ),
                        ]),
                        F$,
                        "}",
                      ]
                    : "",
                ];
              case "EnumValueDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  n("name"),
                  R$(e, n, r),
                ];
              case "InputValueDefinition":
                return [
                  n("description"),
                  r.description ? (r.description.block ? F$ : k$) : "",
                  n("name"),
                  ": ",
                  n("type"),
                  r.defaultValue ? [" = ", n("defaultValue")] : "",
                  R$(e, n, r),
                ];
              case "InputObjectTypeExtension":
              case "InputObjectTypeDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  "InputObjectTypeExtension" === r.kind ? "extend " : "",
                  "input ",
                  n("name"),
                  R$(e, n, r),
                  r.fields.length > 0
                    ? [
                        " {",
                        P$([
                          F$,
                          T$(
                            F$,
                            e.call((e) => z$(e, t, n), "fields")
                          ),
                        ]),
                        F$,
                        "}",
                      ]
                    : "",
                ];
              case "SchemaDefinition":
                return [
                  "schema",
                  R$(e, n, r),
                  " {",
                  r.operationTypes.length > 0
                    ? P$([
                        F$,
                        T$(
                          F$,
                          e.call((e) => z$(e, t, n), "operationTypes")
                        ),
                      ])
                    : "",
                  F$,
                  "}",
                ];
              case "OperationTypeDefinition":
                return [n("operation"), ": ", n("type")];
              case "InterfaceTypeExtension":
              case "InterfaceTypeDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  "InterfaceTypeExtension" === r.kind ? "extend " : "",
                  "interface ",
                  n("name"),
                  r.interfaces.length > 0
                    ? [" implements ", ...V$(e, t, n)]
                    : "",
                  R$(e, n, r),
                  r.fields.length > 0
                    ? [
                        " {",
                        P$([
                          F$,
                          T$(
                            F$,
                            e.call((e) => z$(e, t, n), "fields")
                          ),
                        ]),
                        F$,
                        "}",
                      ]
                    : "",
                ];
              case "FragmentSpread":
                return ["...", n("name"), R$(e, n, r)];
              case "InlineFragment":
                return [
                  "...",
                  r.typeCondition ? [" on ", n("typeCondition")] : "",
                  R$(e, n, r),
                  " ",
                  n("selectionSet"),
                ];
              case "UnionTypeExtension":
              case "UnionTypeDefinition":
                return B$([
                  n("description"),
                  r.description ? F$ : "",
                  B$([
                    "UnionTypeExtension" === r.kind ? "extend " : "",
                    "union ",
                    n("name"),
                    R$(e, n, r),
                    r.types.length > 0
                      ? [
                          " =",
                          N$("", " "),
                          P$([
                            N$([k$, "  "]),
                            T$([k$, "| "], e.map(n, "types")),
                          ]),
                        ]
                      : "",
                  ]),
                ]);
              case "ScalarTypeExtension":
              case "ScalarTypeDefinition":
                return [
                  n("description"),
                  r.description ? F$ : "",
                  "ScalarTypeExtension" === r.kind ? "extend " : "",
                  "scalar ",
                  n("name"),
                  R$(e, n, r),
                ];
              case "NonNullType":
                return [n("type"), "!"];
              case "ListType":
                return ["[", n("type"), "]"];
              default:
                throw new Error(
                  "unknown graphql type: " + JSON.stringify(r.kind)
                );
            }
          },
          massageAstNode: q$,
          hasPrettierIgnore: function (e) {
            const t = e.getValue();
            return (
              t &&
              Array.isArray(t.comments) &&
              t.comments.some((e) => "prettier-ignore" === e.value.trim())
            );
          },
          insertPragma: j$,
          printComment: function (e) {
            const t = e.getValue();
            if ("Comment" === t.kind) return "#" + t.value.trimEnd();
            throw new Error("Not a comment: " + JSON.stringify(t));
          },
          canAttachComment: function (e) {
            return e.kind && "Comment" !== e.kind;
          },
        };
        const U$ = W$,
          H$ = { bracketSpacing: UM.bracketSpacing };
        var G$ = {
            languages: [
              tD(
                {
                  name: "GraphQL",
                  type: "data",
                  color: "#e10098",
                  extensions: [".graphql", ".gql", ".graphqls"],
                  tmScope: "source.graphql",
                  aceMode: "text",
                  languageId: 139,
                },
                () => ({
                  since: "1.5.0",
                  parsers: ["graphql"],
                  vscodeLanguageIds: ["graphql"],
                })
              ),
            ],
            options: H$,
            printers: { graphql: U$ },
            parsers: void 0,
          },
          Y$ = {
            locStart: function (e) {
              return e.position.start.offset;
            },
            locEnd: function (e) {
              return e.position.end.offset;
            },
          };
        const { getLast: X$ } = nl,
          { locStart: J$, locEnd: Z$ } = Y$,
          {
            cjkPattern: K$,
            kPattern: Q$,
            punctuationPattern: eR,
          } = {
            cjkPattern:
              "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?",
            kPattern:
              "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]",
            punctuationPattern:
              "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]",
          },
          tR = [
            "liquidNode",
            "inlineCode",
            "emphasis",
            "esComment",
            "strong",
            "delete",
            "wikiLink",
            "link",
            "linkReference",
            "image",
            "imageReference",
            "footnote",
            "footnoteReference",
            "sentence",
            "whitespace",
            "word",
            "break",
            "inlineMath",
          ],
          nR = [...tR, "tableCell", "paragraph", "heading"],
          rR = new RegExp(Q$),
          iR = new RegExp(eR);
        function oR(e, t) {
          const [, n, r, i] = t
            .slice(e.position.start.offset, e.position.end.offset)
            .match(/^\s*(\d+)(\.|\))(\s*)/);
          return { numberText: n, marker: r, leadingSpaces: i };
        }
        var sR = {
          mapAst: function (e, t) {
            return (function e(n, r, i) {
              const o = Object.assign({}, t(n, r, i));
              return (
                o.children &&
                  (o.children = o.children.map((t, n) => e(t, n, [o, ...i]))),
                o
              );
            })(e, null, []);
          },
          splitText: function (e, t) {
            const n = "non-cjk",
              r = "cj-letter",
              i = "cjk-punctuation",
              o = [],
              s = (
                "preserve" === t.proseWrap
                  ? e
                  : e.replace(
                      new RegExp("(".concat(K$, ")\n(").concat(K$, ")"), "g"),
                      "$1$2"
                    )
              ).split(/([\t\n ]+)/);
            for (const [e, t] of s.entries()) {
              if (e % 2 == 1) {
                o.push({
                  type: "whitespace",
                  value: /\n/.test(t) ? "\n" : " ",
                });
                continue;
              }
              if ((0 === e || e === s.length - 1) && "" === t) continue;
              const u = t.split(new RegExp("(".concat(K$, ")")));
              for (const [e, t] of u.entries())
                ((0 !== e && e !== u.length - 1) || "" !== t) &&
                  (e % 2 != 0
                    ? a(
                        iR.test(t)
                          ? {
                              type: "word",
                              value: t,
                              kind: i,
                              hasLeadingPunctuation: !0,
                              hasTrailingPunctuation: !0,
                            }
                          : {
                              type: "word",
                              value: t,
                              kind: rR.test(t) ? "k-letter" : r,
                              hasLeadingPunctuation: !1,
                              hasTrailingPunctuation: !1,
                            }
                      )
                    : "" !== t &&
                      a({
                        type: "word",
                        value: t,
                        kind: n,
                        hasLeadingPunctuation: iR.test(t[0]),
                        hasTrailingPunctuation: iR.test(X$(t)),
                      }));
            }
            return o;
            function a(e) {
              const t = X$(o);
              var s, a;
              t &&
                "word" === t.type &&
                ((t.kind === n && e.kind === r && !t.hasTrailingPunctuation) ||
                (t.kind === r && e.kind === n && !e.hasLeadingPunctuation)
                  ? o.push({ type: "whitespace", value: " " })
                  : ((s = n),
                    (a = i),
                    (t.kind === s && e.kind === a) ||
                      (t.kind === a && e.kind === s) ||
                      [t.value, e.value].some((e) => /\u3000/.test(e)) ||
                      o.push({ type: "whitespace", value: "" }))),
                o.push(e);
            }
          },
          punctuationPattern: eR,
          getFencedCodeBlockValue: function (e, t) {
            const { value: n } = e;
            return e.position.end.offset === t.length &&
              n.endsWith("\n") &&
              t.endsWith("\n")
              ? n.slice(0, -1)
              : n;
          },
          getOrderedListItemInfo: oR,
          hasGitDiffFriendlyOrderedList: function (e, t) {
            if (!e.ordered) return !1;
            if (e.children.length < 2) return !1;
            const n = Number(oR(e.children[0], t.originalText).numberText),
              r = Number(oR(e.children[1], t.originalText).numberText);
            if (0 === n && e.children.length > 2) {
              const n = Number(oR(e.children[2], t.originalText).numberText);
              return 1 === r && 1 === n;
            }
            return 1 === r;
          },
          INLINE_NODE_TYPES: tR,
          INLINE_NODE_WRAPPER_TYPES: nR,
          isAutolink: function (e) {
            if (!e || "link" !== e.type || 1 !== e.children.length) return !1;
            const t = e.children[0];
            return t && J$(e) === J$(t) && Z$(e) === Z$(t);
          },
        };
        const { inferParserByLanguage: aR, getMaxContinuousCount: uR } = nl,
          {
            builders: { hardline: lR, markAsRoot: cR },
            utils: { replaceEndOfLine: pR },
          } = Vl,
          fR = uI,
          { getFencedCodeBlockValue: dR } = sR;
        const hR = fI,
          mR = ["format", "prettier"];
        function gR(e) {
          const t = "@(".concat(mR.join("|"), ")"),
            n = new RegExp(
              [
                "\x3c!--\\s*".concat(t, "\\s*--\x3e"),
                "{\\s*\\/\\*\\s*".concat(t, "\\s*\\*\\/\\s*}"),
                "\x3c!--.*\r?\n[\\s\\S]*(^|\n)[^\\S\n]*".concat(
                  t,
                  "[^\\S\n]*($|\n)[\\s\\S]*\n.*--\x3e"
                ),
              ].join("|"),
              "m"
            ),
            r = e.match(n);
          return r && 0 === r.index;
        }
        var yR = {
          startWithPragma: gR,
          hasPragma: (e) => gR(hR(e).content.trimStart()),
          insertPragma: (e) => {
            const t = hR(e),
              n = "\x3c!-- @".concat(mR[0], " --\x3e");
            return t.frontMatter
              ? ""
                  .concat(t.frontMatter.raw, "\n\n")
                  .concat(n, "\n\n")
                  .concat(t.content)
              : "".concat(n, "\n\n").concat(t.content);
          },
        };
        const vR = ns,
          { getOrderedListItemInfo: DR, mapAst: bR, splitText: ER } = sR,
          CR = /^.$/su;
        function xR(e, t, n) {
          return bR(e, (e) => {
            if (!e.children) return e;
            const r = e.children.reduce((e, r) => {
              const i = vR(e);
              return i && t(i, r) ? e.splice(-1, 1, n(i, r)) : e.push(r), e;
            }, []);
            return Object.assign(Object.assign({}, e), {}, { children: r });
          });
        }
        const { isFrontMatterNode: wR } = nl,
          { startWithPragma: AR } = yR,
          SR = new Set(["position", "raw"]);
        function _R(e, t, n) {
          return (
            ("front-matter" !== e.type &&
              "code" !== e.type &&
              "yaml" !== e.type &&
              "import" !== e.type &&
              "export" !== e.type &&
              "jsx" !== e.type) ||
              delete t.value,
            "list" === e.type && delete t.isAligned,
            ("list" !== e.type && "listItem" !== e.type) ||
              (delete t.spread, delete t.loose),
            "text" === e.type
              ? null
              : ("inlineCode" === e.type &&
                  (t.value = e.value.replace(/[\t\n ]+/g, " ")),
                "wikiLink" === e.type &&
                  (t.value = e.value.trim().replace(/[\t\n]+/g, " ")),
                ("definition" !== e.type && "linkReference" !== e.type) ||
                  (t.label = e.label
                    .trim()
                    .replace(/[\t\n ]+/g, " ")
                    .toLowerCase()),
                ("definition" !== e.type &&
                  "link" !== e.type &&
                  "image" !== e.type) ||
                  !e.title ||
                  (t.title = e.title.replace(/\\(["')])/g, "$1")),
                n &&
                "root" === n.type &&
                n.children.length > 0 &&
                (n.children[0] === e ||
                  (wR(n.children[0]) && n.children[1] === e)) &&
                "html" === e.type &&
                AR(e.value)
                  ? null
                  : void 0)
          );
        }
        _R.ignoredProperties = SR;
        var TR = _R;
        const {
            getLast: FR,
            getMinNotPresentContinuousCount: kR,
            getMaxContinuousCount: OR,
            getStringWidth: BR,
            isNonEmptyArray: PR,
          } = nl,
          {
            builders: {
              breakParent: NR,
              join: MR,
              line: IR,
              literalline: jR,
              markAsRoot: LR,
              hardline: $R,
              softline: RR,
              ifBreak: zR,
              fill: VR,
              align: qR,
              indent: WR,
              group: UR,
              hardlineWithoutBreakParent: HR,
            },
            utils: { normalizeDoc: GR, replaceTextEndOfLine: YR },
            printer: { printDocToString: XR },
          } = Vl,
          JR = function (e, t, n, r) {
            const i = e.getValue();
            if ("code" === i.type && null !== i.lang) {
              const e = aR(i.lang, r);
              if (e) {
                const t = r.__inJsTemplate ? "~" : "`",
                  o = t.repeat(Math.max(3, uR(i.value, t) + 1)),
                  s = { parser: e };
                "tsx" === i.lang && (s.filepath = "dummy.tsx");
                const a = n(dR(i, r.originalText), s, {
                  stripTrailingHardline: !0,
                });
                return cR([
                  o,
                  i.lang,
                  i.meta ? " " + i.meta : "",
                  lR,
                  pR(a),
                  lR,
                  o,
                ]);
              }
            }
            switch (i.type) {
              case "front-matter":
                return fR(i, n);
              case "importExport":
                return [
                  n(
                    i.value,
                    { parser: "babel" },
                    { stripTrailingHardline: !0 }
                  ),
                  lR,
                ];
              case "jsx":
                return n(
                  "<$>".concat(i.value, "</$>"),
                  { parser: "__js_expression", rootMarker: "mdx" },
                  { stripTrailingHardline: !0 }
                );
            }
            return null;
          },
          { insertPragma: ZR } = yR,
          { locStart: KR, locEnd: QR } = Y$,
          ez = function (e, t) {
            return (
              (e = (function (e, t) {
                return bR(e, (e) =>
                  "text" === e.type &&
                  "*" !== e.value &&
                  "_" !== e.value &&
                  CR.test(e.value) &&
                  e.position.end.offset - e.position.start.offset !==
                    e.value.length
                    ? Object.assign(
                        Object.assign({}, e),
                        {},
                        {
                          value: t.originalText.slice(
                            e.position.start.offset,
                            e.position.end.offset
                          ),
                        }
                      )
                    : e
                );
              })(e, t)),
              (e = (function (e, t) {
                return bR(e, (e, n, r) => {
                  if ("code" === e.type) {
                    const n = /^\n?(?: {4,}|\t)/.test(
                      t.originalText.slice(
                        e.position.start.offset,
                        e.position.end.offset
                      )
                    );
                    if (((e.isIndented = n), n))
                      for (let e = 0; e < r.length; e++) {
                        const t = r[e];
                        if (t.hasIndentedCodeblock) break;
                        "list" === t.type && (t.hasIndentedCodeblock = !0);
                      }
                  }
                  return e;
                });
              })(
                (e = (function (e) {
                  return bR(e, (e) =>
                    "inlineCode" !== e.type
                      ? e
                      : Object.assign(
                          Object.assign({}, e),
                          {},
                          { value: e.value.replace(/\s+/g, " ") }
                        )
                  );
                })(
                  (e = (function (e) {
                    return xR(
                      e,
                      (e, t) => "text" === e.type && "text" === t.type,
                      (e, t) => ({
                        type: "text",
                        value: e.value + t.value,
                        position: {
                          start: e.position.start,
                          end: t.position.end,
                        },
                      })
                    );
                  })(e))
                )),
                t
              )),
              (e = (function (e, t) {
                return bR(e, (e, t, n) => {
                  if ("list" === e.type && e.children.length > 0) {
                    for (let t = 0; t < n.length; t++) {
                      const r = n[t];
                      if ("list" === r.type && !r.isAligned)
                        return (e.isAligned = !1), e;
                    }
                    e.isAligned = r(e);
                  }
                  return e;
                });
                function n(e) {
                  return 0 === e.children.length
                    ? -1
                    : e.children[0].position.start.column - 1;
                }
                function r(e) {
                  if (!e.ordered) return !0;
                  const [r, i] = e.children;
                  if (DR(r, t.originalText).leadingSpaces.length > 1) return !0;
                  const o = n(r);
                  return (
                    -1 !== o &&
                    (1 === e.children.length
                      ? o % t.tabWidth == 0
                      : o === n(i) &&
                        (o % t.tabWidth == 0 ||
                          DR(i, t.originalText).leadingSpaces.length > 1))
                  );
                }
              })(e, t)),
              (e = (function (e, t) {
                return bR(e, (e, n, r) => {
                  let [i] = r;
                  if ("text" !== e.type) return e;
                  let { value: o } = e;
                  return (
                    "paragraph" === i.type &&
                      (0 === n && (o = o.trimStart()),
                      n === i.children.length - 1 && (o = o.trimEnd())),
                    {
                      type: "sentence",
                      position: e.position,
                      children: ER(o, t),
                    }
                  );
                });
              })(e, t)),
              (function (e) {
                return xR(
                  e,
                  (e, t) =>
                    "importExport" === e.type && "importExport" === t.type,
                  (e, t) => ({
                    type: "importExport",
                    value: e.value + "\n\n" + t.value,
                    position: { start: e.position.start, end: t.position.end },
                  })
                );
              })(
                (e = (function (e) {
                  return bR(e, (e) =>
                    "import" !== e.type && "export" !== e.type
                      ? e
                      : Object.assign(
                          Object.assign({}, e),
                          {},
                          { type: "importExport" }
                        )
                  );
                })(e))
              )
            );
          },
          tz = TR,
          {
            getFencedCodeBlockValue: nz,
            hasGitDiffFriendlyOrderedList: rz,
            splitText: iz,
            punctuationPattern: oz,
            INLINE_NODE_TYPES: sz,
            INLINE_NODE_WRAPPER_TYPES: az,
            isAutolink: uz,
          } = sR,
          lz = new Set(["importExport"]),
          cz = ["heading", "tableCell", "link", "wikiLink"],
          pz = new Set(["listItem", "definition", "footnoteDefinition"]);
        function fz(e, t, n, r) {
          const i = e.getValue(),
            o = null === i.checked ? "" : i.checked ? "[x] " : "[ ] ";
          return [
            o,
            vz(e, t, n, {
              processor: (e, i) => {
                if (0 === i && "list" !== e.getValue().type)
                  return qR(" ".repeat(o.length), n());
                const s = " ".repeat(
                  (function (e, t, n) {
                    return e < 0 ? 0 : e > 3 ? 3 : e;
                  })(t.tabWidth - r.length)
                );
                return [s, qR(s, n())];
              },
            }),
          ];
        }
        function dz(e, t) {
          return (function (e, t, n) {
            let r = -1;
            for (const i of t.children)
              if ((i.type === e.type && n(i) ? r++ : (r = -1), i === e))
                return r;
          })(e, t, (t) => t.ordered === e.ordered);
        }
        function hz(e, t) {
          const n = Array.isArray(t) ? t : [t];
          let r,
            i = -1;
          for (; (r = e.getParentNode(++i)); ) if (n.includes(r.type)) return i;
          return -1;
        }
        function mz(e, t) {
          const n = hz(e, t);
          return -1 === n ? null : e.getParentNode(n);
        }
        function gz(e, t, n) {
          if ("preserve" === n.proseWrap && "\n" === t) return $R;
          const r = "always" === n.proseWrap && !mz(e, cz);
          return "" !== t ? (r ? IR : " ") : r ? RR : "";
        }
        function yz(e, t, n) {
          const r = [];
          let i = null;
          const { children: o } = e.getValue();
          for (const [e, t] of o.entries())
            switch (bz(t)) {
              case "start":
                null === i && (i = { index: e, offset: t.position.end.offset });
                break;
              case "end":
                null !== i &&
                  (r.push({
                    start: i,
                    end: { index: e, offset: t.position.start.offset },
                  }),
                  (i = null));
            }
          return vz(e, t, n, {
            processor: (e, i) => {
              if (r.length > 0) {
                const e = r[0];
                if (i === e.start.index)
                  return [
                    o[e.start.index].value,
                    t.originalText.slice(e.start.offset, e.end.offset),
                    o[e.end.index].value,
                  ];
                if (e.start.index < i && i < e.end.index) return !1;
                if (i === e.end.index) return r.shift(), !1;
              }
              return n();
            },
          });
        }
        function vz(e, t, n) {
          let r =
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          const { postprocessor: i } = r,
            o = r.processor || (() => n()),
            s = e.getValue(),
            a = [];
          let u;
          return (
            e.each((e, n) => {
              const r = e.getValue(),
                i = o(e, n);
              if (!1 !== i) {
                const e = { parts: a, prevNode: u, parentNode: s, options: t };
                Ez(r, e) &&
                  (a.push($R),
                  (u && lz.has(u.type)) ||
                    ((Cz(r, e) || xz(r, e)) && a.push($R)),
                  xz(r, e) && a.push($R)),
                  a.push(i),
                  (u = r);
              }
            }, "children"),
            i ? i(a) : a
          );
        }
        function Dz(e) {
          let t = e;
          for (; PR(t.children); ) t = FR(t.children);
          return t;
        }
        function bz(e) {
          let t;
          if ("html" === e.type)
            t = e.value.match(
              /^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/
            );
          else {
            let n;
            "esComment" === e.type
              ? (n = e)
              : "paragraph" === e.type &&
                1 === e.children.length &&
                "esComment" === e.children[0].type &&
                (n = e.children[0]),
              n && (t = n.value.match(/^prettier-ignore(?:-(start|end))?$/));
          }
          return !!t && (t[1] ? t[1] : "next");
        }
        function Ez(e, t) {
          const n = 0 === t.parts.length,
            r = sz.includes(e.type),
            i = "html" === e.type && az.includes(t.parentNode.type);
          return !n && !r && !i;
        }
        function Cz(e, t) {
          const n =
              (t.prevNode && t.prevNode.type) === e.type && pz.has(e.type),
            r = "listItem" === t.parentNode.type && !t.parentNode.loose,
            i =
              t.prevNode && "listItem" === t.prevNode.type && t.prevNode.loose,
            o = "next" === bz(t.prevNode),
            s =
              "html" === e.type &&
              t.prevNode &&
              "html" === t.prevNode.type &&
              t.prevNode.position.end.line + 1 === e.position.start.line,
            a =
              "html" === e.type &&
              "listItem" === t.parentNode.type &&
              t.prevNode &&
              "paragraph" === t.prevNode.type &&
              t.prevNode.position.end.line + 1 === e.position.start.line;
          return i || !(n || r || o || s || a);
        }
        function xz(e, t) {
          const n = t.prevNode && "list" === t.prevNode.type,
            r = "code" === e.type && e.isIndented;
          return n && r;
        }
        function wz(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          const n = [" ", ...(Array.isArray(t) ? t : [t])];
          return new RegExp(n.map((e) => "\\".concat(e)).join("|")).test(e)
            ? "<".concat(e, ">")
            : e;
        }
        function Az(e, t) {
          if (!e) return "";
          if (
            !(arguments.length > 2 && void 0 !== arguments[2]) ||
            arguments[2]
          )
            return " " + Az(e, t, !1);
          if (
            (e = e.replace(/\\(["')])/g, "$1")).includes('"') &&
            e.includes("'") &&
            !e.includes(")")
          )
            return "(".concat(e, ")");
          const n = e.split("'").length - 1,
            r = e.split('"').length - 1,
            i = n > r ? '"' : r > n || t.singleQuote ? "'" : '"';
          return (
            (e = (e = e.replace(/\\/, "\\\\")).replace(
              new RegExp("(".concat(i, ")"), "g"),
              "\\$1"
            )),
            "".concat(i).concat(e).concat(i)
          );
        }
        var Sz = {
            preprocess: ez,
            print: function (e, t, n) {
              const r = e.getValue();
              if (
                (function (e) {
                  const t = mz(e, ["linkReference", "imageReference"]);
                  return (
                    t &&
                    ("linkReference" !== t.type || "full" !== t.referenceType)
                  );
                })(e)
              )
                return iz(
                  t.originalText.slice(
                    r.position.start.offset,
                    r.position.end.offset
                  ),
                  t
                ).map((n) =>
                  "word" === n.type
                    ? n.value
                    : "" === n.value
                    ? ""
                    : gz(e, n.value, t)
                );
              switch (r.type) {
                case "front-matter":
                  return t.originalText.slice(
                    r.position.start.offset,
                    r.position.end.offset
                  );
                case "root":
                  return 0 === r.children.length
                    ? ""
                    : [GR(yz(e, t, n)), lz.has(Dz(r).type) ? "" : $R];
                case "paragraph":
                  return vz(e, t, n, { postprocessor: VR });
                case "sentence":
                  return vz(e, t, n);
                case "word": {
                  let t = r.value
                    .replace(/\*/g, "\\$&")
                    .replace(
                      new RegExp(
                        [
                          "(^|".concat(oz, ")(_+)"),
                          "(_+)(".concat(oz, "|$)"),
                        ].join("|"),
                        "g"
                      ),
                      (e, t, n, r, i) =>
                        (n
                          ? "".concat(t).concat(n)
                          : "".concat(r).concat(i)
                        ).replace(/_/g, "\\_")
                    );
                  const n = (e, t, n) => "sentence" === e.type && 0 === n,
                    i = (e, t, n) => uz(e.children[n - 1]);
                  return (
                    t !== r.value &&
                      (e.match(void 0, n, i) ||
                        e.match(
                          void 0,
                          n,
                          (e, t, n) => "emphasis" === e.type && 0 === n,
                          i
                        )) &&
                      (t = t.replace(/^(\\?[*_])+/, (e) =>
                        e.replace(/\\/g, "")
                      )),
                    t
                  );
                }
                case "whitespace": {
                  const n = e.getParentNode(),
                    i = n.children.indexOf(r),
                    o = n.children[i + 1],
                    s =
                      o && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(o.value)
                        ? "never"
                        : t.proseWrap;
                  return gz(e, r.value, { proseWrap: s });
                }
                case "emphasis": {
                  let i;
                  if (uz(r.children[0]))
                    i = t.originalText[r.position.start.offset];
                  else {
                    const t = e.getParentNode(),
                      n = t.children.indexOf(r),
                      o = t.children[n - 1],
                      s = t.children[n + 1];
                    i =
                      (o &&
                        "sentence" === o.type &&
                        o.children.length > 0 &&
                        "word" === FR(o.children).type &&
                        !FR(o.children).hasTrailingPunctuation) ||
                      (s &&
                        "sentence" === s.type &&
                        s.children.length > 0 &&
                        "word" === s.children[0].type &&
                        !s.children[0].hasLeadingPunctuation) ||
                      mz(e, "emphasis")
                        ? "*"
                        : "_";
                  }
                  return [i, vz(e, t, n), i];
                }
                case "strong":
                  return ["**", vz(e, t, n), "**"];
                case "delete":
                  return ["~~", vz(e, t, n), "~~"];
                case "inlineCode": {
                  const e = kR(r.value, "`"),
                    t = "`".repeat(e || 1),
                    n = e && !/^\s/.test(r.value) ? " " : "";
                  return [t, n, r.value, n, t];
                }
                case "wikiLink": {
                  let e = "";
                  return (
                    (e =
                      "preserve" === t.proseWrap
                        ? r.value
                        : r.value.replace(/[\t\n]+/g, " ")),
                    ["[[", e, "]]"]
                  );
                }
                case "link":
                  switch (t.originalText[r.position.start.offset]) {
                    case "<": {
                      const e = "mailto:";
                      return [
                        "<",
                        r.url.startsWith(e) &&
                        t.originalText.slice(
                          r.position.start.offset + 1,
                          r.position.start.offset + 1 + e.length
                        ) !== e
                          ? r.url.slice(e.length)
                          : r.url,
                        ">",
                      ];
                    }
                    case "[":
                      return [
                        "[",
                        vz(e, t, n),
                        "](",
                        wz(r.url, ")"),
                        Az(r.title, t),
                        ")",
                      ];
                    default:
                      return t.originalText.slice(
                        r.position.start.offset,
                        r.position.end.offset
                      );
                  }
                case "image":
                  return [
                    "![",
                    r.alt || "",
                    "](",
                    wz(r.url, ")"),
                    Az(r.title, t),
                    ")",
                  ];
                case "blockquote":
                  return ["> ", qR("> ", vz(e, t, n))];
                case "heading":
                  return ["#".repeat(r.depth) + " ", vz(e, t, n)];
                case "code": {
                  if (r.isIndented) {
                    const e = " ".repeat(4);
                    return qR(e, [e, ...YR(r.value, $R)]);
                  }
                  const e = t.__inJsTemplate ? "~" : "`",
                    n = e.repeat(Math.max(3, OR(r.value, e) + 1));
                  return [
                    n,
                    r.lang || "",
                    r.meta ? " " + r.meta : "",
                    $R,
                    ...YR(nz(r, t.originalText), $R),
                    $R,
                    n,
                  ];
                }
                case "html": {
                  const t = e.getParentNode(),
                    n =
                      "root" === t.type && FR(t.children) === r
                        ? r.value.trimEnd()
                        : r.value,
                    i = /^<!--.*-->$/s.test(n);
                  return YR(n, i ? $R : LR(jR));
                }
                case "list": {
                  const i = dz(r, e.getParentNode()),
                    o = rz(r, t);
                  return vz(e, t, n, {
                    processor: (e, s) => {
                      const a = (function () {
                          const e = r.ordered
                            ? (0 === s ? r.start : o ? 1 : r.start + s) +
                              (i % 2 == 0 ? ". " : ") ")
                            : i % 2 == 0
                            ? "- "
                            : "* ";
                          return r.isAligned || r.hasIndentedCodeblock
                            ? (function (e, t) {
                                const n = (function () {
                                  const n = e.length % t.tabWidth;
                                  return 0 === n ? 0 : t.tabWidth - n;
                                })();
                                return e + " ".repeat(n >= 4 ? 0 : n);
                              })(e, t)
                            : e;
                        })(),
                        u = e.getValue();
                      return 2 === u.children.length &&
                        "html" === u.children[1].type &&
                        u.children[0].position.start.column !==
                          u.children[1].position.start.column
                        ? [a, fz(e, t, n, a)]
                        : [a, qR(" ".repeat(a.length), fz(e, t, n, a))];
                    },
                  });
                }
                case "thematicBreak": {
                  const t = hz(e, "list");
                  return -1 === t
                    ? "---"
                    : dz(e.getParentNode(t), e.getParentNode(t + 1)) % 2 == 0
                    ? "***"
                    : "---";
                }
                case "linkReference":
                  return [
                    "[",
                    vz(e, t, n),
                    "]",
                    "full" === r.referenceType
                      ? ["[", r.identifier, "]"]
                      : "collapsed" === r.referenceType
                      ? "[]"
                      : "",
                  ];
                case "imageReference":
                  return "full" === r.referenceType
                    ? ["![", r.alt || "", "][", r.identifier, "]"]
                    : [
                        "![",
                        r.alt,
                        "]",
                        "collapsed" === r.referenceType ? "[]" : "",
                      ];
                case "definition": {
                  const e = "always" === t.proseWrap ? IR : " ";
                  return UR([
                    "[",
                    r.identifier,
                    "]:",
                    WR([
                      e,
                      wz(r.url),
                      null === r.title ? "" : [e, Az(r.title, t, !1)],
                    ]),
                  ]);
                }
                case "footnote":
                  return ["[^", vz(e, t, n), "]"];
                case "footnoteReference":
                  return ["[^", r.identifier, "]"];
                case "footnoteDefinition": {
                  const i = e.getParentNode().children[e.getName() + 1],
                    o =
                      1 === r.children.length &&
                      "paragraph" === r.children[0].type &&
                      ("never" === t.proseWrap ||
                        ("preserve" === t.proseWrap &&
                          r.children[0].position.start.line ===
                            r.children[0].position.end.line));
                  return [
                    "[^",
                    r.identifier,
                    "]: ",
                    o
                      ? vz(e, t, n)
                      : UR([
                          qR(
                            " ".repeat(4),
                            vz(e, t, n, {
                              processor: (e, t) =>
                                0 === t ? UR([RR, n()]) : n(),
                            })
                          ),
                          i && "footnoteDefinition" === i.type ? RR : "",
                        ]),
                  ];
                }
                case "table":
                  return (function (e, t, n) {
                    const r = e.getValue(),
                      i = [],
                      o = e.map(
                        (e) =>
                          e.map((e, r) => {
                            const o = XR(n(), t).formatted,
                              s = BR(o);
                            return (
                              (i[r] = Math.max(i[r] || 3, s)),
                              { text: o, width: s }
                            );
                          }, "children"),
                        "children"
                      ),
                      s = u(!1);
                    if ("never" !== t.proseWrap) return [NR, s];
                    const a = u(!0);
                    return [NR, UR(zR(a, s))];
                    function u(e) {
                      const t = [c(o[0], e), l(e)];
                      return (
                        o.length > 1 &&
                          t.push(
                            MR(
                              HR,
                              o.slice(1).map((t) => c(t, e))
                            )
                          ),
                        MR(HR, t)
                      );
                    }
                    function l(e) {
                      const t = i.map((t, n) => {
                        const i = r.align[n],
                          o = "center" === i || "left" === i ? ":" : "-",
                          s = "center" === i || "right" === i ? ":" : "-",
                          a = e ? "-" : "-".repeat(t - 2);
                        return "".concat(o).concat(a).concat(s);
                      });
                      return "| ".concat(t.join(" | "), " |");
                    }
                    function c(e, t) {
                      const n = e.map((e, n) => {
                        let { text: o, width: s } = e;
                        if (t) return o;
                        const a = i[n] - s,
                          u = r.align[n];
                        let l = 0;
                        "right" === u
                          ? (l = a)
                          : "center" === u && (l = Math.floor(a / 2));
                        const c = a - l;
                        return ""
                          .concat(" ".repeat(l))
                          .concat(o)
                          .concat(" ".repeat(c));
                      });
                      return "| ".concat(n.join(" | "), " |");
                    }
                  })(e, t, n);
                case "tableCell":
                  return vz(e, t, n);
                case "break":
                  return /\s/.test(t.originalText[r.position.start.offset])
                    ? ["  ", LR(jR)]
                    : ["\\", $R];
                case "liquidNode":
                  return YR(r.value, $R);
                case "importExport":
                  return [r.value, $R];
                case "esComment":
                  return ["{/* ", r.value, " */}"];
                case "jsx":
                  return r.value;
                case "math":
                  return [
                    "$$",
                    $R,
                    r.value ? [...YR(r.value, $R), $R] : "",
                    "$$",
                  ];
                case "inlineMath":
                  return t.originalText.slice(KR(r), QR(r));
                default:
                  throw new Error(
                    "Unknown markdown type ".concat(JSON.stringify(r.type))
                  );
              }
            },
            embed: JR,
            massageAstNode: tz,
            hasPrettierIgnore: function (e) {
              const t = Number(e.getName());
              return (
                0 !== t && "next" === bz(e.getParentNode().children[t - 1])
              );
            },
            insertPragma: ZR,
          },
          _z = {
            name: "Markdown",
            type: "prose",
            color: "#083fa1",
            aliases: ["pandoc"],
            aceMode: "markdown",
            codemirrorMode: "gfm",
            codemirrorMimeType: "text/x-gfm",
            wrap: !0,
            extensions: [
              ".md",
              ".markdown",
              ".mdown",
              ".mdwn",
              ".mdx",
              ".mkd",
              ".mkdn",
              ".mkdown",
              ".ronn",
              ".scd",
              ".workbook",
            ],
            filenames: ["contents.lr"],
            tmScope: "source.gfm",
            languageId: 222,
          };
        const Tz = tD,
          Fz = Sz,
          kz = { proseWrap: UM.proseWrap, singleQuote: UM.singleQuote },
          Oz = [
            Tz(_z, (e) => ({
              since: "1.8.0",
              parsers: ["markdown"],
              vscodeLanguageIds: ["markdown"],
              filenames: [...e.filenames, "README"],
              extensions: e.extensions.filter((e) => ".mdx" !== e),
            })),
            Tz(_z, () => ({
              name: "MDX",
              since: "1.15.0",
              parsers: ["mdx"],
              vscodeLanguageIds: ["mdx"],
              filenames: [],
              extensions: [".mdx"],
            })),
          ];
        var Bz = {
          languages: Oz,
          options: kz,
          printers: { mdast: Fz },
          parsers: void 0,
        };
        const { isFrontMatterNode: Pz } = nl,
          Nz = new Set([
            "sourceSpan",
            "startSourceSpan",
            "endSourceSpan",
            "nameSpan",
            "valueSpan",
          ]);
        function Mz(e, t) {
          return "text" === e.type ||
            "comment" === e.type ||
            Pz(e) ||
            "yaml" === e.type ||
            "toml" === e.type
            ? null
            : ("attribute" === e.type && delete t.value,
              void ("docType" === e.type && delete t.value));
        }
        Mz.ignoredProperties = Nz;
        var Iz = Mz;
        const { inferParserByLanguage: jz, isFrontMatterNode: Lz } = nl,
          {
            builders: { line: $z, hardline: Rz, join: zz },
            utils: { getDocParts: Vz, replaceTextEndOfLine: qz },
          } = Vl,
          {
            CSS_DISPLAY_TAGS: Wz,
            CSS_DISPLAY_DEFAULT: Uz,
            CSS_WHITE_SPACE_TAGS: Hz,
            CSS_WHITE_SPACE_DEFAULT: Gz,
          } = {
            CSS_DISPLAY_TAGS: {
              area: "none",
              base: "none",
              basefont: "none",
              datalist: "none",
              head: "none",
              link: "none",
              meta: "none",
              noembed: "none",
              noframes: "none",
              param: "block",
              rp: "none",
              script: "block",
              source: "block",
              style: "none",
              template: "inline",
              track: "block",
              title: "none",
              html: "block",
              body: "block",
              address: "block",
              blockquote: "block",
              center: "block",
              div: "block",
              figure: "block",
              figcaption: "block",
              footer: "block",
              form: "block",
              header: "block",
              hr: "block",
              legend: "block",
              listing: "block",
              main: "block",
              p: "block",
              plaintext: "block",
              pre: "block",
              xmp: "block",
              slot: "contents",
              ruby: "ruby",
              rt: "ruby-text",
              article: "block",
              aside: "block",
              h1: "block",
              h2: "block",
              h3: "block",
              h4: "block",
              h5: "block",
              h6: "block",
              hgroup: "block",
              nav: "block",
              section: "block",
              dir: "block",
              dd: "block",
              dl: "block",
              dt: "block",
              ol: "block",
              ul: "block",
              li: "list-item",
              table: "table",
              caption: "table-caption",
              colgroup: "table-column-group",
              col: "table-column",
              thead: "table-header-group",
              tbody: "table-row-group",
              tfoot: "table-footer-group",
              tr: "table-row",
              td: "table-cell",
              th: "table-cell",
              fieldset: "block",
              button: "inline-block",
              details: "block",
              summary: "block",
              dialog: "block",
              meter: "inline-block",
              progress: "inline-block",
              object: "inline-block",
              video: "inline-block",
              audio: "inline-block",
              select: "inline-block",
              option: "block",
              optgroup: "block",
            },
            CSS_DISPLAY_DEFAULT: "inline",
            CSS_WHITE_SPACE_TAGS: {
              listing: "pre",
              plaintext: "pre",
              pre: "pre",
              xmp: "pre",
              nobr: "nowrap",
              table: "initial",
              textarea: "pre-wrap",
            },
            CSS_WHITE_SPACE_DEFAULT: "normal",
          },
          Yz = tV([
            "a",
            "abbr",
            "acronym",
            "address",
            "applet",
            "area",
            "article",
            "aside",
            "audio",
            "b",
            "base",
            "basefont",
            "bdi",
            "bdo",
            "bgsound",
            "big",
            "blink",
            "blockquote",
            "body",
            "br",
            "button",
            "canvas",
            "caption",
            "center",
            "cite",
            "code",
            "col",
            "colgroup",
            "command",
            "content",
            "data",
            "datalist",
            "dd",
            "del",
            "details",
            "dfn",
            "dialog",
            "dir",
            "div",
            "dl",
            "dt",
            "element",
            "em",
            "embed",
            "fieldset",
            "figcaption",
            "figure",
            "font",
            "footer",
            "form",
            "frame",
            "frameset",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "head",
            "header",
            "hgroup",
            "hr",
            "html",
            "i",
            "iframe",
            "image",
            "img",
            "input",
            "ins",
            "isindex",
            "kbd",
            "keygen",
            "label",
            "legend",
            "li",
            "link",
            "listing",
            "main",
            "map",
            "mark",
            "marquee",
            "math",
            "menu",
            "menuitem",
            "meta",
            "meter",
            "multicol",
            "nav",
            "nextid",
            "nobr",
            "noembed",
            "noframes",
            "noscript",
            "object",
            "ol",
            "optgroup",
            "option",
            "output",
            "p",
            "param",
            "picture",
            "plaintext",
            "pre",
            "progress",
            "q",
            "rb",
            "rbc",
            "rp",
            "rt",
            "rtc",
            "ruby",
            "s",
            "samp",
            "script",
            "section",
            "select",
            "shadow",
            "slot",
            "small",
            "source",
            "spacer",
            "span",
            "strike",
            "strong",
            "style",
            "sub",
            "summary",
            "sup",
            "svg",
            "table",
            "tbody",
            "td",
            "template",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "title",
            "tr",
            "track",
            "tt",
            "u",
            "ul",
            "var",
            "video",
            "wbr",
            "xmp",
          ]),
          Xz = (function (e, t) {
            const n = Object.create(null);
            for (const [r, i] of Object.entries(e)) n[r] = t(i, r);
            return n;
          })(
            {
              "*": [
                "accesskey",
                "autocapitalize",
                "autofocus",
                "class",
                "contenteditable",
                "dir",
                "draggable",
                "enterkeyhint",
                "hidden",
                "id",
                "inputmode",
                "is",
                "itemid",
                "itemprop",
                "itemref",
                "itemscope",
                "itemtype",
                "lang",
                "nonce",
                "slot",
                "spellcheck",
                "style",
                "tabindex",
                "title",
                "translate",
              ],
              a: [
                "accesskey",
                "charset",
                "coords",
                "download",
                "href",
                "hreflang",
                "name",
                "ping",
                "referrerpolicy",
                "rel",
                "rev",
                "shape",
                "tabindex",
                "target",
                "type",
              ],
              abbr: ["title"],
              applet: [
                "align",
                "alt",
                "archive",
                "code",
                "codebase",
                "height",
                "hspace",
                "name",
                "object",
                "vspace",
                "width",
              ],
              area: [
                "accesskey",
                "alt",
                "coords",
                "download",
                "href",
                "hreflang",
                "nohref",
                "ping",
                "referrerpolicy",
                "rel",
                "shape",
                "tabindex",
                "target",
                "type",
              ],
              audio: [
                "autoplay",
                "controls",
                "crossorigin",
                "loop",
                "muted",
                "preload",
                "src",
              ],
              base: ["href", "target"],
              basefont: ["color", "face", "size"],
              bdo: ["dir"],
              blockquote: ["cite"],
              body: ["alink", "background", "bgcolor", "link", "text", "vlink"],
              br: ["clear"],
              button: [
                "accesskey",
                "autofocus",
                "disabled",
                "form",
                "formaction",
                "formenctype",
                "formmethod",
                "formnovalidate",
                "formtarget",
                "name",
                "tabindex",
                "type",
                "value",
              ],
              canvas: ["height", "width"],
              caption: ["align"],
              col: ["align", "char", "charoff", "span", "valign", "width"],
              colgroup: ["align", "char", "charoff", "span", "valign", "width"],
              data: ["value"],
              del: ["cite", "datetime"],
              details: ["open"],
              dfn: ["title"],
              dialog: ["open"],
              dir: ["compact"],
              div: ["align"],
              dl: ["compact"],
              embed: ["height", "src", "type", "width"],
              fieldset: ["disabled", "form", "name"],
              font: ["color", "face", "size"],
              form: [
                "accept",
                "accept-charset",
                "action",
                "autocomplete",
                "enctype",
                "method",
                "name",
                "novalidate",
                "target",
              ],
              frame: [
                "frameborder",
                "longdesc",
                "marginheight",
                "marginwidth",
                "name",
                "noresize",
                "scrolling",
                "src",
              ],
              frameset: ["cols", "rows"],
              h1: ["align"],
              h2: ["align"],
              h3: ["align"],
              h4: ["align"],
              h5: ["align"],
              h6: ["align"],
              head: ["profile"],
              hr: ["align", "noshade", "size", "width"],
              html: ["manifest", "version"],
              iframe: [
                "align",
                "allow",
                "allowfullscreen",
                "allowpaymentrequest",
                "allowusermedia",
                "frameborder",
                "height",
                "loading",
                "longdesc",
                "marginheight",
                "marginwidth",
                "name",
                "referrerpolicy",
                "sandbox",
                "scrolling",
                "src",
                "srcdoc",
                "width",
              ],
              img: [
                "align",
                "alt",
                "border",
                "crossorigin",
                "decoding",
                "height",
                "hspace",
                "ismap",
                "loading",
                "longdesc",
                "name",
                "referrerpolicy",
                "sizes",
                "src",
                "srcset",
                "usemap",
                "vspace",
                "width",
              ],
              input: [
                "accept",
                "accesskey",
                "align",
                "alt",
                "autocomplete",
                "autofocus",
                "checked",
                "dirname",
                "disabled",
                "form",
                "formaction",
                "formenctype",
                "formmethod",
                "formnovalidate",
                "formtarget",
                "height",
                "ismap",
                "list",
                "max",
                "maxlength",
                "min",
                "minlength",
                "multiple",
                "name",
                "pattern",
                "placeholder",
                "readonly",
                "required",
                "size",
                "src",
                "step",
                "tabindex",
                "title",
                "type",
                "usemap",
                "value",
                "width",
              ],
              ins: ["cite", "datetime"],
              isindex: ["prompt"],
              label: ["accesskey", "for", "form"],
              legend: ["accesskey", "align"],
              li: ["type", "value"],
              link: [
                "as",
                "charset",
                "color",
                "crossorigin",
                "disabled",
                "href",
                "hreflang",
                "imagesizes",
                "imagesrcset",
                "integrity",
                "media",
                "nonce",
                "referrerpolicy",
                "rel",
                "rev",
                "sizes",
                "target",
                "title",
                "type",
              ],
              map: ["name"],
              menu: ["compact"],
              meta: ["charset", "content", "http-equiv", "name", "scheme"],
              meter: ["high", "low", "max", "min", "optimum", "value"],
              object: [
                "align",
                "archive",
                "border",
                "classid",
                "codebase",
                "codetype",
                "data",
                "declare",
                "form",
                "height",
                "hspace",
                "name",
                "standby",
                "tabindex",
                "type",
                "typemustmatch",
                "usemap",
                "vspace",
                "width",
              ],
              ol: ["compact", "reversed", "start", "type"],
              optgroup: ["disabled", "label"],
              option: ["disabled", "label", "selected", "value"],
              output: ["for", "form", "name"],
              p: ["align"],
              param: ["name", "type", "value", "valuetype"],
              pre: ["width"],
              progress: ["max", "value"],
              q: ["cite"],
              script: [
                "async",
                "charset",
                "crossorigin",
                "defer",
                "integrity",
                "language",
                "nomodule",
                "nonce",
                "referrerpolicy",
                "src",
                "type",
              ],
              select: [
                "autocomplete",
                "autofocus",
                "disabled",
                "form",
                "multiple",
                "name",
                "required",
                "size",
                "tabindex",
              ],
              slot: ["name"],
              source: ["media", "sizes", "src", "srcset", "type"],
              style: ["media", "nonce", "title", "type"],
              table: [
                "align",
                "bgcolor",
                "border",
                "cellpadding",
                "cellspacing",
                "frame",
                "rules",
                "summary",
                "width",
              ],
              tbody: ["align", "char", "charoff", "valign"],
              td: [
                "abbr",
                "align",
                "axis",
                "bgcolor",
                "char",
                "charoff",
                "colspan",
                "headers",
                "height",
                "nowrap",
                "rowspan",
                "scope",
                "valign",
                "width",
              ],
              textarea: [
                "accesskey",
                "autocomplete",
                "autofocus",
                "cols",
                "dirname",
                "disabled",
                "form",
                "maxlength",
                "minlength",
                "name",
                "placeholder",
                "readonly",
                "required",
                "rows",
                "tabindex",
                "wrap",
              ],
              tfoot: ["align", "char", "charoff", "valign"],
              th: [
                "abbr",
                "align",
                "axis",
                "bgcolor",
                "char",
                "charoff",
                "colspan",
                "headers",
                "height",
                "nowrap",
                "rowspan",
                "scope",
                "valign",
                "width",
              ],
              thead: ["align", "char", "charoff", "valign"],
              time: ["datetime"],
              tr: ["align", "bgcolor", "char", "charoff", "valign"],
              track: ["default", "kind", "label", "src", "srclang"],
              ul: ["compact", "type"],
              video: [
                "autoplay",
                "controls",
                "crossorigin",
                "height",
                "loop",
                "muted",
                "playsinline",
                "poster",
                "preload",
                "src",
                "width",
              ],
            },
            tV
          ),
          Jz = new Set(["\t", "\n", "\f", "\r", " "]),
          Zz = (e) => e.replace(/[\t\n\f\r ]+$/, ""),
          Kz = (e) => ((e) => e.replace(/^[\t\f\r ]*?\n/g, ""))(Zz(e)),
          Qz = (e) => e.split(/[\t\n\f\r ]+/),
          eV = (e) => e.match(/^[\t\n\f\r ]*/)[0];
        function tV(e) {
          const t = Object.create(null);
          for (const n of e) t[n] = !0;
          return t;
        }
        function nV(e) {
          return (
            "element" === e.type &&
            ("script" === e.fullName ||
              "style" === e.fullName ||
              "svg:style" === e.fullName ||
              (dV(e) && ("script" === e.name || "style" === e.name)))
          );
        }
        function rV(e) {
          return hV(e).startsWith("pre");
        }
        function iV(e) {
          return (
            "element" === e.type &&
            e.children.length > 0 &&
            (["html", "head", "ul", "ol", "select"].includes(e.name) ||
              (e.cssDisplay.startsWith("table") &&
                "table-cell" !== e.cssDisplay))
          );
        }
        function oV(e) {
          return (
            lV(e) || ("element" === e.type && "br" === e.fullName) || sV(e)
          );
        }
        function sV(e) {
          return aV(e) && uV(e);
        }
        function aV(e) {
          return (
            e.hasLeadingSpaces &&
            (e.prev
              ? e.prev.sourceSpan.end.line < e.sourceSpan.start.line
              : "root" === e.parent.type ||
                e.parent.startSourceSpan.end.line < e.sourceSpan.start.line)
          );
        }
        function uV(e) {
          return (
            e.hasTrailingSpaces &&
            (e.next
              ? e.next.sourceSpan.start.line > e.sourceSpan.end.line
              : "root" === e.parent.type ||
                (e.parent.endSourceSpan &&
                  e.parent.endSourceSpan.start.line > e.sourceSpan.end.line))
          );
        }
        function lV(e) {
          switch (e.type) {
            case "ieConditionalComment":
            case "comment":
            case "directive":
              return !0;
            case "element":
              return ["script", "select"].includes(e.name);
          }
          return !1;
        }
        function cV(e) {
          const { type: t, lang: n } = e.attrMap;
          return "module" === t ||
            "text/javascript" === t ||
            "text/babel" === t ||
            "application/javascript" === t ||
            "jsx" === n
            ? "babel"
            : "application/x-typescript" === t || "ts" === n || "tsx" === n
            ? "typescript"
            : "text/markdown" === t
            ? "markdown"
            : "text/html" === t
            ? "html"
            : t && (t.endsWith("json") || t.endsWith("importmap"))
            ? "json"
            : "text/x-handlebars-template" === t
            ? "glimmer"
            : void 0;
        }
        function pV(e) {
          return "block" === e || "list-item" === e || e.startsWith("table");
        }
        function fV(e) {
          return hV(e).startsWith("pre");
        }
        function dV(e) {
          return (
            "element" === e.type &&
            !e.hasExplicitNamespace &&
            !["html", "svg"].includes(e.namespace)
          );
        }
        function hV(e) {
          return (
            ("element" === e.type && (!e.namespace || dV(e)) && Hz[e.name]) ||
            Gz
          );
        }
        function mV(e) {
          let t = Number.POSITIVE_INFINITY;
          for (const n of e.split("\n")) {
            if (0 === n.length) continue;
            if (!Jz.has(n[0])) return 0;
            const e = eV(n).length;
            n.length !== e && e < t && (t = e);
          }
          return t === Number.POSITIVE_INFINITY ? 0 : t;
        }
        function gV(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : mV(e);
          return 0 === t
            ? e
            : e
                .split("\n")
                .map((e) => e.slice(t))
                .join("\n");
        }
        const yV = new Set(["template", "style", "script"]);
        function vV(e, t) {
          return DV(e, t) && !yV.has(e.fullName);
        }
        function DV(e, t) {
          return (
            "vue" === t.parser &&
            "element" === e.type &&
            "root" === e.parent.type &&
            "html" !== e.fullName.toLowerCase()
          );
        }
        function bV(e, t) {
          return (
            DV(e, t) &&
            (vV(e, t) || (e.attrMap.lang && "html" !== e.attrMap.lang))
          );
        }
        var EV = {
            HTML_ELEMENT_ATTRIBUTES: Xz,
            HTML_TAGS: Yz,
            htmlTrim: (e) => ((e) => e.replace(/^[\t\n\f\r ]+/, ""))(Zz(e)),
            htmlTrimPreserveIndentation: Kz,
            hasHtmlWhitespace: (e) => /[\t\n\f\r ]/.test(e),
            getLeadingAndTrailingHtmlWhitespace: (e) => {
              const [, t, n, r] = e.match(
                /^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s
              );
              return { leadingWhitespace: t, trailingWhitespace: r, text: n };
            },
            canHaveInterpolation: function (e) {
              return e.children && !nV(e);
            },
            countChars: function (e, t) {
              let n = 0;
              for (let r = 0; r < e.length; r++) e[r] === t && n++;
              return n;
            },
            countParents: function (e, t) {
              let n = 0;
              for (let r = e.stack.length - 1; r >= 0; r--) {
                const i = e.stack[r];
                i && "object" == typeof i && !Array.isArray(i) && t(i) && n++;
              }
              return n;
            },
            dedentString: gV,
            forceBreakChildren: iV,
            forceBreakContent: function (e) {
              return (
                iV(e) ||
                ("element" === e.type &&
                  e.children.length > 0 &&
                  (["body", "script", "style"].includes(e.name) ||
                    e.children.some((e) =>
                      (function (e) {
                        return (
                          e.children &&
                          e.children.some((e) => "text" !== e.type)
                        );
                      })(e)
                    ))) ||
                (e.firstChild &&
                  e.firstChild === e.lastChild &&
                  "text" !== e.firstChild.type &&
                  aV(e.firstChild) &&
                  (!e.lastChild.isTrailingSpaceSensitive || uV(e.lastChild)))
              );
            },
            forceNextEmptyLine: function (e) {
              return (
                Lz(e) ||
                (e.next &&
                  e.sourceSpan.end &&
                  e.sourceSpan.end.line + 1 < e.next.sourceSpan.start.line)
              );
            },
            getLastDescendant: function e(t) {
              return t.lastChild ? e(t.lastChild) : t;
            },
            getNodeCssStyleDisplay: function (e, t) {
              if (e.prev && "comment" === e.prev.type) {
                const t = e.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
                if (t) return t[1];
              }
              let n = !1;
              if ("element" === e.type && "svg" === e.namespace) {
                if (
                  !(function (e, t) {
                    let n = e;
                    for (; n; ) {
                      if (t(n)) return !0;
                      n = n.parent;
                    }
                    return !1;
                  })(e, (e) => "svg:foreignObject" === e.fullName)
                )
                  return "svg" === e.name ? "inline-block" : "block";
                n = !0;
              }
              switch (t.htmlWhitespaceSensitivity) {
                case "strict":
                  return "inline";
                case "ignore":
                  return "block";
                default:
                  return "vue" === t.parser &&
                    e.parent &&
                    "root" === e.parent.type
                    ? "block"
                    : ("element" === e.type &&
                        (!e.namespace || n || dV(e)) &&
                        Wz[e.name]) ||
                        Uz;
              }
            },
            getNodeCssStyleWhiteSpace: hV,
            hasPrettierIgnore: function (e) {
              return (
                "attribute" !== e.type &&
                !!e.parent &&
                "number" == typeof e.index &&
                0 !== e.index &&
                (function (e) {
                  return (
                    "comment" === e.type && "prettier-ignore" === e.value.trim()
                  );
                })(e.parent.children[e.index - 1])
              );
            },
            inferScriptParser: function (e, t) {
              return "script" !== e.name || e.attrMap.src
                ? "style" === e.name
                  ? (function (e) {
                      const { lang: t } = e.attrMap;
                      return t && "postcss" !== t && "css" !== t
                        ? "scss" === t
                          ? "scss"
                          : "less" === t
                          ? "less"
                          : void 0
                        : "css";
                    })(e)
                  : t && bV(e, t)
                  ? cV(e) || (!("src" in e.attrMap) && jz(e.attrMap.lang, t))
                  : void 0
                : e.attrMap.lang || e.attrMap.type
                ? cV(e)
                : "babel";
            },
            isVueCustomBlock: vV,
            isVueNonHtmlBlock: bV,
            isVueSlotAttribute: function (e) {
              const t = e.fullName;
              return (
                "#" === t.charAt(0) ||
                "slot-scope" === t ||
                "v-slot" === t ||
                t.startsWith("v-slot:")
              );
            },
            isVueSfcBindingsAttribute: function (e, t) {
              const n = e.parent;
              if (!DV(n, t)) return !1;
              const r = n.fullName,
                i = e.fullName;
              return (
                ("script" === r && "setup" === i) ||
                ("style" === r && "vars" === i)
              );
            },
            isDanglingSpaceSensitiveNode: function (e) {
              return !(pV((t = e.cssDisplay)) || "inline-block" === t || nV(e));
              var t;
            },
            isIndentationSensitiveNode: rV,
            isLeadingSpaceSensitiveNode: function (e, t) {
              const n = (function () {
                return !(
                  Lz(e) ||
                  ((("text" !== e.type && "interpolation" !== e.type) ||
                    !e.prev ||
                    ("text" !== e.prev.type &&
                      "interpolation" !== e.prev.type)) &&
                    (!e.parent ||
                      "none" === e.parent.cssDisplay ||
                      (!fV(e.parent) &&
                        ((!e.prev &&
                          ("root" === e.parent.type ||
                            (fV(e) && e.parent) ||
                            nV(e.parent) ||
                            vV(e.parent, t) ||
                            ((n = e.parent.cssDisplay),
                            pV(n) || "inline-block" === n))) ||
                          (e.prev &&
                            !(function (e) {
                              return !pV(e);
                            })(e.prev.cssDisplay))))))
                );
                var n;
              })();
              return n &&
                !e.prev &&
                e.parent &&
                e.parent.tagDefinition &&
                e.parent.tagDefinition.ignoreFirstLf
                ? "interpolation" === e.type
                : n;
            },
            isPreLikeNode: fV,
            isScriptLikeTag: nV,
            isTextLikeNode: function (e) {
              return "text" === e.type || "comment" === e.type;
            },
            isTrailingSpaceSensitiveNode: function (e, t) {
              return !(
                Lz(e) ||
                ((("text" !== e.type && "interpolation" !== e.type) ||
                  !e.next ||
                  ("text" !== e.next.type &&
                    "interpolation" !== e.next.type)) &&
                  (!e.parent ||
                    "none" === e.parent.cssDisplay ||
                    (!fV(e.parent) &&
                      ((!e.next &&
                        ("root" === e.parent.type ||
                          (fV(e) && e.parent) ||
                          nV(e.parent) ||
                          vV(e.parent, t) ||
                          ((n = e.parent.cssDisplay),
                          pV(n) || "inline-block" === n))) ||
                        (e.next &&
                          !(function (e) {
                            return !pV(e);
                          })(e.next.cssDisplay))))))
              );
              var n;
            },
            isWhitespaceSensitiveNode: function (e) {
              return nV(e) || "interpolation" === e.type || rV(e);
            },
            isUnknownNamespace: dV,
            preferHardlineAsLeadingSpaces: function (e) {
              return lV(e) || (e.prev && oV(e.prev)) || sV(e);
            },
            preferHardlineAsTrailingSpaces: oV,
            shouldPreserveContent: function (e, t) {
              return (
                !(
                  "ieConditionalComment" !== e.type ||
                  !e.lastChild ||
                  e.lastChild.isSelfClosing ||
                  e.lastChild.endSourceSpan
                ) ||
                ("ieConditionalComment" === e.type && !e.complete) ||
                !(
                  !fV(e) ||
                  !e.children.some(
                    (e) => "text" !== e.type && "interpolation" !== e.type
                  )
                ) ||
                !(!bV(e, t) || nV(e) || "interpolation" === e.type)
              );
            },
            unescapeQuoteEntities: function (e) {
              return e.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
            },
            getTextValueParts: function (e) {
              let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : e.value;
              return e.parent.isWhitespaceSensitive
                ? e.parent.isIndentationSensitive
                  ? qz(t)
                  : qz(gV(Kz(t)), Rz)
                : Vz(zz($z, Qz(t)));
            },
          },
          CV = {},
          xV = {};
        !(function (e) {
          function t(t) {
            return e.$0 <= t && t <= e.$9;
          }
          Object.defineProperty(e, "__esModule", { value: !0 }),
            (e.$EOF = 0),
            (e.$BSPACE = 8),
            (e.$TAB = 9),
            (e.$LF = 10),
            (e.$VTAB = 11),
            (e.$FF = 12),
            (e.$CR = 13),
            (e.$SPACE = 32),
            (e.$BANG = 33),
            (e.$DQ = 34),
            (e.$HASH = 35),
            (e.$$ = 36),
            (e.$PERCENT = 37),
            (e.$AMPERSAND = 38),
            (e.$SQ = 39),
            (e.$LPAREN = 40),
            (e.$RPAREN = 41),
            (e.$STAR = 42),
            (e.$PLUS = 43),
            (e.$COMMA = 44),
            (e.$MINUS = 45),
            (e.$PERIOD = 46),
            (e.$SLASH = 47),
            (e.$COLON = 58),
            (e.$SEMICOLON = 59),
            (e.$LT = 60),
            (e.$EQ = 61),
            (e.$GT = 62),
            (e.$QUESTION = 63),
            (e.$0 = 48),
            (e.$7 = 55),
            (e.$9 = 57),
            (e.$A = 65),
            (e.$E = 69),
            (e.$F = 70),
            (e.$X = 88),
            (e.$Z = 90),
            (e.$LBRACKET = 91),
            (e.$BACKSLASH = 92),
            (e.$RBRACKET = 93),
            (e.$CARET = 94),
            (e.$_ = 95),
            (e.$a = 97),
            (e.$b = 98),
            (e.$e = 101),
            (e.$f = 102),
            (e.$n = 110),
            (e.$r = 114),
            (e.$t = 116),
            (e.$u = 117),
            (e.$v = 118),
            (e.$x = 120),
            (e.$z = 122),
            (e.$LBRACE = 123),
            (e.$BAR = 124),
            (e.$RBRACE = 125),
            (e.$NBSP = 160),
            (e.$PIPE = 124),
            (e.$TILDA = 126),
            (e.$AT = 64),
            (e.$BT = 96),
            (e.isWhitespace = function (t) {
              return (t >= e.$TAB && t <= e.$SPACE) || t == e.$NBSP;
            }),
            (e.isDigit = t),
            (e.isAsciiLetter = function (t) {
              return (t >= e.$a && t <= e.$z) || (t >= e.$A && t <= e.$Z);
            }),
            (e.isAsciiHexDigit = function (n) {
              return (
                (n >= e.$a && n <= e.$f) || (n >= e.$A && n <= e.$F) || t(n)
              );
            }),
            (e.isNewLine = function (t) {
              return t === e.$LF || t === e.$CR;
            }),
            (e.isOctalDigit = function (t) {
              return e.$0 <= t && t <= e.$7;
            });
        })(xV);
        var wV = {},
          AV = {};
        Object.defineProperty(AV, "__esModule", { value: !0 });
        class SV {
          constructor(e, t, n) {
            (this.filePath = e), (this.name = t), (this.members = n);
          }
          assertNoMembers() {
            if (this.members.length)
              throw new Error(
                "Illegal state: symbol without members expected, but got ".concat(
                  JSON.stringify(this),
                  "."
                )
              );
          }
        }
        (AV.StaticSymbol = SV),
          (AV.StaticSymbolCache = class {
            constructor() {
              this.cache = new Map();
            }
            get(e, t, n) {
              const r = (n = n || []).length ? ".".concat(n.join(".")) : "",
                i = '"'.concat(e, '".').concat(t).concat(r);
              let o = this.cache.get(i);
              return o || ((o = new SV(e, t, n)), this.cache.set(i, o)), o;
            }
          });
        var _V = {};
        Object.defineProperty(_V, "__esModule", { value: !0 });
        const TV = /-+([a-z0-9])/g;
        function FV(e, t, n) {
          const r = e.indexOf(t);
          return -1 == r ? n : [e.slice(0, r).trim(), e.slice(r + 1).trim()];
        }
        function kV(e, t, n) {
          return Array.isArray(e)
            ? t.visitArray(e, n)
            : (function (e) {
                return (
                  "object" == typeof e &&
                  null !== e &&
                  Object.getPrototypeOf(e) === PV
                );
              })(e)
            ? t.visitStringMap(e, n)
            : null == e ||
              "string" == typeof e ||
              "number" == typeof e ||
              "boolean" == typeof e
            ? t.visitPrimitive(e, n)
            : t.visitOther(e, n);
        }
        (_V.dashCaseToCamelCase = function (e) {
          return e.replace(TV, function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
              t[n] = arguments[n];
            return t[1].toUpperCase();
          });
        }),
          (_V.splitAtColon = function (e, t) {
            return FV(e, ":", t);
          }),
          (_V.splitAtPeriod = function (e, t) {
            return FV(e, ".", t);
          }),
          (_V.visitValue = kV),
          (_V.isDefined = function (e) {
            return null != e;
          }),
          (_V.noUndefined = function (e) {
            return void 0 === e ? null : e;
          }),
          (_V.ValueTransformer = class {
            visitArray(e, t) {
              return e.map((e) => kV(e, this, t));
            }
            visitStringMap(e, t) {
              const n = {};
              return (
                Object.keys(e).forEach((r) => {
                  n[r] = kV(e[r], this, t);
                }),
                n
              );
            }
            visitPrimitive(e, t) {
              return e;
            }
            visitOther(e, t) {
              return e;
            }
          }),
          (_V.SyncAsync = {
            assertSync: (e) => {
              if (NV(e))
                throw new Error("Illegal state: value cannot be a promise");
              return e;
            },
            then: (e, t) => (NV(e) ? e.then(t) : t(e)),
            all: (e) => (e.some(NV) ? Promise.all(e) : e),
          }),
          (_V.error = function (e) {
            throw new Error("Internal Error: ".concat(e));
          }),
          (_V.syntaxError = function (e, t) {
            const n = Error(e);
            return (n[OV] = !0), t && (n[BV] = t), n;
          });
        const OV = "ngSyntaxError",
          BV = "ngParseErrors";
        (_V.isSyntaxError = function (e) {
          return e[OV];
        }),
          (_V.getParseErrors = function (e) {
            return e[BV] || [];
          }),
          (_V.escapeRegExp = function (e) {
            return e.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
          });
        const PV = Object.getPrototypeOf({});
        function NV(e) {
          return !!e && "function" == typeof e.then;
        }
        (_V.utf8Encode = function (e) {
          let t = "";
          for (let n = 0; n < e.length; n++) {
            let r = e.charCodeAt(n);
            if (r >= 55296 && r <= 56319 && e.length > n + 1) {
              const t = e.charCodeAt(n + 1);
              t >= 56320 &&
                t <= 57343 &&
                (n++, (r = ((r - 55296) << 10) + t - 56320 + 65536));
            }
            r <= 127
              ? (t += String.fromCharCode(r))
              : r <= 2047
              ? (t += String.fromCharCode(
                  ((r >> 6) & 31) | 192,
                  (63 & r) | 128
                ))
              : r <= 65535
              ? (t += String.fromCharCode(
                  (r >> 12) | 224,
                  ((r >> 6) & 63) | 128,
                  (63 & r) | 128
                ))
              : r <= 2097151 &&
                (t += String.fromCharCode(
                  ((r >> 18) & 7) | 240,
                  ((r >> 12) & 63) | 128,
                  ((r >> 6) & 63) | 128,
                  (63 & r) | 128
                ));
          }
          return t;
        }),
          (_V.stringify = function e(t) {
            if ("string" == typeof t) return t;
            if (t instanceof Array) return "[" + t.map(e).join(", ") + "]";
            if (null == t) return "" + t;
            if (t.overriddenName) return "".concat(t.overriddenName);
            if (t.name) return "".concat(t.name);
            if (!t.toString) return "object";
            const n = t.toString();
            if (null == n) return "" + n;
            const r = n.indexOf("\n");
            return -1 === r ? n : n.substring(0, r);
          }),
          (_V.resolveForwardRef = function (e) {
            return "function" == typeof e && e.hasOwnProperty("__forward_ref__")
              ? e()
              : e;
          }),
          (_V.isPromise = NV),
          (_V.Version = class {
            constructor(e) {
              this.full = e;
              const t = e.split(".");
              (this.major = t[0]),
                (this.minor = t[1]),
                (this.patch = t.slice(2).join("."));
            }
          });
        const MV = "undefined" != typeof window && window,
          IV =
            "undefined" != typeof self &&
            "undefined" != typeof WorkerGlobalScope &&
            self instanceof WorkerGlobalScope &&
            self,
          jV = (void 0 !== e && e) || MV || IV;
        (_V.global = jV),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 });
            const t = AV,
              n = _V,
              r = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function i(e) {
              return e.replace(/\W/g, "_");
            }
            e.sanitizeIdentifier = i;
            let o = 0;
            function s(e) {
              if (!e || !e.reference) return null;
              const r = e.reference;
              if (r instanceof t.StaticSymbol) return r.name;
              if (r.__anonymousType) return r.__anonymousType;
              let s = n.stringify(r);
              return (
                s.indexOf("(") >= 0
                  ? ((s = "anonymous_".concat(o++)), (r.__anonymousType = s))
                  : (s = i(s)),
                s
              );
            }
            var a;
            (e.identifierName = s),
              (e.identifierModuleUrl = function (e) {
                const r = e.reference;
                return r instanceof t.StaticSymbol
                  ? r.filePath
                  : "./".concat(n.stringify(r));
              }),
              (e.viewClassName = function (e, t) {
                return "View_".concat(s({ reference: e }), "_").concat(t);
              }),
              (e.rendererTypeName = function (e) {
                return "RenderType_".concat(s({ reference: e }));
              }),
              (e.hostViewClassName = function (e) {
                return "HostView_".concat(s({ reference: e }));
              }),
              (e.componentFactoryName = function (e) {
                return "".concat(s({ reference: e }), "NgFactory");
              }),
              (function (e) {
                (e[(e.Pipe = 0)] = "Pipe"),
                  (e[(e.Directive = 1)] = "Directive"),
                  (e[(e.NgModule = 2)] = "NgModule"),
                  (e[(e.Injectable = 3)] = "Injectable");
              })((a = e.CompileSummaryKind || (e.CompileSummaryKind = {}))),
              (e.tokenName = function (e) {
                return null != e.value ? i(e.value) : s(e.identifier);
              }),
              (e.tokenReference = function (e) {
                return null != e.identifier ? e.identifier.reference : e.value;
              }),
              (e.CompileStylesheetMetadata = class {
                constructor() {
                  let {
                    moduleUrl: e,
                    styles: t,
                    styleUrls: n,
                  } = arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {};
                  (this.moduleUrl = e || null),
                    (this.styles = l(t)),
                    (this.styleUrls = l(n));
                }
              }),
              (e.CompileTemplateMetadata = class {
                constructor(e) {
                  let {
                    encapsulation: t,
                    template: n,
                    templateUrl: r,
                    htmlAst: i,
                    styles: o,
                    styleUrls: s,
                    externalStylesheets: a,
                    animations: u,
                    ngContentSelectors: p,
                    interpolation: f,
                    isInline: d,
                    preserveWhitespaces: h,
                  } = e;
                  if (
                    ((this.encapsulation = t),
                    (this.template = n),
                    (this.templateUrl = r),
                    (this.htmlAst = i),
                    (this.styles = l(o)),
                    (this.styleUrls = l(s)),
                    (this.externalStylesheets = l(a)),
                    (this.animations = u ? c(u) : []),
                    (this.ngContentSelectors = p || []),
                    f && 2 != f.length)
                  )
                    throw new Error(
                      "'interpolation' should have a start and an end symbol."
                    );
                  (this.interpolation = f),
                    (this.isInline = d),
                    (this.preserveWhitespaces = h);
                }
                toSummary() {
                  return {
                    ngContentSelectors: this.ngContentSelectors,
                    encapsulation: this.encapsulation,
                    styles: this.styles,
                    animations: this.animations,
                  };
                }
              });
            class u {
              static create(e) {
                let {
                  isHost: t,
                  type: i,
                  isComponent: o,
                  selector: s,
                  exportAs: a,
                  changeDetection: l,
                  inputs: c,
                  outputs: p,
                  host: f,
                  providers: d,
                  viewProviders: h,
                  queries: m,
                  guards: g,
                  viewQueries: y,
                  entryComponents: v,
                  template: D,
                  componentViewType: b,
                  rendererType: E,
                  componentFactory: C,
                } = e;
                const x = {},
                  w = {},
                  A = {};
                null != f &&
                  Object.keys(f).forEach((e) => {
                    const t = f[e],
                      n = e.match(r);
                    null === n
                      ? (A[e] = t)
                      : null != n[1]
                      ? (w[n[1]] = t)
                      : null != n[2] && (x[n[2]] = t);
                  });
                const S = {};
                null != c &&
                  c.forEach((e) => {
                    const t = n.splitAtColon(e, [e, e]);
                    S[t[0]] = t[1];
                  });
                const _ = {};
                return (
                  null != p &&
                    p.forEach((e) => {
                      const t = n.splitAtColon(e, [e, e]);
                      _[t[0]] = t[1];
                    }),
                  new u({
                    isHost: t,
                    type: i,
                    isComponent: !!o,
                    selector: s,
                    exportAs: a,
                    changeDetection: l,
                    inputs: S,
                    outputs: _,
                    hostListeners: x,
                    hostProperties: w,
                    hostAttributes: A,
                    providers: d,
                    viewProviders: h,
                    queries: m,
                    guards: g,
                    viewQueries: y,
                    entryComponents: v,
                    template: D,
                    componentViewType: b,
                    rendererType: E,
                    componentFactory: C,
                  })
                );
              }
              constructor(e) {
                let {
                  isHost: t,
                  type: n,
                  isComponent: r,
                  selector: i,
                  exportAs: o,
                  changeDetection: s,
                  inputs: a,
                  outputs: u,
                  hostListeners: c,
                  hostProperties: p,
                  hostAttributes: f,
                  providers: d,
                  viewProviders: h,
                  queries: m,
                  guards: g,
                  viewQueries: y,
                  entryComponents: v,
                  template: D,
                  componentViewType: b,
                  rendererType: E,
                  componentFactory: C,
                } = e;
                (this.isHost = !!t),
                  (this.type = n),
                  (this.isComponent = r),
                  (this.selector = i),
                  (this.exportAs = o),
                  (this.changeDetection = s),
                  (this.inputs = a),
                  (this.outputs = u),
                  (this.hostListeners = c),
                  (this.hostProperties = p),
                  (this.hostAttributes = f),
                  (this.providers = l(d)),
                  (this.viewProviders = l(h)),
                  (this.queries = l(m)),
                  (this.guards = g),
                  (this.viewQueries = l(y)),
                  (this.entryComponents = l(v)),
                  (this.template = D),
                  (this.componentViewType = b),
                  (this.rendererType = E),
                  (this.componentFactory = C);
              }
              toSummary() {
                return {
                  summaryKind: a.Directive,
                  type: this.type,
                  isComponent: this.isComponent,
                  selector: this.selector,
                  exportAs: this.exportAs,
                  inputs: this.inputs,
                  outputs: this.outputs,
                  hostListeners: this.hostListeners,
                  hostProperties: this.hostProperties,
                  hostAttributes: this.hostAttributes,
                  providers: this.providers,
                  viewProviders: this.viewProviders,
                  queries: this.queries,
                  guards: this.guards,
                  viewQueries: this.viewQueries,
                  entryComponents: this.entryComponents,
                  changeDetection: this.changeDetection,
                  template: this.template && this.template.toSummary(),
                  componentViewType: this.componentViewType,
                  rendererType: this.rendererType,
                  componentFactory: this.componentFactory,
                };
              }
            }
            function l(e) {
              return e || [];
            }
            function c(e) {
              return e.reduce((e, t) => {
                const n = Array.isArray(t) ? c(t) : t;
                return e.concat(n);
              }, []);
            }
            function p(e) {
              return e.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
            }
            (e.CompileDirectiveMetadata = u),
              (e.CompilePipeMetadata = class {
                constructor(e) {
                  let { type: t, name: n, pure: r } = e;
                  (this.type = t), (this.name = n), (this.pure = !!r);
                }
                toSummary() {
                  return {
                    summaryKind: a.Pipe,
                    type: this.type,
                    name: this.name,
                    pure: this.pure,
                  };
                }
              }),
              (e.CompileShallowModuleMetadata = class {}),
              (e.CompileNgModuleMetadata = class {
                constructor(e) {
                  let {
                    type: t,
                    providers: n,
                    declaredDirectives: r,
                    exportedDirectives: i,
                    declaredPipes: o,
                    exportedPipes: s,
                    entryComponents: a,
                    bootstrapComponents: u,
                    importedModules: c,
                    exportedModules: p,
                    schemas: f,
                    transitiveModule: d,
                    id: h,
                  } = e;
                  (this.type = t || null),
                    (this.declaredDirectives = l(r)),
                    (this.exportedDirectives = l(i)),
                    (this.declaredPipes = l(o)),
                    (this.exportedPipes = l(s)),
                    (this.providers = l(n)),
                    (this.entryComponents = l(a)),
                    (this.bootstrapComponents = l(u)),
                    (this.importedModules = l(c)),
                    (this.exportedModules = l(p)),
                    (this.schemas = l(f)),
                    (this.id = h || null),
                    (this.transitiveModule = d || null);
                }
                toSummary() {
                  const e = this.transitiveModule;
                  return {
                    summaryKind: a.NgModule,
                    type: this.type,
                    entryComponents: e.entryComponents,
                    providers: e.providers,
                    modules: e.modules,
                    exportedDirectives: e.exportedDirectives,
                    exportedPipes: e.exportedPipes,
                  };
                }
              }),
              (e.TransitiveCompileNgModuleMetadata = class {
                constructor() {
                  (this.directivesSet = new Set()),
                    (this.directives = []),
                    (this.exportedDirectivesSet = new Set()),
                    (this.exportedDirectives = []),
                    (this.pipesSet = new Set()),
                    (this.pipes = []),
                    (this.exportedPipesSet = new Set()),
                    (this.exportedPipes = []),
                    (this.modulesSet = new Set()),
                    (this.modules = []),
                    (this.entryComponentsSet = new Set()),
                    (this.entryComponents = []),
                    (this.providers = []);
                }
                addProvider(e, t) {
                  this.providers.push({ provider: e, module: t });
                }
                addDirective(e) {
                  this.directivesSet.has(e.reference) ||
                    (this.directivesSet.add(e.reference),
                    this.directives.push(e));
                }
                addExportedDirective(e) {
                  this.exportedDirectivesSet.has(e.reference) ||
                    (this.exportedDirectivesSet.add(e.reference),
                    this.exportedDirectives.push(e));
                }
                addPipe(e) {
                  this.pipesSet.has(e.reference) ||
                    (this.pipesSet.add(e.reference), this.pipes.push(e));
                }
                addExportedPipe(e) {
                  this.exportedPipesSet.has(e.reference) ||
                    (this.exportedPipesSet.add(e.reference),
                    this.exportedPipes.push(e));
                }
                addModule(e) {
                  this.modulesSet.has(e.reference) ||
                    (this.modulesSet.add(e.reference), this.modules.push(e));
                }
                addEntryComponent(e) {
                  this.entryComponentsSet.has(e.componentType) ||
                    (this.entryComponentsSet.add(e.componentType),
                    this.entryComponents.push(e));
                }
              }),
              (e.ProviderMeta = class {
                constructor(e, t) {
                  let {
                    useClass: n,
                    useValue: r,
                    useExisting: i,
                    useFactory: o,
                    deps: s,
                    multi: a,
                  } = t;
                  (this.token = e),
                    (this.useClass = n || null),
                    (this.useValue = r),
                    (this.useExisting = i),
                    (this.useFactory = o || null),
                    (this.dependencies = s || null),
                    (this.multi = !!a);
                }
              }),
              (e.flatten = c),
              (e.templateSourceUrl = function (e, n, r) {
                let i;
                return (
                  (i = r.isInline
                    ? n.type.reference instanceof t.StaticSymbol
                      ? ""
                          .concat(n.type.reference.filePath, ".")
                          .concat(n.type.reference.name, ".html")
                      : "".concat(s(e), "/").concat(s(n.type), ".html")
                    : r.templateUrl),
                  n.type.reference instanceof t.StaticSymbol ? i : p(i)
                );
              }),
              (e.sharedStylesheetJitUrl = function (e, t) {
                const n = e.moduleUrl.split(/\/\\/g),
                  r = n[n.length - 1];
                return p("css/".concat(t).concat(r, ".ngstyle.js"));
              }),
              (e.ngModuleJitUrl = function (e) {
                return p("".concat(s(e.type), "/module.ngfactory.js"));
              }),
              (e.templateJitUrl = function (e, t) {
                return p(
                  "".concat(s(e), "/").concat(s(t.type), ".ngfactory.js")
                );
              });
          })(wV),
          (function (e) {
            Object.defineProperty(e, "__esModule", { value: !0 });
            const t = xV,
              n = wV;
            class r {
              constructor(e, t, n, r) {
                (this.file = e),
                  (this.offset = t),
                  (this.line = n),
                  (this.col = r);
              }
              toString() {
                return null != this.offset
                  ? ""
                      .concat(this.file.url, "@")
                      .concat(this.line, ":")
                      .concat(this.col)
                  : this.file.url;
              }
              moveBy(e) {
                const n = this.file.content,
                  i = n.length;
                let o = this.offset,
                  s = this.line,
                  a = this.col;
                for (; o > 0 && e < 0; )
                  if ((o--, e++, n.charCodeAt(o) == t.$LF)) {
                    s--;
                    const e = n
                      .substr(0, o - 1)
                      .lastIndexOf(String.fromCharCode(t.$LF));
                    a = e > 0 ? o - e : o;
                  } else a--;
                for (; o < i && e > 0; ) {
                  const r = n.charCodeAt(o);
                  o++, e--, r == t.$LF ? (s++, (a = 0)) : a++;
                }
                return new r(this.file, o, s, a);
              }
              getContext(e, t) {
                const n = this.file.content;
                let r = this.offset;
                if (null != r) {
                  r > n.length - 1 && (r = n.length - 1);
                  let i = r,
                    o = 0,
                    s = 0;
                  for (
                    ;
                    o < e && r > 0 && (r--, o++, "\n" != n[r] || ++s != t);

                  );
                  for (
                    o = 0, s = 0;
                    o < e &&
                    i < n.length - 1 &&
                    (i++, o++, "\n" != n[i] || ++s != t);

                  );
                  return {
                    before: n.substring(r, this.offset),
                    after: n.substring(this.offset, i + 1),
                  };
                }
                return null;
              }
            }
            e.ParseLocation = r;
            class i {
              constructor(e, t) {
                (this.content = e), (this.url = t);
              }
            }
            e.ParseSourceFile = i;
            class o {
              constructor(e, t) {
                let n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : null;
                (this.start = e), (this.end = t), (this.details = n);
              }
              toString() {
                return this.start.file.content.substring(
                  this.start.offset,
                  this.end.offset
                );
              }
            }
            var s;
            (e.ParseSourceSpan = o),
              (e.EMPTY_PARSE_LOCATION = new r(new i("", ""), 0, 0, 0)),
              (e.EMPTY_SOURCE_SPAN = new o(
                e.EMPTY_PARSE_LOCATION,
                e.EMPTY_PARSE_LOCATION
              )),
              (function (e) {
                (e[(e.WARNING = 0)] = "WARNING"), (e[(e.ERROR = 1)] = "ERROR");
              })((s = e.ParseErrorLevel || (e.ParseErrorLevel = {}))),
              (e.ParseError = class {
                constructor(e, t) {
                  let n =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : s.ERROR;
                  (this.span = e), (this.msg = t), (this.level = n);
                }
                contextualMessage() {
                  const e = this.span.start.getContext(100, 3);
                  return e
                    ? ""
                        .concat(this.msg, ' ("')
                        .concat(e.before, "[")
                        .concat(s[this.level], " ->]")
                        .concat(e.after, '")')
                    : this.msg;
                }
                toString() {
                  const e = this.span.details
                    ? ", ".concat(this.span.details)
                    : "";
                  return ""
                    .concat(this.contextualMessage(), ": ")
                    .concat(this.span.start)
                    .concat(e);
                }
              }),
              (e.typeSourceSpan = function (e, t) {
                const s = n.identifierModuleUrl(t),
                  a =
                    null != s
                      ? "in "
                          .concat(e, " ")
                          .concat(n.identifierName(t), " in ")
                          .concat(s)
                      : "in ".concat(e, " ").concat(n.identifierName(t)),
                  u = new i("", a);
                return new o(new r(u, -1, -1, -1), new r(u, -1, -1, -1));
              }),
              (e.r3JitTypeSourceSpan = function (e, t, n) {
                const s = "in ".concat(e, " ").concat(t, " in ").concat(n),
                  a = new i("", s);
                return new o(new r(a, -1, -1, -1), new r(a, -1, -1, -1));
              });
          })(CV);
        const { ParseSourceSpan: LV } = CV,
          $V = ns,
          {
            htmlTrim: RV,
            getLeadingAndTrailingHtmlWhitespace: zV,
            hasHtmlWhitespace: VV,
            canHaveInterpolation: qV,
            getNodeCssStyleDisplay: WV,
            isDanglingSpaceSensitiveNode: UV,
            isIndentationSensitiveNode: HV,
            isLeadingSpaceSensitiveNode: GV,
            isTrailingSpaceSensitiveNode: YV,
            isWhitespaceSensitiveNode: XV,
          } = EV,
          JV = [
            function (e) {
              e.walk((e) => {
                if (
                  "element" === e.type &&
                  e.tagDefinition.ignoreFirstLf &&
                  e.children.length > 0 &&
                  "text" === e.children[0].type &&
                  "\n" === e.children[0].value[0]
                ) {
                  const [t, ...n] = e.children;
                  e.setChildren(
                    1 === t.value.length
                      ? n
                      : [t.clone({ value: t.value.slice(1) }), ...n]
                  );
                }
              });
            },
            function (e) {
              const t = (e) =>
                "element" === e.type &&
                e.prev &&
                "ieConditionalStartComment" === e.prev.type &&
                e.prev.sourceSpan.end.offset ===
                  e.startSourceSpan.start.offset &&
                e.firstChild &&
                "ieConditionalEndComment" === e.firstChild.type &&
                e.firstChild.sourceSpan.start.offset ===
                  e.startSourceSpan.end.offset;
              e.walk((e) => {
                if (e.children) {
                  const n = e.children.map(t);
                  if (n.some(Boolean)) {
                    const t = [];
                    for (let r = 0; r < e.children.length; r++) {
                      const i = e.children[r];
                      if (!n[r + 1])
                        if (n[r]) {
                          const e = i.prev,
                            n = i.firstChild,
                            r = new LV(e.sourceSpan.start, n.sourceSpan.end),
                            o = new LV(r.start, i.sourceSpan.end);
                          t.push(
                            i.clone({
                              condition: e.condition,
                              sourceSpan: o,
                              startSourceSpan: r,
                              children: i.children.slice(1),
                            })
                          );
                        } else t.push(i);
                    }
                    e.setChildren(t);
                  }
                }
              });
            },
            function (e) {
              return (function (e, t, n) {
                e.walk((e) => {
                  if (e.children) {
                    const r = e.children.map(t);
                    if (r.some(Boolean)) {
                      const t = [];
                      for (let i = 0; i < e.children.length; i++) {
                        const o = e.children[i];
                        if ("text" !== o.type && !r[i]) {
                          t.push(o);
                          continue;
                        }
                        const s =
                          "text" === o.type
                            ? o
                            : o.clone({ type: "text", value: n(o) });
                        if (0 === t.length || "text" !== $V(t).type) {
                          t.push(s);
                          continue;
                        }
                        const a = t.pop();
                        t.push(
                          a.clone({
                            value: a.value + s.value,
                            sourceSpan: new LV(
                              a.sourceSpan.start,
                              s.sourceSpan.end
                            ),
                          })
                        );
                      }
                      e.setChildren(t);
                    }
                  }
                });
              })(
                e,
                (e) => "cdata" === e.type,
                (e) => "<![CDATA[".concat(e.value, "]]>")
              );
            },
            function (e, t) {
              if ("html" === t.parser) return;
              const n = /{{(.+?)}}/s;
              e.walk((e) => {
                if (!qV(e)) return;
                const t = [];
                for (const r of e.children) {
                  if ("text" !== r.type) {
                    t.push(r);
                    continue;
                  }
                  let e = r.sourceSpan.start,
                    i = null;
                  const o = r.value.split(n);
                  for (let n = 0; n < o.length; n++, e = i) {
                    const r = o[n];
                    n % 2 != 0
                      ? ((i = e.moveBy(r.length + 4)),
                        t.push({
                          type: "interpolation",
                          sourceSpan: new LV(e, i),
                          children:
                            0 === r.length
                              ? []
                              : [
                                  {
                                    type: "text",
                                    value: r,
                                    sourceSpan: new LV(
                                      e.moveBy(2),
                                      i.moveBy(-2)
                                    ),
                                  },
                                ],
                        }))
                      : ((i = e.moveBy(r.length)),
                        r.length > 0 &&
                          t.push({
                            type: "text",
                            value: r,
                            sourceSpan: new LV(e, i),
                          }));
                  }
                }
                e.setChildren(t);
              });
            },
            function (e) {
              e.walk((e) => {
                if (!e.children) return;
                if (
                  0 === e.children.length ||
                  (1 === e.children.length &&
                    "text" === e.children[0].type &&
                    0 === RV(e.children[0].value).length)
                )
                  return (
                    (e.hasDanglingSpaces = e.children.length > 0),
                    void (e.children = [])
                  );
                const t = XV(e),
                  n = HV(e);
                e.setChildren(
                  e.children
                    .flatMap((e) => {
                      if ("text" !== e.type || t) return e;
                      const n = [],
                        {
                          leadingWhitespace: r,
                          text: i,
                          trailingWhitespace: o,
                        } = zV(e.value);
                      return (
                        r && n.push(ZV),
                        i &&
                          n.push({
                            type: "text",
                            value: i,
                            sourceSpan: new LV(
                              e.sourceSpan.start.moveBy(r.length),
                              e.sourceSpan.end.moveBy(-o.length)
                            ),
                          }),
                        o && n.push(ZV),
                        n
                      );
                    })
                    .map((e, t, n) => {
                      if (e !== ZV)
                        return Object.assign(
                          Object.assign({}, e),
                          {},
                          {
                            hasLeadingSpaces: n[t - 1] === ZV,
                            hasTrailingSpaces: n[t + 1] === ZV,
                          }
                        );
                    })
                    .filter(Boolean)
                ),
                  (e.isWhitespaceSensitive = t),
                  (e.isIndentationSensitive = n);
              });
            },
            function (e, t) {
              e.walk((e) => Object.assign(e, { cssDisplay: WV(e, t) }));
            },
            function (e) {
              e.walk((e) =>
                Object.assign(e, {
                  isSelfClosing:
                    !e.children ||
                    ("element" === e.type &&
                      (e.tagDefinition.isVoid ||
                        e.startSourceSpan === e.endSourceSpan)),
                })
              );
            },
            function (e, t) {
              e.walk((e) =>
                "element" !== e.type
                  ? e
                  : Object.assign(e, {
                      hasHtmComponentClosingTag:
                        e.endSourceSpan &&
                        /^<\s*\/\s*\/\s*>$/.test(
                          t.originalText.slice(
                            e.endSourceSpan.start.offset,
                            e.endSourceSpan.end.offset
                          )
                        ),
                    })
              );
            },
            function (e, t) {
              e.walk((e) => {
                e.children &&
                  (0 !== e.children.length
                    ? e.setChildren(
                        e.children
                          .map((e) =>
                            Object.assign(
                              Object.assign({}, e),
                              {},
                              {
                                isLeadingSpaceSensitive: GV(e, t),
                                isTrailingSpaceSensitive: YV(e, t),
                              }
                            )
                          )
                          .map((e, t, n) =>
                            Object.assign(
                              Object.assign({}, e),
                              {},
                              {
                                isLeadingSpaceSensitive:
                                  (0 === t ||
                                    n[t - 1].isTrailingSpaceSensitive) &&
                                  e.isLeadingSpaceSensitive,
                                isTrailingSpaceSensitive:
                                  (t === n.length - 1 ||
                                    n[t + 1].isLeadingSpaceSensitive) &&
                                  e.isTrailingSpaceSensitive,
                              }
                            )
                          )
                      )
                    : (e.isDanglingSpaceSensitive = UV(e)));
              });
            },
            function (e) {
              const t = (e) =>
                "element" === e.type &&
                0 === e.attrs.length &&
                1 === e.children.length &&
                "text" === e.firstChild.type &&
                !VV(e.children[0].value) &&
                !e.firstChild.hasLeadingSpaces &&
                !e.firstChild.hasTrailingSpaces &&
                e.isLeadingSpaceSensitive &&
                !e.hasLeadingSpaces &&
                e.isTrailingSpaceSensitive &&
                !e.hasTrailingSpaces &&
                e.prev &&
                "text" === e.prev.type &&
                e.next &&
                "text" === e.next.type;
              e.walk((e) => {
                if (e.children) {
                  const n = e.children.map(t);
                  if (n.some(Boolean)) {
                    const t = [];
                    for (let r = 0; r < e.children.length; r++) {
                      const i = e.children[r];
                      if (n[r]) {
                        const n = t.pop(),
                          o = e.children[++r],
                          {
                            isTrailingSpaceSensitive: s,
                            hasTrailingSpaces: a,
                          } = o;
                        t.push(
                          n.clone({
                            value:
                              n.value +
                              "<".concat(i.rawName, ">") +
                              i.firstChild.value +
                              "</".concat(i.rawName, ">") +
                              o.value,
                            sourceSpan: new LV(
                              n.sourceSpan.start,
                              o.sourceSpan.end
                            ),
                            isTrailingSpaceSensitive: s,
                            hasTrailingSpaces: a,
                          })
                        );
                      } else t.push(i);
                    }
                    e.setChildren(t);
                  }
                }
              });
            },
          ],
          ZV = { type: "whitespace" };
        var KV = {
          locStart: function (e) {
            return e.sourceSpan.start.offset;
          },
          locEnd: function (e) {
            return e.sourceSpan.end.offset;
          },
        };
        const QV = ly,
          { isNonEmptyArray: eq } = nl,
          {
            builders: { indent: tq, join: nq, line: rq, softline: iq },
            utils: { replaceTextEndOfLine: oq },
          } = Vl,
          { locStart: sq, locEnd: aq } = KV,
          {
            isTextLikeNode: uq,
            getLastDescendant: lq,
            isPreLikeNode: cq,
            hasPrettierIgnore: pq,
            shouldPreserveContent: fq,
          } = EV;
        function dq(e, t) {
          return e.lastChild && Cq(e.lastChild) ? "" : [mq(e, t), yq(e, t)];
        }
        function hq(e, t) {
          return (e.next ? bq(e.next) : Eq(e.parent))
            ? ""
            : [vq(e, t), gq(e, t)];
        }
        function mq(e, t) {
          return Eq(e) ? vq(e.lastChild, t) : "";
        }
        function gq(e, t) {
          return Cq(e) ? yq(e.parent, t) : xq(e) ? Fq(e.next) : "";
        }
        function yq(e, t) {
          if ((QV(!e.isSelfClosing), Dq(e, t))) return "";
          switch (e.type) {
            case "ieConditionalComment":
              return "<!";
            case "element":
              if (e.hasHtmComponentClosingTag) return "<//";
            default:
              return "</".concat(e.rawName);
          }
        }
        function vq(e, t) {
          if (Dq(e, t)) return "";
          switch (e.type) {
            case "ieConditionalComment":
            case "ieConditionalEndComment":
              return "[endif]--\x3e";
            case "ieConditionalStartComment":
              return "]>\x3c!--\x3e";
            case "interpolation":
              return "}}";
            case "element":
              if (e.isSelfClosing) return "/>";
            default:
              return ">";
          }
        }
        function Dq(e, t) {
          return (
            !e.isSelfClosing && !e.endSourceSpan && (pq(e) || fq(e.parent, t))
          );
        }
        function bq(e) {
          return (
            e.prev &&
            "docType" !== e.prev.type &&
            !uq(e.prev) &&
            e.isLeadingSpaceSensitive &&
            !e.hasLeadingSpaces
          );
        }
        function Eq(e) {
          return (
            e.lastChild &&
            e.lastChild.isTrailingSpaceSensitive &&
            !e.lastChild.hasTrailingSpaces &&
            !uq(lq(e.lastChild)) &&
            !cq(e)
          );
        }
        function Cq(e) {
          return (
            !e.next &&
            !e.hasTrailingSpaces &&
            e.isTrailingSpaceSensitive &&
            uq(lq(e))
          );
        }
        function xq(e) {
          return (
            e.next &&
            !uq(e.next) &&
            uq(e) &&
            e.isTrailingSpaceSensitive &&
            !e.hasTrailingSpaces
          );
        }
        function wq(e) {
          return !e.prev && e.isLeadingSpaceSensitive && !e.hasLeadingSpaces;
        }
        function Aq(e, t, n) {
          const r = e.getValue();
          if (!eq(r.attrs)) return r.isSelfClosing ? " " : "";
          const i =
              r.prev &&
              "comment" === r.prev.type &&
              (function (e) {
                const t = e
                  .trim()
                  .match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
                return !!t && (!t[1] || t[1].split(/\s+/));
              })(r.prev.value),
            o =
              "boolean" == typeof i
                ? () => i
                : Array.isArray(i)
                ? (e) => i.includes(e.rawName)
                : () => !1,
            s = e.map((e) => {
              const r = e.getValue();
              return o(r) ? oq(t.originalText.slice(sq(r), aq(r))) : n();
            }, "attrs"),
            a =
              "element" === r.type &&
              "script" === r.fullName &&
              1 === r.attrs.length &&
              "src" === r.attrs[0].fullName &&
              0 === r.children.length,
            u = [tq([a ? " " : rq, nq(rq, s)])];
          return (
            (r.firstChild && wq(r.firstChild)) ||
            (r.isSelfClosing && Eq(r.parent)) ||
            a
              ? u.push(r.isSelfClosing ? " " : "")
              : u.push(
                  t.bracketSameLine
                    ? r.isSelfClosing
                      ? " "
                      : ""
                    : r.isSelfClosing
                    ? rq
                    : iq
                ),
            u
          );
        }
        function Sq(e) {
          return e.firstChild && wq(e.firstChild) ? "" : kq(e);
        }
        function _q(e, t) {
          return e.prev && xq(e.prev) ? "" : [Tq(e, t), Fq(e)];
        }
        function Tq(e, t) {
          return wq(e) ? kq(e.parent) : bq(e) ? vq(e.prev, t) : "";
        }
        function Fq(e) {
          switch (e.type) {
            case "ieConditionalComment":
            case "ieConditionalStartComment":
              return "\x3c!--[if ".concat(e.condition);
            case "ieConditionalEndComment":
              return "\x3c!--<!";
            case "interpolation":
              return "{{";
            case "docType":
              return "<!DOCTYPE";
            case "element":
              if (e.condition)
                return "\x3c!--[if "
                  .concat(e.condition, "]>\x3c!--\x3e<")
                  .concat(e.rawName);
            default:
              return "<".concat(e.rawName);
          }
        }
        function kq(e) {
          switch ((QV(!e.isSelfClosing), e.type)) {
            case "ieConditionalComment":
              return "]>";
            case "element":
              if (e.condition) return ">\x3c!--<![endif]--\x3e";
            default:
              return ">";
          }
        }
        var Oq = {
            printClosingTag: function (e, t) {
              return [e.isSelfClosing ? "" : dq(e, t), hq(e, t)];
            },
            printClosingTagStart: dq,
            printClosingTagStartMarker: yq,
            printClosingTagEndMarker: vq,
            printClosingTagSuffix: gq,
            printClosingTagEnd: hq,
            needsToBorrowLastChildClosingTagEndMarker: Eq,
            needsToBorrowParentClosingTagStartMarker: Cq,
            needsToBorrowPrevClosingTagEndMarker: bq,
            printOpeningTag: function (e, t, n) {
              const r = e.getValue();
              return [_q(r, t), Aq(e, t, n), r.isSelfClosing ? "" : Sq(r)];
            },
            printOpeningTagStart: _q,
            printOpeningTagPrefix: Tq,
            printOpeningTagStartMarker: Fq,
            printOpeningTagEndMarker: kq,
            needsToBorrowNextOpeningTagStartMarker: xq,
            needsToBorrowParentOpeningTagEndMarker: wq,
          },
          Bq = { exports: {} };
        !(function (t) {
          var n, r;
          (n = e),
            (r = function () {
              return function (e, t) {
                var n = (t && t.logger) || console;
                function r(e) {
                  return (
                    " " === e ||
                    "\t" === e ||
                    "\n" === e ||
                    "\f" === e ||
                    "\r" === e
                  );
                }
                function i(t) {
                  var n,
                    r = t.exec(e.substring(y));
                  if (r) return (n = r[0]), (y += n.length), n;
                }
                for (
                  var o,
                    s,
                    a,
                    u,
                    l,
                    c = e.length,
                    p = /^[ \t\n\r\u000c]+/,
                    f = /^[, \t\n\r\u000c]+/,
                    d = /^[^ \t\n\r\u000c]+/,
                    h = /[,]+$/,
                    m = /^\d+$/,
                    g = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,
                    y = 0,
                    v = [];
                  ;

                ) {
                  if ((i(f), y >= c)) return v;
                  (o = i(d)),
                    (s = []),
                    "," === o.slice(-1) ? ((o = o.replace(h, "")), b()) : D();
                }
                function D() {
                  for (i(p), a = "", u = "in descriptor"; ; ) {
                    if (((l = e.charAt(y)), "in descriptor" === u))
                      if (r(l))
                        a && (s.push(a), (a = ""), (u = "after descriptor"));
                      else {
                        if ("," === l)
                          return (y += 1), a && s.push(a), void b();
                        if ("(" === l) (a += l), (u = "in parens");
                        else {
                          if ("" === l) return a && s.push(a), void b();
                          a += l;
                        }
                      }
                    else if ("in parens" === u)
                      if (")" === l) (a += l), (u = "in descriptor");
                      else {
                        if ("" === l) return s.push(a), void b();
                        a += l;
                      }
                    else if ("after descriptor" === u)
                      if (r(l));
                      else {
                        if ("" === l) return void b();
                        (u = "in descriptor"), (y -= 1);
                      }
                    y += 1;
                  }
                }
                function b() {
                  var t,
                    r,
                    i,
                    a,
                    u,
                    l,
                    c,
                    p,
                    f,
                    d = !1,
                    h = {};
                  for (a = 0; a < s.length; a++)
                    (l = (u = s[a])[u.length - 1]),
                      (c = u.substring(0, u.length - 1)),
                      (p = parseInt(c, 10)),
                      (f = parseFloat(c)),
                      m.test(c) && "w" === l
                        ? ((t || r) && (d = !0), 0 === p ? (d = !0) : (t = p))
                        : g.test(c) && "x" === l
                        ? ((t || r || i) && (d = !0),
                          f < 0 ? (d = !0) : (r = f))
                        : m.test(c) && "h" === l
                        ? ((i || r) && (d = !0), 0 === p ? (d = !0) : (i = p))
                        : (d = !0);
                  d
                    ? n &&
                      n.error &&
                      n.error(
                        "Invalid srcset descriptor found in '" +
                          e +
                          "' at '" +
                          u +
                          "'."
                      )
                    : ((h.url = o),
                      t && (h.w = t),
                      r && (h.d = r),
                      i && (h.h = i),
                      v.push(h));
                }
              };
            }),
            t.exports ? (t.exports = r()) : (n.parseSrcset = r());
        })(Bq);
        const Pq = Bq.exports,
          {
            builders: { ifBreak: Nq, join: Mq, line: Iq },
          } = Vl;
        var jq = {
          printImgSrcset: function (e) {
            const t = Pq(e, {
                logger: {
                  error(e) {
                    throw new Error(e);
                  },
                },
              }),
              n = t.some((e) => {
                let { w: t } = e;
                return t;
              }),
              r = t.some((e) => {
                let { h: t } = e;
                return t;
              });
            if (
              n +
                r +
                t.some((e) => {
                  let { d: t } = e;
                  return t;
                }) >
              1
            )
              throw new Error("Mixed descriptor in srcset is not supported");
            const i = n ? "w" : r ? "h" : "d",
              o = n ? "w" : r ? "h" : "x",
              s = (e) => Math.max(...e),
              a = t.map((e) => e.url),
              u = s(a.map((e) => e.length)),
              l = t.map((e) => e[i]).map((e) => (e ? e.toString() : "")),
              c = l.map((e) => {
                const t = e.indexOf(".");
                return -1 === t ? e.length : t;
              }),
              p = s(c);
            return Mq(
              [",", Iq],
              a.map((e, t) => {
                const n = [e],
                  r = l[t];
                if (r) {
                  const i = u - e.length + 1,
                    s = p - c[t],
                    a = " ".repeat(i + s);
                  n.push(Nq(a, " "), r + o);
                }
                return n;
              })
            );
          },
          printClassNames: function (e) {
            return e.trim().split(/\s+/).join(" ");
          },
        };
        const {
          builders: { group: Lq },
        } = Vl;
        var $q = {
          isVueEventBindingExpression: function (e) {
            const t = e.trim();
            return (
              /^(?:[\w$]+|\([^)]*?\))\s*=>|^function\s*\(/.test(t) ||
              /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/.test(
                t
              )
            );
          },
          printVueFor: function (e, t) {
            const {
              left: n,
              operator: r,
              right: i,
            } = (function (e) {
              const t = /,([^,\]}]*)(?:,([^,\]}]*))?$/,
                n = e.match(/(.*?)\s+(in|of)\s+(.*)/s);
              if (!n) return;
              const r = {};
              r.for = n[3].trim();
              const i = n[1].trim().replace(/^\(|\)$/g, ""),
                o = i.match(t);
              return (
                o
                  ? ((r.alias = i.replace(t, "")),
                    (r.iterator1 = o[1].trim()),
                    o[2] && (r.iterator2 = o[2].trim()))
                  : (r.alias = i),
                {
                  left: "".concat(
                    [r.alias, r.iterator1, r.iterator2]
                      .filter(Boolean)
                      .join(",")
                  ),
                  operator: n[2],
                  right: r.for,
                }
              );
            })(e);
            return [
              Lq(
                t("function _(".concat(n, ") {}"), {
                  parser: "babel",
                  __isVueForBindingLeft: !0,
                })
              ),
              " ",
              r,
              " ",
              t(
                i,
                { parser: "__js_expression" },
                { stripTrailingHardline: !0 }
              ),
            ];
          },
          printVueBindings: function (e, t) {
            return t("function _(".concat(e, ") {}"), {
              parser: "babel",
              __isVueBindings: !0,
            });
          },
        };
        const {
          needsToBorrowParentClosingTagStartMarker: Rq,
          printClosingTagStartMarker: zq,
          needsToBorrowLastChildClosingTagEndMarker: Vq,
          printClosingTagEndMarker: qq,
          needsToBorrowParentOpeningTagEndMarker: Wq,
          printOpeningTagEndMarker: Uq,
        } = Oq;
        var Hq = function (e, t) {
          let n = e.startSourceSpan.end.offset;
          e.firstChild && Wq(e.firstChild) && (n -= Uq(e).length);
          let r = e.endSourceSpan.start.offset;
          return (
            e.lastChild && Rq(e.lastChild)
              ? (r += zq(e, t).length)
              : Vq(e) && (r -= qq(e.lastChild, t).length),
            t.originalText.slice(n, r)
          );
        };
        const {
            builders: {
              breakParent: Gq,
              group: Yq,
              hardline: Xq,
              indent: Jq,
              line: Zq,
              fill: Kq,
              softline: Qq,
            },
            utils: { mapDoc: eW, replaceTextEndOfLine: tW },
          } = Vl,
          nW = uI,
          {
            printClosingTag: rW,
            printClosingTagSuffix: iW,
            needsToBorrowPrevClosingTagEndMarker: oW,
            printOpeningTagPrefix: sW,
            printOpeningTag: aW,
          } = Oq,
          { printImgSrcset: uW, printClassNames: lW } = jq,
          {
            printVueFor: cW,
            printVueBindings: pW,
            isVueEventBindingExpression: fW,
          } = $q,
          {
            isScriptLikeTag: dW,
            isVueNonHtmlBlock: hW,
            inferScriptParser: mW,
            htmlTrimPreserveIndentation: gW,
            dedentString: yW,
            unescapeQuoteEntities: vW,
            isVueSlotAttribute: DW,
            isVueSfcBindingsAttribute: bW,
            getTextValueParts: EW,
          } = EV,
          CW = Hq;
        const {
            builders: {
              breakParent: xW,
              group: wW,
              ifBreak: AW,
              line: SW,
              softline: _W,
              hardline: TW,
            },
            utils: { replaceTextEndOfLine: FW },
          } = Vl,
          { locStart: kW, locEnd: OW } = KV,
          {
            forceBreakChildren: BW,
            forceNextEmptyLine: PW,
            isTextLikeNode: NW,
            hasPrettierIgnore: MW,
            preferHardlineAsLeadingSpaces: IW,
          } = EV,
          {
            printOpeningTagPrefix: jW,
            needsToBorrowNextOpeningTagStartMarker: LW,
            printOpeningTagStartMarker: $W,
            needsToBorrowPrevClosingTagEndMarker: RW,
            printClosingTagEndMarker: zW,
            printClosingTagSuffix: VW,
            needsToBorrowParentClosingTagStartMarker: qW,
          } = Oq;
        function WW(e, t, n) {
          const r = e.getValue();
          return MW(r)
            ? [
                jW(r, t),
                ...FW(
                  t.originalText.slice(
                    kW(r) + (r.prev && LW(r.prev) ? $W(r).length : 0),
                    OW(r) - (r.next && RW(r.next) ? zW(r, t).length : 0)
                  )
                ),
                VW(r, t),
              ]
            : n();
        }
        function UW(e, t) {
          return NW(e) && NW(t)
            ? e.isTrailingSpaceSensitive
              ? e.hasTrailingSpaces
                ? IW(t)
                  ? TW
                  : SW
                : ""
              : IW(t)
              ? TW
              : _W
            : (LW(e) &&
                (MW(t) ||
                  t.firstChild ||
                  t.isSelfClosing ||
                  ("element" === t.type && t.attrs.length > 0))) ||
              ("element" === e.type && e.isSelfClosing && RW(t))
            ? ""
            : !t.isLeadingSpaceSensitive ||
              IW(t) ||
              (RW(t) &&
                e.lastChild &&
                qW(e.lastChild) &&
                e.lastChild.lastChild &&
                qW(e.lastChild.lastChild))
            ? TW
            : t.hasLeadingSpaces
            ? SW
            : _W;
        }
        var HW = {
          printChildren: function (e, t, n) {
            const r = e.getValue();
            if (BW(r))
              return [
                xW,
                ...e.map((e) => {
                  const r = e.getValue(),
                    i = r.prev ? UW(r.prev, r) : "";
                  return [i ? [i, PW(r.prev) ? TW : ""] : "", WW(e, t, n)];
                }, "children"),
              ];
            const i = r.children.map(() => Symbol(""));
            return e.map((e, r) => {
              const o = e.getValue();
              if (NW(o)) {
                if (o.prev && NW(o.prev)) {
                  const r = UW(o.prev, o);
                  if (r)
                    return PW(o.prev)
                      ? [TW, TW, WW(e, t, n)]
                      : [r, WW(e, t, n)];
                }
                return WW(e, t, n);
              }
              const s = [],
                a = [],
                u = [],
                l = [],
                c = o.prev ? UW(o.prev, o) : "",
                p = o.next ? UW(o, o.next) : "";
              return (
                c &&
                  (PW(o.prev)
                    ? s.push(TW, TW)
                    : c === TW
                    ? s.push(TW)
                    : NW(o.prev)
                    ? a.push(c)
                    : a.push(AW("", _W, { groupId: i[r - 1] }))),
                p &&
                  (PW(o)
                    ? NW(o.next) && l.push(TW, TW)
                    : p === TW
                    ? NW(o.next) && l.push(TW)
                    : u.push(p)),
                [...s, wW([...a, wW([WW(e, t, n), ...u], { id: i[r] })]), ...l]
              );
            }, "children");
          },
        };
        const {
            builders: {
              breakParent: GW,
              dedentToRoot: YW,
              group: XW,
              ifBreak: JW,
              indentIfBreak: ZW,
              indent: KW,
              line: QW,
              softline: eU,
            },
            utils: { replaceTextEndOfLine: tU },
          } = Vl,
          nU = Hq,
          {
            shouldPreserveContent: rU,
            isScriptLikeTag: iU,
            isVueCustomBlock: oU,
            countParents: sU,
            forceBreakContent: aU,
          } = EV,
          {
            printOpeningTagPrefix: uU,
            printOpeningTag: lU,
            printClosingTagSuffix: cU,
            printClosingTag: pU,
            needsToBorrowPrevClosingTagEndMarker: fU,
            needsToBorrowLastChildClosingTagEndMarker: dU,
          } = Oq,
          { printChildren: hU } = HW;
        var mU = {
          printElement: function (e, t, n) {
            const r = e.getValue();
            if (rU(r, t))
              return [
                uU(r, t),
                XW(lU(e, t, n)),
                ...tU(nU(r, t)),
                ...pU(r, t),
                cU(r, t),
              ];
            const i =
                1 === r.children.length &&
                "interpolation" === r.firstChild.type &&
                r.firstChild.isLeadingSpaceSensitive &&
                !r.firstChild.hasLeadingSpaces &&
                r.lastChild.isTrailingSpaceSensitive &&
                !r.lastChild.hasTrailingSpaces,
              o = Symbol("element-attr-group-id"),
              s = (i) => XW([XW(lU(e, t, n), { id: o }), i, pU(r, t)]);
            return 0 === r.children.length
              ? s(r.hasDanglingSpaces && r.isDanglingSpaceSensitive ? QW : "")
              : s([
                  aU(r) ? GW : "",
                  ((a = [
                    i
                      ? JW(eU, "", { groupId: o })
                      : r.firstChild.hasLeadingSpaces &&
                        r.firstChild.isLeadingSpaceSensitive
                      ? QW
                      : "text" === r.firstChild.type &&
                        r.isWhitespaceSensitive &&
                        r.isIndentationSensitive
                      ? YW(eU)
                      : eU,
                    hU(e, t, n),
                  ]),
                  i
                    ? ZW(a, { groupId: o })
                    : (!iU(r) && !oU(r, t)) ||
                      "root" !== r.parent.type ||
                      "vue" !== t.parser ||
                      t.vueIndentScriptAndStyle
                    ? KW(a)
                    : a),
                  (r.next ? fU(r.next) : dU(r.parent))
                    ? r.lastChild.hasTrailingSpaces &&
                      r.lastChild.isTrailingSpaceSensitive
                      ? " "
                      : ""
                    : i
                    ? JW(eU, "", { groupId: o })
                    : r.lastChild.hasTrailingSpaces &&
                      r.lastChild.isTrailingSpaceSensitive
                    ? QW
                    : ("comment" === r.lastChild.type ||
                        ("text" === r.lastChild.type &&
                          r.isWhitespaceSensitive &&
                          r.isIndentationSensitive)) &&
                      new RegExp(
                        "\\n[\\t ]{".concat(
                          t.tabWidth *
                            sU(e, (e) => e.parent && "root" !== e.parent.type),
                          "}$"
                        )
                      ).test(r.lastChild.value)
                    ? ""
                    : eU,
                ]);
            var a;
          },
        };
        const {
            builders: { fill: gU, group: yU, hardline: vU, literalline: DU },
            utils: {
              cleanDoc: bU,
              getDocParts: EU,
              isConcat: CU,
              replaceTextEndOfLine: xU,
            },
          } = Vl,
          wU = Iz,
          {
            countChars: AU,
            unescapeQuoteEntities: SU,
            getTextValueParts: _U,
          } = EV,
          TU = function (e, t) {
            const n = e.map((e) => e);
            for (const e of JV) e(n, t);
            return n;
          },
          { insertPragma: FU } = {
            hasPragma: function (e) {
              return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(e);
            },
            insertPragma: function (e) {
              return "\x3c!-- @format --\x3e\n\n" + e.replace(/^\s*\n/, "");
            },
          },
          { locStart: kU, locEnd: OU } = KV,
          BU = function (e, t, n, r) {
            const i = e.getValue();
            switch (i.type) {
              case "element":
                if (dW(i) || "interpolation" === i.type) return;
                if (!i.isSelfClosing && hW(i, r)) {
                  const o = mW(i, r);
                  if (!o) return;
                  const s = CW(i, r);
                  let a = /^\s*$/.test(s),
                    u = "";
                  return (
                    a ||
                      ((u = n(
                        gW(s),
                        { parser: o, __embeddedInHtml: !0 },
                        { stripTrailingHardline: !0 }
                      )),
                      (a = "" === u)),
                    [
                      sW(i, r),
                      Yq(aW(e, r, t)),
                      a ? "" : Xq,
                      u,
                      a ? "" : Xq,
                      rW(i, r),
                      iW(i, r),
                    ]
                  );
                }
                break;
              case "text":
                if (dW(i.parent)) {
                  const e = mW(i.parent);
                  if (e) {
                    const t =
                        "markdown" === e
                          ? yW(i.value.replace(/^[^\S\n]*?\n/, ""))
                          : i.value,
                      o = { parser: e, __embeddedInHtml: !0 };
                    if ("html" === r.parser && "babel" === e) {
                      let e = "script";
                      const { attrMap: t } = i.parent;
                      t &&
                        ("module" === t.type ||
                          ("text/babel" === t.type &&
                            "module" === t["data-type"])) &&
                        (e = "module"),
                        (o.__babelSourceType = e);
                    }
                    return [
                      Gq,
                      sW(i, r),
                      n(t, o, { stripTrailingHardline: !0 }),
                      iW(i, r),
                    ];
                  }
                } else if ("interpolation" === i.parent.type) {
                  const e = {
                    __isInHtmlInterpolation: !0,
                    __embeddedInHtml: !0,
                  };
                  return (
                    "angular" === r.parser
                      ? ((e.parser = "__ng_interpolation"),
                        (e.trailingComma = "none"))
                      : "vue" === r.parser
                      ? (e.parser = "__vue_expression")
                      : (e.parser = "__js_expression"),
                    [
                      Jq([Zq, n(i.value, e, { stripTrailingHardline: !0 })]),
                      i.parent.next && oW(i.parent.next) ? " " : Zq,
                    ]
                  );
                }
                break;
              case "attribute": {
                if (!i.value) break;
                if (
                  /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(
                    r.originalText.slice(
                      i.valueSpan.start.offset,
                      i.valueSpan.end.offset
                    )
                  )
                )
                  return [i.rawName, "=", i.value];
                if (
                  "lwc" === r.parser &&
                  /^{.*}$/s.test(
                    r.originalText.slice(
                      i.valueSpan.start.offset,
                      i.valueSpan.end.offset
                    )
                  )
                )
                  return [i.rawName, "=", i.value];
                const e = (function (e, t, n) {
                  const r = (t) => new RegExp(t.join("|")).test(e.fullName),
                    i = () => vW(e.value);
                  let o = !1;
                  const s = (e, t) => {
                      const n =
                        "NGRoot" === e.type
                          ? "NGMicrosyntax" === e.node.type &&
                            1 === e.node.body.length &&
                            "NGMicrosyntaxExpression" === e.node.body[0].type
                            ? e.node.body[0].expression
                            : e.node
                          : "JsExpressionRoot" === e.type
                          ? e.node
                          : e;
                      !n ||
                        ("ObjectExpression" !== n.type &&
                          "ArrayExpression" !== n.type &&
                          ("__vue_expression" !== t.parser ||
                            ("TemplateLiteral" !== n.type &&
                              "StringLiteral" !== n.type))) ||
                        (o = !0);
                    },
                    a = function (e) {
                      let t =
                        !(arguments.length > 1 && void 0 !== arguments[1]) ||
                        arguments[1];
                      return Yq([Jq([Qq, e]), t ? Qq : ""]);
                    },
                    u = (e) => (o ? ((e) => Yq(e))(e) : a(e)),
                    l = (e, n) =>
                      t(
                        e,
                        Object.assign(
                          { __onHtmlBindingRoot: s, __embeddedInHtml: !0 },
                          n
                        ),
                        { stripTrailingHardline: !0 }
                      );
                  if (
                    "srcset" === e.fullName &&
                    ("img" === e.parent.fullName ||
                      "source" === e.parent.fullName)
                  )
                    return a(uW(i()));
                  if ("class" === e.fullName && !n.parentParser) {
                    const e = i();
                    if (!e.includes("{{")) return lW(e);
                  }
                  if ("style" === e.fullName && !n.parentParser) {
                    const e = i();
                    if (!e.includes("{{"))
                      return a(
                        l(e, { parser: "css", __isHTMLStyleAttribute: !0 })
                      );
                  }
                  if ("vue" === n.parser) {
                    if ("v-for" === e.fullName) return cW(i(), l);
                    if (DW(e) || bW(e, n)) return pW(i(), l);
                    const t = ["^:", "^v-bind:"],
                      o = ["^v-"];
                    if (r(["^@", "^v-on:"])) {
                      const e = i();
                      return u(
                        l(e, {
                          parser: fW(e)
                            ? "__js_expression"
                            : "__vue_event_binding",
                        })
                      );
                    }
                    if (r(t)) return u(l(i(), { parser: "__vue_expression" }));
                    if (r(o)) return u(l(i(), { parser: "__js_expression" }));
                  }
                  if ("angular" === n.parser) {
                    const t = (e, t) =>
                        l(
                          e,
                          Object.assign(
                            Object.assign({}, t),
                            {},
                            { trailingComma: "none" }
                          )
                        ),
                      n = ["^\\*"],
                      o = [
                        "^\\[.+\\]$",
                        "^bind(on)?-",
                        "^ng-(if|show|hide|class|style)$",
                      ],
                      s = ["^i18n(-.+)?$"];
                    if (r(["^\\(.+\\)$", "^on-"]))
                      return u(t(i(), { parser: "__ng_action" }));
                    if (r(o)) return u(t(i(), { parser: "__ng_binding" }));
                    if (r(s)) {
                      const t = i().trim();
                      return a(Kq(EW(e, t)), !t.includes("@@"));
                    }
                    if (r(n)) return u(t(i(), { parser: "__ng_directive" }));
                    const c = /{{(.+?)}}/s,
                      p = i();
                    if (c.test(p)) {
                      const e = [];
                      for (const [n, r] of p.split(c).entries())
                        if (n % 2 == 0) e.push(tW(r));
                        else
                          try {
                            e.push(
                              Yq([
                                "{{",
                                Jq([
                                  Zq,
                                  t(r, {
                                    parser: "__ng_interpolation",
                                    __isInHtmlInterpolation: !0,
                                  }),
                                ]),
                                Zq,
                                "}}",
                              ])
                            );
                          } catch {
                            e.push("{{", tW(r), "}}");
                          }
                      return Yq(e);
                    }
                  }
                  return null;
                })(
                  i,
                  (e, t) =>
                    n(
                      e,
                      Object.assign(
                        { __isInHtmlAttribute: !0, __embeddedInHtml: !0 },
                        t
                      ),
                      { stripTrailingHardline: !0 }
                    ),
                  r
                );
                if (e)
                  return [
                    i.rawName,
                    '="',
                    Yq(
                      eW(e, (e) =>
                        "string" == typeof e ? e.replace(/"/g, "&quot;") : e
                      )
                    ),
                    '"',
                  ];
                break;
              }
              case "front-matter":
                return nW(i, n);
            }
          },
          {
            printClosingTagSuffix: PU,
            printClosingTagEnd: NU,
            printOpeningTagPrefix: MU,
            printOpeningTagStart: IU,
          } = Oq,
          { printElement: jU } = mU,
          { printChildren: LU } = HW;
        var $U = {
          preprocess: TU,
          print: function (e, t, n) {
            const r = e.getValue();
            switch (r.type) {
              case "front-matter":
                return xU(r.raw);
              case "root":
                return (
                  t.__onHtmlRoot && t.__onHtmlRoot(r), [yU(LU(e, t, n)), vU]
                );
              case "element":
              case "ieConditionalComment":
                return jU(e, t, n);
              case "ieConditionalStartComment":
              case "ieConditionalEndComment":
                return [IU(r), NU(r)];
              case "interpolation":
                return [IU(r, t), ...e.map(n, "children"), NU(r, t)];
              case "text": {
                if ("interpolation" === r.parent.type) {
                  const e = /\n[^\S\n]*?$/,
                    t = e.test(r.value),
                    n = t ? r.value.replace(e, "") : r.value;
                  return [...xU(n), t ? vU : ""];
                }
                const e = bU([MU(r, t), ..._U(r), PU(r, t)]);
                return CU(e) || "fill" === e.type ? gU(EU(e)) : e;
              }
              case "docType":
                return [
                  yU([
                    IU(r, t),
                    " ",
                    r.value.replace(/^html\b/i, "html").replace(/\s+/g, " "),
                  ]),
                  NU(r, t),
                ];
              case "comment":
                return [
                  MU(r, t),
                  ...xU(t.originalText.slice(kU(r), OU(r)), DU),
                  PU(r, t),
                ];
              case "attribute": {
                if (null === r.value) return r.rawName;
                const e = SU(r.value),
                  t = AU(e, "'") < AU(e, '"') ? "'" : '"';
                return [
                  r.rawName,
                  "=",
                  t,
                  ...xU(
                    '"' === t
                      ? e.replace(/"/g, "&quot;")
                      : e.replace(/'/g, "&apos;")
                  ),
                  t,
                ];
              }
              default:
                throw new Error("Unexpected node type ".concat(r.type));
            }
          },
          insertPragma: FU,
          massageAstNode: wU,
          embed: BU,
        };
        const RU = "HTML";
        var zU = {
          name: "HTML",
          type: "markup",
          tmScope: "text.html.basic",
          aceMode: "html",
          codemirrorMode: "htmlmixed",
          codemirrorMimeType: "text/html",
          color: "#e34c26",
          aliases: ["xhtml"],
          extensions: [".html", ".htm", ".html.hl", ".inc", ".xht", ".xhtml"],
          languageId: 146,
        };
        const VU = tD,
          qU = $U,
          WU = {
            bracketSameLine: UM.bracketSameLine,
            htmlWhitespaceSensitivity: {
              since: "1.15.0",
              category: RU,
              type: "choice",
              default: "css",
              description: "How to handle whitespaces in HTML.",
              choices: [
                {
                  value: "css",
                  description:
                    "Respect the default value of CSS display property.",
                },
                {
                  value: "strict",
                  description: "Whitespaces are considered sensitive.",
                },
                {
                  value: "ignore",
                  description: "Whitespaces are considered insensitive.",
                },
              ],
            },
            vueIndentScriptAndStyle: {
              since: "1.19.0",
              category: RU,
              type: "boolean",
              default: !1,
              description: "Indent script and style tags in Vue files.",
            },
          },
          UU = [
            VU(zU, () => ({
              name: "Angular",
              since: "1.15.0",
              parsers: ["angular"],
              vscodeLanguageIds: ["html"],
              extensions: [".component.html"],
              filenames: [],
            })),
            VU(zU, (e) => ({
              since: "1.15.0",
              parsers: ["html"],
              vscodeLanguageIds: ["html"],
              extensions: [...e.extensions, ".mjml"],
            })),
            VU(zU, () => ({
              name: "Lightning Web Components",
              since: "1.17.0",
              parsers: ["lwc"],
              vscodeLanguageIds: ["html"],
              extensions: [],
              filenames: [],
            })),
            VU(
              {
                name: "Vue",
                type: "markup",
                color: "#41b883",
                extensions: [".vue"],
                tmScope: "text.html.vue",
                aceMode: "html",
                languageId: 391,
              },
              () => ({
                since: "1.10.0",
                parsers: ["vue"],
                vscodeLanguageIds: ["vue"],
              })
            ),
          ];
        var HU = {
          languages: UU,
          printers: { html: qU },
          options: WU,
          parsers: void 0,
        };
        const { getLast: GU, isNonEmptyArray: YU } = nl;
        function XU(e, t) {
          return e && "string" == typeof e.type && (!t || t.includes(e.type));
        }
        function JU(e) {
          return "prettier-ignore" === e.value.trim();
        }
        function ZU(e) {
          return e && YU(e.leadingComments);
        }
        function KU(e) {
          return e && YU(e.middleComments);
        }
        function QU(e) {
          return e && e.indicatorComment;
        }
        function eH(e) {
          return e && e.trailingComment;
        }
        function tH(e) {
          return e && YU(e.endComments);
        }
        function nH(e) {
          const t = [];
          let n;
          for (const r of e.split(/( +)/))
            " " !== r
              ? " " === n
                ? t.push(r)
                : t.push((t.pop() || "") + r)
              : void 0 === n && t.unshift(""),
              (n = r);
          return (
            " " === n && t.push((t.pop() || "") + " "),
            "" === t[0] && (t.shift(), t.unshift(" " + (t.shift() || ""))),
            t
          );
        }
        var rH = {
          getLast: GU,
          getAncestorCount: function (e, t) {
            let n = 0;
            const r = e.stack.length - 1;
            for (let i = 0; i < r; i++) {
              const r = e.stack[i];
              XU(r) && t(r) && n++;
            }
            return n;
          },
          isNode: XU,
          isEmptyNode: function (e) {
            return (
              !YU(e.children) &&
              !(function (e) {
                return ZU(e) || KU(e) || QU(e) || eH(e) || tH(e);
              })(e)
            );
          },
          isInlineNode: function (e) {
            if (!e) return !0;
            switch (e.type) {
              case "plain":
              case "quoteDouble":
              case "quoteSingle":
              case "alias":
              case "flowMapping":
              case "flowSequence":
                return !0;
              default:
                return !1;
            }
          },
          mapNode: function e(t, n, r) {
            return n(
              "children" in t
                ? Object.assign(
                    Object.assign({}, t),
                    {},
                    { children: t.children.map((r) => e(r, n, t)) }
                  )
                : t,
              r
            );
          },
          defineShortcut: function (e, t, n) {
            Object.defineProperty(e, t, { get: n, enumerable: !1 });
          },
          isNextLineEmpty: function (e, t) {
            let n = 0;
            const r = t.length;
            for (let i = e.position.end.offset - 1; i < r; i++) {
              const e = t[i];
              if (("\n" === e && n++, 1 === n && /\S/.test(e))) return !1;
              if (2 === n) return !0;
            }
            return !1;
          },
          isLastDescendantNode: function (e) {
            switch (e.getValue().type) {
              case "tag":
              case "anchor":
              case "comment":
                return !1;
            }
            const t = e.stack.length;
            for (let n = 1; n < t; n++) {
              const t = e.stack[n],
                r = e.stack[n - 1];
              if (
                Array.isArray(r) &&
                "number" == typeof t &&
                t !== r.length - 1
              )
                return !1;
            }
            return !0;
          },
          getBlockValueLineContents: function (e, t) {
            let { parentIndent: n, isLastDescendant: r, options: i } = t;
            const o =
                e.position.start.line === e.position.end.line
                  ? ""
                  : i.originalText
                      .slice(e.position.start.offset, e.position.end.offset)
                      .match(/^[^\n]*?\n(.*)$/s)[1],
              s =
                null === e.indent
                  ? ((e) => (e ? e[1].length : Number.POSITIVE_INFINITY))(
                      o.match(/^( *)\S/m)
                    )
                  : e.indent - 1 + n,
              a = o.split("\n").map((e) => e.slice(s));
            return "preserve" === i.proseWrap || "blockLiteral" === e.type
              ? u(a.map((e) => (0 === e.length ? [] : [e])))
              : u(
                  a
                    .map((e) => (0 === e.length ? [] : nH(e)))
                    .reduce(
                      (e, t, n) =>
                        0 !== n &&
                        a[n - 1].length > 0 &&
                        t.length > 0 &&
                        !/^\s/.test(t[0]) &&
                        !/^\s|\s$/.test(GU(e))
                          ? [...e.slice(0, -1), [...GU(e), ...t]]
                          : [...e, t],
                      []
                    )
                    .map((e) =>
                      e.reduce(
                        (e, t) =>
                          e.length > 0 && /\s$/.test(GU(e))
                            ? [...e.slice(0, -1), GU(e) + " " + t]
                            : [...e, t],
                        []
                      )
                    )
                    .map((e) => ("never" === i.proseWrap ? [e.join(" ")] : e))
                );
            function u(t) {
              if ("keep" === e.chomping)
                return 0 === GU(t).length ? t.slice(0, -1) : t;
              let n = 0;
              for (let e = t.length - 1; e >= 0 && 0 === t[e].length; e--) n++;
              return 0 === n
                ? t
                : n >= 2 && !r
                ? t.slice(0, -(n - 1))
                : t.slice(0, -n);
            }
          },
          getFlowScalarLineContents: function (e, t, n) {
            const r = t
              .split("\n")
              .map((e, t, n) =>
                0 === t && t === n.length - 1
                  ? e
                  : 0 !== t && t !== n.length - 1
                  ? e.trim()
                  : 0 === t
                  ? e.trimEnd()
                  : e.trimStart()
              );
            return "preserve" === n.proseWrap
              ? r.map((e) => (0 === e.length ? [] : [e]))
              : r
                  .map((e) => (0 === e.length ? [] : nH(e)))
                  .reduce(
                    (t, n, i) =>
                      0 !== i &&
                      r[i - 1].length > 0 &&
                      n.length > 0 &&
                      ("quoteDouble" !== e || !GU(GU(t)).endsWith("\\"))
                        ? [...t.slice(0, -1), [...GU(t), ...n]]
                        : [...t, n],
                    []
                  )
                  .map((e) => ("never" === n.proseWrap ? [e.join(" ")] : e));
          },
          getLastDescendantNode: function e(t) {
            return YU(t.children) ? e(GU(t.children)) : t;
          },
          hasPrettierIgnore: function (e) {
            const t = e.getValue();
            if ("documentBody" === t.type) {
              const t = e.getParentNode();
              return tH(t.head) && JU(GU(t.head.endComments));
            }
            return ZU(t) && JU(GU(t.leadingComments));
          },
          hasLeadingComments: ZU,
          hasMiddleComments: KU,
          hasIndicatorComment: QU,
          hasTrailingComment: eH,
          hasEndComments: tH,
        };
        const { defineShortcut: iH, mapNode: oH } = rH;
        function sH(e) {
          switch (e.type) {
            case "document":
              iH(e, "head", () => e.children[0]),
                iH(e, "body", () => e.children[1]);
              break;
            case "documentBody":
            case "sequenceItem":
            case "flowSequenceItem":
            case "mappingKey":
            case "mappingValue":
              iH(e, "content", () => e.children[0]);
              break;
            case "mappingItem":
            case "flowMappingItem":
              iH(e, "key", () => e.children[0]),
                iH(e, "value", () => e.children[1]);
          }
          return e;
        }
        const {
            builders: { softline: aH, align: uH },
          } = Vl,
          { hasEndComments: lH, isNextLineEmpty: cH, isNode: pH } = rH,
          fH = new WeakMap();
        function dH(e) {
          return (
            lH(e) &&
            !pH(e, [
              "documentHead",
              "documentBody",
              "flowMapping",
              "flowSequence",
            ])
          );
        }
        var hH = {
          alignWithSpaces: function (e, t) {
            return uH(" ".repeat(e), t);
          },
          shouldPrintEndComments: dH,
          printNextEmptyLine: function (e, t) {
            const n = e.getValue(),
              r = e.stack[0];
            let i;
            return (
              fH.has(r) ? (i = fH.get(r)) : ((i = new Set()), fH.set(r, i)),
              i.has(n.position.end.line) ||
              (i.add(n.position.end.line), !cH(n, t) || dH(e.getParentNode()))
                ? ""
                : aH
            );
          },
        };
        const {
            builders: {
              ifBreak: mH,
              line: gH,
              softline: yH,
              hardline: vH,
              join: DH,
            },
          } = Vl,
          { isEmptyNode: bH, getLast: EH, hasEndComments: CH } = rH,
          { printNextEmptyLine: xH, alignWithSpaces: wH } = hH;
        function AH(e, t, n) {
          const r = e.getValue(),
            i = "flowMapping" === r.type,
            o = i ? "{" : "[",
            s = i ? "}" : "]";
          let a = yH;
          i && r.children.length > 0 && n.bracketSpacing && (a = gH);
          const u = EH(r.children),
            l = u && "flowMappingItem" === u.type && bH(u.key) && bH(u.value);
          return [
            o,
            wH(n.tabWidth, [
              a,
              SH(e, t, n),
              "none" === n.trailingComma ? "" : mH(","),
              CH(r) ? [vH, DH(vH, e.map(t, "endComments"))] : "",
            ]),
            l ? "" : a,
            s,
          ];
        }
        function SH(e, t, n) {
          const r = e.getValue();
          return e.map(
            (e, i) => [
              t(),
              i === r.children.length - 1
                ? ""
                : [
                    ",",
                    gH,
                    r.children[i].position.start.line !==
                    r.children[i + 1].position.start.line
                      ? xH(e, n.originalText)
                      : "",
                  ],
            ],
            "children"
          );
        }
        var _H = { printFlowMapping: AH, printFlowSequence: AH };
        const {
            builders: {
              conditionalGroup: TH,
              group: FH,
              hardline: kH,
              ifBreak: OH,
              join: BH,
              line: PH,
            },
          } = Vl,
          {
            hasLeadingComments: NH,
            hasMiddleComments: MH,
            hasTrailingComment: IH,
            hasEndComments: jH,
            isNode: LH,
            isEmptyNode: $H,
            isInlineNode: RH,
          } = rH,
          { alignWithSpaces: zH } = hH;
        function VH(e, t) {
          if (!e) return !0;
          switch (e.type) {
            case "plain":
            case "quoteSingle":
            case "quoteDouble":
              break;
            case "alias":
              return !0;
            default:
              return !1;
          }
          if ("preserve" === t.proseWrap)
            return e.position.start.line === e.position.end.line;
          if (
            /\\$/m.test(
              t.originalText.slice(
                e.position.start.offset,
                e.position.end.offset
              )
            )
          )
            return !1;
          switch (t.proseWrap) {
            case "never":
              return !e.value.includes("\n");
            case "always":
              return !/[\n ]/.test(e.value);
            default:
              return !1;
          }
        }
        const {
            builders: {
              dedent: qH,
              dedentToRoot: WH,
              fill: UH,
              hardline: HH,
              join: GH,
              line: YH,
              literalline: XH,
              markAsRoot: JH,
            },
            utils: { getDocParts: ZH },
          } = Vl,
          {
            getAncestorCount: KH,
            getBlockValueLineContents: QH,
            hasIndicatorComment: eG,
            isLastDescendantNode: tG,
            isNode: nG,
          } = rH,
          { alignWithSpaces: rG } = hH;
        const {
            builders: {
              breakParent: iG,
              fill: oG,
              group: sG,
              hardline: aG,
              join: uG,
              line: lG,
              lineSuffix: cG,
              literalline: pG,
            },
            utils: { getDocParts: fG, replaceTextEndOfLine: dG },
          } = Vl,
          { isPreviousLineEmpty: hG } = nl,
          { insertPragma: mG, isPragma: gG } = {
            isPragma: function (e) {
              return /^\s*@(?:prettier|format)\s*$/.test(e);
            },
            hasPragma: function (e) {
              return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(e);
            },
            insertPragma: function (e) {
              return "# @format\n\n".concat(e);
            },
          },
          { locStart: yG } = {
            locStart: function (e) {
              return e.position.start.offset;
            },
            locEnd: function (e) {
              return e.position.end.offset;
            },
          },
          vG = function (e, t, n, r) {
            if (
              "root" === e.getValue().type &&
              r.filepath &&
              /(?:[/\\]|^)\.(?:prettier|stylelint)rc$/.test(r.filepath)
            )
              return n(
                r.originalText,
                Object.assign(Object.assign({}, r), {}, { parser: "json" })
              );
          },
          {
            getFlowScalarLineContents: DG,
            getLastDescendantNode: bG,
            hasLeadingComments: EG,
            hasMiddleComments: CG,
            hasTrailingComment: xG,
            hasEndComments: wG,
            hasPrettierIgnore: AG,
            isLastDescendantNode: SG,
            isNode: _G,
            isInlineNode: TG,
          } = rH,
          FG = function (e) {
            return oH(e, sH);
          },
          {
            alignWithSpaces: kG,
            printNextEmptyLine: OG,
            shouldPrintEndComments: BG,
          } = hH,
          { printFlowMapping: PG, printFlowSequence: NG } = _H,
          MG = function (e, t, n, r, i) {
            const { key: o, value: s } = e,
              a = $H(o),
              u = $H(s);
            if (a && u) return ": ";
            const l = r("key"),
              c = (function (e) {
                return e.key.content && "alias" === e.key.content.type;
              })(e)
                ? " "
                : "";
            if (u)
              return "flowMappingItem" === e.type && "flowMapping" === t.type
                ? l
                : "mappingItem" !== e.type ||
                  !VH(o.content, i) ||
                  IH(o.content) ||
                  (t.tag && "tag:yaml.org,2002:set" === t.tag.value)
                ? ["? ", zH(2, l)]
                : [l, c, ":"];
            const p = r("value");
            if (a) return [": ", zH(2, p)];
            if (NH(s) || !RH(o.content))
              return [
                "? ",
                zH(2, l),
                kH,
                BH(
                  "",
                  n.map(r, "value", "leadingComments").map((e) => [e, kH])
                ),
                ": ",
                zH(2, p),
              ];
            if (
              (function (e) {
                if (!e) return !0;
                switch (e.type) {
                  case "plain":
                  case "quoteDouble":
                  case "quoteSingle":
                    return e.position.start.line === e.position.end.line;
                  case "alias":
                    return !0;
                  default:
                    return !1;
                }
              })(o.content) &&
              !NH(o.content) &&
              !MH(o.content) &&
              !IH(o.content) &&
              !jH(o) &&
              !NH(s.content) &&
              !MH(s.content) &&
              !jH(s) &&
              VH(s.content, i)
            )
              return [l, c, ": ", p];
            const f = Symbol("mappingKey"),
              d = FH([OH("? "), FH(zH(2, l), { id: f })]),
              h = [kH, ": ", zH(2, p)],
              m = [c, ":"];
            NH(s.content) ||
            (jH(s) && s.content && !LH(s.content, ["mapping", "sequence"])) ||
            ("mapping" === t.type && IH(o.content) && RH(s.content)) ||
            (LH(s.content, ["mapping", "sequence"]) &&
              null === s.content.tag &&
              null === s.content.anchor)
              ? m.push(kH)
              : s.content && m.push(PH),
              m.push(p);
            const g = zH(i.tabWidth, m);
            return !VH(o.content, i) || NH(o.content) || MH(o.content) || jH(o)
              ? TH([[d, OH(h, g, { groupId: f })]])
              : TH([[l, g]]);
          },
          IG = function (e, t, n) {
            const r = e.getValue(),
              i = KH(e, (e) => nG(e, ["sequence", "mapping"])),
              o = tG(e),
              s = ["blockFolded" === r.type ? ">" : "|"];
            null !== r.indent && s.push(r.indent.toString()),
              "clip" !== r.chomping &&
                s.push("keep" === r.chomping ? "+" : "-"),
              eG(r) && s.push(" ", t("indicatorComment"));
            const a = QH(r, {
                parentIndent: i,
                isLastDescendant: o,
                options: n,
              }),
              u = [];
            for (const [e, t] of a.entries())
              0 === e && u.push(HH),
                u.push(UH(ZH(GH(YH, t)))),
                e !== a.length - 1
                  ? u.push(0 === t.length ? HH : JH(XH))
                  : "keep" === r.chomping &&
                    o &&
                    u.push(WH(0 === t.length ? HH : XH));
            return (
              null === r.indent
                ? s.push(qH(rG(n.tabWidth, u)))
                : s.push(WH(rG(r.indent - 1 + i, u))),
              s
            );
          };
        function jG(e, t) {
          return xG(e) || (t && (t.head.children.length > 0 || wG(t.head)));
        }
        function LG(e, t, n) {
          const r = DG(e, t, n);
          return uG(
            aG,
            r.map((e) => oG(fG(uG(lG, e))))
          );
        }
        var $G = {
          preprocess: FG,
          embed: vG,
          print: function (e, t, n) {
            const r = e.getValue(),
              i = [];
            "mappingValue" !== r.type &&
              EG(r) &&
              i.push([uG(aG, e.map(n, "leadingComments")), aG]);
            const { tag: o, anchor: s } = r;
            o && i.push(n("tag")),
              o && s && i.push(" "),
              s && i.push(n("anchor"));
            let a = "";
            _G(r, [
              "mapping",
              "sequence",
              "comment",
              "directive",
              "mappingItem",
              "sequenceItem",
            ]) &&
              !SG(e) &&
              (a = OG(e, t.originalText)),
              (o || s) &&
                (_G(r, ["sequence", "mapping"]) && !CG(r)
                  ? i.push(aG)
                  : i.push(" ")),
              CG(r) &&
                i.push([
                  1 === r.middleComments.length ? "" : aG,
                  uG(aG, e.map(n, "middleComments")),
                  aG,
                ]);
            const u = e.getParentNode();
            return (
              AG(e)
                ? i.push(
                    dG(
                      t.originalText
                        .slice(r.position.start.offset, r.position.end.offset)
                        .trimEnd(),
                      pG
                    )
                  )
                : i.push(
                    sG(
                      (function (e, t, n, r, i) {
                        switch (e.type) {
                          case "root": {
                            const { children: t } = e,
                              r = [];
                            n.each((e, n) => {
                              const o = t[n],
                                s = t[n + 1];
                              0 !== n && r.push(aG),
                                r.push(i()),
                                jG(o, s)
                                  ? (r.push(aG, "..."),
                                    xG(o) && r.push(" ", i("trailingComment")))
                                  : s && !xG(s.head) && r.push(aG, "---");
                            }, "children");
                            const o = bG(e);
                            return (
                              (_G(o, ["blockLiteral", "blockFolded"]) &&
                                "keep" === o.chomping) ||
                                r.push(aG),
                              r
                            );
                          }
                          case "document": {
                            const o = [];
                            return (
                              "head" ===
                                (function (e, t, n, r) {
                                  return (n.children[0] === e &&
                                    /---(?:\s|$)/.test(
                                      r.originalText.slice(yG(e), yG(e) + 4)
                                    )) ||
                                    e.head.children.length > 0 ||
                                    wG(e.head) ||
                                    xG(e.head)
                                    ? "head"
                                    : !jG(e, t) && !!t && "root";
                                })(e, t.children[n.getName() + 1], t, r) &&
                                ((e.head.children.length > 0 ||
                                  e.head.endComments.length > 0) &&
                                  o.push(i("head")),
                                xG(e.head)
                                  ? o.push([
                                      "---",
                                      " ",
                                      i(["head", "trailingComment"]),
                                    ])
                                  : o.push("---")),
                              (function (e) {
                                return e.body.children.length > 0 || wG(e.body);
                              })(e) && o.push(i("body")),
                              uG(aG, o)
                            );
                          }
                          case "documentHead":
                            return uG(aG, [
                              ...n.map(i, "children"),
                              ...n.map(i, "endComments"),
                            ]);
                          case "documentBody": {
                            const { children: t, endComments: r } = e;
                            let o = "";
                            if (t.length > 0 && r.length > 0) {
                              const t = bG(e);
                              _G(t, ["blockFolded", "blockLiteral"])
                                ? "keep" !== t.chomping && (o = [aG, aG])
                                : (o = aG);
                            }
                            return [
                              uG(aG, n.map(i, "children")),
                              o,
                              uG(aG, n.map(i, "endComments")),
                            ];
                          }
                          case "directive":
                            return ["%", uG(" ", [e.name, ...e.parameters])];
                          case "comment":
                            return ["#", e.value];
                          case "alias":
                            return ["*", e.value];
                          case "tag":
                            return r.originalText.slice(
                              e.position.start.offset,
                              e.position.end.offset
                            );
                          case "anchor":
                            return ["&", e.value];
                          case "plain":
                            return LG(
                              e.type,
                              r.originalText.slice(
                                e.position.start.offset,
                                e.position.end.offset
                              ),
                              r
                            );
                          case "quoteDouble":
                          case "quoteSingle": {
                            const t = "'",
                              n = '"',
                              i = r.originalText.slice(
                                e.position.start.offset + 1,
                                e.position.end.offset - 1
                              );
                            if (
                              ("quoteSingle" === e.type && i.includes("\\")) ||
                              ("quoteDouble" === e.type && /\\[^"]/.test(i))
                            ) {
                              const o = "quoteDouble" === e.type ? n : t;
                              return [o, LG(e.type, i, r), o];
                            }
                            if (i.includes(n))
                              return [
                                t,
                                LG(
                                  e.type,
                                  "quoteDouble" === e.type
                                    ? i
                                        .replace(/\\"/g, n)
                                        .replace(/'/g, t.repeat(2))
                                    : i,
                                  r
                                ),
                                t,
                              ];
                            if (i.includes(t))
                              return [
                                n,
                                LG(
                                  e.type,
                                  "quoteSingle" === e.type
                                    ? i.replace(/''/g, t)
                                    : i,
                                  r
                                ),
                                n,
                              ];
                            const o = r.singleQuote ? t : n;
                            return [o, LG(e.type, i, r), o];
                          }
                          case "blockFolded":
                          case "blockLiteral":
                            return IG(n, i, r);
                          case "mapping":
                          case "sequence":
                            return uG(aG, n.map(i, "children"));
                          case "sequenceItem":
                            return ["- ", kG(2, e.content ? i("content") : "")];
                          case "mappingKey":
                          case "mappingValue":
                            return e.content ? i("content") : "";
                          case "mappingItem":
                          case "flowMappingItem":
                            return MG(e, t, n, i, r);
                          case "flowMapping":
                            return PG(n, i, r);
                          case "flowSequence":
                            return NG(n, i, r);
                          case "flowSequenceItem":
                            return i("content");
                          default:
                            throw new Error(
                              "Unexpected node type ".concat(e.type)
                            );
                        }
                      })(r, u, e, t, n)
                    )
                  ),
              xG(r) &&
                !_G(r, ["document", "documentHead"]) &&
                i.push(
                  cG([
                    "mappingValue" !== r.type || r.content ? " " : "",
                    "mappingKey" === u.type &&
                    "mapping" === e.getParentNode(2).type &&
                    TG(r)
                      ? ""
                      : iG,
                    n("trailingComment"),
                  ])
                ),
              BG(r) &&
                i.push(
                  kG("sequenceItem" === r.type ? 2 : 0, [
                    aG,
                    uG(
                      aG,
                      e.map(
                        (e) => [
                          hG(t.originalText, e.getValue(), yG) ? aG : "",
                          n(),
                        ],
                        "endComments"
                      )
                    ),
                  ])
                ),
              i.push(a),
              i
            );
          },
          massageAstNode: function (e, t) {
            if (_G(t))
              switch ((delete t.position, t.type)) {
                case "comment":
                  if (gG(t.value)) return null;
                  break;
                case "quoteDouble":
                case "quoteSingle":
                  t.type = "quote";
              }
          },
          insertPragma: mG,
        };
        const RG = $G,
          zG = {
            bracketSpacing: UM.bracketSpacing,
            singleQuote: UM.singleQuote,
            proseWrap: UM.proseWrap,
          },
          VG = [
            tD(
              {
                name: "YAML",
                type: "data",
                color: "#cb171e",
                tmScope: "source.yaml",
                aliases: ["yml"],
                extensions: [
                  ".yml",
                  ".mir",
                  ".reek",
                  ".rviz",
                  ".sublime-syntax",
                  ".syntax",
                  ".yaml",
                  ".yaml-tmlanguage",
                  ".yaml.sed",
                  ".yml.mysql",
                ],
                filenames: [
                  ".clang-format",
                  ".clang-tidy",
                  ".gemrc",
                  "glide.lock",
                  "yarn.lock",
                ],
                aceMode: "yaml",
                codemirrorMode: "yaml",
                codemirrorMimeType: "text/x-yaml",
                languageId: 407,
              },
              (e) => ({
                since: "1.14.0",
                parsers: ["yaml"],
                vscodeLanguageIds: ["yaml", "ansible", "home-assistant"],
                filenames: [
                  ...e.filenames.filter((e) => "yarn.lock" !== e),
                  ".prettierrc",
                  ".stylelintrc",
                ],
              })
            ),
          ];
        var qG = [
          eI,
          hL,
          _$,
          G$,
          Bz,
          HU,
          {
            languages: VG,
            printers: { yaml: RG },
            options: zG,
            parsers: void 0,
          },
        ];
        const { version: WG } = r,
          UG = Fv,
          { getSupportInfo: HG } = Nu,
          GG = Qv,
          YG = qG,
          XG = Vl;
        function JG(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          return function () {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
              r[i] = arguments[i];
            const o = r[t] || {},
              s = o.plugins || [];
            return (
              (r[t] = Object.assign(
                Object.assign({}, o),
                {},
                {
                  plugins: [
                    ...YG,
                    ...(Array.isArray(s) ? s : Object.values(s)),
                  ],
                }
              )),
              e(...r)
            );
          };
        }
        const ZG = JG(UG.formatWithCursor);
        var KG = {
          formatWithCursor: ZG,
          format: (e, t) => ZG(e, t).formatted,
          check(e, t) {
            const { formatted: n } = ZG(e, t);
            return n === e;
          },
          doc: XG,
          getSupportInfo: JG(HG, 0),
          version: WG,
          util: GG,
          __debug: {
            parse: JG(UG.parse),
            formatAST: JG(UG.formatAST),
            formatDoc: JG(UG.formatDoc),
            printToDoc: JG(UG.printToDoc),
            printDocToString: JG(UG.printDocToString),
          },
        };
        return KG;
      })();
    },
    7628: function (e, t, n) {
      "use strict";
      function r(e) {
        return (
          null !== e &&
          "object" == typeof e &&
          "constructor" in e &&
          e.constructor === Object
        );
      }
      function i(e = {}, t = {}) {
        Object.keys(t).forEach((n) => {
          void 0 === e[n]
            ? (e[n] = t[n])
            : r(t[n]) &&
              r(e[n]) &&
              Object.keys(t[n]).length > 0 &&
              i(e[n], t[n]);
        });
      }
      n.d(t, {
        Me: function () {
          return s;
        },
        Jj: function () {
          return u;
        },
      });
      const o = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: "" },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() {} }),
        createElement: () => ({
          children: [],
          childNodes: [],
          style: {},
          setAttribute() {},
          getElementsByTagName: () => [],
        }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
      };
      function s() {
        const e = "undefined" != typeof document ? document : {};
        return i(e, o), e;
      }
      const a = {
        document: o,
        navigator: { userAgent: "" },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle: () => ({ getPropertyValue: () => "" }),
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia: () => ({}),
        requestAnimationFrame: (e) =>
          "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
        cancelAnimationFrame(e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function u() {
        const e = "undefined" != typeof window ? window : {};
        return i(e, a), e;
      }
    },
    638: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return P;
        },
      });
      var r = n(7628),
        i = n(4625),
        o = n(9482);
      let s, a, u;
      function l() {
        return (
          s ||
            (s = (function () {
              const e = (0, r.Jj)(),
                t = (0, r.Me)();
              return {
                smoothScroll:
                  t.documentElement &&
                  "scrollBehavior" in t.documentElement.style,
                touch: !!(
                  "ontouchstart" in e ||
                  (e.DocumentTouch && t instanceof e.DocumentTouch)
                ),
                passiveListener: (function () {
                  let t = !1;
                  try {
                    const n = Object.defineProperty({}, "passive", {
                      get() {
                        t = !0;
                      },
                    });
                    e.addEventListener("testPassiveListener", null, n);
                  } catch (e) {}
                  return t;
                })(),
                gestures: "ongesturestart" in e,
              };
            })()),
          s
        );
      }
      var c = {
          on(e, t, n) {
            const r = this;
            if ("function" != typeof t) return r;
            const i = n ? "unshift" : "push";
            return (
              e.split(" ").forEach((e) => {
                r.eventsListeners[e] || (r.eventsListeners[e] = []),
                  r.eventsListeners[e][i](t);
              }),
              r
            );
          },
          once(e, t, n) {
            const r = this;
            if ("function" != typeof t) return r;
            function i() {
              r.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
              for (
                var n = arguments.length, o = new Array(n), s = 0;
                s < n;
                s++
              )
                o[s] = arguments[s];
              t.apply(r, o);
            }
            return (i.__emitterProxy = t), r.on(e, i, n);
          },
          onAny(e, t) {
            const n = this;
            if ("function" != typeof e) return n;
            const r = t ? "unshift" : "push";
            return (
              n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e),
              n
            );
          },
          offAny(e) {
            const t = this;
            if (!t.eventsAnyListeners) return t;
            const n = t.eventsAnyListeners.indexOf(e);
            return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
          },
          off(e, t) {
            const n = this;
            return n.eventsListeners
              ? (e.split(" ").forEach((e) => {
                  void 0 === t
                    ? (n.eventsListeners[e] = [])
                    : n.eventsListeners[e] &&
                      n.eventsListeners[e].forEach((r, i) => {
                        (r === t ||
                          (r.__emitterProxy && r.__emitterProxy === t)) &&
                          n.eventsListeners[e].splice(i, 1);
                      });
                }),
                n)
              : n;
          },
          emit() {
            const e = this;
            if (!e.eventsListeners) return e;
            let t, n, r;
            for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
              o[s] = arguments[s];
            return (
              "string" == typeof o[0] || Array.isArray(o[0])
                ? ((t = o[0]), (n = o.slice(1, o.length)), (r = e))
                : ((t = o[0].events), (n = o[0].data), (r = o[0].context || e)),
              n.unshift(r),
              (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
                e.eventsAnyListeners &&
                  e.eventsAnyListeners.length &&
                  e.eventsAnyListeners.forEach((e) => {
                    e.apply(r, [t, ...n]);
                  }),
                  e.eventsListeners &&
                    e.eventsListeners[t] &&
                    e.eventsListeners[t].forEach((e) => {
                      e.apply(r, n);
                    });
              }),
              e
            );
          },
        },
        p = {
          updateSize: function () {
            const e = this;
            let t, n;
            const r = e.$el;
            (t =
              void 0 !== e.params.width && null !== e.params.width
                ? e.params.width
                : r[0].clientWidth),
              (n =
                void 0 !== e.params.height && null !== e.params.height
                  ? e.params.height
                  : r[0].clientHeight),
              (0 === t && e.isHorizontal()) ||
                (0 === n && e.isVertical()) ||
                ((t =
                  t -
                  parseInt(r.css("padding-left") || 0, 10) -
                  parseInt(r.css("padding-right") || 0, 10)),
                (n =
                  n -
                  parseInt(r.css("padding-top") || 0, 10) -
                  parseInt(r.css("padding-bottom") || 0, 10)),
                Number.isNaN(t) && (t = 0),
                Number.isNaN(n) && (n = 0),
                Object.assign(e, {
                  width: t,
                  height: n,
                  size: e.isHorizontal() ? t : n,
                }));
          },
          updateSlides: function () {
            const e = this;
            function t(t) {
              return e.isHorizontal()
                ? t
                : {
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom",
                  }[t];
            }
            function n(e, n) {
              return parseFloat(e.getPropertyValue(t(n)) || 0);
            }
            const r = e.params,
              { $wrapperEl: i, size: s, rtlTranslate: a, wrongRTL: u } = e,
              l = e.virtual && r.virtual.enabled,
              c = l ? e.virtual.slides.length : e.slides.length,
              p = i.children(`.${e.params.slideClass}`),
              f = l ? e.virtual.slides.length : p.length;
            let d = [];
            const h = [],
              m = [];
            let g = r.slidesOffsetBefore;
            "function" == typeof g && (g = r.slidesOffsetBefore.call(e));
            let y = r.slidesOffsetAfter;
            "function" == typeof y && (y = r.slidesOffsetAfter.call(e));
            const v = e.snapGrid.length,
              D = e.slidesGrid.length;
            let b = r.spaceBetween,
              E = -g,
              C = 0,
              x = 0;
            if (void 0 === s) return;
            "string" == typeof b &&
              b.indexOf("%") >= 0 &&
              (b = (parseFloat(b.replace("%", "")) / 100) * s),
              (e.virtualSize = -b),
              a
                ? p.css({ marginLeft: "", marginBottom: "", marginTop: "" })
                : p.css({ marginRight: "", marginBottom: "", marginTop: "" }),
              r.centeredSlides &&
                r.cssMode &&
                ((0, o.z2)(e.wrapperEl, "--swiper-centered-offset-before", ""),
                (0, o.z2)(e.wrapperEl, "--swiper-centered-offset-after", ""));
            const w = r.grid && r.grid.rows > 1 && e.grid;
            let A;
            w && e.grid.initSlides(f);
            const S =
              "auto" === r.slidesPerView &&
              r.breakpoints &&
              Object.keys(r.breakpoints).filter(
                (e) => void 0 !== r.breakpoints[e].slidesPerView
              ).length > 0;
            for (let i = 0; i < f; i += 1) {
              A = 0;
              const o = p.eq(i);
              if (
                (w && e.grid.updateSlide(i, o, f, t),
                "none" !== o.css("display"))
              ) {
                if ("auto" === r.slidesPerView) {
                  S && (p[i].style[t("width")] = "");
                  const s = getComputedStyle(o[0]),
                    a = o[0].style.transform,
                    u = o[0].style.webkitTransform;
                  if (
                    (a && (o[0].style.transform = "none"),
                    u && (o[0].style.webkitTransform = "none"),
                    r.roundLengths)
                  )
                    A = e.isHorizontal() ? o.outerWidth(!0) : o.outerHeight(!0);
                  else {
                    const e = n(s, "width"),
                      t = n(s, "padding-left"),
                      r = n(s, "padding-right"),
                      i = n(s, "margin-left"),
                      a = n(s, "margin-right"),
                      u = s.getPropertyValue("box-sizing");
                    if (u && "border-box" === u) A = e + i + a;
                    else {
                      const { clientWidth: n, offsetWidth: s } = o[0];
                      A = e + t + r + i + a + (s - n);
                    }
                  }
                  a && (o[0].style.transform = a),
                    u && (o[0].style.webkitTransform = u),
                    r.roundLengths && (A = Math.floor(A));
                } else
                  (A = (s - (r.slidesPerView - 1) * b) / r.slidesPerView),
                    r.roundLengths && (A = Math.floor(A)),
                    p[i] && (p[i].style[t("width")] = `${A}px`);
                p[i] && (p[i].swiperSlideSize = A),
                  m.push(A),
                  r.centeredSlides
                    ? ((E = E + A / 2 + C / 2 + b),
                      0 === C && 0 !== i && (E = E - s / 2 - b),
                      0 === i && (E = E - s / 2 - b),
                      Math.abs(E) < 0.001 && (E = 0),
                      r.roundLengths && (E = Math.floor(E)),
                      x % r.slidesPerGroup == 0 && d.push(E),
                      h.push(E))
                    : (r.roundLengths && (E = Math.floor(E)),
                      (x - Math.min(e.params.slidesPerGroupSkip, x)) %
                        e.params.slidesPerGroup ==
                        0 && d.push(E),
                      h.push(E),
                      (E = E + A + b)),
                  (e.virtualSize += A + b),
                  (C = A),
                  (x += 1);
              }
            }
            if (
              ((e.virtualSize = Math.max(e.virtualSize, s) + y),
              a &&
                u &&
                ("slide" === r.effect || "coverflow" === r.effect) &&
                i.css({ width: `${e.virtualSize + r.spaceBetween}px` }),
              r.setWrapperSize &&
                i.css({ [t("width")]: `${e.virtualSize + r.spaceBetween}px` }),
              w && e.grid.updateWrapperSize(A, d, t),
              !r.centeredSlides)
            ) {
              const t = [];
              for (let n = 0; n < d.length; n += 1) {
                let i = d[n];
                r.roundLengths && (i = Math.floor(i)),
                  d[n] <= e.virtualSize - s && t.push(i);
              }
              (d = t),
                Math.floor(e.virtualSize - s) - Math.floor(d[d.length - 1]) >
                  1 && d.push(e.virtualSize - s);
            }
            if ((0 === d.length && (d = [0]), 0 !== r.spaceBetween)) {
              const n = e.isHorizontal() && a ? "marginLeft" : t("marginRight");
              p.filter((e, t) => !r.cssMode || t !== p.length - 1).css({
                [n]: `${b}px`,
              });
            }
            if (r.centeredSlides && r.centeredSlidesBounds) {
              let e = 0;
              m.forEach((t) => {
                e += t + (r.spaceBetween ? r.spaceBetween : 0);
              }),
                (e -= r.spaceBetween);
              const t = e - s;
              d = d.map((e) => (e < 0 ? -g : e > t ? t + y : e));
            }
            if (r.centerInsufficientSlides) {
              let e = 0;
              if (
                (m.forEach((t) => {
                  e += t + (r.spaceBetween ? r.spaceBetween : 0);
                }),
                (e -= r.spaceBetween),
                e < s)
              ) {
                const t = (s - e) / 2;
                d.forEach((e, n) => {
                  d[n] = e - t;
                }),
                  h.forEach((e, n) => {
                    h[n] = e + t;
                  });
              }
            }
            if (
              (Object.assign(e, {
                slides: p,
                snapGrid: d,
                slidesGrid: h,
                slidesSizesGrid: m,
              }),
              r.centeredSlides && r.cssMode && !r.centeredSlidesBounds)
            ) {
              (0, o.z2)(
                e.wrapperEl,
                "--swiper-centered-offset-before",
                -d[0] + "px"
              ),
                (0, o.z2)(
                  e.wrapperEl,
                  "--swiper-centered-offset-after",
                  e.size / 2 - m[m.length - 1] / 2 + "px"
                );
              const t = -e.snapGrid[0],
                n = -e.slidesGrid[0];
              (e.snapGrid = e.snapGrid.map((e) => e + t)),
                (e.slidesGrid = e.slidesGrid.map((e) => e + n));
            }
            if (
              (f !== c && e.emit("slidesLengthChange"),
              d.length !== v &&
                (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
              h.length !== D && e.emit("slidesGridLengthChange"),
              r.watchSlidesProgress && e.updateSlidesOffset(),
              !(
                l ||
                r.cssMode ||
                ("slide" !== r.effect && "fade" !== r.effect)
              ))
            ) {
              const t = `${r.containerModifierClass}backface-hidden`,
                n = e.$el.hasClass(t);
              f <= r.maxBackfaceHiddenSlides
                ? n || e.$el.addClass(t)
                : n && e.$el.removeClass(t);
            }
          },
          updateAutoHeight: function (e) {
            const t = this,
              n = [],
              r = t.virtual && t.params.virtual.enabled;
            let i,
              o = 0;
            "number" == typeof e
              ? t.setTransition(e)
              : !0 === e && t.setTransition(t.params.speed);
            const s = (e) =>
              r
                ? t.slides.filter(
                    (t) =>
                      parseInt(
                        t.getAttribute("data-swiper-slide-index"),
                        10
                      ) === e
                  )[0]
                : t.slides.eq(e)[0];
            if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
              if (t.params.centeredSlides)
                t.visibleSlides.each((e) => {
                  n.push(e);
                });
              else
                for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
                  const e = t.activeIndex + i;
                  if (e > t.slides.length && !r) break;
                  n.push(s(e));
                }
            else n.push(s(t.activeIndex));
            for (i = 0; i < n.length; i += 1)
              if (void 0 !== n[i]) {
                const e = n[i].offsetHeight;
                o = e > o ? e : o;
              }
            (o || 0 === o) && t.$wrapperEl.css("height", `${o}px`);
          },
          updateSlidesOffset: function () {
            const e = this,
              t = e.slides;
            for (let n = 0; n < t.length; n += 1)
              t[n].swiperSlideOffset = e.isHorizontal()
                ? t[n].offsetLeft
                : t[n].offsetTop;
          },
          updateSlidesProgress: function (e) {
            void 0 === e && (e = (this && this.translate) || 0);
            const t = this,
              n = t.params,
              { slides: r, rtlTranslate: o, snapGrid: s } = t;
            if (0 === r.length) return;
            void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
            let a = -e;
            o && (a = e),
              r.removeClass(n.slideVisibleClass),
              (t.visibleSlidesIndexes = []),
              (t.visibleSlides = []);
            for (let e = 0; e < r.length; e += 1) {
              const i = r[e];
              let u = i.swiperSlideOffset;
              n.cssMode && n.centeredSlides && (u -= r[0].swiperSlideOffset);
              const l =
                  (a + (n.centeredSlides ? t.minTranslate() : 0) - u) /
                  (i.swiperSlideSize + n.spaceBetween),
                c =
                  (a - s[0] + (n.centeredSlides ? t.minTranslate() : 0) - u) /
                  (i.swiperSlideSize + n.spaceBetween),
                p = -(a - u),
                f = p + t.slidesSizesGrid[e];
              ((p >= 0 && p < t.size - 1) ||
                (f > 1 && f <= t.size) ||
                (p <= 0 && f >= t.size)) &&
                (t.visibleSlides.push(i),
                t.visibleSlidesIndexes.push(e),
                r.eq(e).addClass(n.slideVisibleClass)),
                (i.progress = o ? -l : l),
                (i.originalProgress = o ? -c : c);
            }
            t.visibleSlides = (0, i.Z)(t.visibleSlides);
          },
          updateProgress: function (e) {
            const t = this;
            if (void 0 === e) {
              const n = t.rtlTranslate ? -1 : 1;
              e = (t && t.translate && t.translate * n) || 0;
            }
            const n = t.params,
              r = t.maxTranslate() - t.minTranslate();
            let { progress: i, isBeginning: o, isEnd: s } = t;
            const a = o,
              u = s;
            0 === r
              ? ((i = 0), (o = !0), (s = !0))
              : ((i = (e - t.minTranslate()) / r), (o = i <= 0), (s = i >= 1)),
              Object.assign(t, { progress: i, isBeginning: o, isEnd: s }),
              (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) &&
                t.updateSlidesProgress(e),
              o && !a && t.emit("reachBeginning toEdge"),
              s && !u && t.emit("reachEnd toEdge"),
              ((a && !o) || (u && !s)) && t.emit("fromEdge"),
              t.emit("progress", i);
          },
          updateSlidesClasses: function () {
            const e = this,
              {
                slides: t,
                params: n,
                $wrapperEl: r,
                activeIndex: i,
                realIndex: o,
              } = e,
              s = e.virtual && n.virtual.enabled;
            let a;
            t.removeClass(
              `${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`
            ),
              (a = s
                ? e.$wrapperEl.find(
                    `.${n.slideClass}[data-swiper-slide-index="${i}"]`
                  )
                : t.eq(i)),
              a.addClass(n.slideActiveClass),
              n.loop &&
                (a.hasClass(n.slideDuplicateClass)
                  ? r
                      .children(
                        `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${o}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass)
                  : r
                      .children(
                        `.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${o}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass));
            let u = a
              .nextAll(`.${n.slideClass}`)
              .eq(0)
              .addClass(n.slideNextClass);
            n.loop &&
              0 === u.length &&
              ((u = t.eq(0)), u.addClass(n.slideNextClass));
            let l = a
              .prevAll(`.${n.slideClass}`)
              .eq(0)
              .addClass(n.slidePrevClass);
            n.loop &&
              0 === l.length &&
              ((l = t.eq(-1)), l.addClass(n.slidePrevClass)),
              n.loop &&
                (u.hasClass(n.slideDuplicateClass)
                  ? r
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${u.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass)
                  : r
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${u.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass),
                l.hasClass(n.slideDuplicateClass)
                  ? r
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass)
                  : r
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass)),
              e.emitSlidesClasses();
          },
          updateActiveIndex: function (e) {
            const t = this,
              n = t.rtlTranslate ? t.translate : -t.translate,
              {
                slidesGrid: r,
                snapGrid: i,
                params: o,
                activeIndex: s,
                realIndex: a,
                snapIndex: u,
              } = t;
            let l,
              c = e;
            if (void 0 === c) {
              for (let e = 0; e < r.length; e += 1)
                void 0 !== r[e + 1]
                  ? n >= r[e] && n < r[e + 1] - (r[e + 1] - r[e]) / 2
                    ? (c = e)
                    : n >= r[e] && n < r[e + 1] && (c = e + 1)
                  : n >= r[e] && (c = e);
              o.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0);
            }
            if (i.indexOf(n) >= 0) l = i.indexOf(n);
            else {
              const e = Math.min(o.slidesPerGroupSkip, c);
              l = e + Math.floor((c - e) / o.slidesPerGroup);
            }
            if ((l >= i.length && (l = i.length - 1), c === s))
              return void (
                l !== u && ((t.snapIndex = l), t.emit("snapIndexChange"))
              );
            const p = parseInt(
              t.slides.eq(c).attr("data-swiper-slide-index") || c,
              10
            );
            Object.assign(t, {
              snapIndex: l,
              realIndex: p,
              previousIndex: s,
              activeIndex: c,
            }),
              t.emit("activeIndexChange"),
              t.emit("snapIndexChange"),
              a !== p && t.emit("realIndexChange"),
              (t.initialized || t.params.runCallbacksOnInit) &&
                t.emit("slideChange");
          },
          updateClickedSlide: function (e) {
            const t = this,
              n = t.params,
              r = (0, i.Z)(e).closest(`.${n.slideClass}`)[0];
            let o,
              s = !1;
            if (r)
              for (let e = 0; e < t.slides.length; e += 1)
                if (t.slides[e] === r) {
                  (s = !0), (o = e);
                  break;
                }
            if (!r || !s)
              return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = r),
              t.virtual && t.params.virtual.enabled
                ? (t.clickedIndex = parseInt(
                    (0, i.Z)(r).attr("data-swiper-slide-index"),
                    10
                  ))
                : (t.clickedIndex = o),
              n.slideToClickedSlide &&
                void 0 !== t.clickedIndex &&
                t.clickedIndex !== t.activeIndex &&
                t.slideToClickedSlide();
          },
        },
        f = {
          getTranslate: function (e) {
            void 0 === e && (e = this.isHorizontal() ? "x" : "y");
            const {
              params: t,
              rtlTranslate: n,
              translate: r,
              $wrapperEl: i,
            } = this;
            if (t.virtualTranslate) return n ? -r : r;
            if (t.cssMode) return r;
            let s = (0, o.R6)(i[0], e);
            return n && (s = -s), s || 0;
          },
          setTranslate: function (e, t) {
            const n = this,
              {
                rtlTranslate: r,
                params: i,
                $wrapperEl: o,
                wrapperEl: s,
                progress: a,
              } = n;
            let u,
              l = 0,
              c = 0;
            n.isHorizontal() ? (l = r ? -e : e) : (c = e),
              i.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
              i.cssMode
                ? (s[n.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                    n.isHorizontal() ? -l : -c)
                : i.virtualTranslate ||
                  o.transform(`translate3d(${l}px, ${c}px, 0px)`),
              (n.previousTranslate = n.translate),
              (n.translate = n.isHorizontal() ? l : c);
            const p = n.maxTranslate() - n.minTranslate();
            (u = 0 === p ? 0 : (e - n.minTranslate()) / p),
              u !== a && n.updateProgress(e),
              n.emit("setTranslate", n.translate, t);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (e, t, n, r, i) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0),
              void 0 === r && (r = !0);
            const s = this,
              { params: a, wrapperEl: u } = s;
            if (s.animating && a.preventInteractionOnTransition) return !1;
            const l = s.minTranslate(),
              c = s.maxTranslate();
            let p;
            if (
              ((p = r && e > l ? l : r && e < c ? c : e),
              s.updateProgress(p),
              a.cssMode)
            ) {
              const e = s.isHorizontal();
              if (0 === t) u[e ? "scrollLeft" : "scrollTop"] = -p;
              else {
                if (!s.support.smoothScroll)
                  return (
                    (0, o.x2)({
                      swiper: s,
                      targetPosition: -p,
                      side: e ? "left" : "top",
                    }),
                    !0
                  );
                u.scrollTo({ [e ? "left" : "top"]: -p, behavior: "smooth" });
              }
              return !0;
            }
            return (
              0 === t
                ? (s.setTransition(0),
                  s.setTranslate(p),
                  n &&
                    (s.emit("beforeTransitionStart", t, i),
                    s.emit("transitionEnd")))
                : (s.setTransition(t),
                  s.setTranslate(p),
                  n &&
                    (s.emit("beforeTransitionStart", t, i),
                    s.emit("transitionStart")),
                  s.animating ||
                    ((s.animating = !0),
                    s.onTranslateToWrapperTransitionEnd ||
                      (s.onTranslateToWrapperTransitionEnd = function (e) {
                        s &&
                          !s.destroyed &&
                          e.target === this &&
                          (s.$wrapperEl[0].removeEventListener(
                            "transitionend",
                            s.onTranslateToWrapperTransitionEnd
                          ),
                          s.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            s.onTranslateToWrapperTransitionEnd
                          ),
                          (s.onTranslateToWrapperTransitionEnd = null),
                          delete s.onTranslateToWrapperTransitionEnd,
                          n && s.emit("transitionEnd"));
                      }),
                    s.$wrapperEl[0].addEventListener(
                      "transitionend",
                      s.onTranslateToWrapperTransitionEnd
                    ),
                    s.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      s.onTranslateToWrapperTransitionEnd
                    ))),
              !0
            );
          },
        },
        d = n(3901),
        h = {
          slideTo: function (e, t, n, r, i) {
            if (
              (void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0),
              "number" != typeof e && "string" != typeof e)
            )
              throw new Error(
                `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`
              );
            if ("string" == typeof e) {
              const t = parseInt(e, 10);
              if (!isFinite(t))
                throw new Error(
                  `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
                );
              e = t;
            }
            const s = this;
            let a = e;
            a < 0 && (a = 0);
            const {
              params: u,
              snapGrid: l,
              slidesGrid: c,
              previousIndex: p,
              activeIndex: f,
              rtlTranslate: d,
              wrapperEl: h,
              enabled: m,
            } = s;
            if (
              (s.animating && u.preventInteractionOnTransition) ||
              (!m && !r && !i)
            )
              return !1;
            const g = Math.min(s.params.slidesPerGroupSkip, a);
            let y = g + Math.floor((a - g) / s.params.slidesPerGroup);
            y >= l.length && (y = l.length - 1),
              (f || u.initialSlide || 0) === (p || 0) &&
                n &&
                s.emit("beforeSlideChangeStart");
            const v = -l[y];
            if ((s.updateProgress(v), u.normalizeSlideIndex))
              for (let e = 0; e < c.length; e += 1) {
                const t = -Math.floor(100 * v),
                  n = Math.floor(100 * c[e]),
                  r = Math.floor(100 * c[e + 1]);
                void 0 !== c[e + 1]
                  ? t >= n && t < r - (r - n) / 2
                    ? (a = e)
                    : t >= n && t < r && (a = e + 1)
                  : t >= n && (a = e);
              }
            if (s.initialized && a !== f) {
              if (!s.allowSlideNext && v < s.translate && v < s.minTranslate())
                return !1;
              if (
                !s.allowSlidePrev &&
                v > s.translate &&
                v > s.maxTranslate() &&
                (f || 0) !== a
              )
                return !1;
            }
            let D;
            if (
              ((D = a > f ? "next" : a < f ? "prev" : "reset"),
              (d && -v === s.translate) || (!d && v === s.translate))
            )
              return (
                s.updateActiveIndex(a),
                u.autoHeight && s.updateAutoHeight(),
                s.updateSlidesClasses(),
                "slide" !== u.effect && s.setTranslate(v),
                "reset" !== D &&
                  (s.transitionStart(n, D), s.transitionEnd(n, D)),
                !1
              );
            if (u.cssMode) {
              const e = s.isHorizontal(),
                n = d ? v : -v;
              if (0 === t) {
                const t = s.virtual && s.params.virtual.enabled;
                t &&
                  ((s.wrapperEl.style.scrollSnapType = "none"),
                  (s._immediateVirtual = !0)),
                  (h[e ? "scrollLeft" : "scrollTop"] = n),
                  t &&
                    requestAnimationFrame(() => {
                      (s.wrapperEl.style.scrollSnapType = ""),
                        (s._swiperImmediateVirtual = !1);
                    });
              } else {
                if (!s.support.smoothScroll)
                  return (
                    (0, o.x2)({
                      swiper: s,
                      targetPosition: n,
                      side: e ? "left" : "top",
                    }),
                    !0
                  );
                h.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" });
              }
              return !0;
            }
            return (
              s.setTransition(t),
              s.setTranslate(v),
              s.updateActiveIndex(a),
              s.updateSlidesClasses(),
              s.emit("beforeTransitionStart", t, r),
              s.transitionStart(n, D),
              0 === t
                ? s.transitionEnd(n, D)
                : s.animating ||
                  ((s.animating = !0),
                  s.onSlideToWrapperTransitionEnd ||
                    (s.onSlideToWrapperTransitionEnd = function (e) {
                      s &&
                        !s.destroyed &&
                        e.target === this &&
                        (s.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          s.onSlideToWrapperTransitionEnd
                        ),
                        s.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          s.onSlideToWrapperTransitionEnd
                        ),
                        (s.onSlideToWrapperTransitionEnd = null),
                        delete s.onSlideToWrapperTransitionEnd,
                        s.transitionEnd(n, D));
                    }),
                  s.$wrapperEl[0].addEventListener(
                    "transitionend",
                    s.onSlideToWrapperTransitionEnd
                  ),
                  s.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    s.onSlideToWrapperTransitionEnd
                  )),
              !0
            );
          },
          slideToLoop: function (e, t, n, r) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0);
            const i = this;
            let o = e;
            return (
              i.params.loop && (o += i.loopedSlides), i.slideTo(o, t, n, r)
            );
          },
          slideNext: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const r = this,
              { animating: i, enabled: o, params: s } = r;
            if (!o) return r;
            let a = s.slidesPerGroup;
            "auto" === s.slidesPerView &&
              1 === s.slidesPerGroup &&
              s.slidesPerGroupAuto &&
              (a = Math.max(r.slidesPerViewDynamic("current", !0), 1));
            const u = r.activeIndex < s.slidesPerGroupSkip ? 1 : a;
            if (s.loop) {
              if (i && s.loopPreventsSlide) return !1;
              r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
            }
            return s.rewind && r.isEnd
              ? r.slideTo(0, e, t, n)
              : r.slideTo(r.activeIndex + u, e, t, n);
          },
          slidePrev: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const r = this,
              {
                params: i,
                animating: o,
                snapGrid: s,
                slidesGrid: a,
                rtlTranslate: u,
                enabled: l,
              } = r;
            if (!l) return r;
            if (i.loop) {
              if (o && i.loopPreventsSlide) return !1;
              r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
            }
            function c(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            const p = c(u ? r.translate : -r.translate),
              f = s.map((e) => c(e));
            let d = s[f.indexOf(p) - 1];
            if (void 0 === d && i.cssMode) {
              let e;
              s.forEach((t, n) => {
                p >= t && (e = n);
              }),
                void 0 !== e && (d = s[e > 0 ? e - 1 : e]);
            }
            let h = 0;
            if (
              (void 0 !== d &&
                ((h = a.indexOf(d)),
                h < 0 && (h = r.activeIndex - 1),
                "auto" === i.slidesPerView &&
                  1 === i.slidesPerGroup &&
                  i.slidesPerGroupAuto &&
                  ((h = h - r.slidesPerViewDynamic("previous", !0) + 1),
                  (h = Math.max(h, 0)))),
              i.rewind && r.isBeginning)
            ) {
              const i =
                r.params.virtual && r.params.virtual.enabled && r.virtual
                  ? r.virtual.slides.length - 1
                  : r.slides.length - 1;
              return r.slideTo(i, e, t, n);
            }
            return r.slideTo(h, e, t, n);
          },
          slideReset: function (e, t, n) {
            return (
              void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              this.slideTo(this.activeIndex, e, t, n)
            );
          },
          slideToClosest: function (e, t, n, r) {
            void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              void 0 === r && (r = 0.5);
            const i = this;
            let o = i.activeIndex;
            const s = Math.min(i.params.slidesPerGroupSkip, o),
              a = s + Math.floor((o - s) / i.params.slidesPerGroup),
              u = i.rtlTranslate ? i.translate : -i.translate;
            if (u >= i.snapGrid[a]) {
              const e = i.snapGrid[a];
              u - e > (i.snapGrid[a + 1] - e) * r &&
                (o += i.params.slidesPerGroup);
            } else {
              const e = i.snapGrid[a - 1];
              u - e <= (i.snapGrid[a] - e) * r &&
                (o -= i.params.slidesPerGroup);
            }
            return (
              (o = Math.max(o, 0)),
              (o = Math.min(o, i.slidesGrid.length - 1)),
              i.slideTo(o, e, t, n)
            );
          },
          slideToClickedSlide: function () {
            const e = this,
              { params: t, $wrapperEl: n } = e,
              r =
                "auto" === t.slidesPerView
                  ? e.slidesPerViewDynamic()
                  : t.slidesPerView;
            let s,
              a = e.clickedIndex;
            if (t.loop) {
              if (e.animating) return;
              (s = parseInt(
                (0, i.Z)(e.clickedSlide).attr("data-swiper-slide-index"),
                10
              )),
                t.centeredSlides
                  ? a < e.loopedSlides - r / 2 ||
                    a > e.slides.length - e.loopedSlides + r / 2
                    ? (e.loopFix(),
                      (a = n
                        .children(
                          `.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`
                        )
                        .eq(0)
                        .index()),
                      (0, o.Y3)(() => {
                        e.slideTo(a);
                      }))
                    : e.slideTo(a)
                  : a > e.slides.length - r
                  ? (e.loopFix(),
                    (a = n
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    (0, o.Y3)(() => {
                      e.slideTo(a);
                    }))
                  : e.slideTo(a);
            } else e.slideTo(a);
          },
        },
        m = {
          loopCreate: function () {
            const e = this,
              t = (0, r.Me)(),
              { params: n, $wrapperEl: o } = e,
              s =
                o.children().length > 0
                  ? (0, i.Z)(o.children()[0].parentNode)
                  : o;
            s.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
            let a = s.children(`.${n.slideClass}`);
            if (n.loopFillGroupWithBlank) {
              const e = n.slidesPerGroup - (a.length % n.slidesPerGroup);
              if (e !== n.slidesPerGroup) {
                for (let r = 0; r < e; r += 1) {
                  const e = (0, i.Z)(t.createElement("div")).addClass(
                    `${n.slideClass} ${n.slideBlankClass}`
                  );
                  s.append(e);
                }
                a = s.children(`.${n.slideClass}`);
              }
            }
            "auto" !== n.slidesPerView ||
              n.loopedSlides ||
              (n.loopedSlides = a.length),
              (e.loopedSlides = Math.ceil(
                parseFloat(n.loopedSlides || n.slidesPerView, 10)
              )),
              (e.loopedSlides += n.loopAdditionalSlides),
              e.loopedSlides > a.length && (e.loopedSlides = a.length);
            const u = [],
              l = [];
            a.each((t, n) => {
              const r = (0, i.Z)(t);
              n < e.loopedSlides && l.push(t),
                n < a.length && n >= a.length - e.loopedSlides && u.push(t),
                r.attr("data-swiper-slide-index", n);
            });
            for (let e = 0; e < l.length; e += 1)
              s.append(
                (0, i.Z)(l[e].cloneNode(!0)).addClass(n.slideDuplicateClass)
              );
            for (let e = u.length - 1; e >= 0; e -= 1)
              s.prepend(
                (0, i.Z)(u[e].cloneNode(!0)).addClass(n.slideDuplicateClass)
              );
          },
          loopFix: function () {
            const e = this;
            e.emit("beforeLoopFix");
            const {
              activeIndex: t,
              slides: n,
              loopedSlides: r,
              allowSlidePrev: i,
              allowSlideNext: o,
              snapGrid: s,
              rtlTranslate: a,
            } = e;
            let u;
            (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
            const l = -s[t] - e.getTranslate();
            t < r
              ? ((u = n.length - 3 * r + t),
                (u += r),
                e.slideTo(u, 0, !1, !0) &&
                  0 !== l &&
                  e.setTranslate((a ? -e.translate : e.translate) - l))
              : t >= n.length - r &&
                ((u = -n.length + t + r),
                (u += r),
                e.slideTo(u, 0, !1, !0) &&
                  0 !== l &&
                  e.setTranslate((a ? -e.translate : e.translate) - l)),
              (e.allowSlidePrev = i),
              (e.allowSlideNext = o),
              e.emit("loopFix");
          },
          loopDestroy: function () {
            const { $wrapperEl: e, params: t, slides: n } = this;
            e
              .children(
                `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`
              )
              .remove(),
              n.removeAttr("data-swiper-slide-index");
          },
        };
      function g(e) {
        const t = this,
          n = (0, r.Me)(),
          s = (0, r.Jj)(),
          a = t.touchEventsData,
          { params: u, touches: l, enabled: c } = t;
        if (!c) return;
        if (t.animating && u.preventInteractionOnTransition) return;
        !t.animating && u.cssMode && u.loop && t.loopFix();
        let p = e;
        p.originalEvent && (p = p.originalEvent);
        let f = (0, i.Z)(p.target);
        if ("wrapper" === u.touchEventsTarget && !f.closest(t.wrapperEl).length)
          return;
        if (
          ((a.isTouchEvent = "touchstart" === p.type),
          !a.isTouchEvent && "which" in p && 3 === p.which)
        )
          return;
        if (!a.isTouchEvent && "button" in p && p.button > 0) return;
        if (a.isTouched && a.isMoved) return;
        u.noSwipingClass &&
          "" !== u.noSwipingClass &&
          p.target &&
          p.target.shadowRoot &&
          e.path &&
          e.path[0] &&
          (f = (0, i.Z)(e.path[0]));
        const d = u.noSwipingSelector
            ? u.noSwipingSelector
            : `.${u.noSwipingClass}`,
          h = !(!p.target || !p.target.shadowRoot);
        if (
          u.noSwiping &&
          (h
            ? (function (e, t) {
                return (
                  void 0 === t && (t = this),
                  (function t(n) {
                    return n && n !== (0, r.Me)() && n !== (0, r.Jj)()
                      ? (n.assignedSlot && (n = n.assignedSlot),
                        n.closest(e) || t(n.getRootNode().host))
                      : null;
                  })(t)
                );
              })(d, p.target)
            : f.closest(d)[0])
        )
          return void (t.allowClick = !0);
        if (u.swipeHandler && !f.closest(u.swipeHandler)[0]) return;
        (l.currentX =
          "touchstart" === p.type ? p.targetTouches[0].pageX : p.pageX),
          (l.currentY =
            "touchstart" === p.type ? p.targetTouches[0].pageY : p.pageY);
        const m = l.currentX,
          g = l.currentY,
          y = u.edgeSwipeDetection || u.iOSEdgeSwipeDetection,
          v = u.edgeSwipeThreshold || u.iOSEdgeSwipeThreshold;
        if (y && (m <= v || m >= s.innerWidth - v)) {
          if ("prevent" !== y) return;
          e.preventDefault();
        }
        if (
          (Object.assign(a, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
          }),
          (l.startX = m),
          (l.startY = g),
          (a.touchStartTime = (0, o.zO)()),
          (t.allowClick = !0),
          t.updateSize(),
          (t.swipeDirection = void 0),
          u.threshold > 0 && (a.allowThresholdMove = !1),
          "touchstart" !== p.type)
        ) {
          let e = !0;
          f.is(a.focusableElements) &&
            ((e = !1), "SELECT" === f[0].nodeName && (a.isTouched = !1)),
            n.activeElement &&
              (0, i.Z)(n.activeElement).is(a.focusableElements) &&
              n.activeElement !== f[0] &&
              n.activeElement.blur();
          const r = e && t.allowTouchMove && u.touchStartPreventDefault;
          (!u.touchStartForcePreventDefault && !r) ||
            f[0].isContentEditable ||
            p.preventDefault();
        }
        t.params.freeMode &&
          t.params.freeMode.enabled &&
          t.freeMode &&
          t.animating &&
          !u.cssMode &&
          t.freeMode.onTouchStart(),
          t.emit("touchStart", p);
      }
      function y(e) {
        const t = (0, r.Me)(),
          n = this,
          s = n.touchEventsData,
          { params: a, touches: u, rtlTranslate: l, enabled: c } = n;
        if (!c) return;
        let p = e;
        if ((p.originalEvent && (p = p.originalEvent), !s.isTouched))
          return void (
            s.startMoving &&
            s.isScrolling &&
            n.emit("touchMoveOpposite", p)
          );
        if (s.isTouchEvent && "touchmove" !== p.type) return;
        const f =
            "touchmove" === p.type &&
            p.targetTouches &&
            (p.targetTouches[0] || p.changedTouches[0]),
          d = "touchmove" === p.type ? f.pageX : p.pageX,
          h = "touchmove" === p.type ? f.pageY : p.pageY;
        if (p.preventedByNestedSwiper)
          return (u.startX = d), void (u.startY = h);
        if (!n.allowTouchMove)
          return (
            (0, i.Z)(p.target).is(s.focusableElements) || (n.allowClick = !1),
            void (
              s.isTouched &&
              (Object.assign(u, {
                startX: d,
                startY: h,
                currentX: d,
                currentY: h,
              }),
              (s.touchStartTime = (0, o.zO)()))
            )
          );
        if (s.isTouchEvent && a.touchReleaseOnEdges && !a.loop)
          if (n.isVertical()) {
            if (
              (h < u.startY && n.translate <= n.maxTranslate()) ||
              (h > u.startY && n.translate >= n.minTranslate())
            )
              return (s.isTouched = !1), void (s.isMoved = !1);
          } else if (
            (d < u.startX && n.translate <= n.maxTranslate()) ||
            (d > u.startX && n.translate >= n.minTranslate())
          )
            return;
        if (
          s.isTouchEvent &&
          t.activeElement &&
          p.target === t.activeElement &&
          (0, i.Z)(p.target).is(s.focusableElements)
        )
          return (s.isMoved = !0), void (n.allowClick = !1);
        if (
          (s.allowTouchCallbacks && n.emit("touchMove", p),
          p.targetTouches && p.targetTouches.length > 1)
        )
          return;
        (u.currentX = d), (u.currentY = h);
        const m = u.currentX - u.startX,
          g = u.currentY - u.startY;
        if (
          n.params.threshold &&
          Math.sqrt(m ** 2 + g ** 2) < n.params.threshold
        )
          return;
        if (void 0 === s.isScrolling) {
          let e;
          (n.isHorizontal() && u.currentY === u.startY) ||
          (n.isVertical() && u.currentX === u.startX)
            ? (s.isScrolling = !1)
            : m * m + g * g >= 25 &&
              ((e = (180 * Math.atan2(Math.abs(g), Math.abs(m))) / Math.PI),
              (s.isScrolling = n.isHorizontal()
                ? e > a.touchAngle
                : 90 - e > a.touchAngle));
        }
        if (
          (s.isScrolling && n.emit("touchMoveOpposite", p),
          void 0 === s.startMoving &&
            ((u.currentX === u.startX && u.currentY === u.startY) ||
              (s.startMoving = !0)),
          s.isScrolling)
        )
          return void (s.isTouched = !1);
        if (!s.startMoving) return;
        (n.allowClick = !1),
          !a.cssMode && p.cancelable && p.preventDefault(),
          a.touchMoveStopPropagation && !a.nested && p.stopPropagation(),
          s.isMoved ||
            (a.loop && !a.cssMode && n.loopFix(),
            (s.startTranslate = n.getTranslate()),
            n.setTransition(0),
            n.animating &&
              n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
            (s.allowMomentumBounce = !1),
            !a.grabCursor ||
              (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) ||
              n.setGrabCursor(!0),
            n.emit("sliderFirstMove", p)),
          n.emit("sliderMove", p),
          (s.isMoved = !0);
        let y = n.isHorizontal() ? m : g;
        (u.diff = y),
          (y *= a.touchRatio),
          l && (y = -y),
          (n.swipeDirection = y > 0 ? "prev" : "next"),
          (s.currentTranslate = y + s.startTranslate);
        let v = !0,
          D = a.resistanceRatio;
        if (
          (a.touchReleaseOnEdges && (D = 0),
          y > 0 && s.currentTranslate > n.minTranslate()
            ? ((v = !1),
              a.resistance &&
                (s.currentTranslate =
                  n.minTranslate() -
                  1 +
                  (-n.minTranslate() + s.startTranslate + y) ** D))
            : y < 0 &&
              s.currentTranslate < n.maxTranslate() &&
              ((v = !1),
              a.resistance &&
                (s.currentTranslate =
                  n.maxTranslate() +
                  1 -
                  (n.maxTranslate() - s.startTranslate - y) ** D)),
          v && (p.preventedByNestedSwiper = !0),
          !n.allowSlideNext &&
            "next" === n.swipeDirection &&
            s.currentTranslate < s.startTranslate &&
            (s.currentTranslate = s.startTranslate),
          !n.allowSlidePrev &&
            "prev" === n.swipeDirection &&
            s.currentTranslate > s.startTranslate &&
            (s.currentTranslate = s.startTranslate),
          n.allowSlidePrev ||
            n.allowSlideNext ||
            (s.currentTranslate = s.startTranslate),
          a.threshold > 0)
        ) {
          if (!(Math.abs(y) > a.threshold || s.allowThresholdMove))
            return void (s.currentTranslate = s.startTranslate);
          if (!s.allowThresholdMove)
            return (
              (s.allowThresholdMove = !0),
              (u.startX = u.currentX),
              (u.startY = u.currentY),
              (s.currentTranslate = s.startTranslate),
              void (u.diff = n.isHorizontal()
                ? u.currentX - u.startX
                : u.currentY - u.startY)
            );
        }
        a.followFinger &&
          !a.cssMode &&
          (((a.freeMode && a.freeMode.enabled && n.freeMode) ||
            a.watchSlidesProgress) &&
            (n.updateActiveIndex(), n.updateSlidesClasses()),
          n.params.freeMode &&
            a.freeMode.enabled &&
            n.freeMode &&
            n.freeMode.onTouchMove(),
          n.updateProgress(s.currentTranslate),
          n.setTranslate(s.currentTranslate));
      }
      function v(e) {
        const t = this,
          n = t.touchEventsData,
          {
            params: r,
            touches: i,
            rtlTranslate: s,
            slidesGrid: a,
            enabled: u,
          } = t;
        if (!u) return;
        let l = e;
        if (
          (l.originalEvent && (l = l.originalEvent),
          n.allowTouchCallbacks && t.emit("touchEnd", l),
          (n.allowTouchCallbacks = !1),
          !n.isTouched)
        )
          return (
            n.isMoved && r.grabCursor && t.setGrabCursor(!1),
            (n.isMoved = !1),
            void (n.startMoving = !1)
          );
        r.grabCursor &&
          n.isMoved &&
          n.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const c = (0, o.zO)(),
          p = c - n.touchStartTime;
        if (t.allowClick) {
          const e = l.path || (l.composedPath && l.composedPath());
          t.updateClickedSlide((e && e[0]) || l.target),
            t.emit("tap click", l),
            p < 300 &&
              c - n.lastClickTime < 300 &&
              t.emit("doubleTap doubleClick", l);
        }
        if (
          ((n.lastClickTime = (0, o.zO)()),
          (0, o.Y3)(() => {
            t.destroyed || (t.allowClick = !0);
          }),
          !n.isTouched ||
            !n.isMoved ||
            !t.swipeDirection ||
            0 === i.diff ||
            n.currentTranslate === n.startTranslate)
        )
          return (
            (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1)
          );
        let f;
        if (
          ((n.isTouched = !1),
          (n.isMoved = !1),
          (n.startMoving = !1),
          (f = r.followFinger
            ? s
              ? t.translate
              : -t.translate
            : -n.currentTranslate),
          r.cssMode)
        )
          return;
        if (t.params.freeMode && r.freeMode.enabled)
          return void t.freeMode.onTouchEnd({ currentPos: f });
        let d = 0,
          h = t.slidesSizesGrid[0];
        for (
          let e = 0;
          e < a.length;
          e += e < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup
        ) {
          const t = e < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
          void 0 !== a[e + t]
            ? f >= a[e] && f < a[e + t] && ((d = e), (h = a[e + t] - a[e]))
            : f >= a[e] && ((d = e), (h = a[a.length - 1] - a[a.length - 2]));
        }
        let m = null,
          g = null;
        r.rewind &&
          (t.isBeginning
            ? (g =
                t.params.virtual && t.params.virtual.enabled && t.virtual
                  ? t.virtual.slides.length - 1
                  : t.slides.length - 1)
            : t.isEnd && (m = 0));
        const y = (f - a[d]) / h,
          v = d < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
        if (p > r.longSwipesMs) {
          if (!r.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection &&
            (y >= r.longSwipesRatio
              ? t.slideTo(r.rewind && t.isEnd ? m : d + v)
              : t.slideTo(d)),
            "prev" === t.swipeDirection &&
              (y > 1 - r.longSwipesRatio
                ? t.slideTo(d + v)
                : null !== g && y < 0 && Math.abs(y) > r.longSwipesRatio
                ? t.slideTo(g)
                : t.slideTo(d));
        } else {
          if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
          !t.navigation ||
          (l.target !== t.navigation.nextEl && l.target !== t.navigation.prevEl)
            ? ("next" === t.swipeDirection && t.slideTo(null !== m ? m : d + v),
              "prev" === t.swipeDirection && t.slideTo(null !== g ? g : d))
            : l.target === t.navigation.nextEl
            ? t.slideTo(d + v)
            : t.slideTo(d);
        }
      }
      function D() {
        const e = this,
          { params: t, el: n } = e;
        if (n && 0 === n.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: i, snapGrid: o } = e;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses(),
          ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
          e.isEnd &&
          !e.isBeginning &&
          !e.params.centeredSlides
            ? e.slideTo(e.slides.length - 1, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0),
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            e.autoplay.run(),
          (e.allowSlidePrev = i),
          (e.allowSlideNext = r),
          e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
      }
      function b(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function E() {
        const e = this,
          { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
        if (!r) return;
        let i;
        (e.previousTranslate = e.translate),
          e.isHorizontal()
            ? (e.translate = -t.scrollLeft)
            : (e.translate = -t.scrollTop),
          -0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const o = e.maxTranslate() - e.minTranslate();
        (i = 0 === o ? 0 : (e.translate - e.minTranslate()) / o),
          i !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
          e.emit("setTranslate", e.translate, !1);
      }
      let C = !1;
      function x() {}
      const w = (e, t) => {
        const n = (0, r.Me)(),
          {
            params: i,
            touchEvents: o,
            el: s,
            wrapperEl: a,
            device: u,
            support: l,
          } = e,
          c = !!i.nested,
          p = "on" === t ? "addEventListener" : "removeEventListener",
          f = t;
        if (l.touch) {
          const t = !(
            "touchstart" !== o.start ||
            !l.passiveListener ||
            !i.passiveListeners
          ) && { passive: !0, capture: !1 };
          s[p](o.start, e.onTouchStart, t),
            s[p](
              o.move,
              e.onTouchMove,
              l.passiveListener ? { passive: !1, capture: c } : c
            ),
            s[p](o.end, e.onTouchEnd, t),
            o.cancel && s[p](o.cancel, e.onTouchEnd, t);
        } else
          s[p](o.start, e.onTouchStart, !1),
            n[p](o.move, e.onTouchMove, c),
            n[p](o.end, e.onTouchEnd, !1);
        (i.preventClicks || i.preventClicksPropagation) &&
          s[p]("click", e.onClick, !0),
          i.cssMode && a[p]("scroll", e.onScroll),
          i.updateOnWindowResize
            ? e[f](
                u.ios || u.android
                  ? "resize orientationchange observerUpdate"
                  : "resize observerUpdate",
                D,
                !0
              )
            : e[f]("observerUpdate", D, !0);
      };
      var A = {
        attachEvents: function () {
          const e = this,
            t = (0, r.Me)(),
            { params: n, support: i } = e;
          (e.onTouchStart = g.bind(e)),
            (e.onTouchMove = y.bind(e)),
            (e.onTouchEnd = v.bind(e)),
            n.cssMode && (e.onScroll = E.bind(e)),
            (e.onClick = b.bind(e)),
            i.touch && !C && (t.addEventListener("touchstart", x), (C = !0)),
            w(e, "on");
        },
        detachEvents: function () {
          w(this, "off");
        },
      };
      const S = (e, t) => e.grid && t.grid && t.grid.rows > 1;
      var _ = {
          addClasses: function () {
            const e = this,
              {
                classNames: t,
                params: n,
                rtl: r,
                $el: i,
                device: o,
                support: s,
              } = e,
              a = (function (e, t) {
                const n = [];
                return (
                  e.forEach((e) => {
                    "object" == typeof e
                      ? Object.keys(e).forEach((r) => {
                          e[r] && n.push(t + r);
                        })
                      : "string" == typeof e && n.push(t + e);
                  }),
                  n
                );
              })(
                [
                  "initialized",
                  n.direction,
                  { "pointer-events": !s.touch },
                  { "free-mode": e.params.freeMode && n.freeMode.enabled },
                  { autoheight: n.autoHeight },
                  { rtl: r },
                  { grid: n.grid && n.grid.rows > 1 },
                  {
                    "grid-column":
                      n.grid && n.grid.rows > 1 && "column" === n.grid.fill,
                  },
                  { android: o.android },
                  { ios: o.ios },
                  { "css-mode": n.cssMode },
                  { centered: n.cssMode && n.centeredSlides },
                ],
                n.containerModifierClass
              );
            t.push(...a),
              i.addClass([...t].join(" ")),
              e.emitContainerClasses();
          },
          removeClasses: function () {
            const { $el: e, classNames: t } = this;
            e.removeClass(t.join(" ")), this.emitContainerClasses();
          },
        },
        T = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements:
            "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopFillGroupWithBlank: !1,
          loopPreventsSlide: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function F(e, t) {
        return function (n) {
          void 0 === n && (n = {});
          const r = Object.keys(n)[0],
            i = n[r];
          "object" == typeof i && null !== i
            ? (["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 &&
                !0 === e[r] &&
                (e[r] = { auto: !0 }),
              r in e && "enabled" in i
                ? (!0 === e[r] && (e[r] = { enabled: !0 }),
                  "object" != typeof e[r] ||
                    "enabled" in e[r] ||
                    (e[r].enabled = !0),
                  e[r] || (e[r] = { enabled: !1 }),
                  (0, o.l7)(t, n))
                : (0, o.l7)(t, n))
            : (0, o.l7)(t, n);
        };
      }
      const k = {
          eventsEmitter: c,
          update: p,
          translate: f,
          transition: {
            setTransition: function (e, t) {
              const n = this;
              n.params.cssMode || n.$wrapperEl.transition(e),
                n.emit("setTransition", e, t);
            },
            transitionStart: function (e, t) {
              void 0 === e && (e = !0);
              const n = this,
                { params: r } = n;
              r.cssMode ||
                (r.autoHeight && n.updateAutoHeight(),
                (0, d.Z)({
                  swiper: n,
                  runCallbacks: e,
                  direction: t,
                  step: "Start",
                }));
            },
            transitionEnd: function (e, t) {
              void 0 === e && (e = !0);
              const n = this,
                { params: r } = n;
              (n.animating = !1),
                r.cssMode ||
                  (n.setTransition(0),
                  (0, d.Z)({
                    swiper: n,
                    runCallbacks: e,
                    direction: t,
                    step: "End",
                  }));
            },
          },
          slide: h,
          loop: m,
          grabCursor: {
            setGrabCursor: function (e) {
              const t = this;
              if (
                t.support.touch ||
                !t.params.simulateTouch ||
                (t.params.watchOverflow && t.isLocked) ||
                t.params.cssMode
              )
                return;
              const n =
                "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
              (n.style.cursor = "move"),
                (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
                (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
                (n.style.cursor = e ? "grabbing" : "grab");
            },
            unsetGrabCursor: function () {
              const e = this;
              e.support.touch ||
                (e.params.watchOverflow && e.isLocked) ||
                e.params.cssMode ||
                (e[
                  "container" === e.params.touchEventsTarget
                    ? "el"
                    : "wrapperEl"
                ].style.cursor = "");
            },
          },
          events: A,
          breakpoints: {
            setBreakpoint: function () {
              const e = this,
                {
                  activeIndex: t,
                  initialized: n,
                  loopedSlides: r = 0,
                  params: i,
                  $el: s,
                } = e,
                a = i.breakpoints;
              if (!a || (a && 0 === Object.keys(a).length)) return;
              const u = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
              if (!u || e.currentBreakpoint === u) return;
              const l = (u in a ? a[u] : void 0) || e.originalParams,
                c = S(e, i),
                p = S(e, l),
                f = i.enabled;
              c && !p
                ? (s.removeClass(
                    `${i.containerModifierClass}grid ${i.containerModifierClass}grid-column`
                  ),
                  e.emitContainerClasses())
                : !c &&
                  p &&
                  (s.addClass(`${i.containerModifierClass}grid`),
                  ((l.grid.fill && "column" === l.grid.fill) ||
                    (!l.grid.fill && "column" === i.grid.fill)) &&
                    s.addClass(`${i.containerModifierClass}grid-column`),
                  e.emitContainerClasses());
              const d = l.direction && l.direction !== i.direction,
                h = i.loop && (l.slidesPerView !== i.slidesPerView || d);
              d && n && e.changeDirection(), (0, o.l7)(e.params, l);
              const m = e.params.enabled;
              Object.assign(e, {
                allowTouchMove: e.params.allowTouchMove,
                allowSlideNext: e.params.allowSlideNext,
                allowSlidePrev: e.params.allowSlidePrev,
              }),
                f && !m ? e.disable() : !f && m && e.enable(),
                (e.currentBreakpoint = u),
                e.emit("_beforeBreakpoint", l),
                h &&
                  n &&
                  (e.loopDestroy(),
                  e.loopCreate(),
                  e.updateSlides(),
                  e.slideTo(t - r + e.loopedSlides, 0, !1)),
                e.emit("breakpoint", l);
            },
            getBreakpoint: function (e, t, n) {
              if (
                (void 0 === t && (t = "window"),
                !e || ("container" === t && !n))
              )
                return;
              let i = !1;
              const o = (0, r.Jj)(),
                s = "window" === t ? o.innerHeight : n.clientHeight,
                a = Object.keys(e).map((e) => {
                  if ("string" == typeof e && 0 === e.indexOf("@")) {
                    const t = parseFloat(e.substr(1));
                    return { value: s * t, point: e };
                  }
                  return { value: e, point: e };
                });
              a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
              for (let e = 0; e < a.length; e += 1) {
                const { point: r, value: s } = a[e];
                "window" === t
                  ? o.matchMedia(`(min-width: ${s}px)`).matches && (i = r)
                  : s <= n.clientWidth && (i = r);
              }
              return i || "max";
            },
          },
          checkOverflow: {
            checkOverflow: function () {
              const e = this,
                { isLocked: t, params: n } = e,
                { slidesOffsetBefore: r } = n;
              if (r) {
                const t = e.slides.length - 1,
                  n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * r;
                e.isLocked = e.size > n;
              } else e.isLocked = 1 === e.snapGrid.length;
              !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                t && t !== e.isLocked && (e.isEnd = !1),
                t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
            },
          },
          classes: _,
          images: {
            loadImage: function (e, t, n, o, s, a) {
              const u = (0, r.Jj)();
              let l;
              function c() {
                a && a();
              }
              (0, i.Z)(e).parent("picture")[0] || (e.complete && s)
                ? c()
                : t
                ? ((l = new u.Image()),
                  (l.onload = c),
                  (l.onerror = c),
                  o && (l.sizes = o),
                  n && (l.srcset = n),
                  t && (l.src = t))
                : c();
            },
            preloadImages: function () {
              const e = this;
              function t() {
                null != e &&
                  e &&
                  !e.destroyed &&
                  (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length &&
                    (e.params.updateOnImagesReady && e.update(),
                    e.emit("imagesReady")));
              }
              e.imagesToLoad = e.$el.find("img");
              for (let n = 0; n < e.imagesToLoad.length; n += 1) {
                const r = e.imagesToLoad[n];
                e.loadImage(
                  r,
                  r.currentSrc || r.getAttribute("src"),
                  r.srcset || r.getAttribute("srcset"),
                  r.sizes || r.getAttribute("sizes"),
                  !0,
                  t
                );
              }
            },
          },
        },
        O = {};
      class B {
        constructor() {
          let e, t;
          for (var n = arguments.length, s = new Array(n), c = 0; c < n; c++)
            s[c] = arguments[c];
          if (
            (1 === s.length &&
            s[0].constructor &&
            "Object" === Object.prototype.toString.call(s[0]).slice(8, -1)
              ? (t = s[0])
              : ([e, t] = s),
            t || (t = {}),
            (t = (0, o.l7)({}, t)),
            e && !t.el && (t.el = e),
            t.el && (0, i.Z)(t.el).length > 1)
          ) {
            const e = [];
            return (
              (0, i.Z)(t.el).each((n) => {
                const r = (0, o.l7)({}, t, { el: n });
                e.push(new B(r));
              }),
              e
            );
          }
          const p = this;
          var f;
          (p.__swiper__ = !0),
            (p.support = l()),
            (p.device =
              (void 0 === (f = { userAgent: t.userAgent }) && (f = {}),
              a ||
                (a = (function (e) {
                  let { userAgent: t } = void 0 === e ? {} : e;
                  const n = l(),
                    i = (0, r.Jj)(),
                    o = i.navigator.platform,
                    s = t || i.navigator.userAgent,
                    a = { ios: !1, android: !1 },
                    u = i.screen.width,
                    c = i.screen.height,
                    p = s.match(/(Android);?[\s\/]+([\d.]+)?/);
                  let f = s.match(/(iPad).*OS\s([\d_]+)/);
                  const d = s.match(/(iPod)(.*OS\s([\d_]+))?/),
                    h = !f && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                    m = "Win32" === o;
                  let g = "MacIntel" === o;
                  return (
                    !f &&
                      g &&
                      n.touch &&
                      [
                        "1024x1366",
                        "1366x1024",
                        "834x1194",
                        "1194x834",
                        "834x1112",
                        "1112x834",
                        "768x1024",
                        "1024x768",
                        "820x1180",
                        "1180x820",
                        "810x1080",
                        "1080x810",
                      ].indexOf(`${u}x${c}`) >= 0 &&
                      ((f = s.match(/(Version)\/([\d.]+)/)),
                      f || (f = [0, 1, "13_0_0"]),
                      (g = !1)),
                    p && !m && ((a.os = "android"), (a.android = !0)),
                    (f || h || d) && ((a.os = "ios"), (a.ios = !0)),
                    a
                  );
                })(f)),
              a)),
            (p.browser =
              (u ||
                (u = (function () {
                  const e = (0, r.Jj)();
                  return {
                    isSafari: (function () {
                      const t = e.navigator.userAgent.toLowerCase();
                      return (
                        t.indexOf("safari") >= 0 &&
                        t.indexOf("chrome") < 0 &&
                        t.indexOf("android") < 0
                      );
                    })(),
                    isWebView:
                      /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                        e.navigator.userAgent
                      ),
                  };
                })()),
              u)),
            (p.eventsListeners = {}),
            (p.eventsAnyListeners = []),
            (p.modules = [...p.__modules__]),
            t.modules &&
              Array.isArray(t.modules) &&
              p.modules.push(...t.modules);
          const d = {};
          p.modules.forEach((e) => {
            e({
              swiper: p,
              extendParams: F(t, d),
              on: p.on.bind(p),
              once: p.once.bind(p),
              off: p.off.bind(p),
              emit: p.emit.bind(p),
            });
          });
          const h = (0, o.l7)({}, T, d);
          return (
            (p.params = (0, o.l7)({}, h, O, t)),
            (p.originalParams = (0, o.l7)({}, p.params)),
            (p.passedParams = (0, o.l7)({}, t)),
            p.params &&
              p.params.on &&
              Object.keys(p.params.on).forEach((e) => {
                p.on(e, p.params.on[e]);
              }),
            p.params && p.params.onAny && p.onAny(p.params.onAny),
            (p.$ = i.Z),
            Object.assign(p, {
              enabled: p.params.enabled,
              el: e,
              classNames: [],
              slides: (0, i.Z)(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: () => "horizontal" === p.params.direction,
              isVertical: () => "vertical" === p.params.direction,
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: p.params.allowSlideNext,
              allowSlidePrev: p.params.allowSlidePrev,
              touchEvents: (function () {
                const e = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel",
                  ],
                  t = ["pointerdown", "pointermove", "pointerup"];
                return (
                  (p.touchEventsTouch = {
                    start: e[0],
                    move: e[1],
                    end: e[2],
                    cancel: e[3],
                  }),
                  (p.touchEventsDesktop = {
                    start: t[0],
                    move: t[1],
                    end: t[2],
                  }),
                  p.support.touch || !p.params.simulateTouch
                    ? p.touchEventsTouch
                    : p.touchEventsDesktop
                );
              })(),
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: p.params.focusableElements,
                lastClickTime: (0, o.zO)(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0,
              },
              allowClick: !0,
              allowTouchMove: p.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            p.emit("_swiper"),
            p.params.init && p.init(),
            p
          );
        }
        enable() {
          const e = this;
          e.enabled ||
            ((e.enabled = !0),
            e.params.grabCursor && e.setGrabCursor(),
            e.emit("enable"));
        }
        disable() {
          const e = this;
          e.enabled &&
            ((e.enabled = !1),
            e.params.grabCursor && e.unsetGrabCursor(),
            e.emit("disable"));
        }
        setProgress(e, t) {
          const n = this;
          e = Math.min(Math.max(e, 0), 1);
          const r = n.minTranslate(),
            i = (n.maxTranslate() - r) * e + r;
          n.translateTo(i, void 0 === t ? 0 : t),
            n.updateActiveIndex(),
            n.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(" ")
            .filter(
              (t) =>
                0 === t.indexOf("swiper") ||
                0 === t.indexOf(e.params.containerModifierClass)
            );
          e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
          const t = this;
          return e.className
            .split(" ")
            .filter(
              (e) =>
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass)
            )
            .join(" ");
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.each((n) => {
            const r = e.getSlideClasses(n);
            t.push({ slideEl: n, classNames: r }), e.emit("_slideClass", n, r);
          }),
            e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e, t) {
          void 0 === e && (e = "current"), void 0 === t && (t = !1);
          const {
            params: n,
            slides: r,
            slidesGrid: i,
            slidesSizesGrid: o,
            size: s,
            activeIndex: a,
          } = this;
          let u = 1;
          if (n.centeredSlides) {
            let e,
              t = r[a].swiperSlideSize;
            for (let n = a + 1; n < r.length; n += 1)
              r[n] &&
                !e &&
                ((t += r[n].swiperSlideSize), (u += 1), t > s && (e = !0));
            for (let n = a - 1; n >= 0; n -= 1)
              r[n] &&
                !e &&
                ((t += r[n].swiperSlideSize), (u += 1), t > s && (e = !0));
          } else if ("current" === e)
            for (let e = a + 1; e < r.length; e += 1)
              (t ? i[e] + o[e] - i[a] < s : i[e] - i[a] < s) && (u += 1);
          else for (let e = a - 1; e >= 0; e -= 1) i[a] - i[e] < s && (u += 1);
          return u;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: n } = e;
          function r() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let i;
          n.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.params.freeMode && e.params.freeMode.enabled
              ? (r(), e.params.autoHeight && e.updateAutoHeight())
              : ((i =
                  ("auto" === e.params.slidesPerView ||
                    e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0)),
                i || r()),
            n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
        }
        changeDirection(e, t) {
          void 0 === t && (t = !0);
          const n = this,
            r = n.params.direction;
          return (
            e || (e = "horizontal" === r ? "vertical" : "horizontal"),
            e === r ||
              ("horizontal" !== e && "vertical" !== e) ||
              (n.$el
                .removeClass(`${n.params.containerModifierClass}${r}`)
                .addClass(`${n.params.containerModifierClass}${e}`),
              n.emitContainerClasses(),
              (n.params.direction = e),
              n.slides.each((t) => {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              n.emit("changeDirection"),
              t && n.update()),
            n
          );
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          const n = (0, i.Z)(e || t.params.el);
          if (!(e = n[0])) return !1;
          e.swiper = t;
          const o = () =>
            `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let s = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
              const t = (0, i.Z)(e.shadowRoot.querySelector(o()));
              return (t.children = (e) => n.children(e)), t;
            }
            return n.children(o());
          })();
          if (0 === s.length && t.params.createElements) {
            const e = (0, r.Me)().createElement("div");
            (s = (0, i.Z)(e)),
              (e.className = t.params.wrapperClass),
              n.append(e),
              n.children(`.${t.params.slideClass}`).each((e) => {
                s.append(e);
              });
          }
          return (
            Object.assign(t, {
              $el: n,
              el: e,
              $wrapperEl: s,
              wrapperEl: s[0],
              mounted: !0,
              rtl:
                "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
              rtlTranslate:
                "horizontal" === t.params.direction &&
                ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
              wrongRTL: "-webkit-box" === s.css("display"),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          return (
            t.initialized ||
              !1 === t.mount(e) ||
              (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(
                    t.params.initialSlide + t.loopedSlides,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  )
                : t.slideTo(
                    t.params.initialSlide,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  ),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }
        destroy(e, t) {
          void 0 === e && (e = !0), void 0 === t && (t = !0);
          const n = this,
            { params: r, $el: i, $wrapperEl: s, slides: a } = n;
          return (
            void 0 === n.params ||
              n.destroyed ||
              (n.emit("beforeDestroy"),
              (n.initialized = !1),
              n.detachEvents(),
              r.loop && n.loopDestroy(),
              t &&
                (n.removeClasses(),
                i.removeAttr("style"),
                s.removeAttr("style"),
                a &&
                  a.length &&
                  a
                    .removeClass(
                      [
                        r.slideVisibleClass,
                        r.slideActiveClass,
                        r.slideNextClass,
                        r.slidePrevClass,
                      ].join(" ")
                    )
                    .removeAttr("style")
                    .removeAttr("data-swiper-slide-index")),
              n.emit("destroy"),
              Object.keys(n.eventsListeners).forEach((e) => {
                n.off(e);
              }),
              !1 !== e && ((n.$el[0].swiper = null), (0, o.cP)(n)),
              (n.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          (0, o.l7)(O, e);
        }
        static get extendedDefaults() {
          return O;
        }
        static get defaults() {
          return T;
        }
        static installModule(e) {
          B.prototype.__modules__ || (B.prototype.__modules__ = []);
          const t = B.prototype.__modules__;
          "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e)
            ? (e.forEach((e) => B.installModule(e)), B)
            : (B.installModule(e), B);
        }
      }
      Object.keys(k).forEach((e) => {
        Object.keys(k[e]).forEach((t) => {
          B.prototype[t] = k[e][t];
        });
      }),
        B.use([
          function (e) {
            let { swiper: t, on: n, emit: i } = e;
            const o = (0, r.Jj)();
            let s = null,
              a = null;
            const u = () => {
                t &&
                  !t.destroyed &&
                  t.initialized &&
                  (i("beforeResize"), i("resize"));
              },
              l = () => {
                t && !t.destroyed && t.initialized && i("orientationchange");
              };
            n("init", () => {
              t.params.resizeObserver && void 0 !== o.ResizeObserver
                ? t &&
                  !t.destroyed &&
                  t.initialized &&
                  ((s = new ResizeObserver((e) => {
                    a = o.requestAnimationFrame(() => {
                      const { width: n, height: r } = t;
                      let i = n,
                        o = r;
                      e.forEach((e) => {
                        let {
                          contentBoxSize: n,
                          contentRect: r,
                          target: s,
                        } = e;
                        (s && s !== t.el) ||
                          ((i = r ? r.width : (n[0] || n).inlineSize),
                          (o = r ? r.height : (n[0] || n).blockSize));
                      }),
                        (i === n && o === r) || u();
                    });
                  })),
                  s.observe(t.el))
                : (o.addEventListener("resize", u),
                  o.addEventListener("orientationchange", l));
            }),
              n("destroy", () => {
                a && o.cancelAnimationFrame(a),
                  s && s.unobserve && t.el && (s.unobserve(t.el), (s = null)),
                  o.removeEventListener("resize", u),
                  o.removeEventListener("orientationchange", l);
              });
          },
          function (e) {
            let { swiper: t, extendParams: n, on: i, emit: o } = e;
            const s = [],
              a = (0, r.Jj)(),
              u = function (e, t) {
                void 0 === t && (t = {});
                const n = new (a.MutationObserver || a.WebkitMutationObserver)(
                  (e) => {
                    if (1 === e.length) return void o("observerUpdate", e[0]);
                    const t = function () {
                      o("observerUpdate", e[0]);
                    };
                    a.requestAnimationFrame
                      ? a.requestAnimationFrame(t)
                      : a.setTimeout(t, 0);
                  }
                );
                n.observe(e, {
                  attributes: void 0 === t.attributes || t.attributes,
                  childList: void 0 === t.childList || t.childList,
                  characterData: void 0 === t.characterData || t.characterData,
                }),
                  s.push(n);
              };
            n({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              i("init", () => {
                if (t.params.observer) {
                  if (t.params.observeParents) {
                    const e = t.$el.parents();
                    for (let t = 0; t < e.length; t += 1) u(e[t]);
                  }
                  u(t.$el[0], { childList: t.params.observeSlideChildren }),
                    u(t.$wrapperEl[0], { attributes: !1 });
                }
              }),
              i("destroy", () => {
                s.forEach((e) => {
                  e.disconnect();
                }),
                  s.splice(0, s.length);
              });
          },
        ]);
      var P = B;
    },
    3901: function (e, t, n) {
      "use strict";
      function r(e) {
        let { swiper: t, runCallbacks: n, direction: r, step: i } = e;
        const { activeIndex: o, previousIndex: s } = t;
        let a = r;
        if (
          (a || (a = o > s ? "next" : o < s ? "prev" : "reset"),
          t.emit(`transition${i}`),
          n && o !== s)
        ) {
          if ("reset" === a) return void t.emit(`slideResetTransition${i}`);
          t.emit(`slideChangeTransition${i}`),
            "next" === a
              ? t.emit(`slideNextTransition${i}`)
              : t.emit(`slidePrevTransition${i}`);
        }
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    2799: function (e, t, n) {
      "use strict";
      if (
        (n.d(t, {
          Z: function () {
            return o;
          },
        }),
        /^([15]37|381|570)$/.test(n.j))
      )
        var r = n(3370);
      var i = n(4625);
      function o(e) {
        let { swiper: t, extendParams: n, on: o } = e;
        n({
          a11y: {
            enabled: !0,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
          },
        });
        let s = null;
        function a(e) {
          const t = s;
          0 !== t.length && (t.html(""), t.html(e));
        }
        function u(e) {
          e.attr("tabIndex", "0");
        }
        function l(e) {
          e.attr("tabIndex", "-1");
        }
        function c(e, t) {
          e.attr("role", t);
        }
        function p(e, t) {
          e.attr("aria-roledescription", t);
        }
        function f(e, t) {
          e.attr("aria-label", t);
        }
        function d(e) {
          e.attr("aria-disabled", !0);
        }
        function h(e) {
          e.attr("aria-disabled", !1);
        }
        function m(e) {
          if (13 !== e.keyCode && 32 !== e.keyCode) return;
          const n = t.params.a11y,
            o = (0, i.Z)(e.target);
          t.navigation &&
            t.navigation.$nextEl &&
            o.is(t.navigation.$nextEl) &&
            ((t.isEnd && !t.params.loop) || t.slideNext(),
            t.isEnd ? a(n.lastSlideMessage) : a(n.nextSlideMessage)),
            t.navigation &&
              t.navigation.$prevEl &&
              o.is(t.navigation.$prevEl) &&
              ((t.isBeginning && !t.params.loop) || t.slidePrev(),
              t.isBeginning ? a(n.firstSlideMessage) : a(n.prevSlideMessage)),
            t.pagination &&
              o.is((0, r.Z)(t.params.pagination.bulletClass)) &&
              o[0].click();
        }
        function g() {
          return (
            t.pagination && t.pagination.bullets && t.pagination.bullets.length
          );
        }
        function y() {
          return g() && t.params.pagination.clickable;
        }
        const v = (e, t, n) => {
            u(e),
              "BUTTON" !== e[0].tagName && (c(e, "button"), e.on("keydown", m)),
              f(e, n),
              (function (e, t) {
                e.attr("aria-controls", t);
              })(e, t);
          },
          D = (e) => {
            const n = e.target.closest(`.${t.params.slideClass}`);
            if (!n || !t.slides.includes(n)) return;
            const r = t.slides.indexOf(n) === t.activeIndex,
              i =
                t.params.watchSlidesProgress &&
                t.visibleSlides &&
                t.visibleSlides.includes(n);
            r || i || t.slideTo(t.slides.indexOf(n), 0);
          };
        o("beforeInit", () => {
          s = (0, i.Z)(
            `<span class="${t.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`
          );
        }),
          o("afterInit", () => {
            t.params.a11y.enabled &&
              (function () {
                const e = t.params.a11y;
                t.$el.append(s);
                const n = t.$el;
                e.containerRoleDescriptionMessage &&
                  p(n, e.containerRoleDescriptionMessage),
                  e.containerMessage && f(n, e.containerMessage);
                const o = t.$wrapperEl,
                  a =
                    o.attr("id") ||
                    `swiper-wrapper-${
                      ((u = 16),
                      void 0 === u && (u = 16),
                      "x"
                        .repeat(u)
                        .replace(/x/g, () =>
                          Math.round(16 * Math.random()).toString(16)
                        ))
                    }`;
                var u;
                const l =
                  t.params.autoplay && t.params.autoplay.enabled
                    ? "off"
                    : "polite";
                var d;
                (d = a),
                  o.attr("id", d),
                  (function (e, t) {
                    e.attr("aria-live", t);
                  })(o, l),
                  e.itemRoleDescriptionMessage &&
                    p((0, i.Z)(t.slides), e.itemRoleDescriptionMessage),
                  c((0, i.Z)(t.slides), e.slideRole);
                const h = t.params.loop
                  ? t.slides.filter(
                      (e) => !e.classList.contains(t.params.slideDuplicateClass)
                    ).length
                  : t.slides.length;
                let g, b;
                t.slides.each((n, r) => {
                  const o = (0, i.Z)(n),
                    s = t.params.loop
                      ? parseInt(o.attr("data-swiper-slide-index"), 10)
                      : r;
                  f(
                    o,
                    ((o.attr("data-label") == "") ? "" : o.attr("data-label") || e.slideLabelMessage
                      .replace(/\{\{index\}\}/, s + 1)
                      .replace(/\{\{slidesLength\}\}/, h))
                  );
                }),
                  t.navigation &&
                    t.navigation.$nextEl &&
                    (g = t.navigation.$nextEl),
                  t.navigation &&
                    t.navigation.$prevEl &&
                    (b = t.navigation.$prevEl),
                  g && g.length && v(g, a, e.nextSlideMessage),
                  b && b.length && v(b, a, e.prevSlideMessage),
                  y() &&
                    t.pagination.$el.on(
                      "keydown",
                      (0, r.Z)(t.params.pagination.bulletClass),
                      m
                    ),
                  t.$el.on("focus", D, !0);
              })();
          }),
          o("fromEdge toEdge afterInit lock unlock", () => {
            t.params.a11y.enabled &&
              (function () {
                if (t.params.loop || t.params.rewind || !t.navigation) return;
                const { $nextEl: e, $prevEl: n } = t.navigation;
                n &&
                  n.length > 0 &&
                  (t.isBeginning ? (d(n), l(n)) : (h(n), u(n))),
                  e && e.length > 0 && (t.isEnd ? (d(e), l(e)) : (h(e), u(e)));
              })();
          }),
          o("paginationUpdate", () => {
            t.params.a11y.enabled &&
              (function () {
                const e = t.params.a11y;
                g() &&
                  t.pagination.bullets.each((n) => {
                    const r = (0, i.Z)(n);
                    t.params.pagination.clickable &&
                      (u(r),
                      t.params.pagination.renderBullet ||
                        (c(r, "button"),
                        f(
                          r,
                          e.paginationBulletMessage.replace(
                            /\{\{index\}\}/,
                            r.index() + 1
                          )
                        ))),
                      r.is(`.${t.params.pagination.bulletActiveClass}`)
                        ? r.attr("aria-current", "true")
                        : r.removeAttr("aria-current");
                  });
              })();
          }),
          o("destroy", () => {
            t.params.a11y.enabled &&
              (function () {
                let e, n;
                s && s.length > 0 && s.remove(),
                  t.navigation &&
                    t.navigation.$nextEl &&
                    (e = t.navigation.$nextEl),
                  t.navigation &&
                    t.navigation.$prevEl &&
                    (n = t.navigation.$prevEl),
                  e && e.off("keydown", m),
                  n && n.off("keydown", m),
                  y() &&
                    t.pagination.$el.off(
                      "keydown",
                      (0, r.Z)(t.params.pagination.bulletClass),
                      m
                    ),
                  t.$el.off("focus", D, !0);
              })();
          });
      }
    },
    9127: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(7628),
        i = n(9482);
      function o(e) {
        let t,
          { swiper: n, extendParams: o, on: s, emit: a } = e;
        function u() {
          const e = n.slides.eq(n.activeIndex);
          let r = n.params.autoplay.delay;
          e.attr("data-swiper-autoplay") &&
            (r = e.attr("data-swiper-autoplay") || n.params.autoplay.delay),
            clearTimeout(t),
            (t = (0, i.Y3)(() => {
              let e;
              n.params.autoplay.reverseDirection
                ? n.params.loop
                  ? (n.loopFix(),
                    (e = n.slidePrev(n.params.speed, !0, !0)),
                    a("autoplay"))
                  : n.isBeginning
                  ? n.params.autoplay.stopOnLastSlide
                    ? c()
                    : ((e = n.slideTo(
                        n.slides.length - 1,
                        n.params.speed,
                        !0,
                        !0
                      )),
                      a("autoplay"))
                  : ((e = n.slidePrev(n.params.speed, !0, !0)), a("autoplay"))
                : n.params.loop
                ? (n.loopFix(),
                  (e = n.slideNext(n.params.speed, !0, !0)),
                  a("autoplay"))
                : n.isEnd
                ? n.params.autoplay.stopOnLastSlide
                  ? c()
                  : ((e = n.slideTo(0, n.params.speed, !0, !0)), a("autoplay"))
                : ((e = n.slideNext(n.params.speed, !0, !0)), a("autoplay")),
                ((n.params.cssMode && n.autoplay.running) || !1 === e) && u();
            }, r));
        }
        function l() {
          return (
            void 0 === t &&
            !n.autoplay.running &&
            ((n.autoplay.running = !0), a("autoplayStart"), u(), !0)
          );
        }
        function c() {
          return (
            !!n.autoplay.running &&
            void 0 !== t &&
            (t && (clearTimeout(t), (t = void 0)),
            (n.autoplay.running = !1),
            a("autoplayStop"),
            !0)
          );
        }
        function p(e) {
          n.autoplay.running &&
            (n.autoplay.paused ||
              (t && clearTimeout(t),
              (n.autoplay.paused = !0),
              0 !== e && n.params.autoplay.waitForTransition
                ? ["transitionend", "webkitTransitionEnd"].forEach((e) => {
                    n.$wrapperEl[0].addEventListener(e, d);
                  })
                : ((n.autoplay.paused = !1), u())));
        }
        function f() {
          const e = (0, r.Me)();
          "hidden" === e.visibilityState && n.autoplay.running && p(),
            "visible" === e.visibilityState &&
              n.autoplay.paused &&
              (u(), (n.autoplay.paused = !1));
        }
        function d(e) {
          n &&
            !n.destroyed &&
            n.$wrapperEl &&
            e.target === n.$wrapperEl[0] &&
            (["transitionend", "webkitTransitionEnd"].forEach((e) => {
              n.$wrapperEl[0].removeEventListener(e, d);
            }),
            (n.autoplay.paused = !1),
            n.autoplay.running ? u() : c());
        }
        function h() {
          n.params.autoplay.disableOnInteraction
            ? c()
            : (a("autoplayPause"), p()),
            ["transitionend", "webkitTransitionEnd"].forEach((e) => {
              n.$wrapperEl[0].removeEventListener(e, d);
            });
        }
        function m() {
          n.params.autoplay.disableOnInteraction ||
            ((n.autoplay.paused = !1), a("autoplayResume"), u());
        }
        (n.autoplay = { running: !1, paused: !1 }),
          o({
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
              pauseOnMouseEnter: !1,
            },
          }),
          s("init", () => {
            n.params.autoplay.enabled &&
              (l(),
              (0, r.Me)().addEventListener("visibilitychange", f),
              n.params.autoplay.pauseOnMouseEnter &&
                (n.$el.on("mouseenter", h), n.$el.on("mouseleave", m)));
          }),
          s("beforeTransitionStart", (e, t, r) => {
            n.autoplay.running &&
              (r || !n.params.autoplay.disableOnInteraction
                ? n.autoplay.pause(t)
                : c());
          }),
          s("sliderFirstMove", () => {
            n.autoplay.running &&
              (n.params.autoplay.disableOnInteraction ? c() : p());
          }),
          s("touchEnd", () => {
            n.params.cssMode &&
              n.autoplay.paused &&
              !n.params.autoplay.disableOnInteraction &&
              u();
          }),
          s("destroy", () => {
            n.$el.off("mouseenter", h),
              n.$el.off("mouseleave", m),
              n.autoplay.running && c(),
              (0, r.Me)().removeEventListener("visibilitychange", f);
          }),
          Object.assign(n.autoplay, { pause: p, run: u, start: l, stop: c });
      }
    },
    7031: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return i;
        },
      });
      var r = n(9482);
      function i(e) {
        let { swiper: t, extendParams: n, on: i } = e;
        function o(e, t) {
          const n = (function () {
            let e, t, n;
            return (r, i) => {
              for (t = -1, e = r.length; e - t > 1; )
                (n = (e + t) >> 1), r[n] <= i ? (t = n) : (e = n);
              return e;
            };
          })();
          let r, i;
          return (
            (this.x = e),
            (this.y = t),
            (this.lastIndex = e.length - 1),
            (this.interpolate = function (e) {
              return e
                ? ((i = n(this.x, e)),
                  (r = i - 1),
                  ((e - this.x[r]) * (this.y[i] - this.y[r])) /
                    (this.x[i] - this.x[r]) +
                    this.y[r])
                : 0;
            }),
            this
          );
        }
        function s() {
          t.controller.control &&
            t.controller.spline &&
            ((t.controller.spline = void 0), delete t.controller.spline);
        }
        n({ controller: { control: void 0, inverse: !1, by: "slide" } }),
          (t.controller = { control: void 0 }),
          i("beforeInit", () => {
            t.controller.control = t.params.controller.control;
          }),
          i("update", () => {
            s();
          }),
          i("resize", () => {
            s();
          }),
          i("observerUpdate", () => {
            s();
          }),
          i("setTranslate", (e, n, r) => {
            t.controller.control && t.controller.setTranslate(n, r);
          }),
          i("setTransition", (e, n, r) => {
            t.controller.control && t.controller.setTransition(n, r);
          }),
          Object.assign(t.controller, {
            setTranslate: function (e, n) {
              const r = t.controller.control;
              let i, s;
              const a = t.constructor;
              function u(e) {
                const n = t.rtlTranslate ? -t.translate : t.translate;
                "slide" === t.params.controller.by &&
                  ((function (e) {
                    t.controller.spline ||
                      (t.controller.spline = t.params.loop
                        ? new o(t.slidesGrid, e.slidesGrid)
                        : new o(t.snapGrid, e.snapGrid));
                  })(e),
                  (s = -t.controller.spline.interpolate(-n))),
                  (s && "container" !== t.params.controller.by) ||
                    ((i =
                      (e.maxTranslate() - e.minTranslate()) /
                      (t.maxTranslate() - t.minTranslate())),
                    (s = (n - t.minTranslate()) * i + e.minTranslate())),
                  t.params.controller.inverse && (s = e.maxTranslate() - s),
                  e.updateProgress(s),
                  e.setTranslate(s, t),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses();
              }
              if (Array.isArray(r))
                for (let e = 0; e < r.length; e += 1)
                  r[e] !== n && r[e] instanceof a && u(r[e]);
              else r instanceof a && n !== r && u(r);
            },
            setTransition: function (e, n) {
              const i = t.constructor,
                o = t.controller.control;
              let s;
              function a(n) {
                n.setTransition(e, t),
                  0 !== e &&
                    (n.transitionStart(),
                    n.params.autoHeight &&
                      (0, r.Y3)(() => {
                        n.updateAutoHeight();
                      }),
                    n.$wrapperEl.transitionEnd(() => {
                      o &&
                        (n.params.loop &&
                          "slide" === t.params.controller.by &&
                          n.loopFix(),
                        n.transitionEnd());
                    }));
              }
              if (Array.isArray(o))
                for (s = 0; s < o.length; s += 1)
                  o[s] !== n && o[s] instanceof i && a(o[s]);
              else o instanceof i && n !== o && a(o);
            },
          });
      }
    },
    980: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return a;
        },
      });
      var r = n(9096);
      if (/^([15]37|381|570)$/.test(n.j)) var i = n(5653);
      if (/^([15]37|381|570)$/.test(n.j)) var o = n(5302);
      if (/^([15]37|381|570)$/.test(n.j)) var s = n(1166);
      function a(e) {
        let { swiper: t, extendParams: n, on: a } = e;
        n({ cardsEffect: { slideShadows: !0, transformEl: null } }),
          (0, i.Z)({
            effect: "cards",
            swiper: t,
            on: a,
            setTranslate: () => {
              const { slides: e, activeIndex: n } = t,
                i = t.params.cardsEffect,
                { startTranslate: s, isTouched: a } = t.touchEventsData,
                u = t.translate;
              for (let l = 0; l < e.length; l += 1) {
                const c = e.eq(l),
                  p = c[0].progress,
                  f = Math.min(Math.max(p, -4), 4);
                let d = c[0].swiperSlideOffset;
                t.params.centeredSlides &&
                  !t.params.cssMode &&
                  t.$wrapperEl.transform(`translateX(${t.minTranslate()}px)`),
                  t.params.centeredSlides &&
                    t.params.cssMode &&
                    (d -= e[0].swiperSlideOffset);
                let h = t.params.cssMode ? -d - t.translate : -d,
                  m = 0;
                const g = -100 * Math.abs(f);
                let y = 1,
                  v = -2 * f,
                  D = 8 - 0.75 * Math.abs(f);
                const b =
                    (l === n || l === n - 1) &&
                    f > 0 &&
                    f < 1 &&
                    (a || t.params.cssMode) &&
                    u < s,
                  E =
                    (l === n || l === n + 1) &&
                    f < 0 &&
                    f > -1 &&
                    (a || t.params.cssMode) &&
                    u > s;
                if (b || E) {
                  const e = (1 - Math.abs((Math.abs(f) - 0.5) / 0.5)) ** 0.5;
                  (v += -28 * f * e),
                    (y += -0.5 * e),
                    (D += 96 * e),
                    (m = -25 * e * Math.abs(f) + "%");
                }
                if (
                  ((h =
                    f < 0
                      ? `calc(${h}px + (${D * Math.abs(f)}%))`
                      : f > 0
                      ? `calc(${h}px + (-${D * Math.abs(f)}%))`
                      : `${h}px`),
                  !t.isHorizontal())
                ) {
                  const e = m;
                  (m = h), (h = e);
                }
                const C = `\n        translate3d(${h}, ${m}, ${g}px)\n        rotateZ(${v}deg)\n        scale(${
                  f < 0 ? "" + (1 + (1 - y) * f) : "" + (1 - (1 - y) * f)
                })\n      `;
                if (i.slideShadows) {
                  let e = c.find(".swiper-slide-shadow");
                  0 === e.length && (e = (0, r.Z)(i, c)),
                    e.length &&
                      (e[0].style.opacity = Math.min(
                        Math.max((Math.abs(f) - 0.5) / 0.5, 0),
                        1
                      ));
                }
                (c[0].style.zIndex = -Math.abs(Math.round(p)) + e.length),
                  (0, o.Z)(i, c).transform(C);
              }
            },
            setTransition: (e) => {
              const { transformEl: n } = t.params.cardsEffect;
              (n ? t.slides.find(n) : t.slides)
                .transition(e)
                .find(".swiper-slide-shadow")
                .transition(e),
                (0, s.Z)({ swiper: t, duration: e, transformEl: n });
            },
            perspective: () => !0,
            overwriteParams: () => ({
              watchSlidesProgress: !0,
              virtualTranslate: !t.params.cssMode,
            }),
          });
      }
    },
    3007: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return s;
        },
      });
      var r = n(9096);
      if (/^([15]37|381|570)$/.test(n.j)) var i = n(5653);
      if (/^([15]37|381|570)$/.test(n.j)) var o = n(5302);
      function s(e) {
        let { swiper: t, extendParams: n, on: s } = e;
        n({
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: !0,
            transformEl: null,
          },
        }),
          (0, i.Z)({
            effect: "coverflow",
            swiper: t,
            on: s,
            setTranslate: () => {
              const { width: e, height: n, slides: i, slidesSizesGrid: s } = t,
                a = t.params.coverflowEffect,
                u = t.isHorizontal(),
                l = t.translate,
                c = u ? e / 2 - l : n / 2 - l,
                p = u ? a.rotate : -a.rotate,
                f = a.depth;
              for (let e = 0, t = i.length; e < t; e += 1) {
                const t = i.eq(e),
                  n = s[e],
                  l = ((c - t[0].swiperSlideOffset - n / 2) / n) * a.modifier;
                let d = u ? p * l : 0,
                  h = u ? 0 : p * l,
                  m = -f * Math.abs(l),
                  g = a.stretch;
                "string" == typeof g &&
                  -1 !== g.indexOf("%") &&
                  (g = (parseFloat(a.stretch) / 100) * n);
                let y = u ? 0 : g * l,
                  v = u ? g * l : 0,
                  D = 1 - (1 - a.scale) * Math.abs(l);
                Math.abs(v) < 0.001 && (v = 0),
                  Math.abs(y) < 0.001 && (y = 0),
                  Math.abs(m) < 0.001 && (m = 0),
                  Math.abs(d) < 0.001 && (d = 0),
                  Math.abs(h) < 0.001 && (h = 0),
                  Math.abs(D) < 0.001 && (D = 0);
                const b = `translate3d(${v}px,${y}px,${m}px)  rotateX(${h}deg) rotateY(${d}deg) scale(${D})`;
                if (
                  ((0, o.Z)(a, t).transform(b),
                  (t[0].style.zIndex = 1 - Math.abs(Math.round(l))),
                  a.slideShadows)
                ) {
                  let e = u
                      ? t.find(".swiper-slide-shadow-left")
                      : t.find(".swiper-slide-shadow-top"),
                    n = u
                      ? t.find(".swiper-slide-shadow-right")
                      : t.find(".swiper-slide-shadow-bottom");
                  0 === e.length && (e = (0, r.Z)(a, t, u ? "left" : "top")),
                    0 === n.length &&
                      (n = (0, r.Z)(a, t, u ? "right" : "bottom")),
                    e.length && (e[0].style.opacity = l > 0 ? l : 0),
                    n.length && (n[0].style.opacity = -l > 0 ? -l : 0);
                }
              }
            },
            setTransition: (e) => {
              const { transformEl: n } = t.params.coverflowEffect;
              (n ? t.slides.find(n) : t.slides)
                .transition(e)
                .find(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .transition(e);
            },
            perspective: () => !0,
            overwriteParams: () => ({ watchSlidesProgress: !0 }),
          });
      }
    },
    6100: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return a;
        },
      });
      var r = n(9096);
      if (/^([15]37|381|570)$/.test(n.j)) var i = n(5653);
      if (/^([15]37|381|570)$/.test(n.j)) var o = n(5302);
      if (/^([15]37|381|570)$/.test(n.j)) var s = n(1166);
      function a(e) {
        let { swiper: t, extendParams: n, on: a } = e;
        n({
          creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: !1,
            progressMultiplier: 1,
            perspective: !0,
            prev: {
              translate: [0, 0, 0],
              rotate: [0, 0, 0],
              opacity: 1,
              scale: 1,
            },
            next: {
              translate: [0, 0, 0],
              rotate: [0, 0, 0],
              opacity: 1,
              scale: 1,
            },
          },
        });
        const u = (e) => ("string" == typeof e ? e : `${e}px`);
        (0, i.Z)({
          effect: "creative",
          swiper: t,
          on: a,
          setTranslate: () => {
            const { slides: e, $wrapperEl: n, slidesSizesGrid: i } = t,
              s = t.params.creativeEffect,
              { progressMultiplier: a } = s,
              l = t.params.centeredSlides;
            if (l) {
              const e = i[0] / 2 - t.params.slidesOffsetBefore || 0;
              n.transform(`translateX(calc(50% - ${e}px))`);
            }
            for (let n = 0; n < e.length; n += 1) {
              const i = e.eq(n),
                c = i[0].progress,
                p = Math.min(
                  Math.max(i[0].progress, -s.limitProgress),
                  s.limitProgress
                );
              let f = p;
              l ||
                (f = Math.min(
                  Math.max(i[0].originalProgress, -s.limitProgress),
                  s.limitProgress
                ));
              const d = i[0].swiperSlideOffset,
                h = [t.params.cssMode ? -d - t.translate : -d, 0, 0],
                m = [0, 0, 0];
              let g = !1;
              t.isHorizontal() || ((h[1] = h[0]), (h[0] = 0));
              let y = {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                scale: 1,
                opacity: 1,
              };
              p < 0
                ? ((y = s.next), (g = !0))
                : p > 0 && ((y = s.prev), (g = !0)),
                h.forEach((e, t) => {
                  h[t] = `calc(${e}px + (${u(y.translate[t])} * ${Math.abs(
                    p * a
                  )}))`;
                }),
                m.forEach((e, t) => {
                  m[t] = y.rotate[t] * Math.abs(p * a);
                }),
                (i[0].style.zIndex = -Math.abs(Math.round(c)) + e.length);
              const v = h.join(", "),
                D = `rotateX(${m[0]}deg) rotateY(${m[1]}deg) rotateZ(${m[2]}deg)`,
                b =
                  f < 0
                    ? `scale(${1 + (1 - y.scale) * f * a})`
                    : `scale(${1 - (1 - y.scale) * f * a})`,
                E =
                  f < 0
                    ? 1 + (1 - y.opacity) * f * a
                    : 1 - (1 - y.opacity) * f * a,
                C = `translate3d(${v}) ${D} ${b}`;
              if ((g && y.shadow) || !g) {
                let e = i.children(".swiper-slide-shadow");
                if (
                  (0 === e.length && y.shadow && (e = (0, r.Z)(s, i)), e.length)
                ) {
                  const t = s.shadowPerProgress ? p * (1 / s.limitProgress) : p;
                  e[0].style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                }
              }
              const x = (0, o.Z)(s, i);
              x.transform(C).css({ opacity: E }),
                y.origin && x.css("transform-origin", y.origin);
            }
          },
          setTransition: (e) => {
            const { transformEl: n } = t.params.creativeEffect;
            (n ? t.slides.find(n) : t.slides)
              .transition(e)
              .find(".swiper-slide-shadow")
              .transition(e),
              (0, s.Z)({
                swiper: t,
                duration: e,
                transformEl: n,
                allSlides: !0,
              });
          },
          perspective: () => t.params.creativeEffect.perspective,
          overwriteParams: () => ({
            watchSlidesProgress: !0,
            virtualTranslate: !t.params.cssMode,
          }),
        });
      }
    },
    4278: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(4625);
      if (/^([15]37|381|570)$/.test(n.j)) var i = n(5653);
      function o(e) {
        let { swiper: t, extendParams: n, on: o } = e;
        n({
          cubeEffect: {
            slideShadows: !0,
            shadow: !0,
            shadowOffset: 20,
            shadowScale: 0.94,
          },
        }),
          (0, i.Z)({
            effect: "cube",
            swiper: t,
            on: o,
            setTranslate: () => {
              const {
                  $el: e,
                  $wrapperEl: n,
                  slides: i,
                  width: o,
                  height: s,
                  rtlTranslate: a,
                  size: u,
                  browser: l,
                } = t,
                c = t.params.cubeEffect,
                p = t.isHorizontal(),
                f = t.virtual && t.params.virtual.enabled;
              let d,
                h = 0;
              c.shadow &&
                (p
                  ? ((d = n.find(".swiper-cube-shadow")),
                    0 === d.length &&
                      ((d = (0, r.Z)('<div class="swiper-cube-shadow"></div>')),
                      n.append(d)),
                    d.css({ height: `${o}px` }))
                  : ((d = e.find(".swiper-cube-shadow")),
                    0 === d.length &&
                      ((d = (0, r.Z)('<div class="swiper-cube-shadow"></div>')),
                      e.append(d))));
              for (let e = 0; e < i.length; e += 1) {
                const t = i.eq(e);
                let n = e;
                f && (n = parseInt(t.attr("data-swiper-slide-index"), 10));
                let o = 90 * n,
                  s = Math.floor(o / 360);
                a && ((o = -o), (s = Math.floor(-o / 360)));
                const l = Math.max(Math.min(t[0].progress, 1), -1);
                let d = 0,
                  m = 0,
                  g = 0;
                n % 4 == 0
                  ? ((d = 4 * -s * u), (g = 0))
                  : (n - 1) % 4 == 0
                  ? ((d = 0), (g = 4 * -s * u))
                  : (n - 2) % 4 == 0
                  ? ((d = u + 4 * s * u), (g = u))
                  : (n - 3) % 4 == 0 && ((d = -u), (g = 3 * u + 4 * u * s)),
                  a && (d = -d),
                  p || ((m = d), (d = 0));
                const y = `rotateX(${p ? 0 : -o}deg) rotateY(${
                  p ? o : 0
                }deg) translate3d(${d}px, ${m}px, ${g}px)`;
                if (
                  (l <= 1 &&
                    l > -1 &&
                    ((h = 90 * n + 90 * l), a && (h = 90 * -n - 90 * l)),
                  t.transform(y),
                  c.slideShadows)
                ) {
                  let e = p
                      ? t.find(".swiper-slide-shadow-left")
                      : t.find(".swiper-slide-shadow-top"),
                    n = p
                      ? t.find(".swiper-slide-shadow-right")
                      : t.find(".swiper-slide-shadow-bottom");
                  0 === e.length &&
                    ((e = (0, r.Z)(
                      `<div class="swiper-slide-shadow-${
                        p ? "left" : "top"
                      }"></div>`
                    )),
                    t.append(e)),
                    0 === n.length &&
                      ((n = (0, r.Z)(
                        `<div class="swiper-slide-shadow-${
                          p ? "right" : "bottom"
                        }"></div>`
                      )),
                      t.append(n)),
                    e.length && (e[0].style.opacity = Math.max(-l, 0)),
                    n.length && (n[0].style.opacity = Math.max(l, 0));
                }
              }
              if (
                (n.css({
                  "-webkit-transform-origin": `50% 50% -${u / 2}px`,
                  "transform-origin": `50% 50% -${u / 2}px`,
                }),
                c.shadow)
              )
                if (p)
                  d.transform(
                    `translate3d(0px, ${o / 2 + c.shadowOffset}px, ${
                      -o / 2
                    }px) rotateX(90deg) rotateZ(0deg) scale(${c.shadowScale})`
                  );
                else {
                  const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                    t =
                      1.5 -
                      (Math.sin((2 * e * Math.PI) / 360) / 2 +
                        Math.cos((2 * e * Math.PI) / 360) / 2),
                    n = c.shadowScale,
                    r = c.shadowScale / t,
                    i = c.shadowOffset;
                  d.transform(
                    `scale3d(${n}, 1, ${r}) translate3d(0px, ${s / 2 + i}px, ${
                      -s / 2 / r
                    }px) rotateX(-90deg)`
                  );
                }
              const m = l.isSafari || l.isWebView ? -u / 2 : 0;
              n.transform(
                `translate3d(0px,0,${m}px) rotateX(${
                  t.isHorizontal() ? 0 : h
                }deg) rotateY(${t.isHorizontal() ? -h : 0}deg)`
              );
            },
            setTransition: (e) => {
              const { $el: n, slides: r } = t;
              r
                .transition(e)
                .find(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .transition(e),
                t.params.cubeEffect.shadow &&
                  !t.isHorizontal() &&
                  n.find(".swiper-cube-shadow").transition(e);
            },
            perspective: () => !0,
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              resistanceRatio: 0,
              spaceBetween: 0,
              centeredSlides: !1,
              virtualTranslate: !0,
            }),
          });
      }
    },
    2708: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return a;
        },
      });
      var r = n(9096);
      if (/^([15]37|381|570)$/.test(n.j)) var i = n(5653);
      if (/^([15]37|381|570)$/.test(n.j)) var o = n(5302);
      if (/^([15]37|381|570)$/.test(n.j)) var s = n(1166);
      function a(e) {
        let { swiper: t, extendParams: n, on: a } = e;
        n({
          flipEffect: {
            slideShadows: !0,
            limitRotation: !0,
            transformEl: null,
          },
        }),
          (0, i.Z)({
            effect: "flip",
            swiper: t,
            on: a,
            setTranslate: () => {
              const { slides: e, rtlTranslate: n } = t,
                i = t.params.flipEffect;
              for (let s = 0; s < e.length; s += 1) {
                const a = e.eq(s);
                let u = a[0].progress;
                t.params.flipEffect.limitRotation &&
                  (u = Math.max(Math.min(a[0].progress, 1), -1));
                const l = a[0].swiperSlideOffset;
                let c = -180 * u,
                  p = 0,
                  f = t.params.cssMode ? -l - t.translate : -l,
                  d = 0;
                if (
                  (t.isHorizontal()
                    ? n && (c = -c)
                    : ((d = f), (f = 0), (p = -c), (c = 0)),
                  (a[0].style.zIndex = -Math.abs(Math.round(u)) + e.length),
                  i.slideShadows)
                ) {
                  let e = t.isHorizontal()
                      ? a.find(".swiper-slide-shadow-left")
                      : a.find(".swiper-slide-shadow-top"),
                    n = t.isHorizontal()
                      ? a.find(".swiper-slide-shadow-right")
                      : a.find(".swiper-slide-shadow-bottom");
                  0 === e.length &&
                    (e = (0, r.Z)(i, a, t.isHorizontal() ? "left" : "top")),
                    0 === n.length &&
                      (n = (0, r.Z)(
                        i,
                        a,
                        t.isHorizontal() ? "right" : "bottom"
                      )),
                    e.length && (e[0].style.opacity = Math.max(-u, 0)),
                    n.length && (n[0].style.opacity = Math.max(u, 0));
                }
                const h = `translate3d(${f}px, ${d}px, 0px) rotateX(${p}deg) rotateY(${c}deg)`;
                (0, o.Z)(i, a).transform(h);
              }
            },
            setTransition: (e) => {
              const { transformEl: n } = t.params.flipEffect;
              (n ? t.slides.find(n) : t.slides)
                .transition(e)
                .find(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .transition(e),
                (0, s.Z)({ swiper: t, duration: e, transformEl: n });
            },
            perspective: () => !0,
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              spaceBetween: 0,
              virtualTranslate: !t.params.cssMode,
            }),
          });
      }
    },
    4806: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return i;
        },
      });
      var r = n(9482);
      function i(e) {
        let { swiper: t, extendParams: n, emit: i, once: o } = e;
        n({
          freeMode: {
            enabled: !1,
            momentum: !0,
            momentumRatio: 1,
            momentumBounce: !0,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: !1,
            minimumVelocity: 0.02,
          },
        }),
          Object.assign(t, {
            freeMode: {
              onTouchStart: function () {
                const e = t.getTranslate();
                t.setTranslate(e),
                  t.setTransition(0),
                  (t.touchEventsData.velocities.length = 0),
                  t.freeMode.onTouchEnd({
                    currentPos: t.rtl ? t.translate : -t.translate,
                  });
              },
              onTouchMove: function () {
                const { touchEventsData: e, touches: n } = t;
                0 === e.velocities.length &&
                  e.velocities.push({
                    position: n[t.isHorizontal() ? "startX" : "startY"],
                    time: e.touchStartTime,
                  }),
                  e.velocities.push({
                    position: n[t.isHorizontal() ? "currentX" : "currentY"],
                    time: (0, r.zO)(),
                  });
              },
              onTouchEnd: function (e) {
                let { currentPos: n } = e;
                const {
                    params: s,
                    $wrapperEl: a,
                    rtlTranslate: u,
                    snapGrid: l,
                    touchEventsData: c,
                  } = t,
                  p = (0, r.zO)() - c.touchStartTime;
                if (n < -t.minTranslate()) t.slideTo(t.activeIndex);
                else if (n > -t.maxTranslate())
                  t.slides.length < l.length
                    ? t.slideTo(l.length - 1)
                    : t.slideTo(t.slides.length - 1);
                else {
                  if (s.freeMode.momentum) {
                    if (c.velocities.length > 1) {
                      const e = c.velocities.pop(),
                        n = c.velocities.pop(),
                        i = e.position - n.position,
                        o = e.time - n.time;
                      (t.velocity = i / o),
                        (t.velocity /= 2),
                        Math.abs(t.velocity) < s.freeMode.minimumVelocity &&
                          (t.velocity = 0),
                        (o > 150 || (0, r.zO)() - e.time > 300) &&
                          (t.velocity = 0);
                    } else t.velocity = 0;
                    (t.velocity *= s.freeMode.momentumVelocityRatio),
                      (c.velocities.length = 0);
                    let e = 1e3 * s.freeMode.momentumRatio;
                    const n = t.velocity * e;
                    let p = t.translate + n;
                    u && (p = -p);
                    let f,
                      d = !1;
                    const h =
                      20 *
                      Math.abs(t.velocity) *
                      s.freeMode.momentumBounceRatio;
                    let m;
                    if (p < t.maxTranslate())
                      s.freeMode.momentumBounce
                        ? (p + t.maxTranslate() < -h &&
                            (p = t.maxTranslate() - h),
                          (f = t.maxTranslate()),
                          (d = !0),
                          (c.allowMomentumBounce = !0))
                        : (p = t.maxTranslate()),
                        s.loop && s.centeredSlides && (m = !0);
                    else if (p > t.minTranslate())
                      s.freeMode.momentumBounce
                        ? (p - t.minTranslate() > h &&
                            (p = t.minTranslate() + h),
                          (f = t.minTranslate()),
                          (d = !0),
                          (c.allowMomentumBounce = !0))
                        : (p = t.minTranslate()),
                        s.loop && s.centeredSlides && (m = !0);
                    else if (s.freeMode.sticky) {
                      let e;
                      for (let t = 0; t < l.length; t += 1)
                        if (l[t] > -p) {
                          e = t;
                          break;
                        }
                      (p =
                        Math.abs(l[e] - p) < Math.abs(l[e - 1] - p) ||
                        "next" === t.swipeDirection
                          ? l[e]
                          : l[e - 1]),
                        (p = -p);
                    }
                    if (
                      (m &&
                        o("transitionEnd", () => {
                          t.loopFix();
                        }),
                      0 !== t.velocity)
                    ) {
                      if (
                        ((e = u
                          ? Math.abs((-p - t.translate) / t.velocity)
                          : Math.abs((p - t.translate) / t.velocity)),
                        s.freeMode.sticky)
                      ) {
                        const n = Math.abs((u ? -p : p) - t.translate),
                          r = t.slidesSizesGrid[t.activeIndex];
                        e =
                          n < r
                            ? s.speed
                            : n < 2 * r
                            ? 1.5 * s.speed
                            : 2.5 * s.speed;
                      }
                    } else if (s.freeMode.sticky)
                      return void t.slideToClosest();
                    s.freeMode.momentumBounce && d
                      ? (t.updateProgress(f),
                        t.setTransition(e),
                        t.setTranslate(p),
                        t.transitionStart(!0, t.swipeDirection),
                        (t.animating = !0),
                        a.transitionEnd(() => {
                          t &&
                            !t.destroyed &&
                            c.allowMomentumBounce &&
                            (i("momentumBounce"),
                            t.setTransition(s.speed),
                            setTimeout(() => {
                              t.setTranslate(f),
                                a.transitionEnd(() => {
                                  t && !t.destroyed && t.transitionEnd();
                                });
                            }, 0));
                        }))
                      : t.velocity
                      ? (i("_freeModeNoMomentumRelease"),
                        t.updateProgress(p),
                        t.setTransition(e),
                        t.setTranslate(p),
                        t.transitionStart(!0, t.swipeDirection),
                        t.animating ||
                          ((t.animating = !0),
                          a.transitionEnd(() => {
                            t && !t.destroyed && t.transitionEnd();
                          })))
                      : t.updateProgress(p),
                      t.updateActiveIndex(),
                      t.updateSlidesClasses();
                  } else {
                    if (s.freeMode.sticky) return void t.slideToClosest();
                    s.freeMode && i("_freeModeNoMomentumRelease");
                  }
                  (!s.freeMode.momentum || p >= s.longSwipesMs) &&
                    (t.updateProgress(),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses());
                }
              },
            },
          });
      }
    },
    6237: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(7628),
        i = n(4625);
      function o(e) {
        let { swiper: t, extendParams: n, emit: o, on: s } = e,
          a = !1;
        const u = (0, r.Me)(),
          l = (0, r.Jj)();
        n({
          hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 },
        });
        const c = () => {
            o("hashChange");
            const e = u.location.hash.replace("#", "");
            if (e !== t.slides.eq(t.activeIndex).attr("data-hash")) {
              const n = t.$wrapperEl
                .children(`.${t.params.slideClass}[data-hash="${e}"]`)
                .index();
              if (void 0 === n) return;
              t.slideTo(n);
            }
          },
          p = () => {
            if (a && t.params.hashNavigation.enabled)
              if (
                t.params.hashNavigation.replaceState &&
                l.history &&
                l.history.replaceState
              )
                l.history.replaceState(
                  null,
                  null,
                  `#${t.slides.eq(t.activeIndex).attr("data-hash")}` || ""
                ),
                  o("hashSet");
              else {
                const e = t.slides.eq(t.activeIndex),
                  n = e.attr("data-hash") || e.attr("data-history");
                (u.location.hash = n || ""), o("hashSet");
              }
          };
        s("init", () => {
          t.params.hashNavigation.enabled &&
            (() => {
              if (
                !t.params.hashNavigation.enabled ||
                (t.params.history && t.params.history.enabled)
              )
                return;
              a = !0;
              const e = u.location.hash.replace("#", "");
              if (e) {
                const n = 0;
                for (let r = 0, i = t.slides.length; r < i; r += 1) {
                  const i = t.slides.eq(r);
                  if (
                    (i.attr("data-hash") || i.attr("data-history")) === e &&
                    !i.hasClass(t.params.slideDuplicateClass)
                  ) {
                    const e = i.index();
                    t.slideTo(e, n, t.params.runCallbacksOnInit, !0);
                  }
                }
              }
              t.params.hashNavigation.watchState &&
                (0, i.Z)(l).on("hashchange", c);
            })();
        }),
          s("destroy", () => {
            t.params.hashNavigation.enabled &&
              t.params.hashNavigation.watchState &&
              (0, i.Z)(l).off("hashchange", c);
          }),
          s("transitionEnd _freeModeNoMomentumRelease", () => {
            a && p();
          }),
          s("slideChange", () => {
            a && t.params.cssMode && p();
          });
      }
    },
    68: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return i;
        },
      });
      var r = n(7628);
      function i(e) {
        let { swiper: t, extendParams: n, on: i } = e;
        n({
          history: { enabled: !1, root: "", replaceState: !1, key: "slides" },
        });
        let o = !1,
          s = {};
        const a = (e) =>
            e
              .toString()
              .replace(/\s+/g, "-")
              .replace(/[^\w-]+/g, "")
              .replace(/--+/g, "-")
              .replace(/^-+/, "")
              .replace(/-+$/, ""),
          u = (e) => {
            const t = (0, r.Jj)();
            let n;
            n = e ? new URL(e) : t.location;
            const i = n.pathname
                .slice(1)
                .split("/")
                .filter((e) => "" !== e),
              o = i.length;
            return { key: i[o - 2], value: i[o - 1] };
          },
          l = (e, n) => {
            const i = (0, r.Jj)();
            if (!o || !t.params.history.enabled) return;
            let s;
            s = t.params.url ? new URL(t.params.url) : i.location;
            const u = t.slides.eq(n);
            let l = a(u.attr("data-history"));
            if (t.params.history.root.length > 0) {
              let n = t.params.history.root;
              "/" === n[n.length - 1] && (n = n.slice(0, n.length - 1)),
                (l = `${n}/${e}/${l}`);
            } else s.pathname.includes(e) || (l = `${e}/${l}`);
            const c = i.history.state;
            (c && c.value === l) ||
              (t.params.history.replaceState
                ? i.history.replaceState({ value: l }, null, l)
                : i.history.pushState({ value: l }, null, l));
          },
          c = (e, n, r) => {
            if (n)
              for (let i = 0, o = t.slides.length; i < o; i += 1) {
                const o = t.slides.eq(i);
                if (
                  a(o.attr("data-history")) === n &&
                  !o.hasClass(t.params.slideDuplicateClass)
                ) {
                  const n = o.index();
                  t.slideTo(n, e, r);
                }
              }
            else t.slideTo(0, e, r);
          },
          p = () => {
            (s = u(t.params.url)), c(t.params.speed, t.paths.value, !1);
          };
        i("init", () => {
          t.params.history.enabled &&
            (() => {
              const e = (0, r.Jj)();
              if (t.params.history) {
                if (!e.history || !e.history.pushState)
                  return (
                    (t.params.history.enabled = !1),
                    void (t.params.hashNavigation.enabled = !0)
                  );
                (o = !0),
                  (s = u(t.params.url)),
                  (s.key || s.value) &&
                    (c(0, s.value, t.params.runCallbacksOnInit),
                    t.params.history.replaceState ||
                      e.addEventListener("popstate", p));
              }
            })();
        }),
          i("destroy", () => {
            t.params.history.enabled &&
              (() => {
                const e = (0, r.Jj)();
                t.params.history.replaceState ||
                  e.removeEventListener("popstate", p);
              })();
          }),
          i("transitionEnd _freeModeNoMomentumRelease", () => {
            o && l(t.params.history.key, t.activeIndex);
          }),
          i("slideChange", () => {
            o && t.params.cssMode && l(t.params.history.key, t.activeIndex);
          });
      }
    },
    376: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(7628),
        i = n(4625);
      function o(e) {
        let { swiper: t, extendParams: n, on: o, emit: s } = e;
        const a = (0, r.Me)(),
          u = (0, r.Jj)();
        function l(e) {
          if (!t.enabled) return;
          const { rtlTranslate: n } = t;
          let r = e;
          r.originalEvent && (r = r.originalEvent);
          const i = r.keyCode || r.charCode,
            o = t.params.keyboard.pageUpDown,
            l = o && 33 === i,
            c = o && 34 === i,
            p = 37 === i,
            f = 39 === i,
            d = 38 === i,
            h = 40 === i;
          if (
            !t.allowSlideNext &&
            ((t.isHorizontal() && f) || (t.isVertical() && h) || c)
          )
            return !1;
          if (
            !t.allowSlidePrev &&
            ((t.isHorizontal() && p) || (t.isVertical() && d) || l)
          )
            return !1;
          if (
            !(
              r.shiftKey ||
              r.altKey ||
              r.ctrlKey ||
              r.metaKey ||
              (a.activeElement &&
                a.activeElement.nodeName &&
                ("input" === a.activeElement.nodeName.toLowerCase() ||
                  "textarea" === a.activeElement.nodeName.toLowerCase()))
            )
          ) {
            if (
              t.params.keyboard.onlyInViewport &&
              (l || c || p || f || d || h)
            ) {
              let e = !1;
              if (
                t.$el.parents(`.${t.params.slideClass}`).length > 0 &&
                0 === t.$el.parents(`.${t.params.slideActiveClass}`).length
              )
                return;
              const r = t.$el,
                i = r[0].clientWidth,
                o = r[0].clientHeight,
                s = u.innerWidth,
                a = u.innerHeight,
                l = t.$el.offset();
              n && (l.left -= t.$el[0].scrollLeft);
              const c = [
                [l.left, l.top],
                [l.left + i, l.top],
                [l.left, l.top + o],
                [l.left + i, l.top + o],
              ];
              for (let t = 0; t < c.length; t += 1) {
                const n = c[t];
                if (n[0] >= 0 && n[0] <= s && n[1] >= 0 && n[1] <= a) {
                  if (0 === n[0] && 0 === n[1]) continue;
                  e = !0;
                }
              }
              if (!e) return;
            }
            t.isHorizontal()
              ? ((l || c || p || f) &&
                  (r.preventDefault
                    ? r.preventDefault()
                    : (r.returnValue = !1)),
                (((c || f) && !n) || ((l || p) && n)) && t.slideNext(),
                (((l || p) && !n) || ((c || f) && n)) && t.slidePrev())
              : ((l || c || d || h) &&
                  (r.preventDefault
                    ? r.preventDefault()
                    : (r.returnValue = !1)),
                (c || h) && t.slideNext(),
                (l || d) && t.slidePrev()),
              s("keyPress", i);
          }
        }
        function c() {
          t.keyboard.enabled ||
            ((0, i.Z)(a).on("keydown", l), (t.keyboard.enabled = !0));
        }
        function p() {
          t.keyboard.enabled &&
            ((0, i.Z)(a).off("keydown", l), (t.keyboard.enabled = !1));
        }
        (t.keyboard = { enabled: !1 }),
          n({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
          o("init", () => {
            t.params.keyboard.enabled && c();
          }),
          o("destroy", () => {
            t.keyboard.enabled && p();
          }),
          Object.assign(t.keyboard, { enable: c, disable: p });
      }
    },
    8359: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(7628),
        i = n(4625);
      function o(e) {
        let { swiper: t, extendParams: n, on: o, emit: s } = e;
        n({
          lazy: {
            checkInView: !1,
            enabled: !1,
            loadPrevNext: !1,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: !1,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader",
          },
        }),
          (t.lazy = {});
        let a = !1,
          u = !1;
        function l(e, n) {
          void 0 === n && (n = !0);
          const r = t.params.lazy;
          if (void 0 === e) return;
          if (0 === t.slides.length) return;
          const o =
              t.virtual && t.params.virtual.enabled
                ? t.$wrapperEl.children(
                    `.${t.params.slideClass}[data-swiper-slide-index="${e}"]`
                  )
                : t.slides.eq(e),
            a = o.find(
              `.${r.elementClass}:not(.${r.loadedClass}):not(.${r.loadingClass})`
            );
          !o.hasClass(r.elementClass) ||
            o.hasClass(r.loadedClass) ||
            o.hasClass(r.loadingClass) ||
            a.push(o[0]),
            0 !== a.length &&
              a.each((e) => {
                const a = (0, i.Z)(e);
                a.addClass(r.loadingClass);
                const u = a.attr("data-background"),
                  c = a.attr("data-src"),
                  p = a.attr("data-srcset"),
                  f = a.attr("data-sizes"),
                  d = a.parent("picture");
                t.loadImage(a[0], c || u, p, f, !1, () => {
                  if (null != t && t && (!t || t.params) && !t.destroyed) {
                    if (
                      (u
                        ? (a.css("background-image", `url("${u}")`),
                          a.removeAttr("data-background"))
                        : (p &&
                            (a.attr("srcset", p), a.removeAttr("data-srcset")),
                          f && (a.attr("sizes", f), a.removeAttr("data-sizes")),
                          d.length &&
                            d.children("source").each((e) => {
                              const t = (0, i.Z)(e);
                              t.attr("data-srcset") &&
                                (t.attr("srcset", t.attr("data-srcset")),
                                t.removeAttr("data-srcset"));
                            }),
                          c && (a.attr("src", c), a.removeAttr("data-src"))),
                      a.addClass(r.loadedClass).removeClass(r.loadingClass),
                      o.find(`.${r.preloaderClass}`).remove(),
                      t.params.loop && n)
                    ) {
                      const e = o.attr("data-swiper-slide-index");
                      o.hasClass(t.params.slideDuplicateClass)
                        ? l(
                            t.$wrapperEl
                              .children(
                                `[data-swiper-slide-index="${e}"]:not(.${t.params.slideDuplicateClass})`
                              )
                              .index(),
                            !1
                          )
                        : l(
                            t.$wrapperEl
                              .children(
                                `.${t.params.slideDuplicateClass}[data-swiper-slide-index="${e}"]`
                              )
                              .index(),
                            !1
                          );
                    }
                    s("lazyImageReady", o[0], a[0]),
                      t.params.autoHeight && t.updateAutoHeight();
                  }
                }),
                  s("lazyImageLoad", o[0], a[0]);
              });
        }
        function c() {
          const { $wrapperEl: e, params: n, slides: r, activeIndex: o } = t,
            s = t.virtual && n.virtual.enabled,
            a = n.lazy;
          let c = n.slidesPerView;
          function p(t) {
            if (s) {
              if (
                e.children(`.${n.slideClass}[data-swiper-slide-index="${t}"]`)
                  .length
              )
                return !0;
            } else if (r[t]) return !0;
            return !1;
          }
          function f(e) {
            return s
              ? (0, i.Z)(e).attr("data-swiper-slide-index")
              : (0, i.Z)(e).index();
          }
          if (
            ("auto" === c && (c = 0),
            u || (u = !0),
            t.params.watchSlidesProgress)
          )
            e.children(`.${n.slideVisibleClass}`).each((e) => {
              l(
                s
                  ? (0, i.Z)(e).attr("data-swiper-slide-index")
                  : (0, i.Z)(e).index()
              );
            });
          else if (c > 1) for (let e = o; e < o + c; e += 1) p(e) && l(e);
          else l(o);
          if (a.loadPrevNext)
            if (c > 1 || (a.loadPrevNextAmount && a.loadPrevNextAmount > 1)) {
              const e = a.loadPrevNextAmount,
                t = c,
                n = Math.min(o + t + Math.max(e, t), r.length),
                i = Math.max(o - Math.max(t, e), 0);
              for (let e = o + c; e < n; e += 1) p(e) && l(e);
              for (let e = i; e < o; e += 1) p(e) && l(e);
            } else {
              const t = e.children(`.${n.slideNextClass}`);
              t.length > 0 && l(f(t));
              const r = e.children(`.${n.slidePrevClass}`);
              r.length > 0 && l(f(r));
            }
        }
        function p() {
          const e = (0, r.Jj)();
          if (!t || t.destroyed) return;
          const n = t.params.lazy.scrollingElement
              ? (0, i.Z)(t.params.lazy.scrollingElement)
              : (0, i.Z)(e),
            o = n[0] === e,
            s = o ? e.innerWidth : n[0].offsetWidth,
            u = o ? e.innerHeight : n[0].offsetHeight,
            l = t.$el.offset(),
            { rtlTranslate: f } = t;
          let d = !1;
          f && (l.left -= t.$el[0].scrollLeft);
          const h = [
            [l.left, l.top],
            [l.left + t.width, l.top],
            [l.left, l.top + t.height],
            [l.left + t.width, l.top + t.height],
          ];
          for (let e = 0; e < h.length; e += 1) {
            const t = h[e];
            if (t[0] >= 0 && t[0] <= s && t[1] >= 0 && t[1] <= u) {
              if (0 === t[0] && 0 === t[1]) continue;
              d = !0;
            }
          }
          const m = !(
            "touchstart" !== t.touchEvents.start ||
            !t.support.passiveListener ||
            !t.params.passiveListeners
          ) && { passive: !0, capture: !1 };
          d
            ? (c(), n.off("scroll", p, m))
            : a || ((a = !0), n.on("scroll", p, m));
        }
        o("beforeInit", () => {
          t.params.lazy.enabled &&
            t.params.preloadImages &&
            (t.params.preloadImages = !1);
        }),
          o("init", () => {
            t.params.lazy.enabled && (t.params.lazy.checkInView ? p() : c());
          }),
          o("scroll", () => {
            t.params.freeMode &&
              t.params.freeMode.enabled &&
              !t.params.freeMode.sticky &&
              c();
          }),
          o("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
            t.params.lazy.enabled && (t.params.lazy.checkInView ? p() : c());
          }),
          o("transitionStart", () => {
            t.params.lazy.enabled &&
              (t.params.lazy.loadOnTransitionStart ||
                (!t.params.lazy.loadOnTransitionStart && !u)) &&
              (t.params.lazy.checkInView ? p() : c());
          }),
          o("transitionEnd", () => {
            t.params.lazy.enabled &&
              !t.params.lazy.loadOnTransitionStart &&
              (t.params.lazy.checkInView ? p() : c());
          }),
          o("slideChange", () => {
            const {
              lazy: e,
              cssMode: n,
              watchSlidesProgress: r,
              touchReleaseOnEdges: i,
              resistanceRatio: o,
            } = t.params;
            e.enabled && (n || (r && (i || 0 === o))) && c();
          }),
          Object.assign(t.lazy, { load: c, loadInSlide: l });
      }
    },
    882: function (e, t, n) {
      "use strict";
      function r(e, t) {
        const n = this,
          { $wrapperEl: r, params: i, activeIndex: o } = n;
        let s = o;
        i.loop &&
          ((s -= n.loopedSlides),
          n.loopDestroy(),
          (n.slides = r.children(`.${i.slideClass}`)));
        const a = n.slides.length;
        if (e <= 0) return void n.prependSlide(t);
        if (e >= a) return void n.appendSlide(t);
        let u = s > e ? s + 1 : s;
        const l = [];
        for (let t = a - 1; t >= e; t -= 1) {
          const e = n.slides.eq(t);
          e.remove(), l.unshift(e);
        }
        if ("object" == typeof t && "length" in t) {
          for (let e = 0; e < t.length; e += 1) t[e] && r.append(t[e]);
          u = s > e ? s + t.length : s;
        } else r.append(t);
        for (let e = 0; e < l.length; e += 1) r.append(l[e]);
        i.loop && n.loopCreate(),
          i.observer || n.update(),
          i.loop ? n.slideTo(u + n.loopedSlides, 0, !1) : n.slideTo(u, 0, !1);
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    6796: function (e, t, n) {
      "use strict";
      function r(e) {
        const t = this,
          { $wrapperEl: n, params: r } = t;
        if ((r.loop && t.loopDestroy(), "object" == typeof e && "length" in e))
          for (let t = 0; t < e.length; t += 1) e[t] && n.append(e[t]);
        else n.append(e);
        r.loop && t.loopCreate(), r.observer || t.update();
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    286: function (e, t, n) {
      "use strict";
      function r(e) {
        const t = this,
          { params: n, $wrapperEl: r, activeIndex: i } = t;
        n.loop && t.loopDestroy();
        let o = i + 1;
        if ("object" == typeof e && "length" in e) {
          for (let t = 0; t < e.length; t += 1) e[t] && r.prepend(e[t]);
          o = i + e.length;
        } else r.prepend(e);
        n.loop && t.loopCreate(), n.observer || t.update(), t.slideTo(o, 0, !1);
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    4440: function (e, t, n) {
      "use strict";
      function r() {
        const e = this,
          t = [];
        for (let n = 0; n < e.slides.length; n += 1) t.push(n);
        e.removeSlide(t);
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    3459: function (e, t, n) {
      "use strict";
      function r(e) {
        const t = this,
          { params: n, $wrapperEl: r, activeIndex: i } = t;
        let o = i;
        n.loop &&
          ((o -= t.loopedSlides),
          t.loopDestroy(),
          (t.slides = r.children(`.${n.slideClass}`)));
        let s,
          a = o;
        if ("object" == typeof e && "length" in e) {
          for (let n = 0; n < e.length; n += 1)
            (s = e[n]),
              t.slides[s] && t.slides.eq(s).remove(),
              s < a && (a -= 1);
          a = Math.max(a, 0);
        } else
          (s = e),
            t.slides[s] && t.slides.eq(s).remove(),
            s < a && (a -= 1),
            (a = Math.max(a, 0));
        n.loop && t.loopCreate(),
          n.observer || t.update(),
          n.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1);
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    8372: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return s;
        },
      });
      var r = n(7628),
        i = n(4625),
        o = n(9482);
      function s(e) {
        let { swiper: t, extendParams: n, on: s, emit: a } = e;
        const u = (0, r.Jj)();
        let l;
        n({
          mousewheel: {
            enabled: !1,
            releaseOnEdges: !1,
            invert: !1,
            forceToAxis: !1,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
          },
        }),
          (t.mousewheel = { enabled: !1 });
        let c,
          p = (0, o.zO)();
        const f = [];
        function d() {
          t.enabled && (t.mouseEntered = !0);
        }
        function h() {
          t.enabled && (t.mouseEntered = !1);
        }
        function m(e) {
          return !(
            (t.params.mousewheel.thresholdDelta &&
              e.delta < t.params.mousewheel.thresholdDelta) ||
            (t.params.mousewheel.thresholdTime &&
              (0, o.zO)() - p < t.params.mousewheel.thresholdTime) ||
            (!(e.delta >= 6 && (0, o.zO)() - p < 60) &&
              (e.direction < 0
                ? (t.isEnd && !t.params.loop) ||
                  t.animating ||
                  (t.slideNext(), a("scroll", e.raw))
                : (t.isBeginning && !t.params.loop) ||
                  t.animating ||
                  (t.slidePrev(), a("scroll", e.raw)),
              (p = new u.Date().getTime()),
              1))
          );
        }
        function g(e) {
          let n = e,
            r = !0;
          if (!t.enabled) return;
          const s = t.params.mousewheel;
          t.params.cssMode && n.preventDefault();
          let u = t.$el;
          if (
            ("container" !== t.params.mousewheel.eventsTarget &&
              (u = (0, i.Z)(t.params.mousewheel.eventsTarget)),
            !t.mouseEntered && !u[0].contains(n.target) && !s.releaseOnEdges)
          )
            return !0;
          n.originalEvent && (n = n.originalEvent);
          let p = 0;
          const d = t.rtlTranslate ? -1 : 1,
            h = (function (e) {
              let t = 0,
                n = 0,
                r = 0,
                i = 0;
              return (
                "detail" in e && (n = e.detail),
                "wheelDelta" in e && (n = -e.wheelDelta / 120),
                "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
                "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                "axis" in e &&
                  e.axis === e.HORIZONTAL_AXIS &&
                  ((t = n), (n = 0)),
                (r = 10 * t),
                (i = 10 * n),
                "deltaY" in e && (i = e.deltaY),
                "deltaX" in e && (r = e.deltaX),
                e.shiftKey && !r && ((r = i), (i = 0)),
                (r || i) &&
                  e.deltaMode &&
                  (1 === e.deltaMode
                    ? ((r *= 40), (i *= 40))
                    : ((r *= 800), (i *= 800))),
                r && !t && (t = r < 1 ? -1 : 1),
                i && !n && (n = i < 1 ? -1 : 1),
                { spinX: t, spinY: n, pixelX: r, pixelY: i }
              );
            })(n);
          if (s.forceToAxis)
            if (t.isHorizontal()) {
              if (!(Math.abs(h.pixelX) > Math.abs(h.pixelY))) return !0;
              p = -h.pixelX * d;
            } else {
              if (!(Math.abs(h.pixelY) > Math.abs(h.pixelX))) return !0;
              p = -h.pixelY;
            }
          else
            p =
              Math.abs(h.pixelX) > Math.abs(h.pixelY)
                ? -h.pixelX * d
                : -h.pixelY;
          if (0 === p) return !0;
          s.invert && (p = -p);
          let g = t.getTranslate() + p * s.sensitivity;
          if (
            (g >= t.minTranslate() && (g = t.minTranslate()),
            g <= t.maxTranslate() && (g = t.maxTranslate()),
            (r =
              !!t.params.loop ||
              !(g === t.minTranslate() || g === t.maxTranslate())),
            r && t.params.nested && n.stopPropagation(),
            t.params.freeMode && t.params.freeMode.enabled)
          ) {
            const e = {
                time: (0, o.zO)(),
                delta: Math.abs(p),
                direction: Math.sign(p),
              },
              r =
                c &&
                e.time < c.time + 500 &&
                e.delta <= c.delta &&
                e.direction === c.direction;
            if (!r) {
              (c = void 0), t.params.loop && t.loopFix();
              let i = t.getTranslate() + p * s.sensitivity;
              const u = t.isBeginning,
                d = t.isEnd;
              if (
                (i >= t.minTranslate() && (i = t.minTranslate()),
                i <= t.maxTranslate() && (i = t.maxTranslate()),
                t.setTransition(0),
                t.setTranslate(i),
                t.updateProgress(),
                t.updateActiveIndex(),
                t.updateSlidesClasses(),
                ((!u && t.isBeginning) || (!d && t.isEnd)) &&
                  t.updateSlidesClasses(),
                t.params.freeMode.sticky)
              ) {
                clearTimeout(l), (l = void 0), f.length >= 15 && f.shift();
                const n = f.length ? f[f.length - 1] : void 0,
                  r = f[0];
                if (
                  (f.push(e),
                  n && (e.delta > n.delta || e.direction !== n.direction))
                )
                  f.splice(0);
                else if (
                  f.length >= 15 &&
                  e.time - r.time < 500 &&
                  r.delta - e.delta >= 1 &&
                  e.delta <= 6
                ) {
                  const n = p > 0 ? 0.8 : 0.2;
                  (c = e),
                    f.splice(0),
                    (l = (0, o.Y3)(() => {
                      t.slideToClosest(t.params.speed, !0, void 0, n);
                    }, 0));
                }
                l ||
                  (l = (0, o.Y3)(() => {
                    (c = e),
                      f.splice(0),
                      t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                  }, 500));
              }
              if (
                (r || a("scroll", n),
                t.params.autoplay &&
                  t.params.autoplayDisableOnInteraction &&
                  t.autoplay.stop(),
                i === t.minTranslate() || i === t.maxTranslate())
              )
                return !0;
            }
          } else {
            const n = {
              time: (0, o.zO)(),
              delta: Math.abs(p),
              direction: Math.sign(p),
              raw: e,
            };
            f.length >= 2 && f.shift();
            const r = f.length ? f[f.length - 1] : void 0;
            if (
              (f.push(n),
              r
                ? (n.direction !== r.direction ||
                    n.delta > r.delta ||
                    n.time > r.time + 150) &&
                  m(n)
                : m(n),
              (function (e) {
                const n = t.params.mousewheel;
                if (e.direction < 0) {
                  if (t.isEnd && !t.params.loop && n.releaseOnEdges) return !0;
                } else if (t.isBeginning && !t.params.loop && n.releaseOnEdges)
                  return !0;
                return !1;
              })(n))
            )
              return !0;
          }
          return (
            n.preventDefault ? n.preventDefault() : (n.returnValue = !1), !1
          );
        }
        function y(e) {
          let n = t.$el;
          "container" !== t.params.mousewheel.eventsTarget &&
            (n = (0, i.Z)(t.params.mousewheel.eventsTarget)),
            n[e]("mouseenter", d),
            n[e]("mouseleave", h),
            n[e]("wheel", g);
        }
        function v() {
          return t.params.cssMode
            ? (t.wrapperEl.removeEventListener("wheel", g), !0)
            : !t.mousewheel.enabled &&
                (y("on"), (t.mousewheel.enabled = !0), !0);
        }
        function D() {
          return t.params.cssMode
            ? (t.wrapperEl.addEventListener(event, g), !0)
            : !!t.mousewheel.enabled &&
                (y("off"), (t.mousewheel.enabled = !1), !0);
        }
        s("init", () => {
          !t.params.mousewheel.enabled && t.params.cssMode && D(),
            t.params.mousewheel.enabled && v();
        }),
          s("destroy", () => {
            t.params.cssMode && v(), t.mousewheel.enabled && D();
          }),
          Object.assign(t.mousewheel, { enable: v, disable: D });
      }
    },
    6739: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(4408),
        i = n(4625);
      function o(e) {
        let { swiper: t, extendParams: n, on: o, emit: s } = e;
        function a(e) {
          let n;
          return (
            e &&
              ((n = (0, i.Z)(e)),
              t.params.uniqueNavElements &&
                "string" == typeof e &&
                n.length > 1 &&
                1 === t.$el.find(e).length &&
                (n = t.$el.find(e))),
            n
          );
        }
        function u(e, n) {
          const r = t.params.navigation;
          e &&
            e.length > 0 &&
            (e[n ? "addClass" : "removeClass"](r.disabledClass),
            e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = n),
            t.params.watchOverflow &&
              t.enabled &&
              e[t.isLocked ? "addClass" : "removeClass"](r.lockClass));
        }
        function l() {
          if (t.params.loop) return;
          const { $nextEl: e, $prevEl: n } = t.navigation;
          u(n, t.isBeginning && !t.params.rewind),
            u(e, t.isEnd && !t.params.rewind);
        }
        function c(e) {
          e.preventDefault(),
            (!t.isBeginning || t.params.loop || t.params.rewind) &&
              t.slidePrev();
        }
        function p(e) {
          e.preventDefault(),
            (!t.isEnd || t.params.loop || t.params.rewind) && t.slideNext();
        }
        function f() {
          const e = t.params.navigation;
          if (
            ((t.params.navigation = (0, r.Z)(
              t,
              t.originalParams.navigation,
              t.params.navigation,
              { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
            )),
            !e.nextEl && !e.prevEl)
          )
            return;
          const n = a(e.nextEl),
            i = a(e.prevEl);
          n && n.length > 0 && n.on("click", p),
            i && i.length > 0 && i.on("click", c),
            Object.assign(t.navigation, {
              $nextEl: n,
              nextEl: n && n[0],
              $prevEl: i,
              prevEl: i && i[0],
            }),
            t.enabled ||
              (n && n.addClass(e.lockClass), i && i.addClass(e.lockClass));
        }
        function d() {
          const { $nextEl: e, $prevEl: n } = t.navigation;
          e &&
            e.length &&
            (e.off("click", p),
            e.removeClass(t.params.navigation.disabledClass)),
            n &&
              n.length &&
              (n.off("click", c),
              n.removeClass(t.params.navigation.disabledClass));
        }
        n({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
          },
        }),
          (t.navigation = {
            nextEl: null,
            $nextEl: null,
            prevEl: null,
            $prevEl: null,
          }),
          o("init", () => {
            f(), l();
          }),
          o("toEdge fromEdge lock unlock", () => {
            l();
          }),
          o("destroy", () => {
            d();
          }),
          o("enable disable", () => {
            const { $nextEl: e, $prevEl: n } = t.navigation;
            e &&
              e[t.enabled ? "removeClass" : "addClass"](
                t.params.navigation.lockClass
              ),
              n &&
                n[t.enabled ? "removeClass" : "addClass"](
                  t.params.navigation.lockClass
                );
          }),
          o("click", (e, n) => {
            const { $nextEl: r, $prevEl: o } = t.navigation,
              a = n.target;
            if (
              t.params.navigation.hideOnClick &&
              !(0, i.Z)(a).is(o) &&
              !(0, i.Z)(a).is(r)
            ) {
              if (
                t.pagination &&
                t.params.pagination &&
                t.params.pagination.clickable &&
                (t.pagination.el === a || t.pagination.el.contains(a))
              )
                return;
              let e;
              r
                ? (e = r.hasClass(t.params.navigation.hiddenClass))
                : o && (e = o.hasClass(t.params.navigation.hiddenClass)),
                s(!0 === e ? "navigationShow" : "navigationHide"),
                r && r.toggleClass(t.params.navigation.hiddenClass),
                o && o.toggleClass(t.params.navigation.hiddenClass);
            }
          }),
          Object.assign(t.navigation, { update: l, init: f, destroy: d });
      }
    },
    9224: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return s;
        },
      });
      var r = n(4625);
      if (/^([15]37|381|570)$/.test(n.j)) var i = n(3370);
      var o = n(4408);
      function s(e) {
        let { swiper: t, extendParams: n, on: s, emit: a } = e;
        const u = "swiper-pagination";
        let l;
        n({
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: (e) => e,
            formatFractionTotal: (e) => e,
            bulletClass: `${u}-bullet`,
            bulletActiveClass: `${u}-bullet-active`,
            modifierClass: `${u}-`,
            currentClass: `${u}-current`,
            totalClass: `${u}-total`,
            hiddenClass: `${u}-hidden`,
            progressbarFillClass: `${u}-progressbar-fill`,
            progressbarOppositeClass: `${u}-progressbar-opposite`,
            clickableClass: `${u}-clickable`,
            lockClass: `${u}-lock`,
            horizontalClass: `${u}-horizontal`,
            verticalClass: `${u}-vertical`,
          },
        }),
          (t.pagination = { el: null, $el: null, bullets: [] });
        let c = 0;
        function p() {
          return (
            !t.params.pagination.el ||
            !t.pagination.el ||
            !t.pagination.$el ||
            0 === t.pagination.$el.length
          );
        }
        function f(e, n) {
          const { bulletActiveClass: r } = t.params.pagination;
          e[n]().addClass(`${r}-${n}`)[n]().addClass(`${r}-${n}-${n}`);
        }
        function d() {
          const e = t.rtl,
            n = t.params.pagination;
          if (p()) return;
          const o =
              t.virtual && t.params.virtual.enabled
                ? t.virtual.slides.length
                : t.slides.length,
            s = t.pagination.$el;
          let u;
          const d = t.params.loop
            ? Math.ceil((o - 2 * t.loopedSlides) / t.params.slidesPerGroup)
            : t.snapGrid.length;
          if (
            (t.params.loop
              ? ((u = Math.ceil(
                  (t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup
                )),
                u > o - 1 - 2 * t.loopedSlides && (u -= o - 2 * t.loopedSlides),
                u > d - 1 && (u -= d),
                u < 0 && "bullets" !== t.params.paginationType && (u = d + u))
              : (u = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0),
            "bullets" === n.type &&
              t.pagination.bullets &&
              t.pagination.bullets.length > 0)
          ) {
            const i = t.pagination.bullets;
            let o, a, p;
            if (
              (n.dynamicBullets &&
                ((l = i
                  .eq(0)
                  [t.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                s.css(
                  t.isHorizontal() ? "width" : "height",
                  l * (n.dynamicMainBullets + 4) + "px"
                ),
                n.dynamicMainBullets > 1 &&
                  void 0 !== t.previousIndex &&
                  ((c += u - (t.previousIndex - t.loopedSlides || 0)),
                  c > n.dynamicMainBullets - 1
                    ? (c = n.dynamicMainBullets - 1)
                    : c < 0 && (c = 0)),
                (o = Math.max(u - c, 0)),
                (a = o + (Math.min(i.length, n.dynamicMainBullets) - 1)),
                (p = (a + o) / 2)),
              i.removeClass(
                ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                  .map((e) => `${n.bulletActiveClass}${e}`)
                  .join(" ")
              ),
              s.length > 1)
            )
              i.each((e) => {
                const t = (0, r.Z)(e),
                  i = t.index();
                i === u && t.addClass(n.bulletActiveClass),
                  n.dynamicBullets &&
                    (i >= o &&
                      i <= a &&
                      t.addClass(`${n.bulletActiveClass}-main`),
                    i === o && f(t, "prev"),
                    i === a && f(t, "next"));
              });
            else {
              const e = i.eq(u),
                r = e.index();
              if ((e.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                const e = i.eq(o),
                  s = i.eq(a);
                for (let e = o; e <= a; e += 1)
                  i.eq(e).addClass(`${n.bulletActiveClass}-main`);
                if (t.params.loop)
                  if (r >= i.length) {
                    for (let e = n.dynamicMainBullets; e >= 0; e -= 1)
                      i.eq(i.length - e).addClass(
                        `${n.bulletActiveClass}-main`
                      );
                    i.eq(i.length - n.dynamicMainBullets - 1).addClass(
                      `${n.bulletActiveClass}-prev`
                    );
                  } else f(e, "prev"), f(s, "next");
                else f(e, "prev"), f(s, "next");
              }
            }
            if (n.dynamicBullets) {
              const r = Math.min(i.length, n.dynamicMainBullets + 4),
                o = (l * r - l) / 2 - p * l,
                s = e ? "right" : "left";
              i.css(t.isHorizontal() ? s : "top", `${o}px`);
            }
          }
          if (
            ("fraction" === n.type &&
              (s
                .find((0, i.Z)(n.currentClass))
                .text(n.formatFractionCurrent(u + 1)),
              s.find((0, i.Z)(n.totalClass)).text(n.formatFractionTotal(d))),
            "progressbar" === n.type)
          ) {
            let e;
            e = n.progressbarOpposite
              ? t.isHorizontal()
                ? "vertical"
                : "horizontal"
              : t.isHorizontal()
              ? "horizontal"
              : "vertical";
            const r = (u + 1) / d;
            let o = 1,
              a = 1;
            "horizontal" === e ? (o = r) : (a = r),
              s
                .find((0, i.Z)(n.progressbarFillClass))
                .transform(`translate3d(0,0,0) scaleX(${o}) scaleY(${a})`)
                .transition(t.params.speed);
          }
          "custom" === n.type && n.renderCustom
            ? (s.html(n.renderCustom(t, u + 1, d)), a("paginationRender", s[0]))
            : a("paginationUpdate", s[0]),
            t.params.watchOverflow &&
              t.enabled &&
              s[t.isLocked ? "addClass" : "removeClass"](n.lockClass);
        }
        function h() {
          const e = t.params.pagination;
          if (p()) return;
          const n =
              t.virtual && t.params.virtual.enabled
                ? t.virtual.slides.length
                : t.slides.length,
            r = t.pagination.$el;
          let o = "";
          if ("bullets" === e.type) {
            let s = t.params.loop
              ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup)
              : t.snapGrid.length;
            t.params.freeMode &&
              t.params.freeMode.enabled &&
              !t.params.loop &&
              s > n &&
              (s = n);
            for (let n = 0; n < s; n += 1)
              e.renderBullet
                ? (o += e.renderBullet.call(t, n, e.bulletClass))
                : (o += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
            r.html(o), (t.pagination.bullets = r.find((0, i.Z)(e.bulletClass)));
          }
          "fraction" === e.type &&
            ((o = e.renderFraction
              ? e.renderFraction.call(t, e.currentClass, e.totalClass)
              : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
            r.html(o)),
            "progressbar" === e.type &&
              ((o = e.renderProgressbar
                ? e.renderProgressbar.call(t, e.progressbarFillClass)
                : `<span class="${e.progressbarFillClass}"></span>`),
              r.html(o)),
            "custom" !== e.type && a("paginationRender", t.pagination.$el[0]);
        }
        function m() {
          t.params.pagination = (0, o.Z)(
            t,
            t.originalParams.pagination,
            t.params.pagination,
            { el: "swiper-pagination" }
          );
          const e = t.params.pagination;
          if (!e.el) return;
          let n = (0, r.Z)(e.el);
          0 !== n.length &&
            (t.params.uniqueNavElements &&
              "string" == typeof e.el &&
              n.length > 1 &&
              ((n = t.$el.find(e.el)),
              n.length > 1 &&
                (n = n.filter(
                  (e) => (0, r.Z)(e).parents(".swiper")[0] === t.el
                ))),
            "bullets" === e.type && e.clickable && n.addClass(e.clickableClass),
            n.addClass(e.modifierClass + e.type),
            n.addClass(e.modifierClass + t.params.direction),
            "bullets" === e.type &&
              e.dynamicBullets &&
              (n.addClass(`${e.modifierClass}${e.type}-dynamic`),
              (c = 0),
              e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
            "progressbar" === e.type &&
              e.progressbarOpposite &&
              n.addClass(e.progressbarOppositeClass),
            e.clickable &&
              n.on("click", (0, i.Z)(e.bulletClass), function (e) {
                e.preventDefault();
                let n = (0, r.Z)(this).index() * t.params.slidesPerGroup;
                t.params.loop && (n += t.loopedSlides), t.slideTo(n);
              }),
            Object.assign(t.pagination, { $el: n, el: n[0] }),
            t.enabled || n.addClass(e.lockClass));
        }
        function g() {
          const e = t.params.pagination;
          if (p()) return;
          const n = t.pagination.$el;
          n.removeClass(e.hiddenClass),
            n.removeClass(e.modifierClass + e.type),
            n.removeClass(e.modifierClass + t.params.direction),
            t.pagination.bullets &&
              t.pagination.bullets.removeClass &&
              t.pagination.bullets.removeClass(e.bulletActiveClass),
            e.clickable && n.off("click", (0, i.Z)(e.bulletClass));
        }
        s("init", () => {
          m(), h(), d();
        }),
          s("activeIndexChange", () => {
            (t.params.loop || void 0 === t.snapIndex) && d();
          }),
          s("snapIndexChange", () => {
            t.params.loop || d();
          }),
          s("slidesLengthChange", () => {
            t.params.loop && (h(), d());
          }),
          s("snapGridLengthChange", () => {
            t.params.loop || (h(), d());
          }),
          s("destroy", () => {
            g();
          }),
          s("enable disable", () => {
            const { $el: e } = t.pagination;
            e &&
              e[t.enabled ? "removeClass" : "addClass"](
                t.params.pagination.lockClass
              );
          }),
          s("lock unlock", () => {
            d();
          }),
          s("click", (e, n) => {
            const i = n.target,
              { $el: o } = t.pagination;
            if (
              t.params.pagination.el &&
              t.params.pagination.hideOnClick &&
              o.length > 0 &&
              !(0, r.Z)(i).hasClass(t.params.pagination.bulletClass)
            ) {
              if (
                t.navigation &&
                ((t.navigation.nextEl && i === t.navigation.nextEl) ||
                  (t.navigation.prevEl && i === t.navigation.prevEl))
              )
                return;
              const e = o.hasClass(t.params.pagination.hiddenClass);
              a(!0 === e ? "paginationShow" : "paginationHide"),
                o.toggleClass(t.params.pagination.hiddenClass);
            }
          }),
          Object.assign(t.pagination, {
            render: h,
            update: d,
            init: m,
            destroy: g,
          });
      }
    },
    1190: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return i;
        },
      });
      var r = n(4625);
      function i(e) {
        let { swiper: t, extendParams: n, on: i } = e;
        n({ parallax: { enabled: !1 } });
        const o = (e, n) => {
            const { rtl: i } = t,
              o = (0, r.Z)(e),
              s = i ? -1 : 1,
              a = o.attr("data-swiper-parallax") || "0";
            let u = o.attr("data-swiper-parallax-x"),
              l = o.attr("data-swiper-parallax-y");
            const c = o.attr("data-swiper-parallax-scale"),
              p = o.attr("data-swiper-parallax-opacity");
            if (
              (u || l
                ? ((u = u || "0"), (l = l || "0"))
                : t.isHorizontal()
                ? ((u = a), (l = "0"))
                : ((l = a), (u = "0")),
              (u =
                u.indexOf("%") >= 0
                  ? parseInt(u, 10) * n * s + "%"
                  : u * n * s + "px"),
              (l =
                l.indexOf("%") >= 0 ? parseInt(l, 10) * n + "%" : l * n + "px"),
              null != p)
            ) {
              const e = p - (p - 1) * (1 - Math.abs(n));
              o[0].style.opacity = e;
            }
            if (null == c) o.transform(`translate3d(${u}, ${l}, 0px)`);
            else {
              const e = c - (c - 1) * (1 - Math.abs(n));
              o.transform(`translate3d(${u}, ${l}, 0px) scale(${e})`);
            }
          },
          s = () => {
            const { $el: e, slides: n, progress: i, snapGrid: s } = t;
            e
              .children(
                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
              )
              .each((e) => {
                o(e, i);
              }),
              n.each((e, n) => {
                let a = e.progress;
                t.params.slidesPerGroup > 1 &&
                  "auto" !== t.params.slidesPerView &&
                  (a += Math.ceil(n / 2) - i * (s.length - 1)),
                  (a = Math.min(Math.max(a, -1), 1)),
                  (0, r.Z)(e)
                    .find(
                      "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                    )
                    .each((e) => {
                      o(e, a);
                    });
              });
          };
        i("beforeInit", () => {
          t.params.parallax.enabled &&
            ((t.params.watchSlidesProgress = !0),
            (t.originalParams.watchSlidesProgress = !0));
        }),
          i("init", () => {
            t.params.parallax.enabled && s();
          }),
          i("setTranslate", () => {
            t.params.parallax.enabled && s();
          }),
          i("setTransition", (e, n) => {
            t.params.parallax.enabled &&
              (function (e) {
                void 0 === e && (e = t.params.speed);
                const { $el: n } = t;
                n.find(
                  "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                ).each((t) => {
                  const n = (0, r.Z)(t);
                  let i =
                    parseInt(n.attr("data-swiper-parallax-duration"), 10) || e;
                  0 === e && (i = 0), n.transition(i);
                });
              })(n);
          });
      }
    },
    5652: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return a;
        },
      });
      var r = n(7628),
        i = n(4625),
        o = n(9482),
        s = n(4408);
      function a(e) {
        let { swiper: t, extendParams: n, on: a, emit: u } = e;
        const l = (0, r.Me)();
        let c,
          p,
          f,
          d,
          h = !1,
          m = null,
          g = null;
        function y() {
          if (!t.params.scrollbar.el || !t.scrollbar.el) return;
          const { scrollbar: e, rtlTranslate: n, progress: r } = t,
            { $dragEl: i, $el: o } = e,
            s = t.params.scrollbar;
          let a = p,
            u = (f - p) * r;
          n
            ? ((u = -u),
              u > 0 ? ((a = p - u), (u = 0)) : -u + p > f && (a = f + u))
            : u < 0
            ? ((a = p + u), (u = 0))
            : u + p > f && (a = f - u),
            t.isHorizontal()
              ? (i.transform(`translate3d(${u}px, 0, 0)`),
                (i[0].style.width = `${a}px`))
              : (i.transform(`translate3d(0px, ${u}px, 0)`),
                (i[0].style.height = `${a}px`)),
            s.hide &&
              (clearTimeout(m),
              (o[0].style.opacity = 1),
              (m = setTimeout(() => {
                (o[0].style.opacity = 0), o.transition(400);
              }, 1e3)));
        }
        function v() {
          if (!t.params.scrollbar.el || !t.scrollbar.el) return;
          const { scrollbar: e } = t,
            { $dragEl: n, $el: r } = e;
          (n[0].style.width = ""),
            (n[0].style.height = ""),
            (f = t.isHorizontal() ? r[0].offsetWidth : r[0].offsetHeight),
            (d =
              t.size /
              (t.virtualSize +
                t.params.slidesOffsetBefore -
                (t.params.centeredSlides ? t.snapGrid[0] : 0))),
            (p =
              "auto" === t.params.scrollbar.dragSize
                ? f * d
                : parseInt(t.params.scrollbar.dragSize, 10)),
            t.isHorizontal()
              ? (n[0].style.width = `${p}px`)
              : (n[0].style.height = `${p}px`),
            (r[0].style.display = d >= 1 ? "none" : ""),
            t.params.scrollbar.hide && (r[0].style.opacity = 0),
            t.params.watchOverflow &&
              t.enabled &&
              e.$el[t.isLocked ? "addClass" : "removeClass"](
                t.params.scrollbar.lockClass
              );
        }
        function D(e) {
          return t.isHorizontal()
            ? "touchstart" === e.type || "touchmove" === e.type
              ? e.targetTouches[0].clientX
              : e.clientX
            : "touchstart" === e.type || "touchmove" === e.type
            ? e.targetTouches[0].clientY
            : e.clientY;
        }
        function b(e) {
          const { scrollbar: n, rtlTranslate: r } = t,
            { $el: i } = n;
          let o;
          (o =
            (D(e) -
              i.offset()[t.isHorizontal() ? "left" : "top"] -
              (null !== c ? c : p / 2)) /
            (f - p)),
            (o = Math.max(Math.min(o, 1), 0)),
            r && (o = 1 - o);
          const s =
            t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * o;
          t.updateProgress(s),
            t.setTranslate(s),
            t.updateActiveIndex(),
            t.updateSlidesClasses();
        }
        function E(e) {
          const n = t.params.scrollbar,
            { scrollbar: r, $wrapperEl: i } = t,
            { $el: o, $dragEl: s } = r;
          (h = !0),
            (c =
              e.target === s[0] || e.target === s
                ? D(e) -
                  e.target.getBoundingClientRect()[
                    t.isHorizontal() ? "left" : "top"
                  ]
                : null),
            e.preventDefault(),
            e.stopPropagation(),
            i.transition(100),
            s.transition(100),
            b(e),
            clearTimeout(g),
            o.transition(0),
            n.hide && o.css("opacity", 1),
            t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
            u("scrollbarDragStart", e);
        }
        function C(e) {
          const { scrollbar: n, $wrapperEl: r } = t,
            { $el: i, $dragEl: o } = n;
          h &&
            (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
            b(e),
            r.transition(0),
            i.transition(0),
            o.transition(0),
            u("scrollbarDragMove", e));
        }
        function x(e) {
          const n = t.params.scrollbar,
            { scrollbar: r, $wrapperEl: i } = t,
            { $el: s } = r;
          h &&
            ((h = !1),
            t.params.cssMode &&
              (t.$wrapperEl.css("scroll-snap-type", ""), i.transition("")),
            n.hide &&
              (clearTimeout(g),
              (g = (0, o.Y3)(() => {
                s.css("opacity", 0), s.transition(400);
              }, 1e3))),
            u("scrollbarDragEnd", e),
            n.snapOnRelease && t.slideToClosest());
        }
        function w(e) {
          const {
              scrollbar: n,
              touchEventsTouch: r,
              touchEventsDesktop: i,
              params: o,
              support: s,
            } = t,
            a = n.$el[0],
            u = !(!s.passiveListener || !o.passiveListeners) && {
              passive: !1,
              capture: !1,
            },
            c = !(!s.passiveListener || !o.passiveListeners) && {
              passive: !0,
              capture: !1,
            };
          if (!a) return;
          const p = "on" === e ? "addEventListener" : "removeEventListener";
          s.touch
            ? (a[p](r.start, E, u), a[p](r.move, C, u), a[p](r.end, x, c))
            : (a[p](i.start, E, u), l[p](i.move, C, u), l[p](i.end, x, c));
        }
        function A() {
          const { scrollbar: e, $el: n } = t;
          t.params.scrollbar = (0, s.Z)(
            t,
            t.originalParams.scrollbar,
            t.params.scrollbar,
            { el: "swiper-scrollbar" }
          );
          const r = t.params.scrollbar;
          if (!r.el) return;
          let o = (0, i.Z)(r.el);
          t.params.uniqueNavElements &&
            "string" == typeof r.el &&
            o.length > 1 &&
            1 === n.find(r.el).length &&
            (o = n.find(r.el));
          let a = o.find(`.${t.params.scrollbar.dragClass}`);
          0 === a.length &&
            ((a = (0, i.Z)(
              `<div class="${t.params.scrollbar.dragClass}"></div>`
            )),
            o.append(a)),
            Object.assign(e, { $el: o, el: o[0], $dragEl: a, dragEl: a[0] }),
            r.draggable && t.params.scrollbar.el && w("on"),
            o &&
              o[t.enabled ? "removeClass" : "addClass"](
                t.params.scrollbar.lockClass
              );
        }
        function S() {
          t.params.scrollbar.el && w("off");
        }
        n({
          scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
          },
        }),
          (t.scrollbar = { el: null, dragEl: null, $el: null, $dragEl: null }),
          a("init", () => {
            A(), v(), y();
          }),
          a("update resize observerUpdate lock unlock", () => {
            v();
          }),
          a("setTranslate", () => {
            y();
          }),
          a("setTransition", (e, n) => {
            !(function (e) {
              t.params.scrollbar.el &&
                t.scrollbar.el &&
                t.scrollbar.$dragEl.transition(e);
            })(n);
          }),
          a("enable disable", () => {
            const { $el: e } = t.scrollbar;
            e &&
              e[t.enabled ? "removeClass" : "addClass"](
                t.params.scrollbar.lockClass
              );
          }),
          a("destroy", () => {
            S();
          }),
          Object.assign(t.scrollbar, {
            updateSize: v,
            setTranslate: y,
            init: A,
            destroy: S,
          });
      }
    },
    8333: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(9482),
        i = n(4625);
      function o(e) {
        let { swiper: t, extendParams: n, on: o } = e;
        n({
          thumbs: {
            swiper: null,
            multipleActiveThumbs: !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs",
          },
        });
        let s = !1,
          a = !1;
        function u() {
          const e = t.thumbs.swiper;
          if (!e) return;
          const n = e.clickedIndex,
            r = e.clickedSlide;
          if (r && (0, i.Z)(r).hasClass(t.params.thumbs.slideThumbActiveClass))
            return;
          if (null == n) return;
          let o;
          if (
            ((o = e.params.loop
              ? parseInt(
                  (0, i.Z)(e.clickedSlide).attr("data-swiper-slide-index"),
                  10
                )
              : n),
            t.params.loop)
          ) {
            let e = t.activeIndex;
            t.slides.eq(e).hasClass(t.params.slideDuplicateClass) &&
              (t.loopFix(),
              (t._clientLeft = t.$wrapperEl[0].clientLeft),
              (e = t.activeIndex));
            const n = t.slides
                .eq(e)
                .prevAll(`[data-swiper-slide-index="${o}"]`)
                .eq(0)
                .index(),
              r = t.slides
                .eq(e)
                .nextAll(`[data-swiper-slide-index="${o}"]`)
                .eq(0)
                .index();
            o = void 0 === n ? r : void 0 === r ? n : r - e < e - n ? r : n;
          }
          t.slideTo(o);
        }
        function l() {
          const { thumbs: e } = t.params;
          if (s) return !1;
          s = !0;
          const n = t.constructor;
          if (e.swiper instanceof n)
            (t.thumbs.swiper = e.swiper),
              Object.assign(t.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
              Object.assign(t.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              });
          else if ((0, r.Kn)(e.swiper)) {
            const r = Object.assign({}, e.swiper);
            Object.assign(r, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
              (t.thumbs.swiper = new n(r)),
              (a = !0);
          }
          return (
            t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass),
            t.thumbs.swiper.on("tap", u),
            !0
          );
        }
        function c(e) {
          const n = t.thumbs.swiper;
          if (!n) return;
          const r =
              "auto" === n.params.slidesPerView
                ? n.slidesPerViewDynamic()
                : n.params.slidesPerView,
            i = t.params.thumbs.autoScrollOffset,
            o = i && !n.params.loop;
          if (t.realIndex !== n.realIndex || o) {
            let s,
              a,
              u = n.activeIndex;
            if (n.params.loop) {
              n.slides.eq(u).hasClass(n.params.slideDuplicateClass) &&
                (n.loopFix(),
                (n._clientLeft = n.$wrapperEl[0].clientLeft),
                (u = n.activeIndex));
              const e = n.slides
                  .eq(u)
                  .prevAll(`[data-swiper-slide-index="${t.realIndex}"]`)
                  .eq(0)
                  .index(),
                r = n.slides
                  .eq(u)
                  .nextAll(`[data-swiper-slide-index="${t.realIndex}"]`)
                  .eq(0)
                  .index();
              (s =
                void 0 === e
                  ? r
                  : void 0 === r
                  ? e
                  : r - u == u - e
                  ? n.params.slidesPerGroup > 1
                    ? r
                    : u
                  : r - u < u - e
                  ? r
                  : e),
                (a = t.activeIndex > t.previousIndex ? "next" : "prev");
            } else
              (s = t.realIndex), (a = s > t.previousIndex ? "next" : "prev");
            o && (s += "next" === a ? i : -1 * i),
              n.visibleSlidesIndexes &&
                n.visibleSlidesIndexes.indexOf(s) < 0 &&
                (n.params.centeredSlides
                  ? (s =
                      s > u
                        ? s - Math.floor(r / 2) + 1
                        : s + Math.floor(r / 2) - 1)
                  : s > u && n.params.slidesPerGroup,
                n.slideTo(s, e ? 0 : void 0));
          }
          let s = 1;
          const a = t.params.thumbs.slideThumbActiveClass;
          if (
            (t.params.slidesPerView > 1 &&
              !t.params.centeredSlides &&
              (s = t.params.slidesPerView),
            t.params.thumbs.multipleActiveThumbs || (s = 1),
            (s = Math.floor(s)),
            n.slides.removeClass(a),
            n.params.loop || (n.params.virtual && n.params.virtual.enabled))
          )
            for (let e = 0; e < s; e += 1)
              n.$wrapperEl
                .children(`[data-swiper-slide-index="${t.realIndex + e}"]`)
                .addClass(a);
          else
            for (let e = 0; e < s; e += 1)
              n.slides.eq(t.realIndex + e).addClass(a);
        }
        (t.thumbs = { swiper: null }),
          o("beforeInit", () => {
            const { thumbs: e } = t.params;
            e && e.swiper && (l(), c(!0));
          }),
          o("slideChange update resize observerUpdate", () => {
            t.thumbs.swiper && c();
          }),
          o("setTransition", (e, n) => {
            const r = t.thumbs.swiper;
            r && r.setTransition(n);
          }),
          o("beforeDestroy", () => {
            const e = t.thumbs.swiper;
            e && a && e && e.destroy();
          }),
          Object.assign(t.thumbs, { init: l, update: c });
      }
    },
    5352: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return o;
        },
      });
      var r = n(4625),
        i = n(9482);
      function o(e) {
        let t,
          { swiper: n, extendParams: o, on: s } = e;
        function a(e, t) {
          const i = n.params.virtual;
          if (i.cache && n.virtual.cache[t]) return n.virtual.cache[t];
          const o = i.renderSlide
            ? (0, r.Z)(i.renderSlide.call(n, e, t))
            : (0, r.Z)(
                `<div class="${n.params.slideClass}" data-swiper-slide-index="${t}">${e}</div>`
              );
          return (
            o.attr("data-swiper-slide-index") ||
              o.attr("data-swiper-slide-index", t),
            i.cache && (n.virtual.cache[t] = o),
            o
          );
        }
        function u(e) {
          const {
              slidesPerView: t,
              slidesPerGroup: r,
              centeredSlides: i,
            } = n.params,
            { addSlidesBefore: o, addSlidesAfter: s } = n.params.virtual,
            { from: u, to: l, slides: c, slidesGrid: p, offset: f } = n.virtual;
          n.params.cssMode || n.updateActiveIndex();
          const d = n.activeIndex || 0;
          let h, m, g;
          (h = n.rtlTranslate ? "right" : n.isHorizontal() ? "left" : "top"),
            i
              ? ((m = Math.floor(t / 2) + r + s),
                (g = Math.floor(t / 2) + r + o))
              : ((m = t + (r - 1) + s), (g = r + o));
          const y = Math.max((d || 0) - g, 0),
            v = Math.min((d || 0) + m, c.length - 1),
            D = (n.slidesGrid[y] || 0) - (n.slidesGrid[0] || 0);
          function b() {
            n.updateSlides(),
              n.updateProgress(),
              n.updateSlidesClasses(),
              n.lazy && n.params.lazy.enabled && n.lazy.load();
          }
          if (
            (Object.assign(n.virtual, {
              from: y,
              to: v,
              offset: D,
              slidesGrid: n.slidesGrid,
            }),
            u === y && l === v && !e)
          )
            return (
              n.slidesGrid !== p && D !== f && n.slides.css(h, `${D}px`),
              void n.updateProgress()
            );
          if (n.params.virtual.renderExternal)
            return (
              n.params.virtual.renderExternal.call(n, {
                offset: D,
                from: y,
                to: v,
                slides: (function () {
                  const e = [];
                  for (let t = y; t <= v; t += 1) e.push(c[t]);
                  return e;
                })(),
              }),
              void (n.params.virtual.renderExternalUpdate && b())
            );
          const E = [],
            C = [];
          if (e) n.$wrapperEl.find(`.${n.params.slideClass}`).remove();
          else
            for (let e = u; e <= l; e += 1)
              (e < y || e > v) &&
                n.$wrapperEl
                  .find(
                    `.${n.params.slideClass}[data-swiper-slide-index="${e}"]`
                  )
                  .remove();
          for (let t = 0; t < c.length; t += 1)
            t >= y &&
              t <= v &&
              (void 0 === l || e
                ? C.push(t)
                : (t > l && C.push(t), t < u && E.push(t)));
          C.forEach((e) => {
            n.$wrapperEl.append(a(c[e], e));
          }),
            E.sort((e, t) => t - e).forEach((e) => {
              n.$wrapperEl.prepend(a(c[e], e));
            }),
            n.$wrapperEl.children(".swiper-slide").css(h, `${D}px`),
            b();
        }
        o({
          virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: !0,
            addSlidesBefore: 0,
            addSlidesAfter: 0,
          },
        }),
          (n.virtual = {
            cache: {},
            from: void 0,
            to: void 0,
            slides: [],
            offset: 0,
            slidesGrid: [],
          }),
          s("beforeInit", () => {
            n.params.virtual.enabled &&
              ((n.virtual.slides = n.params.virtual.slides),
              n.classNames.push(`${n.params.containerModifierClass}virtual`),
              (n.params.watchSlidesProgress = !0),
              (n.originalParams.watchSlidesProgress = !0),
              n.params.initialSlide || u());
          }),
          s("setTranslate", () => {
            n.params.virtual.enabled &&
              (n.params.cssMode && !n._immediateVirtual
                ? (clearTimeout(t),
                  (t = setTimeout(() => {
                    u();
                  }, 100)))
                : u());
          }),
          s("init update resize", () => {
            n.params.virtual.enabled &&
              n.params.cssMode &&
              (0, i.z2)(
                n.wrapperEl,
                "--swiper-virtual-size",
                `${n.virtualSize}px`
              );
          }),
          Object.assign(n.virtual, {
            appendSlide: function (e) {
              if ("object" == typeof e && "length" in e)
                for (let t = 0; t < e.length; t += 1)
                  e[t] && n.virtual.slides.push(e[t]);
              else n.virtual.slides.push(e);
              u(!0);
            },
            prependSlide: function (e) {
              const t = n.activeIndex;
              let r = t + 1,
                i = 1;
              if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t += 1)
                  e[t] && n.virtual.slides.unshift(e[t]);
                (r = t + e.length), (i = e.length);
              } else n.virtual.slides.unshift(e);
              if (n.params.virtual.cache) {
                const e = n.virtual.cache,
                  t = {};
                Object.keys(e).forEach((n) => {
                  const r = e[n],
                    o = r.attr("data-swiper-slide-index");
                  o && r.attr("data-swiper-slide-index", parseInt(o, 10) + i),
                    (t[parseInt(n, 10) + i] = r);
                }),
                  (n.virtual.cache = t);
              }
              u(!0), n.slideTo(r, 0);
            },
            removeSlide: function (e) {
              if (null == e) return;
              let t = n.activeIndex;
              if (Array.isArray(e))
                for (let r = e.length - 1; r >= 0; r -= 1)
                  n.virtual.slides.splice(e[r], 1),
                    n.params.virtual.cache && delete n.virtual.cache[e[r]],
                    e[r] < t && (t -= 1),
                    (t = Math.max(t, 0));
              else
                n.virtual.slides.splice(e, 1),
                  n.params.virtual.cache && delete n.virtual.cache[e],
                  e < t && (t -= 1),
                  (t = Math.max(t, 0));
              u(!0), n.slideTo(t, 0);
            },
            removeAllSlides: function () {
              (n.virtual.slides = []),
                n.params.virtual.cache && (n.virtual.cache = {}),
                u(!0),
                n.slideTo(0, 0);
            },
            update: u,
          });
      }
    },
    9790: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return s;
        },
      });
      var r = n(7628),
        i = n(4625),
        o = n(9482);
      function s(e) {
        let { swiper: t, extendParams: n, on: s, emit: a } = e;
        const u = (0, r.Jj)();
        n({
          zoom: {
            enabled: !1,
            maxRatio: 3,
            minRatio: 1,
            toggle: !0,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed",
          },
        }),
          (t.zoom = { enabled: !1 });
        let l,
          c,
          p,
          f = 1,
          d = !1;
        const h = {
            $slideEl: void 0,
            slideWidth: void 0,
            slideHeight: void 0,
            $imageEl: void 0,
            $imageWrapEl: void 0,
            maxRatio: 3,
          },
          m = {
            isTouched: void 0,
            isMoved: void 0,
            currentX: void 0,
            currentY: void 0,
            minX: void 0,
            minY: void 0,
            maxX: void 0,
            maxY: void 0,
            width: void 0,
            height: void 0,
            startX: void 0,
            startY: void 0,
            touchesStart: {},
            touchesCurrent: {},
          },
          g = {
            x: void 0,
            y: void 0,
            prevPositionX: void 0,
            prevPositionY: void 0,
            prevTime: void 0,
          };
        let y = 1;
        function v(e) {
          if (e.targetTouches.length < 2) return 1;
          const t = e.targetTouches[0].pageX,
            n = e.targetTouches[0].pageY,
            r = e.targetTouches[1].pageX,
            i = e.targetTouches[1].pageY;
          return Math.sqrt((r - t) ** 2 + (i - n) ** 2);
        }
        function D(e) {
          const n = t.support,
            r = t.params.zoom;
          if (((c = !1), (p = !1), !n.gestures)) {
            if (
              "touchstart" !== e.type ||
              ("touchstart" === e.type && e.targetTouches.length < 2)
            )
              return;
            (c = !0), (h.scaleStart = v(e));
          }
          (h.$slideEl && h.$slideEl.length) ||
          ((h.$slideEl = (0, i.Z)(e.target).closest(`.${t.params.slideClass}`)),
          0 === h.$slideEl.length && (h.$slideEl = t.slides.eq(t.activeIndex)),
          (h.$imageEl = h.$slideEl
            .find(`.${r.containerClass}`)
            .eq(0)
            .find("picture, img, svg, canvas, .swiper-zoom-target")
            .eq(0)),
          (h.$imageWrapEl = h.$imageEl.parent(`.${r.containerClass}`)),
          (h.maxRatio = h.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
          0 !== h.$imageWrapEl.length)
            ? (h.$imageEl && h.$imageEl.transition(0), (d = !0))
            : (h.$imageEl = void 0);
        }
        function b(e) {
          const n = t.support,
            r = t.params.zoom,
            i = t.zoom;
          if (!n.gestures) {
            if (
              "touchmove" !== e.type ||
              ("touchmove" === e.type && e.targetTouches.length < 2)
            )
              return;
            (p = !0), (h.scaleMove = v(e));
          }
          h.$imageEl && 0 !== h.$imageEl.length
            ? (n.gestures
                ? (i.scale = e.scale * f)
                : (i.scale = (h.scaleMove / h.scaleStart) * f),
              i.scale > h.maxRatio &&
                (i.scale = h.maxRatio - 1 + (i.scale - h.maxRatio + 1) ** 0.5),
              i.scale < r.minRatio &&
                (i.scale = r.minRatio + 1 - (r.minRatio - i.scale + 1) ** 0.5),
              h.$imageEl.transform(`translate3d(0,0,0) scale(${i.scale})`))
            : "gesturechange" === e.type && D(e);
        }
        function E(e) {
          const n = t.device,
            r = t.support,
            i = t.params.zoom,
            o = t.zoom;
          if (!r.gestures) {
            if (!c || !p) return;
            if (
              "touchend" !== e.type ||
              ("touchend" === e.type &&
                e.changedTouches.length < 2 &&
                !n.android)
            )
              return;
            (c = !1), (p = !1);
          }
          h.$imageEl &&
            0 !== h.$imageEl.length &&
            ((o.scale = Math.max(Math.min(o.scale, h.maxRatio), i.minRatio)),
            h.$imageEl
              .transition(t.params.speed)
              .transform(`translate3d(0,0,0) scale(${o.scale})`),
            (f = o.scale),
            (d = !1),
            1 === o.scale && (h.$slideEl = void 0));
        }
        function C(e) {
          const n = t.zoom;
          if (!h.$imageEl || 0 === h.$imageEl.length) return;
          if (((t.allowClick = !1), !m.isTouched || !h.$slideEl)) return;
          m.isMoved ||
            ((m.width = h.$imageEl[0].offsetWidth),
            (m.height = h.$imageEl[0].offsetHeight),
            (m.startX = (0, o.R6)(h.$imageWrapEl[0], "x") || 0),
            (m.startY = (0, o.R6)(h.$imageWrapEl[0], "y") || 0),
            (h.slideWidth = h.$slideEl[0].offsetWidth),
            (h.slideHeight = h.$slideEl[0].offsetHeight),
            h.$imageWrapEl.transition(0));
          const r = m.width * n.scale,
            i = m.height * n.scale;
          if (!(r < h.slideWidth && i < h.slideHeight)) {
            if (
              ((m.minX = Math.min(h.slideWidth / 2 - r / 2, 0)),
              (m.maxX = -m.minX),
              (m.minY = Math.min(h.slideHeight / 2 - i / 2, 0)),
              (m.maxY = -m.minY),
              (m.touchesCurrent.x =
                "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX),
              (m.touchesCurrent.y =
                "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY),
              !m.isMoved && !d)
            ) {
              if (
                t.isHorizontal() &&
                ((Math.floor(m.minX) === Math.floor(m.startX) &&
                  m.touchesCurrent.x < m.touchesStart.x) ||
                  (Math.floor(m.maxX) === Math.floor(m.startX) &&
                    m.touchesCurrent.x > m.touchesStart.x))
              )
                return void (m.isTouched = !1);
              if (
                !t.isHorizontal() &&
                ((Math.floor(m.minY) === Math.floor(m.startY) &&
                  m.touchesCurrent.y < m.touchesStart.y) ||
                  (Math.floor(m.maxY) === Math.floor(m.startY) &&
                    m.touchesCurrent.y > m.touchesStart.y))
              )
                return void (m.isTouched = !1);
            }
            e.cancelable && e.preventDefault(),
              e.stopPropagation(),
              (m.isMoved = !0),
              (m.currentX = m.touchesCurrent.x - m.touchesStart.x + m.startX),
              (m.currentY = m.touchesCurrent.y - m.touchesStart.y + m.startY),
              m.currentX < m.minX &&
                (m.currentX = m.minX + 1 - (m.minX - m.currentX + 1) ** 0.8),
              m.currentX > m.maxX &&
                (m.currentX = m.maxX - 1 + (m.currentX - m.maxX + 1) ** 0.8),
              m.currentY < m.minY &&
                (m.currentY = m.minY + 1 - (m.minY - m.currentY + 1) ** 0.8),
              m.currentY > m.maxY &&
                (m.currentY = m.maxY - 1 + (m.currentY - m.maxY + 1) ** 0.8),
              g.prevPositionX || (g.prevPositionX = m.touchesCurrent.x),
              g.prevPositionY || (g.prevPositionY = m.touchesCurrent.y),
              g.prevTime || (g.prevTime = Date.now()),
              (g.x =
                (m.touchesCurrent.x - g.prevPositionX) /
                (Date.now() - g.prevTime) /
                2),
              (g.y =
                (m.touchesCurrent.y - g.prevPositionY) /
                (Date.now() - g.prevTime) /
                2),
              Math.abs(m.touchesCurrent.x - g.prevPositionX) < 2 && (g.x = 0),
              Math.abs(m.touchesCurrent.y - g.prevPositionY) < 2 && (g.y = 0),
              (g.prevPositionX = m.touchesCurrent.x),
              (g.prevPositionY = m.touchesCurrent.y),
              (g.prevTime = Date.now()),
              h.$imageWrapEl.transform(
                `translate3d(${m.currentX}px, ${m.currentY}px,0)`
              );
          }
        }
        function x() {
          const e = t.zoom;
          h.$slideEl &&
            t.previousIndex !== t.activeIndex &&
            (h.$imageEl && h.$imageEl.transform("translate3d(0,0,0) scale(1)"),
            h.$imageWrapEl && h.$imageWrapEl.transform("translate3d(0,0,0)"),
            (e.scale = 1),
            (f = 1),
            (h.$slideEl = void 0),
            (h.$imageEl = void 0),
            (h.$imageWrapEl = void 0));
        }
        function w(e) {
          const n = t.zoom,
            r = t.params.zoom;
          if (
            (h.$slideEl ||
              (e &&
                e.target &&
                (h.$slideEl = (0, i.Z)(e.target).closest(
                  `.${t.params.slideClass}`
                )),
              h.$slideEl ||
                (t.params.virtual && t.params.virtual.enabled && t.virtual
                  ? (h.$slideEl = t.$wrapperEl.children(
                      `.${t.params.slideActiveClass}`
                    ))
                  : (h.$slideEl = t.slides.eq(t.activeIndex))),
              (h.$imageEl = h.$slideEl
                .find(`.${r.containerClass}`)
                .eq(0)
                .find("picture, img, svg, canvas, .swiper-zoom-target")
                .eq(0)),
              (h.$imageWrapEl = h.$imageEl.parent(`.${r.containerClass}`))),
            !h.$imageEl ||
              0 === h.$imageEl.length ||
              !h.$imageWrapEl ||
              0 === h.$imageWrapEl.length)
          )
            return;
          let o, s, a, l, c, p, d, g, y, v, D, b, E, C, x, w, A, S;
          t.params.cssMode &&
            ((t.wrapperEl.style.overflow = "hidden"),
            (t.wrapperEl.style.touchAction = "none")),
            h.$slideEl.addClass(`${r.zoomedSlideClass}`),
            void 0 === m.touchesStart.x && e
              ? ((o =
                  "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX),
                (s =
                  "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY))
              : ((o = m.touchesStart.x), (s = m.touchesStart.y)),
            (n.scale = h.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
            (f = h.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
            e
              ? ((A = h.$slideEl[0].offsetWidth),
                (S = h.$slideEl[0].offsetHeight),
                (a = h.$slideEl.offset().left + u.scrollX),
                (l = h.$slideEl.offset().top + u.scrollY),
                (c = a + A / 2 - o),
                (p = l + S / 2 - s),
                (y = h.$imageEl[0].offsetWidth),
                (v = h.$imageEl[0].offsetHeight),
                (D = y * n.scale),
                (b = v * n.scale),
                (E = Math.min(A / 2 - D / 2, 0)),
                (C = Math.min(S / 2 - b / 2, 0)),
                (x = -E),
                (w = -C),
                (d = c * n.scale),
                (g = p * n.scale),
                d < E && (d = E),
                d > x && (d = x),
                g < C && (g = C),
                g > w && (g = w))
              : ((d = 0), (g = 0)),
            h.$imageWrapEl
              .transition(300)
              .transform(`translate3d(${d}px, ${g}px,0)`),
            h.$imageEl
              .transition(300)
              .transform(`translate3d(0,0,0) scale(${n.scale})`);
        }
        function A() {
          const e = t.zoom,
            n = t.params.zoom;
          h.$slideEl ||
            (t.params.virtual && t.params.virtual.enabled && t.virtual
              ? (h.$slideEl = t.$wrapperEl.children(
                  `.${t.params.slideActiveClass}`
                ))
              : (h.$slideEl = t.slides.eq(t.activeIndex)),
            (h.$imageEl = h.$slideEl
              .find(`.${n.containerClass}`)
              .eq(0)
              .find("picture, img, svg, canvas, .swiper-zoom-target")
              .eq(0)),
            (h.$imageWrapEl = h.$imageEl.parent(`.${n.containerClass}`))),
            h.$imageEl &&
              0 !== h.$imageEl.length &&
              h.$imageWrapEl &&
              0 !== h.$imageWrapEl.length &&
              (t.params.cssMode &&
                ((t.wrapperEl.style.overflow = ""),
                (t.wrapperEl.style.touchAction = "")),
              (e.scale = 1),
              (f = 1),
              h.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
              h.$imageEl
                .transition(300)
                .transform("translate3d(0,0,0) scale(1)"),
              h.$slideEl.removeClass(`${n.zoomedSlideClass}`),
              (h.$slideEl = void 0));
        }
        function S(e) {
          const n = t.zoom;
          n.scale && 1 !== n.scale ? A() : w(e);
        }
        function _() {
          const e = t.support;
          return {
            passiveListener: !(
              "touchstart" !== t.touchEvents.start ||
              !e.passiveListener ||
              !t.params.passiveListeners
            ) && { passive: !0, capture: !1 },
            activeListenerWithCapture: !e.passiveListener || {
              passive: !1,
              capture: !0,
            },
          };
        }
        function T() {
          return `.${t.params.slideClass}`;
        }
        function F(e) {
          const { passiveListener: n } = _(),
            r = T();
          t.$wrapperEl[e]("gesturestart", r, D, n),
            t.$wrapperEl[e]("gesturechange", r, b, n),
            t.$wrapperEl[e]("gestureend", r, E, n);
        }
        function k() {
          l || ((l = !0), F("on"));
        }
        function O() {
          l && ((l = !1), F("off"));
        }
        function B() {
          const e = t.zoom;
          if (e.enabled) return;
          e.enabled = !0;
          const n = t.support,
            { passiveListener: r, activeListenerWithCapture: i } = _(),
            o = T();
          n.gestures
            ? (t.$wrapperEl.on(t.touchEvents.start, k, r),
              t.$wrapperEl.on(t.touchEvents.end, O, r))
            : "touchstart" === t.touchEvents.start &&
              (t.$wrapperEl.on(t.touchEvents.start, o, D, r),
              t.$wrapperEl.on(t.touchEvents.move, o, b, i),
              t.$wrapperEl.on(t.touchEvents.end, o, E, r),
              t.touchEvents.cancel &&
                t.$wrapperEl.on(t.touchEvents.cancel, o, E, r)),
            t.$wrapperEl.on(
              t.touchEvents.move,
              `.${t.params.zoom.containerClass}`,
              C,
              i
            );
        }
        function P() {
          const e = t.zoom;
          if (!e.enabled) return;
          const n = t.support;
          e.enabled = !1;
          const { passiveListener: r, activeListenerWithCapture: i } = _(),
            o = T();
          n.gestures
            ? (t.$wrapperEl.off(t.touchEvents.start, k, r),
              t.$wrapperEl.off(t.touchEvents.end, O, r))
            : "touchstart" === t.touchEvents.start &&
              (t.$wrapperEl.off(t.touchEvents.start, o, D, r),
              t.$wrapperEl.off(t.touchEvents.move, o, b, i),
              t.$wrapperEl.off(t.touchEvents.end, o, E, r),
              t.touchEvents.cancel &&
                t.$wrapperEl.off(t.touchEvents.cancel, o, E, r)),
            t.$wrapperEl.off(
              t.touchEvents.move,
              `.${t.params.zoom.containerClass}`,
              C,
              i
            );
        }
        Object.defineProperty(t.zoom, "scale", {
          get: () => y,
          set(e) {
            if (y !== e) {
              const t = h.$imageEl ? h.$imageEl[0] : void 0,
                n = h.$slideEl ? h.$slideEl[0] : void 0;
              a("zoomChange", e, t, n);
            }
            y = e;
          },
        }),
          s("init", () => {
            t.params.zoom.enabled && B();
          }),
          s("destroy", () => {
            P();
          }),
          s("touchStart", (e, n) => {
            t.zoom.enabled &&
              (function (e) {
                const n = t.device;
                h.$imageEl &&
                  0 !== h.$imageEl.length &&
                  (m.isTouched ||
                    (n.android && e.cancelable && e.preventDefault(),
                    (m.isTouched = !0),
                    (m.touchesStart.x =
                      "touchstart" === e.type
                        ? e.targetTouches[0].pageX
                        : e.pageX),
                    (m.touchesStart.y =
                      "touchstart" === e.type
                        ? e.targetTouches[0].pageY
                        : e.pageY)));
              })(n);
          }),
          s("touchEnd", (e, n) => {
            t.zoom.enabled &&
              (function () {
                const e = t.zoom;
                if (!h.$imageEl || 0 === h.$imageEl.length) return;
                if (!m.isTouched || !m.isMoved)
                  return (m.isTouched = !1), void (m.isMoved = !1);
                (m.isTouched = !1), (m.isMoved = !1);
                let n = 300,
                  r = 300;
                const i = g.x * n,
                  o = m.currentX + i,
                  s = g.y * r,
                  a = m.currentY + s;
                0 !== g.x && (n = Math.abs((o - m.currentX) / g.x)),
                  0 !== g.y && (r = Math.abs((a - m.currentY) / g.y));
                const u = Math.max(n, r);
                (m.currentX = o), (m.currentY = a);
                const l = m.width * e.scale,
                  c = m.height * e.scale;
                (m.minX = Math.min(h.slideWidth / 2 - l / 2, 0)),
                  (m.maxX = -m.minX),
                  (m.minY = Math.min(h.slideHeight / 2 - c / 2, 0)),
                  (m.maxY = -m.minY),
                  (m.currentX = Math.max(Math.min(m.currentX, m.maxX), m.minX)),
                  (m.currentY = Math.max(Math.min(m.currentY, m.maxY), m.minY)),
                  h.$imageWrapEl
                    .transition(u)
                    .transform(
                      `translate3d(${m.currentX}px, ${m.currentY}px,0)`
                    );
              })();
          }),
          s("doubleTap", (e, n) => {
            !t.animating &&
              t.params.zoom.enabled &&
              t.zoom.enabled &&
              t.params.zoom.toggle &&
              S(n);
          }),
          s("transitionEnd", () => {
            t.zoom.enabled && t.params.zoom.enabled && x();
          }),
          s("slideChange", () => {
            t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && x();
          }),
          Object.assign(t.zoom, {
            enable: B,
            disable: P,
            in: w,
            out: A,
            toggle: S,
          });
      }
    },
    3370: function (e, t, n) {
      "use strict";
      function r(e) {
        return (
          void 0 === e && (e = ""),
          `.${e
            .trim()
            .replace(/([\.:!\/])/g, "\\$1")
            .replace(/ /g, ".")}`
        );
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    4408: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return i;
        },
      });
      var r = n(7628);
      function i(e, t, n, i) {
        const o = (0, r.Me)();
        return (
          e.params.createElements &&
            Object.keys(i).forEach((r) => {
              if (!n[r] && !0 === n.auto) {
                let s = e.$el.children(`.${i[r]}`)[0];
                s ||
                  ((s = o.createElement("div")),
                  (s.className = i[r]),
                  e.$el.append(s)),
                  (n[r] = s),
                  (t[r] = s);
              }
            }),
          n
        );
      }
    },
    9096: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return i;
        },
      });
      var r = n(4625);
      function i(e, t, n) {
        const i = "swiper-slide-shadow" + (n ? `-${n}` : ""),
          o = e.transformEl ? t.find(e.transformEl) : t;
        let s = o.children(`.${i}`);
        return (
          s.length ||
            ((s = (0, r.Z)(
              `<div class="swiper-slide-shadow${n ? `-${n}` : ""}"></div>`
            )),
            o.append(s)),
          s
        );
      }
    },
    4625: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return p;
        },
      });
      var r = n(7628);
      class i extends Array {
        constructor(e) {
          "number" == typeof e
            ? super(e)
            : (super(...(e || [])),
              (function (e) {
                const t = e.__proto__;
                Object.defineProperty(e, "__proto__", {
                  get: () => t,
                  set(e) {
                    t.__proto__ = e;
                  },
                });
              })(this));
        }
      }
      function o(e = []) {
        const t = [];
        return (
          e.forEach((e) => {
            Array.isArray(e) ? t.push(...o(e)) : t.push(e);
          }),
          t
        );
      }
      function s(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function a(e, t) {
        const n = (0, r.Jj)(),
          o = (0, r.Me)();
        let s = [];
        if (!t && e instanceof i) return e;
        if (!e) return new i(s);
        if ("string" == typeof e) {
          const n = e.trim();
          if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
            let e = "div";
            0 === n.indexOf("<li") && (e = "ul"),
              0 === n.indexOf("<tr") && (e = "tbody"),
              (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (e = "tr"),
              0 === n.indexOf("<tbody") && (e = "table"),
              0 === n.indexOf("<option") && (e = "select");
            const t = o.createElement(e);
            t.innerHTML = n;
            for (let e = 0; e < t.childNodes.length; e += 1)
              s.push(t.childNodes[e]);
          } else
            s = (function (e, t) {
              if ("string" != typeof e) return [e];
              const n = [],
                r = t.querySelectorAll(e);
              for (let e = 0; e < r.length; e += 1) n.push(r[e]);
              return n;
            })(e.trim(), t || o);
        } else if (e.nodeType || e === n || e === o) s.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof i) return e;
          s = e;
        }
        return new i(
          (function (e) {
            const t = [];
            for (let n = 0; n < e.length; n += 1)
              -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
          })(s)
        );
      }
      a.fn = i.prototype;
      const u = "resize scroll".split(" ");
      function l(e) {
        return function (...t) {
          if (void 0 === t[0]) {
            for (let t = 0; t < this.length; t += 1)
              u.indexOf(e) < 0 &&
                (e in this[t] ? this[t][e]() : a(this[t]).trigger(e));
            return this;
          }
          return this.on(e, ...t);
        };
      }
      l("click"),
        l("blur"),
        l("focus"),
        l("focusin"),
        l("focusout"),
        l("keyup"),
        l("keydown"),
        l("keypress"),
        l("submit"),
        l("change"),
        l("mousedown"),
        l("mousemove"),
        l("mouseup"),
        l("mouseenter"),
        l("mouseleave"),
        l("mouseout"),
        l("mouseover"),
        l("touchstart"),
        l("touchend"),
        l("touchmove"),
        l("resize"),
        l("scroll");
      const c = {
        addClass: function (...e) {
          const t = o(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.add(...t);
            }),
            this
          );
        },
        removeClass: function (...e) {
          const t = o(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.remove(...t);
            }),
            this
          );
        },
        hasClass: function (...e) {
          const t = o(e.map((e) => e.split(" ")));
          return (
            s(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0)
              .length > 0
          );
        },
        toggleClass: function (...e) {
          const t = o(e.map((e) => e.split(" ")));
          this.forEach((e) => {
            t.forEach((t) => {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" == typeof e)
            return this[0] ? this[0].getAttribute(e) : void 0;
          for (let n = 0; n < this.length; n += 1)
            if (2 === arguments.length) this[n].setAttribute(e, t);
            else
              for (const t in e)
                (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
          return this;
        },
        removeAttr: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (let t = 0; t < this.length; t += 1)
            this[t].style.transitionDuration =
              "string" != typeof e ? `${e}ms` : e;
          return this;
        },
        on: function (...e) {
          let [t, n, r, i] = e;
          function o(e) {
            const t = e.target;
            if (!t) return;
            const i = e.target.dom7EventData || [];
            if ((i.indexOf(e) < 0 && i.unshift(e), a(t).is(n))) r.apply(t, i);
            else {
              const e = a(t).parents();
              for (let t = 0; t < e.length; t += 1)
                a(e[t]).is(n) && r.apply(e[t], i);
            }
          }
          function s(e) {
            const t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
          }
          "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)),
            i || (i = !1);
          const u = t.split(" ");
          let l;
          for (let e = 0; e < this.length; e += 1) {
            const t = this[e];
            if (n)
              for (l = 0; l < u.length; l += 1) {
                const e = u[l];
                t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                  t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                  t.dom7LiveListeners[e].push({
                    listener: r,
                    proxyListener: o,
                  }),
                  t.addEventListener(e, o, i);
              }
            else
              for (l = 0; l < u.length; l += 1) {
                const e = u[l];
                t.dom7Listeners || (t.dom7Listeners = {}),
                  t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                  t.dom7Listeners[e].push({ listener: r, proxyListener: s }),
                  t.addEventListener(e, s, i);
              }
          }
          return this;
        },
        off: function (...e) {
          let [t, n, r, i] = e;
          "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)),
            i || (i = !1);
          const o = t.split(" ");
          for (let e = 0; e < o.length; e += 1) {
            const t = o[e];
            for (let e = 0; e < this.length; e += 1) {
              const o = this[e];
              let s;
              if (
                (!n && o.dom7Listeners
                  ? (s = o.dom7Listeners[t])
                  : n && o.dom7LiveListeners && (s = o.dom7LiveListeners[t]),
                s && s.length)
              )
                for (let e = s.length - 1; e >= 0; e -= 1) {
                  const n = s[e];
                  (r && n.listener === r) ||
                  (r &&
                    n.listener &&
                    n.listener.dom7proxy &&
                    n.listener.dom7proxy === r)
                    ? (o.removeEventListener(t, n.proxyListener, i),
                      s.splice(e, 1))
                    : r ||
                      (o.removeEventListener(t, n.proxyListener, i),
                      s.splice(e, 1));
                }
            }
          }
          return this;
        },
        trigger: function (...e) {
          const t = (0, r.Jj)(),
            n = e[0].split(" "),
            i = e[1];
          for (let r = 0; r < n.length; r += 1) {
            const o = n[r];
            for (let n = 0; n < this.length; n += 1) {
              const r = this[n];
              if (t.CustomEvent) {
                const n = new t.CustomEvent(o, {
                  detail: i,
                  bubbles: !0,
                  cancelable: !0,
                });
                (r.dom7EventData = e.filter((e, t) => t > 0)),
                  r.dispatchEvent(n),
                  (r.dom7EventData = []),
                  delete r.dom7EventData;
              }
            }
          }
          return this;
        },
        transitionEnd: function (e) {
          const t = this;
          return (
            e &&
              t.on("transitionend", function n(r) {
                r.target === this &&
                  (e.call(this, r), t.off("transitionend", n));
              }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue("margin-right")) +
                parseFloat(e.getPropertyValue("margin-left"))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue("margin-top")) +
                parseFloat(e.getPropertyValue("margin-bottom"))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          const e = (0, r.Jj)();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            const e = (0, r.Jj)(),
              t = (0, r.Me)(),
              n = this[0],
              i = n.getBoundingClientRect(),
              o = t.body,
              s = n.clientTop || o.clientTop || 0,
              a = n.clientLeft || o.clientLeft || 0,
              u = n === e ? e.scrollY : n.scrollTop,
              l = n === e ? e.scrollX : n.scrollLeft;
            return { top: i.top + u - s, left: i.left + l - a };
          }
          return null;
        },
        css: function (e, t) {
          const n = (0, r.Jj)();
          let i;
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (i = 0; i < this.length; i += 1)
                for (const t in e) this[i].style[t] = e[t];
              return this;
            }
            if (this[0])
              return n.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" == typeof e) {
            for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach((t, n) => {
                e.apply(t, [t, n]);
              }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          const t = (0, r.Jj)(),
            n = (0, r.Me)(),
            o = this[0];
          let s, u;
          if (!o || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (o.matches) return o.matches(e);
            if (o.webkitMatchesSelector) return o.webkitMatchesSelector(e);
            if (o.msMatchesSelector) return o.msMatchesSelector(e);
            for (s = a(e), u = 0; u < s.length; u += 1)
              if (s[u] === o) return !0;
            return !1;
          }
          if (e === n) return o === n;
          if (e === t) return o === t;
          if (e.nodeType || e instanceof i) {
            for (s = e.nodeType ? [e] : e, u = 0; u < s.length; u += 1)
              if (s[u] === o) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          let e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); )
              1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          const t = this.length;
          if (e > t - 1) return a([]);
          if (e < 0) {
            const n = t + e;
            return a(n < 0 ? [] : [this[n]]);
          }
          return a([this[e]]);
        },
        append: function (...e) {
          let t;
          const n = (0, r.Me)();
          for (let r = 0; r < e.length; r += 1) {
            t = e[r];
            for (let e = 0; e < this.length; e += 1)
              if ("string" == typeof t) {
                const r = n.createElement("div");
                for (r.innerHTML = t; r.firstChild; )
                  this[e].appendChild(r.firstChild);
              } else if (t instanceof i)
                for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
              else this[e].appendChild(t);
          }
          return this;
        },
        prepend: function (e) {
          const t = (0, r.Me)();
          let n, o;
          for (n = 0; n < this.length; n += 1)
            if ("string" == typeof e) {
              const r = t.createElement("div");
              for (r.innerHTML = e, o = r.childNodes.length - 1; o >= 0; o -= 1)
                this[n].insertBefore(r.childNodes[o], this[n].childNodes[0]);
            } else if (e instanceof i)
              for (o = 0; o < e.length; o += 1)
                this[n].insertBefore(e[o], this[n].childNodes[0]);
            else this[n].insertBefore(e, this[n].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling &&
                a(this[0].nextElementSibling).is(e)
                ? a([this[0].nextElementSibling])
                : a([])
              : this[0].nextElementSibling
              ? a([this[0].nextElementSibling])
              : a([])
            : a([]);
        },
        nextAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return a([]);
          for (; n.nextElementSibling; ) {
            const r = n.nextElementSibling;
            e ? a(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return a(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            const t = this[0];
            return e
              ? t.previousElementSibling && a(t.previousElementSibling).is(e)
                ? a([t.previousElementSibling])
                : a([])
              : t.previousElementSibling
              ? a([t.previousElementSibling])
              : a([]);
          }
          return a([]);
        },
        prevAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return a([]);
          for (; n.previousElementSibling; ) {
            const r = n.previousElementSibling;
            e ? a(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return a(t);
        },
        parent: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1)
            null !== this[n].parentNode &&
              (e
                ? a(this[n].parentNode).is(e) && t.push(this[n].parentNode)
                : t.push(this[n].parentNode));
          return a(t);
        },
        parents: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            let r = this[n].parentNode;
            for (; r; )
              e ? a(r).is(e) && t.push(r) : t.push(r), (r = r.parentNode);
          }
          return a(t);
        },
        closest: function (e) {
          let t = this;
          return void 0 === e
            ? a([])
            : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].querySelectorAll(e);
            for (let e = 0; e < r.length; e += 1) t.push(r[e]);
          }
          return a(t);
        },
        children: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].children;
            for (let n = 0; n < r.length; n += 1)
              (e && !a(r[n]).is(e)) || t.push(r[n]);
          }
          return a(t);
        },
        filter: function (e) {
          return a(s(this, e));
        },
        remove: function () {
          for (let e = 0; e < this.length; e += 1)
            this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(c).forEach((e) => {
        Object.defineProperty(a.fn, e, { value: c[e], writable: !0 });
      });
      var p = a;
    },
    5653: function (e, t, n) {
      "use strict";
      function r(e) {
        const {
          effect: t,
          swiper: n,
          on: r,
          setTranslate: i,
          setTransition: o,
          overwriteParams: s,
          perspective: a,
        } = e;
        r("beforeInit", () => {
          if (n.params.effect !== t) return;
          n.classNames.push(`${n.params.containerModifierClass}${t}`),
            a &&
              a() &&
              n.classNames.push(`${n.params.containerModifierClass}3d`);
          const e = s ? s() : {};
          Object.assign(n.params, e), Object.assign(n.originalParams, e);
        }),
          r("setTranslate", () => {
            n.params.effect === t && i();
          }),
          r("setTransition", (e, r) => {
            n.params.effect === t && o(r);
          });
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    5302: function (e, t, n) {
      "use strict";
      function r(e, t) {
        return e.transformEl
          ? t
              .find(e.transformEl)
              .css({
                "backface-visibility": "hidden",
                "-webkit-backface-visibility": "hidden",
              })
          : t;
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    1166: function (e, t, n) {
      "use strict";
      function r(e) {
        let { swiper: t, duration: n, transformEl: r, allSlides: i } = e;
        const { slides: o, activeIndex: s, $wrapperEl: a } = t;
        if (t.params.virtualTranslate && 0 !== n) {
          let e,
            n = !1;
          (e = i ? (r ? o.find(r) : o) : r ? o.eq(s).find(r) : o.eq(s)),
            e.transitionEnd(() => {
              if (n) return;
              if (!t || t.destroyed) return;
              (n = !0), (t.animating = !1);
              const e = ["webkitTransitionEnd", "transitionend"];
              for (let t = 0; t < e.length; t += 1) a.trigger(e[t]);
            });
        }
      }
      n.d(t, {
        Z: function () {
          return r;
        },
      });
    },
    9482: function (e, t, n) {
      "use strict";
      n.d(t, {
        x2: function () {
          return f;
        },
        cP: function () {
          return i;
        },
        Y3: function () {
          return o;
        },
        zO: function () {
          return s;
        },
        R6: function () {
          return a;
        },
        Kn: function () {
          return u;
        },
        l7: function () {
          return c;
        },
        z2: function () {
          return p;
        },
      });
      var r = n(7628);
      function i(e) {
        const t = e;
        Object.keys(t).forEach((e) => {
          try {
            t[e] = null;
          } catch (e) {}
          try {
            delete t[e];
          } catch (e) {}
        });
      }
      function o(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t);
      }
      function s() {
        return Date.now();
      }
      function a(e, t) {
        void 0 === t && (t = "x");
        const n = (0, r.Jj)();
        let i, o, s;
        const a = (function (e) {
          const t = (0, r.Jj)();
          let n;
          return (
            t.getComputedStyle && (n = t.getComputedStyle(e, null)),
            !n && e.currentStyle && (n = e.currentStyle),
            n || (n = e.style),
            n
          );
        })(e);
        return (
          n.WebKitCSSMatrix
            ? ((o = a.transform || a.webkitTransform),
              o.split(",").length > 6 &&
                (o = o
                  .split(", ")
                  .map((e) => e.replace(",", "."))
                  .join(", ")),
              (s = new n.WebKitCSSMatrix("none" === o ? "" : o)))
            : ((s =
                a.MozTransform ||
                a.OTransform ||
                a.MsTransform ||
                a.msTransform ||
                a.transform ||
                a
                  .getPropertyValue("transform")
                  .replace("translate(", "matrix(1, 0, 0, 1,")),
              (i = s.toString().split(","))),
          "x" === t &&
            (o = n.WebKitCSSMatrix
              ? s.m41
              : 16 === i.length
              ? parseFloat(i[12])
              : parseFloat(i[4])),
          "y" === t &&
            (o = n.WebKitCSSMatrix
              ? s.m42
              : 16 === i.length
              ? parseFloat(i[13])
              : parseFloat(i[5])),
          o || 0
        );
      }
      function u(e) {
        return (
          "object" == typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function l(e) {
        return "undefined" != typeof window && void 0 !== window.HTMLElement
          ? e instanceof HTMLElement
          : e && (1 === e.nodeType || 11 === e.nodeType);
      }
      function c() {
        const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
          t = ["__proto__", "constructor", "prototype"];
        for (let n = 1; n < arguments.length; n += 1) {
          const r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
          if (null != r && !l(r)) {
            const n = Object.keys(Object(r)).filter((e) => t.indexOf(e) < 0);
            for (let t = 0, i = n.length; t < i; t += 1) {
              const i = n[t],
                o = Object.getOwnPropertyDescriptor(r, i);
              void 0 !== o &&
                o.enumerable &&
                (u(e[i]) && u(r[i])
                  ? r[i].__swiper__
                    ? (e[i] = r[i])
                    : c(e[i], r[i])
                  : !u(e[i]) && u(r[i])
                  ? ((e[i] = {}),
                    r[i].__swiper__ ? (e[i] = r[i]) : c(e[i], r[i]))
                  : (e[i] = r[i]));
            }
          }
        }
        return e;
      }
      function p(e, t, n) {
        e.style.setProperty(t, n);
      }
      function f(e) {
        let { swiper: t, targetPosition: n, side: i } = e;
        const o = (0, r.Jj)(),
          s = -t.translate;
        let a,
          u = null;
        const l = t.params.speed;
        (t.wrapperEl.style.scrollSnapType = "none"),
          o.cancelAnimationFrame(t.cssModeFrameID);
        const c = n > s ? "next" : "prev",
          p = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
          f = () => {
            (a = new Date().getTime()), null === u && (u = a);
            const e = Math.max(Math.min((a - u) / l, 1), 0),
              r = 0.5 - Math.cos(e * Math.PI) / 2;
            let c = s + r * (n - s);
            if ((p(c, n) && (c = n), t.wrapperEl.scrollTo({ [i]: c }), p(c, n)))
              return (
                (t.wrapperEl.style.overflow = "hidden"),
                (t.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (t.wrapperEl.style.overflow = ""),
                    t.wrapperEl.scrollTo({ [i]: c });
                }),
                void o.cancelAnimationFrame(t.cssModeFrameID)
              );
            t.cssModeFrameID = o.requestAnimationFrame(f);
          };
        f();
      }
    },
    2223: function (e, t, n) {
      "use strict";
      n.d(t, {
        Z: function () {
          return r.Z;
        },
      });
      var r = n(638),
        i = n(5352),
        o = n(376),
        s = n(8372),
        a = n(6739),
        u = n(9224),
        l = n(5652),
        c = n(1190),
        p = n(9790),
        f = n(8359),
        d = n(7031),
        h = n(2799),
        m = n(68),
        g = n(6237),
        y = n(9127),
        v = n(8333),
        D = n(4806),
        b = n(6796),
        E = n(286),
        C = n(882),
        x = n(3459),
        w = n(4440),
        A = n(5653),
        S = n(5302),
        _ = n(1166),
        T = n(4278),
        F = n(2708),
        k = n(3007),
        O = n(6100),
        B = n(980);
      const P = [
        i.Z,
        o.Z,
        s.Z,
        a.Z,
        u.Z,
        l.Z,
        c.Z,
        p.Z,
        f.Z,
        d.Z,
        h.Z,
        m.Z,
        g.Z,
        y.Z,
        v.Z,
        D.Z,
        function (e) {
          let t,
            n,
            r,
            { swiper: i, extendParams: o } = e;
          o({ grid: { rows: 1, fill: "column" } }),
            (i.grid = {
              initSlides: (e) => {
                const { slidesPerView: o } = i.params,
                  { rows: s, fill: a } = i.params.grid;
                (n = t / s),
                  (r = Math.floor(e / s)),
                  (t = Math.floor(e / s) === e / s ? e : Math.ceil(e / s) * s),
                  "auto" !== o && "row" === a && (t = Math.max(t, o * s));
              },
              updateSlide: (e, o, s, a) => {
                const { slidesPerGroup: u, spaceBetween: l } = i.params,
                  { rows: c, fill: p } = i.params.grid;
                let f, d, h;
                if ("row" === p && u > 1) {
                  const n = Math.floor(e / (u * c)),
                    r = e - c * u * n,
                    i =
                      0 === n ? u : Math.min(Math.ceil((s - n * c * u) / c), u);
                  (h = Math.floor(r / i)),
                    (d = r - h * i + n * u),
                    (f = d + (h * t) / c),
                    o.css({ "-webkit-order": f, order: f });
                } else
                  "column" === p
                    ? ((d = Math.floor(e / c)),
                      (h = e - d * c),
                      (d > r || (d === r && h === c - 1)) &&
                        ((h += 1), h >= c && ((h = 0), (d += 1))))
                    : ((h = Math.floor(e / n)), (d = e - h * n));
                o.css(a("margin-top"), 0 !== h ? l && `${l}px` : "");
              },
              updateWrapperSize: (e, n, r) => {
                const {
                    spaceBetween: o,
                    centeredSlides: s,
                    roundLengths: a,
                  } = i.params,
                  { rows: u } = i.params.grid;
                if (
                  ((i.virtualSize = (e + o) * t),
                  (i.virtualSize = Math.ceil(i.virtualSize / u) - o),
                  i.$wrapperEl.css({ [r("width")]: `${i.virtualSize + o}px` }),
                  s)
                ) {
                  n.splice(0, n.length);
                  const e = [];
                  for (let t = 0; t < n.length; t += 1) {
                    let r = n[t];
                    a && (r = Math.floor(r)),
                      n[t] < i.virtualSize + n[0] && e.push(r);
                  }
                  n.push(...e);
                }
              },
            });
        },
        function (e) {
          let { swiper: t } = e;
          Object.assign(t, {
            appendSlide: b.Z.bind(t),
            prependSlide: E.Z.bind(t),
            addSlide: C.Z.bind(t),
            removeSlide: x.Z.bind(t),
            removeAllSlides: w.Z.bind(t),
          });
        },
        function (e) {
          let { swiper: t, extendParams: n, on: r } = e;
          n({ fadeEffect: { crossFade: !1, transformEl: null } }),
            (0, A.Z)({
              effect: "fade",
              swiper: t,
              on: r,
              setTranslate: () => {
                const { slides: e } = t,
                  n = t.params.fadeEffect;
                for (let r = 0; r < e.length; r += 1) {
                  const e = t.slides.eq(r);
                  let i = -e[0].swiperSlideOffset;
                  t.params.virtualTranslate || (i -= t.translate);
                  let o = 0;
                  t.isHorizontal() || ((o = i), (i = 0));
                  const s = t.params.fadeEffect.crossFade
                    ? Math.max(1 - Math.abs(e[0].progress), 0)
                    : 1 + Math.min(Math.max(e[0].progress, -1), 0);
                  (0, S.Z)(n, e)
                    .css({ opacity: s })
                    .transform(`translate3d(${i}px, ${o}px, 0px)`);
                }
              },
              setTransition: (e) => {
                const { transformEl: n } = t.params.fadeEffect;
                (n ? t.slides.find(n) : t.slides).transition(e),
                  (0, _.Z)({
                    swiper: t,
                    duration: e,
                    transformEl: n,
                    allSlides: !0,
                  });
              },
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !t.params.cssMode,
              }),
            });
        },
        T.Z,
        F.Z,
        k.Z,
        O.Z,
        B.Z,
      ];
      r.Z.use(P);
    },
    3220: function (e, t, n) {
      "use strict";
      n.d(t, {
        ZP: function () {
          return r.Z;
        },
      });
      var r = n(638);
      n(5352),
        n(376),
        n(8372),
        n(6739),
        n(9224),
        n(5652),
        n(1190),
        n(9790),
        n(8359),
        n(7031),
        n(2799),
        n(68),
        n(6237),
        n(9127),
        n(8333),
        n(4806),
        n(4278),
        n(2708),
        n(3007),
        n(6100),
        n(980);
    },
  },
]);
